webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	var core_1 = __webpack_require__(2);
	var platform_browser_dynamic_1 = __webpack_require__(20);
	var app_module_1 = __webpack_require__(24);
	// depending on the env mode, enable prod mode or add debugging modules
	if (true) {
	    core_1.enableProdMode();
	}
	function main() {
	    return platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule).then(function (MODULE_REF) {
	        if (module["hot"]) {
	            module["hot"]["accept"]();
	            if (MODULE_REF.instance["hmrOnInit"]) {
	                MODULE_REF.instance["hmrOnInit"](module["hot"]["data"]);
	            }
	            if (MODULE_REF.instance["hmrOnStatus"]) {
	                module["hot"]["apply"](function (status) {
	                    MODULE_REF.instance["hmrOnStatus"](status);
	                });
	            }
	            if (MODULE_REF.instance["hmrOnCheck"]) {
	                module["hot"]["check"](function (err, outdatedModules) {
	                    MODULE_REF.instance["hmrOnCheck"](err, outdatedModules);
	                });
	            }
	            if (MODULE_REF.instance["hmrOnDecline"]) {
	                module["hot"]["decline"](function (dependencies) {
	                    MODULE_REF.instance["hmrOnDecline"](dependencies);
	                });
	            }
	            module["hot"]["dispose"](function (store) {
	                MODULE_REF.instance["hmrOnDestroy"] && MODULE_REF.instance["hmrOnDestroy"](store);
	                MODULE_REF.destroy();
	                MODULE_REF.instance["hmrAfterDestroy"] && MODULE_REF.instance["hmrAfterDestroy"](store);
	            });
	        }
	        return MODULE_REF;
	    });
	}
	exports.main = main;
	if (document.readyState === 'complete') {
	    main();
	}
	else {
	    document.addEventListener('DOMContentLoaded', main);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var notifications_module_1 = __webpack_require__(25);
	var core_1 = __webpack_require__(2);
	var platform_browser_1 = __webpack_require__(22);
	var http_1 = __webpack_require__(276);
	var common_1 = __webpack_require__(23);
	var forms_1 = __webpack_require__(27);
	var ng2_material_components_1 = __webpack_require__(33);
	var shared_module_1 = __webpack_require__(26);
	var sidenav_1 = __webpack_require__(650);
	var app_routing_1 = __webpack_require__(654);
	// services
	var services_1 = __webpack_require__(274);
	var services_2 = __webpack_require__(274);
	var services_3 = __webpack_require__(274);
	var services_4 = __webpack_require__(274);
	var services_5 = __webpack_require__(274);
	var services_6 = __webpack_require__(274);
	var services_7 = __webpack_require__(274);
	var services_8 = __webpack_require__(274);
	var services_9 = __webpack_require__(274);
	var services_10 = __webpack_require__(274);
	var app_component_1 = __webpack_require__(727);
	var home_component_1 = __webpack_require__(656);
	var dashboard_module_1 = __webpack_require__(759);
	// features
	var accounts_module_1 = __webpack_require__(777);
	var employees_module_1 = __webpack_require__(795);
	var accounting_module_1 = __webpack_require__(820);
	var location_module_1 = __webpack_require__(922);
	var inventory_module_1 = __webpack_require__(942);
	var customers_module_1 = __webpack_require__(1025);
	var chat_module_1 = __webpack_require__(1036);
	var clock_in_out_1 = __webpack_require__(1063);
	var settings_1 = __webpack_require__(696);
	var hmr_1 = __webpack_require__(1074);
	var AppModule = (function () {
	    function AppModule(appRef) {
	        this.appRef = appRef;
	    }
	    AppModule.prototype.hmrOnInit = function (store) {
	        console.log('HMR store', store);
	    };
	    AppModule.prototype.hmrOnDestroy = function (store) {
	        var cmpLocation = this.appRef.components.map(function (cmp) { return cmp.location.nativeElement; });
	        // recreate elements
	        store.disposeOldHosts = hmr_1.createNewHosts(cmpLocation);
	        // remove styles
	        hmr_1.removeNgStyles();
	    };
	    AppModule.prototype.hmrAfterDestroy = function (store) {
	        // display new elements
	        store.disposeOldHosts();
	        delete store.disposeOldHosts;
	    };
	    AppModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                platform_browser_1.BrowserModule,
	                http_1.HttpModule,
	                forms_1.FormsModule,
	                forms_1.ReactiveFormsModule,
	                app_routing_1.routing,
	                ng2_material_components_1.MaterialFormsModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                shared_module_1.SharedModule,
	                dashboard_module_1.DashboardModule,
	                // features
	                accounts_module_1.AccountsModule,
	                employees_module_1.EmployeesModule,
	                accounting_module_1.AccountingModule,
	                location_module_1.LocationModule,
	                inventory_module_1.InventoryModule,
	                customers_module_1.CustomersModule,
	                notifications_module_1.NotificationsModule,
	                chat_module_1.ChatModule,
	                clock_in_out_1.ClockInOutModule,
	                settings_1.SettingsModule
	            ],
	            declarations: [
	                app_component_1.AppComponent,
	                home_component_1.HomeComponent,
	                sidenav_1.SideNavComponent,
	            ],
	            providers: [
	                { provide: common_1.LocationStrategy, useClass: common_1.HashLocationStrategy },
	                services_1.ApiService,
	                services_2.AppStateService,
	                services_3.AuthService,
	                services_8.ConfigService,
	                services_4.ManagementService,
	                services_5.Store,
	                services_6.StoreHelper,
	                services_7.UserService,
	                services_9.LocalStorageService,
	                services_10.AccountsService
	            ],
	            bootstrap: [app_component_1.AppComponent]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.ApplicationRef !== 'undefined' && core_1.ApplicationRef) === 'function' && _a) || Object])
	    ], AppModule);
	    return AppModule;
	    var _a;
	}());
	exports.AppModule = AppModule;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var shared_module_1 = __webpack_require__(26);
	var notifications_component_1 = __webpack_require__(640);
	var notifications_service_1 = __webpack_require__(641);
	var common_1 = __webpack_require__(23);
	var core_1 = __webpack_require__(2);
	var ng2_material_components_1 = __webpack_require__(33);
	var strip_html_pipe_1 = __webpack_require__(649);
	var pipes_1 = __webpack_require__(595);
	var NotificationsModule = (function () {
	    function NotificationsModule() {
	    }
	    NotificationsModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                shared_module_1.SharedModule,
	            ],
	            exports: [
	                notifications_component_1.NotificationsComponent,
	            ],
	            declarations: [
	                notifications_component_1.NotificationsComponent,
	                strip_html_pipe_1.StripHTMLPipe,
	                pipes_1.LinkifyPipe
	            ],
	            providers: [notifications_service_1.NotificationService],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], NotificationsModule);
	    return NotificationsModule;
	}());
	exports.NotificationsModule = NotificationsModule;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(23);
	var forms_1 = __webpack_require__(27);
	var ng2_charts_1 = __webpack_require__(31);
	var ng2_material_components_1 = __webpack_require__(33);
	// components
	var ui_1 = __webpack_require__(132);
	var services_1 = __webpack_require__(274);
	/*Pipes */
	var pipes_1 = __webpack_require__(595);
	var SharedModule = (function () {
	    function SharedModule() {
	    }
	    SharedModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                forms_1.FormsModule,
	                forms_1.ReactiveFormsModule,
	                ng2_material_components_1.MaterialFormsModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                ng2_charts_1.ChartsModule
	            ],
	            declarations: [
	                ui_1.BackgroundComponent,
	                ui_1.DateRangeComponent,
	                ui_1.DateRangeSheetComponent,
	                ui_1.IconActionComponent,
	                ui_1.LocationPickerComponent,
	                ui_1.LocationPickerSheetComponent,
	                ui_1.OverlayComponent,
	                ui_1.SheetComponent,
	                ui_1.PaperCoverComponent,
	                ui_1.PagePreloaderComponent,
	                ui_1.AppPageComponent,
	                ui_1.HorizontalSliderComponent,
	                ui_1.UserFeedbackComponent,
	                ui_1.FilterSheetComponent,
	                ui_1.AsyncContentComponent,
	                ui_1.RibbonMessageComponent,
	                ui_1.DynamicImageComponent,
	                ui_1.UserImageComponent,
	                pipes_1.ToLocalDatePipe,
	                pipes_1.MomentifyPipe,
	            ],
	            exports: [
	                ui_1.BackgroundComponent,
	                ui_1.DateRangeComponent,
	                ui_1.DateRangeSheetComponent,
	                ui_1.IconActionComponent,
	                ui_1.LocationPickerComponent,
	                ui_1.LocationPickerSheetComponent,
	                ui_1.OverlayComponent,
	                ui_1.SheetComponent,
	                ui_1.PaperCoverComponent,
	                ui_1.PagePreloaderComponent,
	                ui_1.AppPageComponent,
	                ui_1.HorizontalSliderComponent,
	                ui_1.UserFeedbackComponent,
	                ui_1.FilterSheetComponent,
	                ui_1.AsyncContentComponent,
	                ui_1.RibbonMessageComponent,
	                ui_1.DynamicImageComponent,
	                ui_1.UserImageComponent,
	                pipes_1.ToLocalDatePipe,
	                pipes_1.MomentifyPipe,
	            ],
	            providers: [services_1.NativeChannelService]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SharedModule);
	    return SharedModule;
	}());
	exports.SharedModule = SharedModule;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * @license Angular v2.0.0
	 * (c) 2010-2016 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(2), __webpack_require__(28), __webpack_require__(3), __webpack_require__(4), __webpack_require__(29)) :
	    typeof define === 'function' && define.amd ? define(['exports', '@angular/core', 'rxjs/operator/toPromise', 'rxjs/Subject', 'rxjs/Observable', 'rxjs/observable/fromPromise'], factory) :
	    (factory((global.ng = global.ng || {}, global.ng.forms = global.ng.forms || {}),global.ng.core,global.Rx.Observable.prototype,global.Rx,global.Rx,global.Rx.Observable));
	}(this, function (exports,_angular_core,rxjs_operator_toPromise,rxjs_Subject,rxjs_Observable,rxjs_observable_fromPromise) { 'use strict';
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var globalScope;
	    if (typeof window === 'undefined') {
	        if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
	            // TODO: Replace any with WorkerGlobalScope from lib.webworker.d.ts #3492
	            globalScope = self;
	        }
	        else {
	            globalScope = global;
	        }
	    }
	    else {
	        globalScope = window;
	    }
	    // Need to declare a new variable for global here since TypeScript
	    // exports the original value of the symbol.
	    var global$1 = globalScope;
	    // TODO: remove calls to assert in production environment
	    // Note: Can't just export this and import in in other files
	    // as `assert` is a reserved keyword in Dart
	    global$1.assert = function assert(condition) {
	        // TODO: to be fixed properly via #2830, noop for now
	    };
	    function isPresent(obj) {
	        return obj !== undefined && obj !== null;
	    }
	    function isBlank(obj) {
	        return obj === undefined || obj === null;
	    }
	    function isString(obj) {
	        return typeof obj === 'string';
	    }
	    function isFunction(obj) {
	        return typeof obj === 'function';
	    }
	    function isStringMap(obj) {
	        return typeof obj === 'object' && obj !== null;
	    }
	    function isPromise(obj) {
	        // allow any Promise/A+ compliant thenable.
	        // It's up to the caller to ensure that obj.then conforms to the spec
	        return isPresent(obj) && isFunction(obj.then);
	    }
	    function isArray(obj) {
	        return Array.isArray(obj);
	    }
	    var StringWrapper = (function () {
	        function StringWrapper() {
	        }
	        StringWrapper.fromCharCode = function (code) { return String.fromCharCode(code); };
	        StringWrapper.charCodeAt = function (s, index) { return s.charCodeAt(index); };
	        StringWrapper.split = function (s, regExp) { return s.split(regExp); };
	        StringWrapper.equals = function (s, s2) { return s === s2; };
	        StringWrapper.stripLeft = function (s, charVal) {
	            if (s && s.length) {
	                var pos = 0;
	                for (var i = 0; i < s.length; i++) {
	                    if (s[i] != charVal)
	                        break;
	                    pos++;
	                }
	                s = s.substring(pos);
	            }
	            return s;
	        };
	        StringWrapper.stripRight = function (s, charVal) {
	            if (s && s.length) {
	                var pos = s.length;
	                for (var i = s.length - 1; i >= 0; i--) {
	                    if (s[i] != charVal)
	                        break;
	                    pos--;
	                }
	                s = s.substring(0, pos);
	            }
	            return s;
	        };
	        StringWrapper.replace = function (s, from, replace) {
	            return s.replace(from, replace);
	        };
	        StringWrapper.replaceAll = function (s, from, replace) {
	            return s.replace(from, replace);
	        };
	        StringWrapper.slice = function (s, from, to) {
	            if (from === void 0) { from = 0; }
	            if (to === void 0) { to = null; }
	            return s.slice(from, to === null ? undefined : to);
	        };
	        StringWrapper.replaceAllMapped = function (s, from, cb) {
	            return s.replace(from, function () {
	                var matches = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    matches[_i - 0] = arguments[_i];
	                }
	                // Remove offset & string from the result array
	                matches.splice(-2, 2);
	                // The callback receives match, p1, ..., pn
	                return cb(matches);
	            });
	        };
	        StringWrapper.contains = function (s, substr) { return s.indexOf(substr) != -1; };
	        StringWrapper.compare = function (a, b) {
	            if (a < b) {
	                return -1;
	            }
	            else if (a > b) {
	                return 1;
	            }
	            else {
	                return 0;
	            }
	        };
	        return StringWrapper;
	    }());
	    var NumberWrapper = (function () {
	        function NumberWrapper() {
	        }
	        NumberWrapper.toFixed = function (n, fractionDigits) { return n.toFixed(fractionDigits); };
	        NumberWrapper.equal = function (a, b) { return a === b; };
	        NumberWrapper.parseIntAutoRadix = function (text) {
	            var result = parseInt(text);
	            if (isNaN(result)) {
	                throw new Error('Invalid integer literal when parsing ' + text);
	            }
	            return result;
	        };
	        NumberWrapper.parseInt = function (text, radix) {
	            if (radix == 10) {
	                if (/^(\-|\+)?[0-9]+$/.test(text)) {
	                    return parseInt(text, radix);
	                }
	            }
	            else if (radix == 16) {
	                if (/^(\-|\+)?[0-9ABCDEFabcdef]+$/.test(text)) {
	                    return parseInt(text, radix);
	                }
	            }
	            else {
	                var result = parseInt(text, radix);
	                if (!isNaN(result)) {
	                    return result;
	                }
	            }
	            throw new Error('Invalid integer literal when parsing ' + text + ' in base ' + radix);
	        };
	        Object.defineProperty(NumberWrapper, "NaN", {
	            get: function () { return NaN; },
	            enumerable: true,
	            configurable: true
	        });
	        NumberWrapper.isNumeric = function (value) { return !isNaN(value - parseFloat(value)); };
	        NumberWrapper.isNaN = function (value) { return isNaN(value); };
	        NumberWrapper.isInteger = function (value) { return Number.isInteger(value); };
	        return NumberWrapper;
	    }());
	    // JS has NaN !== NaN
	    function looseIdentical(a, b) {
	        return a === b || typeof a === 'number' && typeof b === 'number' && isNaN(a) && isNaN(b);
	    }
	    function normalizeBool(obj) {
	        return isBlank(obj) ? false : obj;
	    }
	    function isJsObject(o) {
	        return o !== null && (typeof o === 'function' || typeof o === 'object');
	    }
	    function isPrimitive(obj) {
	        return !isJsObject(obj);
	    }
	    function hasConstructor(value, type) {
	        return value.constructor === type;
	    }
	
	    /**
	     * Base class for control directives.
	     *
	     * Only used internally in the forms module.
	     *
	     * @stable
	     */
	    var AbstractControlDirective = (function () {
	        function AbstractControlDirective() {
	        }
	        Object.defineProperty(AbstractControlDirective.prototype, "control", {
	            get: function () { throw new Error('unimplemented'); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "value", {
	            get: function () { return isPresent(this.control) ? this.control.value : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "valid", {
	            get: function () { return isPresent(this.control) ? this.control.valid : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
	            get: function () { return isPresent(this.control) ? this.control.invalid : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "pending", {
	            get: function () { return isPresent(this.control) ? this.control.pending : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "errors", {
	            get: function () {
	                return isPresent(this.control) ? this.control.errors : null;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
	            get: function () { return isPresent(this.control) ? this.control.pristine : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
	            get: function () { return isPresent(this.control) ? this.control.dirty : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "touched", {
	            get: function () { return isPresent(this.control) ? this.control.touched : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
	            get: function () { return isPresent(this.control) ? this.control.untouched : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
	            get: function () { return isPresent(this.control) ? this.control.disabled : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
	            get: function () { return isPresent(this.control) ? this.control.enabled : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
	            get: function () {
	                return isPresent(this.control) ? this.control.statusChanges : null;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
	            get: function () {
	                return isPresent(this.control) ? this.control.valueChanges : null;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "path", {
	            get: function () { return null; },
	            enumerable: true,
	            configurable: true
	        });
	        AbstractControlDirective.prototype.reset = function (value) {
	            if (value === void 0) { value = undefined; }
	            if (isPresent(this.control))
	                this.control.reset(value);
	        };
	        return AbstractControlDirective;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$1 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * A directive that contains multiple {@link NgControl}s.
	     *
	     * Only used by the forms module.
	     *
	     * @stable
	     */
	    var ControlContainer = (function (_super) {
	        __extends$1(ControlContainer, _super);
	        function ControlContainer() {
	            _super.apply(this, arguments);
	        }
	        Object.defineProperty(ControlContainer.prototype, "formDirective", {
	            /**
	             * Get the form to which this container belongs.
	             */
	            get: function () { return null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(ControlContainer.prototype, "path", {
	            /**
	             * Get the path to this container.
	             */
	            get: function () { return null; },
	            enumerable: true,
	            configurable: true
	        });
	        return ControlContainer;
	    }(AbstractControlDirective));
	
	    var Map$1 = global$1.Map;
	    var Set = global$1.Set;
	    // Safari and Internet Explorer do not support the iterable parameter to the
	    // Map constructor.  We work around that by manually adding the items.
	    var createMapFromPairs = (function () {
	        try {
	            if (new Map$1([[1, 2]]).size === 1) {
	                return function createMapFromPairs(pairs) { return new Map$1(pairs); };
	            }
	        }
	        catch (e) {
	        }
	        return function createMapAndPopulateFromPairs(pairs) {
	            var map = new Map$1();
	            for (var i = 0; i < pairs.length; i++) {
	                var pair = pairs[i];
	                map.set(pair[0], pair[1]);
	            }
	            return map;
	        };
	    })();
	    var createMapFromMap = (function () {
	        try {
	            if (new Map$1(new Map$1())) {
	                return function createMapFromMap(m) { return new Map$1(m); };
	            }
	        }
	        catch (e) {
	        }
	        return function createMapAndPopulateFromMap(m) {
	            var map = new Map$1();
	            m.forEach(function (v, k) { map.set(k, v); });
	            return map;
	        };
	    })();
	    var _clearValues = (function () {
	        if ((new Map$1()).keys().next) {
	            return function _clearValues(m) {
	                var keyIterator = m.keys();
	                var k;
	                while (!((k = keyIterator.next()).done)) {
	                    m.set(k.value, null);
	                }
	            };
	        }
	        else {
	            return function _clearValuesWithForeEach(m) {
	                m.forEach(function (v, k) { m.set(k, null); });
	            };
	        }
	    })();
	    // Safari doesn't implement MapIterator.next(), which is used is Traceur's polyfill of Array.from
	    // TODO(mlaval): remove the work around once we have a working polyfill of Array.from
	    var _arrayFromMap = (function () {
	        try {
	            if ((new Map$1()).values().next) {
	                return function createArrayFromMap(m, getValues) {
	                    return getValues ? Array.from(m.values()) : Array.from(m.keys());
	                };
	            }
	        }
	        catch (e) {
	        }
	        return function createArrayFromMapWithForeach(m, getValues) {
	            var res = ListWrapper.createFixedSize(m.size), i = 0;
	            m.forEach(function (v, k) {
	                res[i] = getValues ? v : k;
	                i++;
	            });
	            return res;
	        };
	    })();
	    var MapWrapper = (function () {
	        function MapWrapper() {
	        }
	        MapWrapper.clone = function (m) { return createMapFromMap(m); };
	        MapWrapper.createFromStringMap = function (stringMap) {
	            var result = new Map$1();
	            for (var prop in stringMap) {
	                result.set(prop, stringMap[prop]);
	            }
	            return result;
	        };
	        MapWrapper.toStringMap = function (m) {
	            var r = {};
	            m.forEach(function (v, k) { return r[k] = v; });
	            return r;
	        };
	        MapWrapper.createFromPairs = function (pairs) { return createMapFromPairs(pairs); };
	        MapWrapper.clearValues = function (m) { _clearValues(m); };
	        MapWrapper.iterable = function (m) { return m; };
	        MapWrapper.keys = function (m) { return _arrayFromMap(m, false); };
	        MapWrapper.values = function (m) { return _arrayFromMap(m, true); };
	        return MapWrapper;
	    }());
	    /**
	     * Wraps Javascript Objects
	     */
	    var StringMapWrapper = (function () {
	        function StringMapWrapper() {
	        }
	        StringMapWrapper.create = function () {
	            // Note: We are not using Object.create(null) here due to
	            // performance!
	            // http://jsperf.com/ng2-object-create-null
	            return {};
	        };
	        StringMapWrapper.contains = function (map, key) {
	            return map.hasOwnProperty(key);
	        };
	        StringMapWrapper.get = function (map, key) {
	            return map.hasOwnProperty(key) ? map[key] : undefined;
	        };
	        StringMapWrapper.set = function (map, key, value) { map[key] = value; };
	        StringMapWrapper.keys = function (map) { return Object.keys(map); };
	        StringMapWrapper.values = function (map) {
	            return Object.keys(map).map(function (k) { return map[k]; });
	        };
	        StringMapWrapper.isEmpty = function (map) {
	            for (var prop in map) {
	                return false;
	            }
	            return true;
	        };
	        StringMapWrapper.delete = function (map, key) { delete map[key]; };
	        StringMapWrapper.forEach = function (map, callback) {
	            for (var _i = 0, _a = Object.keys(map); _i < _a.length; _i++) {
	                var k = _a[_i];
	                callback(map[k], k);
	            }
	        };
	        StringMapWrapper.merge = function (m1, m2) {
	            var m = {};
	            for (var _i = 0, _a = Object.keys(m1); _i < _a.length; _i++) {
	                var k = _a[_i];
	                m[k] = m1[k];
	            }
	            for (var _b = 0, _c = Object.keys(m2); _b < _c.length; _b++) {
	                var k = _c[_b];
	                m[k] = m2[k];
	            }
	            return m;
	        };
	        StringMapWrapper.equals = function (m1, m2) {
	            var k1 = Object.keys(m1);
	            var k2 = Object.keys(m2);
	            if (k1.length != k2.length) {
	                return false;
	            }
	            for (var i = 0; i < k1.length; i++) {
	                var key = k1[i];
	                if (m1[key] !== m2[key]) {
	                    return false;
	                }
	            }
	            return true;
	        };
	        return StringMapWrapper;
	    }());
	    var ListWrapper = (function () {
	        function ListWrapper() {
	        }
	        // JS has no way to express a statically fixed size list, but dart does so we
	        // keep both methods.
	        ListWrapper.createFixedSize = function (size) { return new Array(size); };
	        ListWrapper.createGrowableSize = function (size) { return new Array(size); };
	        ListWrapper.clone = function (array) { return array.slice(0); };
	        ListWrapper.forEachWithIndex = function (array, fn) {
	            for (var i = 0; i < array.length; i++) {
	                fn(array[i], i);
	            }
	        };
	        ListWrapper.first = function (array) {
	            if (!array)
	                return null;
	            return array[0];
	        };
	        ListWrapper.last = function (array) {
	            if (!array || array.length == 0)
	                return null;
	            return array[array.length - 1];
	        };
	        ListWrapper.indexOf = function (array, value, startIndex) {
	            if (startIndex === void 0) { startIndex = 0; }
	            return array.indexOf(value, startIndex);
	        };
	        ListWrapper.contains = function (list, el) { return list.indexOf(el) !== -1; };
	        ListWrapper.reversed = function (array) {
	            var a = ListWrapper.clone(array);
	            return a.reverse();
	        };
	        ListWrapper.concat = function (a, b) { return a.concat(b); };
	        ListWrapper.insert = function (list, index, value) { list.splice(index, 0, value); };
	        ListWrapper.removeAt = function (list, index) {
	            var res = list[index];
	            list.splice(index, 1);
	            return res;
	        };
	        ListWrapper.removeAll = function (list, items) {
	            for (var i = 0; i < items.length; ++i) {
	                var index = list.indexOf(items[i]);
	                list.splice(index, 1);
	            }
	        };
	        ListWrapper.remove = function (list, el) {
	            var index = list.indexOf(el);
	            if (index > -1) {
	                list.splice(index, 1);
	                return true;
	            }
	            return false;
	        };
	        ListWrapper.clear = function (list) { list.length = 0; };
	        ListWrapper.isEmpty = function (list) { return list.length == 0; };
	        ListWrapper.fill = function (list, value, start, end) {
	            if (start === void 0) { start = 0; }
	            if (end === void 0) { end = null; }
	            list.fill(value, start, end === null ? list.length : end);
	        };
	        ListWrapper.equals = function (a, b) {
	            if (a.length != b.length)
	                return false;
	            for (var i = 0; i < a.length; ++i) {
	                if (a[i] !== b[i])
	                    return false;
	            }
	            return true;
	        };
	        ListWrapper.slice = function (l, from, to) {
	            if (from === void 0) { from = 0; }
	            if (to === void 0) { to = null; }
	            return l.slice(from, to === null ? undefined : to);
	        };
	        ListWrapper.splice = function (l, from, length) { return l.splice(from, length); };
	        ListWrapper.sort = function (l, compareFn) {
	            if (isPresent(compareFn)) {
	                l.sort(compareFn);
	            }
	            else {
	                l.sort();
	            }
	        };
	        ListWrapper.toString = function (l) { return l.toString(); };
	        ListWrapper.toJSON = function (l) { return JSON.stringify(l); };
	        ListWrapper.maximum = function (list, predicate) {
	            if (list.length == 0) {
	                return null;
	            }
	            var solution = null;
	            var maxValue = -Infinity;
	            for (var index = 0; index < list.length; index++) {
	                var candidate = list[index];
	                if (isBlank(candidate)) {
	                    continue;
	                }
	                var candidateValue = predicate(candidate);
	                if (candidateValue > maxValue) {
	                    solution = candidate;
	                    maxValue = candidateValue;
	                }
	            }
	            return solution;
	        };
	        ListWrapper.flatten = function (list) {
	            var target = [];
	            _flattenArray(list, target);
	            return target;
	        };
	        ListWrapper.addAll = function (list, source) {
	            for (var i = 0; i < source.length; i++) {
	                list.push(source[i]);
	            }
	        };
	        return ListWrapper;
	    }());
	    function _flattenArray(source, target) {
	        if (isPresent(source)) {
	            for (var i = 0; i < source.length; i++) {
	                var item = source[i];
	                if (isArray(item)) {
	                    _flattenArray(item, target);
	                }
	                else {
	                    target.push(item);
	                }
	            }
	        }
	        return target;
	    }
	    // Safari and Internet Explorer do not support the iterable parameter to the
	    // Set constructor.  We work around that by manually adding the items.
	    var createSetFromList = (function () {
	        var test = new Set([1, 2, 3]);
	        if (test.size === 3) {
	            return function createSetFromList(lst) { return new Set(lst); };
	        }
	        else {
	            return function createSetAndPopulateFromList(lst) {
	                var res = new Set(lst);
	                if (res.size !== lst.length) {
	                    for (var i = 0; i < lst.length; i++) {
	                        res.add(lst[i]);
	                    }
	                }
	                return res;
	            };
	        }
	    })();
	
	    /**
	     * Providers for validators to be used for {@link FormControl}s in a form.
	     *
	     * Provide this using `multi: true` to add validators.
	     *
	     * ### Example
	     *
	     * {@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
	     * @stable
	     */
	    var NG_VALIDATORS = new _angular_core.OpaqueToken('NgValidators');
	    /**
	     * Providers for asynchronous validators to be used for {@link FormControl}s
	     * in a form.
	     *
	     * Provide this using `multi: true` to add validators.
	     *
	     * See {@link NG_VALIDATORS} for more details.
	     *
	     * @stable
	     */
	    var NG_ASYNC_VALIDATORS = new _angular_core.OpaqueToken('NgAsyncValidators');
	    /**
	     * Provides a set of validators used by form controls.
	     *
	     * A validator is a function that processes a {@link FormControl} or collection of
	     * controls and returns a map of errors. A null map means that validation has passed.
	     *
	     * ### Example
	     *
	     * ```typescript
	     * var loginControl = new FormControl("", Validators.required)
	     * ```
	     *
	     * @stable
	     */
	    var Validators = (function () {
	        function Validators() {
	        }
	        /**
	         * Validator that requires controls to have a non-empty value.
	         */
	        Validators.required = function (control) {
	            return isBlank(control.value) || (isString(control.value) && control.value == '') ?
	                { 'required': true } :
	                null;
	        };
	        /**
	         * Validator that requires controls to have a value of a minimum length.
	         */
	        Validators.minLength = function (minLength) {
	            return function (control) {
	                if (isPresent(Validators.required(control)))
	                    return null;
	                var v = control.value;
	                return v.length < minLength ?
	                    { 'minlength': { 'requiredLength': minLength, 'actualLength': v.length } } :
	                    null;
	            };
	        };
	        /**
	         * Validator that requires controls to have a value of a maximum length.
	         */
	        Validators.maxLength = function (maxLength) {
	            return function (control) {
	                if (isPresent(Validators.required(control)))
	                    return null;
	                var v = control.value;
	                return v.length > maxLength ?
	                    { 'maxlength': { 'requiredLength': maxLength, 'actualLength': v.length } } :
	                    null;
	            };
	        };
	        /**
	         * Validator that requires a control to match a regex to its value.
	         */
	        Validators.pattern = function (pattern) {
	            return function (control) {
	                if (isPresent(Validators.required(control)))
	                    return null;
	                var regex = new RegExp("^" + pattern + "$");
	                var v = control.value;
	                return regex.test(v) ? null :
	                    { 'pattern': { 'requiredPattern': "^" + pattern + "$", 'actualValue': v } };
	            };
	        };
	        /**
	         * No-op validator.
	         */
	        Validators.nullValidator = function (c) { return null; };
	        /**
	         * Compose multiple validators into a single function that returns the union
	         * of the individual error maps.
	         */
	        Validators.compose = function (validators) {
	            if (isBlank(validators))
	                return null;
	            var presentValidators = validators.filter(isPresent);
	            if (presentValidators.length == 0)
	                return null;
	            return function (control) {
	                return _mergeErrors(_executeValidators(control, presentValidators));
	            };
	        };
	        Validators.composeAsync = function (validators) {
	            if (isBlank(validators))
	                return null;
	            var presentValidators = validators.filter(isPresent);
	            if (presentValidators.length == 0)
	                return null;
	            return function (control) {
	                var promises = _executeAsyncValidators(control, presentValidators).map(_convertToPromise);
	                return Promise.all(promises).then(_mergeErrors);
	            };
	        };
	        return Validators;
	    }());
	    function _convertToPromise(obj) {
	        return isPromise(obj) ? obj : rxjs_operator_toPromise.toPromise.call(obj);
	    }
	    function _executeValidators(control, validators) {
	        return validators.map(function (v) { return v(control); });
	    }
	    function _executeAsyncValidators(control, validators) {
	        return validators.map(function (v) { return v(control); });
	    }
	    function _mergeErrors(arrayOfErrors) {
	        var res = arrayOfErrors.reduce(function (res, errors) {
	            return isPresent(errors) ? StringMapWrapper.merge(res, errors) : res;
	        }, {});
	        return StringMapWrapper.isEmpty(res) ? null : res;
	    }
	
	    /**
	     * Used to provide a {@link ControlValueAccessor} for form controls.
	     *
	     * See {@link DefaultValueAccessor} for how to implement one.
	     * @stable
	     */
	    var NG_VALUE_ACCESSOR = new _angular_core.OpaqueToken('NgValueAccessor');
	
	    var CHECKBOX_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return CheckboxControlValueAccessor; }),
	        multi: true
	    };
	    /**
	     * The accessor for writing a value and listening to changes on a checkbox input element.
	     *
	     *  ### Example
	     *  ```
	     *  <input type="checkbox" name="rememberLogin" ngModel>
	     *  ```
	     *
	     *  @stable
	     */
	    var CheckboxControlValueAccessor = (function () {
	        function CheckboxControlValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        CheckboxControlValueAccessor.prototype.writeValue = function (value) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
	        };
	        CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	        CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        CheckboxControlValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
	                        host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
	                        providers: [CHECKBOX_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        CheckboxControlValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ];
	        return CheckboxControlValueAccessor;
	    }());
	
	    var DEFAULT_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return DefaultValueAccessor; }),
	        multi: true
	    };
	    /**
	     * The default accessor for writing a value and listening to changes that is used by the
	     * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
	     *
	     *  ### Example
	     *  ```
	     *  <input type="text" name="searchQuery" ngModel>
	     *  ```
	     *
	     *  @stable
	     */
	    var DefaultValueAccessor = (function () {
	        function DefaultValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        DefaultValueAccessor.prototype.writeValue = function (value) {
	            var normalizedValue = isBlank(value) ? '' : value;
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
	        };
	        DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	        DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        DefaultValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
	                        // TODO: vsavkin replace the above selector with the one below it once
	                        // https://github.com/angular/angular/issues/3011 is implemented
	                        // selector: '[ngControl],[ngModel],[ngFormControl]',
	                        host: { '(input)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                        providers: [DEFAULT_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        DefaultValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ];
	        return DefaultValueAccessor;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    function normalizeValidator(validator) {
	        if (validator.validate !== undefined) {
	            return function (c) { return validator.validate(c); };
	        }
	        else {
	            return validator;
	        }
	    }
	    function normalizeAsyncValidator(validator) {
	        if (validator.validate !== undefined) {
	            return function (c) { return validator.validate(c); };
	        }
	        else {
	            return validator;
	        }
	    }
	
	    var NUMBER_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return NumberValueAccessor; }),
	        multi: true
	    };
	    /**
	     * The accessor for writing a number value and listening to changes that is used by the
	     * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
	     *
	     *  ### Example
	     *  ```
	     *  <input type="number" [(ngModel)]="age">
	     *  ```
	     */
	    var NumberValueAccessor = (function () {
	        function NumberValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        NumberValueAccessor.prototype.writeValue = function (value) {
	            // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
	            var normalizedValue = isBlank(value) ? '' : value;
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
	        };
	        NumberValueAccessor.prototype.registerOnChange = function (fn) {
	            this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
	        };
	        NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        NumberValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
	                        host: {
	                            '(change)': 'onChange($event.target.value)',
	                            '(input)': 'onChange($event.target.value)',
	                            '(blur)': 'onTouched()'
	                        },
	                        providers: [NUMBER_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        NumberValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ];
	        return NumberValueAccessor;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$2 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    function unimplemented() {
	        throw new Error('unimplemented');
	    }
	    /**
	     * A base class that all control directive extend.
	     * It binds a {@link FormControl} object to a DOM element.
	     *
	     * Used internally by Angular forms.
	     *
	     * @stable
	     */
	    var NgControl = (function (_super) {
	        __extends$2(NgControl, _super);
	        function NgControl() {
	            _super.apply(this, arguments);
	            /** @internal */
	            this._parent = null;
	            this.name = null;
	            this.valueAccessor = null;
	            /** @internal */
	            this._rawValidators = [];
	            /** @internal */
	            this._rawAsyncValidators = [];
	        }
	        Object.defineProperty(NgControl.prototype, "validator", {
	            get: function () { return unimplemented(); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgControl.prototype, "asyncValidator", {
	            get: function () { return unimplemented(); },
	            enumerable: true,
	            configurable: true
	        });
	        return NgControl;
	    }(AbstractControlDirective));
	
	    var RADIO_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return RadioControlValueAccessor; }),
	        multi: true
	    };
	    /**
	     * Internal class used by Angular to uncheck radio buttons with the matching name.
	     */
	    var RadioControlRegistry = (function () {
	        function RadioControlRegistry() {
	            this._accessors = [];
	        }
	        RadioControlRegistry.prototype.add = function (control, accessor) {
	            this._accessors.push([control, accessor]);
	        };
	        RadioControlRegistry.prototype.remove = function (accessor) {
	            var indexToRemove = -1;
	            for (var i = 0; i < this._accessors.length; ++i) {
	                if (this._accessors[i][1] === accessor) {
	                    indexToRemove = i;
	                }
	            }
	            ListWrapper.removeAt(this._accessors, indexToRemove);
	        };
	        RadioControlRegistry.prototype.select = function (accessor) {
	            var _this = this;
	            this._accessors.forEach(function (c) {
	                if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
	                    c[1].fireUncheck(accessor.value);
	                }
	            });
	        };
	        RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
	            if (!controlPair[0].control)
	                return false;
	            return controlPair[0]._parent === accessor._control._parent &&
	                controlPair[1].name === accessor.name;
	        };
	        RadioControlRegistry.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        RadioControlRegistry.ctorParameters = [];
	        return RadioControlRegistry;
	    }());
	    /**
	     * The accessor for writing a radio control value and listening to changes that is used by the
	     * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
	     *
	     *  ### Example
	     *  ```
	     *  @Component({
	     *    template: `
	     *      <input type="radio" name="food" [(ngModel)]="food" value="chicken">
	     *      <input type="radio" name="food" [(ngModel)]="food" value="fish">
	     *    `
	     *  })
	     *  class FoodCmp {
	     *    food = 'chicken';
	     *  }
	     *  ```
	     */
	    var RadioControlValueAccessor = (function () {
	        function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this._registry = _registry;
	            this._injector = _injector;
	            this.onChange = function () { };
	            this.onTouched = function () { };
	        }
	        RadioControlValueAccessor.prototype.ngOnInit = function () {
	            this._control = this._injector.get(NgControl);
	            this._checkName();
	            this._registry.add(this._control, this);
	        };
	        RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
	        RadioControlValueAccessor.prototype.writeValue = function (value) {
	            this._state = value === this.value;
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', this._state);
	        };
	        RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
	            var _this = this;
	            this._fn = fn;
	            this.onChange = function () {
	                fn(_this.value);
	                _this._registry.select(_this);
	            };
	        };
	        RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
	        RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        RadioControlValueAccessor.prototype._checkName = function () {
	            if (this.name && this.formControlName && this.name !== this.formControlName) {
	                this._throwNameError();
	            }
	            if (!this.name && this.formControlName)
	                this.name = this.formControlName;
	        };
	        RadioControlValueAccessor.prototype._throwNameError = function () {
	            throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
	        };
	        RadioControlValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
	                        host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
	                        providers: [RADIO_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        RadioControlValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	            { type: RadioControlRegistry, },
	            { type: _angular_core.Injector, },
	        ];
	        RadioControlValueAccessor.propDecorators = {
	            'name': [{ type: _angular_core.Input },],
	            'formControlName': [{ type: _angular_core.Input },],
	            'value': [{ type: _angular_core.Input },],
	        };
	        return RadioControlValueAccessor;
	    }());
	
	    var SELECT_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return SelectControlValueAccessor; }),
	        multi: true
	    };
	    function _buildValueString(id, value) {
	        if (isBlank(id))
	            return "" + value;
	        if (!isPrimitive(value))
	            value = 'Object';
	        return StringWrapper.slice(id + ": " + value, 0, 50);
	    }
	    function _extractId(valueString) {
	        return valueString.split(':')[0];
	    }
	    /**
	     * The accessor for writing a value and listening to changes on a select element.
	     *
	     * Note: We have to listen to the 'change' event because 'input' events aren't fired
	     * for selects in Firefox and IE:
	     * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
	     * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
	     *
	     * @stable
	     */
	    var SelectControlValueAccessor = (function () {
	        function SelectControlValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            /** @internal */
	            this._optionMap = new Map();
	            /** @internal */
	            this._idCounter = 0;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        SelectControlValueAccessor.prototype.writeValue = function (value) {
	            this.value = value;
	            var valueString = _buildValueString(this._getOptionId(value), value);
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
	        };
	        SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
	            var _this = this;
	            this.onChange = function (valueString) {
	                _this.value = valueString;
	                fn(_this._getOptionValue(valueString));
	            };
	        };
	        SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        /** @internal */
	        SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
	        /** @internal */
	        SelectControlValueAccessor.prototype._getOptionId = function (value) {
	            for (var _i = 0, _a = MapWrapper.keys(this._optionMap); _i < _a.length; _i++) {
	                var id = _a[_i];
	                if (looseIdentical(this._optionMap.get(id), value))
	                    return id;
	            }
	            return null;
	        };
	        /** @internal */
	        SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
	            var value = this._optionMap.get(_extractId(valueString));
	            return isPresent(value) ? value : valueString;
	        };
	        SelectControlValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
	                        host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                        providers: [SELECT_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        SelectControlValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ];
	        return SelectControlValueAccessor;
	    }());
	    /**
	     * Marks `<option>` as dynamic, so Angular can be notified when options change.
	     *
	     * ### Example
	     *
	     * ```
	     * <select name="city" ngModel>
	     *   <option *ngFor="let c of cities" [value]="c"></option>
	     * </select>
	     * ```
	     *
	     * @stable
	     */
	    var NgSelectOption = (function () {
	        function NgSelectOption(_element, _renderer, _select) {
	            this._element = _element;
	            this._renderer = _renderer;
	            this._select = _select;
	            if (isPresent(this._select))
	                this.id = this._select._registerOption();
	        }
	        Object.defineProperty(NgSelectOption.prototype, "ngValue", {
	            set: function (value) {
	                if (this._select == null)
	                    return;
	                this._select._optionMap.set(this.id, value);
	                this._setElementValue(_buildValueString(this.id, value));
	                this._select.writeValue(this._select.value);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgSelectOption.prototype, "value", {
	            set: function (value) {
	                this._setElementValue(value);
	                if (isPresent(this._select))
	                    this._select.writeValue(this._select.value);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /** @internal */
	        NgSelectOption.prototype._setElementValue = function (value) {
	            this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
	        };
	        NgSelectOption.prototype.ngOnDestroy = function () {
	            if (isPresent(this._select)) {
	                this._select._optionMap.delete(this.id);
	                this._select.writeValue(this._select.value);
	            }
	        };
	        NgSelectOption.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: 'option' },] },
	        ];
	        /** @nocollapse */
	        NgSelectOption.ctorParameters = [
	            { type: _angular_core.ElementRef, },
	            { type: _angular_core.Renderer, },
	            { type: SelectControlValueAccessor, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	        ];
	        NgSelectOption.propDecorators = {
	            'ngValue': [{ type: _angular_core.Input, args: ['ngValue',] },],
	            'value': [{ type: _angular_core.Input, args: ['value',] },],
	        };
	        return NgSelectOption;
	    }());
	
	    var SELECT_MULTIPLE_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return SelectMultipleControlValueAccessor; }),
	        multi: true
	    };
	    function _buildValueString$1(id, value) {
	        if (isBlank(id))
	            return "" + value;
	        if (isString(value))
	            value = "'" + value + "'";
	        if (!isPrimitive(value))
	            value = 'Object';
	        return StringWrapper.slice(id + ": " + value, 0, 50);
	    }
	    function _extractId$1(valueString) {
	        return valueString.split(':')[0];
	    }
	    /**
	     * The accessor for writing a value and listening to changes on a select element.
	     *
	     * @stable
	     */
	    var SelectMultipleControlValueAccessor = (function () {
	        function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            /** @internal */
	            this._optionMap = new Map();
	            /** @internal */
	            this._idCounter = 0;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
	            var _this = this;
	            this.value = value;
	            if (value == null)
	                return;
	            var values = value;
	            // convert values to ids
	            var ids = values.map(function (v) { return _this._getOptionId(v); });
	            this._optionMap.forEach(function (opt, o) { opt._setSelected(ids.indexOf(o.toString()) > -1); });
	        };
	        SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
	            var _this = this;
	            this.onChange = function (_) {
	                var selected = [];
	                if (_.hasOwnProperty('selectedOptions')) {
	                    var options = _.selectedOptions;
	                    for (var i = 0; i < options.length; i++) {
	                        var opt = options.item(i);
	                        var val = _this._getOptionValue(opt.value);
	                        selected.push(val);
	                    }
	                }
	                else {
	                    var options = _.options;
	                    for (var i = 0; i < options.length; i++) {
	                        var opt = options.item(i);
	                        if (opt.selected) {
	                            var val = _this._getOptionValue(opt.value);
	                            selected.push(val);
	                        }
	                    }
	                }
	                fn(selected);
	            };
	        };
	        SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        /** @internal */
	        SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
	            var id = (this._idCounter++).toString();
	            this._optionMap.set(id, value);
	            return id;
	        };
	        /** @internal */
	        SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
	            for (var _i = 0, _a = MapWrapper.keys(this._optionMap); _i < _a.length; _i++) {
	                var id = _a[_i];
	                if (looseIdentical(this._optionMap.get(id)._value, value))
	                    return id;
	            }
	            return null;
	        };
	        /** @internal */
	        SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
	            var opt = this._optionMap.get(_extractId$1(valueString));
	            return isPresent(opt) ? opt._value : valueString;
	        };
	        SelectMultipleControlValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
	                        host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
	                        providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        SelectMultipleControlValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ];
	        return SelectMultipleControlValueAccessor;
	    }());
	    /**
	     * Marks `<option>` as dynamic, so Angular can be notified when options change.
	     *
	     * ### Example
	     *
	     * ```
	     * <select multiple name="city" ngModel>
	     *   <option *ngFor="let c of cities" [value]="c"></option>
	     * </select>
	     * ```
	     */
	    var NgSelectMultipleOption = (function () {
	        function NgSelectMultipleOption(_element, _renderer, _select) {
	            this._element = _element;
	            this._renderer = _renderer;
	            this._select = _select;
	            if (isPresent(this._select)) {
	                this.id = this._select._registerOption(this);
	            }
	        }
	        Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
	            set: function (value) {
	                if (this._select == null)
	                    return;
	                this._value = value;
	                this._setElementValue(_buildValueString$1(this.id, value));
	                this._select.writeValue(this._select.value);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
	            set: function (value) {
	                if (isPresent(this._select)) {
	                    this._value = value;
	                    this._setElementValue(_buildValueString$1(this.id, value));
	                    this._select.writeValue(this._select.value);
	                }
	                else {
	                    this._setElementValue(value);
	                }
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /** @internal */
	        NgSelectMultipleOption.prototype._setElementValue = function (value) {
	            this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
	        };
	        /** @internal */
	        NgSelectMultipleOption.prototype._setSelected = function (selected) {
	            this._renderer.setElementProperty(this._element.nativeElement, 'selected', selected);
	        };
	        NgSelectMultipleOption.prototype.ngOnDestroy = function () {
	            if (isPresent(this._select)) {
	                this._select._optionMap.delete(this.id);
	                this._select.writeValue(this._select.value);
	            }
	        };
	        NgSelectMultipleOption.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: 'option' },] },
	        ];
	        /** @nocollapse */
	        NgSelectMultipleOption.ctorParameters = [
	            { type: _angular_core.ElementRef, },
	            { type: _angular_core.Renderer, },
	            { type: SelectMultipleControlValueAccessor, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	        ];
	        NgSelectMultipleOption.propDecorators = {
	            'ngValue': [{ type: _angular_core.Input, args: ['ngValue',] },],
	            'value': [{ type: _angular_core.Input, args: ['value',] },],
	        };
	        return NgSelectMultipleOption;
	    }());
	
	    function controlPath(name, parent) {
	        var p = ListWrapper.clone(parent.path);
	        p.push(name);
	        return p;
	    }
	    function setUpControl(control, dir) {
	        if (isBlank(control))
	            _throwError(dir, 'Cannot find control with');
	        if (isBlank(dir.valueAccessor))
	            _throwError(dir, 'No value accessor for form control with');
	        control.validator = Validators.compose([control.validator, dir.validator]);
	        control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	        dir.valueAccessor.writeValue(control.value);
	        // view -> model
	        dir.valueAccessor.registerOnChange(function (newValue) {
	            dir.viewToModelUpdate(newValue);
	            control.markAsDirty();
	            control.setValue(newValue, { emitModelToViewChange: false });
	        });
	        // touched
	        dir.valueAccessor.registerOnTouched(function () { return control.markAsTouched(); });
	        control.registerOnChange(function (newValue, emitModelEvent) {
	            // control -> view
	            dir.valueAccessor.writeValue(newValue);
	            // control -> ngModel
	            if (emitModelEvent)
	                dir.viewToModelUpdate(newValue);
	        });
	        if (dir.valueAccessor.setDisabledState) {
	            control.registerOnDisabledChange(function (isDisabled) { dir.valueAccessor.setDisabledState(isDisabled); });
	        }
	        // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
	        dir._rawValidators.forEach(function (validator) {
	            if (validator.registerOnValidatorChange)
	                validator.registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
	        });
	        dir._rawAsyncValidators.forEach(function (validator) {
	            if (validator.registerOnValidatorChange)
	                validator.registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
	        });
	    }
	    function cleanUpControl(control, dir) {
	        dir.valueAccessor.registerOnChange(function () { return _noControlError(dir); });
	        dir.valueAccessor.registerOnTouched(function () { return _noControlError(dir); });
	        dir._rawValidators.forEach(function (validator) { return validator.registerOnValidatorChange(null); });
	        dir._rawAsyncValidators.forEach(function (validator) { return validator.registerOnValidatorChange(null); });
	        if (control)
	            control._clearChangeFns();
	    }
	    function setUpFormContainer(control, dir) {
	        if (isBlank(control))
	            _throwError(dir, 'Cannot find control with');
	        control.validator = Validators.compose([control.validator, dir.validator]);
	        control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	    }
	    function _noControlError(dir) {
	        return _throwError(dir, 'There is no FormControl instance attached to form control element with');
	    }
	    function _throwError(dir, message) {
	        var messageEnd;
	        if (dir.path.length > 1) {
	            messageEnd = "path: '" + dir.path.join(' -> ') + "'";
	        }
	        else if (dir.path[0]) {
	            messageEnd = "name: '" + dir.path + "'";
	        }
	        else {
	            messageEnd = 'unspecified name attribute';
	        }
	        throw new Error(message + " " + messageEnd);
	    }
	    function composeValidators(validators) {
	        return isPresent(validators) ? Validators.compose(validators.map(normalizeValidator)) : null;
	    }
	    function composeAsyncValidators(validators) {
	        return isPresent(validators) ? Validators.composeAsync(validators.map(normalizeAsyncValidator)) :
	            null;
	    }
	    function isPropertyUpdated(changes, viewModel) {
	        if (!StringMapWrapper.contains(changes, 'model'))
	            return false;
	        var change = changes['model'];
	        if (change.isFirstChange())
	            return true;
	        return !looseIdentical(viewModel, change.currentValue);
	    }
	    function isBuiltInAccessor(valueAccessor) {
	        return (hasConstructor(valueAccessor, CheckboxControlValueAccessor) ||
	            hasConstructor(valueAccessor, NumberValueAccessor) ||
	            hasConstructor(valueAccessor, SelectControlValueAccessor) ||
	            hasConstructor(valueAccessor, SelectMultipleControlValueAccessor) ||
	            hasConstructor(valueAccessor, RadioControlValueAccessor));
	    }
	    // TODO: vsavkin remove it once https://github.com/angular/angular/issues/3011 is implemented
	    function selectValueAccessor(dir, valueAccessors) {
	        if (isBlank(valueAccessors))
	            return null;
	        var defaultAccessor;
	        var builtinAccessor;
	        var customAccessor;
	        valueAccessors.forEach(function (v) {
	            if (hasConstructor(v, DefaultValueAccessor)) {
	                defaultAccessor = v;
	            }
	            else if (isBuiltInAccessor(v)) {
	                if (isPresent(builtinAccessor))
	                    _throwError(dir, 'More than one built-in value accessor matches form control with');
	                builtinAccessor = v;
	            }
	            else {
	                if (isPresent(customAccessor))
	                    _throwError(dir, 'More than one custom value accessor matches form control with');
	                customAccessor = v;
	            }
	        });
	        if (isPresent(customAccessor))
	            return customAccessor;
	        if (isPresent(builtinAccessor))
	            return builtinAccessor;
	        if (isPresent(defaultAccessor))
	            return defaultAccessor;
	        _throwError(dir, 'No valid value accessor for form control with');
	        return null;
	    }
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * This is a base class for code shared between {@link NgModelGroup} and {@link FormGroupName}.
	     *
	     * @stable
	     */
	    var AbstractFormGroupDirective = (function (_super) {
	        __extends(AbstractFormGroupDirective, _super);
	        function AbstractFormGroupDirective() {
	            _super.apply(this, arguments);
	        }
	        AbstractFormGroupDirective.prototype.ngOnInit = function () {
	            this._checkParentType();
	            this.formDirective.addFormGroup(this);
	        };
	        AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
	            if (this.formDirective) {
	                this.formDirective.removeFormGroup(this);
	            }
	        };
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
	            /**
	             * Get the {@link FormGroup} backing this binding.
	             */
	            get: function () { return this.formDirective.getFormGroup(this); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
	            /**
	             * Get the path to this control group.
	             */
	            get: function () { return controlPath(this.name, this._parent); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
	            /**
	             * Get the {@link Form} to which this group belongs.
	             */
	            get: function () { return this._parent ? this._parent.formDirective : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
	            get: function () { return composeValidators(this._validators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
	            get: function () { return composeAsyncValidators(this._asyncValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        /** @internal */
	        AbstractFormGroupDirective.prototype._checkParentType = function () { };
	        return AbstractFormGroupDirective;
	    }(ControlContainer));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$3 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var AbstractControlStatus = (function () {
	        function AbstractControlStatus(cd) {
	            this._cd = cd;
	        }
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
	            get: function () {
	                return isPresent(this._cd.control) ? this._cd.control.untouched : false;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
	            get: function () {
	                return isPresent(this._cd.control) ? this._cd.control.touched : false;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
	            get: function () {
	                return isPresent(this._cd.control) ? this._cd.control.pristine : false;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
	            get: function () {
	                return isPresent(this._cd.control) ? this._cd.control.dirty : false;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
	            get: function () {
	                return isPresent(this._cd.control) ? this._cd.control.valid : false;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
	            get: function () {
	                return isPresent(this._cd.control) ? this._cd.control.invalid : false;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        return AbstractControlStatus;
	    }());
	    var ngControlStatusHost = {
	        '[class.ng-untouched]': 'ngClassUntouched',
	        '[class.ng-touched]': 'ngClassTouched',
	        '[class.ng-pristine]': 'ngClassPristine',
	        '[class.ng-dirty]': 'ngClassDirty',
	        '[class.ng-valid]': 'ngClassValid',
	        '[class.ng-invalid]': 'ngClassInvalid'
	    };
	    /**
	     * Directive automatically applied to Angular form controls that sets CSS classes
	     * based on control status (valid/invalid/dirty/etc).
	     *
	     * @stable
	     */
	    var NgControlStatus = (function (_super) {
	        __extends$3(NgControlStatus, _super);
	        function NgControlStatus(cd) {
	            _super.call(this, cd);
	        }
	        NgControlStatus.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
	        ];
	        /** @nocollapse */
	        NgControlStatus.ctorParameters = [
	            { type: NgControl, decorators: [{ type: _angular_core.Self },] },
	        ];
	        return NgControlStatus;
	    }(AbstractControlStatus));
	    /**
	     * Directive automatically applied to Angular form groups that sets CSS classes
	     * based on control status (valid/invalid/dirty/etc).
	     *
	     * @stable
	     */
	    var NgControlStatusGroup = (function (_super) {
	        __extends$3(NgControlStatusGroup, _super);
	        function NgControlStatusGroup(cd) {
	            _super.call(this, cd);
	        }
	        NgControlStatusGroup.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
	                        host: ngControlStatusHost
	                    },] },
	        ];
	        /** @nocollapse */
	        NgControlStatusGroup.ctorParameters = [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Self },] },
	        ];
	        return NgControlStatusGroup;
	    }(AbstractControlStatus));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$5 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * Use by directives and components to emit custom Events.
	     *
	     * ### Examples
	     *
	     * In the following example, `Zippy` alternatively emits `open` and `close` events when its
	     * title gets clicked:
	     *
	     * ```
	     * @Component({
	     *   selector: 'zippy',
	     *   template: `
	     *   <div class="zippy">
	     *     <div (click)="toggle()">Toggle</div>
	     *     <div [hidden]="!visible">
	     *       <ng-content></ng-content>
	     *     </div>
	     *  </div>`})
	     * export class Zippy {
	     *   visible: boolean = true;
	     *   @Output() open: EventEmitter<any> = new EventEmitter();
	     *   @Output() close: EventEmitter<any> = new EventEmitter();
	     *
	     *   toggle() {
	     *     this.visible = !this.visible;
	     *     if (this.visible) {
	     *       this.open.emit(null);
	     *     } else {
	     *       this.close.emit(null);
	     *     }
	     *   }
	     * }
	     * ```
	     *
	     * The events payload can be accessed by the parameter `$event` on the components output event
	     * handler:
	     *
	     * ```
	     * <zippy (open)="onOpen($event)" (close)="onClose($event)"></zippy>
	     * ```
	     *
	     * Uses Rx.Observable but provides an adapter to make it work as specified here:
	     * https://github.com/jhusain/observable-spec
	     *
	     * Once a reference implementation of the spec is available, switch to it.
	     * @stable
	     */
	    var EventEmitter = (function (_super) {
	        __extends$5(EventEmitter, _super);
	        /**
	         * Creates an instance of [EventEmitter], which depending on [isAsync],
	         * delivers events synchronously or asynchronously.
	         */
	        function EventEmitter(isAsync) {
	            if (isAsync === void 0) { isAsync = false; }
	            _super.call(this);
	            this.__isAsync = isAsync;
	        }
	        EventEmitter.prototype.emit = function (value) { _super.prototype.next.call(this, value); };
	        EventEmitter.prototype.subscribe = function (generatorOrNext, error, complete) {
	            var schedulerFn;
	            var errorFn = function (err) { return null; };
	            var completeFn = function () { return null; };
	            if (generatorOrNext && typeof generatorOrNext === 'object') {
	                schedulerFn = this.__isAsync ? function (value /** TODO #9100 */) {
	                    setTimeout(function () { return generatorOrNext.next(value); });
	                } : function (value /** TODO #9100 */) { generatorOrNext.next(value); };
	                if (generatorOrNext.error) {
	                    errorFn = this.__isAsync ? function (err) { setTimeout(function () { return generatorOrNext.error(err); }); } :
	                        function (err) { generatorOrNext.error(err); };
	                }
	                if (generatorOrNext.complete) {
	                    completeFn = this.__isAsync ? function () { setTimeout(function () { return generatorOrNext.complete(); }); } :
	                        function () { generatorOrNext.complete(); };
	                }
	            }
	            else {
	                schedulerFn = this.__isAsync ? function (value /** TODO #9100 */) {
	                    setTimeout(function () { return generatorOrNext(value); });
	                } : function (value /** TODO #9100 */) { generatorOrNext(value); };
	                if (error) {
	                    errorFn =
	                        this.__isAsync ? function (err) { setTimeout(function () { return error(err); }); } : function (err) { error(err); };
	                }
	                if (complete) {
	                    completeFn =
	                        this.__isAsync ? function () { setTimeout(function () { return complete(); }); } : function () { complete(); };
	                }
	            }
	            return _super.prototype.subscribe.call(this, schedulerFn, errorFn, completeFn);
	        };
	        return EventEmitter;
	    }(rxjs_Subject.Subject));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$6 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
	     */
	    var VALID = 'VALID';
	    /**
	     * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
	     */
	    var INVALID = 'INVALID';
	    /**
	     * Indicates that a FormControl is pending, i.e. that async validation is occurring and
	     * errors are not yet available for the input value.
	     */
	    var PENDING = 'PENDING';
	    /**
	     * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
	     * calculations of validity or value.
	     */
	    var DISABLED = 'DISABLED';
	    function _find(control, path, delimiter) {
	        if (isBlank(path))
	            return null;
	        if (!(path instanceof Array)) {
	            path = path.split(delimiter);
	        }
	        if (path instanceof Array && ListWrapper.isEmpty(path))
	            return null;
	        return path.reduce(function (v, name) {
	            if (v instanceof FormGroup) {
	                return isPresent(v.controls[name]) ? v.controls[name] : null;
	            }
	            else if (v instanceof FormArray) {
	                var index = name;
	                return isPresent(v.at(index)) ? v.at(index) : null;
	            }
	            else {
	                return null;
	            }
	        }, control);
	    }
	    function toObservable(r) {
	        return isPromise(r) ? rxjs_observable_fromPromise.fromPromise(r) : r;
	    }
	    function coerceToValidator(validator) {
	        return Array.isArray(validator) ? composeValidators(validator) : validator;
	    }
	    function coerceToAsyncValidator(asyncValidator) {
	        return Array.isArray(asyncValidator) ? composeAsyncValidators(asyncValidator) : asyncValidator;
	    }
	    /**
	     * @whatItDoes This is the base class for {@link FormControl}, {@link FormGroup}, and
	     * {@link FormArray}.
	     *
	     * It provides some of the shared behavior that all controls and groups of controls have, like
	     * running validators, calculating status, and resetting state. It also defines the properties
	     * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
	     * instantiated directly.
	     *
	     * @stable
	     */
	    var AbstractControl = (function () {
	        function AbstractControl(validator, asyncValidator) {
	            this.validator = validator;
	            this.asyncValidator = asyncValidator;
	            /** @internal */
	            this._onCollectionChange = function () { };
	            this._pristine = true;
	            this._touched = false;
	        }
	        Object.defineProperty(AbstractControl.prototype, "value", {
	            /**
	             * The value of the control.
	             */
	            get: function () { return this._value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "status", {
	            /**
	             * The validation status of the control. There are four possible
	             * validation statuses:
	             *
	             * * **VALID**:  control has passed all validation checks
	             * * **INVALID**: control has failed at least one validation check
	             * * **PENDING**: control is in the midst of conducting a validation check
	             * * **DISABLED**: control is exempt from validation checks
	             *
	             * These statuses are mutually exclusive, so a control cannot be
	             * both valid AND invalid or invalid AND disabled.
	             */
	            get: function () { return this._status; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "valid", {
	            /**
	             * A control is `valid` when its `status === VALID`.
	             *
	             * In order to have this status, the control must have passed all its
	             * validation checks.
	             */
	            get: function () { return this._status === VALID; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "invalid", {
	            /**
	             * A control is `invalid` when its `status === INVALID`.
	             *
	             * In order to have this status, the control must have failed
	             * at least one of its validation checks.
	             */
	            get: function () { return this._status === INVALID; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "pending", {
	            /**
	             * A control is `pending` when its `status === PENDING`.
	             *
	             * In order to have this status, the control must be in the
	             * middle of conducting a validation check.
	             */
	            get: function () { return this._status == PENDING; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "disabled", {
	            /**
	             * A control is `disabled` when its `status === DISABLED`.
	             *
	             * Disabled controls are exempt from validation checks and
	             * are not included in the aggregate value of their ancestor
	             * controls.
	             */
	            get: function () { return this._status === DISABLED; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "enabled", {
	            /**
	             * A control is `enabled` as long as its `status !== DISABLED`.
	             *
	             * In other words, it has a status of `VALID`, `INVALID`, or
	             * `PENDING`.
	             */
	            get: function () { return this._status !== DISABLED; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "errors", {
	            /**
	             * Returns any errors generated by failing validation. If there
	             * are no errors, it will return null.
	             */
	            get: function () { return this._errors; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "pristine", {
	            /**
	             * A control is `pristine` if the user has not yet changed
	             * the value in the UI.
	             *
	             * Note that programmatic changes to a control's value will
	             * *not* mark it dirty.
	             */
	            get: function () { return this._pristine; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "dirty", {
	            /**
	             * A control is `dirty` if the user has changed the value
	             * in the UI.
	             *
	             * Note that programmatic changes to a control's value will
	             * *not* mark it dirty.
	             */
	            get: function () { return !this.pristine; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "touched", {
	            /**
	            * A control is marked `touched` once the user has triggered
	            * a `blur` event on it.
	            */
	            get: function () { return this._touched; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "untouched", {
	            /**
	             * A control is `untouched` if the user has not yet triggered
	             * a `blur` event on it.
	             */
	            get: function () { return !this._touched; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "valueChanges", {
	            /**
	             * Emits an event every time the value of the control changes, in
	             * the UI or programmatically.
	             */
	            get: function () { return this._valueChanges; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "statusChanges", {
	            /**
	             * Emits an event every time the validation status of the control
	             * is re-calculated.
	             */
	            get: function () { return this._statusChanges; },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * Sets the synchronous validators that are active on this control.  Calling
	         * this will overwrite any existing sync validators.
	         */
	        AbstractControl.prototype.setValidators = function (newValidator) {
	            this.validator = coerceToValidator(newValidator);
	        };
	        /**
	         * Sets the async validators that are active on this control. Calling this
	         * will overwrite any existing async validators.
	         */
	        AbstractControl.prototype.setAsyncValidators = function (newValidator) {
	            this.asyncValidator = coerceToAsyncValidator(newValidator);
	        };
	        /**
	         * Empties out the sync validator list.
	         */
	        AbstractControl.prototype.clearValidators = function () { this.validator = null; };
	        /**
	         * Empties out the async validator list.
	         */
	        AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
	        /**
	         * Marks the control as `touched`.
	         *
	         * This will also mark all direct ancestors as `touched` to maintain
	         * the model.
	         */
	        AbstractControl.prototype.markAsTouched = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            onlySelf = normalizeBool(onlySelf);
	            this._touched = true;
	            if (isPresent(this._parent) && !onlySelf) {
	                this._parent.markAsTouched({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         * Marks the control as `untouched`.
	         *
	         * If the control has any children, it will also mark all children as `untouched`
	         * to maintain the model, and re-calculate the `touched` status of all parent
	         * controls.
	         */
	        AbstractControl.prototype.markAsUntouched = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._touched = false;
	            this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
	            if (isPresent(this._parent) && !onlySelf) {
	                this._parent._updateTouched({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         * Marks the control as `dirty`.
	         *
	         * This will also mark all direct ancestors as `dirty` to maintain
	         * the model.
	         */
	        AbstractControl.prototype.markAsDirty = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            onlySelf = normalizeBool(onlySelf);
	            this._pristine = false;
	            if (isPresent(this._parent) && !onlySelf) {
	                this._parent.markAsDirty({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         * Marks the control as `pristine`.
	         *
	         * If the control has any children, it will also mark all children as `pristine`
	         * to maintain the model, and re-calculate the `pristine` status of all parent
	         * controls.
	         */
	        AbstractControl.prototype.markAsPristine = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._pristine = true;
	            this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
	            if (isPresent(this._parent) && !onlySelf) {
	                this._parent._updatePristine({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         * Marks the control as `pending`.
	         */
	        AbstractControl.prototype.markAsPending = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            onlySelf = normalizeBool(onlySelf);
	            this._status = PENDING;
	            if (isPresent(this._parent) && !onlySelf) {
	                this._parent.markAsPending({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         * Disables the control. This means the control will be exempt from validation checks and
	         * excluded from the aggregate value of any parent. Its status is `DISABLED`.
	         *
	         * If the control has children, all children will be disabled to maintain the model.
	         */
	        AbstractControl.prototype.disable = function (_a) {
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            emitEvent = isPresent(emitEvent) ? emitEvent : true;
	            this._status = DISABLED;
	            this._errors = null;
	            this._forEachChild(function (control) { control.disable({ onlySelf: true }); });
	            this._updateValue();
	            if (emitEvent) {
	                this._valueChanges.emit(this._value);
	                this._statusChanges.emit(this._status);
	            }
	            this._updateAncestors(onlySelf);
	            this._onDisabledChange(true);
	        };
	        /**
	         * Enables the control. This means the control will be included in validation checks and
	         * the aggregate value of its parent. Its status is re-calculated based on its value and
	         * its validators.
	         *
	         * If the control has children, all children will be enabled.
	         */
	        AbstractControl.prototype.enable = function (_a) {
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._status = VALID;
	            this._forEachChild(function (control) { control.enable({ onlySelf: true }); });
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
	            this._updateAncestors(onlySelf);
	            this._onDisabledChange(false);
	        };
	        AbstractControl.prototype._updateAncestors = function (onlySelf) {
	            if (isPresent(this._parent) && !onlySelf) {
	                this._parent.updateValueAndValidity();
	                this._parent._updatePristine();
	                this._parent._updateTouched();
	            }
	        };
	        AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
	        /**
	         * Re-calculates the value and validation status of the control.
	         *
	         * By default, it will also update the value and validity of its ancestors.
	         */
	        AbstractControl.prototype.updateValueAndValidity = function (_a) {
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            onlySelf = normalizeBool(onlySelf);
	            emitEvent = isPresent(emitEvent) ? emitEvent : true;
	            this._setInitialStatus();
	            this._updateValue();
	            if (this.enabled) {
	                this._errors = this._runValidator();
	                this._status = this._calculateStatus();
	                if (this._status === VALID || this._status === PENDING) {
	                    this._runAsyncValidator(emitEvent);
	                }
	            }
	            if (emitEvent) {
	                this._valueChanges.emit(this._value);
	                this._statusChanges.emit(this._status);
	            }
	            if (isPresent(this._parent) && !onlySelf) {
	                this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	            }
	        };
	        /** @internal */
	        AbstractControl.prototype._updateTreeValidity = function (_a) {
	            var emitEvent = (_a === void 0 ? { emitEvent: true } : _a).emitEvent;
	            this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity({ emitEvent: emitEvent }); });
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
	        };
	        AbstractControl.prototype._setInitialStatus = function () { this._status = this._allControlsDisabled() ? DISABLED : VALID; };
	        AbstractControl.prototype._runValidator = function () {
	            return isPresent(this.validator) ? this.validator(this) : null;
	        };
	        AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
	            var _this = this;
	            if (isPresent(this.asyncValidator)) {
	                this._status = PENDING;
	                this._cancelExistingSubscription();
	                var obs = toObservable(this.asyncValidator(this));
	                this._asyncValidationSubscription = obs.subscribe({ next: function (res) { return _this.setErrors(res, { emitEvent: emitEvent }); } });
	            }
	        };
	        AbstractControl.prototype._cancelExistingSubscription = function () {
	            if (isPresent(this._asyncValidationSubscription)) {
	                this._asyncValidationSubscription.unsubscribe();
	            }
	        };
	        /**
	         * Sets errors on a form control.
	         *
	         * This is used when validations are run manually by the user, rather than automatically.
	         *
	         * Calling `setErrors` will also update the validity of the parent control.
	         *
	         * ### Example
	         *
	         * ```
	         * const login = new FormControl("someLogin");
	         * login.setErrors({
	         *   "notUnique": true
	         * });
	         *
	         * expect(login.valid).toEqual(false);
	         * expect(login.errors).toEqual({"notUnique": true});
	         *
	         * login.setValue("someOtherLogin");
	         *
	         * expect(login.valid).toEqual(true);
	         * ```
	         */
	        AbstractControl.prototype.setErrors = function (errors, _a) {
	            var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
	            emitEvent = isPresent(emitEvent) ? emitEvent : true;
	            this._errors = errors;
	            this._updateControlsErrors(emitEvent);
	        };
	        /**
	         * Retrieves a child control given the control's name or path.
	         *
	         * Paths can be passed in as an array or a string delimited by a dot.
	         *
	         * To get a control nested within a `person` sub-group:
	         *
	         * * `this.form.get('person.name');`
	         *
	         * -OR-
	         *
	         * * `this.form.get(['person', 'name']);`
	         */
	        AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
	        /**
	         * Returns true if the control with the given path has the error specified. Otherwise
	         * returns null or undefined.
	         *
	         * If no path is given, it checks for the error on the present control.
	         */
	        AbstractControl.prototype.getError = function (errorCode, path) {
	            if (path === void 0) { path = null; }
	            var control = isPresent(path) && !ListWrapper.isEmpty(path) ? this.get(path) : this;
	            if (isPresent(control) && isPresent(control._errors)) {
	                return StringMapWrapper.get(control._errors, errorCode);
	            }
	            else {
	                return null;
	            }
	        };
	        /**
	         * Returns true if the control with the given path has the error specified. Otherwise
	         * returns false.
	         *
	         * If no path is given, it checks for the error on the present control.
	         */
	        AbstractControl.prototype.hasError = function (errorCode, path) {
	            if (path === void 0) { path = null; }
	            return isPresent(this.getError(errorCode, path));
	        };
	        Object.defineProperty(AbstractControl.prototype, "root", {
	            /**
	             * Retrieves the top-level ancestor of this control.
	             */
	            get: function () {
	                var x = this;
	                while (isPresent(x._parent)) {
	                    x = x._parent;
	                }
	                return x;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /** @internal */
	        AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
	            this._status = this._calculateStatus();
	            if (emitEvent) {
	                this._statusChanges.emit(this._status);
	            }
	            if (isPresent(this._parent)) {
	                this._parent._updateControlsErrors(emitEvent);
	            }
	        };
	        /** @internal */
	        AbstractControl.prototype._initObservables = function () {
	            this._valueChanges = new EventEmitter();
	            this._statusChanges = new EventEmitter();
	        };
	        AbstractControl.prototype._calculateStatus = function () {
	            if (this._allControlsDisabled())
	                return DISABLED;
	            if (isPresent(this._errors))
	                return INVALID;
	            if (this._anyControlsHaveStatus(PENDING))
	                return PENDING;
	            if (this._anyControlsHaveStatus(INVALID))
	                return INVALID;
	            return VALID;
	        };
	        /** @internal */
	        AbstractControl.prototype._anyControlsHaveStatus = function (status) {
	            return this._anyControls(function (control) { return control.status == status; });
	        };
	        /** @internal */
	        AbstractControl.prototype._anyControlsDirty = function () {
	            return this._anyControls(function (control) { return control.dirty; });
	        };
	        /** @internal */
	        AbstractControl.prototype._anyControlsTouched = function () {
	            return this._anyControls(function (control) { return control.touched; });
	        };
	        /** @internal */
	        AbstractControl.prototype._updatePristine = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._pristine = !this._anyControlsDirty();
	            if (isPresent(this._parent) && !onlySelf) {
	                this._parent._updatePristine({ onlySelf: onlySelf });
	            }
	        };
	        /** @internal */
	        AbstractControl.prototype._updateTouched = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._touched = this._anyControlsTouched();
	            if (isPresent(this._parent) && !onlySelf) {
	                this._parent._updateTouched({ onlySelf: onlySelf });
	            }
	        };
	        /** @internal */
	        AbstractControl.prototype._onDisabledChange = function (isDisabled) { };
	        /** @internal */
	        AbstractControl.prototype._isBoxedValue = function (formState) {
	            return isStringMap(formState) && Object.keys(formState).length === 2 && 'value' in formState &&
	                'disabled' in formState;
	        };
	        /** @internal */
	        AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
	        return AbstractControl;
	    }());
	    /**
	     * @whatItDoes Tracks the value and validation status of an individual form control.
	     *
	     * It is one of the three fundamental building blocks of Angular forms, along with
	     * {@link FormGroup} and {@link FormArray}.
	     *
	     * @howToUse
	     *
	     * When instantiating a {@link FormControl}, you can pass in an initial value as the
	     * first argument. Example:
	     *
	     * ```ts
	     * const ctrl = new FormControl('some value');
	     * console.log(ctrl.value);     // 'some value'
	     *```
	     *
	     * You can also initialize the control with a form state object on instantiation,
	     * which includes both the value and whether or not the control is disabled.
	     *
	     * ```ts
	     * const ctrl = new FormControl({value: 'n/a', disabled: true});
	     * console.log(ctrl.value);     // 'n/a'
	     * console.log(ctrl.status);   // 'DISABLED'
	     * ```
	     *
	     * To include a sync validator (or an array of sync validators) with the control,
	     * pass it in as the second argument. Async validators are also supported, but
	     * have to be passed in separately as the third arg.
	     *
	     * ```ts
	     * const ctrl = new FormControl('', Validators.required);
	     * console.log(ctrl.value);     // ''
	     * console.log(ctrl.status);   // 'INVALID'
	     * ```
	     *
	     * See its superclass, {@link AbstractControl}, for more properties and methods.
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * @stable
	     */
	    var FormControl = (function (_super) {
	        __extends$6(FormControl, _super);
	        function FormControl(formState, validator, asyncValidator) {
	            if (formState === void 0) { formState = null; }
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator));
	            /** @internal */
	            this._onChange = [];
	            this._applyFormState(formState);
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	            this._initObservables();
	        }
	        /**
	         * Set the value of the form control to `value`.
	         *
	         * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
	         * and not its parent component. This defaults to false.
	         *
	         * If `emitEvent` is `true`, this
	         * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
	         * to true (as it falls through to `updateValueAndValidity`).
	         *
	         * If `emitModelToViewChange` is `true`, the view will be notified about the new value
	         * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
	         * specified.
	         *
	         * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
	         * model.  This is the default behavior if `emitViewToModelChange` is not specified.
	         */
	        FormControl.prototype.setValue = function (value, _a) {
	            var _this = this;
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent, emitModelToViewChange = _b.emitModelToViewChange, emitViewToModelChange = _b.emitViewToModelChange;
	            emitModelToViewChange = isPresent(emitModelToViewChange) ? emitModelToViewChange : true;
	            emitViewToModelChange = isPresent(emitViewToModelChange) ? emitViewToModelChange : true;
	            this._value = value;
	            if (this._onChange.length && emitModelToViewChange) {
	                this._onChange.forEach(function (changeFn) { return changeFn(_this._value, emitViewToModelChange); });
	            }
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         * Patches the value of a control.
	         *
	         * This function is functionally the same as {@link FormControl.setValue} at this level.
	         * It exists for symmetry with {@link FormGroup.patchValue} on `FormGroups` and `FormArrays`,
	         * where it does behave differently.
	         */
	        FormControl.prototype.patchValue = function (value, options) {
	            if (options === void 0) { options = {}; }
	            this.setValue(value, options);
	        };
	        /**
	         * Resets the form control. This means by default:
	         *
	         * * it is marked as `pristine`
	         * * it is marked as `untouched`
	         * * value is set to null
	         *
	         * You can also reset to a specific form state by passing through a standalone
	         * value or a form state object that contains both a value and a disabled state
	         * (these are the only two properties that cannot be calculated).
	         *
	         * Ex:
	         *
	         * ```ts
	         * this.control.reset('Nancy');
	         *
	         * console.log(this.control.value);  // 'Nancy'
	         * ```
	         *
	         * OR
	         *
	         * ```
	         * this.control.reset({value: 'Nancy', disabled: true});
	         *
	         * console.log(this.control.value);  // 'Nancy'
	         * console.log(this.control.status);  // 'DISABLED'
	         * ```
	         */
	        FormControl.prototype.reset = function (formState, _a) {
	            if (formState === void 0) { formState = null; }
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._applyFormState(formState);
	            this.markAsPristine({ onlySelf: onlySelf });
	            this.markAsUntouched({ onlySelf: onlySelf });
	            this.setValue(this._value, { onlySelf: onlySelf });
	        };
	        /**
	         * @internal
	         */
	        FormControl.prototype._updateValue = function () { };
	        /**
	         * @internal
	         */
	        FormControl.prototype._anyControls = function (condition) { return false; };
	        /**
	         * @internal
	         */
	        FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
	        /**
	         * Register a listener for change events.
	         */
	        FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
	        /**
	         * @internal
	         */
	        FormControl.prototype._clearChangeFns = function () {
	            this._onChange = [];
	            this._onDisabledChange = null;
	            this._onCollectionChange = function () { };
	        };
	        /**
	         * Register a listener for disabled events.
	         */
	        FormControl.prototype.registerOnDisabledChange = function (fn) { this._onDisabledChange = fn; };
	        /**
	         * @internal
	         */
	        FormControl.prototype._forEachChild = function (cb) { };
	        FormControl.prototype._applyFormState = function (formState) {
	            if (this._isBoxedValue(formState)) {
	                this._value = formState.value;
	                formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
	                    this.enable({ onlySelf: true, emitEvent: false });
	            }
	            else {
	                this._value = formState;
	            }
	        };
	        return FormControl;
	    }(AbstractControl));
	    /**
	     * @whatItDoes Tracks the value and validity state of a group of {@link FormControl}
	     * instances.
	     *
	     * A `FormGroup` aggregates the values of each child {@link FormControl} into one object,
	     * with each control name as the key.  It calculates its status by reducing the statuses
	     * of its children. For example, if one of the controls in a group is invalid, the entire
	     * group becomes invalid.
	     *
	     * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
	     * along with {@link FormControl} and {@link FormArray}.
	     *
	     * @howToUse
	     *
	     * When instantiating a {@link FormGroup}, pass in a collection of child controls as the first
	     * argument. The key for each child will be the name under which it is registered.
	     *
	     * ### Example
	     *
	     * ```
	     * const form = new FormGroup({
	     *   first: new FormControl('Nancy', Validators.minLength(2)),
	     *   last: new FormControl('Drew'),
	     * });
	     *
	     * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
	     * console.log(form.status);  // 'VALID'
	     * ```
	     *
	     * You can also include group-level validators as the second arg, or group-level async
	     * validators as the third arg. These come in handy when you want to perform validation
	     * that considers the value of more than one child control.
	     *
	     * ### Example
	     *
	     * ```
	     * const form = new FormGroup({
	     *   password: new FormControl('', Validators.minLength(2)),
	     *   passwordConfirm: new FormControl('', Validators.minLength(2)),
	     * }, passwordMatchValidator);
	     *
	     *
	     * function passwordMatchValidator(g: FormGroup) {
	     *    return g.get('password').value === g.get('passwordConfirm').value
	     *       ? null : {'mismatch': true};
	     * }
	     * ```
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * @stable
	     */
	    var FormGroup = (function (_super) {
	        __extends$6(FormGroup, _super);
	        function FormGroup(controls, validator, asyncValidator) {
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            _super.call(this, validator, asyncValidator);
	            this.controls = controls;
	            this._initObservables();
	            this._setUpControls();
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        }
	        /**
	         * Registers a control with the group's list of controls.
	         *
	         * This method does not update value or validity of the control, so for
	         * most cases you'll want to use {@link FormGroup.addControl} instead.
	         */
	        FormGroup.prototype.registerControl = function (name, control) {
	            if (this.controls[name])
	                return this.controls[name];
	            this.controls[name] = control;
	            control.setParent(this);
	            control._registerOnCollectionChange(this._onCollectionChange);
	            return control;
	        };
	        /**
	         * Add a control to this group.
	         */
	        FormGroup.prototype.addControl = function (name, control) {
	            this.registerControl(name, control);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         * Remove a control from this group.
	         */
	        FormGroup.prototype.removeControl = function (name) {
	            if (this.controls[name])
	                this.controls[name]._registerOnCollectionChange(function () { });
	            StringMapWrapper.delete(this.controls, name);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         * Replace an existing control.
	         */
	        FormGroup.prototype.setControl = function (name, control) {
	            if (this.controls[name])
	                this.controls[name]._registerOnCollectionChange(function () { });
	            StringMapWrapper.delete(this.controls, name);
	            if (control)
	                this.registerControl(name, control);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         * Check whether there is an enabled control with the given name in the group.
	         *
	         * It will return false for disabled controls. If you'd like to check for
	         * existence in the group only, use {@link AbstractControl.get} instead.
	         */
	        FormGroup.prototype.contains = function (controlName) {
	            return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
	        };
	        /**
	         *  Sets the value of the {@link FormGroup}. It accepts an object that matches
	         *  the structure of the group, with control names as keys.
	         *
	         * This method performs strict checks, so it will throw an error if you try
	         * to set the value of a control that doesn't exist or if you exclude the
	         * value of a control.
	         *
	         *  ### Example
	         *
	         *  ```
	         *  const form = new FormGroup({
	         *     first: new FormControl(),
	         *     last: new FormControl()
	         *  });
	         *  console.log(form.value);   // {first: null, last: null}
	         *
	         *  form.setValue({first: 'Nancy', last: 'Drew'});
	         *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
	         *
	         *  ```
	         */
	        FormGroup.prototype.setValue = function (value, _a) {
	            var _this = this;
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._checkAllValuesPresent(value);
	            StringMapWrapper.forEach(value, function (newValue, name) {
	                _this._throwIfControlMissing(name);
	                _this.controls[name].setValue(newValue, { onlySelf: true });
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf });
	        };
	        /**
	         *  Patches the value of the {@link FormGroup}. It accepts an object with control
	         *  names as keys, and will do its best to match the values to the correct controls
	         *  in the group.
	         *
	         *  It accepts both super-sets and sub-sets of the group without throwing an error.
	         *
	         *  ### Example
	         *
	         *  ```
	         *  const form = new FormGroup({
	         *     first: new FormControl(),
	         *     last: new FormControl()
	         *  });
	         *  console.log(form.value);   // {first: null, last: null}
	         *
	         *  form.patchValue({first: 'Nancy'});
	         *  console.log(form.value);   // {first: 'Nancy', last: null}
	         *
	         *  ```
	         */
	        FormGroup.prototype.patchValue = function (value, _a) {
	            var _this = this;
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            StringMapWrapper.forEach(value, function (newValue, name) {
	                if (_this.controls[name]) {
	                    _this.controls[name].patchValue(newValue, { onlySelf: true });
	                }
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf });
	        };
	        /**
	         * Resets the {@link FormGroup}. This means by default:
	         *
	         * * The group and all descendants are marked `pristine`
	         * * The group and all descendants are marked `untouched`
	         * * The value of all descendants will be null or null maps
	         *
	         * You can also reset to a specific form state by passing in a map of states
	         * that matches the structure of your form, with control names as keys. The state
	         * can be a standalone value or a form state object with both a value and a disabled
	         * status.
	         *
	         * ### Example
	         *
	         * ```ts
	         * this.form.reset({first: 'name', last; 'last name'});
	         *
	         * console.log(this.form.value);  // {first: 'name', last: 'last name'}
	         * ```
	         *
	         * - OR -
	         *
	         * ```
	         * this.form.reset({
	         *   first: {value: 'name', disabled: true},
	         *   last: 'last'
	         * });
	         *
	         * console.log(this.form.value);  // {first: 'name', last: 'last name'}
	         * console.log(this.form.get('first').status);  // 'DISABLED'
	         * ```
	         */
	        FormGroup.prototype.reset = function (value, _a) {
	            if (value === void 0) { value = {}; }
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._forEachChild(function (control, name) {
	                control.reset(value[name], { onlySelf: true });
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf });
	            this._updatePristine({ onlySelf: onlySelf });
	            this._updateTouched({ onlySelf: onlySelf });
	        };
	        /**
	         * The aggregate value of the {@link FormGroup}, including any disabled controls.
	         *
	         * If you'd like to include all values regardless of disabled status, use this method.
	         * Otherwise, the `value` property is the best way to get the value of the group.
	         */
	        FormGroup.prototype.getRawValue = function () {
	            return this._reduceChildren({}, function (acc, control, name) {
	                acc[name] = control.value;
	                return acc;
	            });
	        };
	        /** @internal */
	        FormGroup.prototype._throwIfControlMissing = function (name) {
	            if (!Object.keys(this.controls).length) {
	                throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
	            }
	            if (!this.controls[name]) {
	                throw new Error("Cannot find form control with name: " + name + ".");
	            }
	        };
	        /** @internal */
	        FormGroup.prototype._forEachChild = function (cb) {
	            StringMapWrapper.forEach(this.controls, cb);
	        };
	        /** @internal */
	        FormGroup.prototype._setUpControls = function () {
	            var _this = this;
	            this._forEachChild(function (control) {
	                control.setParent(_this);
	                control._registerOnCollectionChange(_this._onCollectionChange);
	            });
	        };
	        /** @internal */
	        FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
	        /** @internal */
	        FormGroup.prototype._anyControls = function (condition) {
	            var _this = this;
	            var res = false;
	            this._forEachChild(function (control, name) {
	                res = res || (_this.contains(name) && condition(control));
	            });
	            return res;
	        };
	        /** @internal */
	        FormGroup.prototype._reduceValue = function () {
	            var _this = this;
	            return this._reduceChildren({}, function (acc, control, name) {
	                if (control.enabled || _this.disabled) {
	                    acc[name] = control.value;
	                }
	                return acc;
	            });
	        };
	        /** @internal */
	        FormGroup.prototype._reduceChildren = function (initValue, fn) {
	            var res = initValue;
	            this._forEachChild(function (control, name) { res = fn(res, control, name); });
	            return res;
	        };
	        /** @internal */
	        FormGroup.prototype._allControlsDisabled = function () {
	            for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
	                var controlName = _a[_i];
	                if (this.controls[controlName].enabled) {
	                    return false;
	                }
	            }
	            return Object.keys(this.controls).length > 0 || this.disabled;
	        };
	        /** @internal */
	        FormGroup.prototype._checkAllValuesPresent = function (value) {
	            this._forEachChild(function (control, name) {
	                if (value[name] === undefined) {
	                    throw new Error("Must supply a value for form control with name: '" + name + "'.");
	                }
	            });
	        };
	        return FormGroup;
	    }(AbstractControl));
	    /**
	     * @whatItDoes Tracks the value and validity state of an array of {@link FormControl}
	     * instances.
	     *
	     * A `FormArray` aggregates the values of each child {@link FormControl} into an array.
	     * It calculates its status by reducing the statuses of its children. For example, if one of
	     * the controls in a `FormArray` is invalid, the entire array becomes invalid.
	     *
	     * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
	     * along with {@link FormControl} and {@link FormGroup}.
	     *
	     * @howToUse
	     *
	     * When instantiating a {@link FormArray}, pass in an array of child controls as the first
	     * argument.
	     *
	     * ### Example
	     *
	     * ```
	     * const arr = new FormArray([
	     *   new FormControl('Nancy', Validators.minLength(2)),
	     *   new FormControl('Drew'),
	     * ]);
	     *
	     * console.log(arr.value);   // ['Nancy', 'Drew']
	     * console.log(arr.status);  // 'VALID'
	     * ```
	     *
	     * You can also include array-level validators as the second arg, or array-level async
	     * validators as the third arg. These come in handy when you want to perform validation
	     * that considers the value of more than one child control.
	     *
	     * ### Adding or removing controls
	     *
	     * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
	     * in `FormArray` itself. These methods ensure the controls are properly tracked in the
	     * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
	     * the `FormArray` directly, as that will result in strange and unexpected behavior such
	     * as broken change detection.
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * @stable
	     */
	    var FormArray = (function (_super) {
	        __extends$6(FormArray, _super);
	        function FormArray(controls, validator, asyncValidator) {
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            _super.call(this, validator, asyncValidator);
	            this.controls = controls;
	            this._initObservables();
	            this._setUpControls();
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        }
	        /**
	         * Get the {@link AbstractControl} at the given `index` in the array.
	         */
	        FormArray.prototype.at = function (index) { return this.controls[index]; };
	        /**
	         * Insert a new {@link AbstractControl} at the end of the array.
	         */
	        FormArray.prototype.push = function (control) {
	            this.controls.push(control);
	            this._registerControl(control);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         * Insert a new {@link AbstractControl} at the given `index` in the array.
	         */
	        FormArray.prototype.insert = function (index, control) {
	            ListWrapper.insert(this.controls, index, control);
	            this._registerControl(control);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         * Remove the control at the given `index` in the array.
	         */
	        FormArray.prototype.removeAt = function (index) {
	            if (this.controls[index])
	                this.controls[index]._registerOnCollectionChange(function () { });
	            ListWrapper.removeAt(this.controls, index);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         * Replace an existing control.
	         */
	        FormArray.prototype.setControl = function (index, control) {
	            if (this.controls[index])
	                this.controls[index]._registerOnCollectionChange(function () { });
	            ListWrapper.removeAt(this.controls, index);
	            if (control) {
	                ListWrapper.insert(this.controls, index, control);
	                this._registerControl(control);
	            }
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        Object.defineProperty(FormArray.prototype, "length", {
	            /**
	             * Length of the control array.
	             */
	            get: function () { return this.controls.length; },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         *  Sets the value of the {@link FormArray}. It accepts an array that matches
	         *  the structure of the control.
	         *
	         * This method performs strict checks, so it will throw an error if you try
	         * to set the value of a control that doesn't exist or if you exclude the
	         * value of a control.
	         *
	         *  ### Example
	         *
	         *  ```
	         *  const arr = new FormArray([
	         *     new FormControl(),
	         *     new FormControl()
	         *  ]);
	         *  console.log(arr.value);   // [null, null]
	         *
	         *  arr.setValue(['Nancy', 'Drew']);
	         *  console.log(arr.value);   // ['Nancy', 'Drew']
	         *  ```
	         */
	        FormArray.prototype.setValue = function (value, _a) {
	            var _this = this;
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._checkAllValuesPresent(value);
	            value.forEach(function (newValue, index) {
	                _this._throwIfControlMissing(index);
	                _this.at(index).setValue(newValue, { onlySelf: true });
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf });
	        };
	        /**
	         *  Patches the value of the {@link FormArray}. It accepts an array that matches the
	         *  structure of the control, and will do its best to match the values to the correct
	         *  controls in the group.
	         *
	         *  It accepts both super-sets and sub-sets of the array without throwing an error.
	         *
	         *  ### Example
	         *
	         *  ```
	         *  const arr = new FormArray([
	         *     new FormControl(),
	         *     new FormControl()
	         *  ]);
	         *  console.log(arr.value);   // [null, null]
	         *
	         *  arr.patchValue(['Nancy']);
	         *  console.log(arr.value);   // ['Nancy', null]
	         *  ```
	         */
	        FormArray.prototype.patchValue = function (value, _a) {
	            var _this = this;
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            value.forEach(function (newValue, index) {
	                if (_this.at(index)) {
	                    _this.at(index).patchValue(newValue, { onlySelf: true });
	                }
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf });
	        };
	        /**
	         * Resets the {@link FormArray}. This means by default:
	         *
	         * * The array and all descendants are marked `pristine`
	         * * The array and all descendants are marked `untouched`
	         * * The value of all descendants will be null or null maps
	         *
	         * You can also reset to a specific form state by passing in an array of states
	         * that matches the structure of the control. The state can be a standalone value
	         * or a form state object with both a value and a disabled status.
	         *
	         * ### Example
	         *
	         * ```ts
	         * this.arr.reset(['name', 'last name']);
	         *
	         * console.log(this.arr.value);  // ['name', 'last name']
	         * ```
	         *
	         * - OR -
	         *
	         * ```
	         * this.arr.reset([
	         *   {value: 'name', disabled: true},
	         *   'last'
	         * ]);
	         *
	         * console.log(this.arr.value);  // ['name', 'last name']
	         * console.log(this.arr.get(0).status);  // 'DISABLED'
	         * ```
	         */
	        FormArray.prototype.reset = function (value, _a) {
	            if (value === void 0) { value = []; }
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._forEachChild(function (control, index) {
	                control.reset(value[index], { onlySelf: true });
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf });
	            this._updatePristine({ onlySelf: onlySelf });
	            this._updateTouched({ onlySelf: onlySelf });
	        };
	        /**
	         * The aggregate value of the array, including any disabled controls.
	         *
	         * If you'd like to include all values regardless of disabled status, use this method.
	         * Otherwise, the `value` property is the best way to get the value of the array.
	         */
	        FormArray.prototype.getRawValue = function () { return this.controls.map(function (control) { return control.value; }); };
	        /** @internal */
	        FormArray.prototype._throwIfControlMissing = function (index) {
	            if (!this.controls.length) {
	                throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
	            }
	            if (!this.at(index)) {
	                throw new Error("Cannot find form control at index " + index);
	            }
	        };
	        /** @internal */
	        FormArray.prototype._forEachChild = function (cb) {
	            this.controls.forEach(function (control, index) { cb(control, index); });
	        };
	        /** @internal */
	        FormArray.prototype._updateValue = function () {
	            var _this = this;
	            this._value = this.controls.filter(function (control) { return control.enabled || _this.disabled; })
	                .map(function (control) { return control.value; });
	        };
	        /** @internal */
	        FormArray.prototype._anyControls = function (condition) {
	            return this.controls.some(function (control) { return control.enabled && condition(control); });
	        };
	        /** @internal */
	        FormArray.prototype._setUpControls = function () {
	            var _this = this;
	            this._forEachChild(function (control) { return _this._registerControl(control); });
	        };
	        /** @internal */
	        FormArray.prototype._checkAllValuesPresent = function (value) {
	            this._forEachChild(function (control, i) {
	                if (value[i] === undefined) {
	                    throw new Error("Must supply a value for form control at index: " + i + ".");
	                }
	            });
	        };
	        /** @internal */
	        FormArray.prototype._allControlsDisabled = function () {
	            for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
	                var control = _a[_i];
	                if (control.enabled)
	                    return false;
	            }
	            return this.controls.length > 0 || this.disabled;
	        };
	        FormArray.prototype._registerControl = function (control) {
	            control.setParent(this);
	            control._registerOnCollectionChange(this._onCollectionChange);
	        };
	        return FormArray;
	    }(AbstractControl));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$4 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var formDirectiveProvider = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return NgForm; })
	    };
	    var resolvedPromise = Promise.resolve(null);
	    /**
	     * @whatItDoes Creates a top-level {@link FormGroup} instance and binds it to a form
	     * to track aggregate form value and validation status.
	     *
	     * @howToUse
	     *
	     * As soon as you import the `FormsModule`, this directive becomes active by default on
	     * all `<form>` tags.  You don't need to add a special selector.
	     *
	     * You can export the directive into a local template variable using `ngForm` as the key
	     * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
	     * {@link FormGroup} instance are duplicated on the directive itself, so a reference to it
	     * will give you access to the aggregate value and validity status of the form, as well as
	     * user interaction properties like `dirty` and `touched`.
	     *
	     * To register child controls with the form, you'll want to use {@link NgModel} with a
	     * `name` attribute.  You can also use {@link NgModelGroup} if you'd like to create
	     * sub-groups within the form.
	     *
	     * You can listen to the directive's `ngSubmit` event to be notified when the user has
	     * triggered a form submission.
	     *
	     * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * * **NgModule**: `FormsModule`
	     *
	     *  @stable
	     */
	    var NgForm = (function (_super) {
	        __extends$4(NgForm, _super);
	        function NgForm(validators, asyncValidators) {
	            _super.call(this);
	            this._submitted = false;
	            this.ngSubmit = new EventEmitter();
	            this.form =
	                new FormGroup({}, composeValidators(validators), composeAsyncValidators(asyncValidators));
	        }
	        Object.defineProperty(NgForm.prototype, "submitted", {
	            get: function () { return this._submitted; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgForm.prototype, "formDirective", {
	            get: function () { return this; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgForm.prototype, "control", {
	            get: function () { return this.form; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgForm.prototype, "path", {
	            get: function () { return []; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgForm.prototype, "controls", {
	            get: function () { return this.form.controls; },
	            enumerable: true,
	            configurable: true
	        });
	        NgForm.prototype.addControl = function (dir) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var container = _this._findContainer(dir.path);
	                dir._control = container.registerControl(dir.name, dir.control);
	                setUpControl(dir.control, dir);
	                dir.control.updateValueAndValidity({ emitEvent: false });
	            });
	        };
	        NgForm.prototype.getControl = function (dir) { return this.form.get(dir.path); };
	        NgForm.prototype.removeControl = function (dir) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var container = _this._findContainer(dir.path);
	                if (isPresent(container)) {
	                    container.removeControl(dir.name);
	                }
	            });
	        };
	        NgForm.prototype.addFormGroup = function (dir) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var container = _this._findContainer(dir.path);
	                var group = new FormGroup({});
	                setUpFormContainer(group, dir);
	                container.registerControl(dir.name, group);
	                group.updateValueAndValidity({ emitEvent: false });
	            });
	        };
	        NgForm.prototype.removeFormGroup = function (dir) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var container = _this._findContainer(dir.path);
	                if (isPresent(container)) {
	                    container.removeControl(dir.name);
	                }
	            });
	        };
	        NgForm.prototype.getFormGroup = function (dir) { return this.form.get(dir.path); };
	        NgForm.prototype.updateModel = function (dir, value) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var ctrl = _this.form.get(dir.path);
	                ctrl.setValue(value);
	            });
	        };
	        NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
	        NgForm.prototype.onSubmit = function () {
	            this._submitted = true;
	            this.ngSubmit.emit(null);
	            return false;
	        };
	        NgForm.prototype.onReset = function () { this.resetForm(); };
	        NgForm.prototype.resetForm = function (value) {
	            if (value === void 0) { value = undefined; }
	            this.form.reset(value);
	            this._submitted = false;
	        };
	        /** @internal */
	        NgForm.prototype._findContainer = function (path) {
	            path.pop();
	            return ListWrapper.isEmpty(path) ? this.form : this.form.get(path);
	        };
	        NgForm.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
	                        providers: [formDirectiveProvider],
	                        host: { '(submit)': 'onSubmit()', '(reset)': 'onReset()' },
	                        outputs: ['ngSubmit'],
	                        exportAs: 'ngForm'
	                    },] },
	        ];
	        /** @nocollapse */
	        NgForm.ctorParameters = [
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ];
	        return NgForm;
	    }(ControlContainer));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var Examples = {
	        formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
	        formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
	        formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; let i=index\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
	        ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
	        ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
	    };
	
	    var TemplateDrivenErrors = (function () {
	        function TemplateDrivenErrors() {
	        }
	        TemplateDrivenErrors.modelParentException = function () {
	            throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + Examples.formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + Examples.ngModelWithFormGroup);
	        };
	        TemplateDrivenErrors.formGroupNameException = function () {
	            throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + Examples.formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + Examples.ngModelGroup);
	        };
	        TemplateDrivenErrors.missingNameException = function () {
	            throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
	        };
	        TemplateDrivenErrors.modelGroupParentException = function () {
	            throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + Examples.formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + Examples.ngModelGroup);
	        };
	        return TemplateDrivenErrors;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$8 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var modelGroupProvider = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return NgModelGroup; })
	    };
	    /**
	     * @whatItDoes Creates and binds a {@link FormGroup} instance to a DOM element.
	     *
	     * @howToUse
	     *
	     * This directive can only be used as a child of {@link NgForm} (or in other words,
	     * within `<form>` tags).
	     *
	     * Use this directive if you'd like to create a sub-group within a form. This can
	     * come in handy if you want to validate a sub-group of your form separately from
	     * the rest of your form, or if some values in your domain model make more sense to
	     * consume together in a nested object.
	     *
	     * Pass in the name you'd like this sub-group to have and it will become the key
	     * for the sub-group in the form's full value. You can also export the directive into
	     * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
	     *
	     * {@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * * **NgModule**: `FormsModule`
	     *
	     * @stable
	     */
	    var NgModelGroup = (function (_super) {
	        __extends$8(NgModelGroup, _super);
	        function NgModelGroup(parent, validators, asyncValidators) {
	            _super.call(this);
	            this._parent = parent;
	            this._validators = validators;
	            this._asyncValidators = asyncValidators;
	        }
	        /** @internal */
	        NgModelGroup.prototype._checkParentType = function () {
	            if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
	                TemplateDrivenErrors.modelGroupParentException();
	            }
	        };
	        NgModelGroup.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
	        ];
	        /** @nocollapse */
	        NgModelGroup.ctorParameters = [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ];
	        NgModelGroup.propDecorators = {
	            'name': [{ type: _angular_core.Input, args: ['ngModelGroup',] },],
	        };
	        return NgModelGroup;
	    }(AbstractFormGroupDirective));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$7 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var formControlBinding = {
	        provide: NgControl,
	        useExisting: _angular_core.forwardRef(function () { return NgModel; })
	    };
	    var resolvedPromise$1 = Promise.resolve(null);
	    /**
	     * @whatItDoes Creates a {@link FormControl} instance from a domain model and binds it
	     * to a form control element.
	     *
	     * The {@link FormControl} instance will track the value, user interaction, and
	     * validation status of the control and keep the view synced with the model. If used
	     * within a parent form, the directive will also register itself with the form as a child
	     * control.
	     *
	     * @howToUse
	     *
	     * This directive can be used by itself or as part of a larger form. All you need is the
	     * `ngModel` selector to activate it.
	     *
	     * It accepts a domain model as an optional {@link @Input}. If you have a one-way binding
	     * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
	     * class will set the value in the view. If you have a two-way binding with `[()]` syntax
	     * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
	     * the domain model in your class as well.
	     *
	     * If you wish to inspect the properties of the associated {@link FormControl} (like
	     * validity state), you can also export the directive into a local template variable using
	     * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
	     * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
	     * will fall through to the control anyway, so you can access them directly. You can see a
	     * full list of properties directly available in {@link AbstractControlDirective}.
	     *
	     * The following is an example of a simple standalone control using `ngModel`:
	     *
	     * {@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
	     *
	     * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
	     * so that the control can be registered with the parent form under that name.
	     *
	     * It's worth noting that in the context of a parent form, you often can skip one-way or
	     * two-way binding because the parent form will sync the value for you. You can access
	     * its properties by exporting it into a local template variable using `ngForm` (ex:
	     * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
	     *
	     * If you do need to populate initial values into your form, using a one-way binding for
	     * `ngModel` tends to be sufficient as long as you use the exported form's value rather
	     * than the domain model's value on submit.
	     *
	     * Take a look at an example of using `ngModel` within a form:
	     *
	     * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
	     *
	     * **npm package**: `@angular/forms`
	     *
	     * **NgModule**: `FormsModule`
	     *
	     *  @stable
	     */
	    var NgModel = (function (_super) {
	        __extends$7(NgModel, _super);
	        function NgModel(parent, validators, asyncValidators, valueAccessors) {
	            _super.call(this);
	            /** @internal */
	            this._control = new FormControl();
	            /** @internal */
	            this._registered = false;
	            this.update = new EventEmitter();
	            this._parent = parent;
	            this._rawValidators = validators || [];
	            this._rawAsyncValidators = asyncValidators || [];
	            this.valueAccessor = selectValueAccessor(this, valueAccessors);
	        }
	        NgModel.prototype.ngOnChanges = function (changes) {
	            this._checkForErrors();
	            if (!this._registered)
	                this._setUpControl();
	            if ('isDisabled' in changes) {
	                this._updateDisabled(changes);
	            }
	            if (isPropertyUpdated(changes, this.viewModel)) {
	                this._updateValue(this.model);
	                this.viewModel = this.model;
	            }
	        };
	        NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
	        Object.defineProperty(NgModel.prototype, "control", {
	            get: function () { return this._control; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgModel.prototype, "path", {
	            get: function () {
	                return this._parent ? controlPath(this.name, this._parent) : [this.name];
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgModel.prototype, "formDirective", {
	            get: function () { return this._parent ? this._parent.formDirective : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgModel.prototype, "validator", {
	            get: function () { return composeValidators(this._rawValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgModel.prototype, "asyncValidator", {
	            get: function () {
	                return composeAsyncValidators(this._rawAsyncValidators);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        NgModel.prototype.viewToModelUpdate = function (newValue) {
	            this.viewModel = newValue;
	            this.update.emit(newValue);
	        };
	        NgModel.prototype._setUpControl = function () {
	            this._isStandalone() ? this._setUpStandalone() :
	                this.formDirective.addControl(this);
	            this._registered = true;
	        };
	        NgModel.prototype._isStandalone = function () {
	            return !this._parent || (this.options && this.options.standalone);
	        };
	        NgModel.prototype._setUpStandalone = function () {
	            setUpControl(this._control, this);
	            this._control.updateValueAndValidity({ emitEvent: false });
	        };
	        NgModel.prototype._checkForErrors = function () {
	            if (!this._isStandalone()) {
	                this._checkParentType();
	            }
	            this._checkName();
	        };
	        NgModel.prototype._checkParentType = function () {
	            if (!(this._parent instanceof NgModelGroup) &&
	                this._parent instanceof AbstractFormGroupDirective) {
	                TemplateDrivenErrors.formGroupNameException();
	            }
	            else if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
	                TemplateDrivenErrors.modelParentException();
	            }
	        };
	        NgModel.prototype._checkName = function () {
	            if (this.options && this.options.name)
	                this.name = this.options.name;
	            if (!this._isStandalone() && !this.name) {
	                TemplateDrivenErrors.missingNameException();
	            }
	        };
	        NgModel.prototype._updateValue = function (value) {
	            var _this = this;
	            resolvedPromise$1.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
	        };
	        NgModel.prototype._updateDisabled = function (changes) {
	            var _this = this;
	            var disabledValue = changes['isDisabled'].currentValue;
	            var isDisabled = disabledValue != null && disabledValue != false;
	            resolvedPromise$1.then(function () {
	                if (isDisabled && !_this.control.disabled) {
	                    _this.control.disable();
	                }
	                else if (!isDisabled && _this.control.disabled) {
	                    _this.control.enable();
	                }
	            });
	        };
	        NgModel.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[ngModel]:not([formControlName]):not([formControl])',
	                        providers: [formControlBinding],
	                        exportAs: 'ngModel'
	                    },] },
	        ];
	        /** @nocollapse */
	        NgModel.ctorParameters = [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALUE_ACCESSOR,] },] },
	        ];
	        NgModel.propDecorators = {
	            'name': [{ type: _angular_core.Input },],
	            'isDisabled': [{ type: _angular_core.Input, args: ['disabled',] },],
	            'model': [{ type: _angular_core.Input, args: ['ngModel',] },],
	            'options': [{ type: _angular_core.Input, args: ['ngModelOptions',] },],
	            'update': [{ type: _angular_core.Output, args: ['ngModelChange',] },],
	        };
	        return NgModel;
	    }(NgControl));
	
	    var ReactiveErrors = (function () {
	        function ReactiveErrors() {
	        }
	        ReactiveErrors.controlParentException = function () {
	            throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + Examples.formControlName);
	        };
	        ReactiveErrors.ngModelGroupException = function () {
	            throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + Examples.formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + Examples.ngModelGroup);
	        };
	        ReactiveErrors.missingFormException = function () {
	            throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + Examples.formControlName);
	        };
	        ReactiveErrors.groupParentException = function () {
	            throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + Examples.formGroupName);
	        };
	        ReactiveErrors.arrayParentException = function () {
	            throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + Examples.formArrayName);
	        };
	        ReactiveErrors.disabledAttrWarning = function () {
	            console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
	        };
	        return ReactiveErrors;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$9 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var formControlBinding$1 = {
	        provide: NgControl,
	        useExisting: _angular_core.forwardRef(function () { return FormControlDirective; })
	    };
	    /**
	     * @whatItDoes Syncs a standalone {@link FormControl} instance to a form control element.
	     *
	     * In other words, this directive ensures that any values written to the {@link FormControl}
	     * instance programmatically will be written to the DOM element (model -> view). Conversely,
	     * any values written to the DOM element through user input will be reflected in the
	     * {@link FormControl} instance (view -> model).
	     *
	     * @howToUse
	     *
	     * Use this directive if you'd like to create and manage a {@link FormControl} instance directly.
	     * Simply create a {@link FormControl}, save it to your component class, and pass it into the
	     * {@link FormControlDirective}.
	     *
	     * This directive is designed to be used as a standalone control.  Unlike {@link FormControlName},
	     * it does not require that your {@link FormControl} instance be part of any parent
	     * {@link FormGroup}, and it won't be registered to any {@link FormGroupDirective} that
	     * exists above it.
	     *
	     * **Get the value**: the `value` property is always synced and available on the
	     * {@link FormControl} instance. See a full list of available properties in
	     * {@link AbstractControl}.
	     *
	     * **Set the value**: You can pass in an initial value when instantiating the {@link FormControl},
	     * or you can set it programmatically later using {@link AbstractControl.setValue} or
	     * {@link AbstractControl.patchValue}.
	     *
	     * **Listen to value**: If you want to listen to changes in the value of the control, you can
	     * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
	     * {@link AbstractControl.statusChanges} to be notified when the validation status is
	     * re-calculated.
	     *
	     * ### Example
	     *
	     * {@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * * **NgModule**: `ReactiveFormsModule`
	     *
	     *  @stable
	     */
	    var FormControlDirective = (function (_super) {
	        __extends$9(FormControlDirective, _super);
	        function FormControlDirective(validators, asyncValidators, valueAccessors) {
	            _super.call(this);
	            this.update = new EventEmitter();
	            this._rawValidators = validators || [];
	            this._rawAsyncValidators = asyncValidators || [];
	            this.valueAccessor = selectValueAccessor(this, valueAccessors);
	        }
	        Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
	            set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
	            enumerable: true,
	            configurable: true
	        });
	        FormControlDirective.prototype.ngOnChanges = function (changes) {
	            if (this._isControlChanged(changes)) {
	                setUpControl(this.form, this);
	                if (this.control.disabled)
	                    this.valueAccessor.setDisabledState(true);
	                this.form.updateValueAndValidity({ emitEvent: false });
	            }
	            if (isPropertyUpdated(changes, this.viewModel)) {
	                this.form.setValue(this.model);
	                this.viewModel = this.model;
	            }
	        };
	        Object.defineProperty(FormControlDirective.prototype, "path", {
	            get: function () { return []; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlDirective.prototype, "validator", {
	            get: function () { return composeValidators(this._rawValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
	            get: function () {
	                return composeAsyncValidators(this._rawAsyncValidators);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlDirective.prototype, "control", {
	            get: function () { return this.form; },
	            enumerable: true,
	            configurable: true
	        });
	        FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
	            this.viewModel = newValue;
	            this.update.emit(newValue);
	        };
	        FormControlDirective.prototype._isControlChanged = function (changes) {
	            return StringMapWrapper.contains(changes, 'form');
	        };
	        FormControlDirective.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formControl]', providers: [formControlBinding$1], exportAs: 'ngForm' },] },
	        ];
	        /** @nocollapse */
	        FormControlDirective.ctorParameters = [
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALUE_ACCESSOR,] },] },
	        ];
	        FormControlDirective.propDecorators = {
	            'form': [{ type: _angular_core.Input, args: ['formControl',] },],
	            'model': [{ type: _angular_core.Input, args: ['ngModel',] },],
	            'update': [{ type: _angular_core.Output, args: ['ngModelChange',] },],
	            'isDisabled': [{ type: _angular_core.Input, args: ['disabled',] },],
	        };
	        return FormControlDirective;
	    }(NgControl));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$11 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var formDirectiveProvider$1 = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return FormGroupDirective; })
	    };
	    /**
	     * @whatItDoes Binds an existing {@link FormGroup} to a DOM element.
	     *
	     * @howToUse
	     *
	     * This directive accepts an existing {@link FormGroup} instance. It will then use this
	     * {@link FormGroup} instance to match any child {@link FormControl}, {@link FormGroup},
	     * and {@link FormArray} instances to child {@link FormControlName}, {@link FormGroupName},
	     * and {@link FormArrayName} directives.
	     *
	     * **Set value**: You can set the form's initial value when instantiating the
	     * {@link FormGroup}, or you can set it programmatically later using the {@link FormGroup}'s
	     * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue} methods.
	     *
	     * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
	     * to the {@link FormGroup}'s {@link AbstractControl.valueChanges} event.  You can also listen to
	     * its {@link AbstractControl.statusChanges} event to be notified when the validation status is
	     * re-calculated.
	     *
	     * ### Example
	     *
	     * In this example, we create form controls for first name and last name.
	     *
	     * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
	     *
	     * **npm package**: `@angular/forms`
	     *
	     * **NgModule**: {@link ReactiveFormsModule}
	     *
	     *  @stable
	     */
	    var FormGroupDirective = (function (_super) {
	        __extends$11(FormGroupDirective, _super);
	        function FormGroupDirective(_validators, _asyncValidators) {
	            _super.call(this);
	            this._validators = _validators;
	            this._asyncValidators = _asyncValidators;
	            this._submitted = false;
	            this.directives = [];
	            this.form = null;
	            this.ngSubmit = new EventEmitter();
	        }
	        FormGroupDirective.prototype.ngOnChanges = function (changes) {
	            this._checkFormPresent();
	            if (StringMapWrapper.contains(changes, 'form')) {
	                this._updateValidators();
	                this._updateDomValue();
	                this._updateRegistrations();
	            }
	        };
	        Object.defineProperty(FormGroupDirective.prototype, "submitted", {
	            get: function () { return this._submitted; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
	            get: function () { return this; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormGroupDirective.prototype, "control", {
	            get: function () { return this.form; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormGroupDirective.prototype, "path", {
	            get: function () { return []; },
	            enumerable: true,
	            configurable: true
	        });
	        FormGroupDirective.prototype.addControl = function (dir) {
	            var ctrl = this.form.get(dir.path);
	            setUpControl(ctrl, dir);
	            ctrl.updateValueAndValidity({ emitEvent: false });
	            this.directives.push(dir);
	            return ctrl;
	        };
	        FormGroupDirective.prototype.getControl = function (dir) { return this.form.get(dir.path); };
	        FormGroupDirective.prototype.removeControl = function (dir) { ListWrapper.remove(this.directives, dir); };
	        FormGroupDirective.prototype.addFormGroup = function (dir) {
	            var ctrl = this.form.get(dir.path);
	            setUpFormContainer(ctrl, dir);
	            ctrl.updateValueAndValidity({ emitEvent: false });
	        };
	        FormGroupDirective.prototype.removeFormGroup = function (dir) { };
	        FormGroupDirective.prototype.getFormGroup = function (dir) { return this.form.get(dir.path); };
	        FormGroupDirective.prototype.addFormArray = function (dir) {
	            var ctrl = this.form.get(dir.path);
	            setUpFormContainer(ctrl, dir);
	            ctrl.updateValueAndValidity({ emitEvent: false });
	        };
	        FormGroupDirective.prototype.removeFormArray = function (dir) { };
	        FormGroupDirective.prototype.getFormArray = function (dir) { return this.form.get(dir.path); };
	        FormGroupDirective.prototype.updateModel = function (dir, value) {
	            var ctrl = this.form.get(dir.path);
	            ctrl.setValue(value);
	        };
	        FormGroupDirective.prototype.onSubmit = function () {
	            this._submitted = true;
	            this.ngSubmit.emit(null);
	            return false;
	        };
	        FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
	        FormGroupDirective.prototype.resetForm = function (value) {
	            if (value === void 0) { value = undefined; }
	            this.form.reset(value);
	            this._submitted = false;
	        };
	        /** @internal */
	        FormGroupDirective.prototype._updateDomValue = function () {
	            var _this = this;
	            this.directives.forEach(function (dir) {
	                var newCtrl = _this.form.get(dir.path);
	                if (dir._control !== newCtrl) {
	                    cleanUpControl(dir._control, dir);
	                    if (newCtrl)
	                        setUpControl(newCtrl, dir);
	                    dir._control = newCtrl;
	                }
	            });
	            this.form._updateTreeValidity({ emitEvent: false });
	        };
	        FormGroupDirective.prototype._updateRegistrations = function () {
	            var _this = this;
	            this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
	            if (this._oldForm)
	                this._oldForm._registerOnCollectionChange(function () { });
	            this._oldForm = this.form;
	        };
	        FormGroupDirective.prototype._updateValidators = function () {
	            var sync = composeValidators(this._validators);
	            this.form.validator = Validators.compose([this.form.validator, sync]);
	            var async = composeAsyncValidators(this._asyncValidators);
	            this.form.asyncValidator = Validators.composeAsync([this.form.asyncValidator, async]);
	        };
	        FormGroupDirective.prototype._checkFormPresent = function () {
	            if (isBlank(this.form)) {
	                ReactiveErrors.missingFormException();
	            }
	        };
	        FormGroupDirective.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[formGroup]',
	                        providers: [formDirectiveProvider$1],
	                        host: { '(submit)': 'onSubmit()', '(reset)': 'onReset()' },
	                        exportAs: 'ngForm'
	                    },] },
	        ];
	        /** @nocollapse */
	        FormGroupDirective.ctorParameters = [
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ];
	        FormGroupDirective.propDecorators = {
	            'form': [{ type: _angular_core.Input, args: ['formGroup',] },],
	            'ngSubmit': [{ type: _angular_core.Output },],
	        };
	        return FormGroupDirective;
	    }(ControlContainer));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$12 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var formGroupNameProvider = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return FormGroupName; })
	    };
	    /**
	     * @whatItDoes Syncs a nested {@link FormGroup} to a DOM element.
	     *
	     * @howToUse
	     *
	     * This directive can only be used with a parent {@link FormGroupDirective} (selector:
	     * `[formGroup]`).
	     *
	     * It accepts the string name of the nested {@link FormGroup} you want to link, and
	     * will look for a {@link FormGroup} registered with that name in the parent
	     * {@link FormGroup} instance you passed into {@link FormGroupDirective}.
	     *
	     * Nested form groups can come in handy when you want to validate a sub-group of a
	     * form separately from the rest or when you'd like to group the values of certain
	     * controls into their own nested object.
	     *
	     * **Access the group**: You can access the associated {@link FormGroup} using the
	     * {@link AbstractControl.get} method. Ex: `this.form.get('name')`.
	     *
	     * You can also access individual controls within the group using dot syntax.
	     * Ex: `this.form.get('name.first')`
	     *
	     * **Get the value**: the `value` property is always synced and available on the
	     * {@link FormGroup}. See a full list of available properties in {@link AbstractControl}.
	     *
	     * **Set the value**: You can set an initial value for each child control when instantiating
	     * the {@link FormGroup}, or you can set it programmatically later using
	     * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}.
	     *
	     * **Listen to value**: If you want to listen to changes in the value of the group, you can
	     * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
	     * {@link AbstractControl.statusChanges} to be notified when the validation status is
	     * re-calculated.
	     *
	     * ### Example
	     *
	     * {@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * * **NgModule**: `ReactiveFormsModule`
	     *
	     * @stable
	     */
	    var FormGroupName = (function (_super) {
	        __extends$12(FormGroupName, _super);
	        function FormGroupName(parent, validators, asyncValidators) {
	            _super.call(this);
	            this._parent = parent;
	            this._validators = validators;
	            this._asyncValidators = asyncValidators;
	        }
	        /** @internal */
	        FormGroupName.prototype._checkParentType = function () {
	            if (_hasInvalidParent(this._parent)) {
	                ReactiveErrors.groupParentException();
	            }
	        };
	        FormGroupName.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
	        ];
	        /** @nocollapse */
	        FormGroupName.ctorParameters = [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ];
	        FormGroupName.propDecorators = {
	            'name': [{ type: _angular_core.Input, args: ['formGroupName',] },],
	        };
	        return FormGroupName;
	    }(AbstractFormGroupDirective));
	    var formArrayNameProvider = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return FormArrayName; })
	    };
	    /**
	     * @whatItDoes Syncs a nested {@link FormArray} to a DOM element.
	     *
	     * @howToUse
	     *
	     * This directive is designed to be used with a parent {@link FormGroupDirective} (selector:
	     * `[formGroup]`).
	     *
	     * It accepts the string name of the nested {@link FormArray} you want to link, and
	     * will look for a {@link FormArray} registered with that name in the parent
	     * {@link FormGroup} instance you passed into {@link FormGroupDirective}.
	     *
	     * Nested form arrays can come in handy when you have a group of form controls but
	     * you're not sure how many there will be. Form arrays allow you to create new
	     * form controls dynamically.
	     *
	     * **Access the array**: You can access the associated {@link FormArray} using the
	     * {@link AbstractControl.get} method on the parent {@link FormGroup}.
	     * Ex: `this.form.get('cities')`.
	     *
	     * **Get the value**: the `value` property is always synced and available on the
	     * {@link FormArray}. See a full list of available properties in {@link AbstractControl}.
	     *
	     * **Set the value**: You can set an initial value for each child control when instantiating
	     * the {@link FormArray}, or you can set the value programmatically later using the
	     * {@link FormArray}'s {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}
	     * methods.
	     *
	     * **Listen to value**: If you want to listen to changes in the value of the array, you can
	     * subscribe to the {@link FormArray}'s {@link AbstractControl.valueChanges} event.  You can also
	     * listen to its {@link AbstractControl.statusChanges} event to be notified when the validation
	     * status is re-calculated.
	     *
	     * **Add new controls**: You can add new controls to the {@link FormArray} dynamically by
	     * calling its {@link FormArray.push} method.
	     *  Ex: `this.form.get('cities').push(new FormControl());`
	     *
	     * ### Example
	     *
	     * {@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * * **NgModule**: `ReactiveFormsModule`
	     *
	     * @stable
	     */
	    var FormArrayName = (function (_super) {
	        __extends$12(FormArrayName, _super);
	        function FormArrayName(parent, validators, asyncValidators) {
	            _super.call(this);
	            this._parent = parent;
	            this._validators = validators;
	            this._asyncValidators = asyncValidators;
	        }
	        FormArrayName.prototype.ngOnInit = function () {
	            this._checkParentType();
	            this.formDirective.addFormArray(this);
	        };
	        FormArrayName.prototype.ngOnDestroy = function () {
	            if (this.formDirective) {
	                this.formDirective.removeFormArray(this);
	            }
	        };
	        Object.defineProperty(FormArrayName.prototype, "control", {
	            get: function () { return this.formDirective.getFormArray(this); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormArrayName.prototype, "formDirective", {
	            get: function () {
	                return this._parent ? this._parent.formDirective : null;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormArrayName.prototype, "path", {
	            get: function () { return controlPath(this.name, this._parent); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormArrayName.prototype, "validator", {
	            get: function () { return composeValidators(this._validators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
	            get: function () { return composeAsyncValidators(this._asyncValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        FormArrayName.prototype._checkParentType = function () {
	            if (_hasInvalidParent(this._parent)) {
	                ReactiveErrors.arrayParentException();
	            }
	        };
	        FormArrayName.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
	        ];
	        /** @nocollapse */
	        FormArrayName.ctorParameters = [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ];
	        FormArrayName.propDecorators = {
	            'name': [{ type: _angular_core.Input, args: ['formArrayName',] },],
	        };
	        return FormArrayName;
	    }(ControlContainer));
	    function _hasInvalidParent(parent) {
	        return !(parent instanceof FormGroupName) && !(parent instanceof FormGroupDirective) &&
	            !(parent instanceof FormArrayName);
	    }
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$10 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var controlNameBinding = {
	        provide: NgControl,
	        useExisting: _angular_core.forwardRef(function () { return FormControlName; })
	    };
	    /**
	     * @whatItDoes  Syncs a {@link FormControl} in an existing {@link FormGroup} to a form control
	     * element by name.
	     *
	     * In other words, this directive ensures that any values written to the {@link FormControl}
	     * instance programmatically will be written to the DOM element (model -> view). Conversely,
	     * any values written to the DOM element through user input will be reflected in the
	     * {@link FormControl} instance (view -> model).
	     *
	     * @howToUse
	     *
	     * This directive is designed to be used with a parent {@link FormGroupDirective} (selector:
	     * `[formGroup]`).
	     *
	     * It accepts the string name of the {@link FormControl} instance you want to
	     * link, and will look for a {@link FormControl} registered with that name in the
	     * closest {@link FormGroup} or {@link FormArray} above it.
	     *
	     * **Access the control**: You can access the {@link FormControl} associated with
	     * this directive by using the {@link AbstractControl.get} method.
	     * Ex: `this.form.get('first');`
	     *
	     * **Get value**: the `value` property is always synced and available on the {@link FormControl}.
	     * See a full list of available properties in {@link AbstractControl}.
	     *
	     *  **Set value**: You can set an initial value for the control when instantiating the
	     *  {@link FormControl}, or you can set it programmatically later using
	     *  {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}.
	     *
	     * **Listen to value**: If you want to listen to changes in the value of the control, you can
	     * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
	     * {@link AbstractControl.statusChanges} to be notified when the validation status is
	     * re-calculated.
	     *
	     * ### Example
	     *
	     * In this example, we create form controls for first name and last name.
	     *
	     * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
	     *
	     *  * **npm package**: `@angular/forms`
	     *
	     *  * **NgModule**: {@link ReactiveFormsModule}
	     *
	     *  @stable
	     */
	    var FormControlName = (function (_super) {
	        __extends$10(FormControlName, _super);
	        function FormControlName(parent, validators, asyncValidators, valueAccessors) {
	            _super.call(this);
	            this._added = false;
	            this.update = new EventEmitter();
	            this._parent = parent;
	            this._rawValidators = validators || [];
	            this._rawAsyncValidators = asyncValidators || [];
	            this.valueAccessor = selectValueAccessor(this, valueAccessors);
	        }
	        Object.defineProperty(FormControlName.prototype, "isDisabled", {
	            set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
	            enumerable: true,
	            configurable: true
	        });
	        FormControlName.prototype.ngOnChanges = function (changes) {
	            if (!this._added)
	                this._setUpControl();
	            if (isPropertyUpdated(changes, this.viewModel)) {
	                this.viewModel = this.model;
	                this.formDirective.updateModel(this, this.model);
	            }
	        };
	        FormControlName.prototype.ngOnDestroy = function () {
	            if (this.formDirective) {
	                this.formDirective.removeControl(this);
	            }
	        };
	        FormControlName.prototype.viewToModelUpdate = function (newValue) {
	            this.viewModel = newValue;
	            this.update.emit(newValue);
	        };
	        Object.defineProperty(FormControlName.prototype, "path", {
	            get: function () { return controlPath(this.name, this._parent); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlName.prototype, "formDirective", {
	            get: function () { return this._parent ? this._parent.formDirective : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlName.prototype, "validator", {
	            get: function () { return composeValidators(this._rawValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlName.prototype, "asyncValidator", {
	            get: function () {
	                return composeAsyncValidators(this._rawAsyncValidators);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlName.prototype, "control", {
	            get: function () { return this._control; },
	            enumerable: true,
	            configurable: true
	        });
	        FormControlName.prototype._checkParentType = function () {
	            if (!(this._parent instanceof FormGroupName) &&
	                this._parent instanceof AbstractFormGroupDirective) {
	                ReactiveErrors.ngModelGroupException();
	            }
	            else if (!(this._parent instanceof FormGroupName) && !(this._parent instanceof FormGroupDirective) &&
	                !(this._parent instanceof FormArrayName)) {
	                ReactiveErrors.controlParentException();
	            }
	        };
	        FormControlName.prototype._setUpControl = function () {
	            this._checkParentType();
	            this._control = this.formDirective.addControl(this);
	            if (this.control.disabled)
	                this.valueAccessor.setDisabledState(true);
	            this._added = true;
	        };
	        FormControlName.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
	        ];
	        /** @nocollapse */
	        FormControlName.ctorParameters = [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALUE_ACCESSOR,] },] },
	        ];
	        FormControlName.propDecorators = {
	            'name': [{ type: _angular_core.Input, args: ['formControlName',] },],
	            'model': [{ type: _angular_core.Input, args: ['ngModel',] },],
	            'update': [{ type: _angular_core.Output, args: ['ngModelChange',] },],
	            'isDisabled': [{ type: _angular_core.Input, args: ['disabled',] },],
	        };
	        return FormControlName;
	    }(NgControl));
	
	    var REQUIRED_VALIDATOR = {
	        provide: NG_VALIDATORS,
	        useExisting: _angular_core.forwardRef(function () { return RequiredValidator; }),
	        multi: true
	    };
	    /**
	     * A Directive that adds the `required` validator to any controls marked with the
	     * `required` attribute, via the {@link NG_VALIDATORS} binding.
	     *
	     * ### Example
	     *
	     * ```
	     * <input name="fullName" ngModel required>
	     * ```
	     *
	     * @stable
	     */
	    var RequiredValidator = (function () {
	        function RequiredValidator() {
	        }
	        Object.defineProperty(RequiredValidator.prototype, "required", {
	            get: function () { return this._required; },
	            set: function (value) {
	                this._required = isPresent(value) && "" + value !== 'false';
	                if (this._onChange)
	                    this._onChange();
	            },
	            enumerable: true,
	            configurable: true
	        });
	        RequiredValidator.prototype.validate = function (c) {
	            return this.required ? Validators.required(c) : null;
	        };
	        RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
	        RequiredValidator.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[required][formControlName],[required][formControl],[required][ngModel]',
	                        providers: [REQUIRED_VALIDATOR],
	                        host: { '[attr.required]': 'required? "" : null' }
	                    },] },
	        ];
	        /** @nocollapse */
	        RequiredValidator.ctorParameters = [];
	        RequiredValidator.propDecorators = {
	            'required': [{ type: _angular_core.Input },],
	        };
	        return RequiredValidator;
	    }());
	    /**
	     * Provider which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
	     *
	     * ## Example:
	     *
	     * {@example common/forms/ts/validators/validators.ts region='min'}
	     */
	    var MIN_LENGTH_VALIDATOR = {
	        provide: NG_VALIDATORS,
	        useExisting: _angular_core.forwardRef(function () { return MinLengthValidator; }),
	        multi: true
	    };
	    /**
	     * A directive which installs the {@link MinLengthValidator} for any `formControlName`,
	     * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
	     *
	     * @stable
	     */
	    var MinLengthValidator = (function () {
	        function MinLengthValidator() {
	        }
	        MinLengthValidator.prototype._createValidator = function () {
	            this._validator = Validators.minLength(parseInt(this.minlength, 10));
	        };
	        MinLengthValidator.prototype.ngOnChanges = function (changes) {
	            if (changes['minlength']) {
	                this._createValidator();
	                if (this._onChange)
	                    this._onChange();
	            }
	        };
	        MinLengthValidator.prototype.validate = function (c) {
	            return isPresent(this.minlength) ? this._validator(c) : null;
	        };
	        MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
	        MinLengthValidator.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
	                        providers: [MIN_LENGTH_VALIDATOR],
	                        host: { '[attr.minlength]': 'minlength? minlength : null' }
	                    },] },
	        ];
	        /** @nocollapse */
	        MinLengthValidator.ctorParameters = [];
	        MinLengthValidator.propDecorators = {
	            'minlength': [{ type: _angular_core.Input },],
	        };
	        return MinLengthValidator;
	    }());
	    /**
	     * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
	     *
	     * ## Example:
	     *
	     * {@example common/forms/ts/validators/validators.ts region='max'}
	     */
	    var MAX_LENGTH_VALIDATOR = {
	        provide: NG_VALIDATORS,
	        useExisting: _angular_core.forwardRef(function () { return MaxLengthValidator; }),
	        multi: true
	    };
	    /**
	     * A directive which installs the {@link MaxLengthValidator} for any `formControlName,
	     * `formControl`,
	     * or control with `ngModel` that also has a `maxlength` attribute.
	     *
	     * @stable
	     */
	    var MaxLengthValidator = (function () {
	        function MaxLengthValidator() {
	        }
	        MaxLengthValidator.prototype._createValidator = function () {
	            this._validator = Validators.maxLength(parseInt(this.maxlength, 10));
	        };
	        MaxLengthValidator.prototype.ngOnChanges = function (changes) {
	            if (changes['maxlength']) {
	                this._createValidator();
	                if (this._onChange)
	                    this._onChange();
	            }
	        };
	        MaxLengthValidator.prototype.validate = function (c) {
	            return isPresent(this.maxlength) ? this._validator(c) : null;
	        };
	        MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
	        MaxLengthValidator.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
	                        providers: [MAX_LENGTH_VALIDATOR],
	                        host: { '[attr.maxlength]': 'maxlength? maxlength : null' }
	                    },] },
	        ];
	        /** @nocollapse */
	        MaxLengthValidator.ctorParameters = [];
	        MaxLengthValidator.propDecorators = {
	            'maxlength': [{ type: _angular_core.Input },],
	        };
	        return MaxLengthValidator;
	    }());
	    var PATTERN_VALIDATOR = {
	        provide: NG_VALIDATORS,
	        useExisting: _angular_core.forwardRef(function () { return PatternValidator; }),
	        multi: true
	    };
	    /**
	     * A Directive that adds the `pattern` validator to any controls marked with the
	     * `pattern` attribute, via the {@link NG_VALIDATORS} binding. Uses attribute value
	     * as the regex to validate Control value against.  Follows pattern attribute
	     * semantics; i.e. regex must match entire Control value.
	     *
	     * ### Example
	     *
	     * ```
	     * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
	     * ```
	     * @stable
	     */
	    var PatternValidator = (function () {
	        function PatternValidator() {
	        }
	        PatternValidator.prototype._createValidator = function () { this._validator = Validators.pattern(this.pattern); };
	        PatternValidator.prototype.ngOnChanges = function (changes) {
	            if (changes['pattern']) {
	                this._createValidator();
	                if (this._onChange)
	                    this._onChange();
	            }
	        };
	        PatternValidator.prototype.validate = function (c) {
	            return isPresent(this.pattern) ? this._validator(c) : null;
	        };
	        PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
	        PatternValidator.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
	                        providers: [PATTERN_VALIDATOR],
	                        host: { '[attr.pattern]': 'pattern? pattern : null' }
	                    },] },
	        ];
	        /** @nocollapse */
	        PatternValidator.ctorParameters = [];
	        PatternValidator.propDecorators = {
	            'pattern': [{ type: _angular_core.Input },],
	        };
	        return PatternValidator;
	    }());
	
	    /**
	     * @whatItDoes Creates an {@link AbstractControl} from a user-specified configuration.
	     *
	     * It is essentially syntactic sugar that shortens the `new FormGroup()`,
	     * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
	     * forms.
	     *
	     * @howToUse
	     *
	     * To use, inject `FormBuilder` into your component class. You can then call its methods
	     * directly.
	     *
	     * {@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
	     *
	     *  * **npm package**: `@angular/forms`
	     *
	     *  * **NgModule**: {@link ReactiveFormsModule}
	     *
	     * @stable
	     */
	    var FormBuilder = (function () {
	        function FormBuilder() {
	        }
	        /**
	         * Construct a new {@link FormGroup} with the given map of configuration.
	         * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
	         *
	         * See the {@link FormGroup} constructor for more details.
	         */
	        FormBuilder.prototype.group = function (controlsConfig, extra) {
	            if (extra === void 0) { extra = null; }
	            var controls = this._reduceControls(controlsConfig);
	            var validator = isPresent(extra) ? StringMapWrapper.get(extra, 'validator') : null;
	            var asyncValidator = isPresent(extra) ? StringMapWrapper.get(extra, 'asyncValidator') : null;
	            return new FormGroup(controls, validator, asyncValidator);
	        };
	        /**
	         * Construct a new {@link FormControl} with the given `formState`,`validator`, and
	         * `asyncValidator`.
	         *
	         * `formState` can either be a standalone value for the form control or an object
	         * that contains both a value and a disabled status.
	         *
	         */
	        FormBuilder.prototype.control = function (formState, validator, asyncValidator) {
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            return new FormControl(formState, validator, asyncValidator);
	        };
	        /**
	         * Construct a {@link FormArray} from the given `controlsConfig` array of
	         * configuration, with the given optional `validator` and `asyncValidator`.
	         */
	        FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
	            var _this = this;
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            var controls = controlsConfig.map(function (c) { return _this._createControl(c); });
	            return new FormArray(controls, validator, asyncValidator);
	        };
	        /** @internal */
	        FormBuilder.prototype._reduceControls = function (controlsConfig) {
	            var _this = this;
	            var controls = {};
	            StringMapWrapper.forEach(controlsConfig, function (controlConfig, controlName) {
	                controls[controlName] = _this._createControl(controlConfig);
	            });
	            return controls;
	        };
	        /** @internal */
	        FormBuilder.prototype._createControl = function (controlConfig) {
	            if (controlConfig instanceof FormControl || controlConfig instanceof FormGroup ||
	                controlConfig instanceof FormArray) {
	                return controlConfig;
	            }
	            else if (isArray(controlConfig)) {
	                var value = controlConfig[0];
	                var validator = controlConfig.length > 1 ? controlConfig[1] : null;
	                var asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
	                return this.control(value, validator, asyncValidator);
	            }
	            else {
	                return this.control(controlConfig);
	            }
	        };
	        FormBuilder.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        FormBuilder.ctorParameters = [];
	        return FormBuilder;
	    }());
	
	    var SHARED_FORM_DIRECTIVES = [
	        NgSelectOption, NgSelectMultipleOption, DefaultValueAccessor, NumberValueAccessor,
	        CheckboxControlValueAccessor, SelectControlValueAccessor, SelectMultipleControlValueAccessor,
	        RadioControlValueAccessor, NgControlStatus, NgControlStatusGroup, RequiredValidator,
	        MinLengthValidator, MaxLengthValidator, PatternValidator
	    ];
	    var TEMPLATE_DRIVEN_DIRECTIVES = [NgModel, NgModelGroup, NgForm];
	    var REACTIVE_DRIVEN_DIRECTIVES = [FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName];
	    /**
	     * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
	     */
	    var InternalFormsSharedModule = (function () {
	        function InternalFormsSharedModule() {
	        }
	        InternalFormsSharedModule.decorators = [
	            { type: _angular_core.NgModule, args: [{ declarations: SHARED_FORM_DIRECTIVES, exports: SHARED_FORM_DIRECTIVES },] },
	        ];
	        /** @nocollapse */
	        InternalFormsSharedModule.ctorParameters = [];
	        return InternalFormsSharedModule;
	    }());
	
	    /**
	     * The ng module for forms.
	     * @stable
	     */
	    var FormsModule = (function () {
	        function FormsModule() {
	        }
	        FormsModule.decorators = [
	            { type: _angular_core.NgModule, args: [{
	                        declarations: TEMPLATE_DRIVEN_DIRECTIVES,
	                        providers: [RadioControlRegistry],
	                        exports: [InternalFormsSharedModule, TEMPLATE_DRIVEN_DIRECTIVES]
	                    },] },
	        ];
	        /** @nocollapse */
	        FormsModule.ctorParameters = [];
	        return FormsModule;
	    }());
	    /**
	     * The ng module for reactive forms.
	     * @stable
	     */
	    var ReactiveFormsModule = (function () {
	        function ReactiveFormsModule() {
	        }
	        ReactiveFormsModule.decorators = [
	            { type: _angular_core.NgModule, args: [{
	                        declarations: [REACTIVE_DRIVEN_DIRECTIVES],
	                        providers: [FormBuilder, RadioControlRegistry],
	                        exports: [InternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES]
	                    },] },
	        ];
	        /** @nocollapse */
	        ReactiveFormsModule.ctorParameters = [];
	        return ReactiveFormsModule;
	    }());
	
	    exports.AbstractControlDirective = AbstractControlDirective;
	    exports.AbstractFormGroupDirective = AbstractFormGroupDirective;
	    exports.CheckboxControlValueAccessor = CheckboxControlValueAccessor;
	    exports.ControlContainer = ControlContainer;
	    exports.NG_VALUE_ACCESSOR = NG_VALUE_ACCESSOR;
	    exports.DefaultValueAccessor = DefaultValueAccessor;
	    exports.NgControl = NgControl;
	    exports.NgControlStatus = NgControlStatus;
	    exports.NgControlStatusGroup = NgControlStatusGroup;
	    exports.NgForm = NgForm;
	    exports.NgModel = NgModel;
	    exports.NgModelGroup = NgModelGroup;
	    exports.FormControlDirective = FormControlDirective;
	    exports.FormControlName = FormControlName;
	    exports.FormGroupDirective = FormGroupDirective;
	    exports.FormArrayName = FormArrayName;
	    exports.FormGroupName = FormGroupName;
	    exports.NgSelectOption = NgSelectOption;
	    exports.SelectControlValueAccessor = SelectControlValueAccessor;
	    exports.SelectMultipleControlValueAccessor = SelectMultipleControlValueAccessor;
	    exports.MaxLengthValidator = MaxLengthValidator;
	    exports.MinLengthValidator = MinLengthValidator;
	    exports.PatternValidator = PatternValidator;
	    exports.RequiredValidator = RequiredValidator;
	    exports.FormBuilder = FormBuilder;
	    exports.AbstractControl = AbstractControl;
	    exports.FormArray = FormArray;
	    exports.FormControl = FormControl;
	    exports.FormGroup = FormGroup;
	    exports.NG_ASYNC_VALIDATORS = NG_ASYNC_VALIDATORS;
	    exports.NG_VALIDATORS = NG_VALIDATORS;
	    exports.Validators = Validators;
	    exports.FormsModule = FormsModule;
	    exports.ReactiveFormsModule = ReactiveFormsModule;
	
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(32));


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var BaseChartComponent = (function () {
	    function BaseChartComponent(element) {
	        this.labels = [];
	        this.options = { responsive: true };
	        this.chartClick = new core_1.EventEmitter();
	        this.chartHover = new core_1.EventEmitter();
	        this.initFlag = false;
	        this.element = element;
	    }
	    BaseChartComponent.prototype.ngOnInit = function () {
	        this.ctx = this.element.nativeElement.children[0].getContext('2d');
	        this.cvs = this.element.nativeElement.children[0];
	        this.parent = this.element.nativeElement;
	        this.initFlag = true;
	        if (this.data || this.datasets) {
	            this.refresh();
	        }
	    };
	    BaseChartComponent.prototype.ngOnChanges = function (changes) {
	        if (this.initFlag) {
	            // Check if the changes are in the data or datasets
	            if (changes.hasOwnProperty('data') || changes.hasOwnProperty('datasets')) {
	                this.chart.data.datasets = this.getDatasets();
	                this.chart.update();
	            }
	            else {
	                this.refresh();
	            }
	        }
	    };
	    BaseChartComponent.prototype.ngOnDestroy = function () {
	        if (this.chart) {
	            this.chart.destroy();
	            this.chart = void 0;
	        }
	    };
	    BaseChartComponent.prototype.getChartBuilder = function (ctx /*, data:Array<any>, options:any*/) {
	        var _this = this;
	        var datasets = this.getDatasets();
	        var options = Object.assign({}, this.options);
	        if (this.legend === false) {
	            options.legend = { display: false };
	        }
	        // hock for onHover and onClick events
	        options.hover = options.hover || {};
	        if (!options.hover.onHover) {
	            options.hover.onHover = function (active) {
	                if (active && !active.length) {
	                    return;
	                }
	                _this.chartHover.emit({ active: active });
	            };
	        }
	        if (!options.onClick) {
	            options.onClick = function (event, active) {
	                _this.chartClick.emit({ event: event, active: active });
	            };
	        }
	        var opts = {
	            type: this.chartType,
	            data: {
	                labels: this.labels,
	                datasets: datasets
	            },
	            options: options
	        };
	        if (typeof Chart === 'undefined') {
	            throw new Error('ng2-charts configuration issue: Embedding Chart.js lib is mandatory');
	        }
	        return new Chart(ctx, opts);
	    };
	    BaseChartComponent.prototype.getDatasets = function () {
	        var _this = this;
	        var datasets = void 0;
	        // in case if datasets is not provided, but data is present
	        if (!this.datasets || !this.datasets.length && (this.data && this.data.length)) {
	            if (Array.isArray(this.data[0])) {
	                datasets = this.data.map(function (data, index) {
	                    return { data: data, label: _this.labels[index] || "Label " + index };
	                });
	            }
	            else {
	                datasets = [{ data: this.data, label: "Label 0" }];
	            }
	        }
	        if (this.datasets && this.datasets.length ||
	            (datasets && datasets.length)) {
	            datasets = (this.datasets || datasets)
	                .map(function (elm, index) {
	                var newElm = Object.assign({}, elm);
	                if (_this.colors && _this.colors.length) {
	                    Object.assign(newElm, _this.colors[index]);
	                }
	                else {
	                    Object.assign(newElm, getColors(_this.chartType, index, newElm.data.length));
	                }
	                return newElm;
	            });
	        }
	        if (!datasets) {
	            throw new Error("ng-charts configuration error, \n      data or datasets field are required to render char " + this.chartType);
	        }
	        return datasets;
	    };
	    BaseChartComponent.prototype.refresh = function () {
	        var _this = this;
	        if (this.options && this.options.responsive && this.parent.clientHeight === 0) {
	            return setTimeout(function () { return _this.refresh(); }, 50);
	        }
	        // todo: remove this line, it is producing flickering
	        this.ngOnDestroy();
	        this.chart = this.getChartBuilder(this.ctx /*, data, this.options*/);
	    };
	    BaseChartComponent.defaultColors = [
	        [255, 99, 132],
	        [54, 162, 235],
	        [255, 206, 86],
	        [231, 233, 237],
	        [75, 192, 192],
	        [151, 187, 205],
	        [220, 220, 220],
	        [247, 70, 74],
	        [70, 191, 189],
	        [253, 180, 92],
	        [148, 159, 177],
	        [77, 83, 96]
	    ];
	    BaseChartComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'base-chart',
	                    template: "<canvas style=\"width: 100%; height: 100%;\"></canvas>",
	                    styles: [":host { display: block; }"]
	                },] },
	    ];
	    /** @nocollapse */
	    BaseChartComponent.ctorParameters = [
	        { type: core_1.ElementRef, },
	    ];
	    BaseChartComponent.propDecorators = {
	        'data': [{ type: core_1.Input },],
	        'datasets': [{ type: core_1.Input },],
	        'labels': [{ type: core_1.Input },],
	        'options': [{ type: core_1.Input },],
	        'chartType': [{ type: core_1.Input },],
	        'colors': [{ type: core_1.Input },],
	        'legend': [{ type: core_1.Input },],
	        'chartClick': [{ type: core_1.Output },],
	        'chartHover': [{ type: core_1.Output },],
	    };
	    return BaseChartComponent;
	}());
	exports.BaseChartComponent = BaseChartComponent;
	function rgba(colour, alpha) {
	    return 'rgba(' + colour.concat(alpha).join(',') + ')';
	}
	function getRandomInt(min, max) {
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	}
	function formatLineColor(colors) {
	    return {
	        backgroundColor: rgba(colors, 0.4),
	        borderColor: rgba(colors, 1),
	        pointBackgroundColor: rgba(colors, 1),
	        pointBorderColor: '#fff',
	        pointHoverBackgroundColor: '#fff',
	        pointHoverBorderColor: rgba(colors, 0.8)
	    };
	}
	function formatBarColor(colors) {
	    return {
	        backgroundColor: rgba(colors, 0.6),
	        borderColor: rgba(colors, 1),
	        hoverBackgroundColor: rgba(colors, 0.8),
	        hoverBorderColor: rgba(colors, 1)
	    };
	}
	function formatPieColors(colors) {
	    return {
	        backgroundColor: colors.map(function (color) { return rgba(color, 0.6); }),
	        borderColor: colors.map(function () { return '#fff'; }),
	        pointBackgroundColor: colors.map(function (color) { return rgba(color, 1); }),
	        pointBorderColor: colors.map(function () { return '#fff'; }),
	        pointHoverBackgroundColor: colors.map(function (color) { return rgba(color, 1); }),
	        pointHoverBorderColor: colors.map(function (color) { return rgba(color, 1); })
	    };
	}
	function formatPolarAreaColors(colors) {
	    return {
	        backgroundColor: colors.map(function (color) { return rgba(color, 0.6); }),
	        borderColor: colors.map(function (color) { return rgba(color, 1); }),
	        hoverBackgroundColor: colors.map(function (color) { return rgba(color, 0.8); }),
	        hoverBorderColor: colors.map(function (color) { return rgba(color, 1); })
	    };
	}
	function getRandomColor() {
	    return [getRandomInt(0, 255), getRandomInt(0, 255), getRandomInt(0, 255)];
	}
	/**
	 * Generate colors for line|bar charts
	 * @param index
	 * @returns {number[]|Color}
	 */
	function generateColor(index) {
	    return BaseChartComponent.defaultColors[index] || getRandomColor();
	}
	/**
	 * Generate colors for pie|doughnut charts
	 * @param count
	 * @returns {Colors}
	 */
	function generateColors(count) {
	    var colorsArr = new Array(count);
	    for (var i = 0; i < count; i++) {
	        colorsArr[i] = BaseChartComponent.defaultColors[i] || getRandomColor();
	    }
	    return colorsArr;
	}
	/**
	 * Generate colors by chart type
	 * @param chartType
	 * @param index
	 * @param count
	 * @returns {Color}
	 */
	function getColors(chartType, index, count) {
	    if (chartType === 'pie' || chartType === 'doughnut') {
	        return formatPieColors(generateColors(count));
	    }
	    if (chartType === 'polarArea') {
	        return formatPolarAreaColors(generateColors(count));
	    }
	    if (chartType === 'line' || chartType === 'radar') {
	        return formatLineColor(generateColor(index));
	    }
	    if (chartType === 'bar' || chartType === 'horizontalBar') {
	        return formatBarColor(generateColor(index));
	    }
	    return generateColor(index);
	}
	var ChartsModule = (function () {
	    function ChartsModule() {
	    }
	    ChartsModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    declarations: [
	                        BaseChartComponent
	                    ],
	                    exports: [
	                        BaseChartComponent
	                    ],
	                    imports: []
	                },] },
	    ];
	    /** @nocollapse */
	    ChartsModule.ctorParameters = [];
	    return ChartsModule;
	}());
	exports.ChartsModule = ChartsModule;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var common_1 = __webpack_require__(34);
	var common_2 = __webpack_require__(34);
	exports.NgTranscludeDirective = common_2.NgTranscludeDirective;
	exports.MATERIAL_COMMON = [
	    common_1.NgTranscludeDirective,
	];
	var utilities_1 = __webpack_require__(35);
	exports.isMobile = utilities_1.isMobile;
	var control_with_type_1 = __webpack_require__(36);
	var date_range_1 = __webpack_require__(38);
	var menu_item_1 = __webpack_require__(39);
	var selection_item_1 = __webpack_require__(40);
	var submitable_form_group_1 = __webpack_require__(41);
	var validation_info_1 = __webpack_require__(42);
	var control_with_type_2 = __webpack_require__(36);
	exports.ControlWithType = control_with_type_2.ControlWithType;
	var date_range_2 = __webpack_require__(38);
	exports.DateRange = date_range_2.DateRange;
	var menu_item_2 = __webpack_require__(39);
	exports.MenuItem = menu_item_2.MenuItem;
	var selection_item_2 = __webpack_require__(40);
	exports.SelectionItem = selection_item_2.SelectionItem;
	var submitable_form_group_2 = __webpack_require__(41);
	exports.SubmitableFormGroup = submitable_form_group_2.SubmitableFormGroup;
	var validation_info_2 = __webpack_require__(42);
	exports.ValidationInfo = validation_info_2.ValidationInfo;
	exports.MATERIAL_MODELS = [
	    control_with_type_1.ControlWithType,
	    date_range_1.DateRange,
	    menu_item_1.MenuItem,
	    selection_item_1.SelectionItem,
	    submitable_form_group_1.SubmitableFormGroup,
	    validation_info_1.ValidationInfo,
	];
	__export(__webpack_require__(43));
	__export(__webpack_require__(72));


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(2);
	var NgTranscludeDirective = (function () {
	    function NgTranscludeDirective(_viewRef) {
	        this.viewRef = _viewRef;
	    }
	    NgTranscludeDirective.prototype.ngOnChanges = function (changes) {
	        if (changes.ngTransclude) {
	            this._createEmbeddedView(changes.ngTransclude.currentValue);
	        }
	    };
	    NgTranscludeDirective.prototype.ngAfterViewInit = function () {
	        this._createEmbeddedView(this.ngTransclude);
	    };
	    NgTranscludeDirective.prototype._createEmbeddedView = function (viewRef) {
	        if (viewRef) {
	            this.viewRef.createEmbeddedView(viewRef);
	        }
	    };
	    return NgTranscludeDirective;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", core_1.TemplateRef)
	], NgTranscludeDirective.prototype, "ngTransclude", void 0);
	NgTranscludeDirective = __decorate([
	    core_1.Directive({
	        selector: '[ngTransclude]',
	    }),
	    __param(0, core_1.Inject(core_1.ViewContainerRef)),
	    __metadata("design:paramtypes", [core_1.ViewContainerRef])
	], NgTranscludeDirective);
	exports.NgTranscludeDirective = NgTranscludeDirective;


/***/ },
/* 35 */
/***/ function(module, exports) {

	"use strict";
	function guid() {
	    function s4() {
	        return Math.floor((1 + Math.random()) * 0x10000)
	            .toString(16)
	            .substring(1);
	    }
	    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
	        s4() + '-' + s4() + s4() + s4();
	}
	exports.guid = guid;
	function isMobile() {
	    var check = false;
	    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
	        check = true; })(navigator.userAgent || navigator.vendor || window.opera);
	    return check;
	}
	exports.isMobile = isMobile;
	;
	function iOS() {
	    var iDevices = [
	        'iPad Simulator',
	        'iPhone Simulator',
	        'iPod Simulator',
	        'iPad',
	        'iPhone',
	        'iPod',
	    ];
	    if (!!navigator.platform) {
	        while (iDevices.length) {
	            if (navigator.platform === iDevices.pop()) {
	                return true;
	            }
	        }
	    }
	    return false;
	}
	exports.iOS = iOS;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var forms_1 = __webpack_require__(27);
	var type_enum_1 = __webpack_require__(37);
	var ControlWithType = (function (_super) {
	    __extends(ControlWithType, _super);
	    function ControlWithType(dataType, value, validator, asyncValidator) {
	        if (value === void 0) { value = null; }
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        var _this = _super.call(this, value, validator, asyncValidator) || this;
	        _this.dataType = dataType;
	        return _this;
	    }
	    ControlWithType.prototype.getValue = function (mandatory) {
	        var value;
	        switch (this.dataType) {
	            case type_enum_1.TypeEnum.String:
	                value = this.value;
	                break;
	            case type_enum_1.TypeEnum.Number:
	                value = Number(this.value.replace(',', ''));
	                break;
	            case type_enum_1.TypeEnum.Date:
	                var momentDate = moment(this.value);
	                value = momentDate.toDate();
	                break;
	            case type_enum_1.TypeEnum.Boolean:
	                value = Boolean(this.value);
	                break;
	            default:
	                value = this.value;
	        }
	        return mandatory || value ? value : undefined;
	    };
	    return ControlWithType;
	}(forms_1.FormControl));
	exports.ControlWithType = ControlWithType;


/***/ },
/* 37 */
/***/ function(module, exports) {

	"use strict";
	var TypeEnum;
	(function (TypeEnum) {
	    TypeEnum[TypeEnum["String"] = 0] = "String";
	    TypeEnum[TypeEnum["Number"] = 1] = "Number";
	    TypeEnum[TypeEnum["Date"] = 2] = "Date";
	    TypeEnum[TypeEnum["Boolean"] = 3] = "Boolean";
	})(TypeEnum = exports.TypeEnum || (exports.TypeEnum = {}));


/***/ },
/* 38 */
/***/ function(module, exports) {

	"use strict";
	var DateRange = (function () {
	    function DateRange(from, to) {
	        this.from = from;
	        this.to = to;
	        this.from = from;
	        this.to = to;
	    }
	    Object.defineProperty(DateRange.prototype, "isValid", {
	        get: function () {
	            return this.to >= this.from;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return DateRange;
	}());
	exports.DateRange = DateRange;


/***/ },
/* 39 */
/***/ function(module, exports) {

	"use strict";
	var MenuItem = (function () {
	    function MenuItem() {
	    }
	    return MenuItem;
	}());
	exports.MenuItem = MenuItem;


/***/ },
/* 40 */
/***/ function(module, exports) {

	"use strict";
	var SelectionItem = (function () {
	    function SelectionItem(id, title, selected, disabled) {
	        this.id = id;
	        this.title = title;
	        this.selected = selected;
	        this.disabled = disabled;
	    }
	    return SelectionItem;
	}());
	exports.SelectionItem = SelectionItem;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var forms_1 = __webpack_require__(27);
	var SubmitableFormGroup = (function (_super) {
	    __extends(SubmitableFormGroup, _super);
	    function SubmitableFormGroup(controls, validator, asyncValidator) {
	        return _super.call(this, controls, validator, asyncValidator) || this;
	    }
	    SubmitableFormGroup.prototype.getValue = function () {
	        var value = {};
	        var keys = Object.keys(this.controls);
	        var controls = this.controls;
	        keys.forEach(function (key) {
	            var result = controls[key].value;
	            if (result) {
	                value[key] = result;
	            }
	        });
	        return value;
	    };
	    return SubmitableFormGroup;
	}(forms_1.FormGroup));
	exports.SubmitableFormGroup = SubmitableFormGroup;


/***/ },
/* 42 */
/***/ function(module, exports) {

	"use strict";
	var ValidationInfo = (function () {
	    function ValidationInfo() {
	    }
	    return ValidationInfo;
	}());
	exports.ValidationInfo = ValidationInfo;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(23);
	var forms_1 = __webpack_require__(27);
	var checkbox_component_1 = __webpack_require__(44);
	var date_range_picker_component_1 = __webpack_require__(47);
	var email_component_1 = __webpack_require__(49);
	var masked_input_directive_1 = __webpack_require__(50);
	var number_component_1 = __webpack_require__(56);
	var password_component_1 = __webpack_require__(58);
	var phone_component_1 = __webpack_require__(59);
	var radio_group_component_1 = __webpack_require__(60);
	var radio_group_service_1 = __webpack_require__(61);
	var radio_component_1 = __webpack_require__(62);
	var select_picker_component_1 = __webpack_require__(63);
	var text_area_component_1 = __webpack_require__(65);
	var text_box_component_1 = __webpack_require__(67);
	var toggle_component_1 = __webpack_require__(68);
	var date_time_picker_component_1 = __webpack_require__(69);
	var datetime_picker_popup_component_1 = __webpack_require__(70);
	var checkbox_component_2 = __webpack_require__(44);
	exports.CheckboxComponent = checkbox_component_2.CheckboxComponent;
	var date_range_picker_component_2 = __webpack_require__(47);
	exports.DateRangePickerComponent = date_range_picker_component_2.DateRangePickerComponent;
	var email_component_2 = __webpack_require__(49);
	exports.EmailComponent = email_component_2.EmailComponent;
	var masked_input_directive_2 = __webpack_require__(50);
	exports.MaskedInputDirective = masked_input_directive_2.MaskedInputDirective;
	var number_component_2 = __webpack_require__(56);
	exports.NumberComponent = number_component_2.NumberComponent;
	var password_component_2 = __webpack_require__(58);
	exports.PasswordComponent = password_component_2.PasswordComponent;
	var phone_component_2 = __webpack_require__(59);
	exports.PhoneComponent = phone_component_2.PhoneComponent;
	var radio_group_component_2 = __webpack_require__(60);
	exports.RadioGroupComponent = radio_group_component_2.RadioGroupComponent;
	var radio_group_service_2 = __webpack_require__(61);
	exports.RadioGroupService = radio_group_service_2.RadioGroupService;
	var radio_component_2 = __webpack_require__(62);
	exports.RadioComponent = radio_component_2.RadioComponent;
	var select_picker_component_2 = __webpack_require__(63);
	exports.SelectPickerComponent = select_picker_component_2.SelectPickerComponent;
	var text_area_component_2 = __webpack_require__(65);
	exports.TextAreaComponent = text_area_component_2.TextAreaComponent;
	var text_box_component_2 = __webpack_require__(67);
	exports.TextBoxComponent = text_box_component_2.TextBoxComponent;
	var toggle_component_2 = __webpack_require__(68);
	exports.ToggleComponent = toggle_component_2.ToggleComponent;
	var date_time_picker_component_2 = __webpack_require__(69);
	exports.DateTimePickerComponent = date_time_picker_component_2.DateTimePickerComponent;
	var datetime_picker_popup_component_2 = __webpack_require__(70);
	exports.DateTimePickerPopupComponent = datetime_picker_popup_component_2.DateTimePickerPopupComponent;
	var MaterialFormsModule = (function () {
	    function MaterialFormsModule() {
	    }
	    return MaterialFormsModule;
	}());
	MaterialFormsModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            common_1.CommonModule,
	            forms_1.FormsModule,
	            forms_1.ReactiveFormsModule,
	        ],
	        declarations: [
	            checkbox_component_1.CheckboxComponent,
	            date_range_picker_component_1.DateRangePickerComponent,
	            date_time_picker_component_1.DateTimePickerComponent,
	            datetime_picker_popup_component_1.DateTimePickerPopupComponent,
	            email_component_1.EmailComponent,
	            masked_input_directive_1.MaskedInputDirective,
	            number_component_1.NumberComponent,
	            password_component_1.PasswordComponent,
	            phone_component_1.PhoneComponent,
	            radio_group_component_1.RadioGroupComponent,
	            radio_component_1.RadioComponent,
	            select_picker_component_1.SelectPickerComponent,
	            text_area_component_1.TextAreaComponent,
	            text_box_component_1.TextBoxComponent,
	            toggle_component_1.ToggleComponent,
	        ],
	        exports: [
	            checkbox_component_1.CheckboxComponent,
	            date_range_picker_component_1.DateRangePickerComponent,
	            date_time_picker_component_1.DateTimePickerComponent,
	            datetime_picker_popup_component_1.DateTimePickerPopupComponent,
	            email_component_1.EmailComponent,
	            masked_input_directive_1.MaskedInputDirective,
	            number_component_1.NumberComponent,
	            password_component_1.PasswordComponent,
	            phone_component_1.PhoneComponent,
	            radio_group_component_1.RadioGroupComponent,
	            radio_component_1.RadioComponent,
	            select_picker_component_1.SelectPickerComponent,
	            text_area_component_1.TextAreaComponent,
	            text_box_component_1.TextBoxComponent,
	            toggle_component_1.ToggleComponent,
	        ],
	        providers: [
	            radio_group_service_1.RadioGroupService,
	        ],
	        entryComponents: [datetime_picker_popup_component_1.DateTimePickerPopupComponent],
	    }),
	    __metadata("design:paramtypes", [])
	], MaterialFormsModule);
	exports.MaterialFormsModule = MaterialFormsModule;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var input_base_component_1 = __webpack_require__(45);
	var type_enum_1 = __webpack_require__(37);
	var CheckboxComponent = (function (_super) {
	    __extends(CheckboxComponent, _super);
	    function CheckboxComponent(el) {
	        var _this = _super.call(this, el) || this;
	        _this.dataType = type_enum_1.TypeEnum.Boolean;
	        return _this;
	    }
	    CheckboxComponent.prototype.addValidators = function () { };
	    CheckboxComponent.prototype.ngOnInit = function () {
	        this.onInit();
	    };
	    CheckboxComponent.prototype.ngOnDestroy = function () {
	    };
	    return CheckboxComponent;
	}(input_base_component_1.InputBase));
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], CheckboxComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], CheckboxComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], CheckboxComponent.prototype, "label", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], CheckboxComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], CheckboxComponent.prototype, "value", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], CheckboxComponent.prototype, "alt", void 0);
	CheckboxComponent = __decorate([
	    core_1.Component({
	        selector: 'checkbox',
	        template: "\n      <div class=\"checkbox m-b-25\" [class.fc-alt]=\"alt\"><label><input class=\"form-control\" type=\"checkbox\" [formControl]=\"control\" [disabled]=\"disabled\"><i class=\"input-helper\"></i>{{label}}</label></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], CheckboxComponent);
	exports.CheckboxComponent = CheckboxComponent;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var forms_1 = __webpack_require__(27);
	var submitable_form_group_1 = __webpack_require__(41);
	var control_with_type_1 = __webpack_require__(36);
	var type_enum_1 = __webpack_require__(37);
	var custom_validators_1 = __webpack_require__(46);
	var InputBase = (function () {
	    function InputBase(el) {
	        this.inputType = 'text';
	        this.initialized = false;
	        this._el = el;
	        this.validations = [];
	        this.dataType = type_enum_1.TypeEnum.String;
	    }
	    InputBase.minValidator = function (length) {
	        return {
	            validator: forms_1.Validators.minLength(length),
	            type: 'minlength',
	            message: "At least " + length + " characters are required",
	        };
	    };
	    InputBase.maxValidator = function (length) {
	        return {
	            validator: forms_1.Validators.maxLength(length),
	            type: 'maxlength',
	            message: "No more than " + length + " characters are allowed",
	        };
	    };
	    InputBase.prototype.onFocus = function (ele) {
	        this.toggled = true;
	    };
	    InputBase.prototype.onBlur = function (ele) {
	        if (!this.control.value) {
	            this.toggled = false;
	        }
	    };
	    InputBase.prototype.addValidators = function () {
	        throw 'Validators should be defined at the derived class';
	    };
	    InputBase.prototype.addMinValidation = function () {
	        if (this.min) {
	            this.validations.push({
	                validator: custom_validators_1.CustomValidators.minNumber(this.min),
	                type: 'tooLow',
	                message: "Minimum aceptable value is " + this.min,
	            });
	        }
	    };
	    InputBase.prototype.addMaxValidation = function () {
	        if (this.max) {
	            this.validations.push({
	                validator: custom_validators_1.CustomValidators.maxNumber(this.max),
	                type: 'tooHigh',
	                message: "Maximum aceptable value is " + this.max,
	            });
	        }
	    };
	    InputBase.prototype.onInit = function () {
	        if (this.floatingLabel === undefined) {
	            this.floatingLabel = true;
	        }
	        this._processControl(this.field);
	        if (this.control.value) {
	            this.toggled = true;
	        }
	        this.initialized = true;
	    };
	    InputBase.prototype._getValidators = function () {
	        this.addValidators();
	        if (this.required) {
	            this.validations.push({
	                validator: forms_1.Validators.required,
	                type: 'required',
	                message: 'This field is required',
	            });
	        }
	        var validators = [];
	        if (this.validations.length > 0) {
	            this.validations.forEach(function (item) { return validators.push(item.validator); });
	        }
	        return validators;
	    };
	    InputBase.prototype._processControl = function (field) {
	        var that = this;
	        var pathTokens = field.split('.');
	        var fieldName = pathTokens.pop();
	        var fg = that.fg;
	        pathTokens.forEach(function (token) {
	            if (!fg.controls[token]) {
	                fg.addControl(token, new submitable_form_group_1.SubmitableFormGroup({}));
	            }
	            fg = fg.controls[token];
	        });
	        if (!this.value) {
	            this.value = '';
	        }
	        var validators = this._getValidators();
	        this.control = new control_with_type_1.ControlWithType(this.dataType, this.value, forms_1.Validators.compose(validators));
	        this.control.__isDecimal = this.decimal;
	        fg.addControl(fieldName, this.control);
	    };
	    return InputBase;
	}());
	exports.InputBase = InputBase;


/***/ },
/* 46 */
/***/ function(module, exports) {

	"use strict";
	function processNumber(control) {
	    'use strict';
	    if (control.value.trim() === '') {
	        return NaN;
	    }
	    var val = control.value.replace(',', '');
	    if (val.length > 2 && control.__isDecimal) {
	        val = val.replace('.', '');
	        var num = val.substring(0, val.length - 2);
	        var dec = val.substring(val.length - 2, val.length);
	        val = num + "." + dec;
	    }
	    return +val;
	}
	var CustomValidators = (function () {
	    function CustomValidators() {
	    }
	    CustomValidators.emailAddress = function (control) {
	        if (control.value.trim() === '') {
	            return null;
	        }
	        var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
	        if (!EMAIL_REGEXP.test(control.value)) {
	            return { invalidEmail: true };
	        }
	        return null;
	    };
	    CustomValidators.complexPassword = function (control) {
	        if (control.value.trim() === '') {
	            return null;
	        }
	        var regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/;
	        var validPassword = regExp.test(control.value);
	        if (!validPassword) {
	            return { weakPassword: true };
	        }
	        return null;
	    };
	    CustomValidators.minNumber = function (min) {
	        return function (control) {
	            var value = processNumber(control);
	            if (isNaN(value)) {
	                return null;
	            }
	            if (value < min) {
	                return { tooLow: true };
	            }
	            return null;
	        };
	    };
	    CustomValidators.maxNumber = function (max) {
	        return function (control) {
	            var value = processNumber(control);
	            if (isNaN(value)) {
	                return null;
	            }
	            if (value > max) {
	                return { tooHigh: true };
	            }
	            return null;
	        };
	    };
	    return CustomValidators;
	}());
	exports.CustomValidators = CustomValidators;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var date_range_picker_helper_1 = __webpack_require__(48);
	var input_base_component_1 = __webpack_require__(45);
	var date_range_1 = __webpack_require__(38);
	var DateRangePickerComponent = (function (_super) {
	    __extends(DateRangePickerComponent, _super);
	    function DateRangePickerComponent(ele) {
	        var _this = _super.call(this, ele) || this;
	        _this.ele = ele;
	        _this.parentEl = $('body');
	        _this.startDate = moment().startOf('day').toString();
	        _this.endDate = moment().endOf('day').toString();
	        _this.dateLimit = false;
	        _this.autoApply = false;
	        _this.singleDatePicker = false;
	        _this.showDropdowns = false;
	        _this.showWeekNumbers = false;
	        _this.showISOWeekNumbers = false;
	        _this.showCustomRangeLabel = true;
	        _this.timePicker = false;
	        _this.timePicker24Hour = false;
	        _this.timePickerIncrement = 1;
	        _this.timePickerSeconds = false;
	        _this.linkedCalendars = true;
	        _this.autoUpdateInput = true;
	        _this.alwaysShowCalendars = false;
	        _this.ranges = {};
	        _this.buttonClasses = 'btn btn-sm';
	        _this.applyClass = 'btn-success';
	        _this.cancelClass = 'btn-default';
	        _this.rangeChanged = new core_1.EventEmitter();
	        _this.isShowing = false;
	        _this.leftCalendar = {};
	        _this.rightCalendar = {};
	        return _this;
	    }
	    DateRangePickerComponent.prototype.ngOnInit = function () {
	        this.onInit();
	        this.element = $(this.ele.nativeElement).find('.form-control');
	        if (this.element.hasClass('dropup'))
	            this.drops = 'up';
	        this.locale = {
	            direction: 'ltr',
	            format: 'MM/DD/YYYY',
	            separator: ' - ',
	            applyLabel: 'Apply',
	            cancelLabel: 'Cancel',
	            weekLabel: 'W',
	            customRangeLabel: 'Custom Range',
	            daysOfWeek: moment.weekdaysMin(),
	            monthNames: moment.monthsShort(),
	            firstDay: moment.localeData().firstDayOfWeek(),
	        };
	        this.callback = function () { };
	        if (typeof this.template !== 'string' && !(this.template instanceof $))
	            this.template = date_range_picker_helper_1.pickerTemplate;
	        var container = this.parentEl.find('.daterangepicker');
	        if (container.length === 0) {
	            this.container = $(this.template).appendTo(this.parentEl);
	        }
	        else {
	            this.container = container;
	        }
	        this._handleOverrides();
	        this._processInitialValues();
	        this._processTimePicker();
	        if (this.autoApply && typeof this.ranges !== 'object') {
	            this.container.find('.ranges').hide();
	        }
	        else if (this.autoApply) {
	            this.container.find('.applyBtn, .cancelBtn').addClass('hide');
	        }
	        this._processSingleDatePicker();
	        if ((typeof this.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
	            this.container.addClass('show-calendar');
	        }
	        this.container.addClass('opens' + this.opens);
	        if (typeof this.ranges !== 'undefined' && this.opens === 'right') {
	            this.container.find('.ranges').prependTo(this.container.find('.calendar.left').parent());
	        }
	        this._processCssForLabelsAndButtons();
	        this._processEventListeners();
	        this._processInitialValue();
	    };
	    DateRangePickerComponent.prototype.ngOnDestroy = function () {
	        this.remove();
	    };
	    DateRangePickerComponent.prototype.addValidators = function () { };
	    DateRangePickerComponent.prototype._handleOverrides = function () {
	        if (typeof this.locale === 'object') {
	            if (typeof this.locale.direction === 'string')
	                this.locale.direction = this.locale.direction;
	            if (typeof this.locale.format === 'string')
	                this.locale.format = this.locale.format;
	            if (typeof this.locale.separator === 'string')
	                this.locale.separator = this.locale.separator;
	            if (typeof this.locale.daysOfWeek === 'object')
	                this.locale.daysOfWeek = this.locale.daysOfWeek.slice();
	            if (typeof this.locale.monthNames === 'object')
	                this.locale.monthNames = this.locale.monthNames.slice();
	            if (typeof this.locale.firstDay === 'number')
	                this.locale.firstDay = this.locale.firstDay;
	            if (typeof this.locale.applyLabel === 'string')
	                this.locale.applyLabel = this.locale.applyLabel;
	            if (typeof this.locale.cancelLabel === 'string')
	                this.locale.cancelLabel = this.locale.cancelLabel;
	            if (typeof this.locale.weekLabel === 'string')
	                this.locale.weekLabel = this.locale.weekLabel;
	            if (typeof this.locale.customRangeLabel === 'string')
	                this.locale.customRangeLabel = this.locale.customRangeLabel;
	        }
	        this.container.addClass(this.locale.direction);
	        if (typeof this.startDate === 'string')
	            this.startDate = moment(this.startDate, this.locale.format);
	        if (typeof this.endDate === 'string')
	            this.endDate = moment(this.endDate, this.locale.format);
	        if (typeof this.minDate === 'string')
	            this.minDate = moment(this.minDate, this.locale.format);
	        if (typeof this.maxDate === 'string')
	            this.maxDate = moment(this.maxDate, this.locale.format);
	        if (typeof this.startDate === 'object')
	            this.startDate = moment(this.startDate);
	        if (typeof this.endDate === 'object')
	            this.endDate = moment(this.endDate);
	        if (typeof this.minDate === 'object')
	            this.minDate = moment(this.minDate);
	        if (typeof this.maxDate === 'object')
	            this.maxDate = moment(this.maxDate);
	        if (this.minDate && this.startDate.isBefore(this.minDate))
	            this.startDate = this.minDate.clone();
	        if (this.maxDate && this.endDate.isAfter(this.maxDate))
	            this.endDate = this.maxDate.clone();
	        if (typeof this.applyClass === 'string')
	            this.applyClass = this.applyClass;
	        if (typeof this.cancelClass === 'string')
	            this.cancelClass = this.cancelClass;
	        if (typeof this.dateLimit === 'object')
	            this.dateLimit = this.dateLimit;
	        if (typeof this.opens === 'string')
	            this.opens = this.opens;
	        if (typeof this.drops === 'string')
	            this.drops = this.drops;
	        if (typeof this.showWeekNumbers === 'boolean')
	            this.showWeekNumbers = this.showWeekNumbers;
	        if (typeof this.showISOWeekNumbers === 'boolean')
	            this.showISOWeekNumbers = this.showISOWeekNumbers;
	        if (typeof this.buttonClasses === 'string')
	            this.buttonClasses = this.buttonClasses;
	        if (typeof this.buttonClasses === 'object')
	            this.buttonClasses = this.buttonClasses.join(' ');
	        if (typeof this.showDropdowns === 'boolean')
	            this.showDropdowns = this.showDropdowns;
	        if (typeof this.showCustomRangeLabel === 'boolean')
	            this.showCustomRangeLabel = this.showCustomRangeLabel;
	        if (typeof this.singleDatePicker === 'boolean') {
	            this.singleDatePicker = this.singleDatePicker;
	            if (this.singleDatePicker)
	                this.endDate = this.startDate.clone();
	        }
	        if (typeof this.timePicker === 'boolean')
	            this.timePicker = this.timePicker;
	        if (typeof this.timePickerSeconds === 'boolean')
	            this.timePickerSeconds = this.timePickerSeconds;
	        if (typeof this.timePickerIncrement === 'number')
	            this.timePickerIncrement = this.timePickerIncrement;
	        if (typeof this.timePicker24Hour === 'boolean')
	            this.timePicker24Hour = this.timePicker24Hour;
	        if (typeof this.autoApply === 'boolean')
	            this.autoApply = this.autoApply;
	        if (typeof this.autoUpdateInput === 'boolean')
	            this.autoUpdateInput = this.autoUpdateInput;
	        if (typeof this.linkedCalendars === 'boolean')
	            this.linkedCalendars = this.linkedCalendars;
	        if (typeof this.isInvalidDate === 'function')
	            this.isInvalidDate = this.isInvalidDate;
	        if (typeof this.isCustomDate === 'function')
	            this.isCustomDate = this.isCustomDate;
	        if (typeof this.alwaysShowCalendars === 'boolean')
	            this.alwaysShowCalendars = this.alwaysShowCalendars;
	        if (this.locale.firstDay !== 0) {
	            var iterator = this.locale.firstDay;
	            while (iterator > 0) {
	                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
	                iterator--;
	            }
	        }
	    };
	    DateRangePickerComponent.prototype._processInitialValues = function () {
	        var start, end;
	        if (typeof this.startDate === 'undefined' && typeof this.endDate === 'undefined') {
	            if ($(this.element).is('input[type=text]')) {
	                var val = $(this.element).val(), split = val.split(this.locale.separator);
	                start = end = null;
	                if (split.length === 2) {
	                    start = moment(split[0], this.locale.format);
	                    end = moment(split[1], this.locale.format);
	                }
	                else if (this.singleDatePicker && val !== '') {
	                    start = moment(val, this.locale.format);
	                    end = moment(val, this.locale.format);
	                }
	                if (start !== null && end !== null) {
	                    this.setStartDate(start);
	                    this.setEndDate(end);
	                }
	            }
	        }
	        if (typeof this.ranges === 'object') {
	            for (var range in this.ranges) {
	                if (typeof this.ranges[range][0] === 'string') {
	                    start = moment(this.ranges[range][0], this.locale.format);
	                }
	                else {
	                    start = moment(this.ranges[range][0]);
	                }
	                if (typeof this.ranges[range][1] === 'string') {
	                    end = moment(this.ranges[range][1], this.locale.format);
	                }
	                else {
	                    end = moment(this.ranges[range][1]);
	                }
	                if (this.minDate && start.isBefore(this.minDate))
	                    start = this.minDate.clone();
	                var maxDate = this.maxDate;
	                if (this.dateLimit && maxDate && start.clone().add(this.dateLimit).isAfter(maxDate))
	                    maxDate = start.clone().add(this.dateLimit);
	                if (maxDate && end.isAfter(maxDate))
	                    end = maxDate.clone();
	                if ((this.minDate && end.isBefore(this.minDate, this.timePicker ? 'minute' : 'day'))
	                    || (maxDate && start.isAfter(maxDate, this.timePicker ? 'minute' : 'day')))
	                    continue;
	                var elem = document.createElement('textarea');
	                elem.innerHTML = range;
	                var rangeHtml = elem.value;
	                this.ranges[rangeHtml] = [start, end];
	            }
	            var list = '<ul>';
	            for (var range in this.ranges) {
	                list += '<li data-range-key="' + range + '">' + range + '</li>';
	            }
	            if (this.showCustomRangeLabel) {
	                list += '<li class="btn btn-sm" data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
	            }
	            list += '</ul>';
	            this.container.find('.ranges').prepend(list);
	        }
	    };
	    DateRangePickerComponent.prototype._processSingleDatePicker = function () {
	        if (this.singleDatePicker) {
	            this.container.addClass('single');
	            this.container.find('.calendar.left').addClass('single');
	            this.container.find('.calendar.left').show();
	            this.container.find('.calendar.right').hide();
	            this.container.find('.daterangepicker_input input, .daterangepicker_input > i').hide();
	            if (this.timePicker) {
	                this.container.find('.ranges ul').hide();
	            }
	            else {
	                this.container.find('.ranges').hide();
	            }
	        }
	    };
	    DateRangePickerComponent.prototype._processTimePicker = function () {
	        if (!this.timePicker) {
	            this.startDate = this.startDate.startOf('day');
	            this.endDate = this.endDate.endOf('day');
	            this.container.find('.calendar-time').hide();
	        }
	        if (this.timePicker && this.autoApply)
	            this.autoApply = false;
	    };
	    DateRangePickerComponent.prototype._processCssForLabelsAndButtons = function () {
	        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
	        if (this.applyClass.length)
	            this.container.find('.applyBtn').addClass(this.applyClass);
	        if (this.cancelClass.length)
	            this.container.find('.cancelBtn').addClass(this.cancelClass);
	        this.container.find('.applyBtn').html(this.locale.applyLabel);
	        this.container.find('.cancelBtn').html(this.locale.cancelLabel);
	    };
	    DateRangePickerComponent.prototype._processEventListeners = function () {
	        this.container.find('.calendar')
	            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
	            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
	            .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
	            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
	            .on('mouseleave.daterangepicker', 'td.available', $.proxy(this.updateFormInputs, this))
	            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
	            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
	            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this))
	            .on('click.daterangepicker', '.daterangepicker_input input', $.proxy(this.showCalendars, this))
	            .on('focus.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsFocused, this))
	            .on('blur.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsBlurred, this))
	            .on('change.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsChanged, this));
	        this.container.find('.ranges')
	            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
	            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))
	            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))
	            .on('mouseenter.daterangepicker', 'li', $.proxy(this.hoverRange, this))
	            .on('mouseleave.daterangepicker', 'li', $.proxy(this.updateFormInputs, this));
	        if (this.element.is('input') || this.element.is('button')) {
	            this.element.on({
	                'click.daterangepicker': $.proxy(this.show, this),
	                'focus.daterangepicker': $.proxy(this.show, this),
	                'keyup.daterangepicker': $.proxy(this.elementChanged, this),
	                'keydown.daterangepicker': $.proxy(this.keydown, this),
	            });
	        }
	        else {
	            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
	        }
	    };
	    DateRangePickerComponent.prototype._processInitialValue = function () {
	        if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
	            this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
	            this.element.trigger('change');
	        }
	        else if (this.element.is('input') && this.autoUpdateInput) {
	            this.element.val(this.startDate.format(this.locale.format));
	            this.element.trigger('change');
	        }
	    };
	    DateRangePickerComponent.prototype.setStartDate = function (startDate) {
	        if (typeof startDate === 'string')
	            this.startDate = moment(startDate, this.locale.format);
	        if (typeof startDate === 'object')
	            this.startDate = moment(startDate);
	        if (!this.timePicker)
	            this.startDate = this.startDate.startOf('day');
	        if (this.timePicker && this.timePickerIncrement)
	            this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	        if (this.minDate && this.startDate.isBefore(this.minDate)) {
	            this.startDate = this.minDate;
	            if (this.timePicker && this.timePickerIncrement)
	                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	        }
	        if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
	            this.startDate = this.maxDate;
	            if (this.timePicker && this.timePickerIncrement)
	                this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	        }
	        if (!this.isShowing)
	            this.updateElement();
	        this.updateMonthsInView();
	    };
	    ;
	    DateRangePickerComponent.prototype.setEndDate = function (endDate) {
	        if (typeof endDate === 'string')
	            this.endDate = moment(endDate, this.locale.format);
	        if (typeof endDate === 'object')
	            this.endDate = moment(endDate);
	        if (!this.timePicker)
	            this.endDate = this.endDate.endOf('day');
	        if (this.timePicker && this.timePickerIncrement)
	            this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	        if (this.endDate.isBefore(this.startDate))
	            this.endDate = this.startDate.clone();
	        if (this.maxDate && this.endDate.isAfter(this.maxDate))
	            this.endDate = this.maxDate;
	        if (this.dateLimit && this.startDate.clone().add(this.dateLimit).isBefore(this.endDate))
	            this.endDate = this.startDate.clone().add(this.dateLimit);
	        this.previousRightTime = this.endDate.clone();
	        if (!this.isShowing)
	            this.updateElement();
	        this.updateMonthsInView();
	    };
	    ;
	    DateRangePickerComponent.prototype.isInvalidDate = function (options) {
	        return false;
	    };
	    DateRangePickerComponent.prototype.isCustomDate = function (options) {
	        return false;
	    };
	    ;
	    DateRangePickerComponent.prototype.updateView = function () {
	        if (this.timePicker) {
	            this.renderTimePicker('left');
	            this.renderTimePicker('right');
	            if (!this.endDate) {
	                this.container.find('.right .calendar-time select').attr('disabled', 'disabled').addClass('disabled');
	            }
	            else {
	                this.container.find('.right .calendar-time select').removeAttr('disabled').removeClass('disabled');
	            }
	        }
	        if (this.endDate) {
	            this.container.find('input[name="daterangepicker_end"]').removeClass('active');
	            this.container.find('input[name="daterangepicker_start"]').addClass('active');
	        }
	        else {
	            this.container.find('input[name="daterangepicker_end"]').addClass('active');
	            this.container.find('input[name="daterangepicker_start"]').removeClass('active');
	        }
	        this.updateMonthsInView();
	        this.updateCalendars();
	        this.updateFormInputs();
	    };
	    DateRangePickerComponent.prototype.updateMonthsInView = function () {
	        if (this.endDate) {
	            if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
	                (this.startDate.format('YYYY-MM') === this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') === this.rightCalendar.month.format('YYYY-MM'))
	                &&
	                    (this.endDate.format('YYYY-MM') === this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') === this.rightCalendar.month.format('YYYY-MM'))) {
	                return;
	            }
	            this.leftCalendar.month = this.startDate.clone().date(2);
	            if (!this.linkedCalendars && (this.endDate.month() !== this.startDate.month() || this.endDate.year() !== this.startDate.year())) {
	                this.rightCalendar.month = this.endDate.clone().date(2);
	            }
	            else {
	                this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
	            }
	        }
	        else {
	            if (this.leftCalendar.month.format('YYYY-MM') !== this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') !== this.startDate.format('YYYY-MM')) {
	                this.leftCalendar.month = this.startDate.clone().date(2);
	                this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
	            }
	        }
	        if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
	            this.rightCalendar.month = this.maxDate.clone().date(2);
	            this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
	        }
	    };
	    DateRangePickerComponent.prototype.updateCalendars = function () {
	        if (this.timePicker) {
	            var hour, minute, second;
	            if (this.endDate) {
	                hour = parseInt(this.container.find('.left .hourselect').val(), 10);
	                minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
	                second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
	                if (!this.timePicker24Hour) {
	                    var ampm = this.container.find('.left .ampmselect').val();
	                    if (ampm === 'PM' && hour < 12)
	                        hour += 12;
	                    if (ampm === 'AM' && hour === 12)
	                        hour = 0;
	                }
	            }
	            else {
	                hour = parseInt(this.container.find('.right .hourselect').val(), 10);
	                minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
	                second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
	                if (!this.timePicker24Hour) {
	                    var ampm = this.container.find('.right .ampmselect').val();
	                    if (ampm === 'PM' && hour < 12)
	                        hour += 12;
	                    if (ampm === 'AM' && hour === 12)
	                        hour = 0;
	                }
	            }
	            this.leftCalendar.month.hour(hour).minute(minute).second(second);
	            this.rightCalendar.month.hour(hour).minute(minute).second(second);
	        }
	        this.renderCalendar('left');
	        this.renderCalendar('right');
	        this.container.find('.ranges li').removeClass('active');
	        if (this.endDate == null)
	            return;
	        this.calculateChosenLabel();
	    };
	    DateRangePickerComponent.prototype.renderCalendar = function (side) {
	        var calendar = side === 'left' ? this.leftCalendar : this.rightCalendar;
	        var month = calendar.month.month();
	        var year = calendar.month.year();
	        var hour = calendar.month.hour();
	        var minute = calendar.month.minute();
	        var second = calendar.month.second();
	        var daysInMonth = moment([year, month]).daysInMonth();
	        var firstDay = moment([year, month, 1]);
	        var lastDay = moment([year, month, daysInMonth]);
	        var lastMonth = moment(firstDay).subtract(1, 'month').month();
	        var lastYear = moment(firstDay).subtract(1, 'month').year();
	        var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
	        var dayOfWeek = firstDay.day();
	        calendar.firstDay = firstDay;
	        calendar.lastDay = lastDay;
	        for (var i = 0; i < 6; i++) {
	            calendar[i] = [];
	        }
	        var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
	        if (startDay > daysInLastMonth)
	            startDay -= 7;
	        if (dayOfWeek === this.locale.firstDay)
	            startDay = daysInLastMonth - 6;
	        var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);
	        for (var i_1 = 0, col = 0, row = 0; i_1 < 42; i_1++, col++, curDate = moment(curDate).add(24, 'hour')) {
	            if (i_1 > 0 && col % 7 === 0) {
	                col = 0;
	                row++;
	            }
	            calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
	            curDate.hour(12);
	            if (this.minDate && calendar[row][col].format('YYYY-MM-DD') === this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side === 'left') {
	                calendar[row][col] = this.minDate.clone();
	            }
	            if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') === this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side === 'right') {
	                calendar[row][col] = this.maxDate.clone();
	            }
	        }
	        if (side === 'left') {
	            this.leftCalendar.calendar = calendar;
	        }
	        else {
	            this.rightCalendar.calendar = calendar;
	        }
	        var minDate = side === 'left' ? this.minDate : this.startDate;
	        var maxDate = this.maxDate;
	        var arrow = this.locale.direction === 'ltr' ? { left: 'chevron-left', right: 'chevron-right' } : { left: 'chevron-right', right: 'chevron-left' };
	        var html = '<table class="table-condensed">';
	        html += '<thead>';
	        html += '<tr>';
	        if (this.showWeekNumbers || this.showISOWeekNumbers)
	            html += '<th></th>';
	        if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side === 'left')) {
	            html += '<th class="prev available"><i class="zmdi zmdi-' + arrow.left + '"></i></th>';
	        }
	        else {
	            html += '<th></th>';
	        }
	        var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format('YYYY');
	        if (this.showDropdowns) {
	            var currentMonth = calendar[1][1].month();
	            var currentYear = calendar[1][1].year();
	            var maxYear = (maxDate && maxDate.year()) || (currentYear + 5);
	            var minYear = (minDate && minDate.year()) || (currentYear - 50);
	            var inMinYear = currentYear === minYear;
	            var inMaxYear = currentYear === maxYear;
	            var monthHtml = '<select class="monthselect">';
	            for (var m = 0; m < 12; m++) {
	                if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
	                    monthHtml += '<option value="' + m + '"' +
	                        (m === currentMonth ? ' selected="selected"' : '') +
	                        '>' + this.locale.monthNames[m] + '</option>';
	                }
	                else {
	                    monthHtml += '<option value="' + m + '"' +
	                        (m === currentMonth ? ' selected="selected"' : '') +
	                        ' disabled="disabled">' + this.locale.monthNames[m] + '</option>';
	                }
	            }
	            monthHtml += '</select>';
	            var yearHtml = '<select class="yearselect">';
	            for (var y = minYear; y <= maxYear; y++) {
	                yearHtml += '<option value="' + y + '"' +
	                    (y === currentYear ? ' selected="selected"' : '') +
	                    '>' + y + '</option>';
	            }
	            yearHtml += '</select>';
	            dateHtml = monthHtml + yearHtml;
	        }
	        html += '<th colspan="5" class="month">' + dateHtml + '</th>';
	        if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side === 'right' || this.singleDatePicker)) {
	            html += '<th class="next available"><i class="zmdi zmdi-' + arrow.right + '"></i></th>';
	        }
	        else {
	            html += '<th></th>';
	        }
	        html += '</tr>';
	        html += '<tr>';
	        if (this.showWeekNumbers || this.showISOWeekNumbers)
	            html += '<th class="week">' + this.locale.weekLabel + '</th>';
	        $.each(this.locale.daysOfWeek, function (index, dayOfWeek) {
	            html += '<th>' + dayOfWeek + '</th>';
	        });
	        html += '</tr>';
	        html += '</thead>';
	        html += '<tbody>';
	        if (this.endDate == null && this.dateLimit) {
	            var maxLimit = this.startDate.clone().add(this.dateLimit).endOf('day');
	            if (!maxDate || maxLimit.isBefore(maxDate)) {
	                maxDate = maxLimit;
	            }
	        }
	        for (var row = 0; row < 6; row++) {
	            html += '<tr>';
	            if (this.showWeekNumbers) {
	                html += '<td class="week">' + calendar[row][0].week() + '</td>';
	            }
	            else if (this.showISOWeekNumbers)
	                html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';
	            for (var col = 0; col < 7; col++) {
	                var classes = new Array();
	                if (calendar[row][col].isSame(new Date(), 'day'))
	                    classes.push('today');
	                if (calendar[row][col].isoWeekday() > 5)
	                    classes.push('weekend');
	                if (calendar[row][col].month() !== calendar[1][1].month())
	                    classes.push('off');
	                if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
	                    classes.push('off', 'disabled');
	                if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
	                    classes.push('off', 'disabled');
	                if (this.isInvalidDate(calendar[row][col]))
	                    classes.push('off', 'disabled');
	                if (calendar[row][col].format('YYYY-MM-DD') === this.startDate.format('YYYY-MM-DD'))
	                    classes.push('active', 'start-date');
	                if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') === this.endDate.format('YYYY-MM-DD'))
	                    classes.push('active', 'end-date');
	                if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
	                    classes.push('in-range');
	                var isCustom = this.isCustomDate(calendar[row][col]);
	                if (isCustom !== false) {
	                    if (typeof isCustom === 'string') {
	                        classes.push(String(isCustom));
	                    }
	                    else
	                        Array.prototype.push.apply(classes, isCustom);
	                }
	                var cname = '', disabled = false;
	                for (var i = 0; i < classes.length; i++) {
	                    cname += classes[i] + ' ';
	                    if (classes[i] === 'disabled')
	                        disabled = true;
	                }
	                if (!disabled)
	                    cname += 'available';
	                html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';
	            }
	            html += '</tr>';
	        }
	        html += '</tbody>';
	        html += '</table>';
	        this.container.find('.calendar.' + side + ' .calendar-table').html(html);
	    };
	    DateRangePickerComponent.prototype.renderTimePicker = function (side) {
	        if (side === 'right' && !this.endDate)
	            return;
	        var html, selected, minDate, maxDate = this.maxDate;
	        if (this.dateLimit && (!this.maxDate || this.startDate.clone().add(this.dateLimit).isAfter(this.maxDate)))
	            maxDate = this.startDate.clone().add(this.dateLimit);
	        if (side === 'left') {
	            selected = this.startDate.clone();
	            minDate = this.minDate;
	        }
	        else if (side === 'right') {
	            selected = this.endDate.clone();
	            minDate = this.startDate;
	            var timeSelector = this.container.find('.calendar.right .calendar-time div');
	            if (!this.endDate && timeSelector.html() !== '') {
	                selected.hour(timeSelector.find('.hourselect option:selected').val() || selected.hour());
	                selected.minute(timeSelector.find('.minuteselect option:selected').val() || selected.minute());
	                selected.second(timeSelector.find('.secondselect option:selected').val() || selected.second());
	                if (!this.timePicker24Hour) {
	                    var ampm = timeSelector.find('.ampmselect option:selected').val();
	                    if (ampm === 'PM' && selected.hour() < 12)
	                        selected.hour(selected.hour() + 12);
	                    if (ampm === 'AM' && selected.hour() === 12)
	                        selected.hour(0);
	                }
	            }
	            if (selected.isBefore(this.startDate))
	                selected = this.startDate.clone();
	            if (maxDate && selected.isAfter(maxDate))
	                selected = maxDate.clone();
	        }
	        html = '<select class="hourselect">';
	        var start = this.timePicker24Hour ? 0 : 1;
	        var end = this.timePicker24Hour ? 23 : 12;
	        for (var i = start; i <= end; i++) {
	            var i_in_24 = i;
	            if (!this.timePicker24Hour)
	                i_in_24 = selected.hour() >= 12 ? (i === 12 ? 12 : i + 12) : (i === 12 ? 0 : i);
	            var time = selected.clone().hour(i_in_24);
	            var disabled = false;
	            if (minDate && time.minute(59).isBefore(minDate))
	                disabled = true;
	            if (maxDate && time.minute(0).isAfter(maxDate))
	                disabled = true;
	            if (i_in_24 === selected.hour() && !disabled) {
	                html += '<option value="' + i + '" selected="selected">' + i + '</option>';
	            }
	            else if (disabled) {
	                html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
	            }
	            else {
	                html += '<option value="' + i + '">' + i + '</option>';
	            }
	        }
	        html += '</select> ';
	        html += ': <select class="minuteselect">';
	        for (var i = 0; i < 60; i += this.timePickerIncrement) {
	            var padded = i < 10 ? '0' + i : i;
	            var time = selected.clone().minute(i);
	            var disabled = false;
	            if (minDate && time.second(59).isBefore(minDate))
	                disabled = true;
	            if (maxDate && time.second(0).isAfter(maxDate))
	                disabled = true;
	            if (selected.minute() === i && !disabled) {
	                html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
	            }
	            else if (disabled) {
	                html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
	            }
	            else {
	                html += '<option value="' + i + '">' + padded + '</option>';
	            }
	        }
	        html += '</select> ';
	        if (this.timePickerSeconds) {
	            html += ': <select class="secondselect">';
	            for (var i = 0; i < 60; i++) {
	                var padded = i < 10 ? '0' + i : i;
	                var time = selected.clone().second(i);
	                var disabled = false;
	                if (minDate && time.isBefore(minDate))
	                    disabled = true;
	                if (maxDate && time.isAfter(maxDate))
	                    disabled = true;
	                if (selected.second() === i && !disabled) {
	                    html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
	                }
	                else if (disabled) {
	                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
	                }
	                else {
	                    html += '<option value="' + i + '">' + padded + '</option>';
	                }
	            }
	            html += '</select> ';
	        }
	        if (!this.timePicker24Hour) {
	            html += '<select class="ampmselect">';
	            var am_html = '';
	            var pm_html = '';
	            if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
	                am_html = ' disabled="disabled" class="disabled"';
	            if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
	                pm_html = ' disabled="disabled" class="disabled"';
	            if (selected.hour() >= 12) {
	                html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
	            }
	            else {
	                html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
	            }
	            html += '</select>';
	        }
	        this.container.find('.calendar.' + side + ' .calendar-time div').html(html);
	    };
	    DateRangePickerComponent.prototype.updateFormInputs = function () {
	        if (this.container.find('input[name=daterangepicker_start]').is(':focus') || this.container.find('input[name=daterangepicker_end]').is(':focus'))
	            return;
	        this.container.find('input[name=daterangepicker_start]').val(this.startDate.format(this.locale.format));
	        if (this.endDate)
	            this.container.find('input[name=daterangepicker_end]').val(this.endDate.format(this.locale.format));
	        if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
	            this.container.find('button.applyBtn').removeAttr('disabled');
	        }
	        else {
	            this.container.find('button.applyBtn').attr('disabled', 'disabled');
	        }
	    };
	    DateRangePickerComponent.prototype.move = function () {
	        var parentOffset = { top: 0, left: 0 }, containerTop;
	        var parentRightEdge = $(window).width();
	        if (!this.parentEl.is('body')) {
	            parentOffset = {
	                top: this.parentEl.offset().top - this.parentEl.scrollTop(),
	                left: this.parentEl.offset().left - this.parentEl.scrollLeft(),
	            };
	            parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
	        }
	        if (this.drops === 'up') {
	            containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
	        }
	        else {
	            containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
	        }
	        this.container[this.drops === 'up' ? 'addClass' : 'removeClass']('dropup');
	        if (this.opens === 'left') {
	            this.container.css({
	                top: containerTop,
	                right: parentRightEdge - this.element.offset().left - this.element.outerWidth(),
	                left: 'auto',
	            });
	            if (this.container.offset().left < 0) {
	                this.container.css({
	                    right: 'auto',
	                    left: 9,
	                });
	            }
	        }
	        else if (this.opens === 'center') {
	            this.container.css({
	                top: containerTop,
	                left: this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
	                    - this.container.outerWidth() / 2,
	                right: 'auto',
	            });
	            if (this.container.offset().left < 0) {
	                this.container.css({
	                    right: 'auto',
	                    left: 9,
	                });
	            }
	        }
	        else {
	            this.container.css({
	                top: containerTop,
	                left: this.element.offset().left - parentOffset.left,
	                right: 'auto',
	            });
	            if (this.container.offset().left + this.container.outerWidth() > $(window).width()) {
	                this.container.css({
	                    left: 'auto',
	                    right: 0,
	                });
	            }
	        }
	    };
	    DateRangePickerComponent.prototype.show = function (e) {
	        if (this.isShowing)
	            return;
	        this._outsideClickProxy = $.proxy(function (e) { this.outsideClick(e); }, this);
	        $(document)
	            .on('mousedown.daterangepicker', this._outsideClickProxy)
	            .on('touchend.daterangepicker', this._outsideClickProxy)
	            .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
	            .on('focusin.daterangepicker', this._outsideClickProxy);
	        $(window).on('resize.daterangepicker', $.proxy(function (e) { this.move(e); }, this));
	        this.oldStartDate = this.startDate.clone();
	        this.oldEndDate = this.endDate.clone();
	        this.previousRightTime = this.endDate.clone();
	        this.updateView();
	        this.container.show();
	        this.move();
	        this.element.trigger('show.daterangepicker', this);
	        this.isShowing = true;
	    };
	    DateRangePickerComponent.prototype.hide = function (e) {
	        if (!this.isShowing)
	            return;
	        if (!this.endDate) {
	            this.startDate = this.oldStartDate.clone();
	            this.endDate = this.oldEndDate.clone();
	        }
	        if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
	            this.callback(this.startDate, this.endDate, this.chosenLabel);
	        this.updateElement();
	        $(document).off('.daterangepicker');
	        $(window).off('.daterangepicker');
	        this.container.hide();
	        this.element.trigger('hide.daterangepicker', this);
	        this.isShowing = false;
	    };
	    DateRangePickerComponent.prototype.toggle = function (e) {
	        if (this.isShowing) {
	            this.hide();
	        }
	        else {
	            this.show();
	        }
	    };
	    DateRangePickerComponent.prototype.outsideClick = function (e) {
	        var target = $(e.target);
	        if (e.type === 'focusin' ||
	            target.closest(this.element).length ||
	            target.closest(this.container).length ||
	            target.closest('.calendar-table').length)
	            return;
	        this.hide();
	        this.element.trigger('outsideClick.daterangepicker', this);
	    };
	    DateRangePickerComponent.prototype.showCalendars = function () {
	        this.container.addClass('show-calendar');
	        this.move();
	        this.element.trigger('showCalendar.daterangepicker', this);
	    };
	    DateRangePickerComponent.prototype.hideCalendars = function () {
	        this.container.removeClass('show-calendar');
	        this.element.trigger('hideCalendar.daterangepicker', this);
	    };
	    DateRangePickerComponent.prototype.hoverRange = function (e) {
	        if (this.container.find('input[name=daterangepicker_start]').is(':focus') || this.container.find('input[name=daterangepicker_end]').is(':focus'))
	            return;
	        var label = e.target.getAttribute('data-range-key');
	        if (label === this.locale.customRangeLabel) {
	            this.updateView();
	        }
	        else {
	            var dates = this.ranges[label];
	            this.container.find('input[name=daterangepicker_start]').val(dates[0].format(this.locale.format));
	            this.container.find('input[name=daterangepicker_end]').val(dates[1].format(this.locale.format));
	        }
	    };
	    DateRangePickerComponent.prototype.clickRange = function (e) {
	        var label = e.target.getAttribute('data-range-key');
	        this.chosenLabel = label;
	        if (label === this.locale.customRangeLabel) {
	            this.showCalendars();
	        }
	        else {
	            var dates = this.ranges[label];
	            this.startDate = dates[0];
	            this.endDate = dates[1];
	            if (!this.timePicker) {
	                this.startDate.startOf('day');
	                this.endDate.endOf('day');
	            }
	            if (!this.alwaysShowCalendars)
	                this.hideCalendars();
	            this.clickApply();
	        }
	    };
	    DateRangePickerComponent.prototype.clickPrev = function (e) {
	        var cal = $(e.target).parents('.calendar');
	        if (cal.hasClass('left')) {
	            this.leftCalendar.month.subtract(1, 'month');
	            if (this.linkedCalendars)
	                this.rightCalendar.month.subtract(1, 'month');
	        }
	        else {
	            this.rightCalendar.month.subtract(1, 'month');
	        }
	        this.updateCalendars();
	    };
	    DateRangePickerComponent.prototype.clickNext = function (e) {
	        var cal = $(e.target).parents('.calendar');
	        if (cal.hasClass('left')) {
	            this.leftCalendar.month.add(1, 'month');
	        }
	        else {
	            this.rightCalendar.month.add(1, 'month');
	            if (this.linkedCalendars)
	                this.leftCalendar.month.add(1, 'month');
	        }
	        this.updateCalendars();
	    };
	    DateRangePickerComponent.prototype.hoverDate = function (e) {
	        if (!$(e.target).hasClass('available'))
	            return;
	        var title = $(e.target).attr('data-title');
	        var row = title.substr(1, 1);
	        var col = title.substr(3, 1);
	        var cal = $(e.target).parents('.calendar');
	        var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
	        if (this.endDate && !this.container.find('input[name=daterangepicker_start]').is(':focus')) {
	            this.container.find('input[name=daterangepicker_start]').val(date.format(this.locale.format));
	        }
	        else if (!this.endDate && !this.container.find('input[name=daterangepicker_end]').is(':focus')) {
	            this.container.find('input[name=daterangepicker_end]').val(date.format(this.locale.format));
	        }
	        var leftCalendar = this.leftCalendar;
	        var rightCalendar = this.rightCalendar;
	        var startDate = this.startDate;
	        if (!this.endDate) {
	            this.container.find('.calendar td').each(function (index, el) {
	                if ($(el).hasClass('week'))
	                    return;
	                var title = $(el).attr('data-title');
	                var row = title.substr(1, 1);
	                var col = title.substr(3, 1);
	                var cal = $(el).parents('.calendar');
	                var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];
	                if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
	                    $(el).addClass('in-range');
	                }
	                else {
	                    $(el).removeClass('in-range');
	                }
	            });
	        }
	    };
	    DateRangePickerComponent.prototype.clickDate = function (e) {
	        if (!$(e.target).hasClass('available'))
	            return;
	        var title = $(e.target).attr('data-title');
	        var row = title.substr(1, 1);
	        var col = title.substr(3, 1);
	        var cal = $(e.target).parents('.calendar');
	        var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
	        if (this.endDate || date.isBefore(this.startDate, 'day')) {
	            if (this.timePicker) {
	                var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
	                if (!this.timePicker24Hour) {
	                    var ampm = this.container.find('.left .ampmselect').val();
	                    if (ampm === 'PM' && hour < 12)
	                        hour += 12;
	                    if (ampm === 'AM' && hour === 12)
	                        hour = 0;
	                }
	                var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
	                var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
	                date = date.clone().hour(hour).minute(minute).second(second);
	            }
	            this.endDate = null;
	            this.setStartDate(date.clone());
	        }
	        else if (!this.endDate && date.isBefore(this.startDate)) {
	            this.setEndDate(this.startDate.clone());
	        }
	        else {
	            if (this.timePicker) {
	                var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
	                if (!this.timePicker24Hour) {
	                    var ampm = this.container.find('.right .ampmselect').val();
	                    if (ampm === 'PM' && hour < 12)
	                        hour += 12;
	                    if (ampm === 'AM' && hour === 12)
	                        hour = 0;
	                }
	                var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
	                var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
	                date = date.clone().hour(hour).minute(minute).second(second);
	            }
	            this.setEndDate(date.clone());
	            if (this.autoApply) {
	                this.calculateChosenLabel();
	                this.clickApply();
	            }
	        }
	        if (this.singleDatePicker) {
	            this.setEndDate(this.startDate);
	            if (!this.timePicker)
	                this.clickApply();
	        }
	        this.updateView();
	        e.stopPropagation();
	    };
	    DateRangePickerComponent.prototype.calculateChosenLabel = function () {
	        var customRange = true;
	        var i = 0;
	        for (var range in this.ranges) {
	            if (this.timePicker) {
	                if (this.startDate.isSame(this.ranges[range][0]) && this.endDate.isSame(this.ranges[range][1])) {
	                    customRange = false;
	                    this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
	                    break;
	                }
	            }
	            else {
	                if (this.startDate.format('YYYY-MM-DD') === this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') === this.ranges[range][1].format('YYYY-MM-DD')) {
	                    customRange = false;
	                    this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
	                    break;
	                }
	            }
	            i++;
	        }
	        if (customRange && this.showCustomRangeLabel) {
	            this.chosenLabel = this.container.find('.ranges li:last').addClass('active').html();
	            this.showCalendars();
	        }
	    };
	    DateRangePickerComponent.prototype.clickApply = function (e) {
	        this.hide();
	        this.element.trigger('apply.daterangepicker', this);
	        this.updateControlValue();
	    };
	    DateRangePickerComponent.prototype.updateControlValue = function () {
	        var startDate = this.startDate.format(this.locale.format);
	        var endDate = this.endDate.format(this.locale.format);
	        this.control.setValue(startDate + " - " + endDate);
	        this.rangeChanged.emit(new date_range_1.DateRange(this.startDate.clone(), this.endDate.clone()));
	    };
	    DateRangePickerComponent.prototype.clickCancel = function (e) {
	        this.startDate = this.oldStartDate;
	        this.endDate = this.oldEndDate;
	        this.hide();
	        this.element.trigger('cancel.daterangepicker', this);
	    };
	    DateRangePickerComponent.prototype.monthOrYearChanged = function (e) {
	        var isLeft = $(e.target).closest('.calendar').hasClass('left'), leftOrRight = isLeft ? 'left' : 'right', cal = this.container.find('.calendar.' + leftOrRight);
	        var month = parseInt(cal.find('.monthselect').val(), 10);
	        var year = cal.find('.yearselect').val();
	        if (!isLeft) {
	            if (year < this.startDate.year() || (year === this.startDate.year() && month < this.startDate.month())) {
	                month = this.startDate.month();
	                year = this.startDate.year();
	            }
	        }
	        if (this.minDate) {
	            if (year < this.minDate.year() || (year === this.minDate.year() && month < this.minDate.month())) {
	                month = this.minDate.month();
	                year = this.minDate.year();
	            }
	        }
	        if (this.maxDate) {
	            if (year > this.maxDate.year() || (year === this.maxDate.year() && month > this.maxDate.month())) {
	                month = this.maxDate.month();
	                year = this.maxDate.year();
	            }
	        }
	        if (isLeft) {
	            this.leftCalendar.month.month(month).year(year);
	            if (this.linkedCalendars)
	                this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
	        }
	        else {
	            this.rightCalendar.month.month(month).year(year);
	            if (this.linkedCalendars)
	                this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
	        }
	        this.updateCalendars();
	    };
	    DateRangePickerComponent.prototype.timeChanged = function (e) {
	        var cal = $(e.target).closest('.calendar'), isLeft = cal.hasClass('left');
	        var hour = parseInt(cal.find('.hourselect').val(), 10);
	        var minute = parseInt(cal.find('.minuteselect').val(), 10);
	        var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;
	        if (!this.timePicker24Hour) {
	            var ampm = cal.find('.ampmselect').val();
	            if (ampm === 'PM' && hour < 12)
	                hour += 12;
	            if (ampm === 'AM' && hour === 12)
	                hour = 0;
	        }
	        if (isLeft) {
	            var start = this.startDate.clone();
	            start.hour(hour);
	            start.minute(minute);
	            start.second(second);
	            this.setStartDate(start);
	            if (this.singleDatePicker) {
	                this.endDate = this.startDate.clone();
	            }
	            else if (this.endDate && this.endDate.format('YYYY-MM-DD') === start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
	                this.setEndDate(start.clone());
	            }
	        }
	        else if (this.endDate) {
	            var end = this.endDate.clone();
	            end.hour(hour);
	            end.minute(minute);
	            end.second(second);
	            this.setEndDate(end);
	        }
	        this.updateCalendars();
	        this.updateFormInputs();
	        this.renderTimePicker('left');
	        this.renderTimePicker('right');
	    };
	    DateRangePickerComponent.prototype.formInputsChanged = function (e) {
	        var isRight = $(e.target).closest('.calendar').hasClass('right');
	        var start = moment(this.container.find('input[name="daterangepicker_start"]').val(), this.locale.format);
	        var end = moment(this.container.find('input[name="daterangepicker_end"]').val(), this.locale.format);
	        if (start.isValid() && end.isValid()) {
	            if (isRight && end.isBefore(start))
	                start = end.clone();
	            this.setStartDate(start);
	            this.setEndDate(end);
	            if (isRight) {
	                this.container.find('input[name="daterangepicker_start"]').val(this.startDate.format(this.locale.format));
	            }
	            else {
	                this.container.find('input[name="daterangepicker_end"]').val(this.endDate.format(this.locale.format));
	            }
	        }
	        this.updateView();
	    };
	    DateRangePickerComponent.prototype.formInputsFocused = function (e) {
	        this.container.find('input[name="daterangepicker_start"], input[name="daterangepicker_end"]').removeClass('active');
	        $(e.target).addClass('active');
	        var isRight = $(e.target).closest('.calendar').hasClass('right');
	        if (isRight) {
	            this.endDate = null;
	            this.setStartDate(this.startDate.clone());
	            this.updateView();
	        }
	    };
	    DateRangePickerComponent.prototype.formInputsBlurred = function (e) {
	        if (!this.endDate) {
	            var val = this.container.find('input[name="daterangepicker_end"]').val();
	            var end = moment(val, this.locale.format);
	            if (end.isValid()) {
	                this.setEndDate(end);
	                this.updateView();
	            }
	        }
	    };
	    DateRangePickerComponent.prototype.elementChanged = function () {
	        if (!this.element.is('input'))
	            return;
	        if (!this.element.val().length)
	            return;
	        if (this.element.val().length < this.locale.format.length)
	            return;
	        var dateString = this.element.val().split(this.locale.separator), start = null, end = null;
	        if (dateString.length === 2) {
	            start = moment(dateString[0], this.locale.format);
	            end = moment(dateString[1], this.locale.format);
	        }
	        if (this.singleDatePicker || start === null || end === null) {
	            start = moment(this.element.val(), this.locale.format);
	            end = start;
	        }
	        if (!start.isValid() || !end.isValid())
	            return;
	        this.setStartDate(start);
	        this.setEndDate(end);
	        this.updateView();
	    };
	    DateRangePickerComponent.prototype.keydown = function (e) {
	        if ((e.keyCode === 9) || (e.keyCode === 13)) {
	            this.hide();
	        }
	    };
	    DateRangePickerComponent.prototype.updateElement = function () {
	        if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
	            this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
	            this.element.trigger('change');
	        }
	        else if (this.element.is('input') && this.autoUpdateInput) {
	            this.element.val(this.startDate.format(this.locale.format));
	            this.element.trigger('change');
	        }
	    };
	    DateRangePickerComponent.prototype.remove = function () {
	        this.container.remove();
	        this.element.off('.daterangepicker');
	        this.element.removeData();
	    };
	    return DateRangePickerComponent;
	}(input_base_component_1.InputBase));
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], DateRangePickerComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], DateRangePickerComponent.prototype, "placeholder", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], DateRangePickerComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], DateRangePickerComponent.prototype, "label", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateRangePickerComponent.prototype, "parentEl", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateRangePickerComponent.prototype, "startDate", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateRangePickerComponent.prototype, "endDate", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateRangePickerComponent.prototype, "minDate", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateRangePickerComponent.prototype, "maxDate", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateRangePickerComponent.prototype, "dateLimit", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateRangePickerComponent.prototype, "autoApply", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateRangePickerComponent.prototype, "singleDatePicker", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateRangePickerComponent.prototype, "showDropdowns", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateRangePickerComponent.prototype, "showWeekNumbers", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateRangePickerComponent.prototype, "showISOWeekNumbers", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateRangePickerComponent.prototype, "showCustomRangeLabel", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateRangePickerComponent.prototype, "timePicker", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateRangePickerComponent.prototype, "timePicker24Hour", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], DateRangePickerComponent.prototype, "timePickerIncrement", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateRangePickerComponent.prototype, "timePickerSeconds", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateRangePickerComponent.prototype, "linkedCalendars", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateRangePickerComponent.prototype, "autoUpdateInput", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateRangePickerComponent.prototype, "alwaysShowCalendars", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateRangePickerComponent.prototype, "ranges", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], DateRangePickerComponent.prototype, "buttonClasses", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], DateRangePickerComponent.prototype, "applyClass", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], DateRangePickerComponent.prototype, "cancelClass", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateRangePickerComponent.prototype, "template", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateRangePickerComponent.prototype, "locale", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], DateRangePickerComponent.prototype, "opens", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], DateRangePickerComponent.prototype, "drops", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], DateRangePickerComponent.prototype, "rangeChanged", void 0);
	DateRangePickerComponent = __decorate([
	    core_1.Component({
	        selector: 'date-range-picker',
	        template: "\n      <div class=\"input-group m-b-15 w-100\" [class.fg-float]=\"floatingLabel\" [class.fc-alt]=\"alt\" [ngClass]=\"{ 'has-error': !control.valid &amp;&amp; (fg.submitted || control.dirty)}\"><label *ngIf=\"label &amp;&amp; !floatingLabel\">{{label}}</label><span class=\"input-group-addon\" *ngIf=\"leftIcon\"><i class=\"zmdi zmdi-{{leftIcon}}\"></i></span><div class=\"fg-line\" [class.disabled]=\"disabled\" [class.fg-toggled]=\"toggled\"><input class=\"form-control\" #i [type]=\"inputType\" placeholder=\"{{placeholder}}\" [formControl]=\"control\" [disabled]=\"disabled\" (focus)=\"onFocus(i)\" (blur)=\"onBlur(i)\"><label class=\"fg-label\" *ngIf=\"label &amp;&amp; floatingLabel\">{{label}}</label></div><span class=\"input-group-addon last\" *ngIf=\"rightIcon\"><i class=\"zmdi zmdi-{{rightIcon}}\"></i></span><div *ngIf=\"!control.valid &amp;&amp; (control.dirty || fg.submitted)\"><small class=\"help-block animated fadeInDown\" *ngFor=\"let v of validations\" [class.hidden]=\"!control.errors[v.type]\">{{v.message}}</small></div></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], DateRangePickerComponent);
	exports.DateRangePickerComponent = DateRangePickerComponent;


/***/ },
/* 48 */
/***/ function(module, exports) {

	"use strict";
	exports.pickerTemplate = "\n\n<div class=\"daterangepicker dropdown-menu\">\n    <div class=\"calendar left\">\n\n        <div class=\"daterangepicker_input input-group form-group\">\n            <span class=\"input-group-addon\">\n                <i class=\"zmdi zmdi-calendar\"></i>\n                <div class=\"calendar-time\">\n                    <div></div>\n                    <i class=\"zmdi zmdi-time\"></i>\n                </div>\n            </span>\n            <div class=\"dtp-container fg-line\">\n                <input class=\"form-control\" type=\"text\" name=\"daterangepicker_start\">\n            </div>\n        </div>\n\n        <div class=\"calendar-table\"></div>\n    </div>\n    <div class=\"calendar right\">\n\n        <div class=\"daterangepicker_input input-group form-group\">\n            <span class=\"input-group-addon\">\n                <i class=\"zmdi zmdi-calendar\"></i>\n                <div class=\"calendar-time\">\n                    <div></div>\n                    <i class=\"zmdi zmdi-time\"></i>\n                </div>\n            </span>\n            <div class=\"dtp-container fg-line\">\n                <input class=\"form-control\" type=\"text\" name=\"daterangepicker_end\">\n            </div>\n        </div>\n\n        <div class=\"calendar-table\"></div>\n    </div>\n    <div class=\"ranges\">\n        <div class=\"range_inputs\">\n            <button class=\"applyBtn\" disabled=\"disabled\" type=\"button\"></button>\n            <button class=\"cancelBtn\" type=\"button\"></button>\n        </div>\n    </div>\n</div>\n";


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var input_base_component_1 = __webpack_require__(45);
	var custom_validators_1 = __webpack_require__(46);
	var EmailComponent = (function (_super) {
	    __extends(EmailComponent, _super);
	    function EmailComponent(el) {
	        var _this = _super.call(this, el) || this;
	        _this.inputType = 'email';
	        return _this;
	    }
	    EmailComponent.prototype.addValidators = function () {
	        this.validations.push({
	            validator: custom_validators_1.CustomValidators.emailAddress,
	            type: 'invalidEmail',
	            message: "Email address is invalid",
	        });
	    };
	    EmailComponent.prototype.ngOnInit = function () {
	        this.onInit();
	        if (!this.leftIcon) {
	            this.leftIcon = 'email';
	        }
	    };
	    EmailComponent.prototype.ngOnDestroy = function () {
	    };
	    return EmailComponent;
	}(input_base_component_1.InputBase));
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], EmailComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], EmailComponent.prototype, "placeholder", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], EmailComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], EmailComponent.prototype, "label", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], EmailComponent.prototype, "floatingLabel", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], EmailComponent.prototype, "leftIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], EmailComponent.prototype, "rightIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], EmailComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], EmailComponent.prototype, "value", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], EmailComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], EmailComponent.prototype, "required", void 0);
	EmailComponent = __decorate([
	    core_1.Component({
	        selector: 'email',
	        template: "\n      <div class=\"input-group m-b-15 w-100\" [class.fg-float]=\"floatingLabel\" [class.fc-alt]=\"alt\" [ngClass]=\"{ 'has-error': !control.valid &amp;&amp; (fg.submitted || control.dirty)}\"><label *ngIf=\"label &amp;&amp; !floatingLabel\">{{label}}</label><span class=\"input-group-addon\" *ngIf=\"leftIcon\"><i class=\"zmdi zmdi-{{leftIcon}}\"></i></span><div class=\"fg-line\" [class.disabled]=\"disabled\" [class.fg-toggled]=\"toggled\"><input class=\"form-control\" #i [type]=\"inputType\" placeholder=\"{{placeholder}}\" [formControl]=\"control\" [disabled]=\"disabled\" (focus)=\"onFocus(i)\" (blur)=\"onBlur(i)\"><label class=\"fg-label\" *ngIf=\"label &amp;&amp; floatingLabel\">{{label}}</label></div><span class=\"input-group-addon last\" *ngIf=\"rightIcon\"><i class=\"zmdi zmdi-{{rightIcon}}\"></i></span><div *ngIf=\"!control.valid &amp;&amp; (control.dirty || fg.submitted)\"><small class=\"help-block animated fadeInDown\" *ngFor=\"let v of validations\" [class.hidden]=\"!control.errors[v.type]\">{{v.message}}</small></div></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], EmailComponent);
	exports.EmailComponent = EmailComponent;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var create_text_mask_input_element_1 = __webpack_require__(51);
	;
	var MaskedInputDirective = (function () {
	    function MaskedInputDirective(inputElement) {
	        this.textMaskConfig = {
	            control: new forms_1.FormControl(),
	            mask: '',
	            guide: true,
	            placeholderChar: '_',
	            pipe: undefined,
	            keepCharPositions: false,
	            onReject: undefined,
	            onAccept: undefined,
	        };
	        this.inputElement = inputElement.nativeElement;
	    }
	    MaskedInputDirective.prototype.writeValue = function (value) {
	        this.textMaskInputElement.update(value);
	        this.textMaskConfig.control.setValue(value, { onlySelf: true, emitEvent: false });
	    };
	    MaskedInputDirective.prototype.registerOnChange = function (fn) {
	        this.textMaskConfig.control.valueChanges.subscribe(fn);
	    };
	    MaskedInputDirective.prototype.registerOnTouched = function () { };
	    MaskedInputDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        this.textMaskInputElement = create_text_mask_input_element_1.default(Object.assign({ inputElement: this.inputElement }, this.textMaskConfig));
	        setTimeout(function () { return _this.onInput(); });
	    };
	    MaskedInputDirective.prototype.onInput = function () {
	        this.textMaskInputElement.update();
	        this.writeValue(this.inputElement.value);
	    };
	    return MaskedInputDirective;
	}());
	__decorate([
	    core_1.Input('textMask'),
	    __metadata("design:type", Object)
	], MaskedInputDirective.prototype, "textMaskConfig", void 0);
	MaskedInputDirective = __decorate([
	    core_1.Directive({
	        host: {
	            '(input)': 'onInput()',
	        },
	        selector: 'input[textMask]',
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], MaskedInputDirective);
	exports.MaskedInputDirective = MaskedInputDirective;
	exports.Directive = MaskedInputDirective;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var adjust_caret_position_1 = __webpack_require__(52);
	var conform_to_mask_1 = __webpack_require__(53);
	var utilities_1 = __webpack_require__(54);
	var constants_1 = __webpack_require__(55);
	var strPlaceholder = 'placeholder';
	var strFunction = 'function';
	var emptyString = '';
	var strNone = 'none';
	;
	function createTextMaskInputElement(_a) {
	    var inputElement = _a.inputElement, providedMask = _a.mask, guide = _a.guide, pipe = _a.pipe, _b = _a.placeholderChar, placeholderChar = _b === void 0 ? constants_1.placeholderChar : _b, onAccept = _a.onAccept, onReject = _a.onReject, _c = _a.keepCharPositions, keepCharPositions = _c === void 0 ? false : _c;
	    if (typeof providedMask === 'object'
	        && providedMask.pipe !== undefined
	        && providedMask.mask !== undefined) {
	        pipe = providedMask.pipe;
	        providedMask = providedMask.mask;
	    }
	    var state = { previousConformedValue: emptyString };
	    var placeholder;
	    var mask;
	    if (providedMask instanceof Array) {
	        placeholder = utilities_1.convertMaskToPlaceholder(providedMask, placeholderChar);
	    }
	    if (inputElement.placeholder === emptyString) {
	        inputElement.setAttribute(strPlaceholder, placeholder);
	    }
	    return {
	        state: state,
	        update: function (rawValue) {
	            if (rawValue === void 0) { rawValue = inputElement.value; }
	            if (rawValue === state.previousConformedValue) {
	                return;
	            }
	            ;
	            var safeRawValue = getSafeRawValue(rawValue);
	            var currentCaretPosition = inputElement.selectionStart;
	            var previousConformedValue = state.previousConformedValue;
	            var caretTrapIndexes;
	            if (typeof providedMask === strFunction) {
	                mask = providedMask(safeRawValue, { currentCaretPosition: currentCaretPosition, previousConformedValue: previousConformedValue, placeholderChar: placeholderChar });
	                var _a = utilities_1.processCaretTraps(mask), maskWithoutCaretTraps = _a.maskWithoutCaretTraps, indexes = _a.indexes;
	                mask = maskWithoutCaretTraps;
	                caretTrapIndexes = indexes;
	                placeholder = utilities_1.convertMaskToPlaceholder(mask, placeholderChar);
	            }
	            else {
	                mask = providedMask;
	            }
	            var conformToMaskConfig = {
	                previousConformedValue: previousConformedValue,
	                guide: guide,
	                placeholderChar: placeholderChar,
	                pipe: pipe,
	                placeholder: placeholder,
	                currentCaretPosition: currentCaretPosition,
	                keepCharPositions: keepCharPositions,
	            };
	            var _b = conform_to_mask_1.default(safeRawValue, mask, conformToMaskConfig), conformedValue = _b.conformedValue, someCharsRejected = _b.meta.someCharsRejected;
	            var piped = typeof pipe === strFunction;
	            var pipeResults = {};
	            if (piped) {
	                pipeResults = pipe(conformedValue, { rawValue: safeRawValue });
	                if (pipeResults === false) {
	                    pipeResults = { value: previousConformedValue, rejected: true };
	                }
	                else if (utilities_1.isString(pipeResults)) {
	                    pipeResults = { value: pipeResults };
	                }
	            }
	            var finalConformedValue = (piped) ? pipeResults.value : conformedValue, adjustedCaretPosition = adjust_caret_position_1.default({
	                previousConformedValue: previousConformedValue,
	                conformedValue: finalConformedValue,
	                placeholder: placeholder,
	                rawValue: safeRawValue,
	                currentCaretPosition: currentCaretPosition,
	                placeholderChar: placeholderChar,
	                indexesOfPipedChars: pipeResults.indexesOfPipedChars,
	                caretTrapIndexes: caretTrapIndexes,
	            }), inputValueShouldBeEmpty = finalConformedValue === placeholder && adjustedCaretPosition === 0, inputElementValue = (inputValueShouldBeEmpty) ? emptyString : finalConformedValue;
	            inputElement.value = inputElementValue;
	            safeSetSelection(inputElement, adjustedCaretPosition);
	            state.previousConformedValue = inputElementValue;
	            if (typeof onAccept === strFunction && inputElementValue !== previousConformedValue) {
	                onAccept();
	            }
	            var isDeletion = safeRawValue.length < previousConformedValue.length;
	            if (typeof onReject === strFunction &&
	                (someCharsRejected || pipeResults.rejected) &&
	                isDeletion === false) {
	                onReject({
	                    conformedValue: finalConformedValue,
	                    pipeRejection: pipeResults.rejected,
	                    maskRejection: someCharsRejected,
	                });
	            }
	        },
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = createTextMaskInputElement;
	function safeSetSelection(element, selectionPosition) {
	    if (document.activeElement === element) {
	        element.setSelectionRange(selectionPosition, selectionPosition, strNone);
	    }
	}
	function getSafeRawValue(inputValue) {
	    if (utilities_1.isString(inputValue)) {
	        return inputValue;
	    }
	    else if (utilities_1.isNumber(inputValue)) {
	        return String(inputValue);
	    }
	    else if (inputValue === undefined || inputValue === null) {
	        return emptyString;
	    }
	    else {
	        throw new Error('The "value" provided to Text Mask needs to be a string or a number. The value ' +
	            ("received was:\n\n " + JSON.stringify(inputValue)));
	    }
	}


/***/ },
/* 52 */
/***/ function(module, exports) {

	"use strict";
	var defaultArray = [];
	var emptyString = '';
	function adjustCaretPosition(_a) {
	    var _b = _a.previousConformedValue, previousConformedValue = _b === void 0 ? emptyString : _b, _c = _a.currentCaretPosition, currentCaretPosition = _c === void 0 ? 0 : _c, conformedValue = _a.conformedValue, rawValue = _a.rawValue, placeholderChar = _a.placeholderChar, placeholder = _a.placeholder, _d = _a.indexesOfPipedChars, indexesOfPipedChars = _d === void 0 ? defaultArray : _d, _e = _a.caretTrapIndexes, caretTrapIndexes = _e === void 0 ? defaultArray : _e;
	    if (currentCaretPosition === 0) {
	        return 0;
	    }
	    var rawValueLength = rawValue.length;
	    var previousConformedValueLength = previousConformedValue.length;
	    var placeholderLength = placeholder.length;
	    var conformedValueLength = conformedValue.length;
	    var editLength = rawValueLength - previousConformedValueLength;
	    var isAddition = editLength > 0;
	    var isFirstRawValue = previousConformedValueLength === 0;
	    var isPartialMultiCharEdit = editLength > 1 && !isAddition && !isFirstRawValue;
	    if (isPartialMultiCharEdit) {
	        return currentCaretPosition;
	    }
	    var possiblyHasRejectedChar = isAddition && (previousConformedValue === conformedValue ||
	        conformedValue === placeholder);
	    var startingSearchIndex = 0;
	    if (possiblyHasRejectedChar) {
	        startingSearchIndex = currentCaretPosition - editLength;
	    }
	    else {
	        var normalizedConformedValue_1 = conformedValue.toLowerCase();
	        var normalizedRawValue = rawValue.toLowerCase();
	        var leftHalfChars = normalizedRawValue.substr(0, currentCaretPosition).split(emptyString);
	        var intersection = leftHalfChars.filter(function (char) { return normalizedConformedValue_1.indexOf(char) !== -1; });
	        var targetChar_1 = intersection[intersection.length - 1];
	        var pipedChars = indexesOfPipedChars.map(function (index) { return normalizedConformedValue_1[index]; });
	        var countTargetCharInPipedChars = pipedChars.filter(function (char) { return char === targetChar_1; }).length;
	        var countTargetCharInIntersection = intersection.filter(function (char) { return char === targetChar_1; }).length;
	        var countTargetCharInPlaceholder = placeholder
	            .substr(0, placeholder.indexOf(placeholderChar))
	            .split(emptyString)
	            .filter(function (char, index) { return (char === targetChar_1 &&
	            rawValue[index] !== char); })
	            .length;
	        var requiredNumberOfMatches = (countTargetCharInPlaceholder +
	            countTargetCharInIntersection +
	            countTargetCharInPipedChars);
	        var numberOfEncounteredMatches = 0;
	        for (var i = 0; i < conformedValueLength; i++) {
	            var conformedValueChar = normalizedConformedValue_1[i];
	            startingSearchIndex = i + 1;
	            if (conformedValueChar === targetChar_1) {
	                numberOfEncounteredMatches++;
	            }
	            if (numberOfEncounteredMatches >= requiredNumberOfMatches) {
	                break;
	            }
	        }
	    }
	    if (isAddition) {
	        var lastPlaceholderChar = startingSearchIndex;
	        for (var i = startingSearchIndex; i <= placeholderLength; i++) {
	            if (placeholder[i] === placeholderChar) {
	                lastPlaceholderChar = i;
	            }
	            if (placeholder[i] === placeholderChar ||
	                caretTrapIndexes.indexOf(i) !== -1 ||
	                i === placeholderLength) {
	                return lastPlaceholderChar;
	            }
	        }
	    }
	    else {
	        for (var i = startingSearchIndex; i >= 0; i--) {
	            if (placeholder[i - 1] === placeholderChar ||
	                caretTrapIndexes.indexOf(i) !== -1 ||
	                i === 0) {
	                return i;
	            }
	        }
	    }
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = adjustCaretPosition;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var utilities_1 = __webpack_require__(54);
	var constants_1 = __webpack_require__(55);
	var emptyString = '';
	;
	function conformToMask(rawValue, mask, config) {
	    if (rawValue === void 0) { rawValue = emptyString; }
	    if (mask === void 0) { mask = emptyString; }
	    if (config === void 0) { config = {}; }
	    var _a = config.guide, guide = _a === void 0 ? true : _a, _b = config.previousConformedValue, previousConformedValue = _b === void 0 ? emptyString : _b, _c = config.placeholderChar, placeholderChar = _c === void 0 ? constants_1.placeholderChar : _c, _d = config.placeholder, placeholder = _d === void 0 ? utilities_1.convertMaskToPlaceholder(mask, constants_1.placeholderChar) : _d, currentCaretPosition = config.currentCaretPosition, keepCharPositions = config.keepCharPositions;
	    var suppressGuide = guide === false && previousConformedValue !== undefined;
	    var rawValueLength = rawValue.length;
	    var previousConformedValueLength = previousConformedValue.length;
	    var placeholderLength = placeholder.length;
	    var maskLength = mask.length;
	    var editDistance = rawValueLength - previousConformedValueLength;
	    var isAddition = editDistance > 0;
	    var indexOfFirstChange = currentCaretPosition + (isAddition ? -editDistance : 0);
	    var indexOfLastChange = indexOfFirstChange + Math.abs(editDistance);
	    if (keepCharPositions === true && !isAddition) {
	        var compensatingPlaceholderChars = emptyString;
	        for (var i = indexOfFirstChange; i < indexOfLastChange; i++) {
	            if (placeholder[i] === placeholderChar) {
	                compensatingPlaceholderChars += placeholderChar;
	            }
	        }
	        rawValue = (rawValue.slice(0, indexOfFirstChange) +
	            compensatingPlaceholderChars +
	            rawValue.slice(indexOfFirstChange, rawValueLength));
	    }
	    var rawValueArr = rawValue
	        .split(emptyString)
	        .map(function (char, i) { return ({ char: char, isNew: i >= indexOfFirstChange && i < indexOfLastChange }); });
	    for (var i = rawValueLength - 1; i >= 0; i--) {
	        var char = rawValueArr[i].char;
	        if (char !== placeholderChar) {
	            var shouldOffset = i >= indexOfFirstChange && previousConformedValueLength === maskLength;
	            if (char === placeholder[(shouldOffset) ? i - editDistance : i]) {
	                rawValueArr.splice(i, 1);
	            }
	        }
	    }
	    var conformedValue = emptyString;
	    var someCharsRejected = false;
	    placeholderLoop: for (var i = 0; i < placeholderLength; i++) {
	        var charInPlaceholder = placeholder[i];
	        if (charInPlaceholder === placeholderChar) {
	            if (rawValueArr.length > 0) {
	                while (rawValueArr.length > 0) {
	                    var _e = rawValueArr.shift(), rawValueChar = _e.char, isNew = _e.isNew;
	                    if (rawValueChar === placeholderChar && suppressGuide !== true) {
	                        conformedValue += placeholderChar;
	                        continue placeholderLoop;
	                    }
	                    else if (mask[i].test(rawValueChar)) {
	                        if (keepCharPositions !== true ||
	                            isNew === false ||
	                            previousConformedValue === emptyString ||
	                            guide === false ||
	                            !isAddition) {
	                            conformedValue += rawValueChar;
	                        }
	                        else {
	                            var rawValueArrLength = rawValueArr.length;
	                            var indexOfNextAvailablePlaceholderChar = null;
	                            for (var i_1 = 0; i_1 < rawValueArrLength; i_1++) {
	                                var charData = rawValueArr[i_1];
	                                if (charData.char !== placeholderChar && charData.isNew === false) {
	                                    break;
	                                }
	                                if (charData.char === placeholderChar) {
	                                    indexOfNextAvailablePlaceholderChar = i_1;
	                                    break;
	                                }
	                            }
	                            if (indexOfNextAvailablePlaceholderChar !== null) {
	                                conformedValue += rawValueChar;
	                                rawValueArr.splice(indexOfNextAvailablePlaceholderChar, 1);
	                            }
	                            else {
	                                i--;
	                            }
	                        }
	                        continue placeholderLoop;
	                    }
	                    else {
	                        someCharsRejected = true;
	                    }
	                }
	            }
	            if (suppressGuide === false) {
	                conformedValue += placeholder.substr(i, placeholderLength);
	            }
	            break;
	        }
	        else {
	            conformedValue += charInPlaceholder;
	        }
	    }
	    if (suppressGuide && isAddition === false) {
	        var indexOfLastFilledPlaceholderChar = null;
	        for (var i = 0; i < conformedValue.length; i++) {
	            if (placeholder[i] === placeholderChar) {
	                indexOfLastFilledPlaceholderChar = i;
	            }
	        }
	        if (indexOfLastFilledPlaceholderChar !== null) {
	            conformedValue = conformedValue.substr(0, indexOfLastFilledPlaceholderChar + 1);
	        }
	        else {
	            conformedValue = emptyString;
	        }
	    }
	    return { conformedValue: conformedValue, meta: { someCharsRejected: someCharsRejected } };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = conformToMask;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var constants_1 = __webpack_require__(55);
	var emptyArray = [];
	function convertMaskToPlaceholder(mask, placeholderChar) {
	    if (mask === void 0) { mask = emptyArray; }
	    if (placeholderChar === void 0) { placeholderChar = constants_1.placeholderChar; }
	    if (mask.indexOf(placeholderChar) !== -1) {
	        throw new Error('Placeholder character must not be used as part of the mask. Please specify a character ' +
	            'that is not present in your mask as your placeholder character.\n\n' +
	            ("The placeholder character that was received is: " + JSON.stringify(placeholderChar) + "\n\n") +
	            ("The mask that was received is: " + JSON.stringify(mask)));
	    }
	    return mask.map(function (char) {
	        return (char instanceof RegExp) ? placeholderChar : char;
	    }).join('');
	}
	exports.convertMaskToPlaceholder = convertMaskToPlaceholder;
	function isString(value) {
	    return typeof value === 'string' || value instanceof String;
	}
	exports.isString = isString;
	function isNumber(value) {
	    return value && value.length === undefined && !isNaN(value);
	}
	exports.isNumber = isNumber;
	var strCaretTrap = '[]';
	function processCaretTraps(mask) {
	    var indexes = [];
	    var indexOfCaretTrap;
	    while (indexOfCaretTrap = mask.indexOf(strCaretTrap), indexOfCaretTrap !== -1) {
	        indexes.push(indexOfCaretTrap);
	        mask.splice(indexOfCaretTrap, 1);
	    }
	    return { maskWithoutCaretTraps: mask, indexes: indexes };
	}
	exports.processCaretTraps = processCaretTraps;


/***/ },
/* 55 */
/***/ function(module, exports) {

	"use strict";
	exports.placeholderChar = '_';


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var input_base_component_1 = __webpack_require__(45);
	var type_enum_1 = __webpack_require__(37);
	var create_number_mask_1 = __webpack_require__(57);
	var NumberComponent = (function (_super) {
	    __extends(NumberComponent, _super);
	    function NumberComponent(el) {
	        var _this = _super.call(this, el) || this;
	        _this.dataType = type_enum_1.TypeEnum.Number;
	        return _this;
	    }
	    NumberComponent.prototype.addValidators = function () {
	        this.addMinValidation();
	        this.addMaxValidation();
	    };
	    NumberComponent.prototype.ngOnInit = function () {
	        this.onInit();
	        var maskConfig = {
	            allowDecimal: this.decimal,
	            prefix: this.prefix || '',
	            suffix: this.suffix,
	            decimalLimit: this.decimalPlaces,
	        };
	        if (this.currency && !this.prefix) {
	            maskConfig.prefix = '$ ';
	            maskConfig.allowDecimal = true;
	            maskConfig.decimalLimit = 2;
	        }
	        if (this.percent) {
	            maskConfig.suffix = ' %';
	            maskConfig.allowDecimal = true;
	            maskConfig.decimalLimit = 2;
	        }
	        this.numberMask = create_number_mask_1.default(maskConfig);
	    };
	    NumberComponent.prototype.ngOnDestroy = function () {
	    };
	    return NumberComponent;
	}(input_base_component_1.InputBase));
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], NumberComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], NumberComponent.prototype, "placeholder", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], NumberComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], NumberComponent.prototype, "label", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], NumberComponent.prototype, "floatingLabel", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], NumberComponent.prototype, "leftIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], NumberComponent.prototype, "rightIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], NumberComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], NumberComponent.prototype, "value", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], NumberComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], NumberComponent.prototype, "decimal", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], NumberComponent.prototype, "currency", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], NumberComponent.prototype, "percent", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], NumberComponent.prototype, "prefix", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], NumberComponent.prototype, "suffix", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], NumberComponent.prototype, "decimalPlaces", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], NumberComponent.prototype, "required", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], NumberComponent.prototype, "min", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], NumberComponent.prototype, "max", void 0);
	NumberComponent = __decorate([
	    core_1.Component({
	        selector: 'number',
	        template: "\n      <div class=\"input-group m-b-15 w-100\" [class.fg-float]=\"floatingLabel\" [class.fc-alt]=\"alt\" style=\"width: 100%\" [ngClass]=\"{ 'has-error': !control.valid &amp;&amp; (fg.submitted || control.dirty)}\"><label *ngIf=\"label &amp;&amp; !floatingLabel\">{{label}}</label><span class=\"input-group-addon\" *ngIf=\"leftIcon\"><i class=\"zmdi zmdi-{{leftIcon}}\"></i></span><div class=\"fg-line\" [class.disabled]=\"disabled\" [class.fg-toggled]=\"toggled\"><input class=\"form-control\" #i type=\"text\" [textMask]=\"{ control: control, mask: numberMask }\" placeholder=\"{{placeholder}}\" [formControl]=\"control\" [disabled]=\"disabled\" (focus)=\"onFocus(i)\" (blur)=\"onBlur(i)\"><label class=\"fg-label\" *ngIf=\"label &amp;&amp; floatingLabel\">{{label}}</label></div><span class=\"input-group-addon last\" *ngIf=\"rightIcon\"><i class=\"zmdi zmdi-{{rightIcon}}\"></i></span><div *ngIf=\"!control.valid &amp;&amp; (control.dirty || fg.submitted)\"><small class=\"help-block animated fadeInDown\" *ngFor=\"let v of validations\" [class.hidden]=\"!control.errors[v.type]\">{{v.message}}</small></div></div>\n    ",
	        styles: ['.form-control { text-align: right; } '],
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], NumberComponent);
	exports.NumberComponent = NumberComponent;


/***/ },
/* 57 */
/***/ function(module, exports) {

	"use strict";
	var dollarSign = '$';
	var emptyString = '';
	var comma = ',';
	var period = '.';
	var nonDigitsRegExp = /\D+/g;
	var number = 'number';
	var digitRegExp = /\d/;
	;
	function createNumberMask(_a) {
	    var _b = _a === void 0 ? {} : _a, _c = _b.prefix, prefix = _c === void 0 ? dollarSign : _c, _d = _b.suffix, suffix = _d === void 0 ? emptyString : _d, _e = _b.includeThousandsSeparator, includeThousandsSeparator = _e === void 0 ? true : _e, _f = _b.thousandsSeparatorSymbol, thousandsSeparatorSymbol = _f === void 0 ? comma : _f, _g = _b.allowDecimal, allowDecimal = _g === void 0 ? false : _g, _h = _b.decimalSymbol, decimalSymbol = _h === void 0 ? period : _h, _j = _b.decimalLimit, decimalLimit = _j === void 0 ? 2 : _j, _k = _b.requireDecimal, requireDecimal = _k === void 0 ? false : _k;
	    function numberMask(rawValue) {
	        var rawValueLength = rawValue.length;
	        if (rawValue === emptyString ||
	            (rawValue[0] === prefix[0] && rawValueLength === 1)) {
	            return prefix.split(emptyString).concat([digitRegExp.toString()]).concat(suffix.split(emptyString));
	        }
	        var indexOfLastDecimal = rawValue.lastIndexOf(decimalSymbol);
	        var hasDecimal = indexOfLastDecimal !== -1;
	        var integer;
	        var fraction;
	        var mask;
	        if (hasDecimal && (allowDecimal || requireDecimal)) {
	            integer = rawValue.slice(0, indexOfLastDecimal);
	            fraction = rawValue.slice(indexOfLastDecimal + 1, rawValueLength);
	            fraction = convertToMask(fraction.replace(nonDigitsRegExp, emptyString));
	        }
	        else {
	            integer = rawValue;
	        }
	        integer = integer.replace(nonDigitsRegExp, emptyString);
	        integer = (includeThousandsSeparator) ? addThousandsSeparator(integer, thousandsSeparatorSymbol) : integer;
	        mask = convertToMask(integer);
	        if ((hasDecimal && allowDecimal) || requireDecimal === true) {
	            if (rawValue[indexOfLastDecimal - 1] !== decimalSymbol) {
	                mask.push('[]');
	            }
	            mask.push(decimalSymbol, '[]');
	            if (fraction) {
	                if (typeof decimalLimit === number) {
	                    fraction = fraction.slice(0, decimalLimit);
	                }
	                mask = mask.concat(fraction);
	            }
	            else if (requireDecimal === true) {
	                for (var i = 0; i < decimalLimit; i++) {
	                    mask.push(digitRegExp);
	                }
	            }
	        }
	        if (prefix.length > 0) {
	            mask = prefix.split(emptyString).concat(mask);
	        }
	        if (suffix.length > 0) {
	            mask = mask.concat(suffix.split(emptyString));
	        }
	        return mask;
	    }
	    numberMask.instanceOf = 'createNumberMask';
	    return numberMask;
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = createNumberMask;
	function convertToMask(strNumber) {
	    return strNumber
	        .split(emptyString)
	        .map(function (char) { return digitRegExp.test(char) ? digitRegExp : char; });
	}
	function addThousandsSeparator(n, thousandsSeparatorSymbol) {
	    return n.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparatorSymbol);
	}


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var input_base_component_1 = __webpack_require__(45);
	var custom_validators_1 = __webpack_require__(46);
	var PasswordComponent = (function (_super) {
	    __extends(PasswordComponent, _super);
	    function PasswordComponent(el) {
	        var _this = _super.call(this, el) || this;
	        _this.inputType = 'password';
	        return _this;
	    }
	    PasswordComponent.prototype.addValidators = function () {
	        if (this.enforceComplexity) {
	            this.validations.push({
	                validator: custom_validators_1.CustomValidators.complexPassword,
	                type: 'weakPassword',
	                message: "This password is not complex enough.\n                It requires at least one of each: upper case letter,\n                lower case letter, digit and a special character.\n                Also it should be at least eight charaacters long.",
	            });
	        }
	        else {
	            if (this.min) {
	                this.validations.push(input_base_component_1.InputBase.minValidator(this.min));
	            }
	            if (this.max) {
	                this.validations.push(input_base_component_1.InputBase.maxValidator(this.max));
	            }
	        }
	    };
	    PasswordComponent.prototype.ngOnInit = function () {
	        this.onInit();
	        if (!this.leftIcon) {
	            this.leftIcon = 'key';
	        }
	    };
	    PasswordComponent.prototype.ngOnDestroy = function () {
	    };
	    return PasswordComponent;
	}(input_base_component_1.InputBase));
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], PasswordComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PasswordComponent.prototype, "placeholder", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PasswordComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PasswordComponent.prototype, "label", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], PasswordComponent.prototype, "floatingLabel", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PasswordComponent.prototype, "leftIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PasswordComponent.prototype, "rightIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], PasswordComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PasswordComponent.prototype, "value", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], PasswordComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], PasswordComponent.prototype, "required", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], PasswordComponent.prototype, "min", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], PasswordComponent.prototype, "max", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], PasswordComponent.prototype, "enforceComplexity", void 0);
	PasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'password',
	        template: "\n      <div class=\"input-group m-b-15 w-100\" [class.fg-float]=\"floatingLabel\" [class.fc-alt]=\"alt\" [ngClass]=\"{ 'has-error': !control.valid &amp;&amp; (fg.submitted || control.dirty)}\"><label *ngIf=\"label &amp;&amp; !floatingLabel\">{{label}}</label><span class=\"input-group-addon\" *ngIf=\"leftIcon\"><i class=\"zmdi zmdi-{{leftIcon}}\"></i></span><div class=\"fg-line\" [class.disabled]=\"disabled\" [class.fg-toggled]=\"toggled\"><input class=\"form-control\" #i [type]=\"inputType\" placeholder=\"{{placeholder}}\" [formControl]=\"control\" [disabled]=\"disabled\" (focus)=\"onFocus(i)\" (blur)=\"onBlur(i)\"><label class=\"fg-label\" *ngIf=\"label &amp;&amp; floatingLabel\">{{label}}</label></div><span class=\"input-group-addon last\" *ngIf=\"rightIcon\"><i class=\"zmdi zmdi-{{rightIcon}}\"></i></span><div *ngIf=\"!control.valid &amp;&amp; (control.dirty || fg.submitted)\"><small class=\"help-block animated fadeInDown\" *ngFor=\"let v of validations\" [class.hidden]=\"!control.errors[v.type]\">{{v.message}}</small></div></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], PasswordComponent);
	exports.PasswordComponent = PasswordComponent;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var input_base_component_1 = __webpack_require__(45);
	var PhoneComponent = (function (_super) {
	    __extends(PhoneComponent, _super);
	    function PhoneComponent(el) {
	        var _this = _super.call(this, el) || this;
	        _this.inputType = 'tel';
	        return _this;
	    }
	    PhoneComponent.prototype.addValidators = function () { };
	    PhoneComponent.prototype.ngOnInit = function () {
	        this.onInit();
	        if (!this.leftIcon) {
	            this.leftIcon = this.fax ? 'account-box-phone' : 'phone';
	        }
	    };
	    PhoneComponent.prototype.ngOnDestroy = function () {
	    };
	    return PhoneComponent;
	}(input_base_component_1.InputBase));
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], PhoneComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PhoneComponent.prototype, "placeholder", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PhoneComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PhoneComponent.prototype, "label", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], PhoneComponent.prototype, "floatingLabel", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PhoneComponent.prototype, "leftIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PhoneComponent.prototype, "rightIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], PhoneComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], PhoneComponent.prototype, "value", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], PhoneComponent.prototype, "fax", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], PhoneComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], PhoneComponent.prototype, "required", void 0);
	PhoneComponent = __decorate([
	    core_1.Component({
	        selector: 'phone',
	        template: "\n      <div class=\"input-group m-b-15 w-100\" [class.fg-float]=\"floatingLabel\" [class.fc-alt]=\"alt\" [ngClass]=\"{ 'has-error': !control.valid &amp;&amp; (fg.submitted || control.dirty)}\"><label *ngIf=\"label &amp;&amp; !floatingLabel\">{{label}}</label><span class=\"input-group-addon\" *ngIf=\"leftIcon\"><i class=\"zmdi zmdi-{{leftIcon}}\"></i></span><div class=\"fg-line\" [class.disabled]=\"disabled\" [class.fg-toggled]=\"toggled\"><input class=\"form-control\" #i [type]=\"inputType\" placeholder=\"{{placeholder}}\" [formControl]=\"control\" [disabled]=\"disabled\" (focus)=\"onFocus(i)\" (blur)=\"onBlur(i)\"><label class=\"fg-label\" *ngIf=\"label &amp;&amp; floatingLabel\">{{label}}</label></div><span class=\"input-group-addon last\" *ngIf=\"rightIcon\"><i class=\"zmdi zmdi-{{rightIcon}}\"></i></span><div *ngIf=\"!control.valid &amp;&amp; (control.dirty || fg.submitted)\"><small class=\"help-block animated fadeInDown\" *ngFor=\"let v of validations\" [class.hidden]=\"!control.errors[v.type]\">{{v.message}}</small></div></div>\n    ",
	        styles: ['.form-control { text-align: right; } '],
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], PhoneComponent);
	exports.PhoneComponent = PhoneComponent;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var input_base_component_1 = __webpack_require__(45);
	var radio_group_service_1 = __webpack_require__(61);
	var RadioGroupComponent = (function (_super) {
	    __extends(RadioGroupComponent, _super);
	    function RadioGroupComponent(el, service) {
	        var _this = _super.call(this, el) || this;
	        _this.service = service;
	        _this.disabled = false;
	        _this.service.optionSelected$.subscribe(function (value) {
	            _this.control.setValue(value);
	        });
	        return _this;
	    }
	    RadioGroupComponent.prototype.ngOnInit = function () {
	        this.onInit();
	        this.service.fieldName = this.field;
	        this.service.defaultValue = this.defaultValue;
	    };
	    RadioGroupComponent.prototype.addValidators = function () { };
	    return RadioGroupComponent;
	}(input_base_component_1.InputBase));
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], RadioGroupComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], RadioGroupComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], RadioGroupComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], RadioGroupComponent.prototype, "defaultValue", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], RadioGroupComponent.prototype, "alt", void 0);
	RadioGroupComponent = __decorate([
	    core_1.Component({
	        selector: 'radio-group',
	        template: "\n      <div class=\"radio-group\" [class.fc-alt]=\"alt\"><ng-content></ng-content></div>\n    ",
	        providers: [radio_group_service_1.RadioGroupService],
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, radio_group_service_1.RadioGroupService])
	], RadioGroupComponent);
	exports.RadioGroupComponent = RadioGroupComponent;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var Subject_1 = __webpack_require__(3);
	var RadioGroupService = (function () {
	    function RadioGroupService() {
	        this.optionSelectedSource = new Subject_1.Subject();
	    }
	    RadioGroupService.prototype.announceSelectedOption = function (value) {
	        this.optionSelectedSource.next(value);
	    };
	    Object.defineProperty(RadioGroupService.prototype, "optionSelected$", {
	        get: function () {
	            return this.optionSelectedSource.asObservable();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return RadioGroupService;
	}());
	RadioGroupService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [])
	], RadioGroupService);
	exports.RadioGroupService = RadioGroupService;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var radio_group_service_1 = __webpack_require__(61);
	var RadioComponent = (function () {
	    function RadioComponent(el, _service) {
	        this.el = el;
	        this._service = _service;
	    }
	    Object.defineProperty(RadioComponent.prototype, "groupName", {
	        get: function () {
	            return this._service.fieldName.replace('.', '_');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RadioComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        var ele = this.el.nativeElement.getElementsByTagName('input')[0];
	        this._service.optionSelected$.subscribe(function (value) {
	            ele.checked = value === _this.value;
	        });
	        if (this._service.defaultValue === this.value) {
	            window.setTimeout(function () { _this._service.announceSelectedOption(_this.value); }, 0);
	        }
	    };
	    RadioComponent.prototype.check = function () {
	        this._updateValue();
	    };
	    RadioComponent.prototype._updateValue = function () {
	        this._service.announceSelectedOption(this.value);
	    };
	    return RadioComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], RadioComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], RadioComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], RadioComponent.prototype, "label", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], RadioComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], RadioComponent.prototype, "nane", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], RadioComponent.prototype, "value", void 0);
	RadioComponent = __decorate([
	    core_1.Component({
	        selector: 'radio',
	        template: "\n      <div class=\"radio m-b-15\" [class.disabled]=\"disabled\"><label><input type=\"radio\" [name]=\"groupName\" [disabled]=\"disabled\" [attr.value]=\"value\" (click)=\"check()\"><i class=\"input-helper\"></i>{{label}}</label></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef,
	        radio_group_service_1.RadioGroupService])
	], RadioComponent);
	exports.RadioComponent = RadioComponent;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var input_base_component_1 = __webpack_require__(45);
	var polyfills_1 = __webpack_require__(64);
	polyfills_1.processPolyfills();
	var SelectPickerComponent = (function (_super) {
	    __extends(SelectPickerComponent, _super);
	    function SelectPickerComponent(el) {
	        var _this = _super.call(this, el) || this;
	        _this.el = el;
	        _this.multiple = false;
	        _this.autofocus = false;
	        _this.noneSelectedText = 'Nothing selected';
	        _this.noneResultsText = 'No results matched ';
	        _this.multipleSeparator = ', ';
	        _this.liveSearch = false;
	        _this.liveSearchPlaceholder = null;
	        _this.liveSearchStyle = 'contains';
	        _this.maxOptions = 100;
	        _this.isMobile = false;
	        _this.tickIcon = 'zmdi-check';
	        _this.open = false;
	        return _this;
	    }
	    SelectPickerComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.onInit();
	        this.query = new forms_1.FormControl();
	        this.query.valueChanges.subscribe(function (filter) {
	            _this._filterResults(filter);
	        });
	        this._updateValue();
	    };
	    SelectPickerComponent.prototype.ngOnChanges = function (changes) {
	        var that = this;
	        if (changes['items']) {
	            var clone = [];
	            var currentValue = changes['items'].currentValue;
	            if (currentValue) {
	                clone = currentValue.map(function (item) {
	                    return {
	                        id: item.id,
	                        title: item.title,
	                        disabled: item.disabled,
	                        selected: item.selected,
	                    };
	                });
	            }
	            that._clonedItems = clone;
	            this._updateSelectionText();
	            if (this.initialized) {
	                this._updateValue();
	            }
	            this._filterResults(null);
	        }
	    };
	    Object.defineProperty(SelectPickerComponent.prototype, "emptySearch", {
	        get: function () {
	            return this.filteredItems === undefined || this.filteredItems.length === 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SelectPickerComponent.prototype.toggleOpen = function () {
	        this.open = !this.open;
	    };
	    SelectPickerComponent.prototype.toggleItem = function (item) {
	        if (!this.multiple) {
	            this._clonedItems.forEach(function (item) {
	                item.selected = false;
	            });
	            item.selected = !item.selected;
	        }
	        else {
	            this._processMultipleSelection(item);
	        }
	        this._updateSelectionText();
	        this._updateValue();
	    };
	    SelectPickerComponent.prototype.addValidators = function () { };
	    SelectPickerComponent.prototype._updateValue = function () {
	        var selectedItems = this._clonedItems
	            .filter(function (item) { return item.selected; })
	            .map(function (item) { return item.id; });
	        var values = selectedItems.join(',');
	        this.control.setValue(values);
	        this.value = values;
	    };
	    SelectPickerComponent.prototype._updateSelectionText = function () {
	        if (this._clonedItems) {
	            this.selection = this._clonedItems
	                .filter(function (item) { return item.selected; })
	                .map(function (item) { return item.title; })
	                .join(this.multipleSeparator);
	        }
	        if (!this.selection) {
	            this.selection = this.noneSelectedText;
	        }
	    };
	    SelectPickerComponent.prototype._filterResults = function (filter) {
	        var contains = this.liveSearchStyle === 'contains';
	        if (!filter || filter === '') {
	            this.filteredItems = this._clonedItems;
	        }
	        else {
	            this.filteredItems = this._clonedItems.filter(function (item) {
	                return contains ?
	                    item.title.toLowerCase().includes(filter.toLowerCase()) :
	                    item.title.toLowerCase().startsWith(filter.toLowerCase());
	            });
	        }
	    };
	    SelectPickerComponent.prototype._processMultipleSelection = function (item) {
	        var selectedItems = this._clonedItems.filter(function (item) {
	            return item.selected;
	        });
	        if (!item.selected && selectedItems.length >= this.maxOptions) {
	            return;
	        }
	        item.selected = !item.selected;
	    };
	    return SelectPickerComponent;
	}(input_base_component_1.InputBase));
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], SelectPickerComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], SelectPickerComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], SelectPickerComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], SelectPickerComponent.prototype, "placeholder", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], SelectPickerComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], SelectPickerComponent.prototype, "leftIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], SelectPickerComponent.prototype, "rightIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Array)
	], SelectPickerComponent.prototype, "items", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], SelectPickerComponent.prototype, "multiple", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], SelectPickerComponent.prototype, "autofocus", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], SelectPickerComponent.prototype, "noneSelectedText", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], SelectPickerComponent.prototype, "noneResultsText", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], SelectPickerComponent.prototype, "multipleSeparator", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], SelectPickerComponent.prototype, "liveSearch", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], SelectPickerComponent.prototype, "liveSearchPlaceholder", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], SelectPickerComponent.prototype, "liveSearchStyle", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], SelectPickerComponent.prototype, "maxOptions", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], SelectPickerComponent.prototype, "isMobile", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], SelectPickerComponent.prototype, "tickIcon", void 0);
	SelectPickerComponent = __decorate([
	    core_1.Component({
	        selector: 'select-picker',
	        template: "\n      <div class=\"input-group m-b-15 w-100\" [class.fc-alt]=\"alt\" [ngClass]=\"{ 'has-error': !control.valid &amp;&amp; (fg.submitted || control.dirty)}\"><span class=\"input-group-addon\" *ngIf=\"leftIcon\"><i class=\"zmdi zmdi-{{leftIcon}}\"></i></span><div class=\"btn-group bootstrap-select\" [class.fc-alt]=\"alt\"><button class=\"btn dropdown-toggle btn-default\" type=\"button\" data-toggle=\"dropdown\" role=\"button\" title=\"{{selected}}\" aria-expanded=\"true\" (click)=\"toggleOpen()\"><span class=\"filter-option pull-left\">{{selection}}</span><span class=\"bs-caret\"><span class=\"caret\"></span></span></button><div class=\"dropdown-menu\" [class.open]=\"open\" role=\"combobox\" style=\"max-height: 394px; overflow: hidden; min-height: 0px\"><div class=\"bs-searchbox\" *ngIf=\"liveSearch\"><input class=\"form-control\" [formControl]=\"query\" type=\"text\" autocomplete=\"off\" role=\"textbox\" aria-label=\"Search\" placeholder=\"{{liveSearchPlaceholder}}\"></div><ul class=\"dropdown-menu inner\" role=\"listbox\" aria-expanded=\"true\" style=\"max-height: 392px; overflow-y: auto; min-height: 0px\"><li *ngFor=\"let item of filteredItems; let idx = index\" [attr.data-original-index]=\"idx\" [class.selected]=\"item.selected\" (click)=\"toggleItem(item)\"><a tabindex=\"{{idx}}\" [attr.data-tokens]=\"null\" role=\"option\" [attr.aria-disabled]=\"item.disabled\" [attr.aria-selected]=\"item.selected\"><span class=\"text\">{{item.title}}</span><span class=\"zmdi check-mark {{tickIcon}}\"></span></a></li><li class=\"no-results\" *ngIf=\"emptySearch\">{{ noneResultsText }} \"{{ query.valueChanges | async }}\"</li></ul></div><select class=\"my-selectpicker\" style=\"display: none\" tabindex=\"-98\" [class.mobile-device]=\"isMobile\" [attr.multiple]=\"multiple\"><option *ngFor=\"let item of filteredItems\" value=\"{{item.id}}\" [attr.selected]=\"item.selected ? true : null\">{{item.title}}</option></select></div><span class=\"input-group-addon last\" *ngIf=\"rightIcon\"><i class=\"zmdi zmdi-{{rightIcon}}\"></i></span></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], SelectPickerComponent);
	exports.SelectPickerComponent = SelectPickerComponent;


/***/ },
/* 64 */
/***/ function(module, exports) {

	"use strict";
	function processPolyfills() {
	    if (!String.prototype.includes) {
	        (function () {
	            'use strict';
	            var toString = {}.toString;
	            var defineProperty = (function () {
	                try {
	                    var object = {};
	                    var $defineProperty = Object.defineProperty;
	                    var result = $defineProperty(object, object, object) && $defineProperty;
	                }
	                catch (error) {
	                }
	                return result;
	            }());
	            var indexOf = ''.indexOf;
	            var includes = function (search) {
	                if (this == null) {
	                    throw new TypeError();
	                }
	                var string = String(this);
	                if (search && toString.call(search) === '[object RegExp]') {
	                    throw new TypeError();
	                }
	                var stringLength = string.length;
	                var searchString = String(search);
	                var searchLength = searchString.length;
	                var position = arguments.length > 1 ? arguments[1] : undefined;
	                var pos = position ? Number(position) : 0;
	                if (pos !== pos) {
	                    pos = 0;
	                }
	                var start = Math.min(Math.max(pos, 0), stringLength);
	                if (searchLength + start > stringLength) {
	                    return false;
	                }
	                return indexOf.call(string, searchString, pos) !== -1;
	            };
	            if (defineProperty) {
	                defineProperty(String.prototype, 'includes', {
	                    'value': includes,
	                    'configurable': true,
	                    'writable': true,
	                });
	            }
	            else {
	                String.prototype.includes = includes;
	            }
	        }());
	    }
	    if (!String.prototype.startsWith) {
	        (function () {
	            'use strict';
	            var defineProperty = (function () {
	                try {
	                    var object = {};
	                    var $defineProperty = Object.defineProperty;
	                    var result = $defineProperty(object, object, object) && $defineProperty;
	                }
	                catch (error) {
	                }
	                return result;
	            }());
	            var toString = {}.toString;
	            var startsWith = function (search) {
	                if (this == null) {
	                    throw new TypeError();
	                }
	                var string = String(this);
	                if (search && toString.call(search) === '[object RegExp]') {
	                    throw new TypeError();
	                }
	                var stringLength = string.length;
	                var searchString = String(search);
	                var searchLength = searchString.length;
	                var position = arguments.length > 1 ? arguments[1] : undefined;
	                var pos = position ? Number(position) : 0;
	                if (pos !== pos) {
	                    pos = 0;
	                }
	                var start = Math.min(Math.max(pos, 0), stringLength);
	                if (searchLength + start > stringLength) {
	                    return false;
	                }
	                var index = -1;
	                while (++index < searchLength) {
	                    if (string.charCodeAt(start + index) !== searchString.charCodeAt(index)) {
	                        return false;
	                    }
	                }
	                return true;
	            };
	            if (defineProperty) {
	                defineProperty(String.prototype, 'startsWith', {
	                    'value': startsWith,
	                    'configurable': true,
	                    'writable': true,
	                });
	            }
	            else {
	                String.prototype.startsWith = startsWith;
	            }
	        }());
	    }
	    if (!Object.keys) {
	        Object.keys = (function () {
	            'use strict';
	            var hasOwnProperty = Object.prototype.hasOwnProperty, hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'), dontEnums = [
	                'toString',
	                'toLocaleString',
	                'valueOf',
	                'hasOwnProperty',
	                'isPrototypeOf',
	                'propertyIsEnumerable',
	                'constructor',
	            ], dontEnumsLength = dontEnums.length;
	            return function (obj) {
	                if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
	                    throw new TypeError('Object.keys called on non-object');
	                }
	                var result = [], prop, i;
	                for (prop in obj) {
	                    if (hasOwnProperty.call(obj, prop)) {
	                        result.push(prop);
	                    }
	                }
	                if (hasDontEnumBug) {
	                    for (i = 0; i < dontEnumsLength; i++) {
	                        if (hasOwnProperty.call(obj, dontEnums[i])) {
	                            result.push(dontEnums[i]);
	                        }
	                    }
	                }
	                return result;
	            };
	        }());
	    }
	}
	exports.processPolyfills = processPolyfills;
	function normalizeToBase(text) {
	    var rExps = [
	        { re: /[\xC0-\xC6]/g, ch: 'A' },
	        { re: /[\xE0-\xE6]/g, ch: 'a' },
	        { re: /[\xC8-\xCB]/g, ch: 'E' },
	        { re: /[\xE8-\xEB]/g, ch: 'e' },
	        { re: /[\xCC-\xCF]/g, ch: 'I' },
	        { re: /[\xEC-\xEF]/g, ch: 'i' },
	        { re: /[\xD2-\xD6]/g, ch: 'O' },
	        { re: /[\xF2-\xF6]/g, ch: 'o' },
	        { re: /[\xD9-\xDC]/g, ch: 'U' },
	        { re: /[\xF9-\xFC]/g, ch: 'u' },
	        { re: /[\xC7-\xE7]/g, ch: 'c' },
	        { re: /[\xD1]/g, ch: 'N' },
	        { re: /[\xF1]/g, ch: 'n' },
	    ];
	    $.each(rExps, function () {
	        text = text.replace(this.re, this.ch);
	    });
	    return text;
	}
	exports.normalizeToBase = normalizeToBase;
	function htmlEscape(html) {
	    var escapeMap = {
	        '&': '&amp;',
	        '<': '&lt;',
	        '>': '&gt;',
	        '"': '&quot;',
	        '\'': '&#x27;',
	        '`': '&#x60;',
	    };
	    var source = '(?:' + Object.keys(escapeMap).join('|') + ')', testRegexp = new RegExp(source), replaceRegexp = new RegExp(source, 'g'), string = html == null ? '' : '' + html;
	    return testRegexp.test(string) ? string.replace(replaceRegexp, function (match) {
	        return escapeMap[match];
	    }) : string;
	}
	exports.htmlEscape = htmlEscape;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var input_base_component_1 = __webpack_require__(45);
	var autosize_1 = __webpack_require__(66);
	var TextAreaComponent = (function (_super) {
	    __extends(TextAreaComponent, _super);
	    function TextAreaComponent(el) {
	        var _this = _super.call(this, el) || this;
	        _this.autosize = true;
	        _this.rows = 3;
	        return _this;
	    }
	    TextAreaComponent.prototype.addValidators = function () {
	        if (this.min) {
	            this.validations.push(input_base_component_1.InputBase.minValidator(this.min));
	        }
	        if (this.max) {
	            this.validations.push(input_base_component_1.InputBase.maxValidator(this.max));
	        }
	    };
	    TextAreaComponent.prototype.ngOnInit = function () {
	        this.onInit();
	        if (this.autosize) {
	            autosize_1.default(this._el.nativeElement.getElementsByClassName('form-control'));
	        }
	    };
	    TextAreaComponent.prototype.ngOnDestroy = function () {
	    };
	    return TextAreaComponent;
	}(input_base_component_1.InputBase));
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], TextAreaComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TextAreaComponent.prototype, "placeholder", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TextAreaComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TextAreaComponent.prototype, "label", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], TextAreaComponent.prototype, "floatingLabel", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TextAreaComponent.prototype, "leftIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], TextAreaComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TextAreaComponent.prototype, "value", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], TextAreaComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], TextAreaComponent.prototype, "required", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], TextAreaComponent.prototype, "min", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], TextAreaComponent.prototype, "max", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], TextAreaComponent.prototype, "autosize", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], TextAreaComponent.prototype, "rows", void 0);
	TextAreaComponent = __decorate([
	    core_1.Component({
	        selector: 'text-area',
	        template: "\n      <div class=\"text-area form-group m-b-25 w-100\" [class.fc-alt]=\"alt\" [ngClass]=\"{ 'has-error': !control.valid &amp;&amp; (fg.submitted || control.dirty)}\"><label *ngIf=\"label\">{{label}}</label><div class=\"fg-line\" [class.disabled]=\"disabled\" [class.fg-toggled]=\"toggled\"><textarea class=\"form-control auto-size\" #i [attr.disabled]=\"disabled\" placeholder=\"{{placeholder}}\" [formControl]=\"control\" (focus)=\"onFocus(i)\" (blur)=\"onBlur(i)\" [attr.rows]=\"rows\"></textarea></div><div *ngIf=\"!control.valid &amp;&amp; (control.dirty || fg.submitted)\"><small class=\"help-block animated fadeInDown\" *ngFor=\"let v of validations\" [class.hidden]=\"!control.errors[v.type]\">{{v.message}}</small></div></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], TextAreaComponent);
	exports.TextAreaComponent = TextAreaComponent;


/***/ },
/* 66 */
/***/ function(module, exports) {

	"use strict";
	var set = (typeof Set === 'function') ? new Set() : (function () {
	    var list = [];
	    return {
	        has: function (key) {
	            return Boolean(list.indexOf(key) > -1);
	        },
	        add: function (key) {
	            list.push(key);
	        },
	        delete: function (key) {
	            list.splice(list.indexOf(key), 1);
	        },
	    };
	})();
	var createEvent = function (name) { return new Event(name); };
	try {
	    new Event('test');
	}
	catch (e) {
	    createEvent = function (name) {
	        var evt = document.createEvent('Event');
	        evt.initEvent(name, true, false);
	        return evt;
	    };
	}
	function assign(ta, options) {
	    if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || set.has(ta))
	        return;
	    var heightOffset = null;
	    var clientWidth = ta.clientWidth;
	    var cachedHeight = null;
	    function init() {
	        var style = window.getComputedStyle(ta, null);
	        if (style.resize === 'vertical') {
	            ta.style.resize = 'none';
	        }
	        else if (style.resize === 'both') {
	            ta.style.resize = 'horizontal';
	        }
	        if (style.boxSizing === 'content-box') {
	            heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
	        }
	        else {
	            heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
	        }
	        if (isNaN(heightOffset)) {
	            heightOffset = 0;
	        }
	        update();
	    }
	    function changeOverflow(value) {
	        {
	            var width = ta.style.width;
	            ta.style.width = '0px';
	            ta.offsetWidth;
	            ta.style.width = width;
	        }
	        ta.style.overflowY = value;
	        resize();
	    }
	    function getParentOverflows(el) {
	        var arr = [];
	        while (el && el.parentNode && el.parentNode instanceof Element) {
	            if (el.parentNode.scrollTop) {
	                arr.push({
	                    node: el.parentNode,
	                    scrollTop: el.parentNode.scrollTop,
	                });
	            }
	            el = el.parentNode;
	        }
	        return arr;
	    }
	    function resize() {
	        var originalHeight = ta.style.height;
	        var overflows = getParentOverflows(ta);
	        var docTop = document.documentElement && document.documentElement.scrollTop;
	        ta.style.height = 'auto';
	        var endHeight = ta.scrollHeight + heightOffset;
	        if (ta.scrollHeight === 0) {
	            ta.style.height = originalHeight;
	            return;
	        }
	        ta.style.height = endHeight + 'px';
	        clientWidth = ta.clientWidth;
	        overflows.forEach(function (el) {
	            el.node.scrollTop = el.scrollTop;
	        });
	        if (docTop) {
	            document.documentElement.scrollTop = docTop;
	        }
	    }
	    function update() {
	        resize();
	        var computed = window.getComputedStyle(ta, null);
	        var computedHeight = Math.round(parseFloat(computed.height));
	        var styleHeight = Math.round(parseFloat(ta.style.height));
	        if (computedHeight !== styleHeight) {
	            if (computed.overflowY !== 'visible') {
	                changeOverflow('visible');
	            }
	        }
	        else {
	            if (computed.overflowY !== 'hidden') {
	                changeOverflow('hidden');
	            }
	        }
	        if (cachedHeight !== computedHeight) {
	            cachedHeight = computedHeight;
	            var evt = createEvent('autosize:resized');
	            ta.dispatchEvent(evt);
	        }
	    }
	    var pageResize = function () {
	        if (ta.clientWidth !== clientWidth) {
	            update();
	        }
	    };
	    var destroy = function (style) {
	        window.removeEventListener('resize', pageResize, false);
	        ta.removeEventListener('input', update, false);
	        ta.removeEventListener('keyup', update, false);
	        ta.removeEventListener('autosize:destroy', destroy, false);
	        ta.removeEventListener('autosize:update', update, false);
	        set.delete(ta);
	        Object.keys(style).forEach(function (key) {
	            ta.style[key] = style[key];
	        });
	    };
	    destroy.bind(ta, {
	        height: ta.style.height,
	        resize: ta.style.resize,
	        overflowY: ta.style.overflowY,
	        overflowX: ta.style.overflowX,
	        wordWrap: ta.style.wordWrap,
	    });
	    ta.addEventListener('autosize:destroy', destroy, false);
	    if ('onpropertychange' in ta && 'oninput' in ta) {
	        ta.addEventListener('keyup', update, false);
	    }
	    window.addEventListener('resize', pageResize, false);
	    ta.addEventListener('input', update, false);
	    ta.addEventListener('autosize:update', update, false);
	    set.add(ta);
	    ta.style.overflowX = 'hidden';
	    ta.style.wordWrap = 'break-word';
	    init();
	}
	function destroy(ta) {
	    if (!(ta && ta.nodeName && ta.nodeName === 'TEXTAREA'))
	        return;
	    var evt = createEvent('autosize:destroy');
	    ta.dispatchEvent(evt);
	}
	function update(ta) {
	    if (!(ta && ta.nodeName && ta.nodeName === 'TEXTAREA'))
	        return;
	    var evt = createEvent('autosize:update');
	    ta.dispatchEvent(evt);
	}
	var autosize = null;
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
	    autosize = function (el) { return el; };
	    autosize.destroy = function (el) { return el; };
	    autosize.update = function (el) { return el; };
	}
	else {
	    autosize = function (el, options) {
	        if (el) {
	            Array.prototype.forEach.call(el.length ? el : [el], function (x) { return assign(x, options); });
	        }
	        return el;
	    };
	    autosize.destroy = function (el) {
	        if (el) {
	            Array.prototype.forEach.call(el.length ? el : [el], destroy);
	        }
	        return el;
	    };
	    autosize.update = function (el) {
	        if (el) {
	            Array.prototype.forEach.call(el.length ? el : [el], update);
	        }
	        return el;
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = autosize;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var input_base_component_1 = __webpack_require__(45);
	var TextBoxComponent = (function (_super) {
	    __extends(TextBoxComponent, _super);
	    function TextBoxComponent(el) {
	        return _super.call(this, el) || this;
	    }
	    TextBoxComponent.prototype.addValidators = function () {
	        if (this.min) {
	            this.validations.push(input_base_component_1.InputBase.minValidator(this.min));
	        }
	        if (this.max) {
	            this.validations.push(input_base_component_1.InputBase.maxValidator(this.max));
	        }
	    };
	    TextBoxComponent.prototype.ngOnInit = function () {
	        this.onInit();
	    };
	    TextBoxComponent.prototype.ngOnDestroy = function () {
	    };
	    return TextBoxComponent;
	}(input_base_component_1.InputBase));
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], TextBoxComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TextBoxComponent.prototype, "placeholder", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TextBoxComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TextBoxComponent.prototype, "label", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], TextBoxComponent.prototype, "floatingLabel", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TextBoxComponent.prototype, "leftIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TextBoxComponent.prototype, "rightIcon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TextBoxComponent.prototype, "value", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], TextBoxComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], TextBoxComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], TextBoxComponent.prototype, "required", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], TextBoxComponent.prototype, "min", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], TextBoxComponent.prototype, "max", void 0);
	TextBoxComponent = __decorate([
	    core_1.Component({
	        selector: 'text-box',
	        template: "\n      <div class=\"input-group m-b-15 w-100\" [class.fg-float]=\"floatingLabel\" [class.fc-alt]=\"alt\" [ngClass]=\"{ 'has-error': !control.valid &amp;&amp; (fg.submitted || control.dirty)}\"><label *ngIf=\"label &amp;&amp; !floatingLabel\">{{label}}</label><span class=\"input-group-addon\" *ngIf=\"leftIcon\"><i class=\"zmdi zmdi-{{leftIcon}}\"></i></span><div class=\"fg-line\" [class.disabled]=\"disabled\" [class.fg-toggled]=\"toggled\"><input class=\"form-control\" #i [type]=\"inputType\" placeholder=\"{{placeholder}}\" [formControl]=\"control\" [disabled]=\"disabled\" (focus)=\"onFocus(i)\" (blur)=\"onBlur(i)\"><label class=\"fg-label\" *ngIf=\"label &amp;&amp; floatingLabel\">{{label}}</label></div><span class=\"input-group-addon last\" *ngIf=\"rightIcon\"><i class=\"zmdi zmdi-{{rightIcon}}\"></i></span><div *ngIf=\"!control.valid &amp;&amp; (control.dirty || fg.submitted)\"><small class=\"help-block animated fadeInDown\" *ngFor=\"let v of validations\" [class.hidden]=\"!control.errors[v.type]\">{{v.message}}</small></div></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], TextBoxComponent);
	exports.TextBoxComponent = TextBoxComponent;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var input_base_component_1 = __webpack_require__(45);
	var utilities_1 = __webpack_require__(35);
	var ToggleComponent = (function (_super) {
	    __extends(ToggleComponent, _super);
	    function ToggleComponent(el) {
	        var _this = _super.call(this, el) || this;
	        _this.color = '';
	        return _this;
	    }
	    ToggleComponent.prototype.addValidators = function () { };
	    ToggleComponent.prototype.ngOnInit = function () {
	        this.onInit();
	        this.identifier = utilities_1.guid();
	    };
	    ToggleComponent.prototype.ngOnDestroy = function () {
	    };
	    return ToggleComponent;
	}(input_base_component_1.InputBase));
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], ToggleComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ToggleComponent.prototype, "placeholder", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ToggleComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ToggleComponent.prototype, "label", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ToggleComponent.prototype, "value", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], ToggleComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ToggleComponent.prototype, "color", void 0);
	ToggleComponent = __decorate([
	    core_1.Component({
	        selector: 'toggle',
	        template: "\n      <div class=\"toggle-switch\" [class.disabled]=\"disabled\" [attr.data-ts-color]=\"color\"><label class=\"ts-label\" [attr.for]=\"identifier\">{{label}}</label><input [attr.id]=\"identifier\" type=\"checkbox\" hidden=\"hidden\" [disabled]=\"disabled\" [formControl]=\"control\"><label class=\"ts-helper\" [attr.for]=\"identifier\"></label></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], ToggleComponent);
	exports.ToggleComponent = ToggleComponent;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var datetime_picker_popup_component_1 = __webpack_require__(70);
	var datetime_1 = __webpack_require__(71);
	var input_base_component_1 = __webpack_require__(45);
	var utilities_1 = __webpack_require__(35);
	var DateTimePickerComponent = (function (_super) {
	    __extends(DateTimePickerComponent, _super);
	    function DateTimePickerComponent(ele, resolver, viewContainerRef, parent) {
	        var _this = _super.call(this, ele) || this;
	        _this.ele = ele;
	        _this.resolver = resolver;
	        _this.viewContainerRef = viewContainerRef;
	        _this.parent = parent;
	        _this.dateFormat = 'MM/DD/YYYY';
	        _this.dateOnly = true;
	        _this.hour = 23;
	        _this.minute = 59;
	        _this.closeOnSelect = true;
	        _this.valueChanged = function (date) {
	            if (typeof date === 'string' && date) {
	                _this.el['dateValue'] = _this.getDate(date);
	            }
	            else if (typeof date === 'object') {
	                _this.el['dateValue'] = date;
	            }
	            else if (typeof date === 'undefined') {
	                _this.el['dateValue'] = null;
	            }
	            var formattedDate = _this.getFormattedDateStr();
	            if (!moment(_this.control.value).isSame(formattedDate))
	                _this.control.setValue(_this.getFormattedDateStr());
	        };
	        _this.hideDatetimePicker = function (event) {
	            if (_this.componentRef) {
	                if (event &&
	                    event.type === 'click' &&
	                    event.target !== _this.el &&
	                    !_this.elementIn(event.target, _this.datetimePickerEl)) {
	                    _this.componentRef.destroy();
	                    _this.componentRef = undefined;
	                }
	                else if (!event) {
	                    _this.componentRef.destroy();
	                    _this.componentRef = undefined;
	                }
	            }
	        };
	        _this.keyEventListener = function (e) {
	            if (e.keyCode === 27) {
	                _this.hideDatetimePicker();
	            }
	        };
	        return _this;
	    }
	    DateTimePickerComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.onInit();
	        this.el = this.viewContainerRef.element.nativeElement
	            .getElementsByTagName('input')[0];
	        if (utilities_1.iOS()) {
	            this.inputType = 'date';
	            return;
	        }
	        var wrapper = document.createElement('div');
	        wrapper.className = 'ng2-datetime-picker';
	        wrapper.style.position = 'relative';
	        this.el.parentElement.insertBefore(wrapper, this.el.nextSibling);
	        wrapper.appendChild(this.el);
	        document.body.addEventListener('click', this.hideDatetimePicker);
	        this.el.addEventListener('keyup', this.keyEventListener);
	        setTimeout(function () {
	            _this.valueChanged(_this.el.value);
	        });
	    };
	    DateTimePickerComponent.prototype.addValidators = function () { };
	    DateTimePickerComponent.prototype.ngOnChanges = function (changes) {
	        var newNgModel;
	        if (changes && changes['ngModel']) {
	            newNgModel = changes['ngModel'].currentValue;
	        }
	        this.triggerChange(newNgModel);
	    };
	    DateTimePickerComponent.prototype.triggerChange = function (newNgModel) {
	        if (this.ctrl) {
	            this.ctrl.markAsDirty();
	        }
	        if (typeof newNgModel === 'string') {
	            this.el['dateValue'] = this.getDate(newNgModel);
	        }
	        else if (newNgModel instanceof Date) {
	            this.el['dateValue'] = newNgModel;
	        }
	    };
	    DateTimePickerComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	        document.body.removeEventListener('click', this.hideDatetimePicker);
	        this.el.removeEventListener('keyup', this.keyEventListener);
	        if (this.datetimePickerEl) {
	            this.datetimePickerEl.removeEventListener('keyup', this.keyEventListener);
	        }
	    };
	    DateTimePickerComponent.prototype.preventDefault = function (event) {
	        if (event) {
	            event.preventDefault();
	            event.stopPropagation();
	        }
	    };
	    DateTimePickerComponent.prototype.showDatetimePicker = function (event) {
	        var _this = this;
	        if (this.componentRef || utilities_1.iOS()) {
	            return;
	        }
	        setTimeout(function () {
	            var factory = _this.resolver.resolveComponentFactory(datetime_picker_popup_component_1.DateTimePickerPopupComponent);
	            _this.componentRef = _this.viewContainerRef.createComponent(factory);
	            _this.datetimePickerEl = _this.componentRef.location.nativeElement;
	            _this.datetimePickerEl.addEventListener('keyup', _this.keyEventListener);
	            var component = _this.componentRef.instance;
	            component.initDateTime(_this.el['dateValue']);
	            component.dateOnly = _this.dateOnly;
	            _this.styleDatetimePicker();
	            component.changes.subscribe(_this.valueChanged);
	            component.closing.subscribe(function () {
	                return _this.closeOnSelect !== false && _this.hideDatetimePicker();
	            });
	        }, 10);
	    };
	    DateTimePickerComponent.prototype.elementIn = function (el, containerEl) {
	        while (el = el.parentNode) {
	            if (el === containerEl)
	                return true;
	        }
	        return false;
	    };
	    DateTimePickerComponent.prototype.styleDatetimePicker = function () {
	        var _this = this;
	        var thisElBCR = this.el.getBoundingClientRect();
	        this.datetimePickerEl.style.width = thisElBCR.width + 'px';
	        this.datetimePickerEl.style.position = 'absolute';
	        this.datetimePickerEl.style.zIndex = '1000';
	        this.datetimePickerEl.style.left = '42px';
	        this.datetimePickerEl.style.transition = 'height 0.3s ease-in';
	        setTimeout(function () {
	            var thisElBcr = _this.el.getBoundingClientRect();
	            var datetimePickerElBcr = _this.datetimePickerEl.getBoundingClientRect();
	            if (thisElBcr.bottom + datetimePickerElBcr.height > window.innerHeight) {
	                _this.datetimePickerEl.style.bottom = '58px';
	            }
	            else {
	                _this.datetimePickerEl.style.top = thisElBcr.height + 'px';
	            }
	            _this.datetimePickerEl.style.visibility = 'visible';
	        });
	    };
	    ;
	    DateTimePickerComponent.prototype.getFormattedDateStr = function () {
	        if (this.el['dateValue']) {
	            if (this.dateFormat) {
	                return datetime_1.DateTime.momentFormatDate(this.el['dateValue'], this.dateFormat);
	            }
	            else {
	                return datetime_1.DateTime.formatDate(this.el['dateValue'], this.dateOnly);
	            }
	        }
	        else {
	            return null;
	        }
	    };
	    DateTimePickerComponent.prototype.getDate = function (arg) {
	        var date;
	        if (typeof arg === 'string') {
	            if (this.dateFormat) {
	                date = datetime_1.DateTime.momentParse(arg, this.dateFormat);
	            }
	            else {
	                date = datetime_1.DateTime.parse(arg);
	            }
	        }
	        else {
	            date = arg;
	        }
	        return date;
	    };
	    return DateTimePickerComponent;
	}(input_base_component_1.InputBase));
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", forms_1.FormGroup)
	], DateTimePickerComponent.prototype, "fg", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], DateTimePickerComponent.prototype, "placeholder", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], DateTimePickerComponent.prototype, "field", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], DateTimePickerComponent.prototype, "label", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateTimePickerComponent.prototype, "floatingLabel", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateTimePickerComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateTimePickerComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], DateTimePickerComponent.prototype, "required", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], DateTimePickerComponent.prototype, "value", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateTimePickerComponent.prototype, "dateFormat", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateTimePickerComponent.prototype, "dateOnly", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateTimePickerComponent.prototype, "hour", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateTimePickerComponent.prototype, "minute", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], DateTimePickerComponent.prototype, "closeOnSelect", void 0);
	DateTimePickerComponent = __decorate([
	    core_1.Component({
	        selector: 'date-time-picker',
	        template: "\n      <div class=\"input-group form-group\" [class.fc-alt]=\"alt\"><span class=\"input-group-addon\"><i class=\"zmdi zmdi-calendar\"></i></span><div class=\"dtp-container fg-line\" [class.disabled]=\"disabled\" [class.fg-toggled]=\"toggled\"><input class=\"form-control date-time-picker\" #i [type]=\"inputType\" placeholder=\"{{placeholder}}\" [formControl]=\"control\" [disabled]=\"disabled\" (focus)=\"onFocus(i); showDatetimePicker($event)\" (blur)=\"onBlur(i)\" (click)=\"preventDefault($event)\" (change)=\"valueChanged($event.target.value)\"></div></div>\n    ",
	        providers: [datetime_1.DateTime],
	    }),
	    __param(3, core_1.Optional()), __param(3, core_1.Host()), __param(3, core_1.SkipSelf()),
	    __metadata("design:paramtypes", [core_1.ElementRef,
	        core_1.ComponentFactoryResolver,
	        core_1.ViewContainerRef,
	        forms_1.ControlContainer])
	], DateTimePickerComponent);
	exports.DateTimePickerComponent = DateTimePickerComponent;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var datetime_1 = __webpack_require__(71);
	var DateTimePickerPopupComponent = (function () {
	    function DateTimePickerPopupComponent(elementRef, dateTime, cdRef) {
	        this.dateTime = dateTime;
	        this.cdRef = cdRef;
	        this.changes = new core_1.EventEmitter();
	        this.closing = new core_1.EventEmitter();
	        this.el = elementRef.nativeElement;
	    }
	    DateTimePickerPopupComponent.prototype.ngAfterViewInit = function () {
	        if (!this.dateOnly) {
	            this._hours.nativeElement.addEventListener('keyup', function (e) {
	                e.stopPropagation();
	            });
	            this._hours.nativeElement.addEventListener('mousedown', function (e) {
	                e.stopPropagation();
	            });
	            this._minutes.nativeElement.addEventListener('keyup', function (e) {
	                e.stopPropagation();
	            });
	            this._minutes.nativeElement.addEventListener('mousedown', function (e) {
	                e.stopPropagation();
	            });
	        }
	    };
	    Object.defineProperty(DateTimePickerPopupComponent.prototype, "year", {
	        get: function () {
	            return this.selectedDate.getFullYear();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DateTimePickerPopupComponent.prototype, "month", {
	        get: function () {
	            return this.selectedDate.getMonth();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DateTimePickerPopupComponent.prototype, "day", {
	        get: function () {
	            return this.selectedDate.getDate();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DateTimePickerPopupComponent.prototype, "today", {
	        get: function () {
	            var dt = new Date();
	            dt.setHours(0);
	            dt.setMinutes(0);
	            dt.setSeconds(0);
	            dt.setMilliseconds(0);
	            return dt;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DateTimePickerPopupComponent.prototype.initDateTime = function (date) {
	        date = date || new Date();
	        this.selectedDate = date;
	        this.hour = this.selectedDate.getHours();
	        this.minute = this.selectedDate.getMinutes();
	        this.monthData = this.dateTime.getMonthData(this.year, this.month);
	    };
	    DateTimePickerPopupComponent.prototype.toDate = function (year, month, day) {
	        return new Date(year, month, day);
	    };
	    DateTimePickerPopupComponent.prototype.toDateOnly = function (date) {
	        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
	    };
	    DateTimePickerPopupComponent.prototype.selectDate = function (dayNum) {
	        if (dayNum) {
	            this.selectedDate = new Date(this.monthData.year, this.monthData.month, dayNum);
	        }
	        this.selectedDate.setHours(parseInt('' + this.hour || '0', 10));
	        this.selectedDate.setMinutes(parseInt('' + this.minute || '0', 10));
	        this.changes.emit(this.selectedDate);
	        this.closing.emit(true);
	    };
	    ;
	    DateTimePickerPopupComponent.prototype.updateMonthData = function (num) {
	        this.monthData = this.dateTime.getMonthData(this.monthData.year, this.monthData.month + num);
	    };
	    return DateTimePickerPopupComponent;
	}());
	__decorate([
	    core_1.ViewChild('hours'),
	    __metadata("design:type", core_1.ElementRef)
	], DateTimePickerPopupComponent.prototype, "_hours", void 0);
	__decorate([
	    core_1.ViewChild('minutes'),
	    __metadata("design:type", core_1.ElementRef)
	], DateTimePickerPopupComponent.prototype, "_minutes", void 0);
	DateTimePickerPopupComponent = __decorate([
	    core_1.Component({
	        providers: [datetime_1.DateTime],
	        selector: 'datetime-picker-popup',
	        template: "\n    <div class=\"datetime-picker\" tabindex=\"0\"><!-- Month - Year--><div class=\"month\"><button class=\"prev\" type=\"button\" (click)=\"updateMonthData(-1)\"><i class=\"zmdi zmdi-chevron-left\"></i></button><span title=\"{{dateTime.months[monthData.month].fullName}}\">{{dateTime.months[monthData.month].fullName}}</span>    {{monthData.year}}<button class=\"next\" type=\"button\" (click)=\"updateMonthData(+1)\"><i class=\"zmdi zmdi-chevron-right\"></i></button></div><div class=\"days\"><!-- Su Mo Tu We Th Fr Sa--><div class=\"day-of-week\" *ngFor=\"let dayOfWeek of dateTime.localizedDaysOfWeek\" [ngClass]=\"{weekend: dayOfWeek.weekend}\" title=\"{{dayOfWeek.fullName}}\">{{dayOfWeek.shortName}}</div><!-- Fill up blank days for this month--><div *ngIf=\"monthData.leadingDays.length &lt; 7\"><div class=\"day\" *ngFor=\"let dayNum of monthData.leadingDays\" [ngClass]=\"{weekend: [0,6].indexOf(toDate(monthData.year, monthData.month-1, dayNum).getDay()) !== -1}\">{{dayNum}}</div></div><div class=\"day selectable\" *ngFor=\"let dayNum of monthData.days\" (click)=\"selectDate(dayNum)\" title=\"{{monthData.year}}-{{monthData.month+1}}-{{dayNum}}\" [ngClass]=\"{    selected:    toDate(monthData.year, monthData.month, dayNum).getTime() === toDateOnly(selectedDate).getTime(),    today:    toDate(monthData.year, monthData.month, dayNum).getTime() === today.getTime(),    weekend:    [0,6].indexOf(toDate(monthData.year, monthData.month, dayNum).getDay()) !== -1    }\">{{dayNum}}</div><!-- Fill up blank days for this month--><div *ngIf=\"monthData.trailingDays.length &lt; 7\"><div class=\"day\" *ngFor=\"let dayNum of monthData.trailingDays\" [ngClass]=\"{weekend: [0,6].indexOf(toDate(monthData.year, monthData.month+1, dayNum).getDay()) !== -1}\">{{dayNum}}</div></div></div><!-- Time--><div class=\"days\" id=\"time\" *ngIf=\"!dateOnly\"><label class=\"timeLabel\">Time:</label><span class=\"timeValue\">{{(\"0\"+hour).slice(-2)}} : {{(\"0\"+minute).slice(-2)}}</span><br><label class=\"hourLabel\">Hour:</label><input class=\"hourInput\" #hours=\"\" (change)=\"selectDate()\" type=\"range\" min=\"0\" max=\"23\" [(ngModel)]=\"hour\"><label class=\"minutesLabel\">Min:</label><input class=\"minutesInput\" #minutes=\"\" (change)=\"selectDate()\" type=\"range\" min=\"0\" max=\"59\" range=\"10\" [(ngModel)]=\"minute\"></div></div><!-- <hr/>--><!-- Date: {{selectedDate}}<br/>--><!-- Hour: {{hour}} Minute: {{minute}}<br/>-->\n  ",
	        styles: ["\n    @keyframes slideDown {\n      0% {\n        transform:  translateY(-10px);\n      }\n      100% {\n        transform: translateY(0px);\n      }\n    }\n\n    .datetime-picker {\n        color: #333;\n        outline-width: 0;\n        font-size: 12px;\n        border: 1px solid #ddd;\n        display: inline-block;\n        background: #fff;\n        animation: slideDown 0.1s ease-in-out;\n        animation-fill-mode: both;\n    }\n    .datetime-picker > .month {\n        text-align: center;\n        line-height: 22px;\n        padding: 20px 10px;\n        background: #2196F3;\n        text-transform: uppercase;\n        font-weight: bold;\n        /*border-bottom: 1px solid #ddd;*/\n        position: relative;\n        color: whitesmoke;\n        font-size: 14px;\n    }\n    .datetime-picker > .month > button {\n        color: whitesmoke;\n        font: normal 14px sans-serif;\n        outline: none;\n        position: absolute;\n        background: transparent;\n        border: none;\n        cursor: pointer;\n    }\n    .datetime-picker > .month > button:hover {\n        color: whitesmoke;\n    }\n    .datetime-picker > .month > button.prev {\n        left: 10px;\n    }\n    .datetime-picker > .month > button.next {\n        right: 10px;\n    }\n    .datetime-picker > .days {\n        width: 224px; /* 30 x 7 */\n        margin: 20px;\n        text-align: center;\n    }\n\n\n    .datetime-picker > .days .day-of-week,\n    .datetime-picker > .days .day {\n        box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        border: 1px solid transparent;\n        width: 32px;\n        line-height: 31px;\n        float: left;\n    }\n    .datetime-picker > .days .day-of-week {\n        font-weight: bold;\n    }\n    .datetime-picker > .days .day-of-week.weekend {\n        color: #ccc;\n        /*background-color: inherit;*/\n    }\n    .datetime-picker > .days .day:not(.selectable) {\n        color: #ccc;\n        cursor: default;\n    }\n    .datetime-picker > .days .weekend {\n        color: #ccc;\n        /*background-color: #eee;*/\n    }\n    .datetime-picker > .days .day.selectable  {\n        cursor: pointer;\n    }\n    .datetime-picker > .days .day.selected {\n        background: #2196F3;\n        color: #fff;\n        border-radius: 50%;\n    }\n    .datetime-picker > .days .day:not(.selected).selectable:hover {\n        background: #eee;\n        border-radius: 50%;\n    }\n    .datetime-picker > .days:after {\n        content: '';\n        display: block;\n        clear: left;\n        height: 0;\n    }\n    .datetime-picker .hourLabel,\n    .datetime-picker .minutesLabel {\n        display: inline-block;\n        width: 40px;\n        text-align: right;\n    }\n    .datetime-picker input[type=range] {\n        width: 150px;\n    }\n  "],
	        encapsulation: core_1.ViewEncapsulation.None,
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, datetime_1.DateTime, core_1.ChangeDetectorRef])
	], DateTimePickerPopupComponent);
	exports.DateTimePickerPopupComponent = DateTimePickerPopupComponent;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var DateTime = DateTime_1 = (function () {
	    function DateTime() {
	        this.initialize();
	    }
	    DateTime.momentFormatDate = function (d, dateFormat) {
	        if (typeof moment === 'undefined') {
	            console.error("momentjs is required with dateFormat.\n        please add <script src=\"moment.min.js\"></script>\"> in your html.");
	        }
	        return moment(d).format(dateFormat);
	    };
	    DateTime.momentParse = function (dateStr, dateFormat) {
	        if (typeof moment === 'undefined') {
	            console.error("momentjs is required with dateFormat.\n        please add <script src=\"moment.min.js\"></script>\"> in your html.");
	        }
	        var date = moment(dateStr, dateFormat).toDate();
	        if (isNaN(date.getTime())) {
	            date = moment(dateStr).toDate();
	        }
	        return date;
	    };
	    DateTime.formatDate = function (d, dateOnly) {
	        var pad0 = function (number) {
	            return ('0' + number).slice(-2);
	        };
	        var ret = d.getFullYear() + '-' + pad0(d.getMonth() + 1) + '-' + pad0(d.getDate());
	        if (!dateOnly) {
	            ret += ' ' + pad0(d.getHours()) + ':' + pad0(d.getMinutes());
	        }
	        return ret;
	    };
	    DateTime.parse = function (dateStr) {
	        dateStr = DateTime_1.removeTimezone(dateStr);
	        dateStr = dateStr + DateTime_1.addDSTOffset(dateStr);
	        return DateTime_1.getDateFromString(dateStr);
	    };
	    DateTime.removeTimezone = function (dateStr) {
	        var matches = dateStr.match(/[0-9]{2}:/);
	        dateStr += matches ? '' : ' 00:00:00';
	        return dateStr.replace(/([0-9]{2}-[0-9]{2})-([0-9]{4})/, '$2-$1')
	            .replace(/([\/-][0-9]{2,4})\ ([0-9]{2}\:[0-9]{2}\:)/, '$1T$2')
	            .replace(/EDT|EST|CDT|CST|MDT|PDT|PST|UT|GMT/g, '')
	            .replace(/\s*\(\)\s*/, '')
	            .replace(/[\-\+][0-9]{2}:?[0-9]{2}$/, '')
	            .replace(/000Z$/, '00');
	    };
	    DateTime.addDSTOffset = function (dateStr) {
	        var date = DateTime_1.getDateFromString(dateStr);
	        var jan = new Date(date.getFullYear(), 0, 1);
	        var jul = new Date(date.getFullYear(), 6, 1);
	        var stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
	        var isDST = date.getTimezoneOffset() < stdTimezoneOffset;
	        var offset = isDST ? stdTimezoneOffset - 60 : stdTimezoneOffset;
	        var diff = offset >= 0 ? '-' : '+';
	        offset = Math.abs(offset);
	        return diff +
	            ('0' + (offset / 60)).slice(-2) + ':' +
	            ('0' + (offset % 60)).slice(-2);
	    };
	    ;
	    DateTime.getDateFromString = function (dateStr) {
	        var tmp = dateStr.split(/[\+\-:\ T]/);
	        return new Date(parseInt(tmp[0], 10), parseInt(tmp[1], 10) - 1, parseInt(tmp[2], 10), parseInt(tmp[3] || '0', 10), parseInt(tmp[4] || '0', 10), parseInt(tmp[5] || '0', 10));
	    };
	    DateTime.prototype.initialize = function () {
	        this.months = [
	            { fullName: 'January', shortName: 'Jan' },
	            { fullName: 'February', shortName: 'Feb' },
	            { fullName: 'March', shortName: 'Mar' },
	            { fullName: 'April', shortName: 'Apr' },
	            { fullName: 'May', shortName: 'May' },
	            { fullName: 'June', shortName: 'Jun' },
	            { fullName: 'July', shortName: 'Jul' },
	            { fullName: 'August', shortName: 'Aug' },
	            { fullName: 'September', shortName: 'Sep' },
	            { fullName: 'October', shortName: 'Oct' },
	            { fullName: 'November', shortName: 'Nov' },
	            { fullName: 'December', shortName: 'Dec' },
	        ];
	        this.days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
	        this.daysOfWeek = [
	            { fullName: 'Sunday', shortName: 'Su', weekend: true },
	            { fullName: 'Monday', shortName: 'Mo' },
	            { fullName: 'Tuesday', shortName: 'Tu' },
	            { fullName: 'Wednesday', shortName: 'We' },
	            { fullName: 'Thursday', shortName: 'Th' },
	            { fullName: 'Friday', shortName: 'Fr' },
	            { fullName: 'Saturday', shortName: 'Sa', weekend: true },
	        ];
	        if (typeof moment !== 'undefined') {
	            this.months = this.months.map(function (el, index) {
	                el.fullName = moment.months()[index];
	                el.shortName = moment.monthsShort()[index];
	                return el;
	            });
	            this.daysOfWeek = this.daysOfWeek.map(function (el, index) {
	                el.fullName = moment.weekdays()[index];
	                el.shortName = moment.weekdaysShort()[index].substr(0, 2);
	                return el;
	            });
	            this.firstDayOfWeek = moment.localeData().firstDayOfWeek();
	        }
	        this.firstDayOfWeek = this.firstDayOfWeek || 0;
	        this.localizedDaysOfWeek = this.daysOfWeek
	            .concat(this.daysOfWeek)
	            .splice(this.firstDayOfWeek, 7);
	    };
	    DateTime.prototype.getMonthData = function (year, month) {
	        year = month > 11 ? year + 1 :
	            month < 0 ? year - 1 : year;
	        month = (month + 12) % 12;
	        var firstDayOfMonth = new Date(year, month, 1);
	        var lastDayOfMonth = new Date(year, month + 1, 0);
	        var lastDayOfPreviousMonth = new Date(year, month, 0);
	        var daysInMonth = lastDayOfMonth.getDate();
	        var daysInLastMonth = lastDayOfPreviousMonth.getDate();
	        var dayOfWeek = firstDayOfMonth.getDay();
	        var leadingDays = (dayOfWeek - this.firstDayOfWeek + 7) % 7 || 7;
	        var trailingDays = this.days.slice(0, 6 * 7 - (leadingDays + daysInMonth));
	        if (trailingDays.length > 7) {
	            trailingDays = trailingDays.slice(0, trailingDays.length - 7);
	        }
	        var monthData = {
	            year: year,
	            month: month,
	            days: this.days.slice(0, daysInMonth),
	            leadingDays: this.days.slice(-leadingDays - (31 - daysInLastMonth), daysInLastMonth),
	            trailingDays: trailingDays,
	        };
	        return monthData;
	    };
	    ;
	    return DateTime;
	}());
	DateTime = DateTime_1 = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [])
	], DateTime);
	exports.DateTime = DateTime;
	var DateTime_1;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(23);
	var forms_1 = __webpack_require__(27);
	var action_item_directive_1 = __webpack_require__(73);
	var actions_component_1 = __webpack_require__(75);
	var actions_service_1 = __webpack_require__(74);
	var app_header_component_1 = __webpack_require__(76);
	var button_component_1 = __webpack_require__(105);
	var button_group_component_1 = __webpack_require__(106);
	var card_action_component_1 = __webpack_require__(107);
	var card_body_component_1 = __webpack_require__(108);
	var card_header_component_1 = __webpack_require__(109);
	var card_padding_directive_1 = __webpack_require__(110);
	var card_component_1 = __webpack_require__(111);
	var header_component_1 = __webpack_require__(112);
	var preloader_component_1 = __webpack_require__(113);
	var preloader_directive_1 = __webpack_require__(114);
	var side_menu_item_component_1 = __webpack_require__(115);
	var side_menu_component_1 = __webpack_require__(116);
	var sidebar_component_1 = __webpack_require__(117);
	var tab_directive_1 = __webpack_require__(118);
	var tab_heading_directive_1 = __webpack_require__(120);
	var tabset_component_1 = __webpack_require__(119);
	var modal_component_1 = __webpack_require__(121);
	var modal_header_component_1 = __webpack_require__(127);
	var modal_body_component_1 = __webpack_require__(128);
	var modal_footer_component_1 = __webpack_require__(129);
	var autofocus_directive_1 = __webpack_require__(130);
	var cropped_image_component_1 = __webpack_require__(131);
	var common_2 = __webpack_require__(34);
	var card_action_component_2 = __webpack_require__(107);
	exports.CardActionComponent = card_action_component_2.CardActionComponent;
	var card_body_component_2 = __webpack_require__(108);
	exports.CardBodyComponent = card_body_component_2.CardBodyComponent;
	var card_header_component_2 = __webpack_require__(109);
	exports.CardHeaderComponent = card_header_component_2.CardHeaderComponent;
	var card_padding_directive_2 = __webpack_require__(110);
	exports.CardPaddingDirective = card_padding_directive_2.CardPaddingDirective;
	var card_component_2 = __webpack_require__(111);
	exports.CardComponent = card_component_2.CardComponent;
	var header_component_2 = __webpack_require__(112);
	exports.HeaderComponent = header_component_2.HeaderComponent;
	var preloader_component_2 = __webpack_require__(113);
	exports.PreloaderComponent = preloader_component_2.PreloaderComponent;
	var preloader_directive_2 = __webpack_require__(114);
	exports.PreLoaderDirective = preloader_directive_2.PreLoaderDirective;
	var side_menu_item_component_2 = __webpack_require__(115);
	exports.SideMenuItemComponent = side_menu_item_component_2.SideMenuItemComponent;
	var side_menu_component_2 = __webpack_require__(116);
	exports.SideMenuComponent = side_menu_component_2.SideMenuComponent;
	var sidebar_component_2 = __webpack_require__(117);
	exports.SidebarComponent = sidebar_component_2.SidebarComponent;
	var tab_directive_2 = __webpack_require__(118);
	exports.TabDirective = tab_directive_2.TabDirective;
	var tab_heading_directive_2 = __webpack_require__(120);
	exports.TabHeadingDirective = tab_heading_directive_2.TabHeadingDirective;
	var tabset_component_2 = __webpack_require__(119);
	exports.TabsetComponent = tabset_component_2.TabsetComponent;
	var modal_component_2 = __webpack_require__(121);
	exports.ModalComponent = modal_component_2.ModalComponent;
	var modal_header_component_2 = __webpack_require__(127);
	exports.ModalHeaderComponent = modal_header_component_2.ModalHeaderComponent;
	var modal_body_component_2 = __webpack_require__(128);
	exports.ModalBodyComponent = modal_body_component_2.ModalBodyComponent;
	var modal_footer_component_2 = __webpack_require__(129);
	exports.ModalFooterComponent = modal_footer_component_2.ModalFooterComponent;
	var autofocus_directive_2 = __webpack_require__(130);
	exports.AutofocusDirective = autofocus_directive_2.AutofocusDirective;
	var cropped_image_component_2 = __webpack_require__(131);
	exports.CroppedImageComponent = cropped_image_component_2.CroppedImageComponent;
	var common_3 = __webpack_require__(34);
	exports.NgTranscludeDirective = common_3.NgTranscludeDirective;
	var MaterialUserInterfaceModule = (function () {
	    function MaterialUserInterfaceModule() {
	    }
	    return MaterialUserInterfaceModule;
	}());
	MaterialUserInterfaceModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            common_1.CommonModule,
	            forms_1.ReactiveFormsModule,
	        ],
	        declarations: [
	            common_2.NgTranscludeDirective,
	            action_item_directive_1.ActionItemDirective,
	            actions_component_1.ActionsComponent,
	            app_header_component_1.AppHeaderComponent,
	            button_component_1.ButtonComponent,
	            button_group_component_1.ButtonGroupComponent,
	            card_action_component_1.CardActionComponent,
	            card_body_component_1.CardBodyComponent,
	            card_header_component_1.CardHeaderComponent,
	            card_padding_directive_1.CardPaddingDirective,
	            card_component_1.CardComponent,
	            header_component_1.HeaderComponent,
	            preloader_component_1.PreloaderComponent,
	            preloader_directive_1.PreLoaderDirective,
	            side_menu_item_component_1.SideMenuItemComponent,
	            side_menu_component_1.SideMenuComponent,
	            sidebar_component_1.SidebarComponent,
	            tab_directive_1.TabDirective,
	            tab_heading_directive_1.TabHeadingDirective,
	            tabset_component_1.TabsetComponent,
	            modal_component_1.ModalComponent,
	            modal_header_component_1.ModalHeaderComponent,
	            modal_body_component_1.ModalBodyComponent,
	            modal_footer_component_1.ModalFooterComponent,
	            autofocus_directive_1.AutofocusDirective,
	            cropped_image_component_1.CroppedImageComponent,
	        ],
	        exports: [
	            action_item_directive_1.ActionItemDirective,
	            actions_component_1.ActionsComponent,
	            app_header_component_1.AppHeaderComponent,
	            button_component_1.ButtonComponent,
	            button_group_component_1.ButtonGroupComponent,
	            card_action_component_1.CardActionComponent,
	            card_body_component_1.CardBodyComponent,
	            card_header_component_1.CardHeaderComponent,
	            card_padding_directive_1.CardPaddingDirective,
	            card_component_1.CardComponent,
	            header_component_1.HeaderComponent,
	            preloader_component_1.PreloaderComponent,
	            preloader_directive_1.PreLoaderDirective,
	            side_menu_item_component_1.SideMenuItemComponent,
	            side_menu_component_1.SideMenuComponent,
	            sidebar_component_1.SidebarComponent,
	            tab_directive_1.TabDirective,
	            tab_heading_directive_1.TabHeadingDirective,
	            tabset_component_1.TabsetComponent,
	            modal_component_1.ModalComponent,
	            modal_header_component_1.ModalHeaderComponent,
	            modal_body_component_1.ModalBodyComponent,
	            modal_footer_component_1.ModalFooterComponent,
	            autofocus_directive_1.AutofocusDirective,
	            cropped_image_component_1.CroppedImageComponent,
	        ],
	        providers: [
	            actions_service_1.ActionsService,
	        ],
	    }),
	    __metadata("design:paramtypes", [])
	], MaterialUserInterfaceModule);
	exports.MaterialUserInterfaceModule = MaterialUserInterfaceModule;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var menu_item_1 = __webpack_require__(39);
	var actions_service_1 = __webpack_require__(74);
	var ActionItemDirective = (function () {
	    function ActionItemDirective(_el, _renderer, _actionsService) {
	        this._el = _el;
	        this._renderer = _renderer;
	        this._actionsService = _actionsService;
	    }
	    ActionItemDirective.prototype.ngAfterViewInit = function () {
	        this._createAnchor(this._el.nativeElement, this.actionItem);
	    };
	    ActionItemDirective.prototype.onActionClicked = function ($event, menuItem) {
	        $event.preventDefault();
	        var item = menuItem ? menuItem : this.actionItem;
	        if (!item.children) {
	            this._actionsService.announceAction(item);
	        }
	    };
	    ActionItemDirective.prototype._createAnchor = function (ele, menuItem, submenu) {
	        var _this = this;
	        if (submenu === void 0) { submenu = false; }
	        var anchor = this._renderer.createElement(ele, 'a');
	        this._renderer.setElementAttribute(anchor, 'href', '');
	        if (submenu) {
	            this._renderer.listen(anchor, 'click', function (event) {
	                _this.onActionClicked(event, menuItem);
	            });
	        }
	        var icon = menuItem.icon;
	        if (icon) {
	            var i = this._renderer.createElement(anchor, 'i');
	            this._renderer.setElementClass(i, 'zmdi', true);
	            this._renderer.setElementClass(i, "zmdi-" + icon, true);
	            if (this._actionsService.showBig) {
	                this._renderer.setElementClass(i, 'tm-icon', true);
	            }
	        }
	        var title = menuItem.title;
	        if (title) {
	            this._renderer.createText(anchor, title);
	        }
	        if (menuItem.children) {
	            this._renderer.setElementClass(ele, 'dropdown', true);
	            this._renderer.setElementAttribute(ele, 'data-toggle', 'dropdown');
	            var ul_1 = this._renderer.createElement(ele, 'ul');
	            this._renderer.setElementClass(ul_1, 'dropdown-menu', true);
	            this._renderer.setElementClass(ul_1, 'dm-icon', true);
	            this._renderer.setElementClass(ul_1, 'dropdown-menu-right', true);
	            this.actionItem.children.forEach(function (item) {
	                var li = _this._renderer.createElement(ul_1, 'li');
	                _this._createAnchor(li, item, true);
	            });
	        }
	    };
	    return ActionItemDirective;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", menu_item_1.MenuItem)
	], ActionItemDirective.prototype, "actionItem", void 0);
	__decorate([
	    core_1.HostListener('click', ['$event']),
	    __metadata("design:type", Function),
	    __metadata("design:paramtypes", [MouseEvent, menu_item_1.MenuItem]),
	    __metadata("design:returntype", void 0)
	], ActionItemDirective.prototype, "onActionClicked", null);
	ActionItemDirective = __decorate([
	    core_1.Directive({ selector: '[actionItem]' }),
	    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer, actions_service_1.ActionsService])
	], ActionItemDirective);
	exports.ActionItemDirective = ActionItemDirective;


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var Subject_1 = __webpack_require__(3);
	var ActionsService = (function () {
	    function ActionsService() {
	        this.actionClickedSource = new Subject_1.Subject();
	        this.actionClicked$ = this.actionClickedSource.asObservable();
	    }
	    ActionsService.prototype.announceAction = function (action) {
	        this.actionClickedSource.next(action);
	    };
	    return ActionsService;
	}());
	ActionsService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [])
	], ActionsService);
	exports.ActionsService = ActionsService;


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var actions_service_1 = __webpack_require__(74);
	var ActionsComponent = (function () {
	    function ActionsComponent(actionsService) {
	        var _this = this;
	        this.actionsService = actionsService;
	        this.alt = false;
	        this.showBig = false;
	        this.color = 'light-gray';
	        this.actionClicked = new core_1.EventEmitter();
	        actionsService.actionClicked$.subscribe(function (actionItem) {
	            _this.actionClicked.emit(actionItem);
	        });
	    }
	    ActionsComponent.prototype.ngOnInit = function () {
	        this.actionsService.showBig = this.showBig;
	        if (!this.actionItems || this.actionItems.length === 0) {
	            throw 'Actions component need actions to show';
	        }
	    };
	    Object.defineProperty(ActionsComponent.prototype, "dropdown", {
	        get: function () {
	            return this.actionItems.some(function (item) {
	                return item.children !== undefined;
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return ActionsComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Array)
	], ActionsComponent.prototype, "actionItems", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], ActionsComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], ActionsComponent.prototype, "showBig", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ActionsComponent.prototype, "color", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], ActionsComponent.prototype, "actionClicked", void 0);
	ActionsComponent = __decorate([
	    core_1.Component({
	        selector: 'actions',
	        template: "\n    <ul class=\"actions c-{{color}}\" [ngClass]=\"{ 'actions-alt': alt, 'dropdown': dropdown }\" [class.actions]=\"!showBig\" [class.top-menu]=\"showBig\"><li *ngFor=\"let item of actionItems\" [actionItem]=\"item\"></li></ul>\n  ",
	        providers: [actions_service_1.ActionsService],
	    }),
	    __metadata("design:paramtypes", [actions_service_1.ActionsService])
	], ActionsComponent);
	exports.ActionsComponent = ActionsComponent;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var AppHeaderComponent = (function () {
	    function AppHeaderComponent(_router) {
	        this._router = _router;
	        this.sidebarOpen = false;
	        this.logoHref = '/';
	        this.backActive = false;
	        this.onSidebarToggle = new core_1.EventEmitter();
	        this.onActionClicked = new core_1.EventEmitter();
	        this.onbackActionClicked = new core_1.EventEmitter();
	    }
	    AppHeaderComponent.prototype.toggleSidebar = function () {
	        this.sidebarOpen = !this.sidebarOpen;
	        this.onSidebarToggle.emit(this.sidebarOpen);
	    };
	    AppHeaderComponent.prototype.headerActionClicked = function (item) {
	        this.onActionClicked.emit(item);
	    };
	    AppHeaderComponent.prototype.backActionClicked = function () {
	        this.onbackActionClicked.emit();
	    };
	    return AppHeaderComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AppHeaderComponent.prototype, "color", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], AppHeaderComponent.prototype, "addMenuTrigger", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AppHeaderComponent.prototype, "brand", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], AppHeaderComponent.prototype, "sidebarOpen", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Array)
	], AppHeaderComponent.prototype, "actions", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AppHeaderComponent.prototype, "logoPath", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AppHeaderComponent.prototype, "logoHref", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], AppHeaderComponent.prototype, "backActive", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], AppHeaderComponent.prototype, "onSidebarToggle", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], AppHeaderComponent.prototype, "onActionClicked", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], AppHeaderComponent.prototype, "onbackActionClicked", void 0);
	AppHeaderComponent = __decorate([
	    core_1.Component({
	        selector: 'app-header',
	        template: "\n      <header class=\"clearfix animated slideInDown\" id=\"header\" [attr.data-current-skin]=\"color\"><ul class=\"header-inner\"><!-- menu trigger--><li id=\"menu-trigger\" [attr.data-trigger]=\"'#sidebar'\" *ngIf=\"addMenuTrigger &amp;&amp; !backActive\" [class.open]=\"sidebarOpen\" (click)=\"toggleSidebar()\"><div class=\"line-wrap\"><div class=\"line top\"></div><div class=\"line center\"></div><div class=\"line bottom\"></div></div></li><li id=\"menu-trigger\" *ngIf=\"backActive\" (click)=\"backActionClicked()\" [class.open]=\"backActive\"><div class=\"line-wrap\"><div class=\"line top\"></div><div class=\"line center\"></div><div class=\"line bottom\"></div></div></li><!-- brand--><li class=\"logo\" *ngIf=\"brand\"><a [href]=\"logoHref\">{{brand}}</a></li><!-- logo--><li *ngIf=\"!brand &amp;&amp; logo\"><a class=\"m-l-10\" [href]=\"logoHref\"><img [src]=\"logoPath\"></a></li><li class=\"pull-right\" *ngIf=\"actions\"><actions color=\"white\" [actionItems]=\"actions\" [showBig]=\"true\" (actionClicked)=\"headerActionClicked($event)\"></actions></li></ul><!-- for extra content injection--><ng-content></ng-content></header>\n    ",
	    }),
	    __metadata("design:paramtypes", [router_1.Router])
	], AppHeaderComponent);
	exports.AppHeaderComponent = AppHeaderComponent;


/***/ },
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var ButtonComponent = (function () {
	    function ButtonComponent() {
	        this.type = 'button';
	        this.size = '';
	        this.clicked = new core_1.EventEmitter();
	    }
	    Object.defineProperty(ButtonComponent.prototype, "iconAndtext", {
	        get: function () {
	            return this.title !== undefined && this.icon !== undefined && !this.circular;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ButtonComponent.prototype.ngOnInit = function () {
	        if (this.simple) {
	            this.simpleColor = this.color;
	            this.color = null;
	        }
	    };
	    ButtonComponent.prototype.onClick = function (e) {
	        e.preventDefault();
	        this.clicked.emit(null);
	    };
	    return ButtonComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ButtonComponent.prototype, "title", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ButtonComponent.prototype, "color", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ButtonComponent.prototype, "icon", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], ButtonComponent.prototype, "block", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], ButtonComponent.prototype, "circular", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], ButtonComponent.prototype, "rounded", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], ButtonComponent.prototype, "simple", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], ButtonComponent.prototype, "type", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ButtonComponent.prototype, "size", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], ButtonComponent.prototype, "disabled", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], ButtonComponent.prototype, "clicked", void 0);
	ButtonComponent = __decorate([
	    core_1.Component({
	        selector: 'bw-button',
	        template: "\n      <button class=\"btn waves-effect bgm-{{color}} c-{{simpleColor}} btn-{{size}}\" type=\"{{type}}\" [class.btn-icon-text]=\"iconAndtext\" [class.btn-block]=\"block\" [class.waves-circle]=\"circular\" [class.waves-float]=\"circular\" [class.btn-icon]=\"circular\" [class.btn-rounded]=\"rounded\" [class.btn-link]=\"simple\" [disabled]=\"disabled\" (click)=\"onClick($event)\"><i class=\"zmdi zmdi-{{icon}}\" *ngIf=\"icon\"></i>{{title}}</button>\n    ",
	    }),
	    __metadata("design:paramtypes", [])
	], ButtonComponent);
	exports.ButtonComponent = ButtonComponent;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var ButtonGroupComponent = (function () {
	    function ButtonGroupComponent() {
	        this.size = 'default';
	        this.optionSelected = new core_1.EventEmitter();
	    }
	    ButtonGroupComponent.prototype.activateOption = function (option) {
	        this.activeOption = option;
	        this.optionSelected.emit(option);
	    };
	    return ButtonGroupComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Array)
	], ButtonGroupComponent.prototype, "options", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ButtonGroupComponent.prototype, "type", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ButtonGroupComponent.prototype, "activeOption", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ButtonGroupComponent.prototype, "size", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], ButtonGroupComponent.prototype, "optionSelected", void 0);
	ButtonGroupComponent = __decorate([
	    core_1.Component({
	        selector: 'bw-button-group',
	        template: "\n    <div class=\"btn-group btn-group-{{size}}\"><button class=\"btn waves-effect btn-{{type}}\" *ngFor=\"let o of options\" type=\"button\" (click)=\"activateOption(o)\" [class.active]=\"o === activeOption\">{{o}}</button></div>\n  ",
	    }),
	    __metadata("design:paramtypes", [])
	], ButtonGroupComponent);
	exports.ButtonGroupComponent = ButtonGroupComponent;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var CardActionComponent = (function () {
	    function CardActionComponent() {
	        this.actionClicked = new core_1.EventEmitter();
	    }
	    CardActionComponent.prototype.onClicked = function (event) {
	        event.preventDefault();
	        this.actionClicked.emit(null);
	    };
	    return CardActionComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], CardActionComponent.prototype, "color", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], CardActionComponent.prototype, "icon", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], CardActionComponent.prototype, "actionClicked", void 0);
	CardActionComponent = __decorate([
	    core_1.Component({
	        selector: 'card-action',
	        template: "\n      <button class=\"btn btn-float waves-effect bgm-{{color}}\" (click)=\"onClicked($event)\"><i class=\"zmdi zmdi-{{icon}}\"></i></button>\n    ",
	    }),
	    __metadata("design:paramtypes", [])
	], CardActionComponent);
	exports.CardActionComponent = CardActionComponent;


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var CardBodyComponent = (function () {
	    function CardBodyComponent() {
	        this.padded = false;
	    }
	    CardBodyComponent.prototype.ngOnInit = function () { };
	    return CardBodyComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], CardBodyComponent.prototype, "padded", void 0);
	CardBodyComponent = __decorate([
	    core_1.Component({
	        selector: 'card-body',
	        template: "\n      <div class=\"card-body\" [class.card-padding]=\"padded\"><ng-content></ng-content></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [])
	], CardBodyComponent);
	exports.CardBodyComponent = CardBodyComponent;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var CardHeaderComponent = (function () {
	    function CardHeaderComponent() {
	        this.padded = false;
	        this.color = 'default';
	    }
	    CardHeaderComponent.prototype.ngAfterViewInit = function () { };
	    Object.defineProperty(CardHeaderComponent.prototype, "defaultHeader", {
	        get: function () {
	            return this.color === 'default';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CardHeaderComponent.prototype, "customColor", {
	        get: function () {
	            if (this.color === 'default' || this.color === 'white') {
	                return '';
	            }
	            return 'bgm-' + this.color;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return CardHeaderComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], CardHeaderComponent.prototype, "padded", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], CardHeaderComponent.prototype, "color", void 0);
	CardHeaderComponent = __decorate([
	    core_1.Component({
	        selector: 'card-header',
	        template: "\n      <div class=\"card-header {{customColor}}\" [class.card-padding]=\"padded\" [class.ch-alt]=\"defaultHeader\"><ng-content></ng-content></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [])
	], CardHeaderComponent);
	exports.CardHeaderComponent = CardHeaderComponent;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var CardPaddingDirective = (function () {
	    function CardPaddingDirective() {
	    }
	    return CardPaddingDirective;
	}());
	CardPaddingDirective = __decorate([
	    core_1.Directive({
	        selector: '[card-padding]',
	        host: { '[class.card-padding]': 'true' },
	    }),
	    __metadata("design:paramtypes", [])
	], CardPaddingDirective);
	exports.CardPaddingDirective = CardPaddingDirective;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var CardComponent = (function () {
	    function CardComponent() {
	    }
	    Object.defineProperty(CardComponent.prototype, "depthClass", {
	        get: function () {
	            return this.depth ? "z-depth-" + this.depth : '';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CardComponent.prototype, "topDepthClass", {
	        get: function () {
	            return !this.depth && this.topDepth ? "z-depth-" + this.topDepth + "-top" : '';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return CardComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], CardComponent.prototype, "depth", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], CardComponent.prototype, "topDepth", void 0);
	CardComponent = __decorate([
	    core_1.Component({
	        selector: 'card',
	        template: "\n      <div class=\"card {{depthClass}} {{topDepthClass}}\"><ng-content></ng-content></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [])
	], CardComponent);
	exports.CardComponent = CardComponent;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var HeaderComponent = (function () {
	    function HeaderComponent() {
	    }
	    HeaderComponent.prototype.ngOnInit = function () { };
	    return HeaderComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], HeaderComponent.prototype, "block", void 0);
	HeaderComponent = __decorate([
	    core_1.Component({
	        selector: 'bw-header',
	        template: "\n      <div [class.block-header]=\"block\"><ng-content></ng-content></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [])
	], HeaderComponent);
	exports.HeaderComponent = HeaderComponent;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var PreloaderComponent = (function () {
	    function PreloaderComponent() {
	    }
	    return PreloaderComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PreloaderComponent.prototype, "color", void 0);
	PreloaderComponent = __decorate([
	    core_1.Component({
	        selector: 'bw-preloader',
	        template: "\n    <div class=\"preloader pl-xxl pls-{{color}}\"><svg class=\"pl-circular\" viewbox=\"25 25 50 50\"><svg:circle class=\"plc-path\" cx=\"50\" cy=\"50\" r=\"20\"></svg:circle></svg></div>\n  ",
	    }),
	    __metadata("design:paramtypes", [])
	], PreloaderComponent);
	exports.PreloaderComponent = PreloaderComponent;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var PreLoaderDirective = (function () {
	    function PreLoaderDirective(_el, _renderer) {
	        this._el = _el;
	        this._renderer = _renderer;
	    }
	    PreLoaderDirective.prototype.ngAfterViewInit = function () {
	        var r = this._renderer;
	        var ele = this._el.nativeElement;
	        r.setElementClass(ele, 'preloader', true);
	        r.setElementClass(ele, 'pl-xxl', true);
	        var svg = r.createElement(ele, 'svg');
	        r.setElementClass(svg, 'pl-circular', true);
	        r.setElementAttribute(svg, 'viewBox', '25 25 50 50');
	        var circle = r.createElement(svg, 'circle');
	        r.setElementClass(circle, 'plc-path', true);
	        r.setElementAttribute(circle, 'cx', '50');
	        r.setElementAttribute(circle, 'cy', '50');
	        r.setElementAttribute(circle, 'r', '20');
	    };
	    return PreLoaderDirective;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], PreLoaderDirective.prototype, "preLoader", void 0);
	PreLoaderDirective = __decorate([
	    core_1.Directive({ selector: '[bwPreloader]' }),
	    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer])
	], PreLoaderDirective);
	exports.PreLoaderDirective = PreLoaderDirective;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var menu_item_1 = __webpack_require__(39);
	var SideMenuItemComponent = (function () {
	    function SideMenuItemComponent(_router) {
	        this._router = _router;
	        this.itemClicked = new core_1.EventEmitter();
	        this.expanded = false;
	    }
	    SideMenuItemComponent.prototype.ngOnInit = function () { };
	    SideMenuItemComponent.prototype.onItemClicked = function (e) {
	        e.preventDefault();
	        if (!this.item.children) {
	            this.itemClicked.emit(this.item);
	        }
	        if (this.item.children && this.item.children.length > 0) {
	            this.expanded = !this.expanded;
	            return;
	        }
	        if (this.item.route) {
	            this._router.navigate([this.item.route]);
	        }
	        else if (this.item.url) {
	            this._router.navigateByUrl(this.item.url);
	        }
	        else if (this.item.externalUrl) {
	            window.open(this.item.externalUrl);
	        }
	    };
	    return SideMenuItemComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], SideMenuItemComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", menu_item_1.MenuItem)
	], SideMenuItemComponent.prototype, "item", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], SideMenuItemComponent.prototype, "itemClicked", void 0);
	SideMenuItemComponent = __decorate([
	    core_1.Component({
	        selector: 'side-menu-item',
	        template: "\n      <li [ngClass]=\"{ 'active': active, 'toggled': expanded, 'sub-menu': item.children }\" (click)=\"onItemClicked($event)\"><a href=\"\" (click)=\"$event.preventDefault()\" [class.fc-alt]=\"alt\"><i class=\"zmdi zmdi-{{item.icon}}\" *ngIf=\"item.icon\"></i>{{item.title}}</a><ul [@isVisibleChanged]=\"expanded\" *ngIf=\"item.children\"><side-menu-item [item]=\"child\" *ngFor=\"let child of item.children\"></side-menu-item></ul></li>\n    ",
	        animations: [
	            core_1.trigger('isVisibleChanged', [
	                core_1.state('true', core_1.style({ opacity: 1 })),
	                core_1.state('false', core_1.style({ opacity: 0, height: 0 })),
	                core_1.transition('* => *', core_1.animate('.2s')),
	            ]),
	        ],
	    }),
	    __metadata("design:paramtypes", [router_1.Router])
	], SideMenuItemComponent);
	exports.SideMenuItemComponent = SideMenuItemComponent;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var SideMenuComponent = (function () {
	    function SideMenuComponent() {
	        this.alt = false;
	        this.itemClicked = new core_1.EventEmitter();
	    }
	    SideMenuComponent.prototype.onItemClicked = function (item) {
	        this.itemClicked.emit(item);
	    };
	    return SideMenuComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], SideMenuComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Array)
	], SideMenuComponent.prototype, "items", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], SideMenuComponent.prototype, "itemClicked", void 0);
	SideMenuComponent = __decorate([
	    core_1.Component({
	        selector: 'side-menu',
	        template: "\n      <ul class=\"main-menu\"><side-menu-item *ngFor=\"let item of items\" [item]=\"item\" (itemClicked)=\"onItemClicked($event)\" [alt]=\"alt\"></side-menu-item></ul>\n    ",
	    }),
	    __metadata("design:paramtypes", [])
	], SideMenuComponent);
	exports.SideMenuComponent = SideMenuComponent;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var SidebarComponent = (function () {
	    function SidebarComponent() {
	        this.fullHeight = false;
	    }
	    return SidebarComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], SidebarComponent.prototype, "open", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], SidebarComponent.prototype, "fullHeight", void 0);
	SidebarComponent = __decorate([
	    core_1.Component({
	        selector: 'sidebar',
	        template: "\n      <aside class=\"sidebar c-overflow\" id=\"sidebar\" style=\"overflow: visible\" [ngClass]=\"{ 'toggled': open, 'full-height': fullHeight }\"><div id=\"mCSB_1\" tabindex=\"0\" style=\"height: 100%\"><div style=\"position: relative; top: 0px; left: 0px; width: 100%; height: 100%; overflow: auto\" dir=\"ltr\"><ng-content></ng-content></div></div></aside>\n    ",
	    }),
	    __metadata("design:paramtypes", [])
	], SidebarComponent);
	exports.SidebarComponent = SidebarComponent;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var tabset_component_1 = __webpack_require__(119);
	var TabDirective = (function () {
	    function TabDirective(tabset) {
	        this.select = new core_1.EventEmitter(false);
	        this.deselect = new core_1.EventEmitter(false);
	        this.removed = new core_1.EventEmitter(false);
	        this.addClass = true;
	        this.tabset = tabset;
	        this.tabset.addTab(this);
	    }
	    Object.defineProperty(TabDirective.prototype, "active", {
	        get: function () {
	            return this._active;
	        },
	        set: function (active) {
	            var _this = this;
	            if (this.disabled && active || !active) {
	                if (!active) {
	                    this._active = active;
	                }
	                this.deselect.emit(this);
	                return;
	            }
	            this._active = active;
	            this.select.emit(this);
	            this.tabset.tabs.forEach(function (tab) {
	                if (tab !== _this) {
	                    tab.active = false;
	                }
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TabDirective.prototype.ngOnInit = function () { this.removable = !!this.removable; };
	    TabDirective.prototype.ngOnDestroy = function () {
	        this.tabset.removeTab(this);
	    };
	    return TabDirective;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TabDirective.prototype, "heading", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], TabDirective.prototype, "disabled", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], TabDirective.prototype, "removable", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], TabDirective.prototype, "icon", void 0);
	__decorate([
	    core_1.HostBinding('class.active'),
	    core_1.Input(),
	    __metadata("design:type", Boolean),
	    __metadata("design:paramtypes", [])
	], TabDirective.prototype, "active", null);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", core_1.EventEmitter)
	], TabDirective.prototype, "select", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", core_1.EventEmitter)
	], TabDirective.prototype, "deselect", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", core_1.EventEmitter)
	], TabDirective.prototype, "removed", void 0);
	__decorate([
	    core_1.HostBinding('class.tab-pane'),
	    __metadata("design:type", Boolean)
	], TabDirective.prototype, "addClass", void 0);
	TabDirective = __decorate([
	    core_1.Directive({ selector: 'tab, [tab]' }),
	    __metadata("design:paramtypes", [tabset_component_1.TabsetComponent])
	], TabDirective);
	exports.TabDirective = TabDirective;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var TabsetComponent = (function () {
	    function TabsetComponent() {
	        this.alt = false;
	        this.clazz = true;
	        this.tabs = [];
	        this.classMap = {};
	    }
	    Object.defineProperty(TabsetComponent.prototype, "iconTab", {
	        get: function () { return this._iconTab; },
	        set: function (value) {
	            this._iconTab = value;
	            this.setClassMap();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TabsetComponent.prototype.ngOnInit = function () {
	    };
	    TabsetComponent.prototype.ngOnDestroy = function () {
	        this.isDestroyed = true;
	    };
	    TabsetComponent.prototype.tabClicked = function (tab) {
	        tab.active = true;
	    };
	    TabsetComponent.prototype.selectTab = function (index) {
	        if (index < 1 || index > this.tabs.length) {
	            console.error('Tab index out of range');
	        }
	        var tab = this.tabs[index - 1];
	        tab.active = true;
	    };
	    TabsetComponent.prototype.addTab = function (tab) {
	        this.tabs.push(tab);
	        tab.active = this.tabs.length === 1 && tab.active !== false;
	    };
	    TabsetComponent.prototype.removeTab = function (tab) {
	        var index = this.tabs.indexOf(tab);
	        if (index === -1 || this.isDestroyed) {
	            return;
	        }
	        if (tab.active && this.hasAvailableTabs(index)) {
	            var newActiveIndex = this.getClosestTabIndex(index);
	            this.tabs[newActiveIndex].active = true;
	        }
	        tab.removed.emit(tab);
	        this.tabs.splice(index, 1);
	    };
	    TabsetComponent.prototype.getClosestTabIndex = function (index) {
	        var tabsLength = this.tabs.length;
	        if (!tabsLength) {
	            return -1;
	        }
	        for (var step = 1; step <= tabsLength; step += 1) {
	            var prevIndex = index - step;
	            var nextIndex = index + step;
	            if (this.tabs[prevIndex] && !this.tabs[prevIndex].disabled) {
	                return prevIndex;
	            }
	            if (this.tabs[nextIndex] && !this.tabs[nextIndex].disabled) {
	                return nextIndex;
	            }
	        }
	        return -1;
	    };
	    TabsetComponent.prototype.hasAvailableTabs = function (index) {
	        var tabsLength = this.tabs.length;
	        if (!tabsLength) {
	            return false;
	        }
	        for (var i = 0; i < tabsLength; i += 1) {
	            if (!this.tabs[i].disabled && i !== index) {
	                return true;
	            }
	        }
	        return false;
	    };
	    TabsetComponent.prototype.setClassMap = function () {
	        this.classMap = {
	            'tn-icon': this.iconTab,
	        };
	    };
	    return TabsetComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean),
	    __metadata("design:paramtypes", [])
	], TabsetComponent.prototype, "iconTab", null);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], TabsetComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.HostBinding('class.tab-container'),
	    __metadata("design:type", Boolean)
	], TabsetComponent.prototype, "clazz", void 0);
	TabsetComponent = __decorate([
	    core_1.Component({
	        selector: 'tabset',
	        template: "\n    <ul class=\"tab-nav tn-justified\" role=\"tablist\" (click)=\"$event.preventDefault()\" [ngClass]=\"classMap\" [class.ts-alt]=\"alt\"><li class=\"nav-item\" *ngFor=\"let tabz of tabs\" [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\" role=\"presentation\"><a class=\"nav-link\" href=\"\" [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\" (click)=\"tabClicked(tabz)\"><i class=\"zmdi zmdi-{{tabz.icon}}\" *ngIf=\"tabz.icon\" [ngClass]=\"{ 'icon-tab': iconTab }\"></i><span [ngTransclude]=\"tabz.headingRef\">{{tabz.heading}}</span><span *ngIf=\"tabz.removable\"><span class=\"zmdi zmdi-close-circle\" (click)=\"$event.preventDefault(); removeTab(tabz);\"></span></span></a></li></ul><div class=\"tab-content\"><ng-content></ng-content></div>\n  ",
	    }),
	    __metadata("design:paramtypes", [])
	], TabsetComponent);
	exports.TabsetComponent = TabsetComponent;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var tab_directive_1 = __webpack_require__(118);
	var TabHeadingDirective = (function () {
	    function TabHeadingDirective(templateRef, tab) {
	        tab.headingRef = templateRef;
	    }
	    return TabHeadingDirective;
	}());
	TabHeadingDirective = __decorate([
	    core_1.Directive({ selector: '[tabHeading]' }),
	    __metadata("design:paramtypes", [core_1.TemplateRef, tab_directive_1.TabDirective])
	], TabHeadingDirective);
	exports.TabHeadingDirective = TabHeadingDirective;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var modal_instance_model_1 = __webpack_require__(122);
	var ModalComponent = (function () {
	    function ModalComponent(element) {
	        var _this = this;
	        this.element = element;
	        this.visible = false;
	        this.animation = true;
	        this.backdrop = true;
	        this.keyboard = true;
	        this.cssClass = '';
	        this.onClose = new core_1.EventEmitter(false);
	        this.onDismiss = new core_1.EventEmitter(false);
	        this.onOpen = new core_1.EventEmitter(false);
	        this.overrideSize = null;
	        this.instance = new modal_instance_model_1.ModalInstance(this.element);
	        this.instance.hidden.subscribe(function (result) {
	            _this.visible = _this.instance.visible;
	            if (result === modal_instance_model_1.ModalResult.Dismiss) {
	                _this.onDismiss.emit(undefined);
	            }
	        });
	        this.instance.shown.subscribe(function () {
	            _this.onOpen.emit(undefined);
	        });
	    }
	    Object.defineProperty(ModalComponent.prototype, "fadeClass", {
	        get: function () {
	            return this.animation;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ModalComponent.prototype, "dataKeyboardAttr", {
	        get: function () {
	            return this.keyboard;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ModalComponent.prototype, "dataBackdropAttr", {
	        get: function () {
	            return this.backdrop;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ModalComponent.prototype.ngOnDestroy = function () {
	        return this.instance && this.instance.destroy();
	    };
	    ModalComponent.prototype.routerCanDeactivate = function () {
	        return this.ngOnDestroy();
	    };
	    ModalComponent.prototype.open = function (size) {
	        var _this = this;
	        if (ModalSize.validSize(size))
	            this.overrideSize = size;
	        return this.instance.open().then(function () {
	            _this.visible = _this.instance.visible;
	        });
	    };
	    ModalComponent.prototype.close = function (value) {
	        var _this = this;
	        return this.instance.close().then(function () {
	            _this.onClose.emit(value);
	        });
	    };
	    ModalComponent.prototype.dismiss = function () {
	        return this.instance.dismiss();
	    };
	    ModalComponent.prototype.getCssClasses = function () {
	        var classes = [];
	        if (this.isSmall()) {
	            classes.push('modal-sm');
	        }
	        if (this.isLarge()) {
	            classes.push('modal-lg');
	        }
	        if (this.cssClass !== '') {
	            classes.push(this.cssClass);
	        }
	        return classes.join(' ');
	    };
	    ModalComponent.prototype.isSmall = function () {
	        return this.overrideSize !== ModalSize.Large
	            && this.size === ModalSize.Small
	            || this.overrideSize === ModalSize.Small;
	    };
	    ModalComponent.prototype.isLarge = function () {
	        return this.overrideSize !== ModalSize.Small
	            && this.size === ModalSize.Large
	            || this.overrideSize === ModalSize.Large;
	    };
	    return ModalComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], ModalComponent.prototype, "animation", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], ModalComponent.prototype, "backdrop", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Boolean)
	], ModalComponent.prototype, "keyboard", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ModalComponent.prototype, "size", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ModalComponent.prototype, "cssClass", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", core_1.EventEmitter)
	], ModalComponent.prototype, "onClose", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", core_1.EventEmitter)
	], ModalComponent.prototype, "onDismiss", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", core_1.EventEmitter)
	], ModalComponent.prototype, "onOpen", void 0);
	__decorate([
	    core_1.HostBinding('class.fade'),
	    __metadata("design:type", Boolean),
	    __metadata("design:paramtypes", [])
	], ModalComponent.prototype, "fadeClass", null);
	__decorate([
	    core_1.HostBinding('attr.data-keyboard'),
	    __metadata("design:type", Boolean),
	    __metadata("design:paramtypes", [])
	], ModalComponent.prototype, "dataKeyboardAttr", null);
	__decorate([
	    core_1.HostBinding('attr.data-backdrop'),
	    __metadata("design:type", Object),
	    __metadata("design:paramtypes", [])
	], ModalComponent.prototype, "dataBackdropAttr", null);
	ModalComponent = __decorate([
	    core_1.Component({
	        selector: 'modal',
	        host: {
	            'class': 'modal',
	            'role': 'dialog',
	            'tabindex': '-1',
	        },
	        template: "\n        <div class=\"modal-dialog\" [ngClass]=\"getCssClasses()\">\n            <div class=\"modal-content\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n    ",
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], ModalComponent);
	exports.ModalComponent = ModalComponent;
	var ModalSize = (function () {
	    function ModalSize() {
	    }
	    ModalSize.validSize = function (size) {
	        return size && (size === ModalSize.Small || size === ModalSize.Large);
	    };
	    return ModalSize;
	}());
	ModalSize.Small = 'sm';
	ModalSize.Large = 'lg';
	exports.ModalSize = ModalSize;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	__webpack_require__(123);
	__webpack_require__(124);
	var ModalInstance = (function () {
	    function ModalInstance(element) {
	        this.element = element;
	        this.visible = false;
	        this.suffix = '.ng2-bs3-modal';
	        this.shownEventName = 'shown.bs.modal' + this.suffix;
	        this.hiddenEventName = 'hidden.bs.modal' + this.suffix;
	        this.init();
	    }
	    ModalInstance.prototype.open = function () {
	        return this.show();
	    };
	    ModalInstance.prototype.close = function () {
	        this.result = ModalResult.Close;
	        return this.hide();
	    };
	    ModalInstance.prototype.dismiss = function () {
	        this.result = ModalResult.Dismiss;
	        return this.hide();
	    };
	    ModalInstance.prototype.destroy = function () {
	        var _this = this;
	        return this.hide().then(function () {
	            if (_this.$modal) {
	                _this.$modal.data('bs.modal', null);
	                _this.$modal.remove();
	            }
	        });
	    };
	    ModalInstance.prototype.show = function () {
	        var promise = toPromise(this.shown);
	        this.resetData();
	        this.$modal.modal();
	        return promise;
	    };
	    ModalInstance.prototype.hide = function () {
	        if (this.$modal && this.visible) {
	            var promise = toPromise(this.hidden);
	            this.$modal.modal('hide');
	            return promise;
	        }
	        return Promise.resolve(this.result);
	    };
	    ModalInstance.prototype.init = function () {
	        var _this = this;
	        this.$modal = jQuery(this.element.nativeElement);
	        this.$modal.appendTo('body');
	        this.shown = Observable_1.Observable.fromEvent(this.$modal, this.shownEventName)
	            .map(function () {
	            _this.visible = true;
	        });
	        this.hidden = Observable_1.Observable.fromEvent(this.$modal, this.hiddenEventName)
	            .map(function () {
	            var result = (!_this.result || _this.result === ModalResult.None)
	                ? ModalResult.Dismiss : _this.result;
	            _this.result = ModalResult.None;
	            _this.visible = false;
	            return result;
	        });
	    };
	    ModalInstance.prototype.resetData = function () {
	        this.$modal.removeData();
	        this.$modal.data('backdrop', booleanOrValue(this.$modal.attr('data-backdrop')));
	        this.$modal.data('keyboard', booleanOrValue(this.$modal.attr('data-keyboard')));
	    };
	    return ModalInstance;
	}());
	exports.ModalInstance = ModalInstance;
	function booleanOrValue(value) {
	    if (value === 'true') {
	        return true;
	    }
	    else if (value === 'false')
	        return false;
	    return value;
	}
	function toPromise(observable) {
	    return new Promise(function (resolve, reject) {
	        observable.subscribe(function (next) {
	            resolve(next);
	        });
	    });
	}
	var ModalResult;
	(function (ModalResult) {
	    ModalResult[ModalResult["None"] = 0] = "None";
	    ModalResult[ModalResult["Close"] = 1] = "Close";
	    ModalResult[ModalResult["Dismiss"] = 2] = "Dismiss";
	})(ModalResult = exports.ModalResult || (exports.ModalResult = {}));


/***/ },
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var modal_component_1 = __webpack_require__(121);
	var ModalHeaderComponent = (function () {
	    function ModalHeaderComponent(modal) {
	        this.modal = modal;
	        this.showClose = false;
	    }
	    return ModalHeaderComponent;
	}());
	__decorate([
	    core_1.Input('show-close'),
	    __metadata("design:type", Boolean)
	], ModalHeaderComponent.prototype, "showClose", void 0);
	ModalHeaderComponent = __decorate([
	    core_1.Component({
	        selector: 'modal-header',
	        template: "\n      <div class=\"modal-header\"><button class=\"close\" *ngIf=\"showClose\" type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"modal.dismiss()\"><span aria-hidden=\"true\">\u00D7</span></button><ng-content></ng-content></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [modal_component_1.ModalComponent])
	], ModalHeaderComponent);
	exports.ModalHeaderComponent = ModalHeaderComponent;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var ModalBodyComponent = (function () {
	    function ModalBodyComponent() {
	    }
	    return ModalBodyComponent;
	}());
	ModalBodyComponent = __decorate([
	    core_1.Component({
	        selector: 'modal-body',
	        template: "\n        <div class=\"modal-body\">\n            <ng-content></ng-content>\n        </div>\n    ",
	    }),
	    __metadata("design:paramtypes", [])
	], ModalBodyComponent);
	exports.ModalBodyComponent = ModalBodyComponent;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(2);
	var modal_component_1 = __webpack_require__(121);
	var ModalFooterComponent = (function () {
	    function ModalFooterComponent(modal) {
	        this.modal = modal;
	        this.showDefaultButtons = false;
	        this.dismissButtonLabel = 'Dismiss';
	        this.closeButtonLabel = 'Close';
	    }
	    return ModalFooterComponent;
	}());
	__decorate([
	    core_1.Input('show-default-buttons'),
	    __metadata("design:type", Boolean)
	], ModalFooterComponent.prototype, "showDefaultButtons", void 0);
	__decorate([
	    core_1.Input('dismiss-button-label'),
	    __metadata("design:type", String)
	], ModalFooterComponent.prototype, "dismissButtonLabel", void 0);
	__decorate([
	    core_1.Input('close-button-label'),
	    __metadata("design:type", String)
	], ModalFooterComponent.prototype, "closeButtonLabel", void 0);
	ModalFooterComponent = __decorate([
	    core_1.Component({
	        selector: 'modal-footer',
	        template: "\n      <div class=\"modal-footer\"><ng-content></ng-content><button class=\"btn btn-default\" *ngIf=\"showDefaultButtons\" type=\"button\" data-dismiss=\"modal\" (click)=\"modal.dismiss()\">{{dismissButtonLabel}}</button><button class=\"btn btn-primary\" *ngIf=\"showDefaultButtons\" type=\"button\" (click)=\"modal.close()\">{{closeButtonLabel}}</button></div>\n    ",
	    }),
	    __metadata("design:paramtypes", [modal_component_1.ModalComponent])
	], ModalFooterComponent);
	exports.ModalFooterComponent = ModalFooterComponent;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(2);
	var modal_component_1 = __webpack_require__(121);
	var AutofocusDirective = (function () {
	    function AutofocusDirective(el, modal) {
	        var _this = this;
	        this.el = el;
	        this.modal = modal;
	        if (modal) {
	            this.modal.onOpen.subscribe(function () {
	                _this.el.nativeElement.focus();
	            });
	        }
	    }
	    return AutofocusDirective;
	}());
	AutofocusDirective = __decorate([
	    core_1.Directive({
	        selector: '[autofocus]',
	    }),
	    __param(1, core_1.Optional()),
	    __metadata("design:paramtypes", [core_1.ElementRef, modal_component_1.ModalComponent])
	], AutofocusDirective);
	exports.AutofocusDirective = AutofocusDirective;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var platform_browser_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(2);
	var CroppedImageComponent = (function () {
	    function CroppedImageComponent(_sanitizer) {
	        this._sanitizer = _sanitizer;
	        this.width = 96;
	        this.alt = false;
	        this.border = true;
	        this.coefficient = 1;
	        this.radius = 50;
	    }
	    Object.defineProperty(CroppedImageComponent.prototype, "imageUrl", {
	        get: function () {
	            if (!this.image) {
	                return null;
	            }
	            return this.image + "?width=" + this.ampedN + "&height=" + this.ampedN;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CroppedImageComponent.prototype, "ampedN", {
	        get: function () {
	            return this._nearestMultipleOfTwo(this.width * 1.5);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CroppedImageComponent.prototype, "croppedImageStyle", {
	        get: function () {
	            var tickness = Math.round((this.width * 0.05) * this.coefficient);
	            var opacity = this.alt ? 0.8 : 0.3;
	            var borderStyle = this.border ? "border: " + tickness + "px solid rgba(50, 50, 50, " + opacity + ");" : '';
	            return this._sanitizer.bypassSecurityTrustStyle(borderStyle + " object-fit: cover; margin: auto; border-radius: " + this.radius + "%; \n                                                         position: relative; width: " + this.width + "px; height: " + this.width + "px;");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CroppedImageComponent.prototype, "textMargin", {
	        get: function () {
	            return Math.ceil((this.width * 0.06) * this.coefficient);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CroppedImageComponent.prototype._nearestMultipleOfTwo = function (n) {
	        return Math.ceil(n / 2) * 2;
	    };
	    return CroppedImageComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], CroppedImageComponent.prototype, "width", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], CroppedImageComponent.prototype, "image", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], CroppedImageComponent.prototype, "text", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], CroppedImageComponent.prototype, "alt", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], CroppedImageComponent.prototype, "border", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], CroppedImageComponent.prototype, "coefficient", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object)
	], CroppedImageComponent.prototype, "radius", void 0);
	CroppedImageComponent = __decorate([
	    core_1.Component({
	        selector: 'cropped-image',
	        template: "\n      <div class=\"layout-column layout-align-center-center\"><div class=\"ci-cropper\" [style.width.px]=\"width\" [style.height.px]=\"width\"><div class=\"cropped-image\" [style.width.px]=\"width\" [style.height.px]=\"width\"><img *ngIf=\"image\" src=\"{{imageUrl}}\" [attr.style]=\"croppedImageStyle\"></div></div><div class=\"ci-footer text-center\" [class.ci-alt]=\"alt\" [style.margin-top.px]=\"textMargin\"> {{ text }}</div></div>\n    ",
	        host: { '[style.position]': 'relative' },
	    }),
	    __metadata("design:paramtypes", [platform_browser_1.DomSanitizer])
	], CroppedImageComponent);
	exports.CroppedImageComponent = CroppedImageComponent;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(133));
	__export(__webpack_require__(134));
	__export(__webpack_require__(135));
	__export(__webpack_require__(136));
	__export(__webpack_require__(267));
	__export(__webpack_require__(273));
	__export(__webpack_require__(611));
	__export(__webpack_require__(611));
	__export(__webpack_require__(613));
	__export(__webpack_require__(615));
	__export(__webpack_require__(616));
	__export(__webpack_require__(617));
	__export(__webpack_require__(619));
	__export(__webpack_require__(622));
	__export(__webpack_require__(624));
	__export(__webpack_require__(625));
	__export(__webpack_require__(628));
	__export(__webpack_require__(631));
	__export(__webpack_require__(635));
	__export(__webpack_require__(638));


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var IconActionComponent = (function () {
	    function IconActionComponent() {
	    }
	    IconActionComponent.prototype.ngOnInit = function () {
	        switch (this.size) {
	            case 'small':
	                this.size = '36px';
	                break;
	            case 'big':
	                this.size = '48px';
	                break;
	            case 'huge':
	                this.size = '72px';
	                break;
	            default:
	                this.size = '24px';
	        }
	    };
	    IconActionComponent.prototype.onMouseOver = function () {
	        this.hover = true;
	    };
	    IconActionComponent.prototype.onMouseOut = function () {
	        this.hover = false;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], IconActionComponent.prototype, "icon", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], IconActionComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], IconActionComponent.prototype, "size", void 0);
	    IconActionComponent = __decorate([
	        core_1.Component({
	            selector: 'icon-action',
	            styles: ["\n        div {\n            padding: 4px;\n        }\n        div.hover {\n            background-color: #363636 !important;\n        }\n        i {\n            color: #8e8e8e;\n            display: block;\n        }\n        a {\n            color: #8e8e8e !important;\n        }\n    "],
	            template: "\n    <div style=\"text-align: center;\"\n        [ngClass]=\"{ 'hover': hover }\"\n        (mouseover)=\"onMouseOver()\"\n        (mouseout)=\"onMouseOut()\">\n        <a href=\"#\">\n            <i class=\"zmdi zmdi-{{icon}}\" [style.font-size]=\"size\"></i>\n            <div>{{ title }}</div>\n        </a>\n    </div>\n    "
	        }), 
	        __metadata('design:paramtypes', [])
	    ], IconActionComponent);
	    return IconActionComponent;
	}());
	exports.IconActionComponent = IconActionComponent;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var BackgroundComponent = (function () {
	    function BackgroundComponent() {
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], BackgroundComponent.prototype, "image", void 0);
	    BackgroundComponent = __decorate([
	        core_1.Component({
	            selector: 'bw-background',
	            styles: [
	                "img.bg {\n        /* Set rules to fill background */\n        // min-height: 100%;\n        min-width: 1024px;\n        /* Set up proportionate scaling */\n        // width: 100%;\n        // height: auto;\n        /* Set up positioning */\n        position: fixed;\n        top: 0;\n        left: 0;\n      }\n      \n      @media screen and (max-width: 420px) {\n        /* Specific to this particular image */\n        img.bg {\n          left: 50%;\n          margin-left: -290px;\n          /* 50% */\n        }\n      }\n\n      @media screen and (min-width: 421px) {\n        /* Specific to this particular image */\n        img.bg {\n          min-height: 100%;\n        }\n      }"
	            ],
	            template: "<img class=\"bg animated fadeIn\" src=\"{{image}}\"/>",
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BackgroundComponent);
	    return BackgroundComponent;
	}());
	exports.BackgroundComponent = BackgroundComponent;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var OverlayComponent = (function () {
	    function OverlayComponent() {
	        this.opacity = 0.2;
	    }
	    Object.defineProperty(OverlayComponent.prototype, "backgroundColor", {
	        get: function () {
	            return 'rgba(0,0,0,' + this.opacity + ')';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OverlayComponent.prototype.ngOnInit = function () { };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], OverlayComponent.prototype, "opacity", void 0);
	    OverlayComponent = __decorate([
	        core_1.Component({
	            selector: 'bw-overlay',
	            styles: [
	                "\n      .overlay{\n          position: fixed;\n          top: 0;\n          left: 0;\n          width: 100%;\n          min-height: 100%;\n          /*  z-index: 10;\n          background-color: rgba(0,0,0,0.2); dim the background*/\n        }\n      "
	            ],
	            template: "<div class=\"overlay animated fadeIn\" [style.background-color]=\"backgroundColor\"></div>",
	        }), 
	        __metadata('design:paramtypes', [])
	    ], OverlayComponent);
	    return OverlayComponent;
	}());
	exports.OverlayComponent = OverlayComponent;


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var moment = __webpack_require__(139);
	var DateRangeComponent = (function () {
	    function DateRangeComponent() {
	        this.dateRange = new models_1.DateRange();
	    }
	    Object.defineProperty(DateRangeComponent.prototype, "isValid", {
	        get: function () {
	            var formValue = this.fg.value;
	            return moment(formValue.from).isBefore(moment(formValue.to));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
	    ], DateRangeComponent.prototype, "fg", void 0);
	    DateRangeComponent = __decorate([
	        core_1.Component({
	            selector: 'date-range',
	            template: __webpack_require__(266),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DateRangeComponent);
	    return DateRangeComponent;
	    var _a;
	}());
	exports.DateRangeComponent = DateRangeComponent;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(138));
	__export(__webpack_require__(249));
	__export(__webpack_require__(250));
	__export(__webpack_require__(251));
	__export(__webpack_require__(252));
	__export(__webpack_require__(254));
	__export(__webpack_require__(256));
	__export(__webpack_require__(257));
	__export(__webpack_require__(258));
	__export(__webpack_require__(259));
	__export(__webpack_require__(260));
	__export(__webpack_require__(250));
	__export(__webpack_require__(261));
	__export(__webpack_require__(253));
	__export(__webpack_require__(262));
	__export(__webpack_require__(255));
	__export(__webpack_require__(263));
	__export(__webpack_require__(264));
	__export(__webpack_require__(265));


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(139);
	var Account = (function () {
	    function Account(info) {
	        this['.issued'] = moment(info['.issued']);
	        this['.expires'] = moment(info['.expires']);
	        this.access_token = info['access_token'];
	        this.clientId = info['clientId'];
	        this.username = info['username'];
	        this.accountName = info['accountName'];
	    }
	    return Account;
	}());
	exports.Account = Account;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.17.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i in momentProperties) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _ordinalParseLenient.
	    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return this._months;
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return this._monthsShort;
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    //can't just apply() to create a date:
	    //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    //the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    //the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return this._weekdays;
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    ordinalParse: defaultOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(140)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	        hooks.createFromInputFallback(config);
	    }
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse)) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (input === undefined) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (typeof(input) === 'object') {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString () {
	    var m = this.clone().utc();
	    if (0 < m.year() && m.year() <= 9999) {
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            return this.toDate().toISOString();
	        } else {
	            return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    } else {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$1 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$1;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this[units + 's']();
	}
	
	function makeGetter(name) {
	    return function () {
	        return this._data[name];
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    s: 45,  // seconds to minute
	    m: 45,  // minutes to hour
	    h: 22,  // hours to day
	    d: 26,  // days to month
	    M: 11   // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds < thresholds.s && ['s', seconds]  ||
	            minutes <= 1           && ['m']           ||
	            minutes < thresholds.m && ['mm', minutes] ||
	            hours   <= 1           && ['h']           ||
	            hours   < thresholds.h && ['hh', hours]   ||
	            days    <= 1           && ['d']           ||
	            days    < thresholds.d && ['dd', days]    ||
	            months  <= 1           && ['M']           ||
	            months  < thresholds.M && ['MM', months]  ||
	            years   <= 1           && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    return true;
	}
	
	function humanize (withSuffix) {
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.17.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 141,
		"./af.js": 141,
		"./ar": 142,
		"./ar-dz": 143,
		"./ar-dz.js": 143,
		"./ar-ly": 144,
		"./ar-ly.js": 144,
		"./ar-ma": 145,
		"./ar-ma.js": 145,
		"./ar-sa": 146,
		"./ar-sa.js": 146,
		"./ar-tn": 147,
		"./ar-tn.js": 147,
		"./ar.js": 142,
		"./az": 148,
		"./az.js": 148,
		"./be": 149,
		"./be.js": 149,
		"./bg": 150,
		"./bg.js": 150,
		"./bn": 151,
		"./bn.js": 151,
		"./bo": 152,
		"./bo.js": 152,
		"./br": 153,
		"./br.js": 153,
		"./bs": 154,
		"./bs.js": 154,
		"./ca": 155,
		"./ca.js": 155,
		"./cs": 156,
		"./cs.js": 156,
		"./cv": 157,
		"./cv.js": 157,
		"./cy": 158,
		"./cy.js": 158,
		"./da": 159,
		"./da.js": 159,
		"./de": 160,
		"./de-at": 161,
		"./de-at.js": 161,
		"./de.js": 160,
		"./dv": 162,
		"./dv.js": 162,
		"./el": 163,
		"./el.js": 163,
		"./en-au": 164,
		"./en-au.js": 164,
		"./en-ca": 165,
		"./en-ca.js": 165,
		"./en-gb": 166,
		"./en-gb.js": 166,
		"./en-ie": 167,
		"./en-ie.js": 167,
		"./en-nz": 168,
		"./en-nz.js": 168,
		"./eo": 169,
		"./eo.js": 169,
		"./es": 170,
		"./es-do": 171,
		"./es-do.js": 171,
		"./es.js": 170,
		"./et": 172,
		"./et.js": 172,
		"./eu": 173,
		"./eu.js": 173,
		"./fa": 174,
		"./fa.js": 174,
		"./fi": 175,
		"./fi.js": 175,
		"./fo": 176,
		"./fo.js": 176,
		"./fr": 177,
		"./fr-ca": 178,
		"./fr-ca.js": 178,
		"./fr-ch": 179,
		"./fr-ch.js": 179,
		"./fr.js": 177,
		"./fy": 180,
		"./fy.js": 180,
		"./gd": 181,
		"./gd.js": 181,
		"./gl": 182,
		"./gl.js": 182,
		"./he": 183,
		"./he.js": 183,
		"./hi": 184,
		"./hi.js": 184,
		"./hr": 185,
		"./hr.js": 185,
		"./hu": 186,
		"./hu.js": 186,
		"./hy-am": 187,
		"./hy-am.js": 187,
		"./id": 188,
		"./id.js": 188,
		"./is": 189,
		"./is.js": 189,
		"./it": 190,
		"./it.js": 190,
		"./ja": 191,
		"./ja.js": 191,
		"./jv": 192,
		"./jv.js": 192,
		"./ka": 193,
		"./ka.js": 193,
		"./kk": 194,
		"./kk.js": 194,
		"./km": 195,
		"./km.js": 195,
		"./ko": 196,
		"./ko.js": 196,
		"./ky": 197,
		"./ky.js": 197,
		"./lb": 198,
		"./lb.js": 198,
		"./lo": 199,
		"./lo.js": 199,
		"./lt": 200,
		"./lt.js": 200,
		"./lv": 201,
		"./lv.js": 201,
		"./me": 202,
		"./me.js": 202,
		"./mi": 203,
		"./mi.js": 203,
		"./mk": 204,
		"./mk.js": 204,
		"./ml": 205,
		"./ml.js": 205,
		"./mr": 206,
		"./mr.js": 206,
		"./ms": 207,
		"./ms-my": 208,
		"./ms-my.js": 208,
		"./ms.js": 207,
		"./my": 209,
		"./my.js": 209,
		"./nb": 210,
		"./nb.js": 210,
		"./ne": 211,
		"./ne.js": 211,
		"./nl": 212,
		"./nl-be": 213,
		"./nl-be.js": 213,
		"./nl.js": 212,
		"./nn": 214,
		"./nn.js": 214,
		"./pa-in": 215,
		"./pa-in.js": 215,
		"./pl": 216,
		"./pl.js": 216,
		"./pt": 217,
		"./pt-br": 218,
		"./pt-br.js": 218,
		"./pt.js": 217,
		"./ro": 219,
		"./ro.js": 219,
		"./ru": 220,
		"./ru.js": 220,
		"./se": 221,
		"./se.js": 221,
		"./si": 222,
		"./si.js": 222,
		"./sk": 223,
		"./sk.js": 223,
		"./sl": 224,
		"./sl.js": 224,
		"./sq": 225,
		"./sq.js": 225,
		"./sr": 226,
		"./sr-cyrl": 227,
		"./sr-cyrl.js": 227,
		"./sr.js": 226,
		"./ss": 228,
		"./ss.js": 228,
		"./sv": 229,
		"./sv.js": 229,
		"./sw": 230,
		"./sw.js": 230,
		"./ta": 231,
		"./ta.js": 231,
		"./te": 232,
		"./te.js": 232,
		"./tet": 233,
		"./tet.js": 233,
		"./th": 234,
		"./th.js": 234,
		"./tl-ph": 235,
		"./tl-ph.js": 235,
		"./tlh": 236,
		"./tlh.js": 236,
		"./tr": 237,
		"./tr.js": 237,
		"./tzl": 238,
		"./tzl.js": 238,
		"./tzm": 239,
		"./tzm-latn": 240,
		"./tzm-latn.js": 240,
		"./tzm.js": 239,
		"./uk": 241,
		"./uk.js": 241,
		"./uz": 242,
		"./uz.js": 242,
		"./vi": 243,
		"./vi.js": 243,
		"./x-pseudo": 244,
		"./x-pseudo.js": 244,
		"./yo": 245,
		"./yo.js": 245,
		"./zh-cn": 246,
		"./zh-cn.js": 246,
		"./zh-hk": 247,
		"./zh-hk.js": 247,
		"./zh-tw": 248,
		"./zh-tw.js": 248
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 140;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    ordinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    ordinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	    monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    ordinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[I dag kl.] LT',
	        nextDay : '[I morgen kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[I går kl.] LT',
	        lastWeek : '[sidste] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    ordinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	    weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-an de] MMMM, YYYY',
	        LLL : 'D[-an de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'je %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    ordinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چندین ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    ordinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : '');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    ordinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	    weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	    weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'Ah時m分',
	        LTS : 'Ah時m分s秒',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah時m分',
	        LLLL : 'YYYY年M月D日Ah時m分 dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    ordinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის წინ');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის წინ');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h시 m분',
	        LTS : 'A h시 m분 s초',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h시 m분',
	        LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '일분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    ordinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    ordinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    ordinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    ordinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    ordinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    },
	    nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    ordinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah点mm分',
	        LTS : 'Ah点m分s秒',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah点mm分',
	        llll : 'YYYY年MMMD日ddddAh点mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : function () {
	            return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	        },
	        nextDay : function () {
	            return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	        },
	        lastDay : function () {
	            return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	        },
	        nextWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        lastWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        sameElse : 'LL'
	    },
	    ordinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(139)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 249 */
/***/ function(module, exports) {

	"use strict";
	var User = (function () {
	    function User(userInfo) {
	        this.active = true;
	        this.isTokenValid = true;
	        Object.assign(this, userInfo);
	        // move regions to regionsIds
	        this.regionIds = this.regions;
	        this.locationIds = this.locations;
	    }
	    return User;
	}());
	exports.User = User;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(139);
	var UserToken = (function () {
	    function UserToken(info) {
	        this.issued = moment(info['.issued']);
	        this.expires = moment(info['.expires']);
	        this.token = info['access_token'];
	        this.tenant = info['clientId'];
	        this.accountName = info['accountName'];
	    }
	    return UserToken;
	}());
	exports.UserToken = UserToken;


/***/ },
/* 251 */
/***/ function(module, exports) {

	"use strict";


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(139);
	var utils_1 = __webpack_require__(253);
	var DateRange = (function () {
	    function DateRange(start, end) {
	        this.start = start;
	        this.end = end;
	        if (start) {
	            start = moment(start);
	        }
	        if (end) {
	            end = moment(end);
	        }
	        this.start = start && start.isValid() ? moment(start) : moment();
	        this.end = end && end.isValid() ? moment(end) : moment();
	    }
	    Object.defineProperty(DateRange.prototype, "isValid", {
	        get: function () {
	            return this.start && this.end && this.start.isSameOrBefore(this.end);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DateRange.prototype.toQueryString = function () {
	        var start = moment(this.start).startOf('day');
	        var end = moment(this.end).endOf('day');
	        var payload = {
	            'date[start]': start.format('MM/DD/YYYY HH:mm:ss'),
	            'date[end]': end.format('MM/DD/YYYY HH:mm:ss'),
	        };
	        return utils_1.objToQueryString(payload);
	    };
	    return DateRange;
	}());
	exports.DateRange = DateRange;


/***/ },
/* 253 */
/***/ function(module, exports) {

	"use strict";
	function objToQueryString(obj) {
	    var queryString = '';
	    if (!obj) {
	        return queryString;
	    }
	    Object.keys(obj).forEach(function (key) {
	        var value = obj[key];
	        if (value) {
	            queryString += key + "=" + encodeURIComponent(value) + "&";
	        }
	    });
	    return queryString;
	}
	exports.objToQueryString = objToQueryString;
	function toJson(obj) {
	    try {
	        return obj.json();
	    }
	    catch (e) {
	        console.log('cannot deserialize the current json object');
	        return null;
	    }
	}
	exports.toJson = toJson;
	function strToUrl(str) {
	    return str.replace(/_ /g, '-').toLowerCase();
	}
	exports.strToUrl = strToUrl;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var idName_1 = __webpack_require__(255);
	var Region = (function (_super) {
	    __extends(Region, _super);
	    function Region() {
	        _super.apply(this, arguments);
	    }
	    return Region;
	}(idName_1.IdName));
	exports.Region = Region;


/***/ },
/* 255 */
/***/ function(module, exports) {

	"use strict";
	var IdName = (function () {
	    function IdName() {
	    }
	    return IdName;
	}());
	exports.IdName = IdName;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var idName_1 = __webpack_require__(255);
	var LocationIdentifier = (function (_super) {
	    __extends(LocationIdentifier, _super);
	    function LocationIdentifier() {
	        _super.apply(this, arguments);
	    }
	    return LocationIdentifier;
	}(idName_1.IdName));
	exports.LocationIdentifier = LocationIdentifier;
	var Location = (function (_super) {
	    __extends(Location, _super);
	    function Location() {
	        _super.apply(this, arguments);
	    }
	    return Location;
	}(idName_1.IdName));
	exports.Location = Location;


/***/ },
/* 257 */
/***/ function(module, exports) {

	"use strict";
	var HeaderAction = (function () {
	    function HeaderAction(id, icon) {
	        this.id = id;
	        this.icon = icon;
	    }
	    return HeaderAction;
	}());
	exports.HeaderAction = HeaderAction;


/***/ },
/* 258 */
/***/ function(module, exports) {

	"use strict";
	var BaseComponent = (function () {
	    function BaseComponent(store, storeHelper, userService) {
	        this.store = store;
	        this.storeHelper = storeHelper;
	        this.userService = userService;
	    }
	    return BaseComponent;
	}());
	exports.BaseComponent = BaseComponent;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var base_component_1 = __webpack_require__(258);
	var TopLevelComponent = (function (_super) {
	    __extends(TopLevelComponent, _super);
	    function TopLevelComponent(store, storeHelper, userService) {
	        _super.call(this, store, storeHelper, userService);
	        this.store = store;
	        this.storeHelper = storeHelper;
	        this.empty = false;
	        this.loading = false;
	    }
	    Object.defineProperty(TopLevelComponent.prototype, "headerTitle", {
	        set: function (header) {
	            var _this = this;
	            setTimeout(function () { return _this.store.pushAppEvent({ type: 'title', data: header }); }, 0);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TopLevelComponent.prototype, "headerActions", {
	        set: function (headerActions) {
	            if (!headerActions) {
	                headerActions = [];
	            }
	            this._headerActions = headerActions;
	            this.storeHelper.update('headerActions', headerActions);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TopLevelComponent.prototype.subscribeToHeaderActions = function (headerActionCallback) {
	        var _this = this;
	        if (!headerActionCallback) {
	            return;
	        }
	        this._headerActionCallback = headerActionCallback;
	        this.store.appEvents$.subscribe(function (appEvent) { return _this._processAppEvent(appEvent); });
	    };
	    TopLevelComponent.prototype.subscribeToBackHeaderAction = function (headerBackActionCallback) {
	        var _this = this;
	        if (!headerBackActionCallback) {
	            return;
	        }
	        this.headerBackActionCallback = headerBackActionCallback;
	        this.store.appEvents$.subscribe(function (appEvent) {
	            if (appEvent.type === 'backAction') {
	                _this.headerBackActionCallback();
	            }
	        });
	    };
	    TopLevelComponent.prototype._processAppEvent = function (appEvent) {
	        if (appEvent.type === 'action') {
	            var action = this._headerActions.find(function (action) { return action.id === appEvent.data.id; });
	            if (action) {
	                this._headerActionCallback(action);
	            }
	        }
	    };
	    return TopLevelComponent;
	}(base_component_1.BaseComponent));
	exports.TopLevelComponent = TopLevelComponent;


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var top_level_component_1 = __webpack_require__(259);
	var ProtectedTopLevelComponent = (function (_super) {
	    __extends(ProtectedTopLevelComponent, _super);
	    function ProtectedTopLevelComponent(store, storeHelper, userService) {
	        var _this = this;
	        _super.call(this, store, storeHelper, userService);
	        this.store = store;
	        this.storeHelper = storeHelper;
	        userService.user$.subscribe(function (user) {
	            _this.user = user;
	            _this.initialize();
	        });
	    }
	    /*
	     * This method will be called everytime there is a user change
	     */
	    ProtectedTopLevelComponent.prototype.initialize = function () {
	        throw 'this method needs to be implement onthe derived class';
	    };
	    return ProtectedTopLevelComponent;
	}(top_level_component_1.TopLevelComponent));
	exports.ProtectedTopLevelComponent = ProtectedTopLevelComponent;


/***/ },
/* 261 */
251,
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var _1 = __webpack_require__(137);
	var LocationPickerSelection = (function () {
	    function LocationPickerSelection(region, locations) {
	        this.region = region;
	        this.locations = locations;
	    }
	    LocationPickerSelection.prototype.toQueryString = function () {
	        var payload = {
	            locations: this.locations ? this.locations.map(function (l) { return l.id; }).join(',') : []
	        };
	        return _1.objToQueryString(payload);
	    };
	    return LocationPickerSelection;
	}());
	exports.LocationPickerSelection = LocationPickerSelection;


/***/ },
/* 263 */
251,
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var _1 = __webpack_require__(137);
	var GeneralFilter = (function () {
	    function GeneralFilter(date, locationsSelection, filter) {
	        this.date = date;
	        this.locationsSelection = locationsSelection;
	        this.filter = filter;
	    }
	    GeneralFilter.prototype.toQueryString = function () {
	        var payload = {
	            filter: this.filter
	        };
	        this.locationsSelection = this.locationsSelection || new _1.LocationPickerSelection();
	        return this.date.toQueryString() + "&" + this.locationsSelection.toQueryString() + "&" + _1.objToQueryString(payload);
	    };
	    GeneralFilter.prototype.clone = function () {
	        var dr = new _1.DateRange(this.date.start, this.date.end);
	        var locationSelection = new _1.LocationPickerSelection(this.locationsSelection.region, this.locationsSelection.locations);
	        return new GeneralFilter(dr, locationSelection, this.filter);
	    };
	    return GeneralFilter;
	}());
	exports.GeneralFilter = GeneralFilter;


/***/ },
/* 265 */
/***/ function(module, exports) {

	"use strict";
	var TopLevelWithoutHeaderComponent = (function () {
	    function TopLevelWithoutHeaderComponent(store) {
	        this.store = store;
	        this._showHeader(false);
	    }
	    TopLevelWithoutHeaderComponent.prototype.componentDestroy = function () {
	        this._showHeader(true);
	    };
	    TopLevelWithoutHeaderComponent.prototype._showHeader = function (show) {
	        var _this = this;
	        setTimeout(function () { return _this.store.pushAppEvent({ type: 'hideHeader', data: show }); }, 0);
	    };
	    return TopLevelWithoutHeaderComponent;
	}());
	exports.TopLevelWithoutHeaderComponent = TopLevelWithoutHeaderComponent;


/***/ },
/* 266 */
/***/ function(module, exports) {

	module.exports = "<div class=\"layout-column layout-padding\"><date-time-picker class=\"flex\" [fg]=\"fg\" field=\"from\" placeholder=\"From\" [alt]=\"true\" format=\"MM/DD/YYYY\" [required]=\"true\"></date-time-picker><date-time-picker class=\"flex\" [fg]=\"fg\" field=\"to\" placeholder=\"To\" [alt]=\"true\" format=\"MM/DD/YYYY\" [required]=\"true\"></date-time-picker></div>";

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var core_1 = __webpack_require__(2);
	var ng2_material_components_1 = __webpack_require__(33);
	var sheet_component_1 = __webpack_require__(268);
	var date_range_1 = __webpack_require__(271);
	var moment = __webpack_require__(139);
	var DateRangeSheetComponent = (function () {
	    function DateRangeSheetComponent() {
	        this.isValid = true;
	        this.fg = new ng2_material_components_1.SubmitableFormGroup({});
	        this.applyRange = new core_1.EventEmitter();
	    }
	    DateRangeSheetComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        setTimeout(function () { return _this.onApplyClicked(); }, 1000);
	    };
	    DateRangeSheetComponent.prototype.toggle = function () {
	        this.sheetComponent.toggle();
	    };
	    DateRangeSheetComponent.prototype.onApplyClicked = function () {
	        this.fg.submitted = true;
	        var value = this.fg.value;
	        var dateRange = new models_1.DateRange(value.from === '' ? moment() : moment(value.from), value.to === '' ? moment() : moment(value.to));
	        this.isValid = dateRange.isValid;
	        if (this.isValid) {
	            this.applyRange.emit(dateRange);
	        }
	    };
	    __decorate([
	        core_1.ViewChild(sheet_component_1.SheetComponent), 
	        __metadata('design:type', Object)
	    ], DateRangeSheetComponent.prototype, "sheetComponent", void 0);
	    __decorate([
	        core_1.ViewChild(date_range_1.DateRangeComponent), 
	        __metadata('design:type', Object)
	    ], DateRangeSheetComponent.prototype, "dateRangeComponent", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], DateRangeSheetComponent.prototype, "applyRange", void 0);
	    DateRangeSheetComponent = __decorate([
	        core_1.Component({
	            selector: 'date-range-sheet',
	            template: __webpack_require__(272),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DateRangeSheetComponent);
	    return DateRangeSheetComponent;
	}());
	exports.DateRangeSheetComponent = DateRangeSheetComponent;


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var SheetComponent = (function () {
	    function SheetComponent() {
	        this.color = 'red';
	        this.display = 'none';
	    }
	    SheetComponent.prototype.ngOnInit = function () {
	        this.themeColor = "bgm-" + this.color;
	    };
	    SheetComponent.prototype.toggle = function () {
	        if (!this.animation || this.animation === 'slideOutUp') {
	            this.animation = 'slideInDown';
	            this.display = '';
	        }
	        else {
	            this.animation = 'slideOutUp';
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], SheetComponent.prototype, "color", void 0);
	    SheetComponent = __decorate([
	        core_1.Component({
	            selector: 'sheet',
	            styles: [__webpack_require__(269)],
	            template: __webpack_require__(270),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SheetComponent);
	    return SheetComponent;
	}());
	exports.SheetComponent = SheetComponent;


/***/ },
/* 269 */
/***/ function(module, exports) {

	module.exports = ".sheet-container{position:fixed;padding:10px;left:0;top:0;right:0;margin-top:70px;z-index:10}\n"

/***/ },
/* 270 */
/***/ function(module, exports) {

	module.exports = "<div class=\"sheet-container animated {{animation}} {{themeColor}}\" [style.display]=\"display\"><ng-content></ng-content></div>";

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(136));


/***/ },
/* 272 */
/***/ function(module, exports) {

	module.exports = "<sheet><date-range [fg]=\"fg\"></date-range><div class=\"text-center c-white animated shake\" *ngIf=\"!isValid\"><i class=\"zmdi zmdi-info-outline m-r-10\"> </i>Invalid Range</div><div class=\"layout-row layout-align-end layout-padding\"><bw-button title=\"Apply\" icon=\"check\" color=\"white\" [simple]=\"true\" (clicked)=\"onApplyClicked()\"></bw-button></div></sheet>";

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var models_2 = __webpack_require__(137);
	var services_1 = __webpack_require__(274);
	var ng2_material_components_1 = __webpack_require__(33);
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var LocationPickerComponent = (function () {
	    function LocationPickerComponent(_userSvc) {
	        this._userSvc = _userSvc;
	        this.showLocations = true;
	        this.allowSelectMultipleLocations = true;
	        this.regionSelected = new models_2.Region();
	        this.locationSelected = new models_2.Location();
	        this.applyLocationSelected = new core_1.EventEmitter();
	        this.filterReady = new core_1.EventEmitter();
	    }
	    LocationPickerComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._userSubs = this._userSvc.user$
	            .do(function (user) { return _this._user = user; })
	            .subscribe(function (user) { return _this._refreshRegions(user); });
	    };
	    LocationPickerComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this._regionSubs = this.fg.controls['region'].valueChanges
	            .subscribe(function (regionId) { return _this._updateLocations(regionId); });
	    };
	    LocationPickerComponent.prototype.ngOnDestroy = function () {
	        this._userSubs.unsubscribe();
	        this._regionSubs.unsubscribe();
	    };
	    LocationPickerComponent.prototype.getSelection = function () {
	        var value = this.fg.value;
	        var region = this.regionsFiltered.find(function (r) { return r.id === +value.region; });
	        var locationIds = value.location ? value.location.split(',') : [];
	        var locations = [];
	        if (locationIds.length > 0) {
	            locations = region.locations.filter(function (l) { return locationIds.indexOf(l.id.toString()) !== -1; });
	        }
	        else if (region) {
	            locations = region.locations;
	        }
	        else {
	            locations = this._user.locations;
	        }
	        return new models_1.LocationPickerSelection(region, locations);
	    };
	    LocationPickerComponent.prototype._refreshRegions = function (user) {
	        var _this = this;
	        if (!user || !user.regions) {
	            this.regions = null;
	            return;
	        }
	        this.regions = user.regions.map(function (region) {
	            return new ng2_material_components_1.SelectionItem(region.id, region.name, region.id === _this.regionSelected.id);
	        });
	        if (this.regionsFiltered) {
	            this.regions = this.regionsFiltered.map(function (region) {
	                return new ng2_material_components_1.SelectionItem(region.id, region.name, region.id === _this.regionSelected.id);
	            });
	        }
	        else {
	            this.regionsFiltered = this._user.regions;
	        }
	        setTimeout(function () { return _this.filterReady.emit(); }, 100);
	    };
	    LocationPickerComponent.prototype._updateLocations = function (regionId) {
	        var _this = this;
	        if (!regionId) {
	            return;
	        }
	        this.fg.controls['location'].setValue('');
	        this.locations = this.regionsFiltered
	            .find(function (region) { return region.id === +regionId; }).locations
	            .map(function (location) { return new ng2_material_components_1.SelectionItem(location.id, location.name, location.id === _this.locationSelected.id); });
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], LocationPickerComponent.prototype, "showLocations", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], LocationPickerComponent.prototype, "allowSelectMultipleLocations", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
	    ], LocationPickerComponent.prototype, "fg", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], LocationPickerComponent.prototype, "regionsFiltered", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof models_2.Region !== 'undefined' && models_2.Region) === 'function' && _b) || Object)
	    ], LocationPickerComponent.prototype, "regionSelected", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_c = typeof models_2.Location !== 'undefined' && models_2.Location) === 'function' && _c) || Object)
	    ], LocationPickerComponent.prototype, "locationSelected", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], LocationPickerComponent.prototype, "applyLocationSelected", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], LocationPickerComponent.prototype, "filterReady", void 0);
	    LocationPickerComponent = __decorate([
	        core_1.Component({
	            selector: 'location-picker',
	            template: __webpack_require__(610),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_d = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _d) || Object])
	    ], LocationPickerComponent);
	    return LocationPickerComponent;
	    var _a, _b, _c, _d;
	}());
	exports.LocationPickerComponent = LocationPickerComponent;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(275));
	__export(__webpack_require__(572));
	__export(__webpack_require__(573));
	__export(__webpack_require__(574));
	__export(__webpack_require__(575));
	__export(__webpack_require__(605));
	__export(__webpack_require__(606));
	__export(__webpack_require__(603));
	__export(__webpack_require__(607));
	__export(__webpack_require__(608));
	__export(__webpack_require__(609));


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var http_1 = __webpack_require__(276);
	var Observable_1 = __webpack_require__(4);
	__webpack_require__(277);
	__webpack_require__(339);
	var utils_1 = __webpack_require__(253);
	var moment = __webpack_require__(139);
	var ApiService = (function () {
	    function ApiService(http, router) {
	        this.http = http;
	        this.router = router;
	        this.headers = new http_1.Headers({
	            'Content-Type': 'application/json',
	            Accept: 'application/json'
	        });
	    }
	    ApiService.prototype.get = function (baseUrl, path, queryString) {
	        var _this = this;
	        this.setLocalDateTimeHeader();
	        var url = "" + baseUrl + path;
	        if (queryString) {
	            url += "?" + queryString.toQueryString();
	        }
	        return this.http.get(url, { headers: this.headers })
	            .map(this.checkForError)
	            .catch(function (err) { return _this.checkForUnauthorized(err); })
	            .map(utils_1.toJson);
	    };
	    ApiService.prototype.post = function (baseUrl, path, body, urlEncoded) {
	        var _this = this;
	        if (urlEncoded === void 0) { urlEncoded = false; }
	        this.setLocalDateTimeHeader();
	        var payload = '';
	        if (typeof body === 'string') {
	            payload = body;
	        }
	        else if (urlEncoded) {
	            this.headers.set('Content-Type', 'application/x-www-form-urlencoded');
	            payload = utils_1.objToQueryString(body);
	        }
	        else {
	            payload = JSON.stringify(body);
	        }
	        return this.http.post("" + baseUrl + path, payload, { headers: this.headers })
	            .map(this.checkForError)
	            .catch(function (err) { return _this.checkForUnauthorized(err); })
	            .map(utils_1.toJson);
	    };
	    ApiService.prototype.delete = function (baseUrl, path, body) {
	        var _this = this;
	        this.setLocalDateTimeHeader();
	        return this.http.delete("" + baseUrl + path, { headers: this.headers, body: body })
	            .map(this.checkForError)
	            .catch(function (err) { return _this.checkForUnauthorized(err); })
	            .map(utils_1.toJson);
	    };
	    ApiService.prototype.patch = function (baseUrl, path, body, queryString, urlEncoded) {
	        var _this = this;
	        if (urlEncoded === void 0) { urlEncoded = false; }
	        this.setLocalDateTimeHeader();
	        var url = "" + baseUrl + path;
	        if (queryString) {
	            url += "?" + queryString.toQueryString();
	        }
	        var payload = '';
	        if (typeof body === 'string') {
	            payload = body;
	        }
	        else if (urlEncoded) {
	            this.headers.set('Content-Type', 'application/x-www-form-urlencoded');
	            payload = utils_1.objToQueryString(body);
	        }
	        else {
	            payload = JSON.stringify(body);
	        }
	        return this.http.patch(url, payload, { headers: this.headers })
	            .map(this.checkForError)
	            .catch(function (err) { return _this.checkForUnauthorized(err); })
	            .map(utils_1.toJson);
	    };
	    ApiService.prototype.setHeaders = function (headers) {
	        var _this = this;
	        Object.keys(headers).forEach(function (header) { return _this.headers.set(header, headers[header]); });
	    };
	    ApiService.prototype.checkForError = function (response) {
	        if (response.status >= 200 && response.status < 300) {
	            return response;
	        }
	        else {
	            var error = new Error(response.statusText);
	            error['response'] = response;
	            console.error(error);
	            throw error;
	        }
	    };
	    ApiService.prototype.checkForUnauthorized = function (err) {
	        if (err.status === 401) {
	            this.router.navigate(['/login']);
	        }
	        return Observable_1.Observable.throw(err);
	    };
	    ApiService.prototype.setLocalDateTimeHeader = function () {
	        this.headers.set('DateTime', moment(Date()).format('MM/DD/YYYY hh:mm:ss'));
	    };
	    ApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], ApiService);
	    return ApiService;
	    var _a, _b;
	}());
	exports.ApiService = ApiService;


/***/ },
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var BehaviorSubject_1 = __webpack_require__(104);
	var AppStateService = (function () {
	    function AppStateService() {
	        this._backAction = new BehaviorSubject_1.BehaviorSubject(false);
	    }
	    Object.defineProperty(AppStateService.prototype, "headerActions$", {
	        get: function () {
	            return this._headerActions.asObservable();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppStateService.prototype, "backAction$", {
	        get: function () {
	            return this._backAction.asObservable();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AppStateService.prototype.changeHeaderActions = function (actions) {
	        this.appState.headerActions = actions;
	        this._headerActions.next(this.appState.headerActions);
	    };
	    AppStateService.prototype.changeBackActionValue = function (value) {
	        this._showBackAction = value;
	        this._backAction.next(this._showBackAction);
	    };
	    AppStateService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], AppStateService);
	    return AppStateService;
	}());
	exports.AppStateService = AppStateService;


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var utils_1 = __webpack_require__(253);
	var core_1 = __webpack_require__(2);
	var store_helper_1 = __webpack_require__(574);
	var store_1 = __webpack_require__(575);
	var api_service_1 = __webpack_require__(275);
	var router_1 = __webpack_require__(77);
	var config_service_1 = __webpack_require__(603);
	var models_1 = __webpack_require__(137);
	var user_service_1 = __webpack_require__(605);
	var native_channel_service_1 = __webpack_require__(607);
	var local_storage_service_1 = __webpack_require__(608);
	var accounts_service_1 = __webpack_require__(609);
	var moment = __webpack_require__(139);
	__webpack_require__(277);
	var AuthService = (function () {
	    function AuthService(storeHelper, api, _router, store, configService, _userSvc, _nativeChannelService, _localStorageService, _accService) {
	        var _this = this;
	        this.storeHelper = storeHelper;
	        this.api = api;
	        this._router = _router;
	        this.store = store;
	        this.configService = configService;
	        this._userSvc = _userSvc;
	        this._nativeChannelService = _nativeChannelService;
	        this._localStorageService = _localStorageService;
	        this._accService = _accService;
	        this.BEARER_KEY = 'nova_bearer_info';
	        this._userSvc.user$.subscribe(function (user) { return _this._checkIfUserIsNull(user); });
	        var userTokenJson = this._getUserLogged();
	        if (userTokenJson) {
	            this._userToken = new models_1.UserToken(userTokenJson);
	            this.setBearer();
	        }
	    }
	    Object.defineProperty(AuthService.prototype, "accessToken", {
	        get: function () {
	            return this._userToken.token;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AuthService.prototype.setBearer = function () {
	        this.api.setHeaders({ Authorization: "Bearer " + this._userToken.token });
	        // retrieve user info
	        this._userSvc.updateUserInfo();
	        this._nativeChannelService.setUserToken(this._userToken.token);
	    };
	    AuthService.prototype.isAuthorized = function () {
	        var isTokenValid = false;
	        if (this._userToken) {
	            isTokenValid = this._userToken.expires.isAfter(moment());
	            //if theres is a user logged with token expired removed the account of this user form local storage;
	            if (!isTokenValid) {
	                this._accService.removeAccount(this._userToken.accountName);
	            }
	        }
	        return isTokenValid;
	    };
	    AuthService.prototype.canActivate = function () {
	        var isAuth = this.isAuthorized();
	        if (!isAuth) {
	            this._router.navigate(['', 'accounts']);
	        }
	        return isAuth;
	    };
	    AuthService.prototype.login = function (account) {
	        this._userToken = new models_1.UserToken(account);
	        this.setBearer();
	        this.storeHelper.update('user', this._userToken);
	        this._localStorageService.set(this.BEARER_KEY, account);
	    };
	    AuthService.prototype.switchAccount = function () {
	        this._removeUserLogged();
	    };
	    AuthService.prototype.authenticate = function (creds) {
	        var _this = this;
	        var auth = this.configService.getContext('auth');
	        // convert company name to host value
	        // TODO: I need to come back here and make this value dynamic
	        creds.host = "https://" + creds.account.replace(/_/g, '-') + ".beta.novapointofsale.com";
	        creds.grant_type = 'password';
	        var loginPayload = utils_1.objToQueryString(creds);
	        if (!creds.password) {
	            loginPayload += '&password=';
	        }
	        return this.api.post(auth.url, 'token', loginPayload, true)
	            .do(function (res) {
	            res.username = creds.username.toUpperCase();
	            res.accountName = creds.account.toUpperCase();
	            _this._userToken = new models_1.UserToken(res);
	            _this.setBearer();
	            _this._accService.updateAccounts(new models_1.Account(res));
	            _this._localStorageService.set(_this.BEARER_KEY, res);
	        })
	            .do(function (res) { return _this.storeHelper.update('user', _this._userToken); })
	            .map(function (res) { return res; });
	    };
	    AuthService.prototype.signout = function (account, redirect) {
	        if (redirect === void 0) { redirect = false; }
	        if (!account) {
	            return;
	        }
	        this._accService.removeUserTokenFromAccount(account);
	        if (redirect) {
	            this._router.navigate(['', 'accounts']);
	        }
	    };
	    AuthService.prototype.removeAccount = function (account) {
	        if (!account) {
	            return;
	        }
	        this._accService.removeAccount(account);
	        var userTokenJson = this._localStorageService.get(this.BEARER_KEY);
	        if (userTokenJson && this._accService.accountsEquals(userTokenJson.accountName, account)) {
	            this._removeUserLogged();
	        }
	    };
	    AuthService.prototype._removeUserLogged = function () {
	        this._removeCurrentUserFromLocalStore();
	        this._userToken = null;
	        this._userSvc.removeUser();
	        this.store.purge();
	    };
	    AuthService.prototype._getUserLogged = function () {
	        var accounts = this._accService.getAccounts();
	        var userTokenJson = this._localStorageService.get(this.BEARER_KEY);
	        if (!userTokenJson || !userTokenJson.accountName || accounts.length < 1) {
	            this._removeCurrentUserFromLocalStore();
	            return null;
	        }
	        //get account to current user 
	        var account = this._accService.getAccountByName(userTokenJson.accountName);
	        if (!account) {
	            //remove user if does not belong to account in local storage
	            this._removeCurrentUserFromLocalStore();
	            return null;
	        }
	        return userTokenJson;
	    };
	    AuthService.prototype._removeCurrentUserFromLocalStore = function () {
	        this._localStorageService.remove(this.BEARER_KEY);
	    };
	    AuthService.prototype._checkIfUserIsNull = function (user) {
	        if (user && !user.isTokenValid) {
	            var redirectToLogin = false;
	            var userTokenJson = this._localStorageService.get(this.BEARER_KEY);
	            if (userTokenJson && userTokenJson.accountName) {
	                redirectToLogin = true;
	                var account = this._accService.getAccountByName(userTokenJson.accountName);
	                this._accService.removeUserTokenFromAccount(account);
	                this._removeCurrentUserFromLocalStore();
	                this._userToken = null;
	                this.store.purge();
	            }
	            if (redirectToLogin) {
	                this._router.navigate(['accounts/login', userTokenJson.accountName]);
	            }
	            else {
	                this._router.navigate(['/accounts']);
	            }
	        }
	    };
	    AuthService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof store_helper_1.StoreHelper !== 'undefined' && store_helper_1.StoreHelper) === 'function' && _a) || Object, (typeof (_b = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof store_1.Store !== 'undefined' && store_1.Store) === 'function' && _d) || Object, (typeof (_e = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _e) || Object, (typeof (_f = typeof user_service_1.UserService !== 'undefined' && user_service_1.UserService) === 'function' && _f) || Object, (typeof (_g = typeof native_channel_service_1.NativeChannelService !== 'undefined' && native_channel_service_1.NativeChannelService) === 'function' && _g) || Object, (typeof (_h = typeof local_storage_service_1.LocalStorageService !== 'undefined' && local_storage_service_1.LocalStorageService) === 'function' && _h) || Object, (typeof (_j = typeof accounts_service_1.AccountsService !== 'undefined' && accounts_service_1.AccountsService) === 'function' && _j) || Object])
	    ], AuthService);
	    return AuthService;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.AuthService = AuthService;


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var store_1 = __webpack_require__(575);
	var StoreHelper = (function () {
	    function StoreHelper(store) {
	        this.store = store;
	    }
	    StoreHelper.prototype.update = function (prop, state) {
	        var currentState = this.store.getState();
	        this.store.setState(Object.assign({}, currentState, (_a = {}, _a[prop] = state, _a)));
	        var _a;
	    };
	    StoreHelper.prototype.add = function (prop, state) {
	        var currentState = this.store.getState();
	        var collection = currentState[prop];
	        this.store.setState(Object.assign({}, currentState, (_a = {}, _a[prop] = [state].concat(collection), _a)));
	        var _a;
	    };
	    StoreHelper.prototype.findAndUpdate = function (prop, state) {
	        var currentState = this.store.getState();
	        var collection = currentState[prop];
	        this.store.setState(Object.assign({}, currentState, (_a = {}, _a[prop] = collection.map(function (item) {
	            if (item.id !== state.id) {
	                return item;
	            }
	            return Object.assign({}, item, state);
	        }), _a)));
	        var _a;
	    };
	    StoreHelper.prototype.findAndDelete = function (prop, id) {
	        var currentState = this.store.getState();
	        var collection = currentState[prop];
	        this.store.setState(Object.assign({}, currentState, (_a = {}, _a[prop] = collection.filter(function (item) { return item.id !== id; }), _a)));
	        var _a;
	    };
	    StoreHelper = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof store_1.Store !== 'undefined' && store_1.Store) === 'function' && _a) || Object])
	    ], StoreHelper);
	    return StoreHelper;
	    var _a;
	}());
	exports.StoreHelper = StoreHelper;


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(576);
	var Subject_1 = __webpack_require__(3);
	var BehaviorSubject_1 = __webpack_require__(104);
	var core_1 = __webpack_require__(2);
	var models_2 = __webpack_require__(580);
	var models_3 = __webpack_require__(589);
	__webpack_require__(277);
	var defaultState = {
	    company: null,
	    headerActions: [],
	    employeeInvoicesFilter: new models_2.EmployeeInvoicesFilter(null, null),
	    products: [],
	    locationInvoiceDetailFilter: new models_3.LocationInvoiceDetailFilter(null, null),
	    customerInvoicesFilter: new models_1.CustomerInvoicesFilter(null, null, null),
	    users: []
	};
	var _store = new BehaviorSubject_1.BehaviorSubject(defaultState);
	var _actionsSubject = new Subject_1.Subject();
	var Store = (function () {
	    function Store() {
	        this._store = _store;
	        this._actionsSubject = _actionsSubject;
	        this.changes$ = this._store.asObservable().distinctUntilChanged();
	        this.appEvents$ = this._actionsSubject.asObservable().distinctUntilChanged();
	    }
	    Store.prototype.pushAppEvent = function (actionData) {
	        this._actionsSubject.next({
	            type: actionData.type,
	            data: actionData.data
	        });
	    };
	    Store.prototype.setState = function (state) {
	        this._store.next(state);
	    };
	    Store.prototype.getState = function () {
	        return this._store.value;
	    };
	    Store.prototype.purge = function () {
	        this._store.next(defaultState);
	    };
	    Store = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], Store);
	    return Store;
	}());
	exports.Store = Store;


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(577));
	__export(__webpack_require__(578));
	__export(__webpack_require__(579));


/***/ },
/* 577 */
/***/ function(module, exports) {

	"use strict";
	var CustomerPurchasesSummary = (function () {
	    function CustomerPurchasesSummary(summary) {
	        Object.assign(this, summary);
	    }
	    Object.defineProperty(CustomerPurchasesSummary.prototype, "fullName", {
	        get: function () {
	            return this.firstName + " " + this.lastName;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return CustomerPurchasesSummary;
	}());
	exports.CustomerPurchasesSummary = CustomerPurchasesSummary;


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var CustomerInvoicesFilter = (function () {
	    function CustomerInvoicesFilter(date, locationsSelection, customerPurchasesSummary) {
	        this.date = date;
	        this.locationsSelection = locationsSelection;
	        this.customerPurchasesSummary = customerPurchasesSummary;
	    }
	    CustomerInvoicesFilter.prototype.toQueryString = function () {
	        var payload = {
	            customerId: this.customerPurchasesSummary.customerId
	        };
	        this.locationsSelection = this.locationsSelection || new models_1.LocationPickerSelection();
	        return this.date.toQueryString() + "&" + this.locationsSelection.toQueryString() + "&" + models_1.objToQueryString(payload);
	    };
	    return CustomerInvoicesFilter;
	}());
	exports.CustomerInvoicesFilter = CustomerInvoicesFilter;


/***/ },
/* 579 */
/***/ function(module, exports) {

	"use strict";
	var CustomerInvoiceDetails = (function () {
	    function CustomerInvoiceDetails(data) {
	        Object.assign(this, data);
	    }
	    return CustomerInvoiceDetails;
	}());
	exports.CustomerInvoiceDetails = CustomerInvoiceDetails;


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(581));
	__export(__webpack_require__(582));
	__export(__webpack_require__(583));
	__export(__webpack_require__(584));
	__export(__webpack_require__(585));
	__export(__webpack_require__(586));
	__export(__webpack_require__(587));
	__export(__webpack_require__(588));


/***/ },
/* 581 */
/***/ function(module, exports) {

	"use strict";
	var EmployeeScore = (function () {
	    function EmployeeScore(data) {
	        Object.assign(this, data);
	    }
	    return EmployeeScore;
	}());
	exports.EmployeeScore = EmployeeScore;


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var EmployeesFilter = (function () {
	    function EmployeesFilter(date, locationsSelection, filter) {
	        this.date = date;
	        this.locationsSelection = locationsSelection;
	        this.filter = filter;
	    }
	    EmployeesFilter.prototype.toQueryString = function () {
	        var payload = {
	            filter: this.filter
	        };
	        this.locationsSelection = this.locationsSelection || new models_1.LocationPickerSelection();
	        return this.date.toQueryString() + "&" + this.locationsSelection.toQueryString() + "&" + models_1.objToQueryString(payload);
	    };
	    return EmployeesFilter;
	}());
	exports.EmployeesFilter = EmployeesFilter;


/***/ },
/* 583 */
/***/ function(module, exports) {

	"use strict";
	var EmployeeInvoice = (function () {
	    function EmployeeInvoice(invoice) {
	        Object.assign(this, invoice);
	    }
	    return EmployeeInvoice;
	}());
	exports.EmployeeInvoice = EmployeeInvoice;


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var employees_filter_1 = __webpack_require__(582);
	var models_1 = __webpack_require__(137);
	var EmployeeInvoicesFilter = (function (_super) {
	    __extends(EmployeeInvoicesFilter, _super);
	    function EmployeeInvoicesFilter(filter, employee) {
	        if (!filter) {
	            filter = new employees_filter_1.EmployeesFilter(new models_1.DateRange());
	        }
	        _super.call(this, filter.date, filter.locationsSelection, filter.filter);
	        this.employee = employee;
	    }
	    EmployeeInvoicesFilter.prototype.toQueryString = function () {
	        var payload = {
	            filter: this.filter,
	            employees: this.employee.id
	        };
	        this.locationsSelection = this.locationsSelection || new models_1.LocationPickerSelection();
	        return this.date.toQueryString() + "&" + this.locationsSelection.toQueryString() + "&" + models_1.objToQueryString(payload);
	    };
	    return EmployeeInvoicesFilter;
	}(employees_filter_1.EmployeesFilter));
	exports.EmployeeInvoicesFilter = EmployeeInvoicesFilter;


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(139);
	var dateFormat = 'MM/DD/YYYY hh:mm A';
	var EmployeeScoreDetails = (function () {
	    function EmployeeScoreDetails(data) {
	        Object.assign(this, data);
	        // format dates
	        if (!this.invoices) {
	            return;
	        }
	        this.invoices.forEach(function (invoice) { return invoice.timestamp = moment(invoice.timestamp).format(dateFormat); });
	    }
	    return EmployeeScoreDetails;
	}());
	exports.EmployeeScoreDetails = EmployeeScoreDetails;


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var employee_score_1 = __webpack_require__(581);
	var EmployeeSalary = (function (_super) {
	    __extends(EmployeeSalary, _super);
	    function EmployeeSalary() {
	        _super.apply(this, arguments);
	    }
	    return EmployeeSalary;
	}(employee_score_1.EmployeeScore));
	exports.EmployeeSalary = EmployeeSalary;


/***/ },
/* 587 */
/***/ function(module, exports) {

	"use strict";
	var EmployeeSalaryDetails = (function () {
	    function EmployeeSalaryDetails(data) {
	        Object.assign(this, data);
	        this.formatDeductions();
	    }
	    EmployeeSalaryDetails.prototype.formatDeductions = function () {
	        if (this.deductions) {
	            this.deductions.forEach(function (d) {
	                d.amount = -d.amount;
	            });
	        }
	    };
	    return EmployeeSalaryDetails;
	}());
	exports.EmployeeSalaryDetails = EmployeeSalaryDetails;


/***/ },
/* 588 */
251,
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(590));
	__export(__webpack_require__(591));
	__export(__webpack_require__(592));
	__export(__webpack_require__(593));
	__export(__webpack_require__(592));


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var LocationsFilter = (function () {
	    function LocationsFilter(date, locationsSelection, filter) {
	        this.date = date;
	        this.locationsSelection = locationsSelection;
	        this.filter = filter;
	    }
	    LocationsFilter.prototype.toQueryString = function () {
	        var payload = {
	            filter: this.filter
	        };
	        this.locationsSelection = this.locationsSelection || new models_1.LocationPickerSelection();
	        return this.date.toQueryString() + "&" + this.locationsSelection.toQueryString() + "&" + models_1.objToQueryString(payload);
	    };
	    return LocationsFilter;
	}());
	exports.LocationsFilter = LocationsFilter;


/***/ },
/* 591 */
/***/ function(module, exports) {

	"use strict";
	var LocationSale = (function () {
	    function LocationSale(locationSale) {
	        Object.assign(this, locationSale);
	    }
	    return LocationSale;
	}());
	exports.LocationSale = LocationSale;


/***/ },
/* 592 */
/***/ function(module, exports) {

	"use strict";
	var LocationInvoiceDetail = (function () {
	    function LocationInvoiceDetail(locationInvoiceDetail) {
	        Object.assign(this, locationInvoiceDetail);
	    }
	    return LocationInvoiceDetail;
	}());
	exports.LocationInvoiceDetail = LocationInvoiceDetail;


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var locations_filter_1 = __webpack_require__(590);
	var shared_1 = __webpack_require__(594);
	var LocationInvoiceDetailFilter = (function (_super) {
	    __extends(LocationInvoiceDetailFilter, _super);
	    function LocationInvoiceDetailFilter(filter, locationSale) {
	        if (!filter) {
	            filter = new locations_filter_1.LocationsFilter(new shared_1.DateRange());
	        }
	        _super.call(this, filter.date, filter.locationsSelection, filter.filter);
	        this.locationSale = locationSale;
	    }
	    LocationInvoiceDetailFilter.prototype.toQueryString = function () {
	        var payload = {
	            locations: this.locationSale.id,
	            type: [1, 2, 3],
	            'sort[property]': 'timestamp',
	            'sort[dir]': 'desc'
	        };
	        this.locationsSelection = this.locationsSelection || new shared_1.LocationPickerSelection();
	        return this.date.toQueryString() + "&" + shared_1.objToQueryString(payload);
	    };
	    return LocationInvoiceDetailFilter;
	}(locations_filter_1.LocationsFilter));
	exports.LocationInvoiceDetailFilter = LocationInvoiceDetailFilter;


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(137));
	__export(__webpack_require__(274));
	__export(__webpack_require__(132));
	__export(__webpack_require__(595));


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(596));
	__export(__webpack_require__(597));
	__export(__webpack_require__(598));
	__export(__webpack_require__(599));
	__export(__webpack_require__(600));
	__export(__webpack_require__(601));
	__export(__webpack_require__(602));


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var moment = __webpack_require__(139);
	var FromNowPipe = (function () {
	    function FromNowPipe() {
	    }
	    FromNowPipe.prototype.transform = function (value, args) {
	        return moment(value).fromNow();
	    };
	    FromNowPipe = __decorate([
	        core_1.Pipe({ name: 'fromNow' }), 
	        __metadata('design:paramtypes', [])
	    ], FromNowPipe);
	    return FromNowPipe;
	}());
	exports.FromNowPipe = FromNowPipe;


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	(function (SortingDirection) {
	    SortingDirection[SortingDirection['asc'] = 1] = 'asc';
	    SortingDirection[SortingDirection['desc'] = -1] = 'desc';
	})(exports.SortingDirection || (exports.SortingDirection = {}));
	var SortingDirection = exports.SortingDirection;
	var SortByDatePipe = (function () {
	    function SortByDatePipe() {
	    }
	    SortByDatePipe.prototype.transform = function (array, arg1, arg2) {
	        if (!array || array.length < 2) {
	            return array;
	        }
	        if (!arg1 || !arg2) {
	            return array;
	        }
	        if (!(arg2 in SortingDirection)) {
	            return array;
	        }
	        array.sort(function (a, b) {
	            a = new Date(a[arg1]);
	            b = new Date(b[arg1]);
	            if (a < b) {
	                return (1 * SortingDirection[arg2]);
	            }
	            else if (a > b) {
	                return (-1 * SortingDirection[arg2]);
	            }
	            else {
	                return 0;
	            }
	        });
	        return array;
	    };
	    SortByDatePipe = __decorate([
	        core_1.Pipe({
	            name: "sortByDate"
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SortByDatePipe);
	    return SortByDatePipe;
	}());
	exports.SortByDatePipe = SortByDatePipe;


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var LinkifyPipe = (function () {
	    function LinkifyPipe() {
	    }
	    LinkifyPipe.prototype.transform = function (value) {
	        // URLs starting with http://, https://, or ftp://
	        var replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
	        var replacedText = value.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
	        // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
	        var replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
	        replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
	        // Change email addresses to mailto:: links.
	        var replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
	        replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
	        return replacedText;
	    };
	    LinkifyPipe = __decorate([
	        core_1.Pipe({
	            name: 'linkify'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LinkifyPipe);
	    return LinkifyPipe;
	}());
	exports.LinkifyPipe = LinkifyPipe;


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var CapitalizePipe = (function () {
	    function CapitalizePipe() {
	    }
	    CapitalizePipe.prototype.transform = function (value) {
	        if (value) {
	            return value.charAt(0).toUpperCase() + value.slice(1);
	        }
	        return value;
	    };
	    CapitalizePipe = __decorate([
	        core_1.Pipe({ name: 'capitalize' }), 
	        __metadata('design:paramtypes', [])
	    ], CapitalizePipe);
	    return CapitalizePipe;
	}());
	exports.CapitalizePipe = CapitalizePipe;


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var moment = __webpack_require__(139);
	var MomentifyPipe = (function () {
	    function MomentifyPipe() {
	    }
	    MomentifyPipe.prototype.transform = function (value) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var format = args[0];
	        return moment(value).format(format);
	    };
	    MomentifyPipe = __decorate([
	        core_1.Pipe({
	            name: 'momentify'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MomentifyPipe);
	    return MomentifyPipe;
	}());
	exports.MomentifyPipe = MomentifyPipe;


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var moment = __webpack_require__(139);
	var DurationPipe = (function () {
	    function DurationPipe() {
	    }
	    DurationPipe.prototype.transform = function (value) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var format = args[0];
	        var duration = moment.duration(value);
	        var result = '';
	        switch (format) {
	            case 'seconds':
	                result = String(duration.seconds());
	                break;
	            case 'minutes':
	                result = String(duration.minutes());
	                break;
	            case 'hours':
	                result = String(duration.hours());
	                break;
	            default:
	                result = duration.hours() + "h:" + duration.minutes() + "m:" + duration.seconds() + "s";
	                break;
	        }
	        return result;
	    };
	    DurationPipe = __decorate([
	        core_1.Pipe({
	            name: 'duration'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DurationPipe);
	    return DurationPipe;
	}());
	exports.DurationPipe = DurationPipe;


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var moment = __webpack_require__(139);
	var dateFormat = 'MM/DD/YYYY hh:mm A';
	var ToLocalDatePipe = (function () {
	    function ToLocalDatePipe() {
	    }
	    ToLocalDatePipe.prototype.transform = function (value, format) {
	        var _format = format ? format : dateFormat;
	        return moment(value).format(_format);
	    };
	    ToLocalDatePipe = __decorate([
	        core_1.Pipe({
	            name: "toLocalDate"
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ToLocalDatePipe);
	    return ToLocalDatePipe;
	}());
	exports.ToLocalDatePipe = ToLocalDatePipe;


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var configuration_1 = __webpack_require__(604);
	var ConfigService = (function () {
	    function ConfigService() {
	        this._configuration = new configuration_1.Configuration(ConfigService.PROD);
	    }
	    ConfigService.prototype.getContext = function (name) {
	        return this._configuration.getContext(name);
	    };
	    ConfigService.PROD = [
	        { name: 'auth', url: 'https://auth.api.novapointofsale.com/' },
	        { name: 'accounting', url: 'https://accounting.api.novapointofsale.com/' },
	        { name: 'bi', url: 'https://bi.api.novapointofsale.com/' },
	        { name: 'inventory', url: 'https://inventory.api.novapointofsale.com/' },
	        { name: 'management', url: 'https://management.api.novapointofsale.com/' },
	        { name: 'ba', url: 'https://app1.novapointofsale.com/v2/BillingAutomation/Location' },
	    ];
	    ConfigService.TEST = [
	        { name: 'auth', url: 'https://test.novapointofsale.com/auth/' },
	        { name: 'accounting', url: 'https://test.novapointofsale.com/accounting/' },
	        { name: 'bi', url: 'https://test.novapointofsale.com/bi/' },
	        { name: 'inventory', url: 'https://test.novapointofsale.com/inventory/' },
	        { name: 'management', url: 'https://test.novapointofsale.com/management/' },
	        { name: 'ba', url: 'https://app1.novapointofsale.com/v2/BillingAutomation/Location' },
	    ];
	    ConfigService.LOCAL = [
	        { name: 'auth', url: 'https://test.novapointofsale.com/auth/' },
	        { name: 'accounting', url: 'https://test.novapointofsale.com/accounting/' },
	        { name: 'bi', url: 'https://test.novapointofsale.com/bi/' },
	        { name: 'inventory', url: 'https://test.novapointofsale.com/inventory/' },
	        { name: 'management', url: 'http://localhost:63512/' },
	        { name: 'ba', url: 'https://app1.novapointofsale.com/v2/BillingAutomation/Location' },
	    ];
	    ConfigService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], ConfigService);
	    return ConfigService;
	}());
	exports.ConfigService = ConfigService;


/***/ },
/* 604 */
/***/ function(module, exports) {

	"use strict";
	var Configuration = (function () {
	    function Configuration(_boundedContexts) {
	        this._boundedContexts = _boundedContexts;
	    }
	    Configuration.prototype.getContext = function (name) {
	        return this._boundedContexts.find(function (c) { return c.name === name; });
	    };
	    return Configuration;
	}());
	exports.Configuration = Configuration;


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var store_helper_1 = __webpack_require__(574);
	var store_1 = __webpack_require__(575);
	var api_service_1 = __webpack_require__(275);
	var BehaviorSubject_1 = __webpack_require__(104);
	var config_service_1 = __webpack_require__(603);
	var models_1 = __webpack_require__(137);
	var management_service_1 = __webpack_require__(606);
	__webpack_require__(277);
	var UserService = (function () {
	    function UserService(_router, _storeHelper, _api, _store, _configService, _managementSvc) {
	        this._router = _router;
	        this._storeHelper = _storeHelper;
	        this._api = _api;
	        this._store = _store;
	        this._configService = _configService;
	        this._managementSvc = _managementSvc;
	        this._managementCtx = _configService.getContext('management');
	        this._userSubject = new BehaviorSubject_1.BehaviorSubject(null);
	    }
	    Object.defineProperty(UserService.prototype, "user$", {
	        get: function () {
	            return this._userSubject.asObservable();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    UserService.prototype.updateUserInfo = function () {
	        var _this = this;
	        var that = this;
	        this._api.get(this._managementCtx.url, 'users/me')
	            .map(function (userRaw) { return new models_1.User(userRaw); })
	            .subscribe(function (user) { return that._loadUserRegions(user); }, function (err) { return _this._handleHttpError(err); });
	    };
	    UserService.prototype.removeUser = function () {
	        this.user = null;
	        this._userSubject.next(this.user);
	    };
	    UserService.prototype.inactiveUser = function () {
	        this.user.active = false;
	        this._userSubject.next(this.user);
	    };
	    UserService.prototype.userHasAccess = function (err) {
	        return err.status !== 403;
	    };
	    UserService.prototype._handleHttpError = function (err) {
	        if (err.status === 500 || err.status === 401) {
	            this.user = new models_1.User(null);
	            this.user.isTokenValid = false;
	            this._userSubject.next(this.user);
	        }
	    };
	    UserService.prototype._loadUserRegions = function (user) {
	        var that = this;
	        that.user = user;
	        this._managementSvc.loadRegions(user)
	            .subscribe(function (regions) {
	            that.user.regions = regions;
	            that.user.locations = regions.map(function (r) { return r.locations; }).reduce(function (l, l2) { return l.concat(l2); });
	            that._userSubject.next(that.user);
	        });
	    };
	    UserService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof store_helper_1.StoreHelper !== 'undefined' && store_helper_1.StoreHelper) === 'function' && _b) || Object, (typeof (_c = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _c) || Object, (typeof (_d = typeof store_1.Store !== 'undefined' && store_1.Store) === 'function' && _d) || Object, (typeof (_e = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _e) || Object, (typeof (_f = typeof management_service_1.ManagementService !== 'undefined' && management_service_1.ManagementService) === 'function' && _f) || Object])
	    ], UserService);
	    return UserService;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.UserService = UserService;


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var store_1 = __webpack_require__(575);
	var store_helper_1 = __webpack_require__(574);
	var api_service_1 = __webpack_require__(275);
	var config_service_1 = __webpack_require__(603);
	__webpack_require__(417);
	var ManagementService = (function () {
	    function ManagementService(_storeHelper, _api, _store, _configService) {
	        this._storeHelper = _storeHelper;
	        this._api = _api;
	        this._store = _store;
	        this._configService = _configService;
	        this._managementCtx = _configService.getContext('management');
	    }
	    /*
	     * Load the regions this user has access to
	     * @param userRegionIds     Logged in user instance
	     */
	    ManagementService.prototype.loadRegions = function (user) {
	        var that = this;
	        return this._api.get(this._managementCtx.url, 'regions')
	            .map(function (regions) { return that._filterRegions(user, regions); });
	    };
	    ManagementService.prototype._filterRegions = function (user, regions) {
	        return regions.filter(function (region) { return user.regionIds.some(function (id) { return id === region.id; }); });
	    };
	    ManagementService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof store_helper_1.StoreHelper !== 'undefined' && store_helper_1.StoreHelper) === 'function' && _a) || Object, (typeof (_b = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _b) || Object, (typeof (_c = typeof store_1.Store !== 'undefined' && store_1.Store) === 'function' && _c) || Object, (typeof (_d = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _d) || Object])
	    ], ManagementService);
	    return ManagementService;
	    var _a, _b, _c, _d;
	}());
	exports.ManagementService = ManagementService;


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var NativeChannelService = (function () {
	    function NativeChannelService() {
	    }
	    NativeChannelService.prototype.callPhoneNumber = function (phoneNumber) {
	        console.log('Calling number: ' + phoneNumber);
	        this._postMessage("tel://" + phoneNumber);
	    };
	    NativeChannelService.prototype.setUserToken = function (token) {
	        console.log('Setting token: ' + token);
	        this._postMessage("setToken:" + token);
	    };
	    NativeChannelService.prototype.openLink = function (url) {
	        this._postMessage(url);
	    };
	    NativeChannelService.prototype.logoff = function () {
	        console.log('Logging user off');
	        this._postMessage('logoff');
	    };
	    NativeChannelService.prototype._postMessage = function (message) {
	        try {
	            var w = window;
	            // ios
	            if (w.webkit) {
	                w.webkit.messageHandlers.callbackHandler.postMessage(message);
	                return true;
	            }
	            // android
	            if (w.Android) {
	                w.Android.postMessage(message);
	                return true;
	            }
	        }
	        catch (err) {
	            console.log('error');
	        }
	        return false;
	    };
	    NativeChannelService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], NativeChannelService);
	    return NativeChannelService;
	}());
	exports.NativeChannelService = NativeChannelService;


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var LocalStorageService = (function () {
	    function LocalStorageService() {
	    }
	    LocalStorageService.prototype.get = function (key) {
	        if (!key) {
	            return;
	        }
	        return JSON.parse(window.localStorage.getItem(key));
	    };
	    LocalStorageService.prototype.set = function (key, data) {
	        if (!key || !data) {
	            return;
	        }
	        window.localStorage.setItem(key, JSON.stringify(data));
	    };
	    LocalStorageService.prototype.remove = function (key) {
	        if (!key) {
	            return;
	        }
	        window.localStorage.removeItem(key);
	    };
	    LocalStorageService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], LocalStorageService);
	    return LocalStorageService;
	}());
	exports.LocalStorageService = LocalStorageService;


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var models_1 = __webpack_require__(137);
	var native_channel_service_1 = __webpack_require__(607);
	var local_storage_service_1 = __webpack_require__(608);
	__webpack_require__(277);
	var AccountsService = (function () {
	    function AccountsService(_localStorageService, _nativeChannelService) {
	        this._localStorageService = _localStorageService;
	        this._nativeChannelService = _nativeChannelService;
	        this.Accounts_KEY = 'nova_accounts';
	    }
	    AccountsService.prototype.getAccounts = function () {
	        var accountsFromStorage = this._localStorageService.get(this.Accounts_KEY) || [];
	        return accountsFromStorage.map(function (a) { return new models_1.Account(a); });
	    };
	    AccountsService.prototype.getAccountByUser = function (user) {
	        if (!user) {
	            return;
	        }
	        return this.getAccountByName(user.accountName);
	    };
	    AccountsService.prototype.getAccountByName = function (accountName) {
	        var _this = this;
	        if (!accountName) {
	            return;
	        }
	        var accounts = this.getAccounts();
	        var account = accounts.find(function (a) { return _this.accountsEquals(accountName, a.accountName); });
	        if (account) {
	            return new models_1.Account(account);
	        }
	    };
	    AccountsService.prototype.updateAccounts = function (accountToUpdate) {
	        var _this = this;
	        if (!accountToUpdate || !accountToUpdate.accountName) {
	            return;
	        }
	        var accounts = this.getAccounts();
	        var account = this.getAccountByName(accountToUpdate.accountName);
	        //If account already exist remove it from local  storage and device token then add it again with new information
	        if (account) {
	            this._removeDeviceToken(account.access_token);
	            if (accountToUpdate.access_token) {
	                this._nativeChannelService.setUserToken(accountToUpdate.access_token);
	            }
	            accounts = accounts.filter(function (a) { return !_this.accountsEquals(accountToUpdate.accountName, a.accountName); });
	        }
	        accountToUpdate.accountName = this._formatAccount(accountToUpdate.accountName);
	        accounts.push(accountToUpdate);
	        this._localStorageService.set(this.Accounts_KEY, accounts);
	    };
	    AccountsService.prototype.removeAccount = function (accountName) {
	        var _this = this;
	        var account = this.getAccountByName(accountName);
	        if (account) {
	            //remove device token
	            this._nativeChannelService.setUserToken(account.access_token);
	            this._nativeChannelService.logoff();
	            //remove account from local storage
	            var accounts = this.getAccounts();
	            accounts = accounts.filter(function (a) { return !_this.accountsEquals(accountName, a.accountName); });
	            this._localStorageService.set(this.Accounts_KEY, accounts);
	        }
	    };
	    AccountsService.prototype.accountsEquals = function (account1, account2) {
	        if (!account1 || !account2) {
	            return false;
	        }
	        account1 = this._formatAccount(account1);
	        account2 = this._formatAccount(account2);
	        return account1 === account2;
	    };
	    AccountsService.prototype.removeUserTokenFromAccount = function (account) {
	        if (!account) {
	            return;
	        }
	        // Remove token from account to sign out
	        account['access_token'] = null;
	        this.updateAccounts(account);
	    };
	    AccountsService.prototype._formatAccount = function (account) {
	        if (!account) {
	            return;
	        }
	        return account.replace(/_/g, '-').toUpperCase();
	    };
	    AccountsService.prototype._removeDeviceToken = function (token) {
	        if (!token) {
	            return;
	        }
	        this._nativeChannelService.setUserToken(token);
	        this._nativeChannelService.logoff();
	    };
	    AccountsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof local_storage_service_1.LocalStorageService !== 'undefined' && local_storage_service_1.LocalStorageService) === 'function' && _a) || Object, (typeof (_b = typeof native_channel_service_1.NativeChannelService !== 'undefined' && native_channel_service_1.NativeChannelService) === 'function' && _b) || Object])
	    ], AccountsService);
	    return AccountsService;
	    var _a, _b;
	}());
	exports.AccountsService = AccountsService;


/***/ },
/* 610 */
/***/ function(module, exports) {

	module.exports = "<form [formGroup]=\"fg\"><div class=\"layout-column-xs layout-padding\"><div><select-picker [fg]=\"fg\" field=\"region\" label=\"Regions\" [liveSearch]=\"true\" [items]=\"regions\" liveSearchPlaceholder=\"... type to seach ...\" noneSelectedText=\"Select Region\" [alt]=\"true\" leftIcon=\"globe\"></select-picker></div><div *ngIf=\"showLocations\"><select-picker [fg]=\"fg\" field=\"location\" label=\"Locations\" [liveSearch]=\"true\" [items]=\"locations\" liveSearchPlaceholder=\"... type to seach ...\" noneSelectedText=\"Select Location\" [alt]=\"true\" leftIcon=\"pin\" [multiple]=\"allowSelectMultipleLocations\"></select-picker></div></div></form>";

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var location_picker_1 = __webpack_require__(612);
	var sheet_1 = __webpack_require__(613);
	var LocationPickerSheetComponent = (function () {
	    function LocationPickerSheetComponent() {
	        this.showLocations = true;
	        this.applyChanges = new core_1.EventEmitter();
	    }
	    LocationPickerSheetComponent.prototype.toggle = function () {
	        this.sheetComponent.toggle();
	    };
	    LocationPickerSheetComponent.prototype.onApplyClicked = function () {
	        var form = this.locationPickerComponent.fg;
	        if (form.valid) {
	            var selection = this.locationPickerComponent.getSelection();
	            this.applyChanges.emit(selection);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], LocationPickerSheetComponent.prototype, "showLocations", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], LocationPickerSheetComponent.prototype, "applyChanges", void 0);
	    __decorate([
	        core_1.ViewChild(sheet_1.SheetComponent), 
	        __metadata('design:type', Object)
	    ], LocationPickerSheetComponent.prototype, "sheetComponent", void 0);
	    __decorate([
	        core_1.ViewChild(location_picker_1.LocationPickerComponent), 
	        __metadata('design:type', Object)
	    ], LocationPickerSheetComponent.prototype, "locationPickerComponent", void 0);
	    LocationPickerSheetComponent = __decorate([
	        core_1.Component({
	            selector: 'location-picker-sheet',
	            template: __webpack_require__(614)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocationPickerSheetComponent);
	    return LocationPickerSheetComponent;
	}());
	exports.LocationPickerSheetComponent = LocationPickerSheetComponent;


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(273));


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(268));


/***/ },
/* 614 */
/***/ function(module, exports) {

	module.exports = "<sheet color=\"red\"><location-picker (locationChanged)=\"onLocationChanged($event)\" [showLocations]=\"showLocations\"></location-picker><div class=\"layout-row layout-align-end layout-padding\"><bw-button title=\"Apply\" icon=\"check\" color=\"white\" [simple]=\"true\" (clicked)=\"onApplyClicked($event)\"></bw-button></div></sheet>";

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var PaperCoverComponent = (function () {
	    function PaperCoverComponent() {
	        this.effect = 'slideInRight';
	        this.outEffect = 'slideOutRight';
	        this.closeIcon = 'chevron-right';
	        this.closed = new core_1.EventEmitter();
	    }
	    PaperCoverComponent.prototype.close = function (e) {
	        var _this = this;
	        e.preventDefault();
	        this.effect = this.outEffect;
	        setTimeout(function () { return _this.closed.emit(); }, 1200);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], PaperCoverComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], PaperCoverComponent.prototype, "effect", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], PaperCoverComponent.prototype, "outEffect", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], PaperCoverComponent.prototype, "closeIcon", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], PaperCoverComponent.prototype, "closed", void 0);
	    PaperCoverComponent = __decorate([
	        core_1.Component({
	            selector: 'paper-cover',
	            styles: [
	                "\n        .paper-cover {\n            position: fixed;\n            top: 0;\n            left: 0;\n            height: 100%;\n            width: 100%;\n            z-index: 2000;\n            background-color: rgba(0,0,0,0.9);\n        }\n        .paper-cover .cover-content {\n            overflow: auto;\n        }\n        .paper-cover .title {\n            text-align: center;\n            color: #ccc;\n            font-size: 24px;\n            margin-left: 20px;\n        }\n        "
	            ],
	            template: "\n        <div class=\"paper-cover animated {{effect}}\">\n            <div class=\"layout-column layout-padding h-100\">\n                <div class=\"flex-nogrow layout-row\">\n                    <div class=\"layout-row layout-align-center-center\">\n                        <div class=\"flex-nogrow\">\n                            <bw-button \n                                        *ngIf=\"closeIcon\" \n                                        color=\"red\" \n                                        icon=\"{{closeIcon}}\" \n                                        [circular]=\"true\" \n                                        (click)=\"close($event)\n                            \">\n                            </bw-button>\n                        </div>\n                        <div class=\"flex title text-center\">{{title}}</div>\n                    </div>\n                </div>\n                <div class=\"flex cover-content\">\n                    <ng-content></ng-content>\n                </div>\n            </div>\n        </div>\n    ",
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PaperCoverComponent);
	    return PaperCoverComponent;
	}());
	exports.PaperCoverComponent = PaperCoverComponent;


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var PagePreloaderComponent = (function () {
	    function PagePreloaderComponent() {
	        this.message = 'Loading ...';
	        this.effect = 'fadeIn';
	        this.hidden = false;
	    }
	    PagePreloaderComponent.prototype.show = function () {
	        this.hidden = false;
	        this.effect = 'fadeIn';
	    };
	    PagePreloaderComponent.prototype.hide = function () {
	        var _this = this;
	        this.effect = 'fadeOut';
	        setTimeout(function () { return _this.hidden = true; }, 1200);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], PagePreloaderComponent.prototype, "message", void 0);
	    PagePreloaderComponent = __decorate([
	        core_1.Component({
	            selector: 'page-preloader',
	            styles: ["\n        .page-preloader {\n            position: fixed;\n            top: 0;\n            left: 0;\n            height: 100%;\n            width: 100%;\n            z-index: 18;\n            background-color: rgba(0,0,0,0.7);\n        }\n    "],
	            template: "\n        <div class=\"page-preloader animated {{effect}}\" [class.hidden]=\"hidden\">\n            <div class=\"layout-column layout-align-center-center h-100\">\n                <div class=\"flex-nogrow text-center\">\n                    <bw-preloader color=\"red\"></bw-preloader>\n                    <div>{{message}}</div>\n                </div>\n            </div>\n        </div>\n    "
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PagePreloaderComponent);
	    return PagePreloaderComponent;
	}());
	exports.PagePreloaderComponent = PagePreloaderComponent;


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(618));


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var _1 = __webpack_require__(132);
	var AppPageComponent = (function () {
	    function AppPageComponent() {
	    }
	    AppPageComponent.prototype.ngOnInit = function () {
	        this.activatePreloader();
	    };
	    AppPageComponent.prototype.activatePreloader = function () {
	        this.preloader.show();
	    };
	    AppPageComponent.prototype.deactivatePreloader = function () {
	        this.preloader.hide();
	    };
	    __decorate([
	        core_1.ViewChild(_1.PagePreloaderComponent), 
	        __metadata('design:type', Object)
	    ], AppPageComponent.prototype, "preloader", void 0);
	    AppPageComponent = __decorate([
	        core_1.Component({
	            selector: 'app-page',
	            styles: ["        \n        .app-page {\n            padding-top: 70px;\n            position: relative;\n            overflow: auto;\n            height: 100%;\n\n            .mobile-page-content {\n                height: 100%;\n                overflow: auto;\n            }\n        }\n    "],
	            template: "\n        <div class=\"app-page h-100\">\n            <page-preloader></page-preloader>\n            <ng-content></ng-content>\n        </div>\n    "
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppPageComponent);
	    return AppPageComponent;
	}());
	exports.AppPageComponent = AppPageComponent;


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var UserFeedbackComponent = (function () {
	    function UserFeedbackComponent() {
	        this.type = 'info'; // values: info, warning, error, success
	        this.icon = 'info';
	    }
	    UserFeedbackComponent.prototype.ngOnInit = function () {
	        switch (this.type) {
	            case 'info':
	                this.icon = 'info-outline';
	                break;
	            case 'warning':
	                this.icon = 'alert-triangle';
	                break;
	            case 'success':
	                this.icon = 'check';
	                break;
	            case 'error':
	                this.icon = 'alert-octagon';
	                break;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], UserFeedbackComponent.prototype, "type", void 0);
	    __decorate([
	        // values: info, warning, error, success
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], UserFeedbackComponent.prototype, "message", void 0);
	    UserFeedbackComponent = __decorate([
	        core_1.Component({
	            selector: 'user-feedback',
	            styles: [__webpack_require__(620)],
	            template: __webpack_require__(621),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], UserFeedbackComponent);
	    return UserFeedbackComponent;
	}());
	exports.UserFeedbackComponent = UserFeedbackComponent;


/***/ },
/* 620 */
/***/ function(module, exports) {

	module.exports = ".user-feedback{margin-top:25px}.user-feedback .icon{font-size:62px}.user-feedback .message{font-size:18px}.user-feedback.info{color:#FFC107}.user-feedback.warning{color:#FF5722}.user-feedback.success{color:#4CAF50}.user-feedback.error{color:#E41736}\n"

/***/ },
/* 621 */
/***/ function(module, exports) {

	module.exports = "<div class=\"user-feedback animated shake layout-column layout-align-start-center h-100 {{type}}\"><div class=\"flex-nogrow message text-center\"><div class=\"icon\"><i class=\"zmdi zmdi-{{icon}}\"></i></div><div class=\"message\">{{message}}</div></div></div>";

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(623));


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var platform_browser_1 = __webpack_require__(22);
	var HorizontalSliderComponent = (function () {
	    function HorizontalSliderComponent(_sanitizer) {
	        this._sanitizer = _sanitizer;
	        this.items = [];
	        this.itemWidth = 60;
	        this.itemClicked = new core_1.EventEmitter();
	    }
	    HorizontalSliderComponent.prototype.ngOnInit = function () { };
	    HorizontalSliderComponent.prototype.getContainerStyle = function () {
	        return this._sanitizer.bypassSecurityTrustStyle("\n            width: " + ((this.itemWidth * this.items.length) + (30 * this.items.length) + 300) + "px;\n            margin-left: calc(50% - " + this.itemWidth + "px);            \n        ");
	    };
	    HorizontalSliderComponent.prototype.activate = function (e, item) {
	        e.preventDefault();
	        this.items.forEach(function (i) { return i.selected = false; });
	        item.selected = true;
	        this.itemClicked.emit(item);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], HorizontalSliderComponent.prototype, "items", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], HorizontalSliderComponent.prototype, "itemWidth", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], HorizontalSliderComponent.prototype, "itemClicked", void 0);
	    HorizontalSliderComponent = __decorate([
	        core_1.Component({
	            selector: 'horizontal-slider',
	            styles: ["\n        .slider-container {\n            display: block;\n            width: 100%;\n            overflow-x: auto;\n        }\n        .horizontal-slider {\n            display: block;\n            background-color: transparent;            \n        }\n        .horizontal-slider .item {\n            text-align: center;\n            padding: 10px 15px;\n            display: inline-block;\n            transition: 0.2s;\n            font-size: 16px;\n        }\n        .horizontal-slider .item.active {\n            transform: scale(1.2);\n            color: #FFC107;\n        }\n\n    "],
	            template: "\n        <div class=\"slider-container\">\n            <div class=\"horizontal-slider\" [attr.style]=\"getContainerStyle()\">\n                <div class=\"item\" *ngFor=\"let item of items\" (click)=\"activate($event, item)\" [class.active]=\"item.selected\">\n                    {{item.name}}\n                </div>\n            </div>\n        <div>\n    "
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof platform_browser_1.DomSanitizer !== 'undefined' && platform_browser_1.DomSanitizer) === 'function' && _a) || Object])
	    ], HorizontalSliderComponent);
	    return HorizontalSliderComponent;
	    var _a;
	}());
	exports.HorizontalSliderComponent = HorizontalSliderComponent;


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(619));


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(626));


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var ui_1 = __webpack_require__(132);
	var models_2 = __webpack_require__(137);
	var FilterSheetComponent = (function () {
	    function FilterSheetComponent(_userSvc) {
	        this._userSvc = _userSvc;
	        this.filterChanged = new core_1.EventEmitter();
	        this.dateOptions = ['Today', 'Custom Range'];
	        this.activeOption = this.dateOptions[0];
	    }
	    FilterSheetComponent.prototype.ngOnDestroy = function () { };
	    FilterSheetComponent.prototype.locationPickerReady = function () {
	        this.applyFilter(null);
	    };
	    FilterSheetComponent.prototype.toggle = function () {
	        this.sheet.toggle();
	    };
	    FilterSheetComponent.prototype.onDateOptionSelected = function (option) {
	        this.showDateRange = option === 'Custom Range';
	    };
	    FilterSheetComponent.prototype.applyFilter = function (e) {
	        if (e) {
	            e.preventDefault();
	        }
	        var value = this.fg.value;
	        var dateRange = this.showDateRange ?
	            new models_1.DateRange(value.from, value.to)
	            : new models_1.DateRange();
	        this.IsValidDateRange = dateRange.isValid;
	        if (this.IsValidDateRange) {
	            var locationsPickerSelection = this.locationPicker.getSelection();
	            var filter = new models_2.GeneralFilter(dateRange, locationsPickerSelection, value.filter);
	            this.filterChanged.emit(filter);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
	    ], FilterSheetComponent.prototype, "fg", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof models_2.GeneralFilter !== 'undefined' && models_2.GeneralFilter) === 'function' && _b) || Object)
	    ], FilterSheetComponent.prototype, "filter", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], FilterSheetComponent.prototype, "filterChanged", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.SheetComponent), 
	        __metadata('design:type', Object)
	    ], FilterSheetComponent.prototype, "sheet", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.LocationPickerComponent), 
	        __metadata('design:type', Object)
	    ], FilterSheetComponent.prototype, "locationPicker", void 0);
	    FilterSheetComponent = __decorate([
	        core_1.Component({
	            selector: 'filter-sheet',
	            template: __webpack_require__(627)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _c) || Object])
	    ], FilterSheetComponent);
	    return FilterSheetComponent;
	    var _a, _b, _c;
	}());
	exports.FilterSheetComponent = FilterSheetComponent;


/***/ },
/* 627 */
/***/ function(module, exports) {

	module.exports = "<sheet><div class=\"text-center m-b-15\"><bw-button-group [options]=\"dateOptions\" [activeOption]=\"activeOption\" type=\"danger\" (optionSelected)=\"onDateOptionSelected($event)\"></bw-button-group></div><div class=\"layout-row layout-padding\">       <text-box [fg]=\"fg\" [alt]=\"true\" field=\"filter\" leftIcon=\"search\" label=\"Filter employees\"></text-box></div><date-range [fg]=\"fg\" [class.hidden]=\"!showDateRange\"></date-range><div class=\"text-center c-white animated shake\" *ngIf=\"showDateRange &amp;&amp; !IsValidDateRange\"><i class=\"zmdi zmdi-info-outline m-r-10\"> </i>Invalid Range</div><location-picker [fg]=\"fg\" (filterReady)=\"locationPickerReady($event)\"></location-picker><div class=\"text-right m-b-10\"><bw-button title=\"Apply\" icon=\"check\" [simple]=\"true\" (click)=\"applyFilter($event)\"></bw-button></div></sheet>";

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(629));


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var AsyncContentComponent = (function () {
	    function AsyncContentComponent() {
	        this.busy = false;
	        this.backgroundColor = 'black';
	        this.opacity = 0.8;
	        this.loaderColor = '#E41736';
	        this.message = 'Loading ...';
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AsyncContentComponent.prototype, "busy", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AsyncContentComponent.prototype, "backgroundColor", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AsyncContentComponent.prototype, "opacity", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AsyncContentComponent.prototype, "loaderColor", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AsyncContentComponent.prototype, "message", void 0);
	    AsyncContentComponent = __decorate([
	        core_1.Component({
	            selector: 'async-content',
	            styles: [__webpack_require__(630)],
	            template: "\n        <div class=\"async-content\">\n            <div class=\"background\" [style.background-color]=\"backgroundColor\" [style.opacity]=\"opacity\" [class.hidden]=\"!busy\"></div>\n            <div class=\"preloader-container\" [class.hidden]=\"!busy\">\n                <div class=\"layout-column layout-align-center-center h-100\">\n                    <div class=\"flex-nogrow\">{{message}}</div>\n                </div>\n            </div>\n            <div [class.hidden]=\"busy\" class=\"animated fadeIn\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n    ",
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AsyncContentComponent);
	    return AsyncContentComponent;
	}());
	exports.AsyncContentComponent = AsyncContentComponent;


/***/ },
/* 630 */
/***/ function(module, exports) {

	module.exports = ".async-content{position:relative;min-height:40px}.async-content .preloader-container{position:absolute;left:0;right:0;top:0;bottom:0;color:white}.async-content .background{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}\n"

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(632));


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var RibbonMessageComponent = (function () {
	    function RibbonMessageComponent() {
	        this.backgroundColor = 'black';
	        this.color = 'white';
	        this.message = '';
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], RibbonMessageComponent.prototype, "backgroundColor", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], RibbonMessageComponent.prototype, "color", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], RibbonMessageComponent.prototype, "message", void 0);
	    RibbonMessageComponent = __decorate([
	        core_1.Component({
	            selector: 'ribbon-message',
	            styles: [__webpack_require__(633)],
	            template: __webpack_require__(634),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], RibbonMessageComponent);
	    return RibbonMessageComponent;
	}());
	exports.RibbonMessageComponent = RibbonMessageComponent;


/***/ },
/* 633 */
/***/ function(module, exports) {

	module.exports = ".ribbon-content{position:relative;min-height:40px}.ribbon-content .content{position:absolute;left:0;right:0;top:0;bottom:0;color:white}.ribbon-content .content .label{font-weight:bold}.ribbon-content .background{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}\n"

/***/ },
/* 634 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ribbon-content\"> <div class=\"background\" [style.background-color]=\"backgroundColor\"><div class=\"content animated fadeIn\"> <div class=\"layout-column layout-align-center-center h-100\"><span [style.color]=\"color\"><strong>{{ message }}</strong></span></div></div></div></div>";

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(2);
	var DynamicImageComponent = (function () {
	    function DynamicImageComponent(_sanitizer) {
	        this._sanitizer = _sanitizer;
	        this.width = 96;
	        this.alt = false;
	    }
	    Object.defineProperty(DynamicImageComponent.prototype, "imageUrl", {
	        get: function () {
	            if (!this.image) {
	                return null;
	            }
	            return this.image + "?width=" + this.ampedN + "&height=" + this.ampedN;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DynamicImageComponent.prototype, "ampedN", {
	        get: function () {
	            return this._nearestMultipleOfTwo(this.width * 1.5);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DynamicImageComponent.prototype, "imgStyle", {
	        get: function () {
	            var tickness = Math.round(this.width * 0.05);
	            var opacity = this.alt ? 0.8 : 0.3;
	            return this._sanitizer.bypassSecurityTrustStyle("border: " + tickness + "px solid rgba(50, 50, 50, " + opacity + "); \n                                                         object-fit: cover; margin: auto; border-radius: 50%; \n                                                         position: relative; width: " + this.width + "px; height: " + this.width + "px;");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DynamicImageComponent.prototype, "textMargin", {
	        get: function () {
	            return Math.ceil(this.width * 0.06);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DynamicImageComponent.prototype._nearestMultipleOfTwo = function (n) {
	        return Math.ceil(n / 2) * 2;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DynamicImageComponent.prototype, "width", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DynamicImageComponent.prototype, "image", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DynamicImageComponent.prototype, "text", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DynamicImageComponent.prototype, "alt", void 0);
	    DynamicImageComponent = __decorate([
	        core_1.Component({
	            selector: 'dynamic-image',
	            styles: [__webpack_require__(636)],
	            template: __webpack_require__(637)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof platform_browser_1.DomSanitizer !== 'undefined' && platform_browser_1.DomSanitizer) === 'function' && _a) || Object])
	    ], DynamicImageComponent);
	    return DynamicImageComponent;
	    var _a;
	}());
	exports.DynamicImageComponent = DynamicImageComponent;


/***/ },
/* 636 */
/***/ function(module, exports) {

	module.exports = "div{border-radius:50%;position:relative}.user-image{border-radius:50%;border-width:5px;position:absolute}.text-footer{color:#9E9E9E;font-size:14px}.text-footer.ui-alt{color:#f5f5f5 !important}\n"

/***/ },
/* 637 */
/***/ function(module, exports) {

	module.exports = "<div class=\"layout-column layout-align-center-center\"><div class=\"image-cropper\" [style.width.px]=\"width\" [style.height.px]=\"width\"><div class=\"user-image\" [style.width.px]=\"width\" [style.height.px]=\"width\"><img *ngIf=\"image\" src=\"{{imageUrl}}\" [attr.style]=\"imgStyle\"/></div></div><div class=\"text-footer text-center\" [class.ui-alt]=\"alt\" [style.margin-top.px]=\"textMargin\"> {{ text }}</div></div>";

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var dynamic_image_component_1 = __webpack_require__(635);
	var platform_browser_1 = __webpack_require__(22);
	var services_1 = __webpack_require__(274);
	var core_1 = __webpack_require__(2);
	var models_1 = __webpack_require__(137);
	var UserImageComponent = (function (_super) {
	    __extends(UserImageComponent, _super);
	    function UserImageComponent(_configService, _userService, _sanitizer) {
	        var _this = this;
	        _super.call(this, _sanitizer);
	        this._configService = _configService;
	        this._userService = _userService;
	        this.width = 96;
	        this.alt = false;
	        this._baseUrl = this._configService.getContext('management').url;
	        var sub = this._userService.user$.subscribe(function (u) { return _this.user = u; });
	    }
	    Object.defineProperty(UserImageComponent.prototype, "userImage", {
	        get: function () {
	            if (!this.user || !this.user.isTokenValid) {
	                return null;
	            }
	            var url = this._baseUrl + "/users/" + models_1.strToUrl(this.user.tenant) + "/" + this.user.id + ".jpg";
	            return url;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(UserImageComponent.prototype, "name", {
	        get: function () {
	            if (this.user) {
	                return this.user.name;
	            }
	            return '';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], UserImageComponent.prototype, "width", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], UserImageComponent.prototype, "alt", void 0);
	    UserImageComponent = __decorate([
	        core_1.Component({
	            selector: 'user-image',
	            template: __webpack_require__(639)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _b) || Object, (typeof (_c = typeof platform_browser_1.DomSanitizer !== 'undefined' && platform_browser_1.DomSanitizer) === 'function' && _c) || Object])
	    ], UserImageComponent);
	    return UserImageComponent;
	    var _a, _b, _c;
	}(dynamic_image_component_1.DynamicImageComponent));
	exports.UserImageComponent = UserImageComponent;


/***/ },
/* 639 */
/***/ function(module, exports) {

	module.exports = "<div class=\"layout-column layout-align-center-center\"><dynamic-image [alt]=\"alt\" [width]=\"width\" [image]=\"userImage\" text=\"{{name}}\"> </dynamic-image></div>";

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var app_page_component_1 = __webpack_require__(618);
	var models_1 = __webpack_require__(137);
	var services_1 = __webpack_require__(274);
	var notifications_service_1 = __webpack_require__(641);
	var core_1 = __webpack_require__(2);
	var NotificationsComponent = (function (_super) {
	    __extends(NotificationsComponent, _super);
	    function NotificationsComponent(store, storeHelper, userService, notificationService) {
	        _super.call(this, store, storeHelper, userService);
	        this.notificationService = notificationService;
	        this.notifications = [];
	        this.pushNotifications = [];
	        this.error = '';
	        this.elementsLoaded = { system: false, push: false };
	        this.headerTitle = 'Notifications';
	        this.headerActions = [{ id: 'none', icon: 'none' }];
	    }
	    NotificationsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var that = this;
	        this.pushNotificationSub = this.notificationService.getPushNotifications()
	            .subscribe(function (n) { return _this.pushNotifications = n; }, function (err) { return _this.error = err; }, function () { return that.notifyElementLoaded('push'); });
	        this.notificationSub = this.notificationService.getSystemNotifications()
	            .subscribe(function (n) { return _this.notifications = n; }, function (err) { return _this.error = err; }, function () { return that.notifyElementLoaded('system'); });
	    };
	    NotificationsComponent.prototype.ngOnDestroy = function () {
	        this.notificationSub.unsubscribe();
	        this.pushNotificationSub.unsubscribe();
	    };
	    NotificationsComponent.prototype.notifyElementLoaded = function (element) {
	        if (element === void 0) { element = null; }
	        if (!element) {
	            return;
	        }
	        ;
	        switch (element) {
	            case 'system':
	                this.elementsLoaded.system = true;
	                if (this.elementsLoaded.push === true && this.elementsLoaded.system === true) {
	                    this.appPage.deactivatePreloader();
	                }
	                break;
	            case 'push':
	                this.elementsLoaded.push = true;
	                if (this.elementsLoaded.push === true && this.elementsLoaded.system === true) {
	                    this.appPage.deactivatePreloader();
	                }
	                break;
	        }
	    };
	    __decorate([
	        core_1.ViewChild(app_page_component_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], NotificationsComponent.prototype, "appPage", void 0);
	    NotificationsComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(647),
	            styles: [__webpack_require__(648)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _a) || Object, (typeof (_b = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _b) || Object, (typeof (_c = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _c) || Object, (typeof (_d = typeof notifications_service_1.NotificationService !== 'undefined' && notifications_service_1.NotificationService) === 'function' && _d) || Object])
	    ], NotificationsComponent);
	    return NotificationsComponent;
	    var _a, _b, _c, _d;
	}(models_1.TopLevelComponent));
	exports.NotificationsComponent = NotificationsComponent;


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(642);
	var core_1 = __webpack_require__(2);
	var NotificationService = (function () {
	    function NotificationService(_storeHelper, _configService, _userService, _apiService) {
	        this._storeHelper = _storeHelper;
	        this._configService = _configService;
	        this._userService = _userService;
	        this._apiService = _apiService;
	        this.baseUrl = this._configService.getContext('bi').url;
	        this.systemNotificationsPath = 'feeds/notifications';
	        this.pushNotificationsPath = 'feeds/push';
	        this.systemNotifications = [];
	        this.pushNotifications = [];
	    }
	    NotificationService.prototype.getSystemNotifications = function (regions, page, size, start) {
	        if (regions === void 0) { regions = []; }
	        if (page === void 0) { page = 1; }
	        if (size === void 0) { size = 50; }
	        var notificationsFilter = new models_1.NotificationsFilter(regions, page, size, start);
	        var notifications$ = this._apiService.get(this.baseUrl, this.systemNotificationsPath, notificationsFilter)
	            .map(function (report) { return report.data.map(function (r) { return new models_1.Notification(r); }); }).cache();
	        return notifications$;
	    };
	    NotificationService.prototype.getPushNotifications = function (page, size, start) {
	        if (page === void 0) { page = 1; }
	        if (size === void 0) { size = 50; }
	        var pushNotificationsFilter = new models_1.PushNotificationsFilter(page, size, start);
	        var pushNotifications$ = this._apiService.get(this.baseUrl, this.pushNotificationsPath, pushNotificationsFilter)
	            .map(function (report) { return report.data.map(function (r) { return new models_1.PushNotification(r); }); }).cache();
	        return pushNotifications$;
	    };
	    NotificationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object, (typeof (_c = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _c) || Object, (typeof (_d = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _d) || Object])
	    ], NotificationService);
	    return NotificationService;
	    var _a, _b, _c, _d;
	}());
	exports.NotificationService = NotificationService;


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(643));
	__export(__webpack_require__(644));
	__export(__webpack_require__(645));
	__export(__webpack_require__(646));


/***/ },
/* 643 */
/***/ function(module, exports) {

	"use strict";
	var Notification = (function () {
	    function Notification(obj) {
	        this.id = obj.order || null;
	        Object.assign(this, obj);
	    }
	    return Notification;
	}());
	exports.Notification = Notification;


/***/ },
/* 644 */
/***/ function(module, exports) {

	"use strict";
	var PushNotification = (function () {
	    function PushNotification(obj) {
	        this.id = obj.order || null;
	        Object.assign(this, obj);
	    }
	    return PushNotification;
	}());
	exports.PushNotification = PushNotification;


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var utils_1 = __webpack_require__(253);
	var moment = __webpack_require__(139);
	var NotificationsFilter = (function () {
	    function NotificationsFilter(regions, page, size, start) {
	        this.regions = regions;
	        this.page = page || 1;
	        this.size = size || 50;
	        this.start = start || null;
	    }
	    NotificationsFilter.prototype.toQueryString = function () {
	        var payload = {
	            page: this.page,
	            size: this.size,
	        };
	        if (this.regions.length > 0) {
	            payload['regions'] = this.regions;
	        }
	        ;
	        if (this.start) {
	            payload['date[start]'] = moment(this.start).format('MM/DD/YYYY');
	        }
	        return utils_1.objToQueryString(payload);
	    };
	    return NotificationsFilter;
	}());
	exports.NotificationsFilter = NotificationsFilter;


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var utils_1 = __webpack_require__(253);
	var moment = __webpack_require__(139);
	var PushNotificationsFilter = (function () {
	    function PushNotificationsFilter(page, size, start) {
	        this.page = page || 1;
	        this.size = size || 50;
	        this.start = start || null;
	    }
	    PushNotificationsFilter.prototype.toQueryString = function () {
	        var payload = {
	            page: this.page,
	            size: this.size,
	        };
	        if (this.start) {
	            payload['start'] = moment(this.start).format('MM/DD/YYYY');
	        }
	        return utils_1.objToQueryString(payload);
	    };
	    return PushNotificationsFilter;
	}());
	exports.PushNotificationsFilter = PushNotificationsFilter;


/***/ },
/* 647 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"mobile-page-content\"><div class=\"layout-column h-100\"><tabset [alt]=\"true\"><tab heading=\"Push\">   <div class=\"layout-column layout-padding\"><div class=\"flex text-center\" *ngIf=\"pushNotifications.length &lt; 1 &amp;&amp; elementsLoaded.push\"><h3>You don't have push notifications at this time.</h3></div></div><div class=\"notification\" *ngFor=\"let pushNotification of pushNotifications\"><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"timestamp\">{{ pushNotification.timestamp | momentify:'MM/DD/YYYY hh:mm a' }}</div></div></div><div class=\"layout-row\"><div class=\"flex text-left notification-text\"><div *ngFor=\"let line of pushNotification.text.split('\n')\"> <span [innerHtml]=\"line | linkify\"></span></div></div></div></div></tab><tab heading=\"System\"> <div class=\"layout-column layout-padding\"><div class=\"flex text-center\" *ngIf=\"notifications.length &lt; 1 &amp;&amp; elementsLoaded.system\"><h3>You don't have system notifications at this time.</h3></div></div><div class=\"notification\" *ngFor=\"let notification of notifications\"><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"timestamp\">{{ notification.timestamp | momentify:'MM/DD/YYYY hh:mm a' }}</div></div></div><div class=\"layout-row\"><div class=\"flex text-left notification-text\"><div *ngFor=\"let line of notification.text.split('\n')\"> <span>{{ line | stripHTML }}</span></div></div></div><div class=\"layout-row\"><div class=\"flex-9\"><i class=\"icon zmdi zmdi-globe\"></i></div><div class=\"flex-91 footer\"><strong>Region: </strong> {{ notification.region.name }}     </div></div></div></tab></tabset></div></div></app-page>";

/***/ },
/* 648 */
/***/ function(module, exports) {

	module.exports = ".notification{display:block;color:#aeaeae !important;clear:both;cursor:pointer;padding:10px 15px}.notification::after{content:'';display:block;width:100%;margin-top:5px;border-bottom:1px solid #404040}.notification .notification-text{padding-top:10px;padding-bottom:10px;font-size:13px}.notification .icon{width:18px;font-size:18px;color:#9e9e9e}.notification .footer{color:#9e9e9e}.notification .timestamp{color:#737373;font-size:11px}h3{color:#555}a *{font-weight:bold}\n"

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var StripHTMLPipe = (function () {
	    function StripHTMLPipe() {
	    }
	    StripHTMLPipe.prototype.transform = function (value) {
	        return value ? String(value).replace(/<[^>]+>/gm, '') : '';
	    };
	    StripHTMLPipe = __decorate([
	        core_1.Pipe({
	            name: 'stripHTML'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], StripHTMLPipe);
	    return StripHTMLPipe;
	}());
	exports.StripHTMLPipe = StripHTMLPipe;


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(651));


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var ui_1 = __webpack_require__(132);
	var services_1 = __webpack_require__(274);
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var SideNavComponent = (function () {
	    function SideNavComponent(_authService, _userSvc, _router, _nativeChannelService, _config) {
	        this._authService = _authService;
	        this._userSvc = _userSvc;
	        this._router = _router;
	        this._nativeChannelService = _nativeChannelService;
	        this._config = _config;
	        this.itemClicked = new core_1.EventEmitter();
	        this.user = new models_1.User({});
	        this.menuItems = [
	            { id: '1', title: 'Dashboard', icon: 'view-dashboard', route: '/dashboard' },
	            {
	                id: '2', title: 'Employees', icon: 'accounts', children: [
	                    { id: '21', title: 'Scores', icon: 'star-outline', route: '/employees/scores' },
	                    { id: '22', title: 'Salaries', icon: 'money-box', route: '/employees/salaries' },
	                ]
	            },
	            { id: '3', title: 'Locations', icon: 'navigation', route: '/locations' },
	            { id: '4', title: 'Customers', icon: 'accounts-list-alt', route: '/customers' },
	            { id: '5', title: 'Inventory', icon: 'assignment-check', route: '/inventory', children: [
	                    { id: '51', title: 'Inventory', icon: 'assignment-check', route: '/inventory' },
	                    { id: '52', title: 'Transfer', icon: 'swap', route: '/inventory/transfer' },
	                    { id: '53', title: 'Transfer History', icon: 'calendar-alt', route: '/inventory/transfer-history' },
	                ]
	            },
	            { id: '6', title: 'Accounting', icon: 'balance-wallet', children: [
	                    { id: '61', title: 'Profit/Loss', icon: 'eye', route: '/accounting/profit-loss' },
	                    { id: '62', title: 'Payment Methods', icon: 'card', route: '/accounting/payment' },
	                    { id: '63', title: 'Refunds', icon: 'refresh', route: '/accounting/refunds' },
	                ]
	            },
	            { id: '7', title: 'Check In/Out', icon: 'alarm-check', route: '/clock-in-out' },
	            { id: '8', title: 'Bill & Payments', icon: 'money-box' },
	        ];
	    }
	    SideNavComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._userSvc.user$.subscribe(function (user) {
	            _this.user = user ? user : new models_1.User(null);
	        });
	    };
	    SideNavComponent.prototype.callSupport = function () {
	        this._nativeChannelService.callPhoneNumber('18883706682');
	    };
	    SideNavComponent.prototype.navigate = function (route) {
	        this._router.navigate([route]);
	    };
	    SideNavComponent.prototype.onMenuItemClicked = function (item) {
	        if (item.id === String(8)) {
	            if (!this._nativeChannelService.openLink(this._config.getContext('ba').url)) {
	                window.open(this._config.getContext('ba').url);
	            }
	        }
	    };
	    /*singoutMode() {
	      setTimeout(() => this.singoutDetails = true, 100);
	    }
	  
	    singout() {
	      this._authService.signout(true);
	      this.singoutDetails = false;
	    }
	  
	    /*coverClosed(e: MouseEvent) {
	       e.preventDefault();
	       this.paperCoverComponent.effect = 'slideOutLeft';
	       setTimeout(() => this.singoutDetails = false, 1200);
	    }*/
	    SideNavComponent.prototype.switchAccount = function (e) {
	        e.preventDefault();
	        this.singoutDetails = false;
	        this._router.navigate(['accounts']);
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.PaperCoverComponent), 
	        __metadata('design:type', Object)
	    ], SideNavComponent.prototype, "paperCoverComponent", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], SideNavComponent.prototype, "open", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], SideNavComponent.prototype, "itemClicked", void 0);
	    SideNavComponent = __decorate([
	        core_1.Component({
	            selector: 'my-sidenav',
	            styles: [__webpack_require__(652)],
	            template: __webpack_require__(653),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.AuthService !== 'undefined' && services_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof services_1.NativeChannelService !== 'undefined' && services_1.NativeChannelService) === 'function' && _d) || Object, (typeof (_e = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _e) || Object])
	    ], SideNavComponent);
	    return SideNavComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.SideNavComponent = SideNavComponent;


/***/ },
/* 652 */
/***/ function(module, exports) {

	module.exports = ".options{padding:10px}.vertical-align{position:fixed;top:50%;left:50%;transform:translate(-50%, -50%)}@media (max-height: 570px){.user{display:none}}\n"

/***/ },
/* 653 */
/***/ function(module, exports) {

	module.exports = "<sidebar [open]=\"open\"><!--paper-cover(          *ngIf=\"singoutDetails\", \n          (closed)=\"coverClosed()\", \n          effect = 'slideInLeft', \n          outEffect=\"slideOutLeft\", \n          closeIcon=\"\"\n      )\n.flex.layout-column.vertical-align\n     .flex-nogrow.m-b-35\n        bw-button(title='Switch Account', color='red', icon='swap', [block]=\"true\", (click)=\"switchAccount($event)\")\n     .flex-nogrow.m-b-25\n        bw-button(title='Logout', color='red', icon='square-right', [block]=\"true\", (click)=\"singout()\")\n     .flex-nogrow\n        bw-button(title='Cancel', color='red', icon='close', [block]=\"true\", [simple]=\"true\", (click)=\"coverClosed($event)\")--><div class=\"layout-column h-100\"><div class=\"scrollable flex\"><side-menu [items]=\"menuItems\" (itemClicked)=\"onMenuItemClicked($event)\"></side-menu></div><div class=\"flex-nogrow options\"><div class=\"layout-column layout-align-end\"><div class=\"flex-nogrow layout-row layout-align-center layout-padding\"><bw-button color=\"red\" icon=\"comments\" [circular]=\"true\" size=\"lg\" (click)=\"navigate('/chat')\"></bw-button><bw-button color=\"red\" icon=\"settings\" [circular]=\"true\" size=\"lg\" (click)=\"navigate('/settings')\"></bw-button><bw-button color=\"red\" icon=\"notifications\" [circular]=\"true\" size=\"lg\" (click)=\"navigate('/notifications')\"></bw-button></div><div class=\"flex user layout-row layout-align-center\"><user-image class=\"m-t-5 flex\" [width]=\"64\"></user-image></div><div class=\"flex-nogrow layout-row layout-padding layout-align-center\"><bw-button color=\"red\" icon=\"swap\" [circular]=\"true\" size=\"lg\" (click)=\"switchAccount($event)\"></bw-button></div><div class=\"flex-nogrow support layout-row layout-align-center m-b-15\"><bw-button class=\"flex-90\" title=\"Call Support\" color=\"red\" icon=\"phone\" [block]=\"true\" (click)=\"callSupport()\"></bw-button></div></div></div></div></sidebar>";

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(77);
	var services_1 = __webpack_require__(274);
	var home_1 = __webpack_require__(655);
	var accounts_component_1 = __webpack_require__(659);
	var dashboard_component_1 = __webpack_require__(660);
	var employees_component_1 = __webpack_require__(671);
	var accounting_component_1 = __webpack_require__(672);
	var location_component_1 = __webpack_require__(673);
	var inventory_component_1 = __webpack_require__(674);
	var notifications_1 = __webpack_require__(675);
	var customers_component_1 = __webpack_require__(676);
	var chat_component_1 = __webpack_require__(677);
	var clock_in_out_component_1 = __webpack_require__(686);
	var settings_1 = __webpack_require__(696);
	var routes = [
	    { path: '', component: home_1.HomeComponent },
	    { path: 'accounts', component: accounts_component_1.AccountsComponent },
	    { path: 'dashboard', component: dashboard_component_1.DashboardComponent, canActivate: [services_1.AuthService] },
	    { path: 'employees', component: employees_component_1.EmployeesComponent, canActivate: [services_1.AuthService] },
	    { path: 'locations', component: location_component_1.LocationComponent, canActivate: [services_1.AuthService] },
	    { path: 'inventory', component: inventory_component_1.InventoryComponent, canActivate: [services_1.AuthService] },
	    { path: 'accounting', component: accounting_component_1.AccountingComponent, canActivate: [services_1.AuthService] },
	    { path: 'notifications', component: notifications_1.NotificationsComponent, canActivate: [services_1.AuthService] },
	    { path: 'customers', component: customers_component_1.CustomersComponent, canActivate: [services_1.AuthService] },
	    { path: 'chat', component: chat_component_1.ChatComponent, canActivate: [services_1.AuthService] },
	    { path: 'clock-in-out', component: clock_in_out_component_1.ClockInOutComponent, canActivate: [services_1.AuthService] },
	    { path: 'settings', component: settings_1.SettingsComponent, canActivate: [services_1.AuthService] },
	];
	exports.routing = router_1.RouterModule.forRoot(routes);


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(656));


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var services_1 = __webpack_require__(274);
	var HomeComponent = (function () {
	    function HomeComponent(_router, _authSvc, _accService) {
	        this._router = _router;
	        this._authSvc = _authSvc;
	        this._accService = _accService;
	        this.accounts = [];
	        this.logoAnimation = 'slideInDown';
	        this.welcomeAnimation = 'slideInUp';
	    }
	    HomeComponent.prototype.ngOnInit = function () {
	        this.accounts = this._accService.getAccounts();
	    };
	    HomeComponent.prototype.ngAfterViewInit = function () {
	        if (this.accounts.length > 0) {
	            this._router.navigate(['/accounts']);
	        }
	    };
	    HomeComponent.prototype.addAccountClicked = function () {
	        var _this = this;
	        this.logoAnimation = 'slideOutUp';
	        this.welcomeAnimation = 'slideOutDown';
	        setTimeout(function () { return _this._router.navigate(['/accounts']); }, 1000);
	    };
	    HomeComponent = __decorate([
	        core_1.Component({
	            styles: [__webpack_require__(657)],
	            template: __webpack_require__(658)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof services_1.AuthService !== 'undefined' && services_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof services_1.AccountsService !== 'undefined' && services_1.AccountsService) === 'function' && _c) || Object])
	    ], HomeComponent);
	    return HomeComponent;
	    var _a, _b, _c;
	}());
	exports.HomeComponent = HomeComponent;


/***/ },
/* 657 */
/***/ function(module, exports) {

	module.exports = ".nova-logo{margin-top:15px}.welcome{font-weight:100;color:white;text-align:center;margin-top:-40px}.welcome .header{font-size:32px}.welcome .subheader{font-size:16px}.welcome #add-account button{border-radius:25px !important}\n"

/***/ },
/* 658 */
/***/ function(module, exports) {

	module.exports = "<div class=\"layout-column layout-padding layout-align-center-center h-100\"><div class=\"flex\"><div class=\"nova-logo animated {{logoAnimation}}\"><img src=\"/img/logos/logo-medium.png\"/></div></div><div class=\"welcome flex-nogrow m-b-25 animated {{welcomeAnimation}}\"><div class=\"layout-column layout-align-end-center\"><div class=\"flex header\">Welcome to Nova</div><div class=\"flex-nogrow subheader\">The POS System You Need To Run Your Retail Business</div></div></div><div class=\"flex-nogrow\"><bw-button id=\"add-account\" title=\"Start\" color=\"red\" size=\"lg\" [rounded]=\"true\" (click)=\"addAccountClicked($event)\"></bw-button></div></div>";

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var AccountsComponent = (function () {
	    function AccountsComponent() {
	    }
	    AccountsComponent = __decorate([
	        core_1.Component({
	            template: '<router-outlet></router-outlet>'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AccountsComponent);
	    return AccountsComponent;
	}());
	exports.AccountsComponent = AccountsComponent;


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var forms_1 = __webpack_require__(27);
	var core_1 = __webpack_require__(2);
	var app_page_component_1 = __webpack_require__(618);
	var dashboard_filter_sheet_1 = __webpack_require__(661);
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var DashboardComponent = (function (_super) {
	    __extends(DashboardComponent, _super);
	    function DashboardComponent(store, storeHelper, userService) {
	        _super.call(this, store, storeHelper, userService);
	        this.fg = new forms_1.FormGroup({});
	        this._calendarAction = { id: 'calendar', icon: 'calendar' };
	        this._initialFilter = true;
	    }
	    DashboardComponent.prototype.ngOnInit = function () {
	        this.headerTitle = 'Dashboard';
	        this.headerActions = [this._calendarAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	        var that = this;
	        this._userSubscription = this.userService.user$.subscribe(function (user) {
	            that._user = user;
	        });
	    };
	    DashboardComponent.prototype.ngOnDestroy = function () {
	        this._userSubscription.unsubscribe();
	    };
	    DashboardComponent.prototype.onFilterChanged = function (filter) {
	        if (this._user != null) {
	            this.dashboardFilter = filter;
	            if (!this._initialFilter) {
	                this.filterSheet.toggle();
	            }
	            this._initialFilter = false;
	        }
	    };
	    DashboardComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._calendarAction.id) {
	            this.filterSheet.toggle();
	        }
	    };
	    __decorate([
	        core_1.ViewChild(app_page_component_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], DashboardComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(dashboard_filter_sheet_1.DashboardFilterSheetComponent), 
	        __metadata('design:type', Object)
	    ], DashboardComponent.prototype, "filterSheet", void 0);
	    DashboardComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(670),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _a) || Object, (typeof (_b = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _b) || Object, (typeof (_c = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _c) || Object])
	    ], DashboardComponent);
	    return DashboardComponent;
	    var _a, _b, _c;
	}(models_1.TopLevelComponent));
	exports.DashboardComponent = DashboardComponent;


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(662));


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var ui_1 = __webpack_require__(132);
	var models_2 = __webpack_require__(663);
	var DashboardFilterSheetComponent = (function () {
	    function DashboardFilterSheetComponent(_userSvc) {
	        this._userSvc = _userSvc;
	        this.filterChanged = new core_1.EventEmitter();
	        this.dateOptions = ['Today', 'Custom Range'];
	        this.activeOption = this.dateOptions[0];
	    }
	    DashboardFilterSheetComponent.prototype.ngOnDestroy = function () { };
	    DashboardFilterSheetComponent.prototype.locationPickerReady = function () {
	        this.applyFilter(null);
	    };
	    DashboardFilterSheetComponent.prototype.toggle = function () {
	        this.sheet.toggle();
	    };
	    DashboardFilterSheetComponent.prototype.onDateOptionSelected = function (option) {
	        this.showDateRange = option === 'Custom Range';
	    };
	    DashboardFilterSheetComponent.prototype.applyFilter = function (e) {
	        if (e) {
	            e.preventDefault();
	        }
	        var value = this.fg.value;
	        var dateRange = this.showDateRange ?
	            new models_1.DateRange(value.from, value.to)
	            : new models_1.DateRange();
	        this.IsValidDateRange = dateRange.isValid;
	        if (this.IsValidDateRange) {
	            var locationsPickerSelection = this.locationPicker.getSelection();
	            var filter = new models_2.DashboardFilter(dateRange, locationsPickerSelection);
	            this.filterChanged.emit(filter);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
	    ], DashboardFilterSheetComponent.prototype, "fg", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof models_2.DashboardFilter !== 'undefined' && models_2.DashboardFilter) === 'function' && _b) || Object)
	    ], DashboardFilterSheetComponent.prototype, "filter", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], DashboardFilterSheetComponent.prototype, "filterChanged", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.SheetComponent), 
	        __metadata('design:type', Object)
	    ], DashboardFilterSheetComponent.prototype, "sheet", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.LocationPickerComponent), 
	        __metadata('design:type', Object)
	    ], DashboardFilterSheetComponent.prototype, "locationPicker", void 0);
	    DashboardFilterSheetComponent = __decorate([
	        core_1.Component({
	            selector: 'dashboard-filter-sheet',
	            template: __webpack_require__(669)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _c) || Object])
	    ], DashboardFilterSheetComponent);
	    return DashboardFilterSheetComponent;
	    var _a, _b, _c;
	}());
	exports.DashboardFilterSheetComponent = DashboardFilterSheetComponent;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(664));
	__export(__webpack_require__(665));
	__export(__webpack_require__(666));
	__export(__webpack_require__(667));
	__export(__webpack_require__(668));


/***/ },
/* 664 */
/***/ function(module, exports) {

	"use strict";
	var IncomeSummary = (function () {
	    function IncomeSummary(data) {
	        Object.assign(this, data);
	    }
	    return IncomeSummary;
	}());
	exports.IncomeSummary = IncomeSummary;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var DashboardFilter = (function () {
	    function DashboardFilter(date, locationsSelection) {
	        this.date = date;
	        this.locationsSelection = locationsSelection;
	    }
	    DashboardFilter.prototype.toQueryString = function () {
	        this.locationsSelection = this.locationsSelection || new models_1.LocationPickerSelection();
	        return this.date.toQueryString() + "&" + this.locationsSelection.toQueryString();
	    };
	    return DashboardFilter;
	}());
	exports.DashboardFilter = DashboardFilter;


/***/ },
/* 666 */
/***/ function(module, exports) {

	"use strict";
	var EmployeeSales = (function () {
	    function EmployeeSales(data) {
	        Object.assign(this, data);
	    }
	    return EmployeeSales;
	}());
	exports.EmployeeSales = EmployeeSales;


/***/ },
/* 667 */
/***/ function(module, exports) {

	"use strict";
	var LocationSales = (function () {
	    function LocationSales(data) {
	        Object.assign(this, data);
	    }
	    return LocationSales;
	}());
	exports.LocationSales = LocationSales;


/***/ },
/* 668 */
/***/ function(module, exports) {

	"use strict";
	var ProductsSold = (function () {
	    function ProductsSold(data) {
	        Object.assign(this, data);
	    }
	    return ProductsSold;
	}());
	exports.ProductsSold = ProductsSold;


/***/ },
/* 669 */
/***/ function(module, exports) {

	module.exports = "<sheet><div class=\"text-center m-b-15\"><bw-button-group [options]=\"dateOptions\" [activeOption]=\"activeOption\" type=\"danger\" (optionSelected)=\"onDateOptionSelected($event)\"></bw-button-group></div><date-range [fg]=\"fg\" [hidden]=\"!showDateRange\"></date-range><div class=\"text-center c-white animated shake\" *ngIf=\"showDateRange &amp;&amp; !IsValidDateRange\"><i class=\"zmdi zmdi-info-outline m-r-10\"> </i>Invalid Range</div><location-picker [fg]=\"fg\" (filterReady)=\"locationPickerReady($event)\"></location-picker><div class=\"text-right m-b-10\"><bw-button title=\"Apply\" icon=\"check\" [simple]=\"true\" (click)=\"applyFilter($event)\"></bw-button></div></sheet>";

/***/ },
/* 670 */
/***/ function(module, exports) {

	module.exports = "<div class=\"dashboard-container mobile-page h-100\"><dashboard-filter-sheet [fg]=\"fg\" (filterChanged)=\"onFilterChanged($event)\"></dashboard-filter-sheet><div class=\"layout-column layout-padding h-100\"><div class=\"flex h-100 scrollable\"><dashboard-summary [dashboardFilter]=\"dashboardFilter\">       </dashboard-summary><dashboard-employees [dashboardFilter]=\"dashboardFilter\"></dashboard-employees><dashboard-locations [dashboardFilter]=\"dashboardFilter\"></dashboard-locations><dashboard-inventory [dashboardFilter]=\"dashboardFilter\"></dashboard-inventory></div></div></div>";

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var EmployeesComponent = (function () {
	    function EmployeesComponent() {
	    }
	    EmployeesComponent = __decorate([
	        core_1.Component({
	            template: '<router-outlet></router-outlet>'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], EmployeesComponent);
	    return EmployeesComponent;
	}());
	exports.EmployeesComponent = EmployeesComponent;


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var AccountingComponent = (function () {
	    function AccountingComponent() {
	    }
	    AccountingComponent = __decorate([
	        core_1.Component({
	            template: '<router-outlet></router-outlet>'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AccountingComponent);
	    return AccountingComponent;
	}());
	exports.AccountingComponent = AccountingComponent;


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var LocationComponent = (function () {
	    function LocationComponent() {
	    }
	    LocationComponent = __decorate([
	        core_1.Component({
	            template: "\n    <router-outlet></router-outlet>\n  "
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocationComponent);
	    return LocationComponent;
	}());
	exports.LocationComponent = LocationComponent;


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var InventoryComponent = (function () {
	    function InventoryComponent() {
	    }
	    InventoryComponent = __decorate([
	        core_1.Component({
	            template: '<router-outlet></router-outlet>'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], InventoryComponent);
	    return InventoryComponent;
	}());
	exports.InventoryComponent = InventoryComponent;


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(640));


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var CustomersComponent = (function () {
	    function CustomersComponent() {
	    }
	    CustomersComponent = __decorate([
	        core_1.Component({
	            template: '<router-outlet></router-outlet>'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CustomersComponent);
	    return CustomersComponent;
	}());
	exports.CustomersComponent = CustomersComponent;


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var signalR_service_1 = __webpack_require__(678);
	var models_1 = __webpack_require__(137);
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var chat_service_1 = __webpack_require__(679);
	var services_1 = __webpack_require__(274);
	var ChatComponent = (function (_super) {
	    __extends(ChatComponent, _super);
	    function ChatComponent(_router, storeHelper, store, userService, _chatService, signalRService, _ngZone) {
	        _super.call(this, store, storeHelper, userService);
	        this._router = _router;
	        this._chatService = _chatService;
	        this.signalRService = signalRService;
	        this._ngZone = _ngZone;
	    }
	    ChatComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.commandsSubscription = this._subscribeToChatCommands();
	        this.userSubscription = this.userService.user$.subscribe(function (user) {
	            _this._user = user;
	        });
	        this.signalRService.connect();
	    };
	    ChatComponent.prototype.ngOnDestroy = function () {
	        this.commandsSubscription.unsubscribe();
	        this.userSubscription.unsubscribe();
	    };
	    ChatComponent.prototype._subscribeToChatCommands = function () {
	        var _this = this;
	        return this._chatService.commandBus$
	            .subscribe(function (chatCommand) { return _this._processChatCommands(chatCommand); });
	    };
	    ChatComponent.prototype._processChatCommands = function (chatCommand) {
	        var _this = this;
	        switch (chatCommand.id) {
	            case 'openThread':
	                this._chatService.joinRegion(chatCommand.data.region);
	                this.signalRService.joinRegion(chatCommand.data.region);
	                this._router.navigate(['chat/messages']);
	                break;
	            case 'joinRegion':
	                this._chatService.joinRegion(chatCommand.data);
	                this.signalRService.joinRegion(chatCommand.data);
	                this._router.navigate(['chat/messages']);
	                break;
	            case 'sendMessageToSignalR':
	                this.signalRService.sendChatMessageToRegion(chatCommand.data.region, chatCommand.data.text, chatCommand.data.timestamp);
	                break;
	            case 'displayReceivedMessage':
	                this._ngZone.run(function () {
	                    _this._chatService.proccessIncomingMessage(chatCommand.data);
	                });
	                break;
	            default:
	                return;
	        }
	    };
	    ChatComponent = __decorate([
	        core_1.Component({
	            template: "<router-outlet></router-outlet>",
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _b) || Object, (typeof (_c = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _c) || Object, (typeof (_d = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _d) || Object, (typeof (_e = typeof chat_service_1.ChatService !== 'undefined' && chat_service_1.ChatService) === 'function' && _e) || Object, (typeof (_f = typeof signalR_service_1.SignalRService !== 'undefined' && signalR_service_1.SignalRService) === 'function' && _f) || Object, (typeof (_g = typeof core_1.NgZone !== 'undefined' && core_1.NgZone) === 'function' && _g) || Object])
	    ], ChatComponent);
	    return ChatComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}(models_1.TopLevelComponent));
	exports.ChatComponent = ChatComponent;


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var chat_service_1 = __webpack_require__(679);
	var services_1 = __webpack_require__(274);
	var core_1 = __webpack_require__(2);
	var rxjs_1 = __webpack_require__(277);
	var dateFormat = 'MM/DD/YYYY hh:mm:ss A';
	var ConnectionState;
	(function (ConnectionState) {
	    ConnectionState[ConnectionState["Connecting"] = 0] = "Connecting";
	    ConnectionState[ConnectionState["Connected"] = 1] = "Connected";
	    ConnectionState[ConnectionState["Reconnecting"] = 2] = "Reconnecting";
	    ConnectionState[ConnectionState["Disconnected"] = 4] = "Disconnected";
	})(ConnectionState || (ConnectionState = {}));
	var SignalRService = (function () {
	    function SignalRService(authService, userService, configService, chatService) {
	        this.authService = authService;
	        this.userService = userService;
	        this.configService = configService;
	        this.chatService = chatService;
	        this.connectionStateSubject = new rxjs_1.Subject();
	        this.startingSubject = new rxjs_1.Subject();
	        this.errorSubject = new rxjs_1.Subject();
	        if ($ === undefined || $.hubConnection === undefined) {
	            throw new Error("The variable '$' or the .hubConnection() function are not defined...please check the SignalR scripts have been loaded properly");
	        }
	        this._subscribeToUser();
	        this.baseUrl = this.configService.getContext('bi').url;
	        this.connectionState$ = this.connectionStateSubject.asObservable();
	        this.error$ = this.errorSubject.asObservable();
	        this.starting$ = this.startingSubject.asObservable();
	        this.hubConnection = $.hubConnection();
	        this.hubConnection.url = this.baseUrl + "signalr";
	        this.hubConnection.qs = "token=" + this.token;
	        this.hubProxy = this.hubConnection.createHubProxy('chat');
	        this.hubConnection.transportConnectTimeout = 3000;
	        this._subscribeToConnectionStates();
	        this._subscribeToErrors();
	        this._subscribeOnServerEvents();
	    }
	    SignalRService.prototype.joinRegion = function (region) {
	        this.hubProxy.invoke('JoinRegion', region.id)
	            .done(function () {
	            console.log('Susceffuly joine to region');
	            return true;
	        })
	            .fail(function (error) {
	            console.log('Error joining to region ' + error);
	            return error;
	        });
	    };
	    SignalRService.prototype.sendChatMessageToRegion = function (region, text, timestamp) {
	        this.hubProxy.invoke('SendMessageToRegion', region.id, text, timestamp)
	            .done(function () {
	            console.log('Invocation of SendMessageToRegion succeeded');
	            return true;
	        })
	            .fail(function (error) {
	            console.log('Invocation of SendMessageToRegion failed. Error: ' + error);
	            return error;
	        });
	    };
	    SignalRService.prototype.connect = function () {
	        var _this = this;
	        this.hubConnection.start()
	            .done(function (data) {
	            console.log('Now connected ' + data.transport.name + ', connection ID= ' + data.id);
	            _this.startingSubject.next();
	        })
	            .fail(function (error) {
	            _this.startingSubject.error(error);
	            console.log('Could not connect ' + error);
	        });
	    };
	    SignalRService.prototype.disconnect = function () {
	        this.hubConnection.stop();
	        this.startingSubject.next();
	    };
	    SignalRService.prototype._subscribeToUser = function () {
	        var _this = this;
	        this.userService.user$.subscribe(function () {
	            return _this.token = _this.authService.accessToken;
	        });
	    };
	    SignalRService.prototype._subscribeToConnectionStates = function () {
	        var _this = this;
	        this.hubConnection.stateChanged(function (state) {
	            _this.connectionState = ConnectionState.Connecting;
	            switch (state.newState) {
	                case $.signalR.connectionState.connecting:
	                    _this.connectionState = ConnectionState.Connecting;
	                    break;
	                case $.signalR.connectionState.connected:
	                    _this.connectionState = ConnectionState.Connected;
	                    break;
	                case $.signalR.connectionState.reconnecting:
	                    _this.connectionState = ConnectionState.Reconnecting;
	                    break;
	                case $.signalR.connectionState.disconnected:
	                    _this.connectionState = ConnectionState.Disconnected;
	                    break;
	            }
	            _this.connectionStateSubject.next(_this.connectionState);
	        });
	    };
	    SignalRService.prototype._subscribeToErrors = function () {
	        var _this = this;
	        this.hubConnection.error(function (error) {
	            _this.errorSubject.next(error);
	        });
	    };
	    SignalRService.prototype._subscribeOnServerEvents = function () {
	        var _this = this;
	        this.hubProxy.on('sendMessage', function (data) {
	            _this.chatService.pushChatCommand({
	                id: 'displayReceivedMessage',
	                data: { message: data }
	            });
	        });
	    };
	    SignalRService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.AuthService !== 'undefined' && services_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _b) || Object, (typeof (_c = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _c) || Object, (typeof (_d = typeof chat_service_1.ChatService !== 'undefined' && chat_service_1.ChatService) === 'function' && _d) || Object])
	    ], SignalRService);
	    return SignalRService;
	    var _a, _b, _c, _d;
	}());
	exports.SignalRService = SignalRService;


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(680);
	var services_1 = __webpack_require__(274);
	var models_2 = __webpack_require__(680);
	var core_1 = __webpack_require__(2);
	var rxjs_1 = __webpack_require__(277);
	var moment = __webpack_require__(139);
	var dateFormat = 'MM/DD/YYYY hh:mm:ss A';
	var _commandBusSubject = new rxjs_1.Subject();
	var _currentThreadSubject = new rxjs_1.Subject();
	exports.VirtualAllRegionsElement = { id: -1,
	    name: 'All Regions',
	    useKits: false,
	    locations: []
	};
	var ChatService = (function () {
	    function ChatService(_userService, _apiService, configService) {
	        var _this = this;
	        this._userService = _userService;
	        this._apiService = _apiService;
	        this.configService = configService;
	        this._baseUrl = this.configService.getContext('bi').url;
	        this._messagesPath = 'feeds/messages';
	        this._threadsPath = 'feeds/threads';
	        this._commandBusSubject = _commandBusSubject;
	        this._threads = new Array();
	        this._threadSubject = _currentThreadSubject;
	        this._messagesSubject = new rxjs_1.Subject();
	        this._userService.user$.subscribe(function (user) { return _this._user = user; });
	        this.commandBus$ = this._commandBusSubject.asObservable().distinctUntilChanged();
	        this.messages$ = this._messagesSubject.asObservable().distinctUntilChanged();
	    }
	    // Mapping  Static functions
	    ChatService.getMessageById = function (id, messages) {
	        var message = messages.filter(function (m) { return m.region.id === id; })[0];
	        return message;
	    };
	    ChatService.mapMessages = function (res) {
	        return res.data.map(function (m) { return new models_2.ChatMessage(m); });
	    };
	    ChatService.mapThreads = function (res) {
	        return res.map(function (m) { return new models_2.ChatMessage(m); });
	    };
	    ;
	    Object.defineProperty(ChatService.prototype, "user", {
	        get: function () {
	            return this._user;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ChatService.prototype, "thread", {
	        get: function () {
	            return this._currentThread;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ChatService.prototype, "threads", {
	        get: function () {
	            return this._threads;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ChatService.prototype, "thread$", {
	        get: function () {
	            return this._threadSubject.asObservable().distinctUntilChanged();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ChatService.prototype.setThread = function (thread) {
	        this._currentThread = thread;
	        this._threadSubject.next(this._currentThread);
	    };
	    ChatService.prototype.joinRegion = function (region) {
	        var thread = this._threads.find(function (thread) { return thread.region === region; });
	        if (!thread) {
	            thread = this.createThread(region);
	        }
	        else {
	            thread.messages = new Array();
	            this._messagesSubject.next();
	        }
	        ;
	        this.setThread(thread);
	    };
	    ChatService.prototype.createThread = function (region) {
	        var thread = new models_2.Thread(region);
	        this._threads.push(thread);
	        return thread;
	    };
	    ChatService.prototype.sendChatMessageToSignalR = function (text) {
	        var _this = this;
	        var timestamp = moment(Date()).format(dateFormat);
	        var regions = [this._currentThread.region];
	        if (this._currentThread.region.id === -1) {
	            regions = this._user.regions;
	        }
	        regions.forEach(function (r) {
	            _this.pushChatCommand({ id: 'sendMessageToSignalR',
	                data: { region: r,
	                    text: text,
	                    timestamp: timestamp
	                }
	            });
	        });
	    };
	    ChatService.prototype.proccessIncomingMessage = function (data) {
	        var message = new models_2.ChatMessage(data.message);
	        message.text = data.message.message;
	        message.name = data.message.user;
	        var timestamp = moment(Date()).format(dateFormat);
	        message.timestamp = timestamp;
	        this._currentThread.messages.push(message);
	        this._messagesSubject.next(this._currentThread.messages);
	    };
	    ChatService.prototype.pushChatCommand = function (command) {
	        this._commandBusSubject.next({
	            id: command.id,
	            data: command.data
	        });
	    };
	    ChatService.prototype.getMessageHistory = function (regions, page, size) {
	        var _this = this;
	        if (regions === void 0) { regions = [this._currentThread.region.id]; }
	        if (page === void 0) { page = 1; }
	        if (size === void 0) { size = 10; }
	        var messageFilter = new models_1.MessagesFilter({ regions: regions,
	            page: page,
	            size: size });
	        return this._apiService.get(this._baseUrl, this._messagesPath, messageFilter)
	            .map(function (res) {
	            var result = ChatService.mapMessages(res);
	            _this._currentThread.messages = result;
	            _this._messagesSubject.next(result);
	            return result;
	        });
	    };
	    ChatService.prototype.pullThreadsLastMessage = function () {
	        var _this = this;
	        var regionsArray = this.threads.map(function (t) { return (t.region.id); });
	        var threadFilter = new models_1.ThreadsFilter({ regions: regionsArray });
	        return this._apiService.get(this._baseUrl, this._threadsPath, threadFilter)
	            .map(function (res) {
	            var result = ChatService.mapThreads(res);
	            _this.updateThreadLastMessage(result);
	            return result;
	        });
	    };
	    ChatService.prototype.updateThreadLastMessage = function (messages) {
	        this.threads.forEach(function (t) {
	            t.messages = new Array();
	            t.messages.push(ChatService.getMessageById(t.region.id, messages));
	        });
	    };
	    ChatService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _b) || Object, (typeof (_c = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _c) || Object])
	    ], ChatService);
	    return ChatService;
	    var _a, _b, _c;
	}());
	exports.ChatService = ChatService;


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(681));
	__export(__webpack_require__(682));
	__export(__webpack_require__(683));
	__export(__webpack_require__(684));
	__export(__webpack_require__(685));


/***/ },
/* 681 */
251,
/* 682 */
/***/ function(module, exports) {

	"use strict";
	var ChatMessage = (function () {
	    function ChatMessage(obj) {
	        Object.assign(this, obj);
	        this.id = obj.order || null;
	        this.user = obj.name || null;
	    }
	    return ChatMessage;
	}());
	exports.ChatMessage = ChatMessage;


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var MessagesFilter = (function () {
	    function MessagesFilter(obj) {
	        Object.assign(this, obj);
	    }
	    MessagesFilter.prototype.toQueryString = function () {
	        var payload = {
	            regions: this.regions,
	            page: this.page,
	            size: this.size,
	        };
	        return models_1.objToQueryString(payload);
	    };
	    return MessagesFilter;
	}());
	exports.MessagesFilter = MessagesFilter;


/***/ },
/* 684 */
/***/ function(module, exports) {

	"use strict";
	var Thread = (function () {
	    function Thread(region) {
	        this.region = region;
	        this.messages = new Array();
	    }
	    return Thread;
	}());
	exports.Thread = Thread;


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var ThreadsFilter = (function () {
	    function ThreadsFilter(obj) {
	        Object.assign(this, obj);
	    }
	    ThreadsFilter.prototype.toQueryString = function () {
	        var payload = {
	            regions: this.regions,
	        };
	        return models_1.objToQueryString(payload);
	    };
	    return ThreadsFilter;
	}());
	exports.ThreadsFilter = ThreadsFilter;


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var forms_1 = __webpack_require__(27);
	var moment = __webpack_require__(139);
	var models_1 = __webpack_require__(687);
	var app_page_component_1 = __webpack_require__(618);
	var models_2 = __webpack_require__(137);
	var services_1 = __webpack_require__(274);
	var services_2 = __webpack_require__(693);
	var core_1 = __webpack_require__(2);
	var ng2_material_components_1 = __webpack_require__(33);
	var ClockInOutComponent = (function (_super) {
	    __extends(ClockInOutComponent, _super);
	    function ClockInOutComponent(store, storeHelper, userService, clockInOutSvc) {
	        var _this = this;
	        _super.call(this, store, storeHelper, userService);
	        this.clockInOutSvc = clockInOutSvc;
	        this.fg = new forms_1.FormGroup({});
	        this.clockInOutLogs = [];
	        this.error = '';
	        this.loading = true;
	        this._headerAction = { id: 'changeDate', icon: 'calendar' };
	        this.headerTitle = 'Clock In/Out';
	        this.headerActions = [{ id: 'none', icon: 'none' }];
	        this.userService.user$.subscribe(function (user) { return _this._user = user; });
	    }
	    ClockInOutComponent.prototype.ngOnInit = function () {
	        this.date = moment();
	        var dateFilter = new models_1.ClockDateFilter(this.date);
	        this._updateLogs(dateFilter);
	        this.headerActions = [this._headerAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	    };
	    ClockInOutComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.fgSub = this.fg.controls['date'].valueChanges
	            .subscribe(function (value) { return _this.onDateChanged(value); });
	    };
	    ClockInOutComponent.prototype._updateLogs = function (filter) {
	        var _this = this;
	        if (this.logSub) {
	            this.logSub.unsubscribe();
	        }
	        this.loading = true;
	        this.appPage.activatePreloader();
	        this.logSub = this.clockInOutSvc.getLocationEmployeeLogs(filter)
	            .subscribe(function (l) { return _this.clockInOutLogs = l; }, function (err) { return _this.error = err; }, function () { return _this.requestSuccess(); });
	    };
	    ClockInOutComponent.prototype.ngOnDestroy = function () {
	        this.logSub.unsubscribe();
	        this.fgSub.unsubscribe();
	    };
	    ClockInOutComponent.prototype.requestSuccess = function () {
	        this.loading = false;
	        this.appPage.deactivatePreloader();
	    };
	    ClockInOutComponent.prototype.locationHasLogs = function (locationId) {
	        var locationLog = this.clockInOutLogs.find(function (l) { return l.id === locationId; });
	        return locationLog !== undefined && locationLog !== null;
	    };
	    ClockInOutComponent.prototype.getLocationLogById = function (locationId) {
	        return this.clockInOutLogs.find(function (l) { return l.id === locationId; }) || null;
	    };
	    ClockInOutComponent.prototype.onDateChanged = function (value) {
	        var filter = new models_1.ClockDateFilter(value);
	        this._updateLogs(filter);
	    };
	    ClockInOutComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._headerAction.id) {
	            this.datetimePicker.el.focus();
	        }
	    };
	    Object.defineProperty(ClockInOutComponent.prototype, "user", {
	        get: function () {
	            return this._user;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ClockInOutComponent.prototype, "dateFormatted", {
	        get: function () {
	            return this.date.format('MM/DD/YYYY');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.ViewChild(app_page_component_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], ClockInOutComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(ng2_material_components_1.DateTimePickerComponent), 
	        __metadata('design:type', Object)
	    ], ClockInOutComponent.prototype, "datetimePicker", void 0);
	    ClockInOutComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(695),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _a) || Object, (typeof (_b = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _b) || Object, (typeof (_c = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _c) || Object, (typeof (_d = typeof services_2.ClockInOutService !== 'undefined' && services_2.ClockInOutService) === 'function' && _d) || Object])
	    ], ClockInOutComponent);
	    return ClockInOutComponent;
	    var _a, _b, _c, _d;
	}(models_2.TopLevelComponent));
	exports.ClockInOutComponent = ClockInOutComponent;


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(688));
	__export(__webpack_require__(689));
	__export(__webpack_require__(690));
	__export(__webpack_require__(691));
	__export(__webpack_require__(692));


/***/ },
/* 688 */
/***/ function(module, exports) {

	"use strict";
	(function (ClockAction) {
	    ClockAction[ClockAction['clockIn'] = 1] = 'clockIn';
	    ClockAction[ClockAction['clockOut'] = 2] = 'clockOut';
	    ClockAction[ClockAction['break'] = 3] = 'break';
	})(exports.ClockAction || (exports.ClockAction = {}));
	var ClockAction = exports.ClockAction;


/***/ },
/* 689 */
/***/ function(module, exports) {

	"use strict";
	var EmployeeClockAction = (function () {
	    function EmployeeClockAction(data) {
	        Object.assign(this, data);
	    }
	    return EmployeeClockAction;
	}());
	exports.EmployeeClockAction = EmployeeClockAction;


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var EmployeeClockLog = (function (_super) {
	    __extends(EmployeeClockLog, _super);
	    function EmployeeClockLog(data) {
	        _super.call(this);
	        this.clockLogs = [];
	        Object.assign(this, data);
	    }
	    return EmployeeClockLog;
	}(models_1.IdName));
	exports.EmployeeClockLog = EmployeeClockLog;


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var LocationEmployeeLog = (function (_super) {
	    __extends(LocationEmployeeLog, _super);
	    function LocationEmployeeLog(data) {
	        _super.call(this);
	        this.employees = [];
	        Object.assign(this, data);
	    }
	    return LocationEmployeeLog;
	}(models_1.IdName));
	exports.LocationEmployeeLog = LocationEmployeeLog;


/***/ },
/* 692 */
/***/ function(module, exports) {

	"use strict";
	var ClockDateFilter = (function () {
	    function ClockDateFilter(value) {
	        if (typeof value !== 'string') {
	            this.date = value.format('MM/DD/YYYY');
	            return;
	        }
	        this.date = value;
	    }
	    ClockDateFilter.prototype.toQueryString = function () {
	        return "date=" + this.date;
	    };
	    return ClockDateFilter;
	}());
	exports.ClockDateFilter = ClockDateFilter;


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(694));


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(687);
	var core_1 = __webpack_require__(2);
	var ClockInOutService = (function () {
	    function ClockInOutService(_configService, _apiService) {
	        this._configService = _configService;
	        this._apiService = _apiService;
	        this.baseUrl = this._configService.getContext('management').url;
	        this.path = 'locations/mobile/check-in-out';
	        this.locations = [];
	    }
	    ClockInOutService.prototype.getLocationEmployeeLogs = function (dateFilter) {
	        return this._apiService.get(this.baseUrl, this.path, dateFilter || null)
	            .map(function (logs) { return logs.locations.map(function (locationEmployeesLog) { return new models_1.LocationEmployeeLog(locationEmployeesLog); }); })
	            .cache();
	    };
	    ClockInOutService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _b) || Object])
	    ], ClockInOutService);
	    return ClockInOutService;
	    var _a, _b;
	}());
	exports.ClockInOutService = ClockInOutService;


/***/ },
/* 695 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"mobile-page-content\"><div class=\"layout-column h-100\" [hidden]=\"loading\"><div class=\"layout-row layout-padding layout-align-center-center m-t--50 flex\"><date-time-picker [fg]=\"fg\" field=\"date\" [alt]=\"true\" [value]=\"dateFormatted\" [style.margin-top.px]=\"-200\"></date-time-picker></div><div class=\"layout-row layout-padding m-t-5\" *ngFor=\"let location of clockInOutLogs\"><location-logs class=\"flex-100\" [locationLogs]=\"getLocationLogById(location.id)\"> </location-logs></div><div class=\"layout-row layout-align-center-center m-t-20\" *ngIf=\"clockInOutLogs.length &lt; 1\"><div class=\"message m-t-10\"><i class=\"zmdi zmdi-info m-b-5\"> </i>No Employees checked in/out</div></div></div></div></app-page>";

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(697));
	__export(__webpack_require__(698));


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var SettingsComponent = (function () {
	    function SettingsComponent() {
	    }
	    SettingsComponent = __decorate([
	        core_1.Component({
	            template: '<router-outlet></router-outlet>'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SettingsComponent);
	    return SettingsComponent;
	}());
	exports.SettingsComponent = SettingsComponent;


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var settings_routing_1 = __webpack_require__(699);
	var forms_1 = __webpack_require__(27);
	var core_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(23);
	var shared_module_1 = __webpack_require__(26);
	var ng2_material_components_1 = __webpack_require__(33);
	var settings_component_1 = __webpack_require__(697);
	var personal_info_1 = __webpack_require__(711);
	var change_password_1 = __webpack_require__(700);
	var ui_1 = __webpack_require__(715);
	var services_1 = __webpack_require__(702);
	var SettingsModule = (function () {
	    function SettingsModule() {
	    }
	    SettingsModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                ng2_material_components_1.MaterialFormsModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                settings_routing_1.settingsRouting,
	                shared_module_1.SharedModule,
	                forms_1.FormsModule,
	                forms_1.ReactiveFormsModule
	            ],
	            exports: [
	                settings_component_1.SettingsComponent,
	            ],
	            declarations: [
	                settings_component_1.SettingsComponent,
	                personal_info_1.PersonalInfoComponent,
	                change_password_1.ChangePasswordComponent,
	                ui_1.PasswordFormComponent,
	                ui_1.PersonalInfoViewComponent,
	                ui_1.PersonalInfoEditComponent
	            ],
	            providers: [
	                services_1.SettingsService
	            ],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SettingsModule);
	    return SettingsModule;
	}());
	exports.SettingsModule = SettingsModule;


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(77);
	var settings_component_1 = __webpack_require__(697);
	var change_password_1 = __webpack_require__(700);
	var personal_info_1 = __webpack_require__(711);
	var settingsRoutes = [
	    {
	        path: 'settings',
	        component: settings_component_1.SettingsComponent,
	        children: [
	            {
	                path: '',
	                component: personal_info_1.PersonalInfoComponent
	            },
	            {
	                path: 'password',
	                component: change_password_1.ChangePasswordComponent
	            },
	        ]
	    }
	];
	exports.settingsRouting = router_1.RouterModule.forChild(settingsRoutes);


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(701));


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(77);
	var services_1 = __webpack_require__(702);
	var core_1 = __webpack_require__(2);
	var app_page_component_1 = __webpack_require__(618);
	var models_1 = __webpack_require__(137);
	var services_2 = __webpack_require__(274);
	var forms_1 = __webpack_require__(27);
	var models_2 = __webpack_require__(704);
	var ChangePasswordComponent = (function (_super) {
	    __extends(ChangePasswordComponent, _super);
	    function ChangePasswordComponent(store, storeHelper, userService, _authService, _settingsService, _router) {
	        var _this = this;
	        _super.call(this, store, storeHelper, userService);
	        this._authService = _authService;
	        this._settingsService = _settingsService;
	        this._router = _router;
	        this.fg = new forms_1.FormGroup({});
	        this.subs = [];
	        this.animation = 'fadeIn';
	        this.error = false;
	        this.loading = false;
	        this.changinPassword = true;
	        this.errorMessage = '';
	        this.headerTitle = 'Change Password';
	        this.headerActions = [{ id: 'none', icon: 'none' }];
	        this.subs.push(this.userService.user$.subscribe(function (user) { return _this._user = user; }));
	    }
	    ChangePasswordComponent.prototype.ngOnInit = function () {
	        this.appPage.deactivatePreloader();
	    };
	    ChangePasswordComponent.prototype.ngOnDestroy = function () {
	        this.subs.forEach(function (s) { return s.unsubscribe; });
	    };
	    ChangePasswordComponent.prototype.changePassword = function () {
	        this.error = false;
	        if (!this._formValid()) {
	            return;
	        }
	        var passwordInfo = new models_2.UpdatePasswordModel({
	            currentPassword: this.fg.value.currentPassword,
	            newPassword: this.fg.value.newPassword,
	        });
	        this.appPage.activatePreloader();
	        var that = this;
	        this.subs.push(this._settingsService.setUserPassword(passwordInfo)
	            .subscribe(function (r) { return that._handleSuccessResponse(r, passwordInfo); }, function (err) { return that._handleHttpError(err); }, function () { return that.loading = false; }));
	    };
	    ChangePasswordComponent.prototype._formValid = function () {
	        if (this.fg.value.newPassword !== this.fg.value.confirmPassword) {
	            this._displayError('New password and confirmation doesn\'t match');
	            return false;
	        }
	        return true;
	    };
	    ChangePasswordComponent.prototype._handleSuccessResponse = function (res, passwordInfo) {
	        if (res.success) {
	            this._reauthenticate(passwordInfo);
	            return;
	        }
	        this._displayError(JSON.stringify(res.errors['password']));
	        this.appPage.deactivatePreloader();
	        this.loading = false;
	    };
	    ChangePasswordComponent.prototype._handleHttpError = function (res) {
	        this._displayError('Connection Error, try again');
	        this.loading = false;
	        this.appPage.deactivatePreloader();
	    };
	    ChangePasswordComponent.prototype.goToSettings = function () {
	        this.navigate('/settings');
	    };
	    ChangePasswordComponent.prototype.navigate = function (route) {
	        this._router.navigate([route]);
	    };
	    ChangePasswordComponent.prototype._displayError = function (error) {
	        this.errorMessage = error;
	        this.error = true;
	    };
	    ChangePasswordComponent.prototype._reauthenticate = function (passwordInfo) {
	        var _this = this;
	        var creds = {
	            account: this._user.tenant.substr(4),
	            username: this._user.name,
	            password: passwordInfo.newPassword
	        };
	        this.subs.push(this._authService.authenticate(creds)
	            .subscribe(function (res) { return _this._onSuccesfullAuth(res); }, function (err) { return _this._onErrorAuth(err); }, function () { return console.log('ReAuth completed'); }));
	    };
	    ChangePasswordComponent.prototype._onSuccesfullAuth = function (res) {
	        this.error = false;
	        this.changinPassword = false;
	        this.appPage.deactivatePreloader();
	    };
	    ChangePasswordComponent.prototype._onErrorAuth = function (res) {
	        this._displayError('There was an error authenticating new credentials, you will be redirected to the login');
	        this.changinPassword = false;
	        this.appPage.deactivatePreloader();
	    };
	    __decorate([
	        core_1.ViewChild(app_page_component_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], ChangePasswordComponent.prototype, "appPage", void 0);
	    ChangePasswordComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(709),
	            styles: [__webpack_require__(710)],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_2.Store !== 'undefined' && services_2.Store) === 'function' && _a) || Object, (typeof (_b = typeof services_2.StoreHelper !== 'undefined' && services_2.StoreHelper) === 'function' && _b) || Object, (typeof (_c = typeof services_2.UserService !== 'undefined' && services_2.UserService) === 'function' && _c) || Object, (typeof (_d = typeof services_2.AuthService !== 'undefined' && services_2.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof services_1.SettingsService !== 'undefined' && services_1.SettingsService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object])
	    ], ChangePasswordComponent);
	    return ChangePasswordComponent;
	    var _a, _b, _c, _d, _e, _f;
	}(models_1.TopLevelComponent));
	exports.ChangePasswordComponent = ChangePasswordComponent;


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(703));


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var services_1 = __webpack_require__(274);
	var core_1 = __webpack_require__(2);
	var models_1 = __webpack_require__(704);
	var SettingsService = (function () {
	    function SettingsService(_configService, _apiService) {
	        this._configService = _configService;
	        this._apiService = _apiService;
	        this._baseUrl = this._configService.getContext('management').url;
	    }
	    SettingsService.prototype.getUserSettings = function () {
	        return this._apiService.get(this._baseUrl, 'users/me/mobile/settings')
	            .do(function (res) { return new models_1.MobileUserSettings(res); })
	            .cache();
	    };
	    SettingsService.prototype.setUserSettings = function (payload) {
	        return this._apiService.post(this._baseUrl, 'users/mobile/settings', payload)
	            .map(function (res) { return res; })
	            .cache();
	    };
	    SettingsService.prototype.setUserPassword = function (payload) {
	        return this._apiService.post(this._baseUrl, 'users/password', payload)
	            .map(function (res) { return res; })
	            .cache();
	    };
	    SettingsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _b) || Object])
	    ], SettingsService);
	    return SettingsService;
	    var _a, _b;
	}());
	exports.SettingsService = SettingsService;


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(705));
	__export(__webpack_require__(706));
	__export(__webpack_require__(707));
	__export(__webpack_require__(708));


/***/ },
/* 705 */
/***/ function(module, exports) {

	"use strict";
	var SmsProviders = (function () {
	    function SmsProviders() {
	    }
	    return SmsProviders;
	}());
	exports.SmsProviders = SmsProviders;
	var MobileUserSettings = (function () {
	    function MobileUserSettings(obj) {
	        Object.assign(this, obj);
	    }
	    return MobileUserSettings;
	}());
	exports.MobileUserSettings = MobileUserSettings;


/***/ },
/* 706 */
/***/ function(module, exports) {

	"use strict";
	var PersonalInfo = (function () {
	    function PersonalInfo(obj) {
	        Object.assign(this, obj);
	    }
	    return PersonalInfo;
	}());
	exports.PersonalInfo = PersonalInfo;


/***/ },
/* 707 */
/***/ function(module, exports) {

	"use strict";
	var DetailedResponse = (function () {
	    function DetailedResponse(obj) {
	        Object.assign(this, obj);
	    }
	    return DetailedResponse;
	}());
	exports.DetailedResponse = DetailedResponse;


/***/ },
/* 708 */
/***/ function(module, exports) {

	"use strict";
	var UpdatePasswordModel = (function () {
	    function UpdatePasswordModel(obj) {
	        Object.assign(this, obj);
	    }
	    return UpdatePasswordModel;
	}());
	exports.UpdatePasswordModel = UpdatePasswordModel;


/***/ },
/* 709 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"layout-column h-100 layout-padding animated {{animation}}\" *ngIf=\"changinPassword\"><div class=\"flex layout-column layout-align-center-center scrollable-settings m-t-30\"><password-form class=\"flex-60-nogrow\" [fg]=\"fg\"></password-form><div class=\"layout-row layout-align-center-center flex-20-nogrow\" *ngIf=\"error\"><div class=\"text-center animated shake m-t-10\"><div class=\"error-message\">{{ errorMessage }}</div></div></div></div><div class=\"layout-row layout-padding layout-align-center-end flex-40-nogrow material-buttons\"><bw-button id=\"change-password\" title=\"Confirm\" [rounded]=\"true\" type=\"submit\" color=\"red\" (click)=\"changePassword($event)\"></bw-button><bw-button id=\"change-password\" title=\"Cancel\" [rounded]=\"true\" color=\"red\" (click)=\"goToSettings()\"></bw-button></div></div><div class=\"layout-column h-100 layout-padding animated {{animation}}\" *ngIf=\"!changinPassword\"><div class=\"flex layout-column layout-align-center-center scrollable-settings\"><div class=\"layout-column layout-padding layout-align-center-center\" *ngIf=\"error\"><div class=\"text-center animated fadeIn m-t-50\"><div class=\"icon-error i zmdi zmdi-close-circle-o\"></div><div class=\"error-message\">{{ errorMessage }} </div></div></div><div class=\"layout-column layout-padding layout-align-center-center\" *ngIf=\"!error\"><div class=\"text-center animated fadeIn m-t-50\"><div class=\"icon-success i zmdi zmdi-check\"></div><div class=\"success-message\">Password changed, new credentials authorized</div></div></div></div><div class=\"layout-row layout-padding layout-align-center-end flex-40-nogrow material-buttons\"><bw-button class=\"normal\" title=\"Ok\" [rounded]=\"true\" color=\"red\" (click)=\"goToSettings()\"></bw-button></div></div></app-page>";

/***/ },
/* 710 */
/***/ function(module, exports) {

	module.exports = ".icon-success{font-size:48px;color:#8BC34A !important}.icon-error{font-size:48px;color:#E41736 !important}.error-message{color:#E41736}.success-message{color:#fff}\n"

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(712));


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(77);
	var services_1 = __webpack_require__(702);
	var core_1 = __webpack_require__(2);
	var app_page_component_1 = __webpack_require__(618);
	var models_1 = __webpack_require__(137);
	var services_2 = __webpack_require__(274);
	var models_2 = __webpack_require__(704);
	var services_3 = __webpack_require__(274);
	var forms_1 = __webpack_require__(27);
	var PersonalInfoComponent = (function (_super) {
	    __extends(PersonalInfoComponent, _super);
	    function PersonalInfoComponent(store, storeHelper, userService, _config, _settingsService, _router) {
	        var _this = this;
	        _super.call(this, store, storeHelper, userService);
	        this._config = _config;
	        this._settingsService = _settingsService;
	        this._router = _router;
	        this.subs = [];
	        this.animation = 'fadeIn';
	        this.error = '';
	        this.loading = true;
	        this.editMode = false;
	        this.fg = new forms_1.FormGroup({});
	        this.headerTitle = 'Settings';
	        this.headerActions = [{ id: 'none', icon: 'none' }];
	        this.userService.user$.subscribe(function (user) { return _this._user = user; });
	        this._baseUrl = this._config.getContext('management').url;
	    }
	    PersonalInfoComponent.prototype.ngOnInit = function () {
	        this.getUserSettings();
	        this.rnd = Math.floor(Math.random() * 11);
	    };
	    PersonalInfoComponent.prototype.getUserSettings = function () {
	        var _this = this;
	        this.subs.push(this._settingsService.getUserSettings()
	            .subscribe(function (s) { return _this.settings = s; }, function (err) { return _this.error = err; }, function () { return _this.requestSuccess(); }));
	    };
	    PersonalInfoComponent.prototype.ngOnDestroy = function () {
	        this.subs.forEach(function (u) { return u.unsubscribe(); });
	    };
	    PersonalInfoComponent.prototype.requestSuccess = function () {
	        this.loading = false;
	        this.appPage.deactivatePreloader();
	        this.animation = 'fadeIn';
	    };
	    PersonalInfoComponent.prototype.onSaveInfo = function (save) {
	        var _this = this;
	        if (!save) {
	            this.editMode = false;
	            return;
	        }
	        this.animation = 'fadeOut';
	        var personalInfo = new models_2.PersonalInfo({
	            phoneNumber: this.fg.value.phoneNumber,
	            email: this.fg.value.email,
	            providerId: Number(this.fg.value.providerId) || null
	        });
	        this.appPage.activatePreloader();
	        var response;
	        this.subs.push(this._settingsService.setUserSettings(personalInfo)
	            .subscribe(function (r) { return response = r; }, function (err) { return _this.error = err; }, function () {
	            _this.getUserSettings();
	            _this.editMode = false;
	            return;
	        }));
	    };
	    PersonalInfoComponent.prototype.onEditInfoAction = function (event) {
	        this.editMode = true;
	    };
	    Object.defineProperty(PersonalInfoComponent.prototype, "username", {
	        get: function () {
	            return this._user ? this._user.name : 'User';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PersonalInfoComponent.prototype, "imageUrl", {
	        get: function () {
	            return "" + this._baseUrl + this.settings.imageUrl + "?rnd=" + this.rnd;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PersonalInfoComponent.prototype.changePassword = function () {
	        this.navigate('/settings/password');
	    };
	    PersonalInfoComponent.prototype.navigate = function (route) {
	        this._router.navigate([route]);
	    };
	    __decorate([
	        core_1.ViewChild(app_page_component_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], PersonalInfoComponent.prototype, "appPage", void 0);
	    PersonalInfoComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(713),
	            styles: [__webpack_require__(714)],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_2.Store !== 'undefined' && services_2.Store) === 'function' && _a) || Object, (typeof (_b = typeof services_2.StoreHelper !== 'undefined' && services_2.StoreHelper) === 'function' && _b) || Object, (typeof (_c = typeof services_2.UserService !== 'undefined' && services_2.UserService) === 'function' && _c) || Object, (typeof (_d = typeof services_3.ConfigService !== 'undefined' && services_3.ConfigService) === 'function' && _d) || Object, (typeof (_e = typeof services_1.SettingsService !== 'undefined' && services_1.SettingsService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object])
	    ], PersonalInfoComponent);
	    return PersonalInfoComponent;
	    var _a, _b, _c, _d, _e, _f;
	}(models_1.TopLevelComponent));
	exports.PersonalInfoComponent = PersonalInfoComponent;


/***/ },
/* 713 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"layout-column h-100 layout-padding animated {{animation}}\" *ngIf=\"!loading\"><div class=\"flex scrollable-settings\"><user-image class=\"m-t-30 flex\" [width]=\"128\" [alt]=\"true\"></user-image><div class=\"layout-column layout-align-center-center flex\"><bw-button class=\"m-t-20 flex\" color=\"red\" title=\"Change Password\" [rounded]=\"true\" size=\"sm\" (click)=\"changePassword()\"></bw-button></div><div class=\"info layout-column layout-align-center-center flex-grow m-t-30\"><personal-info-view [hidden]=\"editMode\" [settings]=\"settings\" (viewInfoAction)=\"beginEdit()\"></personal-info-view><personal-info-edit [hidden]=\"!editMode\" [fg]=\"fg\" [settings]=\"settings\" (editInfoAction)=\"onEditInfoAction($event)\"></personal-info-edit></div></div><div class=\"layout-row layout-padding layout-align-center-start flex-60-nogrow material-buttons\"><bw-button [hidden]=\"editMode\" color=\"red\" [circular]=\"true\" icon=\"edit\" size=\"lg\" (click)=\"onEditInfoAction()\"> </bw-button><bw-button [hidden]=\"!editMode\" color=\"red\" [rounded]=\"true\" title=\"Save\" icon=\"check\" (click)=\"onSaveInfo(true)\"></bw-button><bw-button [hidden]=\"!editMode\" color=\"red\" [rounded]=\"true\" title=\"Cancel\" icon=\"close\" (click)=\"onSaveInfo(false)\"></bw-button></div></div></app-page>";

/***/ },
/* 714 */
/***/ function(module, exports) {

	module.exports = ".info{width:100%;clear:both;cursor:pointer;font-size:14px;display:block}.info .body{position:relative}.scrollable-settings{overflow:auto}.material-buttons{z-index:5}\n"

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(716));
	__export(__webpack_require__(719));
	__export(__webpack_require__(723));


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(717));


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var PasswordFormComponent = (function () {
	    function PasswordFormComponent() {
	        this.fg = new forms_1.FormGroup({});
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
	    ], PasswordFormComponent.prototype, "fg", void 0);
	    PasswordFormComponent = __decorate([
	        core_1.Component({
	            selector: 'password-form',
	            template: __webpack_require__(718)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PasswordFormComponent);
	    return PasswordFormComponent;
	    var _a;
	}());
	exports.PasswordFormComponent = PasswordFormComponent;


/***/ },
/* 718 */
/***/ function(module, exports) {

	module.exports = "<div class=\"layout-row layout-align-center-center\"><div class=\"flex-70 m-r-20 layout-column layout-padding layout-align-center-center\"><div class=\"flex input\"><password [fg]=\"fg\" field=\"currentPassword\" label=\"Current Password\" leftIcon=\"lock\" required=\"required\" [alt]=\"true\"></password></div><div class=\"flex input m-t-25\"><password [fg]=\"fg\" field=\"newPassword\" label=\"New Password\" leftIcon=\"lock\" required=\"required\" [alt]=\"true\"></password></div><div class=\"flex input m-t-25\"><password [fg]=\"fg\" field=\"confirmPassword\" label=\"Confirm Password\" leftIcon=\"lock\" required=\"required\" [alt]=\"true\"></password></div></div></div>";

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(720));


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(704);
	var core_1 = __webpack_require__(2);
	var PersonalInfoViewComponent = (function () {
	    function PersonalInfoViewComponent() {
	    }
	    Object.defineProperty(PersonalInfoViewComponent.prototype, "email", {
	        get: function () {
	            return this.settings.email;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PersonalInfoViewComponent.prototype, "phoneNumber", {
	        get: function () {
	            return this.settings.phoneNumber;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PersonalInfoViewComponent.prototype, "smsProviderName", {
	        get: function () {
	            return this.settings.smsProviders.selected.name;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof models_1.MobileUserSettings !== 'undefined' && models_1.MobileUserSettings) === 'function' && _a) || Object)
	    ], PersonalInfoViewComponent.prototype, "settings", void 0);
	    PersonalInfoViewComponent = __decorate([
	        core_1.Component({
	            selector: 'personal-info-view',
	            styles: [__webpack_require__(721)],
	            template: __webpack_require__(722)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PersonalInfoViewComponent);
	    return PersonalInfoViewComponent;
	    var _a;
	}());
	exports.PersonalInfoViewComponent = PersonalInfoViewComponent;


/***/ },
/* 721 */
/***/ function(module, exports) {

	module.exports = ".personal-info{width:100%;display:block;clear:both;cursor:pointer}.personal-info .title{font-size:14px;color:#9E9E9E}.personal-info .title i{font-size:16px}.personal-info .data{color:#fff}\n"

/***/ },
/* 722 */
/***/ function(module, exports) {

	module.exports = "<div class=\"personal-info\" id=\"phone-number\"><div class=\"layout-row layout-align-center-center flex\"><div class=\"title\">Phone Number:</div></div><div class=\"layout-row layout-align-center-center flex\"><div class=\"data m-t-5\">{{ phoneNumber }}</div></div></div><div class=\"personal-info m-t-35\" id=\"sms-provider\"><div class=\"layout-row layout-align-center-center flex\"><div class=\"title\">SMS Provider:</div></div><div class=\"layout-row layout-align-center-center flex\"><div class=\"data m-t-5\">    {{ smsProviderName }}</div></div></div><div class=\"personal-info m-t-35\" id=\"email\"><div class=\"layout-row layout-align-center-center flex\"><div class=\"title\">Email:</div></div><div class=\"layout-row layout-align-center-center flex\"><div class=\"data m-t-5\">{{ email }}</div></div></div>";

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(724));


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(704);
	var core_1 = __webpack_require__(2);
	var ng2_material_components_1 = __webpack_require__(33);
	var forms_1 = __webpack_require__(27);
	var PersonalInfoEditComponent = (function () {
	    function PersonalInfoEditComponent() {
	        this.fg = new forms_1.FormGroup({});
	        this.selectPickerInitialized = false;
	        this.providers = [];
	    }
	    PersonalInfoEditComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.providers = this.settings.smsProviders.providers
	            .map(function (p) {
	            return new ng2_material_components_1.SelectionItem(p.id, p.name, p.id === _this.settings.smsProviders.selected.id);
	        });
	        this.selectedProvider = this.providers.find(function (p) { return p.id === _this.settings.smsProviders.selected.id; });
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof models_1.MobileUserSettings !== 'undefined' && models_1.MobileUserSettings) === 'function' && _a) || Object)
	    ], PersonalInfoEditComponent.prototype, "settings", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], PersonalInfoEditComponent.prototype, "fg", void 0);
	    PersonalInfoEditComponent = __decorate([
	        core_1.Component({
	            selector: 'personal-info-edit',
	            styles: [__webpack_require__(725)],
	            template: __webpack_require__(726),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PersonalInfoEditComponent);
	    return PersonalInfoEditComponent;
	    var _a;
	}());
	exports.PersonalInfoEditComponent = PersonalInfoEditComponent;


/***/ },
/* 725 */
721,
/* 726 */
/***/ function(module, exports) {

	module.exports = "<div class=\"personal-info m-t-15\" id=\"phone-number\"><div class=\"layout-row layout-align-center-center flex\"><div class=\"title\">Phone Number:</div></div><div class=\"layout-row layout-align-center-center flex\"><div class=\"flex-60 data m-t-5\"><text-box [fg]=\"fg\" field=\"phoneNumber\" [alt]=\"true\" [value]=\"settings.phoneNumber || ''\"></text-box></div></div></div><div class=\"personal-info m-t-20\" id=\"sms-provider\"><div class=\"layout-row layout-align-center-center flex\"><div class=\"title\">SMS Provider:</div></div><div class=\"layout-row layout-align-center-center flex\"><div class=\"flex-60 data m-t-5\">    <select-picker [fg]=\"fg\" field=\"providerId\" [items]=\"providers\" noneSelectedText=\"Select Provider\" [alt]=\"true\"></select-picker></div></div></div><div class=\"personal-info m-t-20\" id=\"email\"><div class=\"layout-row layout-align-center-center flex\"><div class=\"title\">Email:</div></div><div class=\"layout-row layout-align-center-center flex\"><div class=\"flex-60 data m-t-5\"><text-box [fg]=\"fg\" field=\"email\" [alt]=\"true\" [value]=\"settings.email || ''\"></text-box></div></div></div>";

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(728);
	__webpack_require__(755);
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var services_1 = __webpack_require__(274);
	var AppComponent = (function () {
	    function AppComponent(_store, _authService, _router, _userSvc, _appStateService) {
	        this._store = _store;
	        this._authService = _authService;
	        this._router = _router;
	        this._userSvc = _userSvc;
	        this._appStateService = _appStateService;
	        this.loading = false;
	        this.name = 'Nova On The Go';
	        this.url = 'http://www.novapointofsale.com';
	        this.headerTitle = 'Nova Mobile App';
	        this.headerActions = null;
	        this._hasToShowHeader = true;
	        // Do something with api
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._store.changes$.subscribe(function (state) { return _this._processStoreChanges(state); });
	        this._userSvc.user$.subscribe(function (user) { return _this._processUserChanges(user); });
	        // TODO: migrate this to the store, not need to be separated
	        this._subscribeToTitleChanges();
	        this._subscribeHasToShowHeaderChanges();
	        this._appStateService.backAction$.subscribe(function (value) {
	            _this.backActive = value;
	        });
	        // close side bar everytime we are openning a new route
	        this._router.events.subscribe(function (event) {
	            if (event instanceof router_1.NavigationStart) {
	                _this.sidebarOpen = false;
	                _this.backActive = false;
	            }
	        });
	    };
	    AppComponent.prototype.onActionClicked = function (item) {
	        this._store.pushAppEvent({
	            type: 'action',
	            data: item,
	        });
	    };
	    AppComponent.prototype.onBackActionClicked = function () {
	        this._store.pushAppEvent({
	            type: 'backAction',
	        });
	    };
	    AppComponent.prototype.onMenuItemClicked = function (item) {
	        // if (!item.children) {
	        //   this.sidebarOpen = false;
	        // }
	    };
	    AppComponent.prototype._processStoreChanges = function (state) {
	        // header actions
	        if (state.headerActions !== null && state.headerActions.length !== 0) {
	            this.headerActions = state.headerActions;
	        }
	    };
	    AppComponent.prototype._processUserChanges = function (user) {
	        // user changes
	        if (user !== null && this._hasToShowHeader) {
	            this.showHeader = true;
	            this.opacity = 0.8;
	        }
	        else {
	            this._hideHeader();
	        }
	    };
	    AppComponent.prototype._subscribeToTitleChanges = function () {
	        var that = this;
	        this._store.appEvents$.subscribe(function (appEvent) {
	            if (appEvent.type === 'title') {
	                that.headerTitle = appEvent.data;
	            }
	        });
	    };
	    AppComponent.prototype._subscribeHasToShowHeaderChanges = function () {
	        var that = this;
	        this._store.appEvents$.subscribe(function (appEvent) {
	            if (appEvent.type === 'hideHeader') {
	                that._hasToShowHeader = appEvent.data;
	                if (!that._hasToShowHeader) {
	                    that._hideHeader();
	                }
	            }
	        });
	    };
	    AppComponent.prototype._hideHeader = function () {
	        this.sidebarOpen = false;
	        this.showHeader = false;
	        this.opacity = 0.4;
	    };
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'my-app',
	            template: __webpack_require__(757),
	            styles: [__webpack_require__(758)],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _a) || Object, (typeof (_b = typeof services_1.AuthService !== 'undefined' && services_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _d) || Object, (typeof (_e = typeof services_1.AppStateService !== 'undefined' && services_1.AppStateService) === 'function' && _e) || Object])
	    ], AppComponent);
	    return AppComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.AppComponent = AppComponent;


/***/ },
/* 728 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */
728,
/* 756 */,
/* 757 */
/***/ function(module, exports) {

	module.exports = "<app-header *ngIf=\"showHeader\" color=\"red\" [addMenuTrigger]=\"true\" [brand]=\"headerTitle\" [actions]=\"headerActions\" [sidebarOpen]=\"sidebarOpen\" [backActive]=\"backActive\" (onSidebarToggle)=\"sidebarOpen = $event\" (onActionClicked)=\"onActionClicked($event)\" (onbackActionClicked)=\"onBackActionClicked()\"></app-header><my-sidenav [open]=\"sidebarOpen\"></my-sidenav><bw-background image=\"/img/backgrounds/main-background.png\"></bw-background><bw-overlay [opacity]=\"opacity\"></bw-overlay><section id=\"main-content\"><router-outlet></router-outlet></section>";

/***/ },
/* 758 */
/***/ function(module, exports) {

	module.exports = ":host{display:block;height:100%}\n"

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(23);
	var shared_module_1 = __webpack_require__(26);
	var ng2_material_components_1 = __webpack_require__(33);
	var dashboard_component_1 = __webpack_require__(660);
	var employees_1 = __webpack_require__(760);
	var inventory_1 = __webpack_require__(765);
	var locations_1 = __webpack_require__(768);
	var summary_1 = __webpack_require__(771);
	var shared_1 = __webpack_require__(775);
	var services_1 = __webpack_require__(762);
	var DashboardModule = (function () {
	    function DashboardModule() {
	    }
	    DashboardModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                ng2_material_components_1.MaterialFormsModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                shared_module_1.SharedModule,
	            ],
	            exports: [
	                dashboard_component_1.DashboardComponent,
	                employees_1.DashboardEmployeesComponent,
	                inventory_1.DashboardInventoryComponent,
	                locations_1.DashboardLocationsComponent,
	                summary_1.DashboardSummaryComponent,
	                shared_1.DashboardFilterSheetComponent
	            ],
	            declarations: [
	                dashboard_component_1.DashboardComponent,
	                employees_1.DashboardEmployeesComponent,
	                inventory_1.DashboardInventoryComponent,
	                locations_1.DashboardLocationsComponent,
	                summary_1.DashboardSummaryComponent,
	                shared_1.DashboardFilterSheetComponent
	            ],
	            providers: [
	                services_1.DashboardService
	            ],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DashboardModule);
	    return DashboardModule;
	}());
	exports.DashboardModule = DashboardModule;


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(761));


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var dashboard_filter_1 = __webpack_require__(665);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(762);
	var DashboardEmployeesComponent = (function () {
	    function DashboardEmployeesComponent(_dashboardService) {
	        this._dashboardService = _dashboardService;
	    }
	    DashboardEmployeesComponent.prototype.ngOnChanges = function (changes) {
	        var _this = this;
	        var dashboardFilter = changes['dashboardFilter'].currentValue;
	        if (dashboardFilter) {
	            this._employeeSalesSubscription = this._dashboardService.getEmployeeSales(dashboardFilter)
	                .subscribe(function (sales) { return _this.employeeSales = sales; });
	        }
	    };
	    DashboardEmployeesComponent.prototype.ngOnDestroy = function () {
	        //this._employeeSalesSubscription.unsubscribe();
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof dashboard_filter_1.DashboardFilter !== 'undefined' && dashboard_filter_1.DashboardFilter) === 'function' && _a) || Object)
	    ], DashboardEmployeesComponent.prototype, "dashboardFilter", void 0);
	    DashboardEmployeesComponent = __decorate([
	        core_1.Component({
	            selector: 'dashboard-employees',
	            template: __webpack_require__(764)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof services_1.DashboardService !== 'undefined' && services_1.DashboardService) === 'function' && _b) || Object])
	    ], DashboardEmployeesComponent);
	    return DashboardEmployeesComponent;
	    var _a, _b;
	}());
	exports.DashboardEmployeesComponent = DashboardEmployeesComponent;


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(763));


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(663);
	var models_2 = __webpack_require__(663);
	var services_1 = __webpack_require__(274);
	var core_1 = __webpack_require__(2);
	var DashboardService = (function () {
	    function DashboardService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    DashboardService.prototype.getIncomeSummary = function (filter) {
	        return this._api.get(this._bi.url, 'managerial/income/summary', filter)
	            .map(function (summary) { return new models_2.IncomeSummary(summary); })
	            .cache();
	    };
	    DashboardService.prototype.getEmployeeSales = function (filter) {
	        return this._api.get(this._bi.url, 'employees/sales', filter)
	            .map(function (sales) { return sales.data.map(function (sale) { return new models_1.EmployeeSales(sale); }); })
	            .cache();
	    };
	    DashboardService.prototype.getSalesByLocation = function (filter) {
	        return this._api.get(this._bi.url, 'reporting/mobile/sales/locations', filter)
	            .map(function (sales) { return sales.map(function (sale) { return new models_1.LocationSales(sale); }); })
	            .cache();
	    };
	    DashboardService.prototype.getProductsSoldByLocation = function (filter) {
	        return this._api.get(this._bi.url, 'inventory/sold', filter)
	            .map(function (sold) { return sold.map(function (productsSold) { return new models_1.ProductsSold(productsSold); }); })
	            .cache();
	    };
	    DashboardService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], DashboardService);
	    return DashboardService;
	    var _a, _b;
	}());
	exports.DashboardService = DashboardService;


/***/ },
/* 764 */
/***/ function(module, exports) {

	module.exports = "<async-content [busy]=\"loading\"><div class=\"list-header m-t-15 text-center animated fadein\"><i class=\"zmdi zmdi-accounts\"></i>Employees</div><div class=\"message\" *ngIf=\"!employeeSales || employeeSales.length &lt; 1\"><i class=\"zmdi zmdi-info\"> </i>No employee sales were found</div><div class=\"list-item simple\" *ngFor=\"let sale of employeeSales\"><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">{{sale.employee.name}}</div><small>{{sale.location.name}}</small></div><div class=\"flex-nogrow results c-amber\" [class.negative-number]=\"sale.afc &lt;= 0\">{{ sale.afc | currency:'USD':true }}</div></div></div></async-content>";

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(766));


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var services_1 = __webpack_require__(762);
	var services_2 = __webpack_require__(274);
	var dashboard_filter_1 = __webpack_require__(665);
	var core_1 = __webpack_require__(2);
	var ui_1 = __webpack_require__(132);
	var DashboardInventoryComponent = (function () {
	    function DashboardInventoryComponent(_dashboardService, _userSvc) {
	        this._dashboardService = _dashboardService;
	        this._userSvc = _userSvc;
	        this.productsSold = [];
	        this.loading = true;
	        this.authorized = true;
	        this.errorMessage = 'Inventory - Not Authorized';
	    }
	    DashboardInventoryComponent.prototype.ngOnChanges = function (changes) {
	        var _this = this;
	        var dashboardFilter = changes['dashboardFilter'].currentValue;
	        if (dashboardFilter) {
	            this.loading = true;
	            this._productsSoldSubscription = this._dashboardService.getProductsSoldByLocation(dashboardFilter)
	                .subscribe(function (sold) { return _this.productsSold = sold; }, function (err) {
	                _this.authorized = _this._userSvc.userHasAccess(err);
	                _this.loading = false;
	            }, function () { return _this.loading = false; });
	        }
	    };
	    DashboardInventoryComponent.prototype.ngOnDestroy = function () {
	        // this._productsSoldSubscription.unsubscribe();
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.RibbonMessageComponent), 
	        __metadata('design:type', Object)
	    ], DashboardInventoryComponent.prototype, "ribbonMessage", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof dashboard_filter_1.DashboardFilter !== 'undefined' && dashboard_filter_1.DashboardFilter) === 'function' && _a) || Object)
	    ], DashboardInventoryComponent.prototype, "dashboardFilter", void 0);
	    DashboardInventoryComponent = __decorate([
	        core_1.Component({
	            selector: 'dashboard-inventory',
	            template: __webpack_require__(767)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof services_1.DashboardService !== 'undefined' && services_1.DashboardService) === 'function' && _b) || Object, (typeof (_c = typeof services_2.UserService !== 'undefined' && services_2.UserService) === 'function' && _c) || Object])
	    ], DashboardInventoryComponent);
	    return DashboardInventoryComponent;
	    var _a, _b, _c;
	}());
	exports.DashboardInventoryComponent = DashboardInventoryComponent;


/***/ },
/* 767 */
/***/ function(module, exports) {

	module.exports = "<async-content [busy]=\"loading\"><div class=\"flex\" *ngIf=\"authorized\"><div class=\"list-header m-t-15 text-center animated fadein\"><i class=\"zmdi zmdi-shopping-cart-plus\"></i>Inventory</div><div class=\"message\" *ngIf=\"!productsSold || productsSold.length &lt; 1\"><i class=\"zmdi zmdi-info\"> </i>The inventory was not affect for the selected period</div><div class=\"list-item simple\" *ngFor=\"let sale of productsSold\"><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">{{sale.product.name}}</div></div><div class=\"flex-nogrow results c-amber\">{{ sale.quantity }}</div></div></div></div><ribbon-message [hidden]=\"authorized || loading\" [message]=\"errorMessage\"></ribbon-message></async-content>";

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(769));


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var services_1 = __webpack_require__(762);
	var models_1 = __webpack_require__(663);
	var services_2 = __webpack_require__(274);
	var core_1 = __webpack_require__(2);
	var ui_1 = __webpack_require__(132);
	var DashboardLocationsComponent = (function () {
	    function DashboardLocationsComponent(_dashboardService, _userSvc) {
	        this._dashboardService = _dashboardService;
	        this._userSvc = _userSvc;
	        this.locationSales = [];
	        this.loading = true;
	        this.authorized = true;
	        this.errorMessage = 'Locations - Not Authorized';
	    }
	    DashboardLocationsComponent.prototype.ngOnChanges = function (changes) {
	        var _this = this;
	        var dashboardFilter = changes['dashboardFilter'].currentValue;
	        if (dashboardFilter) {
	            this.loading = true;
	            this._locationSalesSubscription = this._dashboardService.getSalesByLocation(dashboardFilter)
	                .subscribe(function (sales) { return _this.locationSales = sales; }, function (err) {
	                _this.authorized = _this._userSvc.userHasAccess(err);
	                _this.loading = false;
	            }, function () { return _this.loading = false; });
	        }
	    };
	    DashboardLocationsComponent.prototype.ngOnDestroy = function () {
	        // this._locationSalesSubscription.unsubscribe();
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.RibbonMessageComponent), 
	        __metadata('design:type', Object)
	    ], DashboardLocationsComponent.prototype, "ribbonMessage", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof models_1.DashboardFilter !== 'undefined' && models_1.DashboardFilter) === 'function' && _a) || Object)
	    ], DashboardLocationsComponent.prototype, "dashboardFilter", void 0);
	    DashboardLocationsComponent = __decorate([
	        core_1.Component({
	            selector: 'dashboard-locations',
	            template: __webpack_require__(770)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof services_1.DashboardService !== 'undefined' && services_1.DashboardService) === 'function' && _b) || Object, (typeof (_c = typeof services_2.UserService !== 'undefined' && services_2.UserService) === 'function' && _c) || Object])
	    ], DashboardLocationsComponent);
	    return DashboardLocationsComponent;
	    var _a, _b, _c;
	}());
	exports.DashboardLocationsComponent = DashboardLocationsComponent;


/***/ },
/* 770 */
/***/ function(module, exports) {

	module.exports = "<async-content [busy]=\"loading\"><div class=\"flex\" *ngIf=\"authorized\"><div class=\"list-header m-t-15 text-center animated fadein\"><i class=\"zmdi zmdi-pin\"></i>Locations</div><div class=\"message\" *ngIf=\"!locationSales || locationSales.length &lt; 1\"><i class=\"zmdi zmdi-info\"> </i>No sales were made during the selected period</div><div class=\"list-item simple\" *ngFor=\"let sale of locationSales\"><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">{{sale.name}}            </div></div><div class=\"flex-nogrow results c-amber\" [class.negative-number]=\"sale.afc &lt;= 0\">{{ sale.total | currency:'USD':true }}</div></div><div class=\"layout-row\" *ngIf=\"sale.lastInvoice\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right m-r-20\"><span>Last Sale Date</span></div></div></div><div class=\"flex-nogrow\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ sale.lastInvoice | toLocalDate}}           </div></div></div></div></div></div><ribbon-message [hidden]=\"authorized || loading\" [message]=\"errorMessage\"></ribbon-message></async-content>";

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(772));


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var dashboard_filter_1 = __webpack_require__(665);
	var models_1 = __webpack_require__(663);
	var services_1 = __webpack_require__(762);
	var core_1 = __webpack_require__(2);
	var ui_1 = __webpack_require__(132);
	var DashboardSummaryComponent = (function () {
	    function DashboardSummaryComponent(_dashboardService) {
	        this._dashboardService = _dashboardService;
	        this.incomeSummary = new models_1.IncomeSummary(null);
	        this.loading = true;
	        this.authorized = true;
	        this.errorMessage = 'Summary - Not Authorized';
	    }
	    DashboardSummaryComponent.prototype.ngOnChanges = function (changes) {
	        var _this = this;
	        var dashboardFilter = changes['dashboardFilter'].currentValue;
	        if (dashboardFilter) {
	            this.loading = true;
	            this._summarySubscription = this._dashboardService.getIncomeSummary(dashboardFilter)
	                .subscribe(function (summary) { return _this.incomeSummary = summary; }, function (err) { return _this._handleHttpError(err); }, function () { return _this.loading = false; });
	        }
	        ;
	    };
	    DashboardSummaryComponent.prototype.ngOnDestroy = function () {
	        // this._summarySubscription.unsubscribe();
	    };
	    DashboardSummaryComponent.prototype._handleHttpError = function (err) {
	        if (err.status === 403) {
	            this.authorized = false;
	        }
	        this.loading = false;
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.RibbonMessageComponent), 
	        __metadata('design:type', Object)
	    ], DashboardSummaryComponent.prototype, "ribbonMessage", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof dashboard_filter_1.DashboardFilter !== 'undefined' && dashboard_filter_1.DashboardFilter) === 'function' && _a) || Object)
	    ], DashboardSummaryComponent.prototype, "dashboardFilter", void 0);
	    DashboardSummaryComponent = __decorate([
	        core_1.Component({
	            selector: 'dashboard-summary',
	            styles: [__webpack_require__(773)],
	            template: __webpack_require__(774)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof services_1.DashboardService !== 'undefined' && services_1.DashboardService) === 'function' && _b) || Object])
	    ], DashboardSummaryComponent);
	    return DashboardSummaryComponent;
	    var _a, _b;
	}());
	exports.DashboardSummaryComponent = DashboardSummaryComponent;


/***/ },
/* 773 */
/***/ function(module, exports) {

	module.exports = ".income-summary{position:relative}.income-summary .cover{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}.income-summary .flex{position:relative}.income-summary .label{color:#9E9E9E;font-size:10px}.income-summary .net{font-size:32px}.income-summary .tax,.income-summary .gross{font-size:20px}\n"

/***/ },
/* 774 */
/***/ function(module, exports) {

	module.exports = "<async-content [busy]=\"loading\"><div class=\"income-summary layout-column layout-padding text-center z-depth-2 animated fadein\" *ngIf=\"authorized\"><div class=\"cover\"></div><div class=\"flex\"><div class=\"label\">Total Net</div><div class=\"net c-amber\">{{ incomeSummary.net | currency:'USD':'$' }} </div></div><div class=\"flex\"><div class=\"layout-row\"><div class=\"flex\"><div class=\"label\">Total Tax</div><div class=\"tax c-lime\">{{ incomeSummary.tax | currency:'USD':'$' }}</div></div><div class=\"flex\"><div class=\"label\">Total Gross</div><div class=\"gross c-lime\">{{ incomeSummary.gross | currency:'USD':'$' }}</div></div></div></div></div><ribbon-message [hidden]=\"authorized || loading\" [message]=\"errorMessage\"></ribbon-message></async-content>";

/***/ },
/* 775 */
[1080, 776, 663, 762],
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(661));


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(23);
	var accounts_routing_1 = __webpack_require__(778);
	var shared_module_1 = __webpack_require__(26);
	var services_1 = __webpack_require__(274);
	var forms_1 = __webpack_require__(27);
	var ng2_material_components_1 = __webpack_require__(33);
	var accounts_component_1 = __webpack_require__(659);
	var choose_account_1 = __webpack_require__(779);
	var login_1 = __webpack_require__(783);
	var add_account_1 = __webpack_require__(787);
	var delete_account_1 = __webpack_require__(791);
	var AccountsModule = (function () {
	    function AccountsModule() {
	    }
	    AccountsModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                ng2_material_components_1.MaterialFormsModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                accounts_routing_1.accountsRouting,
	                shared_module_1.SharedModule,
	                forms_1.FormsModule,
	                forms_1.ReactiveFormsModule
	            ],
	            exports: [
	                accounts_component_1.AccountsComponent,
	                choose_account_1.ChooseAccountComponent,
	                login_1.LoginComponent,
	                add_account_1.AddAccountComponent,
	                delete_account_1.DeleteAccountComponent
	            ],
	            declarations: [
	                accounts_component_1.AccountsComponent,
	                choose_account_1.ChooseAccountComponent,
	                login_1.LoginComponent,
	                add_account_1.AddAccountComponent,
	                delete_account_1.DeleteAccountComponent
	            ],
	            providers: [
	                services_1.UserService,
	                services_1.AuthService,
	                services_1.AccountsService
	            ],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AccountsModule);
	    return AccountsModule;
	}());
	exports.AccountsModule = AccountsModule;


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(77);
	var accounts_component_1 = __webpack_require__(659);
	var choose_account_1 = __webpack_require__(779);
	var login_1 = __webpack_require__(783);
	var add_account_1 = __webpack_require__(787);
	var delete_account_1 = __webpack_require__(791);
	var accountsRoutes = [
	    {
	        path: 'accounts',
	        component: accounts_component_1.AccountsComponent,
	        children: [
	            {
	                path: '',
	                component: choose_account_1.ChooseAccountComponent
	            },
	            {
	                path: 'login/:account',
	                component: login_1.LoginComponent
	            },
	            {
	                path: 'add-account',
	                component: add_account_1.AddAccountComponent
	            },
	            {
	                path: 'delete-account/:account',
	                component: delete_account_1.DeleteAccountComponent
	            }
	        ]
	    }
	];
	exports.accountsRouting = router_1.RouterModule.forChild(accountsRoutes);


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(780));


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var router_1 = __webpack_require__(77);
	var models_1 = __webpack_require__(137);
	var ChooseAccountComponent = (function (_super) {
	    __extends(ChooseAccountComponent, _super);
	    function ChooseAccountComponent(_authSvc, _router, _accService, store) {
	        _super.call(this, store);
	        this._authSvc = _authSvc;
	        this._router = _router;
	        this._accService = _accService;
	        this.store = store;
	        this.accounts = [];
	        this.imageUrl = '/img/accounts_icon3.jpg';
	        this.hasUserAuthorized = this._authSvc.isAuthorized();
	    }
	    ChooseAccountComponent.prototype.ngOnInit = function () {
	        this.accounts = this._accService.getAccounts();
	        this.multipleAccountsRegistered = this.accounts.length > 1;
	    };
	    ChooseAccountComponent.prototype.ngAfterViewInit = function () {
	        if (this.accounts.length < 1) {
	            this._redirectToAddAccount();
	        }
	    };
	    ChooseAccountComponent.prototype.ngOnDestroy = function () {
	        this.componentDestroy();
	    };
	    ChooseAccountComponent.prototype.login = function (account) {
	        if (account.access_token) {
	            this._authSvc.login(account);
	            this._router.navigate(['/dashboard']);
	        }
	        else {
	            this._router.navigate(['accounts/login', account.accountName]);
	        }
	    };
	    ChooseAccountComponent.prototype.addAccountClicked = function () {
	        this._redirectToAddAccount();
	    };
	    ChooseAccountComponent.prototype.remove = function (e, accountToRemove) {
	        e.preventDefault();
	        this._router.navigate(['accounts/delete-account', accountToRemove]);
	    };
	    ChooseAccountComponent.prototype.goToDashboard = function () {
	        if (this.hasUserAuthorized) {
	            this._authSvc.setBearer();
	            this._router.navigate(['/dashboard']);
	        }
	    };
	    ChooseAccountComponent.prototype._redirectToAddAccount = function () {
	        this._router.navigate(['accounts/add-account']);
	    };
	    ChooseAccountComponent = __decorate([
	        core_1.Component({
	            styles: [__webpack_require__(781)],
	            template: __webpack_require__(782)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.AuthService !== 'undefined' && services_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof services_1.AccountsService !== 'undefined' && services_1.AccountsService) === 'function' && _c) || Object, (typeof (_d = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _d) || Object])
	    ], ChooseAccountComponent);
	    return ChooseAccountComponent;
	    var _a, _b, _c, _d;
	}(models_1.TopLevelWithoutHeaderComponent));
	exports.ChooseAccountComponent = ChooseAccountComponent;


/***/ },
/* 781 */
/***/ function(module, exports) {

	module.exports = ".delete-icon{color:aliceblue;margin-left:-50px;font-size:22px;position:absolute;margin-top:-15px;z-index:1000}.scrollable-settings{overflow:auto}@media screen and (max-height: 640px){.logo-margin{margin-left:30px}}\n"

/***/ },
/* 782 */
/***/ function(module, exports) {

	module.exports = "<div class=\"login-container full-screen\"><form class=\"h-100\"><div class=\"layout-column layout-padding h-100\"><div class=\"nova-logo flex-none animated slideInDown\"><div class=\"layout-row\"><div class=\"flex\"><bw-button *ngIf=\"hasUserAuthorized\" title=\"Dashboard\" [simple]=\"true\" color=\"red\" icon=\"view-dashboard\" (clicked)=\"goToDashboard($event)\"></bw-button></div><img class=\"flex-nogrow logo-margin\" src=\"/img/logos/logo.png\"/><div class=\"flex\" style=\"text-align: right\"><bw-button title=\"Help\" [simple]=\"true\" color=\"red\" icon=\"help-outline\"></bw-button></div></div></div><div class=\"flex scrollable-settings text-center animated fadeInDown\"><h1 class=\"title c-white\">Choose Account</h1><div class=\"layout-row layout-align-center-center layout-wrap animated {{animation}}\" *ngIf=\"!loading\"><div *ngFor=\"let account of accounts\" [class.col-xs-6]=\"multipleAccountsRegistered\"><div class=\"m-t-30\"><i class=\"zmdi zmdi-close-circle delete-icon\" (click)=\"remove($event, account.accountName)\"></i></div><dynamic-image [alt]=\"true\" [width]=\"96\" [image]=\"imageUrl\" text=\"{{account.accountName}}\" (click)=\"login(account)\"> </dynamic-image><div *ngIf=\"account.username\" [class.c-lime]=\"account.access_token\" [class.c-light-gray]=\"!account.access_token\"> {{account.username}}</div></div></div></div><div class=\"layout-row layout-padding layout-align-center-start flex-60-nogrow material-buttons animated slideInUp\"><bw-button title=\"Add New\" color=\"red\" icon=\"plus\" [rounded]=\"true\" (clicked)=\"addAccountClicked($event)\"></bw-button></div></div></form></div>";

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(784));


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var services_1 = __webpack_require__(274);
	var router_1 = __webpack_require__(77);
	var models_1 = __webpack_require__(137);
	var LoginComponent = (function (_super) {
	    __extends(LoginComponent, _super);
	    function LoginComponent(_authSvc, _router, _route, _accService, store) {
	        _super.call(this, store);
	        this._authSvc = _authSvc;
	        this._router = _router;
	        this._route = _route;
	        this._accService = _accService;
	        this.store = store;
	        this.fg = new forms_1.FormGroup({});
	        this.authErrorMessage = 'Invalid credentials';
	        this.authError = false;
	        this.imageUrl = '/img/accounts_icon3.jpg';
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._route.params.forEach(function (params) {
	            var accountName = params['account'];
	            _this.accountToLogin = _this._accService.getAccountByName(accountName);
	        });
	    };
	    LoginComponent.prototype.ngAfterViewInit = function () {
	        if (!this.accountToLogin) {
	            this._redirectToChooseAccount();
	        }
	    };
	    LoginComponent.prototype.ngOnDestroy = function () {
	        this.componentDestroy();
	    };
	    LoginComponent.prototype.login = function (e) {
	        var _this = this;
	        e.preventDefault();
	        this.authError = false;
	        var creds = this.fg.value;
	        creds.account = this.accountToLogin.accountName;
	        this._authSvc.authenticate(creds)
	            .subscribe(function (res) { return _this._onSuccesfullAuth(res); }, function (err) { return _this._onErrorAuth(err); }, function () { return console.log('Auth completed'); });
	    };
	    LoginComponent.prototype.cancel = function () {
	        this._redirectToChooseAccount();
	    };
	    LoginComponent.prototype._redirectToChooseAccount = function () {
	        this._router.navigate(['/accounts']);
	    };
	    LoginComponent.prototype._onSuccesfullAuth = function (res) {
	        this.authError = false;
	        this._router.navigate(['/dashboard']);
	    };
	    LoginComponent.prototype._onErrorAuth = function (res) {
	        this.authError = true;
	    };
	    LoginComponent = __decorate([
	        core_1.Component({
	            styles: [__webpack_require__(785)],
	            template: __webpack_require__(786)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.AuthService !== 'undefined' && services_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof services_1.AccountsService !== 'undefined' && services_1.AccountsService) === 'function' && _d) || Object, (typeof (_e = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _e) || Object])
	    ], LoginComponent);
	    return LoginComponent;
	    var _a, _b, _c, _d, _e;
	}(models_1.TopLevelWithoutHeaderComponent));
	exports.LoginComponent = LoginComponent;


/***/ },
/* 785 */
/***/ function(module, exports) {

	module.exports = ".error-message{background-color:#E41736;color:#fff;font-size:16px;display:inline-block;padding:5px 10px;border-radius:10px}@media screen and (max-height: 640px){.login-form{margin-top:-30px}}\n"

/***/ },
/* 786 */
/***/ function(module, exports) {

	module.exports = "<div class=\"login-container full-screen\"><form class=\"h-100\" [formGroup]=\"fg\" #f=\"ngForm\"><div class=\"layout-column layout-padding h-100\"><div class=\"nova-logo flex-none animated slideInDown\"><div class=\"layout-row\"><div class=\"flex\"><bw-button title=\"Cancel\" [simple]=\"true\" color=\"red\" icon=\"chevron-left\" (clicked)=\"cancel($event)\"></bw-button></div><img class=\"flex-nogrow\" src=\"/img/logos/logo.png\"/><div class=\"flex\"></div></div></div><div class=\"flex text-center animated fadeInDown\"><h1 class=\"title c-white\">Login</h1><div class=\"layout-column m-t-20 h-100 animated {{animation}}\"><div class=\"flex\"><dynamic-image [alt]=\"true\" [width]=\"96\" [image]=\"imageUrl\" text=\"{{accountToLogin.accountName}}\"> </dynamic-image></div></div></div><div class=\"flex input animated slideInUp login-form\"><div class=\"m-b-25\"><text-box [fg]=\"fg\" field=\"username\" label=\"User Name\" leftIcon=\"account-o\" [alt]=\"true\" required=\"required\" [value]=\"accountToLogin.username\"></text-box></div><div class=\"m-b-25\"><password [fg]=\"fg\" field=\"password\" label=\"Password\" leftIcon=\"lock\" [alt]=\"true\" required=\"required\"></password></div><div class=\"layout-row layout-align-center-center\"><bw-button id=\"add-account\" title=\"Login\" type=\"submit\" color=\"red\" icon=\"plus\" [rounded]=\"true\" (click)=\"login($event)\"></bw-button></div><div class=\"text-center animated shake m-t-10\" *ngIf=\"authError\"><div class=\"error-message\">{{authErrorMessage}}</div></div></div></div></form></div>";

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(788));


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var services_1 = __webpack_require__(274);
	var router_1 = __webpack_require__(77);
	var models_1 = __webpack_require__(137);
	var AddAccountComponent = (function (_super) {
	    __extends(AddAccountComponent, _super);
	    function AddAccountComponent(_authSvc, _router, _accService, store) {
	        _super.call(this, store);
	        this._authSvc = _authSvc;
	        this._router = _router;
	        this._accService = _accService;
	        this.store = store;
	        this.fg = new forms_1.FormGroup({});
	        this.authErrorMessage = 'Invalid credentials';
	        this.authError = false;
	    }
	    AddAccountComponent.prototype.ngOnDestroy = function () {
	        this.componentDestroy();
	    };
	    AddAccountComponent.prototype.goBackClicked = function () {
	        var accounts = this._accService.getAccounts();
	        if (accounts.length > 0) {
	            this._router.navigate(['accounts']);
	        }
	        else {
	            this._router.navigate(['']);
	        }
	    };
	    AddAccountComponent.prototype.register = function (e) {
	        var _this = this;
	        e.preventDefault();
	        this.authError = false;
	        var creds = this.fg.value;
	        this._authSvc.authenticate(creds)
	            .subscribe(function (res) { return _this._onSuccesfullAuth(res); }, function (err) { return _this._onErrorAuth(err); }, function () { return console.log('Auth completed'); });
	    };
	    AddAccountComponent.prototype._onSuccesfullAuth = function (res) {
	        this.authError = false;
	        this._router.navigate(['/dashboard']);
	    };
	    AddAccountComponent.prototype._onErrorAuth = function (res) {
	        this.authError = true;
	    };
	    AddAccountComponent = __decorate([
	        core_1.Component({
	            styles: [__webpack_require__(789)],
	            template: __webpack_require__(790)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.AuthService !== 'undefined' && services_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof services_1.AccountsService !== 'undefined' && services_1.AccountsService) === 'function' && _c) || Object, (typeof (_d = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _d) || Object])
	    ], AddAccountComponent);
	    return AddAccountComponent;
	    var _a, _b, _c, _d;
	}(models_1.TopLevelWithoutHeaderComponent));
	exports.AddAccountComponent = AddAccountComponent;


/***/ },
/* 789 */
/***/ function(module, exports) {

	module.exports = ".error-message{background-color:#E41736;color:#fff;font-size:16px;display:inline-block;padding:5px 10px;border-radius:10px}@media screen and (max-height: 640px){.login-form{margin-top:-100px}}\n"

/***/ },
/* 790 */
/***/ function(module, exports) {

	module.exports = "<div class=\"login-container full-screen\"><form class=\"h-100\" [formGroup]=\"fg\" #f=\"ngForm\"><div class=\"layout-column layout-padding h-100\"><div class=\"nova-logo flex-none animated slideInDown\"><div class=\"layout-row\"><div class=\"flex\"><bw-button title=\"Back\" [simple]=\"true\" color=\"red\" icon=\"chevron-left\" (clicked)=\"goBackClicked($event)\"></bw-button></div><img class=\"flex-nogrow\" src=\"/img/logos/logo.png\"/><div class=\"flex\" style=\"text-align: right\"><bw-button title=\"Help\" [simple]=\"true\" color=\"red\" icon=\"help-outline\"></bw-button></div></div></div><div class=\"flex text-center animated fadeInDown\"><h1 class=\"title c-white\">Add Account</h1></div><div class=\"flex input animated slideInUp login-form\"><div class=\"m-b-25\"><text-box [fg]=\"fg\" field=\"account\" label=\"Account Name\" leftIcon=\"globe\" [alt]=\"true\" required=\"required\"></text-box></div><div class=\"m-b-25\"><text-box [fg]=\"fg\" field=\"username\" label=\"User Name\" leftIcon=\"account-o\" [alt]=\"true\" required=\"required\"></text-box></div><div class=\"m-b-25\"><password [fg]=\"fg\" field=\"password\" label=\"Password\" leftIcon=\"lock\" [alt]=\"true\" required=\"required\"></password></div><div class=\"layout-row layout-align-center-center\"><bw-button id=\"add-account\" title=\"Add account\" type=\"submit\" color=\"red\" icon=\"plus\" [rounded]=\"true\" (click)=\"register($event)\"></bw-button></div><div class=\"text-center\"><br/><a class=\"c-red\" href=\"\">Forgot my password</a></div><div class=\"text-center animated shake m-t-10\" *ngIf=\"authError\"><div class=\"error-message\">{{authErrorMessage}}</div></div></div></div></form></div>";

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(792));


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var models_1 = __webpack_require__(137);
	var services_1 = __webpack_require__(274);
	var DeleteAccountComponent = (function (_super) {
	    __extends(DeleteAccountComponent, _super);
	    function DeleteAccountComponent(_authService, _router, _route, _accService, store) {
	        _super.call(this, store);
	        this._authService = _authService;
	        this._router = _router;
	        this._route = _route;
	        this._accService = _accService;
	        this.store = store;
	        this.imageUrl = '/img/accounts_icon3.jpg';
	    }
	    DeleteAccountComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._route.params.forEach(function (params) {
	            _this._accountName = params['account'];
	            _this.account = _this._accService.getAccountByName(_this._accountName);
	        });
	    };
	    DeleteAccountComponent.prototype.ngAfterViewInit = function () {
	        if (!this.account) {
	            this._router.navigate(['/accounts']);
	        }
	    };
	    DeleteAccountComponent.prototype.ngOnDestroy = function () {
	        this.componentDestroy();
	    };
	    DeleteAccountComponent.prototype.cancelClicked = function () {
	        this._navigateToAccounts();
	    };
	    DeleteAccountComponent.prototype.delete = function (e) {
	        e.preventDefault();
	        this._authService.removeAccount(this._accountName);
	        this._navigateToAccounts();
	    };
	    DeleteAccountComponent.prototype.singout = function (e) {
	        e.preventDefault();
	        this._authService.signout(this.account, true);
	        this._navigateToAccounts();
	    };
	    DeleteAccountComponent.prototype._navigateToAccounts = function () {
	        this._router.navigate(['accounts']);
	    };
	    DeleteAccountComponent = __decorate([
	        core_1.Component({
	            styles: [__webpack_require__(793)],
	            template: __webpack_require__(794)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.AuthService !== 'undefined' && services_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof services_1.AccountsService !== 'undefined' && services_1.AccountsService) === 'function' && _d) || Object, (typeof (_e = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _e) || Object])
	    ], DeleteAccountComponent);
	    return DeleteAccountComponent;
	    var _a, _b, _c, _d, _e;
	}(models_1.TopLevelWithoutHeaderComponent));
	exports.DeleteAccountComponent = DeleteAccountComponent;


/***/ },
/* 793 */
/***/ function(module, exports) {

	module.exports = ".error-message{background-color:#E41736;color:#fff;font-size:16px;display:inline-block;padding:5px 10px;border-radius:10px}\n"

/***/ },
/* 794 */
/***/ function(module, exports) {

	module.exports = "<div class=\"login-container full-screen\"><div class=\"h-100\"><div class=\"layout-column layout-padding h-100\"><div class=\"nova-logo flex-none animated slideInDown\"><div class=\"layout-row\"><div class=\"flex\"><bw-button title=\"Cancel\" [simple]=\"true\" color=\"red\" icon=\"chevron-left\" (clicked)=\"cancelClicked()\"></bw-button></div><img class=\"flex-nogrow\" src=\"/img/logos/logo.png\"/><div class=\"flex\"></div></div></div><div class=\"flex text-center animated fadeInDown\"><div class=\"layout-column m-t-20 h-100 animated {{animation}}\" *ngIf=\"!loading\"><div class=\"flex\"><dynamic-image [alt]=\"true\" [width]=\"96\" [image]=\"imageUrl\" text=\"{{account.accountName}}\"></dynamic-image><div *ngIf=\"account.username\" [class.c-lime]=\"account.access_token\" [class.c-light-gray]=\"!account.access_token\"> {{account.username}}</div></div></div></div><div class=\"flex input animated slideInUp\"><div class=\"layout-row layout-align-center-center m-b-30\" *ngIf=\"account.access_token\"><bw-button title=\"Logout\" color=\"red\" icon=\"square-right\" [rounded]=\"true\" [block]=\"true\" (click)=\"singout($event)\"></bw-button></div><div class=\"layout-row layout-align-center-center\"><bw-button title=\"Delete\" color=\"red\" icon=\"delete\" [rounded]=\"true\" [block]=\"true\" (click)=\"delete($event)\"></bw-button></div><div class=\"text-center animated shake m-t-10\" *ngIf=\"deleteError\"><div class=\"error-message\">Error deleting this account. Try again.</div></div></div></div></div></div>";

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var services_1 = __webpack_require__(796);
	var core_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(23);
	var forms_1 = __webpack_require__(27);
	var employees_routing_1 = __webpack_require__(803);
	var shared_module_1 = __webpack_require__(26);
	var shared_1 = __webpack_require__(798);
	var ng2_material_components_1 = __webpack_require__(33);
	var employees_component_1 = __webpack_require__(671);
	var scores_1 = __webpack_require__(804);
	var salaries_1 = __webpack_require__(811);
	var EmployeesModule = (function () {
	    function EmployeesModule() {
	    }
	    EmployeesModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                forms_1.ReactiveFormsModule,
	                ng2_material_components_1.MaterialFormsModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                employees_routing_1.employeesRouting,
	                shared_module_1.SharedModule,
	            ],
	            exports: [
	                employees_component_1.EmployeesComponent,
	                scores_1.ScoresComponent,
	                scores_1.ScoreInvoicesComponent,
	                salaries_1.SalariesComponent,
	                shared_1.EmployeesFilterSheetComponent,
	                salaries_1.SalaryDetailsComponent,
	                salaries_1.SalaryAverageComponent,
	                salaries_1.TimestampedAmountsComponent
	            ],
	            declarations: [
	                employees_component_1.EmployeesComponent,
	                scores_1.ScoresComponent,
	                scores_1.ScoreInvoicesComponent,
	                salaries_1.SalariesComponent,
	                shared_1.EmployeesFilterSheetComponent,
	                salaries_1.SalaryDetailsComponent,
	                salaries_1.SalaryAverageComponent,
	                salaries_1.TimestampedAmountsComponent
	            ],
	            providers: [
	                services_1.EmployeesService
	            ],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], EmployeesModule);
	    return EmployeesModule;
	}());
	exports.EmployeesModule = EmployeesModule;


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(797));


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var _1 = __webpack_require__(798);
	var services_1 = __webpack_require__(274);
	var core_1 = __webpack_require__(2);
	var EmployeesService = (function () {
	    function EmployeesService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    EmployeesService.prototype.getScores = function (filter) {
	        return this._api.get(this._bi.url, 'employees/scores', filter)
	            .map(function (scores) { return scores.map(function (score) { return new _1.EmployeeScore(score); }); })
	            .cache();
	    };
	    EmployeesService.prototype.getSalaries = function (filter) {
	        return this._api.get(this._bi.url, 'employees/salary', filter)
	            .map(function (scores) { return scores.map(function (score) { return new _1.EmployeeSalary(score); }); })
	            .cache();
	    };
	    EmployeesService.prototype.getInvoices = function (filter) {
	        return this._api.get(this._bi.url, 'employees/invoices', filter)
	            .map(function (scoreDetails) { return new _1.EmployeeScoreDetails(scoreDetails); })
	            .cache();
	    };
	    EmployeesService.prototype.getSalaryDetails = function (filter) {
	        return this._api.get(this._bi.url, 'employees/salary/details', filter)
	            .map(function (salariesDetails) { return salariesDetails.map(function (details) { return new _1.EmployeeSalaryDetails(details); }); })
	            .cache();
	    };
	    EmployeesService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], EmployeesService);
	    return EmployeesService;
	    var _a, _b;
	}());
	exports.EmployeesService = EmployeesService;


/***/ },
/* 798 */
[1080, 799, 580, 796],
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(800));


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(801));


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var ui_1 = __webpack_require__(132);
	var models_2 = __webpack_require__(580);
	var EmployeesFilterSheetComponent = (function () {
	    function EmployeesFilterSheetComponent(_userSvc) {
	        this._userSvc = _userSvc;
	        this.filterChanged = new core_1.EventEmitter();
	        this.dateOptions = ['Today', 'Custom Range'];
	        this.activeOption = this.dateOptions[0];
	    }
	    EmployeesFilterSheetComponent.prototype.ngOnDestroy = function () { };
	    EmployeesFilterSheetComponent.prototype.locationPickerReady = function () {
	        this.applyFilter(null);
	    };
	    EmployeesFilterSheetComponent.prototype.toggle = function () {
	        this.sheet.toggle();
	    };
	    EmployeesFilterSheetComponent.prototype.onDateOptionSelected = function (option) {
	        this.showDateRange = option === 'Custom Range';
	    };
	    EmployeesFilterSheetComponent.prototype.applyFilter = function (e) {
	        if (e) {
	            e.preventDefault();
	        }
	        var value = this.fg.value;
	        var dateRange = this.showDateRange ?
	            new models_1.DateRange(value.from, value.to)
	            : new models_1.DateRange();
	        this.IsValidDateRange = dateRange.isValid;
	        if (this.IsValidDateRange) {
	            var locationsPickerSelection = this.locationPicker.getSelection();
	            var filter = new models_2.EmployeesFilter(dateRange, locationsPickerSelection, value.filter);
	            this.filterChanged.emit(filter);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
	    ], EmployeesFilterSheetComponent.prototype, "fg", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof models_2.EmployeesFilter !== 'undefined' && models_2.EmployeesFilter) === 'function' && _b) || Object)
	    ], EmployeesFilterSheetComponent.prototype, "filter", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], EmployeesFilterSheetComponent.prototype, "filterChanged", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.SheetComponent), 
	        __metadata('design:type', Object)
	    ], EmployeesFilterSheetComponent.prototype, "sheet", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.LocationPickerComponent), 
	        __metadata('design:type', Object)
	    ], EmployeesFilterSheetComponent.prototype, "locationPicker", void 0);
	    EmployeesFilterSheetComponent = __decorate([
	        core_1.Component({
	            selector: 'employees-filter-sheet',
	            template: __webpack_require__(802)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _c) || Object])
	    ], EmployeesFilterSheetComponent);
	    return EmployeesFilterSheetComponent;
	    var _a, _b, _c;
	}());
	exports.EmployeesFilterSheetComponent = EmployeesFilterSheetComponent;


/***/ },
/* 802 */
/***/ function(module, exports) {

	module.exports = "<sheet><div class=\"text-center m-b-15\"><bw-button-group [options]=\"dateOptions\" [activeOption]=\"activeOption\" type=\"danger\" (optionSelected)=\"onDateOptionSelected($event)\"></bw-button-group></div><div class=\"layout-row layout-padding\">       <text-box [fg]=\"fg\" [alt]=\"true\" field=\"filter\" leftIcon=\"search\" label=\"Filter employees\"></text-box></div><date-range [fg]=\"fg\" [hidden]=\"!showDateRange\"></date-range><div class=\"text-center c-white animated shake\" *ngIf=\"showDateRange &amp;&amp; !IsValidDateRange\"><i class=\"zmdi zmdi-info-outline m-r-10\"> </i>Invalid Range</div><location-picker [fg]=\"fg\" (filterReady)=\"locationPickerReady($event)\"></location-picker><div class=\"text-right m-b-10\"><bw-button title=\"Apply\" icon=\"check\" [simple]=\"true\" (click)=\"applyFilter($event)\"></bw-button></div></sheet>";

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(77);
	var employees_component_1 = __webpack_require__(671);
	var scores_1 = __webpack_require__(804);
	var salaries_1 = __webpack_require__(811);
	var employeesRoutes = [
	    {
	        path: 'employees',
	        component: employees_component_1.EmployeesComponent,
	        children: [
	            {
	                path: 'scores',
	                component: scores_1.ScoresComponent
	            },
	            {
	                path: 'salaries',
	                component: salaries_1.SalariesComponent
	            }
	        ]
	    }
	];
	exports.employeesRouting = router_1.RouterModule.forChild(employeesRoutes);


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(805));
	__export(__webpack_require__(808));


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var app_page_component_1 = __webpack_require__(618);
	var services_1 = __webpack_require__(796);
	var shared_1 = __webpack_require__(798);
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var forms_1 = __webpack_require__(27);
	var models_1 = __webpack_require__(137);
	var services_2 = __webpack_require__(274);
	var shared_2 = __webpack_require__(798);
	var ScoresComponent = (function (_super) {
	    __extends(ScoresComponent, _super);
	    function ScoresComponent(_employeesService, store, storeHelper, userService, _router) {
	        _super.call(this, store, storeHelper, userService);
	        this._employeesService = _employeesService;
	        this._router = _router;
	        this.fg = new forms_1.FormGroup({});
	        this.showScoreDetails = false;
	        this._searchAction = { id: 'search', icon: 'search' };
	        this._filterReady = false;
	        // set title and actions
	        this.headerTitle = 'Scores';
	        this.headerActions = [this._searchAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	    }
	    ScoresComponent.prototype.ngOnDestroy = function () {
	        this._preloaderSubs.unsubscribe();
	    };
	    ScoresComponent.prototype.onFilterChanged = function (filter) {
	        var _this = this;
	        this._employeesFilter = filter;
	        if (this._employeesFilter.locationsSelection.locations.length > 0) {
	            this._loadScores();
	        }
	        else {
	            this._resetScoreData();
	            this.empty = true;
	            setTimeout(function () { return _this.filterSheet.toggle(); }, 1500);
	            if (this._filterReady) {
	                this.filterSheet.toggle();
	            }
	            this._filterReady = true;
	        }
	    };
	    ScoresComponent.prototype.showInvoices = function (score) {
	        if (score.sales === 0) {
	            return;
	        }
	        var filter = new shared_1.EmployeeInvoicesFilter(this._employeesFilter, score.employee);
	        this.storeHelper.update('employeeInvoicesFilter', filter);
	        this.selectedEmployee = score.employee;
	        this.showScoreDetails = true;
	    };
	    ScoresComponent.prototype.coverClosed = function () {
	        this.showScoreDetails = false;
	        this.headerTitle = 'Scores';
	    };
	    ScoresComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._searchAction.id) {
	            this.filterSheet.toggle();
	        }
	    };
	    ScoresComponent.prototype._loadScores = function () {
	        var _this = this;
	        var that = this;
	        this.empty = false;
	        this.appPage.activatePreloader();
	        this.scores$ = this._employeesService.getScores(this._employeesFilter);
	        this._preloaderSubs = this.scores$.subscribe(function (res) {
	            that.appPage.deactivatePreloader();
	            _this.empty = res.length <= 0;
	            if (_this.empty) {
	                setTimeout(function () { return _this.filterSheet.toggle(); }, 1500);
	            }
	        });
	        if (this._filterReady) {
	            this.filterSheet.toggle();
	        }
	        this._filterReady = true;
	    };
	    ScoresComponent.prototype._resetScoreData = function () {
	        this.scores$.subscribe(function (i) { return i.splice(0); });
	    };
	    __decorate([
	        core_1.ViewChild(app_page_component_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], ScoresComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(shared_2.EmployeesFilterSheetComponent), 
	        __metadata('design:type', Object)
	    ], ScoresComponent.prototype, "filterSheet", void 0);
	    ScoresComponent = __decorate([
	        core_1.Component({
	            selector: 'my-scores',
	            template: __webpack_require__(806),
	            styles: [
	                __webpack_require__(807)
	            ],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.EmployeesService !== 'undefined' && services_1.EmployeesService) === 'function' && _a) || Object, (typeof (_b = typeof services_2.Store !== 'undefined' && services_2.Store) === 'function' && _b) || Object, (typeof (_c = typeof services_2.StoreHelper !== 'undefined' && services_2.StoreHelper) === 'function' && _c) || Object, (typeof (_d = typeof services_2.UserService !== 'undefined' && services_2.UserService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object])
	    ], ScoresComponent);
	    return ScoresComponent;
	    var _a, _b, _c, _d, _e;
	}(models_1.TopLevelComponent));
	exports.ScoresComponent = ScoresComponent;


/***/ },
/* 806 */
/***/ function(module, exports) {

	module.exports = "<app-page><employees-filter-sheet [fg]=\"fg\" (filterChanged)=\"onFilterChanged($event)\">  </employees-filter-sheet><paper-cover *ngIf=\"showScoreDetails\" [title]=\"selectedEmployee.name\" (closed)=\"coverClosed()\"><div class=\"layout-column layout-padding\"><score-invoices></score-invoices></div></paper-cover><div class=\"mobile-page-content h-100\"><div class=\"h-100\" [ngSwitch]=\"empty\"><user-feedback *ngSwitchCase=\"true\" type=\"info\" message=\"No Results Found\"></user-feedback><div *ngSwitchCase=\"false\"><div class=\"score master\" *ngFor=\"let score of scores$ | async\" (click)=\"showInvoices(score)\" [class.item-disabled]=\"score.sales === 0\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-account-o\"></i><div class=\"flex content\"><div class=\"title\">{{score.employee.name}}</div><small>{{score.location.name}}</small></div><div class=\"flex-nogrow results c-amber\" [class.negative-number]=\"score.salary &lt;= 0\">{{ score.salary | currency:'USD':true }}</div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">Sales</div><div class=\"flex text-right\">Avg Sale per hour</div><div class=\"flex text-right\">Commission                            </div></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ score.sales | currency:'USD':true }}</div><div class=\"flex text-right\">{{ score.averageSalaryPerHour | currency:'USD':true }}</div><div class=\"flex text-right\">{{ score.commission | currency:'USD':true }}</div></div></div></div></div></div></div></div></app-page>";

/***/ },
/* 807 */
/***/ function(module, exports) {

	module.exports = ".score{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.score.item-disabled{opacity:0.3}.score.master{padding-right:30px}.score.master::before{border-style:solid;border-width:0.1em 0.1em 0 0;content:'';display:inline-block;height:0.55em;width:0.55em;position:absolute;top:calc(50% - 10px);vertical-align:top;right:10px;transform:rotate(45deg)}.score::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.score .avatar{float:left;width:50px;font-size:38px}.score .content title{font-size:24px}.score .content small{color:#9e9e9e}.score .results{width:100px;text-align:right}.score .secondary{color:#9e9e9e;font-size:11px}\n"

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var page_preloader_component_1 = __webpack_require__(616);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var shared_1 = __webpack_require__(798);
	var services_2 = __webpack_require__(796);
	var ScoreInvoicesComponent = (function () {
	    function ScoreInvoicesComponent(_employeesService, store) {
	        this._employeesService = _employeesService;
	        this.scoreDetails = new shared_1.EmployeeScoreDetails(null);
	        var that = this;
	        var storeState = store.getState();
	        this._invoicesSubs = this._employeesService.getInvoices(storeState.employeeInvoicesFilter)
	            .subscribe(function (res) {
	            that.scoreDetails = res;
	            that.preloader.hide();
	        });
	    }
	    ScoreInvoicesComponent.prototype.ngOnInit = function () {
	        this.preloader.show();
	    };
	    ScoreInvoicesComponent.prototype.ngOnDestroy = function () {
	        this._invoicesSubs.unsubscribe();
	    };
	    __decorate([
	        core_1.ViewChild(page_preloader_component_1.PagePreloaderComponent), 
	        __metadata('design:type', Object)
	    ], ScoreInvoicesComponent.prototype, "preloader", void 0);
	    ScoreInvoicesComponent = __decorate([
	        core_1.Component({
	            selector: 'score-invoices',
	            styles: [__webpack_require__(809)],
	            template: __webpack_require__(810)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_2.EmployeesService !== 'undefined' && services_2.EmployeesService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _b) || Object])
	    ], ScoreInvoicesComponent);
	    return ScoreInvoicesComponent;
	    var _a, _b;
	}());
	exports.ScoreInvoicesComponent = ScoreInvoicesComponent;


/***/ },
/* 809 */
/***/ function(module, exports) {

	module.exports = ".score{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.score::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.score .content title{font-size:24px}.score .content small{color:#9e9e9e}.score .results{width:100px;text-align:right}.score .secondary{color:#9e9e9e;font-size:11px}.score .amount.sale{color:#8BC34A}.score .amount.refund{color:#E41736}\n"

/***/ },
/* 810 */
/***/ function(module, exports) {

	module.exports = "<page-preloader></page-preloader><div class=\"score\" *ngFor=\"let invoice of scoreDetails.invoices\"><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">{{invoice.timestamp}}</div><small><div>Invoice Number: {{invoice.invoiceId}} </div><div>{{invoice.location.name}}</div></small></div><div class=\"flex-nogrow results amount\" [class.sale]=\"invoice.afc &gt; 0\" [class.refund]=\"invoice.afc &lt;= 0\">{{ invoice.afc | currency:'USD':true }}</div></div></div>";

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(812));
	__export(__webpack_require__(814));
	__export(__webpack_require__(816));
	__export(__webpack_require__(818));


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var forms_1 = __webpack_require__(27);
	var core_1 = __webpack_require__(2);
	var shared_1 = __webpack_require__(594);
	var services_1 = __webpack_require__(274);
	var app_page_component_1 = __webpack_require__(618);
	var services_2 = __webpack_require__(796);
	var shared_2 = __webpack_require__(798);
	var ui_1 = __webpack_require__(799);
	var SalariesComponent = (function (_super) {
	    __extends(SalariesComponent, _super);
	    function SalariesComponent(_employeesService, store, storeHelper, userService) {
	        _super.call(this, store, storeHelper, userService);
	        this._employeesService = _employeesService;
	        this.fg = new forms_1.FormGroup({});
	        this._searchAction = { id: 'search', icon: 'search' };
	        this._filterReady = false;
	        this.headerTitle = 'Salaries';
	        this.headerActions = [this._searchAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	    }
	    SalariesComponent.prototype.onFilterChanged = function (filter) {
	        var _this = this;
	        this._employeesFilter = filter;
	        if (this._employeesFilter.locationsSelection.locations.length > 0) {
	            this._loadSalaries();
	        }
	        else {
	            this._resetSalariesData();
	            this.empty = true;
	            setTimeout(function () { return _this.filterSheet.toggle(); }, 1500);
	            if (this._filterReady) {
	                this.filterSheet.toggle();
	            }
	            this._filterReady = true;
	        }
	    };
	    SalariesComponent.prototype.showDetails = function (salary) {
	        if (salary.salary === 0) {
	            return;
	        }
	        var filter = new shared_2.EmployeeInvoicesFilter(this._employeesFilter, salary.employee);
	        this.storeHelper.update('employeeInvoicesFilter', filter);
	        this.selectedEmployee = salary.employee;
	        this.showSalaryDetails = true;
	    };
	    SalariesComponent.prototype.coverClosed = function () {
	        this.showSalaryDetails = false;
	        this.headerTitle = 'Salaries';
	    };
	    SalariesComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._searchAction.id) {
	            this.filterSheet.toggle();
	        }
	    };
	    SalariesComponent.prototype._loadSalaries = function () {
	        var _this = this;
	        var that = this;
	        this.empty = false;
	        this.appPage.activatePreloader();
	        this.salaries$ = this._employeesService.getSalaries(this._employeesFilter);
	        this._preloaderSubs = this.salaries$.subscribe(function (res) {
	            that.appPage.deactivatePreloader();
	            _this.empty = res.length <= 0;
	            if (_this.empty) {
	                setTimeout(function () { return _this.filterSheet.toggle(); }, 1500);
	            }
	        });
	        if (this._filterReady) {
	            this.filterSheet.toggle();
	        }
	        this._filterReady = true;
	    };
	    SalariesComponent.prototype._resetSalariesData = function () {
	        this.salaries$.subscribe(function (i) { return i.splice(0); });
	    };
	    __decorate([
	        core_1.ViewChild(app_page_component_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], SalariesComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.EmployeesFilterSheetComponent), 
	        __metadata('design:type', Object)
	    ], SalariesComponent.prototype, "filterSheet", void 0);
	    SalariesComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(813)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_2.EmployeesService !== 'undefined' && services_2.EmployeesService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _b) || Object, (typeof (_c = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _c) || Object, (typeof (_d = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _d) || Object])
	    ], SalariesComponent);
	    return SalariesComponent;
	    var _a, _b, _c, _d;
	}(shared_1.TopLevelComponent));
	exports.SalariesComponent = SalariesComponent;


/***/ },
/* 813 */
/***/ function(module, exports) {

	module.exports = "<app-page><employees-filter-sheet [fg]=\"fg\" (filterChanged)=\"onFilterChanged($event)\">  </employees-filter-sheet><paper-cover *ngIf=\"showSalaryDetails\" [title]=\"selectedEmployee.name\" (closed)=\"coverClosed()\"><salary-details></salary-details></paper-cover><div class=\"mobile-page-content\"><div class=\"h-100\" [ngSwitch]=\"empty\"><user-feedback *ngSwitchCase=\"true\" type=\"info\" message=\"No Results Found\"></user-feedback><div *ngSwitchCase=\"false\"><div class=\"list-item master with-avatar\" *ngFor=\"let salary of salaries$ | async\" (click)=\"showDetails(salary)\" [class.item-disabled]=\"salary.salary == 0\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-account-o\"></i><div class=\"flex content\"><div class=\"title\">{{salary.employee.name}}</div><small>{{salary.location.name}}</small></div><div class=\"flex-nogrow results c-amber\" [class.negative-number]=\"salary.salary &lt;= 0\">{{ salary.salary | currency:'USD':true }}</div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">Hourly Salary</div><div class=\"flex text-right\">Commission</div><div class=\"flex text-right\">Deductions</div><div class=\"flex text-right\">Reimbursements                            </div></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ salary.hourlySalary | currency:'USD':true }}</div><div class=\"flex text-right\">{{ salary.commission | currency:'USD':true }}</div><div class=\"flex text-right\">{{ salary.deductions | currency:'USD':true }}</div><div class=\"flex text-right\">{{ salary.reimbursements | currency:'USD':true }}</div></div></div></div><div class=\"separator\"></div></div></div></div></div></app-page>";

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var shared_1 = __webpack_require__(798);
	var ui_1 = __webpack_require__(132);
	var services_1 = __webpack_require__(274);
	var services_2 = __webpack_require__(796);
	var SalaryDetailsComponent = (function () {
	    function SalaryDetailsComponent(_employeesService, store) {
	        this._employeesService = _employeesService;
	        this.items = [
	            { id: 1, name: 'Salary', selected: true },
	            { id: 2, name: 'Sales' },
	            { id: 3, name: 'Commissions' },
	            { id: 4, name: 'Hourly Salary' },
	            { id: 5, name: 'Avg sales per hour' },
	            { id: 6, name: 'Deductions' },
	            { id: 7, name: 'Reimbursements' },
	        ];
	        this.salaryDetails = new shared_1.EmployeeSalaryDetails(null);
	        var that = this;
	        var storeState = store.getState();
	        this._salariesSubs = this._employeesService.getSalaryDetails(storeState.employeeInvoicesFilter)
	            .subscribe(function (res) {
	            that.salaryDetails = res[0];
	            that.preloader.hide();
	        });
	    }
	    SalaryDetailsComponent.prototype.ngOnInit = function () {
	        this.sectionSelected = this.items[0];
	    };
	    SalaryDetailsComponent.prototype.ngOnDestroy = function () {
	        this._salariesSubs.unsubscribe();
	    };
	    SalaryDetailsComponent.prototype.onItemClicked = function (item) {
	        this.sectionSelected = item;
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.PagePreloaderComponent), 
	        __metadata('design:type', Object)
	    ], SalaryDetailsComponent.prototype, "preloader", void 0);
	    SalaryDetailsComponent = __decorate([
	        core_1.Component({
	            selector: 'salary-details',
	            template: __webpack_require__(815)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_2.EmployeesService !== 'undefined' && services_2.EmployeesService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _b) || Object])
	    ], SalaryDetailsComponent);
	    return SalaryDetailsComponent;
	    var _a, _b;
	}());
	exports.SalaryDetailsComponent = SalaryDetailsComponent;


/***/ },
/* 815 */
/***/ function(module, exports) {

	module.exports = "<page-preloader></page-preloader><div class=\"layout-column h-100\"><div class=\"flex-nogrow m-t-20 m-b-15\"><horizontal-slider [items]=\"items\" (itemClicked)=\"onItemClicked($event)\"></horizontal-slider></div><div class=\"flex scrollable\"><div class=\"h-100\" [ngSwitch]=\"sectionSelected.id\"><timestamped-amounts *ngSwitchCase=\"1\" [amounts]=\"salaryDetails.totals\"></timestamped-amounts><timestamped-amounts *ngSwitchCase=\"2\" [amounts]=\"salaryDetails.sales\"></timestamped-amounts><timestamped-amounts *ngSwitchCase=\"3\" [amounts]=\"salaryDetails.commissions\"></timestamped-amounts><timestamped-amounts *ngSwitchCase=\"4\" [amounts]=\"salaryDetails.hourlySalaries\"></timestamped-amounts><salary-average *ngSwitchCase=\"5\" [averagePerHour]=\"salaryDetails.averagePerHour\"></salary-average><timestamped-amounts *ngSwitchCase=\"6\" [amounts]=\"salaryDetails.deductions\"></timestamped-amounts><timestamped-amounts *ngSwitchCase=\"7\" [amounts]=\"salaryDetails.reimbursements\"></timestamped-amounts></div></div></div>";

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var TimestampedAmountsComponent = (function () {
	    function TimestampedAmountsComponent() {
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], TimestampedAmountsComponent.prototype, "amounts", void 0);
	    TimestampedAmountsComponent = __decorate([
	        core_1.Component({
	            selector: 'timestamped-amounts',
	            template: __webpack_require__(817)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TimestampedAmountsComponent);
	    return TimestampedAmountsComponent;
	}());
	exports.TimestampedAmountsComponent = TimestampedAmountsComponent;


/***/ },
/* 817 */
/***/ function(module, exports) {

	module.exports = "<div class=\"layout-column layout-padding animated fadeIn\"><div class=\"list-item\" *ngFor=\"let item of amounts\"><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">{{item.timestamp | toLocalDate:'MM/DD/YYYY'}}</div></div><div class=\"flex-nogrow results c-green\" [class.negative-number]=\"item.amount &lt;= 0\">{{ item.amount | currency:'USD':true }}</div></div></div></div>";

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var SalaryAverageComponent = (function () {
	    function SalaryAverageComponent() {
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], SalaryAverageComponent.prototype, "averagePerHour", void 0);
	    SalaryAverageComponent = __decorate([
	        core_1.Component({
	            selector: 'salary-average',
	            styles: [" .average { font-size: 42px; margin-top: -220px } "],
	            template: __webpack_require__(819)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SalaryAverageComponent);
	    return SalaryAverageComponent;
	}());
	exports.SalaryAverageComponent = SalaryAverageComponent;


/***/ },
/* 819 */
/***/ function(module, exports) {

	module.exports = "<div class=\"animated fadeIn h-100\">   <div class=\"layout-column layout-align-center-center h-100\"><div class=\"flex-nogrow average c-amber\">{{ averagePerHour | currency:'USD':true }}</div></div></div>";

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var refunds_filter_sheet_1 = __webpack_require__(821);
	var accounting_service_1 = __webpack_require__(841);
	var core_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(23);
	var accounting_routing_1 = __webpack_require__(842);
	var shared_module_1 = __webpack_require__(26);
	var shared_1 = __webpack_require__(844);
	var shared_2 = __webpack_require__(844);
	var ng2_material_components_1 = __webpack_require__(33);
	var accounting_component_1 = __webpack_require__(672);
	var profit_loss_1 = __webpack_require__(873);
	var payment_1 = __webpack_require__(870);
	var payment_details_1 = __webpack_require__(876);
	var shared_3 = __webpack_require__(844);
	var ng2_charts_1 = __webpack_require__(31);
	var profit_1 = __webpack_require__(880);
	var profit_summary_1 = __webpack_require__(883);
	var profit_location_1 = __webpack_require__(887);
	var profit_product_1 = __webpack_require__(891);
	var profit_employee_1 = __webpack_require__(895);
	var shared_4 = __webpack_require__(844);
	var loss_1 = __webpack_require__(899);
	var loss_summary_1 = __webpack_require__(902);
	var loss_category_1 = __webpack_require__(906);
	var loss_cost_1 = __webpack_require__(910);
	var loss_inventory_1 = __webpack_require__(914);
	var loss_payroll_1 = __webpack_require__(918);
	var accounting_refunds_component_1 = __webpack_require__(843);
	var shared_5 = __webpack_require__(844);
	var shared_6 = __webpack_require__(844);
	var AccountingModule = (function () {
	    function AccountingModule() {
	    }
	    AccountingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                ng2_material_components_1.MaterialFormsModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                accounting_routing_1.accountingRouting,
	                shared_module_1.SharedModule,
	                ng2_charts_1.ChartsModule
	            ],
	            exports: [
	                accounting_component_1.AccountingComponent,
	                payment_1.PaymentIndexComponent,
	                payment_details_1.PaymentDetailsComponent,
	                shared_1.PaymentsFilterSheetComponent,
	                profit_loss_1.ProfitLossIndexComponent,
	                profit_1.ProfitIndexComponent,
	                profit_summary_1.ProfitSummaryComponent,
	                profit_location_1.ProfitLocationComponent,
	                profit_product_1.ProfitProductComponent,
	                profit_employee_1.ProfitEmployeeComponent,
	                loss_1.LossIndexComponent,
	                loss_summary_1.LossSummaryComponent,
	                loss_category_1.LossCategoryComponent,
	                loss_cost_1.LossCostComponent,
	                loss_inventory_1.LossInventoryComponent,
	                loss_payroll_1.LossPayrollComponent,
	                shared_2.ProfitLossFilterSheetComponent,
	                accounting_refunds_component_1.AccountingRefundsComponent,
	                refunds_filter_sheet_1.RefundsFilterSheetComponent,
	                shared_6.PieChartComponent,
	                shared_6.BarChartComponent
	            ],
	            declarations: [
	                accounting_component_1.AccountingComponent,
	                payment_1.PaymentIndexComponent,
	                payment_details_1.PaymentDetailsComponent,
	                shared_1.PaymentsFilterSheetComponent,
	                profit_loss_1.ProfitLossIndexComponent,
	                profit_1.ProfitIndexComponent,
	                profit_summary_1.ProfitSummaryComponent,
	                profit_location_1.ProfitLocationComponent,
	                profit_product_1.ProfitProductComponent,
	                profit_employee_1.ProfitEmployeeComponent,
	                loss_1.LossIndexComponent,
	                loss_summary_1.LossSummaryComponent,
	                loss_category_1.LossCategoryComponent,
	                loss_cost_1.LossCostComponent,
	                loss_inventory_1.LossInventoryComponent,
	                loss_payroll_1.LossPayrollComponent,
	                shared_2.ProfitLossFilterSheetComponent,
	                accounting_refunds_component_1.AccountingRefundsComponent,
	                refunds_filter_sheet_1.RefundsFilterSheetComponent,
	                shared_6.PieChartComponent,
	                shared_6.BarChartComponent
	            ],
	            providers: [
	                shared_3.PaymentMethodSummaryService,
	                shared_4.ProfitSummaryService,
	                shared_4.ProfitLocationSaleService,
	                shared_4.ProfitProductSaleService,
	                shared_4.ProfitEmployeeSaleService,
	                shared_5.LossExpenseCategoryService,
	                shared_5.LossCostSaleService,
	                shared_5.LossInventoryLossesService,
	                shared_5.LossPayrollService,
	                accounting_service_1.AccountingService
	            ],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AccountingModule);
	    return AccountingModule;
	}());
	exports.AccountingModule = AccountingModule;


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(822));


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var models_1 = __webpack_require__(137);
	var services_1 = __webpack_require__(274);
	var ui_1 = __webpack_require__(132);
	var forms_1 = __webpack_require__(27);
	var models_2 = __webpack_require__(823);
	var RefundsFilterSheetComponent = (function () {
	    function RefundsFilterSheetComponent(_userSvc) {
	        this._userSvc = _userSvc;
	        this.filterChanged = new core_1.EventEmitter();
	        this.dateOptions = ['Today', 'Custom Range'];
	        this.activeOption = this.dateOptions[0];
	    }
	    RefundsFilterSheetComponent.prototype.locationPickerReady = function () {
	        this.applyFilter(null);
	    };
	    RefundsFilterSheetComponent.prototype.toggle = function () {
	        this.sheet.toggle();
	    };
	    RefundsFilterSheetComponent.prototype.onDateOptionSelected = function (option) {
	        this.showDateRange = option === 'Custom Range';
	    };
	    RefundsFilterSheetComponent.prototype.applyFilter = function (e) {
	        var _this = this;
	        if (e) {
	            e.preventDefault();
	        }
	        var value = this.fg.value;
	        var dateRange = this.showDateRange ?
	            new models_1.DateRange(value.from, value.to)
	            : new models_1.DateRange();
	        this.IsValidDateRange = dateRange.isValid;
	        if (this.IsValidDateRange) {
	            var locationsPickerSelection = this.locationPicker.getSelection();
	            var filter_1 = new models_2.AccountingRefundFilter(dateRange, locationsPickerSelection);
	            setTimeout(function () { return _this.filterChanged.emit(filter_1); }, 10);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
	    ], RefundsFilterSheetComponent.prototype, "fg", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof models_2.AccountingRefundFilter !== 'undefined' && models_2.AccountingRefundFilter) === 'function' && _b) || Object)
	    ], RefundsFilterSheetComponent.prototype, "filter", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], RefundsFilterSheetComponent.prototype, "filterChanged", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.SheetComponent), 
	        __metadata('design:type', Object)
	    ], RefundsFilterSheetComponent.prototype, "sheet", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.LocationPickerComponent), 
	        __metadata('design:type', Object)
	    ], RefundsFilterSheetComponent.prototype, "locationPicker", void 0);
	    RefundsFilterSheetComponent = __decorate([
	        core_1.Component({
	            selector: 'refunds-filter-sheet',
	            template: __webpack_require__(840)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _c) || Object])
	    ], RefundsFilterSheetComponent);
	    return RefundsFilterSheetComponent;
	    var _a, _b, _c;
	}());
	exports.RefundsFilterSheetComponent = RefundsFilterSheetComponent;


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(824));
	__export(__webpack_require__(825));
	__export(__webpack_require__(826));
	__export(__webpack_require__(827));
	__export(__webpack_require__(828));
	__export(__webpack_require__(829));
	__export(__webpack_require__(830));
	__export(__webpack_require__(831));
	__export(__webpack_require__(832));
	__export(__webpack_require__(833));
	__export(__webpack_require__(834));
	__export(__webpack_require__(835));
	__export(__webpack_require__(836));
	__export(__webpack_require__(837));
	__export(__webpack_require__(838));
	__export(__webpack_require__(839));


/***/ },
/* 824 */
/***/ function(module, exports) {

	"use strict";
	var PaymentMethod = (function () {
	    function PaymentMethod(paymentMethod) {
	        Object.assign(this, paymentMethod);
	    }
	    return PaymentMethod;
	}());
	exports.PaymentMethod = PaymentMethod;


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var PaymentsFilter = (function () {
	    function PaymentsFilter(date, locationsSelection) {
	        this.date = date;
	        this.locationsSelection = locationsSelection;
	    }
	    PaymentsFilter.prototype.toQueryString = function () {
	        this.locationsSelection = this.locationsSelection || new models_1.LocationPickerSelection();
	        if (this.locationsSelection !== null && this.locationsSelection !== undefined) {
	            return this.date.toQueryString() + "&" + this.locationsSelection.toQueryString();
	        }
	    };
	    return PaymentsFilter;
	}());
	exports.PaymentsFilter = PaymentsFilter;


/***/ },
/* 826 */
/***/ function(module, exports) {

	"use strict";
	var PaymentMethodSummary = (function () {
	    function PaymentMethodSummary(paymentMethod) {
	        this.paymentMethod = paymentMethod;
	        this.totalCash = 0;
	        this.totalExternalCredit = 0;
	        this.totalCreditCards = 0;
	        this.totalChecks = 0;
	        this.externalArray = ['amex', 'visa', 'mastercard', 'discover', 'other'];
	        this._CalculateTotals();
	    }
	    PaymentMethodSummary.prototype._CalculateTotals = function () {
	        var _this = this;
	        this.paymentMethod.forEach(function (element) {
	            var method = element.name.toLowerCase();
	            if (method === 'cash') {
	                _this.totalCash += element.amount;
	            }
	            else if (_this.externalArray.indexOf(method) !== -1) {
	                _this.totalExternalCredit += element.amount;
	            }
	            else if (method.indexOf('check') !== -1) {
	                _this.totalChecks += element.amount;
	            }
	            else {
	                _this.totalCreditCards += element.amount;
	            }
	        });
	    };
	    return PaymentMethodSummary;
	}());
	exports.PaymentMethodSummary = PaymentMethodSummary;


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var ProfitLossFilter = (function () {
	    function ProfitLossFilter(optionSelected, date, locationsSelection) {
	        this.optionSelected = optionSelected;
	        this.date = date;
	        this.locationsSelection = locationsSelection;
	    }
	    ProfitLossFilter.prototype.toQueryString = function () {
	        this.locationsSelection = this.locationsSelection || new models_1.LocationPickerSelection();
	        if (this.locationsSelection !== null && this.locationsSelection !== undefined) {
	            return this.date.toQueryString() + "&" + this.locationsSelection.toQueryString();
	        }
	    };
	    return ProfitLossFilter;
	}());
	exports.ProfitLossFilter = ProfitLossFilter;


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var ProfitLossExpenseFilter = (function () {
	    function ProfitLossExpenseFilter(date, locationsSelection) {
	        this.date = date;
	        this.locationsSelection = locationsSelection;
	    }
	    ProfitLossExpenseFilter.prototype.toQueryString = function () {
	        this.locationsSelection = this.locationsSelection || new models_1.LocationPickerSelection();
	        if (this.locationsSelection !== null && this.locationsSelection !== undefined) {
	            if (this.locationsSelection.region !== undefined) {
	                return this.date.toQueryString() + "&regions=" + this.locationsSelection.region.id;
	            }
	            return "" + this.date.toQueryString();
	        }
	    };
	    return ProfitLossExpenseFilter;
	}());
	exports.ProfitLossExpenseFilter = ProfitLossExpenseFilter;


/***/ },
/* 829 */
/***/ function(module, exports) {

	"use strict";
	var ProfitSummary = (function () {
	    function ProfitSummary(ProfitSummary) {
	        Object.assign(this, ProfitSummary);
	    }
	    ProfitSummary.prototype.UpdateNetProfit = function () {
	        this.netProfit = (this.net * this.margin) / 100;
	    };
	    return ProfitSummary;
	}());
	exports.ProfitSummary = ProfitSummary;


/***/ },
/* 830 */
/***/ function(module, exports) {

	"use strict";
	var ProfitLocationSale = (function () {
	    function ProfitLocationSale(profitLocationSale) {
	        Object.assign(this, profitLocationSale);
	    }
	    return ProfitLocationSale;
	}());
	exports.ProfitLocationSale = ProfitLocationSale;


/***/ },
/* 831 */
/***/ function(module, exports) {

	"use strict";
	var ProfitProductSale = (function () {
	    function ProfitProductSale(pName, pQuantity, pSubTotal, pTax) {
	        this.name = pName;
	        this.quantity = pQuantity;
	        this.subTotal = pSubTotal;
	        this.tax = pTax;
	        this.total = this.subTotal + this.tax;
	    }
	    return ProfitProductSale;
	}());
	exports.ProfitProductSale = ProfitProductSale;


/***/ },
/* 832 */
/***/ function(module, exports) {

	"use strict";
	var ProfitEmployeeSale = (function () {
	    function ProfitEmployeeSale(pName, pAfc) {
	        this.name = pName;
	        this.afc = pAfc;
	    }
	    return ProfitEmployeeSale;
	}());
	exports.ProfitEmployeeSale = ProfitEmployeeSale;


/***/ },
/* 833 */
/***/ function(module, exports) {

	"use strict";
	var LossCostSale = (function () {
	    function LossCostSale(pName, pCost) {
	        this.name = pName;
	        this.cost = pCost;
	    }
	    return LossCostSale;
	}());
	exports.LossCostSale = LossCostSale;


/***/ },
/* 834 */
/***/ function(module, exports) {

	"use strict";
	var LossInventoryLosses = (function () {
	    function LossInventoryLosses(LossInventoryLosses) {
	        Object.assign(this, LossInventoryLosses);
	    }
	    return LossInventoryLosses;
	}());
	exports.LossInventoryLosses = LossInventoryLosses;


/***/ },
/* 835 */
/***/ function(module, exports) {

	"use strict";
	var LossPayroll = (function () {
	    function LossPayroll(pName, pSalary) {
	        this.name = pName;
	        this.salary = pSalary;
	    }
	    return LossPayroll;
	}());
	exports.LossPayroll = LossPayroll;


/***/ },
/* 836 */
/***/ function(module, exports) {

	"use strict";
	var LossExpenseCategory = (function () {
	    function LossExpenseCategory(LossExpenseCategory) {
	        Object.assign(this, LossExpenseCategory);
	    }
	    return LossExpenseCategory;
	}());
	exports.LossExpenseCategory = LossExpenseCategory;


/***/ },
/* 837 */
/***/ function(module, exports) {

	"use strict";
	var LossSummary = (function () {
	    function LossSummary(pExpenses, pCostGoods, pInventory, pSalary) {
	        this.totalInventory = pInventory;
	        this.totalSalaries = pSalary;
	        this.totalOthers = pExpenses + pCostGoods;
	        this.total = this.totalInventory + this.totalSalaries + this.totalOthers;
	    }
	    return LossSummary;
	}());
	exports.LossSummary = LossSummary;


/***/ },
/* 838 */
/***/ function(module, exports) {

	"use strict";
	var RefundPair = (function () {
	    function RefundPair() {
	    }
	    return RefundPair;
	}());
	exports.RefundPair = RefundPair;
	var InvoicePair = (function () {
	    function InvoicePair() {
	    }
	    return InvoicePair;
	}());
	exports.InvoicePair = InvoicePair;
	var AccountingRefund = (function () {
	    function AccountingRefund(model) {
	        Object.assign(this, model);
	    }
	    return AccountingRefund;
	}());
	exports.AccountingRefund = AccountingRefund;


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var AccountingRefundFilter = (function () {
	    function AccountingRefundFilter(date, locationsSelection) {
	        this.date = date;
	        this.locationsSelection = locationsSelection;
	        this.size = 50;
	        this.page = 1;
	    }
	    AccountingRefundFilter.prototype.toQueryString = function () {
	        this.locationsSelection = this.locationsSelection || new models_1.LocationPickerSelection();
	        return this.date.toQueryString() + "&" + this.locationsSelection.toQueryString() + "&page=" + this.page + "&size=" + this.size;
	    };
	    return AccountingRefundFilter;
	}());
	exports.AccountingRefundFilter = AccountingRefundFilter;


/***/ },
/* 840 */
669,
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(823);
	var AccountingService = (function () {
	    function AccountingService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._accounting = this.configService.getContext('accounting');
	    }
	    AccountingService.prototype.getRefundsReport = function (filter) {
	        return this._api.get(this._accounting.url, 'invoices/refunds', filter)
	            .map(function (report) {
	            return report.data.map(function (r) { return new models_1.AccountingRefund(r); });
	        })
	            .cache();
	    };
	    AccountingService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], AccountingService);
	    return AccountingService;
	    var _a, _b;
	}());
	exports.AccountingService = AccountingService;


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var accounting_refunds_component_1 = __webpack_require__(843);
	var router_1 = __webpack_require__(77);
	var accounting_component_1 = __webpack_require__(672);
	var payment_1 = __webpack_require__(870);
	var profit_loss_1 = __webpack_require__(873);
	var accountingRoutes = [
	    {
	        path: 'accounting',
	        component: accounting_component_1.AccountingComponent,
	        children: [
	            {
	                path: 'profit-loss',
	                component: profit_loss_1.ProfitLossIndexComponent
	            },
	            {
	                path: 'payment',
	                component: payment_1.PaymentIndexComponent
	            },
	            {
	                path: 'refunds',
	                component: accounting_refunds_component_1.AccountingRefundsComponent
	            }
	        ]
	    }
	];
	exports.accountingRouting = router_1.RouterModule.forChild(accountingRoutes);


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var refunds_filter_sheet_component_1 = __webpack_require__(822);
	var core_1 = __webpack_require__(2);
	var ui_1 = __webpack_require__(132);
	var shared_1 = __webpack_require__(844);
	var forms_1 = __webpack_require__(27);
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var AccountingRefundsComponent = (function (_super) {
	    __extends(AccountingRefundsComponent, _super);
	    function AccountingRefundsComponent(_accountingRefundsService, store, storeHelper, userService) {
	        _super.call(this, store, storeHelper, userService);
	        this._accountingRefundsService = _accountingRefundsService;
	        this.fg = new forms_1.FormGroup({});
	        this.refunds = [];
	        this._searchAction = { id: 'search', icon: 'search' };
	        this._filterReady = false;
	        this.empty = false;
	        // set title and actions
	        this.headerTitle = 'Refunds';
	        this.headerActions = [this._searchAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	    }
	    AccountingRefundsComponent.prototype.ngOnDestroy = function () {
	        this._refundsSub.unsubscribe();
	    };
	    AccountingRefundsComponent.prototype.onFilterChanged = function (filter) {
	        var _this = this;
	        this._refundsFilter = filter;
	        if (this._refundsFilter.locationsSelection.locations.length > 0) {
	            this._loadRefundsReport();
	        }
	        else {
	            this._resetRefundsData();
	            this.empty = true;
	            setTimeout(function () { return _this.filterSheet.toggle(); }, 1500);
	            if (this._filterReady) {
	                this.filterSheet.toggle();
	            }
	            this._filterReady = true;
	        }
	    };
	    AccountingRefundsComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._searchAction.id) {
	            this.filterSheet.toggle();
	        }
	    };
	    AccountingRefundsComponent.prototype._loadRefundsReport = function () {
	        var _this = this;
	        var that = this;
	        this.empty = false;
	        this.appPage.activatePreloader();
	        this._refundsSub = this._accountingRefundsService.getRefundsReport(this._refundsFilter)
	            .subscribe(function (refunds) {
	            that.refunds = refunds;
	            that.appPage.deactivatePreloader();
	            _this.empty = refunds.length <= 0;
	            if (_this.empty) {
	                setTimeout(function () { return _this.filterSheet.toggle(); }, 1500);
	            }
	        });
	        if (this._filterReady) {
	            this.filterSheet.toggle();
	        }
	        this._filterReady = true;
	    };
	    AccountingRefundsComponent.prototype._resetRefundsData = function () {
	        this.refunds = [];
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], AccountingRefundsComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(refunds_filter_sheet_component_1.RefundsFilterSheetComponent), 
	        __metadata('design:type', Object)
	    ], AccountingRefundsComponent.prototype, "filterSheet", void 0);
	    AccountingRefundsComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(868),
	            styles: [
	                __webpack_require__(869)
	            ],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof shared_1.AccountingService !== 'undefined' && shared_1.AccountingService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _b) || Object, (typeof (_c = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _c) || Object, (typeof (_d = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _d) || Object])
	    ], AccountingRefundsComponent);
	    return AccountingRefundsComponent;
	    var _a, _b, _c, _d;
	}(models_1.TopLevelComponent));
	exports.AccountingRefundsComponent = AccountingRefundsComponent;


/***/ },
/* 844 */
[1081, 823, 845, 855],
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(846));
	__export(__webpack_require__(847));
	__export(__webpack_require__(848));
	__export(__webpack_require__(849));
	__export(__webpack_require__(850));
	__export(__webpack_require__(851));
	__export(__webpack_require__(852));
	__export(__webpack_require__(853));
	__export(__webpack_require__(854));
	__export(__webpack_require__(841));


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(823);
	var PaymentMethodSummaryService = (function () {
	    function PaymentMethodSummaryService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    PaymentMethodSummaryService.prototype.getPaymentMethodSummary = function (filter) {
	        return this._api.get(this._bi.url, 'reporting/payments/methods', filter)
	            .map(function (payments) { return payments.map(function (payment) { return new models_1.PaymentMethod(payment); }); })
	            .cache();
	    };
	    PaymentMethodSummaryService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], PaymentMethodSummaryService);
	    return PaymentMethodSummaryService;
	    var _a, _b;
	}());
	exports.PaymentMethodSummaryService = PaymentMethodSummaryService;


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(823);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var ProfitSummaryService = (function () {
	    function ProfitSummaryService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    ProfitSummaryService.prototype.getProfitSummary = function (filter) {
	        return this._api.get(this._bi.url, 'managerial/income/summary', filter)
	            .map(function (summary) { return new models_1.ProfitSummary(summary); })
	            .cache();
	    };
	    ProfitSummaryService.prototype.getProfitMargin = function (filter) {
	        return this._api.get(this._bi.url, 'reporting/profit/summary', filter)
	            .map(function (obj) { return obj.margin; })
	            .cache();
	    };
	    ProfitSummaryService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], ProfitSummaryService);
	    return ProfitSummaryService;
	    var _a, _b;
	}());
	exports.ProfitSummaryService = ProfitSummaryService;


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(823);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var ProfitLocationSaleService = (function () {
	    function ProfitLocationSaleService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    ProfitLocationSaleService.prototype.getLocationSales = function (filter) {
	        return this._api.get(this._bi.url, 'reporting/mobile/sales/locations', filter)
	            .map(function (sales) { return sales.map(function (sale) { return new models_1.ProfitLocationSale(sale); }); })
	            .cache();
	    };
	    ProfitLocationSaleService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], ProfitLocationSaleService);
	    return ProfitLocationSaleService;
	    var _a, _b;
	}());
	exports.ProfitLocationSaleService = ProfitLocationSaleService;


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(823);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var ProfitProductSaleService = (function () {
	    function ProfitProductSaleService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    ProfitProductSaleService.prototype.getProductSaleList = function (filter) {
	        return this._api.get(this._bi.url, 'inventory/sold', filter)
	            .map(function (productsales) { return productsales.map(function (sale) { return new models_1.ProfitProductSale(sale.product.name, sale.quantity, sale.subtotal, sale.tax); }); })
	            .cache();
	    };
	    ProfitProductSaleService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], ProfitProductSaleService);
	    return ProfitProductSaleService;
	    var _a, _b;
	}());
	exports.ProfitProductSaleService = ProfitProductSaleService;


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(823);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var ProfitEmployeeSaleService = (function () {
	    function ProfitEmployeeSaleService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    ProfitEmployeeSaleService.prototype.getEmployeeSaleList = function (filter) {
	        return this._api.get(this._bi.url, 'employees/sales', filter)
	            .map(function (employeesales) { return employeesales.data.map(function (sale) { return new models_1.ProfitEmployeeSale(sale.employee.name, sale.afc); }); })
	            .cache();
	    };
	    ProfitEmployeeSaleService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], ProfitEmployeeSaleService);
	    return ProfitEmployeeSaleService;
	    var _a, _b;
	}());
	exports.ProfitEmployeeSaleService = ProfitEmployeeSaleService;


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(823);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var LossCostSaleService = (function () {
	    function LossCostSaleService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    LossCostSaleService.prototype.getProductCostSaleList = function (filter) {
	        return this._api.get(this._bi.url, 'inventory/sold', filter)
	            .map(function (costSales) { return costSales.map(function (sale) { return new models_1.LossCostSale(sale.product.name, sale.cost); }); })
	            .cache();
	    };
	    LossCostSaleService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], LossCostSaleService);
	    return LossCostSaleService;
	    var _a, _b;
	}());
	exports.LossCostSaleService = LossCostSaleService;


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(823);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var LossInventoryLossesService = (function () {
	    function LossInventoryLossesService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    LossInventoryLossesService.prototype.getProductCostSaleList = function (filter) {
	        return this._api.get(this._bi.url, 'inventory/losses', filter)
	            .map(function (inventorySales) { return inventorySales.map(function (inv) { return new models_1.LossInventoryLosses(inv); }); })
	            .cache();
	    };
	    LossInventoryLossesService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], LossInventoryLossesService);
	    return LossInventoryLossesService;
	    var _a, _b;
	}());
	exports.LossInventoryLossesService = LossInventoryLossesService;


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(823);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var LossPayrollService = (function () {
	    function LossPayrollService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    LossPayrollService.prototype.getEmployeePayrollsList = function (filter) {
	        return this._api.get(this._bi.url, 'employees/salary', filter)
	            .map(function (employeeSales) { return employeeSales.map(function (emp) { return new models_1.LossPayroll(emp.employee.name, emp.salary); }); })
	            .cache();
	    };
	    LossPayrollService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], LossPayrollService);
	    return LossPayrollService;
	    var _a, _b;
	}());
	exports.LossPayrollService = LossPayrollService;


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(823);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var LossExpenseCategoryService = (function () {
	    function LossExpenseCategoryService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    LossExpenseCategoryService.prototype.getExpensesByCategoryList = function (filter) {
	        return this._api.get(this._bi.url, 'managerial/expenses', filter)
	            .map(function (expenses) { return expenses.map(function (exp) { return new models_1.LossExpenseCategory(exp); }); })
	            .cache();
	    };
	    LossExpenseCategoryService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], LossExpenseCategoryService);
	    return LossExpenseCategoryService;
	    var _a, _b;
	}());
	exports.LossExpenseCategoryService = LossExpenseCategoryService;


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(856));
	__export(__webpack_require__(859));
	__export(__webpack_require__(862));
	__export(__webpack_require__(865));
	__export(__webpack_require__(821));


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(857));


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var models_1 = __webpack_require__(137);
	var services_1 = __webpack_require__(274);
	var ui_1 = __webpack_require__(132);
	var forms_1 = __webpack_require__(27);
	var models_2 = __webpack_require__(823);
	var PaymentsFilterSheetComponent = (function () {
	    function PaymentsFilterSheetComponent(_userSvc) {
	        this._userSvc = _userSvc;
	        this.filterChanged = new core_1.EventEmitter();
	        this.dateOptions = ['Today', 'Custom Range'];
	        this.activeOption = this.dateOptions[0];
	    }
	    PaymentsFilterSheetComponent.prototype.locationPickerReady = function () {
	        this.applyFilter(null);
	    };
	    PaymentsFilterSheetComponent.prototype.toggle = function () {
	        this.sheet.toggle();
	    };
	    PaymentsFilterSheetComponent.prototype.onDateOptionSelected = function (option) {
	        this.showDateRange = option === 'Custom Range';
	    };
	    PaymentsFilterSheetComponent.prototype.applyFilter = function (e) {
	        var _this = this;
	        if (e) {
	            e.preventDefault();
	        }
	        var value = this.fg.value;
	        var dateRange = this.showDateRange ?
	            new models_1.DateRange(value.from, value.to)
	            : new models_1.DateRange();
	        this.IsValidDateRange = dateRange.isValid;
	        if (this.IsValidDateRange) {
	            var locationsPickerSelection = this.locationPicker.getSelection();
	            var filter_1 = new models_2.PaymentsFilter(dateRange, locationsPickerSelection);
	            setTimeout(function () { return _this.filterChanged.emit(filter_1); }, 10);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
	    ], PaymentsFilterSheetComponent.prototype, "fg", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof models_2.PaymentsFilter !== 'undefined' && models_2.PaymentsFilter) === 'function' && _b) || Object)
	    ], PaymentsFilterSheetComponent.prototype, "filter", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], PaymentsFilterSheetComponent.prototype, "filterChanged", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.SheetComponent), 
	        __metadata('design:type', Object)
	    ], PaymentsFilterSheetComponent.prototype, "sheet", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.LocationPickerComponent), 
	        __metadata('design:type', Object)
	    ], PaymentsFilterSheetComponent.prototype, "locationPicker", void 0);
	    PaymentsFilterSheetComponent = __decorate([
	        core_1.Component({
	            selector: 'payments-filter-sheet',
	            template: __webpack_require__(858)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _c) || Object])
	    ], PaymentsFilterSheetComponent);
	    return PaymentsFilterSheetComponent;
	    var _a, _b, _c;
	}());
	exports.PaymentsFilterSheetComponent = PaymentsFilterSheetComponent;


/***/ },
/* 858 */
669,
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(860));


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var ui_1 = __webpack_require__(132);
	var models_1 = __webpack_require__(823);
	var models_2 = __webpack_require__(137);
	var ProfitLossFilterSheetComponent = (function () {
	    function ProfitLossFilterSheetComponent() {
	        this.filterChanged = new core_1.EventEmitter();
	        this.options = ['Profits', 'Loss'];
	        this.optionSelected = 'Profits';
	        this.activeOption = this.options[0];
	    }
	    ProfitLossFilterSheetComponent.prototype.locationPickerReady = function () {
	        this.applyFilter(null);
	    };
	    ProfitLossFilterSheetComponent.prototype.toggle = function () {
	        this.sheet.toggle();
	    };
	    ProfitLossFilterSheetComponent.prototype.onOptionSelected = function (option) {
	        this.optionSelected = option;
	    };
	    ProfitLossFilterSheetComponent.prototype.applyFilter = function (e) {
	        var _this = this;
	        if (e) {
	            e.preventDefault();
	        }
	        var value = this.fg.value;
	        var dateRange = new models_2.DateRange(value.from, value.to);
	        this.IsValidDateRange = dateRange.isValid;
	        if (this.IsValidDateRange) {
	            var locationsPickerSelection = this.locationPicker.getSelection();
	            var filter_1 = new models_1.ProfitLossFilter(this.optionSelected, dateRange, locationsPickerSelection);
	            setTimeout(function () { return _this.filterChanged.emit(filter_1); }, 10);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
	    ], ProfitLossFilterSheetComponent.prototype, "fg", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof models_1.ProfitLossFilter !== 'undefined' && models_1.ProfitLossFilter) === 'function' && _b) || Object)
	    ], ProfitLossFilterSheetComponent.prototype, "filter", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], ProfitLossFilterSheetComponent.prototype, "filterChanged", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.SheetComponent), 
	        __metadata('design:type', Object)
	    ], ProfitLossFilterSheetComponent.prototype, "sheet", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.LocationPickerComponent), 
	        __metadata('design:type', Object)
	    ], ProfitLossFilterSheetComponent.prototype, "locationPicker", void 0);
	    ProfitLossFilterSheetComponent = __decorate([
	        core_1.Component({
	            selector: 'profit-loss-filter-sheet',
	            template: __webpack_require__(861)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ProfitLossFilterSheetComponent);
	    return ProfitLossFilterSheetComponent;
	    var _a, _b;
	}());
	exports.ProfitLossFilterSheetComponent = ProfitLossFilterSheetComponent;


/***/ },
/* 861 */
/***/ function(module, exports) {

	module.exports = "<sheet><div class=\"text-center\"><bw-button-group [options]=\"options\" [activeOption]=\"activeOption\" type=\"danger\" (optionSelected)=\"onOptionSelected($event)\"></bw-button-group></div><date-range [fg]=\"fg\"></date-range><div class=\"text-center c-white animated shake\" *ngIf=\"!IsValidDateRange\"><i class=\"zmdi zmdi-info-outline m-r-10\"> </i>Invalid Range</div><location-picker [fg]=\"fg\" (filterReady)=\"locationPickerReady($event)\"></location-picker><div class=\"text-right m-b-10\"><bw-button title=\"Apply\" icon=\"check\" [simple]=\"true\" (click)=\"applyFilter($event)\"></bw-button></div></sheet>";

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(863));


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var PieChartComponent = (function () {
	    function PieChartComponent() {
	        this.pieChartType = 'pie';
	        this.pieChartOptions = {
	            responsive: true,
	            legend: {
	                display: false,
	                position: 'left'
	            }
	        };
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], PieChartComponent.prototype, "pieChartLabels", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], PieChartComponent.prototype, "pieChartData", void 0);
	    PieChartComponent = __decorate([
	        core_1.Component({
	            selector: 'my-pie-chart',
	            template: __webpack_require__(864)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PieChartComponent);
	    return PieChartComponent;
	}());
	exports.PieChartComponent = PieChartComponent;


/***/ },
/* 864 */
/***/ function(module, exports) {

	module.exports = "<base-chart class=\"m-t-20 m-b-25 char\" [data]=\"pieChartData\" [labels]=\"pieChartLabels\" [chartType]=\"pieChartType\" [options]=\"pieChartOptions\"></base-chart>";

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(866));


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var BarChartComponent = (function () {
	    function BarChartComponent() {
	        this.barChartType = 'bar';
	        this.barChartOptions = {
	            scaleShowVerticalLines: false,
	            legend: {
	                display: false
	            }
	        };
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BarChartComponent.prototype, "barChartLabels", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], BarChartComponent.prototype, "barChartData", void 0);
	    BarChartComponent = __decorate([
	        core_1.Component({
	            selector: 'my-bar-chart',
	            template: __webpack_require__(867)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BarChartComponent);
	    return BarChartComponent;
	}());
	exports.BarChartComponent = BarChartComponent;


/***/ },
/* 867 */
/***/ function(module, exports) {

	module.exports = "<base-chart class=\"m-t-20 m-b-25 char\" [datasets]=\"barChartData\" [labels]=\"barChartLabels\" [chartType]=\"barChartType\" [options]=\"barChartOptions\"></base-chart>";

/***/ },
/* 868 */
/***/ function(module, exports) {

	module.exports = "<app-page><refunds-filter-sheet [fg]=\"fg\" (filterChanged)=\"onFilterChanged($event)\"></refunds-filter-sheet><div class=\"mobile-page-content h-100\"><div class=\"h-100\" [ngSwitch]=\"empty\"><user-feedback *ngSwitchCase=\"true\" type=\"info\" message=\"No Results Found\"></user-feedback><div *ngSwitchCase=\"false\"><div class=\"list-item\" *ngFor=\"let refund of refunds\"><div class=\"layout-row secondary\"><div class=\"flex-text-left\"> {{ refund.refund.timestamp | toLocalDate }}</div></div><div class=\"layout-row\"><div class=\"flex-10\"><i class=\"zmdi zmdi-account-o icon\"></i></div><div class=\"flex\"><div class=\"employee-name\">{{ refund.employee.name }}</div><div class=\"location-name secondary\">{{ refund.location.name }}</div></div><div class=\"flex-nogrow c-red\">{{ refund.total | currency:'USD':true }}</div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">Refund Id:</div><div class=\"flex text-right\">Invoice Id:</div><div class=\"flex text-right\">Sale Date:                            </div></div></div><div class=\"flex-nogrow\"><div class=\"layout-column secondary\"><div class=\"flex\">{{ refund.refund.refundId }}</div><div class=\"flex\">{{ refund.invoice.invoiceId }}</div><div class=\"flex\">{{ refund.invoice.timestamp | toLocalDate }}</div></div></div></div></div></div></div></div></app-page>";

/***/ },
/* 869 */
/***/ function(module, exports) {

	module.exports = ".list-item{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:5px 10px 0px 10px}.list-item::after{content:'';display:block;width:100%;margin-top:5px;border-bottom:1px solid #404040}.list-item .employee-name{font-size:14px}.list-item .icon{font-size:36px !important;color:#9e9e9e}.list-item .secondary{color:#9e9e9e;font-size:11px;padding-right:5px}\n"

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(871));


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var payment_method_summary_1 = __webpack_require__(826);
	var ui_1 = __webpack_require__(132);
	var shared_1 = __webpack_require__(844);
	var forms_1 = __webpack_require__(27);
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var PaymentIndexComponent = (function (_super) {
	    __extends(PaymentIndexComponent, _super);
	    function PaymentIndexComponent(_paymentMethodSummaryService, store, storeHelper, userService) {
	        _super.call(this, store, storeHelper, userService);
	        this._paymentMethodSummaryService = _paymentMethodSummaryService;
	        this.fg = new forms_1.FormGroup({});
	        this._searchAction = { id: 'search', icon: 'search' };
	        this._filterReady = false;
	        this.empty = false;
	        this.pieChartLabels = ['Total Cash', 'Total External Credit', 'Total Credit Cards', 'Total Checks'];
	        this.pieChartData = [];
	        this.pieChartType = 'pie';
	        this.pieChartColors = [{ backgroundColor: ['#E41736', '#00BCD4', '#FFEB3B', '#ADADAD'] }];
	        this.existNumbers = false;
	        this.pieChartOptions = {
	            responsive: true,
	            legend: {
	                display: false
	            }
	        };
	        // set title and actions
	        this.headerTitle = 'Payment Methods';
	        this.headerActions = [this._searchAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	    }
	    PaymentIndexComponent.prototype.onFilterChanged = function (filter) {
	        this._paymentsFilter = filter;
	        this._loadPaymentSaleList();
	    };
	    PaymentIndexComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._searchAction.id) {
	            this.filterSheet.toggle();
	        }
	    };
	    PaymentIndexComponent.prototype._loadPaymentSaleList = function () {
	        var _this = this;
	        var that = this;
	        this._UpdatePaymentsFilter();
	        if (this._paymentsFilter.locationsSelection.locations.length < 1) {
	            this.empty = true;
	            if (this.empty) {
	                setTimeout(function () { return _this.filterSheet.toggle(); }, 1500);
	            }
	            if (this._filterReady) {
	                this.filterSheet.toggle();
	            }
	            this._filterReady = true;
	            return;
	        }
	        this._paymentMethodSummaryService.getPaymentMethodSummary(this._paymentsFilter)
	            .subscribe(function (payments) {
	            _this.payments = payments;
	            _this._CalculatePaymentSummary();
	            _this._LoadPieChart();
	            _this.empty = !_this.existNumbers;
	            if (_this.empty) {
	                setTimeout(function () { return _this.filterSheet.toggle(); }, 1500);
	            }
	            if (_this._filterReady) {
	                _this.filterSheet.toggle();
	            }
	            _this._filterReady = true;
	            that.appPage.deactivatePreloader();
	        });
	    };
	    PaymentIndexComponent.prototype._UpdatePaymentsFilter = function () {
	        // If we dont have locations selected, then take all the locations from  the region
	        if (this._paymentsFilter.locationsSelection.locations.length < 1) {
	            this._paymentsFilter.locationsSelection.locations = this._paymentsFilter.locationsSelection.region.locations;
	        }
	    };
	    PaymentIndexComponent.prototype._CalculatePaymentSummary = function () {
	        this.paymentSummary = new payment_method_summary_1.PaymentMethodSummary(this.payments);
	    };
	    PaymentIndexComponent.prototype._LoadPieChart = function () {
	        this.existNumbers = this._ValidateExistANumberDifferentZero();
	        if (this.existNumbers) {
	            this.pieChartData = [];
	            this.pieChartData.push(this.paymentSummary.totalCash);
	            this.pieChartData.push(this.paymentSummary.totalExternalCredit);
	            this.pieChartData.push(this.paymentSummary.totalCreditCards);
	            this.pieChartData.push(this.paymentSummary.totalChecks);
	        }
	    };
	    PaymentIndexComponent.prototype._ValidateExistANumberDifferentZero = function () {
	        if (this.paymentSummary.totalCash === 0
	            && this.paymentSummary.totalExternalCredit === 0
	            && this.paymentSummary.totalCreditCards === 0
	            && this.paymentSummary.totalChecks === 0) {
	            return false;
	        }
	        return true;
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], PaymentIndexComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(shared_1.PaymentsFilterSheetComponent), 
	        __metadata('design:type', Object)
	    ], PaymentIndexComponent.prototype, "filterSheet", void 0);
	    PaymentIndexComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(872)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof shared_1.PaymentMethodSummaryService !== 'undefined' && shared_1.PaymentMethodSummaryService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _b) || Object, (typeof (_c = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _c) || Object, (typeof (_d = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _d) || Object])
	    ], PaymentIndexComponent);
	    return PaymentIndexComponent;
	    var _a, _b, _c, _d;
	}(models_1.TopLevelComponent));
	exports.PaymentIndexComponent = PaymentIndexComponent;


/***/ },
/* 872 */
/***/ function(module, exports) {

	module.exports = "<app-page><payments-filter-sheet [fg]=\"fg\" (filterChanged)=\"onFilterChanged($event)\"></payments-filter-sheet><base-chart class=\"m-t-20 m-b-25 char\" *ngIf=\"existNumbers &amp;&amp; !empty\" [data]=\"pieChartData\" [labels]=\"pieChartLabels\" [chartType]=\"pieChartType\" [options]=\"pieChartOptions\" [colors]=\"pieChartColors\"></base-chart><my-payment-details [paymentSummary]=\"paymentSummary\" [empty]=\"empty\"></my-payment-details></app-page>";

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(874));


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ui_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(2);
	var shared_1 = __webpack_require__(844);
	var shared_2 = __webpack_require__(844);
	var shared_3 = __webpack_require__(594);
	var forms_1 = __webpack_require__(27);
	var services_1 = __webpack_require__(274);
	var ProfitLossIndexComponent = (function (_super) {
	    __extends(ProfitLossIndexComponent, _super);
	    function ProfitLossIndexComponent(profitSummaryService, profitLocationSaleService, profitProductSaleService, profitEmployeeSaleService, lossExpenseCategoryService, lossCostSaleService, lossInventoryLossesService, lossPayrollService, store, storeHelper, userService) {
	        _super.call(this, store, storeHelper, userService);
	        this.profitSummaryService = profitSummaryService;
	        this.profitLocationSaleService = profitLocationSaleService;
	        this.profitProductSaleService = profitProductSaleService;
	        this.profitEmployeeSaleService = profitEmployeeSaleService;
	        this.lossExpenseCategoryService = lossExpenseCategoryService;
	        this.lossCostSaleService = lossCostSaleService;
	        this.lossInventoryLossesService = lossInventoryLossesService;
	        this.lossPayrollService = lossPayrollService;
	        this.fg = new forms_1.FormGroup({});
	        this.loading = true;
	        this.authorized = true;
	        this._searchAction = { id: 'calendar', icon: 'calendar' };
	        this._filterReady = false;
	        this.isProfit = true;
	        this.isLoadProfitSummary = false;
	        this.isLoadProfitLocationSales = false;
	        this.isLoadProfitEmployee = false;
	        this.isLoadProfitproduct = false;
	        this.existNumbersInProfitSummary = false;
	        this.isLoadLossExpenseCategory = false;
	        this.isLoadLossCostSale = false;
	        this.isLoadLossInventoryLosses = false;
	        this.isLoadLossPayroll = false;
	        // set title and actions
	        this.headerTitle = 'Profit/Loss';
	        this.headerActions = [this._searchAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	    }
	    ProfitLossIndexComponent.prototype.onFilterChanged = function (filter) {
	        this._CloseFilterSheet();
	        this._profitLossFilter = filter;
	        this._updateIsProfit();
	        this._updateProfitLossFilter();
	        if (this.isProfit) {
	            this._loadProfit();
	        }
	        else {
	            this._loadLoss();
	        }
	    };
	    ProfitLossIndexComponent.prototype._CloseFilterSheet = function () {
	        if (this._filterReady) {
	            this.filterSheet.toggle();
	        }
	        this._filterReady = true;
	    };
	    ProfitLossIndexComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._searchAction.id && this.authorized) {
	            this.filterSheet.toggle();
	        }
	    };
	    ProfitLossIndexComponent.prototype._updateIsProfit = function () {
	        this.isProfit = this._profitLossFilter.optionSelected === 'Profits';
	    };
	    /*LOAD PROFIT */
	    ProfitLossIndexComponent.prototype._loadProfit = function () {
	        this.empty = false;
	        this._loadIconLoading();
	        if (this._profitLossFilter.locationsSelection.locations.length > 0) {
	            this._loadProfitSummary();
	            this._loadLocationSaleList();
	            this._loadProductSaleList();
	            this._loadEmployeeSaleList();
	        }
	        else {
	            this._resetProfitData();
	            this._closeIconLoading();
	            this.empty = true;
	            this._showFilterSheet();
	        }
	    };
	    ProfitLossIndexComponent.prototype._updateProfitLossFilter = function () {
	        // If we dont have locations selected, then take all the locations from  the region
	        if (this._profitLossFilter.locationsSelection.locations.length < 1) {
	            this._profitLossFilter.locationsSelection.locations = this._profitLossFilter.locationsSelection.region.locations;
	        }
	    };
	    ProfitLossIndexComponent.prototype._loadProfitSummary = function () {
	        var _this = this;
	        this.isLoadProfitSummary = false;
	        this.loading = true;
	        this.profitSummaryService.getProfitSummary(this._profitLossFilter)
	            .subscribe(function (profitSummary) {
	            _this.profitSummary = profitSummary;
	        }, function (err) {
	            _this.authorized = _this.userService.userHasAccess(err);
	            _this.appPage.deactivatePreloader();
	            _this.loading = false;
	            _this._resetSummary();
	        }, function () {
	            _this.loading = false;
	            _this._LoadProfitMargin();
	        });
	    };
	    ProfitLossIndexComponent.prototype._LoadProfitMargin = function () {
	        var _this = this;
	        this.profitSummaryService.getProfitMargin(this._profitLossFilter)
	            .subscribe(function (margin) {
	            _this.profitSummary.margin = margin;
	            _this.isLoadProfitSummary = true;
	            _this._checkIfApplyCloseIconLoadingInProfit();
	        }, function (error) { return _this._resetSummary(); });
	    };
	    ProfitLossIndexComponent.prototype._loadLocationSaleList = function () {
	        var _this = this;
	        this.isLoadProfitLocationSales = false;
	        this.profitLocationSaleService.getLocationSales(this._profitLossFilter)
	            .subscribe(function (locations) {
	            _this.locationSales = locations;
	            _this.isLoadProfitLocationSales = true;
	            _this._checkIfApplyCloseIconLoadingInProfit();
	        }, function (error) { return _this._resetLocationSales(); });
	    };
	    ProfitLossIndexComponent.prototype._loadProductSaleList = function () {
	        var _this = this;
	        this.isLoadProfitproduct = false;
	        this.profitProductSaleService.getProductSaleList(this._profitLossFilter)
	            .subscribe(function (sales) {
	            _this.productSales = sales;
	            _this.isLoadProfitproduct = true;
	            _this._checkIfApplyCloseIconLoadingInProfit();
	        }, function (error) { return _this._resetProductSales(); });
	    };
	    ProfitLossIndexComponent.prototype._loadEmployeeSaleList = function () {
	        var _this = this;
	        this.isLoadProfitEmployee = false;
	        this.profitEmployeeSaleService.getEmployeeSaleList(this._profitLossFilter)
	            .subscribe(function (sales) {
	            _this.employeeSales = sales;
	            _this.isLoadProfitEmployee = true;
	            _this._checkIfApplyCloseIconLoadingInProfit();
	        }, function (error) { return _this._resetEmployeeSales(); });
	    };
	    ProfitLossIndexComponent.prototype._ValidateExistANumbersInProfitSummaryDifferentZero = function () {
	        if (this.profitSummary.gross === 0
	            && this.profitSummary.margin === 0
	            && this.profitSummary.net === 0
	            && this.profitSummary.netProfit === 0
	            && this.profitSummary.tax === 0) {
	            return false;
	        }
	        return true;
	    };
	    ProfitLossIndexComponent.prototype._resetProfitData = function () {
	        this._resetSummary();
	        this._resetLocationSales();
	        this._resetProductSales();
	        this._resetEmployeeSales();
	        this.existNumbersInProfitSummary = false;
	    };
	    ProfitLossIndexComponent.prototype._resetSummary = function () {
	        this.profitSummary = new shared_1.ProfitSummary(null);
	    };
	    ProfitLossIndexComponent.prototype._resetLocationSales = function () {
	        this.locationSales = [];
	    };
	    ProfitLossIndexComponent.prototype._resetProductSales = function () {
	        this.productSales = [];
	    };
	    ProfitLossIndexComponent.prototype._resetEmployeeSales = function () {
	        this.employeeSales = [];
	    };
	    ProfitLossIndexComponent.prototype._verifyIfEmptyProfitData = function () {
	        this.empty = !this.existNumbersInProfitSummary;
	    };
	    ProfitLossIndexComponent.prototype._checkIfApplyCloseIconLoadingInProfit = function () {
	        if (this.isLoadProfitEmployee && this.isLoadProfitLocationSales && this.isLoadProfitproduct && this.isLoadProfitSummary) {
	            this.profitSummary.UpdateNetProfit();
	            this.existNumbersInProfitSummary = this._ValidateExistANumbersInProfitSummaryDifferentZero();
	            this._verifyIfEmptyProfitData();
	            this._closeIconLoading();
	            if (this.empty) {
	                this._showFilterSheet();
	            }
	        }
	    };
	    /*END LOAD PROFIT */
	    /*LOAD LOSS */
	    ProfitLossIndexComponent.prototype._loadLoss = function () {
	        this.empty = false;
	        this._loadIconLoading();
	        if (this._profitLossFilter.locationsSelection.locations.length > 0) {
	            this._loadExpensesList();
	            this._loadCostSaleList();
	            this._loadInventoryLossesList();
	            this._loadPayrollList();
	        }
	        else {
	            this._resetLossData();
	            this._closeIconLoading();
	            this.empty = true;
	            this._showFilterSheet();
	        }
	    };
	    ProfitLossIndexComponent.prototype._loadExpensesList = function () {
	        var _this = this;
	        this._profitLossExpenseFilter = new shared_1.ProfitLossExpenseFilter(this._profitLossFilter.date, this._profitLossFilter.locationsSelection);
	        this.isLoadLossExpenseCategory = false;
	        if (this._isAplicableExpenses()) {
	            this.lossExpenseCategoryService.getExpensesByCategoryList(this._profitLossExpenseFilter)
	                .subscribe(function (expensesCategories) {
	                _this.lossExpenseCategories = expensesCategories;
	                _this._updateTotalLossCategory();
	                _this.isLoadLossExpenseCategory = true;
	                _this._checkIfApplyCloseIconLoadingInLoss();
	            }, function (error) { return _this._resetExpensesCategories(); });
	        }
	        else {
	            this._resetExpensesCategories();
	            this.isLoadLossExpenseCategory = true;
	        }
	    };
	    ProfitLossIndexComponent.prototype._loadCostSaleList = function () {
	        var _this = this;
	        this.isLoadLossCostSale = false;
	        this.lossCostSaleService.getProductCostSaleList(this._profitLossFilter)
	            .subscribe(function (costSales) {
	            _this.lossCostSales = costSales;
	            _this._updateTotalLossCostSale();
	            _this.isLoadLossCostSale = true;
	            _this._checkIfApplyCloseIconLoadingInLoss();
	        }, function (error) { return _this._resetCostSales(); });
	    };
	    ProfitLossIndexComponent.prototype._loadInventoryLossesList = function () {
	        var _this = this;
	        this.isLoadLossInventoryLosses = false;
	        this.lossInventoryLossesService.getProductCostSaleList(this._profitLossFilter)
	            .subscribe(function (inventoryLosses) {
	            _this.lossInventoryLosses = inventoryLosses;
	            _this._updateTotalInventoryLosses();
	            _this.isLoadLossInventoryLosses = true;
	            _this._checkIfApplyCloseIconLoadingInLoss();
	        }, function (error) { return _this._resetInventoryLosses(); });
	    };
	    ProfitLossIndexComponent.prototype._loadPayrollList = function () {
	        var _this = this;
	        this.isLoadLossPayroll = false;
	        this.lossPayrollService.getEmployeePayrollsList(this._profitLossFilter)
	            .subscribe(function (payrolls) {
	            _this.lossPayrolls = payrolls;
	            _this._updateTotalLossPayroll();
	            _this.isLoadLossPayroll = true;
	            _this._checkIfApplyCloseIconLoadingInLoss();
	        }, function (error) { return _this._resetPayrolls(); });
	    };
	    ProfitLossIndexComponent.prototype._updateTotalLossCategory = function () {
	        var _this = this;
	        this.totalLossExpenseCategory = 0;
	        this.lossExpenseCategories.forEach(function (element) {
	            _this.totalLossExpenseCategory += element.amount;
	        });
	    };
	    ProfitLossIndexComponent.prototype._updateTotalLossCostSale = function () {
	        var _this = this;
	        this.totalLossCostSale = 0;
	        this.lossCostSales.forEach(function (element) {
	            _this.totalLossCostSale += element.cost;
	        });
	    };
	    ProfitLossIndexComponent.prototype._updateTotalInventoryLosses = function () {
	        var _this = this;
	        this.totalLossInventoryLosses = 0;
	        this.lossInventoryLosses.forEach(function (element) {
	            _this.totalLossInventoryLosses += element.cost;
	        });
	    };
	    ProfitLossIndexComponent.prototype._updateTotalLossPayroll = function () {
	        var _this = this;
	        this.totalLossPayroll = 0;
	        this.lossPayrolls.forEach(function (element) {
	            _this.totalLossPayroll += element.salary;
	        });
	    };
	    ProfitLossIndexComponent.prototype._resetLossData = function () {
	        this._resetExpensesCategories();
	        this._resetPayrolls();
	        this._resetInventoryLosses();
	        this._resetCostSales();
	        this._resetLossSummary();
	    };
	    ProfitLossIndexComponent.prototype._resetLossSummary = function () {
	        this.lossSummary = new shared_2.LossSummary(0, 0, 0, 0);
	    };
	    ProfitLossIndexComponent.prototype._resetExpensesCategories = function () {
	        this.totalLossExpenseCategory = 0;
	        this.lossExpenseCategories = [];
	    };
	    ProfitLossIndexComponent.prototype._resetPayrolls = function () {
	        this.totalLossPayroll = 0;
	        this.lossPayrolls = [];
	    };
	    ProfitLossIndexComponent.prototype._resetInventoryLosses = function () {
	        this.totalLossInventoryLosses = 0;
	        this.lossInventoryLosses = [];
	    };
	    ProfitLossIndexComponent.prototype._resetCostSales = function () {
	        this.totalLossCostSale = 0;
	        this.lossCostSales = [];
	    };
	    ProfitLossIndexComponent.prototype._isAplicableExpenses = function () {
	        var locationFilter = this._profitLossFilter.locationsSelection;
	        return (!locationFilter.region ||
	            (locationFilter.region.id > 0 && locationFilter.region.locations.length === locationFilter.locations.length));
	    };
	    ProfitLossIndexComponent.prototype._verifyIfEmptyLossData = function () {
	        this.empty = this.lossSummary.total === 0;
	    };
	    ProfitLossIndexComponent.prototype._createLossSummary = function () {
	        this.lossSummary = new shared_2.LossSummary(this.totalLossExpenseCategory, this.totalLossCostSale, this.totalLossInventoryLosses, this.totalLossPayroll);
	    };
	    /*End Loss */
	    /*Icon Loading functions */
	    ProfitLossIndexComponent.prototype._loadIconLoading = function () {
	        this.appPage.activatePreloader();
	    };
	    ProfitLossIndexComponent.prototype._closeIconLoading = function () {
	        this.appPage.deactivatePreloader();
	    };
	    ProfitLossIndexComponent.prototype._checkIfApplyCloseIconLoadingInLoss = function () {
	        if (this.isLoadLossExpenseCategory && this.isLoadLossCostSale && this.isLoadLossInventoryLosses && this.isLoadLossPayroll) {
	            this._createLossSummary();
	            this._closeIconLoading();
	            this._verifyIfEmptyLossData();
	            if (this.empty) {
	                this._showFilterSheet();
	            }
	        }
	    };
	    /*Empty message */
	    /*Show Filter Sheew */
	    ProfitLossIndexComponent.prototype._showFilterSheet = function () {
	        var _this = this;
	        setTimeout(function () { return _this.filterSheet.toggle(); }, 1500);
	        this._filterReady = true;
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], ProfitLossIndexComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(shared_1.ProfitLossFilterSheetComponent), 
	        __metadata('design:type', Object)
	    ], ProfitLossIndexComponent.prototype, "filterSheet", void 0);
	    ProfitLossIndexComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(875)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof shared_1.ProfitSummaryService !== 'undefined' && shared_1.ProfitSummaryService) === 'function' && _a) || Object, (typeof (_b = typeof shared_1.ProfitLocationSaleService !== 'undefined' && shared_1.ProfitLocationSaleService) === 'function' && _b) || Object, (typeof (_c = typeof shared_1.ProfitProductSaleService !== 'undefined' && shared_1.ProfitProductSaleService) === 'function' && _c) || Object, (typeof (_d = typeof shared_1.ProfitEmployeeSaleService !== 'undefined' && shared_1.ProfitEmployeeSaleService) === 'function' && _d) || Object, (typeof (_e = typeof shared_2.LossExpenseCategoryService !== 'undefined' && shared_2.LossExpenseCategoryService) === 'function' && _e) || Object, (typeof (_f = typeof shared_2.LossCostSaleService !== 'undefined' && shared_2.LossCostSaleService) === 'function' && _f) || Object, (typeof (_g = typeof shared_2.LossInventoryLossesService !== 'undefined' && shared_2.LossInventoryLossesService) === 'function' && _g) || Object, (typeof (_h = typeof shared_2.LossPayrollService !== 'undefined' && shared_2.LossPayrollService) === 'function' && _h) || Object, (typeof (_j = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _j) || Object, (typeof (_k = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _k) || Object, (typeof (_l = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _l) || Object])
	    ], ProfitLossIndexComponent);
	    return ProfitLossIndexComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}(shared_3.TopLevelComponent));
	exports.ProfitLossIndexComponent = ProfitLossIndexComponent;


/***/ },
/* 875 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"flex\" *ngIf=\"authorized\"><profit-loss-filter-sheet [fg]=\"fg\" (filterChanged)=\"onFilterChanged($event)\"></profit-loss-filter-sheet><div class=\"h-100\" [ngSwitch]=\"empty\"><user-feedback *ngSwitchCase=\"true\" type=\"info\" message=\"No Results Found\"></user-feedback><div *ngSwitchCase=\"false\"><my-loss-index *ngIf=\"!isProfit\" [lossExpenseCategories]=\"lossExpenseCategories\" [totalLossExpenseCategory]=\"totalLossExpenseCategory\" [lossCostSales]=\"lossCostSales\" [totalLossCostSale]=\"totalLossCostSale\" [lossInventoryLosses]=\"lossInventoryLosses\" [totalLossInventoryLosses]=\"totalLossInventoryLosses\" [lossPayrolls]=\"lossPayrolls\" [totalLossPayroll]=\"totalLossPayroll\" [lossSummary]=\"lossSummary\"></my-loss-index><my-profit-index *ngIf=\"isProfit\" [summary]=\"profitSummary\" [existNumbersInProfitSummary]=\"existNumbersInProfitSummary\" [locationSales]=\"locationSales\" [productSales]=\"productSales\" [employeeSales]=\"employeeSales\"></my-profit-index></div></div></div><user-feedback [hidden]=\"authorized || loading\" type=\"info\" message=\"User - Not Authorized\"> </user-feedback></app-page>";

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(877));


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var payment_method_summary_1 = __webpack_require__(826);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var PaymentDetailsComponent = (function (_super) {
	    __extends(PaymentDetailsComponent, _super);
	    function PaymentDetailsComponent(store, storeHelper, userService) {
	        _super.call(this, store, storeHelper, userService);
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof payment_method_summary_1.PaymentMethodSummary !== 'undefined' && payment_method_summary_1.PaymentMethodSummary) === 'function' && _a) || Object)
	    ], PaymentDetailsComponent.prototype, "paymentSummary", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PaymentDetailsComponent.prototype, "empty", void 0);
	    PaymentDetailsComponent = __decorate([
	        core_1.Component({
	            selector: 'my-payment-details',
	            styles: [__webpack_require__(878)],
	            template: __webpack_require__(879)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _b) || Object, (typeof (_c = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _c) || Object, (typeof (_d = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _d) || Object])
	    ], PaymentDetailsComponent);
	    return PaymentDetailsComponent;
	    var _a, _b, _c, _d;
	}(models_1.TopLevelComponent));
	exports.PaymentDetailsComponent = PaymentDetailsComponent;


/***/ },
/* 878 */
/***/ function(module, exports) {

	module.exports = ".payment{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.payment::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.payment .content title{font-size:24px}.payment .content small{color:#9e9e9e}.payment .results{width:100px;text-align:right}.payment .secondary{color:#9e9e9e;font-size:11px}.payment .amount.sale{color:#8BC34A}.payment .amount.refund{color:#E41736}.legend{height:18px;width:18px;margin-right:10px}.color-cash{background-color:#E41736}.color-credit{background-color:#FFEB3B}.color-external-credit{background-color:#00BCD4}.color-checks{background-color:#ADADAD}\n"

/***/ },
/* 879 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mobile-page-content\"><div class=\"h-100\" [ngSwitch]=\"empty\"><user-feedback *ngSwitchCase=\"true\" type=\"info\" message=\"No Results Found\"></user-feedback><div *ngSwitchCase=\"false\"><div class=\"payment master\"><div class=\"layout-row\" *ngIf=\"paymentSummary\"><div class=\"col-xs-1 legend color-cash\"></div><div class=\"flex content\"><div class=\"title\">Total Cash</div></div><div class=\"flex-nogrow results c-amber\">{{ paymentSummary.totalCash| currency:'USD':true}}</div></div><div class=\"separator\"></div></div><div class=\"payment master\"><div class=\"layout-row\" *ngIf=\"paymentSummary\"><div class=\"col-xs-1 legend color-external-credit\"></div><div class=\"flex content\"><div class=\"title\">Total External Credit</div></div><div class=\"flex-nogrow results c-amber\">{{ paymentSummary.totalExternalCredit| currency:'USD':true}}</div></div><div class=\"separator\"></div></div><div class=\"payment master\"><div class=\"layout-row\" *ngIf=\"paymentSummary\"><div class=\"col-xs-1 legend color-credit\"></div><div class=\"flex content\"><div class=\"title\">Total Credit Cards</div></div><div class=\"flex-nogrow results c-amber\">{{ paymentSummary.totalCreditCards| currency:'USD':true}}</div></div><div class=\"separator\"></div></div><div class=\"payment master\"><div class=\"layout-row\" *ngIf=\"paymentSummary\"><div class=\"col-xs-1 legend color-checks\"></div><div class=\"flex content\"><div class=\"title\">Total Checks</div></div><div class=\"flex-nogrow results c-amber\">{{ paymentSummary.totalChecks| currency:'USD':true}}</div></div><div class=\"separator\"></div></div></div></div></div>";

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(881));


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var shared_1 = __webpack_require__(844);
	var ProfitIndexComponent = (function () {
	    function ProfitIndexComponent() {
	        this.existNumbersInProfitSummary = false;
	        this.empty = false;
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof shared_1.ProfitLossFilter !== 'undefined' && shared_1.ProfitLossFilter) === 'function' && _a) || Object)
	    ], ProfitIndexComponent.prototype, "profitLossFilter", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof shared_1.ProfitSummary !== 'undefined' && shared_1.ProfitSummary) === 'function' && _b) || Object)
	    ], ProfitIndexComponent.prototype, "summary", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], ProfitIndexComponent.prototype, "existNumbersInProfitSummary", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ProfitIndexComponent.prototype, "locationSales", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ProfitIndexComponent.prototype, "productSales", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ProfitIndexComponent.prototype, "employeeSales", void 0);
	    ProfitIndexComponent = __decorate([
	        core_1.Component({
	            selector: 'my-profit-index',
	            template: __webpack_require__(882)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ProfitIndexComponent);
	    return ProfitIndexComponent;
	    var _a, _b;
	}());
	exports.ProfitIndexComponent = ProfitIndexComponent;


/***/ },
/* 882 */
/***/ function(module, exports) {

	module.exports = "<my-profit-summary [summary]=\"summary\" [existNumbersInProfitSummary]=\"existNumbersInProfitSummary\"></my-profit-summary><my-profit-location [locationSales]=\"locationSales\"></my-profit-location><my-profit-product [productSales]=\"productSales\"></my-profit-product><my-profit-employee [employeeSales]=\"employeeSales\"></my-profit-employee>";

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(884));


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var models_1 = __webpack_require__(823);
	var ProfitSummaryComponent = (function () {
	    function ProfitSummaryComponent() {
	        this.existNumbersInProfitSummary = false;
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof models_1.ProfitSummary !== 'undefined' && models_1.ProfitSummary) === 'function' && _a) || Object)
	    ], ProfitSummaryComponent.prototype, "summary", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], ProfitSummaryComponent.prototype, "existNumbersInProfitSummary", void 0);
	    ProfitSummaryComponent = __decorate([
	        core_1.Component({
	            selector: 'my-profit-summary',
	            styles: [__webpack_require__(885)],
	            template: __webpack_require__(886)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ProfitSummaryComponent);
	    return ProfitSummaryComponent;
	    var _a;
	}());
	exports.ProfitSummaryComponent = ProfitSummaryComponent;


/***/ },
/* 885 */
/***/ function(module, exports) {

	module.exports = ".income-summary{position:relative}.income-summary .cover{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}.income-summary .flex{position:relative}.income-summary .label{color:#9E9E9E;font-size:10px}.income-summary .net{font-size:32px}.income-summary .tax,.income-summary .margin,.income-summary .gross{font-size:20px}.income-summary .margin.negative{color:#E41736}\n"

/***/ },
/* 886 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mobile-page-content\"><div class=\"income-summary layout-column layout-padding text-center z-depth-2 animated fadein\" *ngIf=\"existNumbersInProfitSummary\"><div class=\"cover\"></div><div class=\"flex\"><div class=\"label\">Total Net</div><div class=\"net c-amber\">{{ summary.netProfit | currency:'USD':'$' }} </div></div><div class=\"flex\"><div class=\"layout-row\"><div class=\"flex\"><div class=\"label\">Profit Margin</div><div class=\"margin\" [class.c-lime]=\"summary.margin &gt; 0\" [class.negative]=\"summary.margin &lt;= 0\">{{ summary.margin}}%</div></div><div class=\"flex\"><div class=\"label\">Total Net Revenue</div><div class=\"gross c-lime\">{{ summary.net | currency:'USD':'$' }}</div></div></div></div><div class=\"flex\"><div class=\"layout-row\"><div class=\"flex\"><div class=\"label\">Total Tax Revenue</div><div class=\"tax c-lime\">{{ summary.tax | currency:'USD':'$' }}</div></div><div class=\"flex\"><div class=\"label\">Total Gross Revenue</div><div class=\"gross c-lime\">{{ summary.gross | currency:'USD':'$' }}</div></div></div></div></div></div>";

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(888));


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var ProfitLocationComponent = (function () {
	    function ProfitLocationComponent() {
	        this.isPieChart = false;
	        this.isBarChart = false;
	        this.optionNotChart = false;
	        this.chartLabels = [];
	    }
	    ProfitLocationComponent.prototype.showPieChart = function () {
	        this.isPieChart = true;
	        this.optionNotChart = true;
	        this.isBarChart = false;
	        this._UpdateChartInformation();
	    };
	    ProfitLocationComponent.prototype._UpdateChartInformation = function () {
	        var _this = this;
	        this.chartLabels = [];
	        this.chartData = [];
	        this.locationSales.forEach(function (loc) {
	            _this.chartLabels.push(loc.name);
	            _this.chartData.push(loc.total);
	        });
	    };
	    ProfitLocationComponent.prototype._UpdateBarChartInformation = function () {
	        this.barChartData = [];
	        var tempObject = {};
	        tempObject['data'] = this.chartData;
	        this.barChartData.push(tempObject);
	    };
	    ProfitLocationComponent.prototype.ShowBarChart = function () {
	        this.isPieChart = false;
	        this.isBarChart = true;
	        this.optionNotChart = true;
	        this._UpdateBarChartInformation();
	    };
	    ProfitLocationComponent.prototype.showInitialSetting = function () {
	        this.isBarChart = false;
	        this.optionNotChart = false;
	        this.isPieChart = false;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], ProfitLocationComponent.prototype, "locationSales", void 0);
	    ProfitLocationComponent = __decorate([
	        core_1.Component({
	            selector: 'my-profit-location',
	            styles: [__webpack_require__(889)],
	            template: __webpack_require__(890)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ProfitLocationComponent);
	    return ProfitLocationComponent;
	}());
	exports.ProfitLocationComponent = ProfitLocationComponent;


/***/ },
/* 889 */
/***/ function(module, exports) {

	module.exports = ".income-summary{position:relative}.income-summary .cover{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}.income-summary .flex{position:relative}.income-summary .label{color:#9E9E9E;font-size:10px}.profit{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.profit.master{padding-right:30px}.profit::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.profit .avatar{float:left;width:50px;font-size:38px}.profit .mini-avatar{float:right;width:20px;font-size:20px}.profit .content title{font-size:24px}.profit .content small{color:#9e9e9e}.profit .results{width:100px;text-align:right}.profit .secondary{color:#9e9e9e;font-size:11px}section.subtitle{background-color:transparent;text-align:center}section.subtitle .title{color:#ccc}.relative{position:relative}.slideRight{position:absolute;top:40%;left:0;cursor:pointer}.pointer{cursor:pointer}\n"

/***/ },
/* 890 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mobile-page-content\"><div class=\"income-summary layout-column layout-padding text-center z-depth-2 animated fadein\" *ngIf=\"locationSales &amp;&amp; locationSales.length &gt; 0\"><div class=\"cover\"></div><div class=\"flex\"><section class=\"subtitle\"><h3 class=\"title\"> <i class=\"flex-nogrow avatar sm zmdi zmdi-pin hc-4x m-r-10 pointer\"> </i><span>Sales By Location</span><i class=\"zmdi zmdi-chart-donut pull-right m-r-30 pointer\" *ngIf=\"!optionNotChart\" (click)=\"showPieChart()\"></i><i class=\"zmdi zmdi-format-list-bulleted pull-right m-r-30 pointer\" *ngIf=\"optionNotChart\" (click)=\"showInitialSetting()\"></i></h3></section></div></div><div class=\"profit master\" *ngIf=\"locationSales &amp;&amp; locationSales.length &gt; 0\"><div class=\"layout-row\" *ngIf=\"isPieChart\"><div class=\"col-xs-11\"><my-pie-chart [pieChartLabels]=\"chartLabels\" [pieChartData]=\"chartData\"></my-pie-chart></div><div class=\"col-xs-1 relative\"><i class=\"zmdi zmdi-chevron-right zmdi-hc-4x slideRight\" (click)=\"ShowBarChart()\"></i></div></div><div class=\"layout-row\" *ngIf=\"isBarChart\"><div class=\"col-xs-11\"><my-bar-chart [barChartLabels]=\"chartLabels\" [barChartData]=\"barChartData\"></my-bar-chart></div><div class=\"col-xs-1 relative\"><i class=\"zmdi zmdi-chevron-right zmdi-hc-4x slideRight\" (click)=\"showPieChart()\"></i></div></div></div><div class=\"h-100\" *ngIf=\"locationSales &amp;&amp; locationSales.length &gt; 0\"><div class=\"profit master\" *ngFor=\"let locationSale of locationSales\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-pin\"></i><div class=\"flex content\"><div class=\"title\">{{locationSale.name}}</div></div><div class=\"flex-nogrow results c-amber\">{{ locationSale.total| currency:'USD':true}}<br/><span class=\"green\" *ngIf=\"locationSale.percent&gt;0\">+{{locationSale.percent}}%</span><span class=\"green\" *ngIf=\"locationSale.percent&lt;0\">-{{locationSale.percent}}%</span></div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\"> </div><span>Sub</span></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ locationSale.subTotal | currency:'USD':true }}</div></div></div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\"> </div><span>Tax</span></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ locationSale.tax | currency:'USD':true }}</div></div></div></div><div class=\"separator\"></div></div></div></div>";

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(892));


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var ProfitProductComponent = (function () {
	    function ProfitProductComponent() {
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], ProfitProductComponent.prototype, "productSales", void 0);
	    ProfitProductComponent = __decorate([
	        core_1.Component({
	            selector: 'my-profit-product',
	            styles: [__webpack_require__(893)],
	            template: __webpack_require__(894)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ProfitProductComponent);
	    return ProfitProductComponent;
	}());
	exports.ProfitProductComponent = ProfitProductComponent;


/***/ },
/* 893 */
/***/ function(module, exports) {

	module.exports = ".income-summary{position:relative}.income-summary .cover{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}.income-summary .flex{position:relative}.income-summary .label{color:#9E9E9E;font-size:10px}.profit{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.profit.master{padding-right:30px}.profit::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.profit .avatar{float:left;width:50px;font-size:38px}.profit .mini-avatar{float:right;width:20px;font-size:20px}.profit .content title{font-size:24px}.profit .content small{color:#9e9e9e}.profit .results{width:100px;text-align:right}.profit .secondary{color:#9e9e9e;font-size:11px}section.subtitle{background-color:transparent;text-align:center}section.subtitle .title{color:#ccc}\n"

/***/ },
/* 894 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mobile-page-content\"><div class=\"income-summary layout-column layout-padding text-center z-depth-2 animated fadein\" *ngIf=\"productSales &amp;&amp; productSales.length &gt; 0\"><div class=\"cover\"></div><div class=\"flex\"><section class=\"subtitle\"><h3 class=\"title\"> <i class=\"flex-nogrow avatar sm zmdi zmdi-shopping-cart-add hc-4x m-r-10\"></i><span>Sales By Product</span></h3></section></div></div><div class=\"h-100\" *ngIf=\"productSales &amp;&amp; productSales.length &gt; 0\"><div class=\"profit master\" *ngFor=\"let productSale of productSales\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-shopping-cart-add\"></i><div class=\"flex content\"><div class=\"title\">{{productSale.name}}</div></div><div class=\"flex-nogrow results c-amber\">{{ productSale.total| currency:'USD':true}}</div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\"> </div><span>QTY</span></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ productSale.quantity}}</div></div></div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\"> </div><span>Net</span></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ productSale.subTotal | currency:'USD':true }}</div></div></div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\"> </div><span>Tax</span></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ productSale.tax | currency:'USD':true }}</div></div></div></div><div class=\"separator\"></div></div></div></div>";

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(896));


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var ProfitEmployeeComponent = (function () {
	    function ProfitEmployeeComponent() {
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ProfitEmployeeComponent.prototype, "employeeSales", void 0);
	    ProfitEmployeeComponent = __decorate([
	        core_1.Component({
	            selector: 'my-profit-employee',
	            styles: [__webpack_require__(897)],
	            template: __webpack_require__(898)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ProfitEmployeeComponent);
	    return ProfitEmployeeComponent;
	}());
	exports.ProfitEmployeeComponent = ProfitEmployeeComponent;


/***/ },
/* 897 */
893,
/* 898 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mobile-page-content\"><div class=\"income-summary layout-column layout-padding text-center z-depth-2 animated fadein\" *ngIf=\"employeeSales &amp;&amp; employeeSales.length &gt; 0\"><div class=\"cover\"></div><div class=\"flex\"><section class=\"subtitle\"><h3 class=\"title\"> <i class=\"flex-nogrow avatar sm zmdi zmdi-account-o hc-4x m-r-10\"></i><span>Sales By Employee</span></h3></section></div></div><div class=\"h-100\" *ngIf=\"employeeSales &amp;&amp; employeeSales.length &gt; 0\"><div class=\"profit master\" *ngFor=\"let employeeSale of employeeSales\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-account-o\"></i><div class=\"flex content\"><div class=\"title\">{{employeeSale.name}}</div></div><div class=\"flex-nogrow results c-amber\">{{ employeeSale.afc| currency:'USD':true}}</div></div><div class=\"separator\"></div></div></div></div>";

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(900));


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var shared_1 = __webpack_require__(844);
	var LossIndexComponent = (function () {
	    function LossIndexComponent() {
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], LossIndexComponent.prototype, "lossExpenseCategories", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], LossIndexComponent.prototype, "totalLossExpenseCategory", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], LossIndexComponent.prototype, "lossCostSales", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], LossIndexComponent.prototype, "totalLossCostSale", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], LossIndexComponent.prototype, "lossInventoryLosses", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], LossIndexComponent.prototype, "totalLossInventoryLosses", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], LossIndexComponent.prototype, "lossPayrolls", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], LossIndexComponent.prototype, "totalLossPayroll", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof shared_1.LossSummary !== 'undefined' && shared_1.LossSummary) === 'function' && _a) || Object)
	    ], LossIndexComponent.prototype, "lossSummary", void 0);
	    LossIndexComponent = __decorate([
	        core_1.Component({
	            selector: 'my-loss-index',
	            template: __webpack_require__(901)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LossIndexComponent);
	    return LossIndexComponent;
	    var _a;
	}());
	exports.LossIndexComponent = LossIndexComponent;


/***/ },
/* 901 */
/***/ function(module, exports) {

	module.exports = "<my-loss-summary [lossSummary]=\"lossSummary\"></my-loss-summary><my-loss-category [lossExpenseCategories]=\"lossExpenseCategories\" [totalLossExpenseCategory]=\"totalLossExpenseCategory\"></my-loss-category><my-loss-cost [lossCostSales]=\"lossCostSales\" [totalLossCostSale]=\"totalLossCostSale\"></my-loss-cost><my-loss-inventory [lossInventoryLosses]=\"lossInventoryLosses\" [totalLossInventoryLosses]=\"totalLossInventoryLosses\"></my-loss-inventory><my-loss-payroll [lossPayrolls]=\"lossPayrolls\" [totalLossPayroll]=\"totalLossPayroll\"></my-loss-payroll>";

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(903));


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var shared_1 = __webpack_require__(844);
	var LossSummaryComponent = (function () {
	    function LossSummaryComponent() {
	        /*Chart variables */
	        this.isPieChart = false;
	        this.isBarChart = false;
	        this.optionNotChart = false;
	        this.chartLabels = ['Inventory Cost', 'Salaries', 'Others'];
	    }
	    LossSummaryComponent.prototype.showPieChart = function () {
	        this.isPieChart = true;
	        this.optionNotChart = true;
	        this.isBarChart = false;
	        this._UpdateChartInformation();
	    };
	    LossSummaryComponent.prototype._UpdateChartInformation = function () {
	        this.chartData = [];
	        this.chartData.push(this.lossSummary.totalInventory);
	        this.chartData.push(this.lossSummary.totalSalaries);
	        this.chartData.push(this.lossSummary.totalOthers);
	    };
	    LossSummaryComponent.prototype._UpdateBarChartInformation = function () {
	        this.barChartData = [];
	        var tempObject = {};
	        tempObject['data'] = this.chartData;
	        this.barChartData.push(tempObject);
	    };
	    LossSummaryComponent.prototype.ShowBarChart = function () {
	        this.isPieChart = false;
	        this.isBarChart = true;
	        this.optionNotChart = true;
	        this._UpdateBarChartInformation();
	    };
	    LossSummaryComponent.prototype.showInitialSetting = function () {
	        this.isBarChart = false;
	        this.optionNotChart = false;
	        this.isPieChart = false;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof shared_1.LossSummary !== 'undefined' && shared_1.LossSummary) === 'function' && _a) || Object)
	    ], LossSummaryComponent.prototype, "lossSummary", void 0);
	    LossSummaryComponent = __decorate([
	        core_1.Component({
	            selector: 'my-loss-summary',
	            styles: [__webpack_require__(904)],
	            template: __webpack_require__(905)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LossSummaryComponent);
	    return LossSummaryComponent;
	    var _a;
	}());
	exports.LossSummaryComponent = LossSummaryComponent;


/***/ },
/* 904 */
/***/ function(module, exports) {

	module.exports = ".income-summary{position:relative}.income-summary .cover{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}.income-summary .flex{position:relative}.income-summary .label{color:#9E9E9E;font-size:10px}.income-summary .total{font-size:32px}.income-summary .others,.income-summary .inventory,.income-summary .salaries{font-size:20px}.income-summary .negative{color:#E41736 !important}section.subtitle{background-color:transparent;text-align:center}section.subtitle .title{color:#ccc}.relative{position:relative}.slideRight{position:absolute;top:40%;left:0;cursor:pointer}.pointer{cursor:pointer}\n"

/***/ },
/* 905 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mobile-page-content\" *ngIf=\"lossSummary &amp;&amp; lossSummary.total &amp;&amp; lossSummary.total!==0\"><div class=\"income-summary layout-column layout-padding text-center z-depth-2 animated fadein\"><div class=\"cover\"></div><div class=\"flex\"><section class=\"subtitle\"><h3 class=\"title\"> <i class=\"zmdi zmdi-chart-donut pull-right m-r-10 m-t-20 pointer\" *ngIf=\"!optionNotChart\" (click)=\"showPieChart()\"></i><i class=\"zmdi zmdi-format-list-bulleted pull-right m-r-10 m-t-20 pointer\" *ngIf=\"optionNotChart\" (click)=\"showInitialSetting()\"></i></h3></section><div class=\"label\">Total Expenses</div><div class=\"total c-amber negative\">{{ lossSummary.total | currency:'USD':'$' }}</div></div><div class=\"flex\" *ngIf=\"!isPieChart &amp;&amp; !isBarChart\"><div class=\"layout-row\"><div class=\"flex\"><div class=\"label\">Inventory Cost</div><div class=\"inventory c-lime\">{{ lossSummary.totalInventory}}</div></div><div class=\"flex\"><div class=\"label\">Salaries</div><div class=\"salaries c-lime\">{{ lossSummary.totalSalaries | currency:'USD':'$' }}</div></div></div></div><div class=\"flex\" *ngIf=\"!isPieChart &amp;&amp; !isBarChart\"><div class=\"layout-row\"><div class=\"flex\"><div class=\"label\">Others</div><div class=\"others c-lime\">{{ lossSummary.totalOthers | currency:'USD':'$' }}</div></div><div class=\"flex\"><div class=\"label\"> </div><div class=\"c-lime\"> </div></div></div></div></div><div class=\"loss master\"><div class=\"layout-row\" *ngIf=\"isPieChart\"><div class=\"col-xs-11\"><my-pie-chart [pieChartLabels]=\"chartLabels\" [pieChartData]=\"chartData\"></my-pie-chart></div><div class=\"col-xs-1 relative\"><i class=\"zmdi zmdi-chevron-right zmdi-hc-4x slideRight\" (click)=\"ShowBarChart()\"></i></div></div><div class=\"layout-row\" *ngIf=\"isBarChart\"><div class=\"col-xs-11\"><my-bar-chart [barChartLabels]=\"chartLabels\" [barChartData]=\"barChartData\"></my-bar-chart></div><div class=\"col-xs-1 relative\"><i class=\"zmdi zmdi-chevron-right zmdi-hc-4x slideRight\" (click)=\"showPieChart()\"></i></div></div></div></div>";

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(907));


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var LossCategoryComponent = (function () {
	    function LossCategoryComponent() {
	        /*Chart variables */
	        this.isPieChart = false;
	        this.isBarChart = false;
	        this.optionNotChart = false;
	        this.chartLabels = [];
	    }
	    LossCategoryComponent.prototype.showPieChart = function () {
	        this.isPieChart = true;
	        this.optionNotChart = true;
	        this.isBarChart = false;
	        this._UpdateChartInformation();
	    };
	    LossCategoryComponent.prototype._UpdateChartInformation = function () {
	        var _this = this;
	        this.chartLabels = [];
	        this.chartData = [];
	        this.lossExpenseCategories.forEach(function (loc) {
	            _this.chartLabels.push(loc.category);
	            _this.chartData.push(loc.amount);
	        });
	    };
	    LossCategoryComponent.prototype._UpdateBarChartInformation = function () {
	        this.barChartData = [];
	        var tempObject = {};
	        tempObject['data'] = this.chartData;
	        this.barChartData.push(tempObject);
	    };
	    LossCategoryComponent.prototype.ShowBarChart = function () {
	        this.isPieChart = false;
	        this.isBarChart = true;
	        this.optionNotChart = true;
	        this._UpdateBarChartInformation();
	    };
	    LossCategoryComponent.prototype.showInitialSetting = function () {
	        this.isBarChart = false;
	        this.optionNotChart = false;
	        this.isPieChart = false;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], LossCategoryComponent.prototype, "lossExpenseCategories", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], LossCategoryComponent.prototype, "totalLossExpenseCategory", void 0);
	    LossCategoryComponent = __decorate([
	        core_1.Component({
	            selector: 'my-loss-category',
	            styles: [__webpack_require__(908)],
	            template: __webpack_require__(909)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LossCategoryComponent);
	    return LossCategoryComponent;
	}());
	exports.LossCategoryComponent = LossCategoryComponent;


/***/ },
/* 908 */
/***/ function(module, exports) {

	module.exports = ".income-summary{position:relative}.income-summary .cover{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}.income-summary .flex{position:relative}.income-summary .label{color:#9E9E9E;font-size:10px}.income-summary .total{font-size:32px}.income-summary .negative{color:#E41736 !important}.loss{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.loss.master{padding-right:30px}.loss::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.loss .avatar{float:left;width:50px;font-size:38px}.loss .content title{font-size:24px}.loss .content small{color:#9e9e9e}.loss .negative{color:#E41736}section.subtitle{background-color:transparent;text-align:center}section.subtitle .title{color:#ccc}.relative{position:relative}.slideRight{position:absolute;top:40%;left:0;cursor:pointer}.pointer{cursor:pointer}.category{font-size:21px}.m-t-3{margin-top:3px}\n"

/***/ },
/* 909 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mobile-page-content\" *ngIf=\"totalLossExpenseCategory!==0\"><div class=\"income-summary layout-column layout-padding text-center z-depth-2 animated fadein\" *ngIf=\"lossExpenseCategories &amp;&amp; lossExpenseCategories.length &gt; 0\"><div class=\"cover\"></div><div class=\"flex\"><section class=\"subtitle\"><h3 class=\"title\"> <i class=\"flex-nogrow avatar sm zmdi zmdi-folder-outline m-r-5 pointer\"> </i><span class=\"category\">Expenses By Category</span><i class=\"zmdi zmdi-chart-donut pull-right m-r-10 m-t-3 pointer\" *ngIf=\"!optionNotChart\" (click)=\"showPieChart()\"></i><i class=\"zmdi zmdi-format-list-bulleted pull-right m-r-10 m-t-3 pointer\" *ngIf=\"optionNotChart\" (click)=\"showInitialSetting()\"></i></h3></section></div><div class=\"flex\"><div class=\"label\">Total</div><div class=\"total c-amber negative\">{{totalLossExpenseCategory}}</div></div></div><div class=\"loss master\" *ngIf=\"lossExpenseCategories &amp;&amp; lossExpenseCategories.length &gt; 0\"><div class=\"layout-row\" *ngIf=\"isPieChart\"><div class=\"col-xs-11\"><my-pie-chart [pieChartLabels]=\"chartLabels\" [pieChartData]=\"chartData\"></my-pie-chart></div><div class=\"col-xs-1 relative\"><i class=\"zmdi zmdi-chevron-right zmdi-hc-4x slideRight\" (click)=\"ShowBarChart()\"></i></div></div><div class=\"layout-row\" *ngIf=\"isBarChart\"><div class=\"col-xs-11\"><my-bar-chart [barChartLabels]=\"chartLabels\" [barChartData]=\"barChartData\"></my-bar-chart></div><div class=\"col-xs-1 relative\"><i class=\"zmdi zmdi-chevron-right zmdi-hc-4x slideRight\" (click)=\"showPieChart()\"></i></div></div></div><div class=\"h-100\" *ngIf=\"lossExpenseCategories &amp;&amp; lossExpenseCategories.length &gt; 0\"><div class=\"loss master\" *ngFor=\"let lossExpenseCategory of lossExpenseCategories\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi zmdi-folder-outline\"></i><div class=\"flex content\"><div class=\"title\">{{lossExpenseCategory.category}}</div></div><div class=\"flex-nogrow negative\">{{ lossExpenseCategory.amount| currency:'USD':true}}</div></div></div></div></div>";

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(911));


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var LossCostComponent = (function () {
	    function LossCostComponent() {
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], LossCostComponent.prototype, "lossCostSales", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], LossCostComponent.prototype, "totalLossCostSale", void 0);
	    LossCostComponent = __decorate([
	        core_1.Component({
	            selector: 'my-loss-cost',
	            styles: [__webpack_require__(912)],
	            template: __webpack_require__(913)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LossCostComponent);
	    return LossCostComponent;
	}());
	exports.LossCostComponent = LossCostComponent;


/***/ },
/* 912 */
/***/ function(module, exports) {

	module.exports = ".income-summary{position:relative}.income-summary .cover{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}.income-summary .flex{position:relative}.income-summary .label{color:#9E9E9E;font-size:10px}.income-summary .total{font-size:32px}.income-summary .negative{color:#E41736 !important}.loss{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.loss.master{padding-right:30px}.loss.master.item-hidden{display:none}.loss::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.loss .avatar{float:left;width:50px;font-size:38px}.loss .content title{font-size:24px}.loss .content small{color:#9e9e9e}.loss .negative{color:#E41736}section.subtitle{background-color:transparent;text-align:center}section.subtitle .title{color:#ccc}\n"

/***/ },
/* 913 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mobile-page-content\" *ngIf=\"totalLossCostSale!==0\"><div class=\"income-summary layout-column layout-padding text-center z-depth-2 animated fadein\" *ngIf=\"lossCostSales &amp;&amp; lossCostSales.length &gt; 0\"><div class=\"cover\"></div><div class=\"flex\"><section class=\"subtitle\"><h3 class=\"title\"> <i class=\"flex-nogrow avatar sm zmdi zmdi-money-box hc-4x m-r-10\"></i><span>Cost of Goods Sold</span></h3></section></div><div class=\"flex\"><div class=\"label\">Total</div><div class=\"total c-amber negative\">{{totalLossCostSale | number:'1.0-2'}}</div></div></div><div class=\"h-100\" *ngIf=\"lossCostSales &amp;&amp; lossCostSales.length &gt; 0\"><div class=\"loss master\" *ngFor=\"let lossCostSale of lossCostSales\" [class.item-hidden]=\"lossCostSale.cost == 0\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi zmdi-money-box\"></i><div class=\"flex content\"><div class=\"title\">{{lossCostSale.name}}</div></div><div class=\"flex-nogrow negative\">{{ lossCostSale.cost| currency:'USD':true}}</div></div></div></div></div>";

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(915));


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var LossInventoryComponent = (function () {
	    function LossInventoryComponent() {
	        /*Chart variables */
	        this.isPieChart = false;
	        this.isBarChart = false;
	        this.optionNotChart = false;
	        this.chartLabels = [];
	    }
	    LossInventoryComponent.prototype.showPieChart = function () {
	        this.isPieChart = true;
	        this.optionNotChart = true;
	        this.isBarChart = false;
	        this._UpdateChartInformation();
	    };
	    LossInventoryComponent.prototype._UpdateChartInformation = function () {
	        var _this = this;
	        this.chartLabels = [];
	        this.chartData = [];
	        this.lossInventoryLosses.forEach(function (loc) {
	            _this.chartLabels.push(loc.reason);
	            _this.chartData.push(loc.cost);
	        });
	    };
	    LossInventoryComponent.prototype._UpdateBarChartInformation = function () {
	        this.barChartData = [];
	        var tempObject = {};
	        tempObject['data'] = this.chartData;
	        this.barChartData.push(tempObject);
	    };
	    LossInventoryComponent.prototype.ShowBarChart = function () {
	        this.isPieChart = false;
	        this.isBarChart = true;
	        this.optionNotChart = true;
	        this._UpdateBarChartInformation();
	    };
	    LossInventoryComponent.prototype.showInitialSetting = function () {
	        this.isBarChart = false;
	        this.optionNotChart = false;
	        this.isPieChart = false;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], LossInventoryComponent.prototype, "lossInventoryLosses", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], LossInventoryComponent.prototype, "totalLossInventoryLosses", void 0);
	    LossInventoryComponent = __decorate([
	        core_1.Component({
	            selector: 'my-loss-inventory',
	            styles: [__webpack_require__(916)],
	            template: __webpack_require__(917)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LossInventoryComponent);
	    return LossInventoryComponent;
	}());
	exports.LossInventoryComponent = LossInventoryComponent;


/***/ },
/* 916 */
/***/ function(module, exports) {

	module.exports = ".income-summary{position:relative}.income-summary .cover{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}.income-summary .flex{position:relative}.income-summary .label{color:#9E9E9E;font-size:10px}.income-summary .total{font-size:32px}.income-summary .negative{color:#E41736 !important}.loss{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.loss.master{padding-right:30px}.loss.master.item-hidden{display:none}.loss::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.loss .avatar{float:left;width:50px;font-size:38px}.loss .content title{font-size:24px}.loss .content small{color:#9e9e9e}.loss .negative{color:#E41736}section.subtitle{background-color:transparent;text-align:center}section.subtitle .title{color:#ccc}.relative{position:relative}.slideRight{position:absolute;top:40%;left:0;cursor:pointer}.pointer{cursor:pointer}\n"

/***/ },
/* 917 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mobile-page-content\" *ngIf=\"totalLossInventoryLosses!==0\"><div class=\"income-summary layout-column layout-padding text-center z-depth-2 animated fadein\" *ngIf=\"lossInventoryLosses &amp;&amp; lossInventoryLosses.length &gt; 0\"><div class=\"cover\"></div><div class=\"flex\"><section class=\"subtitle\"><h3 class=\"title\"> <i class=\"flex-nogrow avatar sm zmdi zmdi-file-text hc-4x m-r-10 pointer\"> </i><span>Inventory Losses</span><i class=\"zmdi zmdi-chart-donut pull-right m-r-30 pointer\" *ngIf=\"!optionNotChart\" (click)=\"showPieChart()\"></i><i class=\"zmdi zmdi-format-list-bulleted pull-right m-r-30 pointer\" *ngIf=\"optionNotChart\" (click)=\"showInitialSetting()\"></i></h3></section></div><div class=\"flex\"><div class=\"label\">Total</div><div class=\"total c-amber negative\">{{totalLossInventoryLosses| number:'1.0-2'}}</div></div></div><div class=\"loss master\" *ngIf=\"lossInventoryLosses &amp;&amp; lossInventoryLosses.length &gt; 0\"><div class=\"layout-row\" *ngIf=\"isPieChart\"><div class=\"col-xs-11\"><my-pie-chart [pieChartLabels]=\"chartLabels\" [pieChartData]=\"chartData\"></my-pie-chart></div><div class=\"col-xs-1 relative\"><i class=\"zmdi zmdi-chevron-right zmdi-hc-4x slideRight\" (click)=\"ShowBarChart()\"></i></div></div><div class=\"layout-row\" *ngIf=\"isBarChart\"><div class=\"col-xs-11\"><my-bar-chart [barChartLabels]=\"chartLabels\" [barChartData]=\"barChartData\"></my-bar-chart></div><div class=\"col-xs-1 relative\"><i class=\"zmdi zmdi-chevron-right zmdi-hc-4x slideRight\" (click)=\"showPieChart()\"></i></div></div></div><div class=\"h-100\" *ngIf=\"lossInventoryLosses &amp;&amp; lossInventoryLosses.length &gt; 0\"><div class=\"loss master\" *ngFor=\"let lossInventoryLoss of lossInventoryLosses\" [class.item-hidden]=\"lossInventoryLoss.cost == 0\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi zmdi-file-text\"></i><div class=\"flex content\"><div class=\"title\">{{lossInventoryLoss.reason}}</div></div><div class=\"flex-nogrow negative\">{{ lossInventoryLoss.cost| currency:'USD':true}}</div></div></div></div></div>";

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(919));


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var LossPayrollComponent = (function () {
	    function LossPayrollComponent() {
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], LossPayrollComponent.prototype, "lossPayrolls", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], LossPayrollComponent.prototype, "totalLossPayroll", void 0);
	    LossPayrollComponent = __decorate([
	        core_1.Component({
	            selector: 'my-loss-payroll',
	            styles: [__webpack_require__(920)],
	            template: __webpack_require__(921)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LossPayrollComponent);
	    return LossPayrollComponent;
	}());
	exports.LossPayrollComponent = LossPayrollComponent;


/***/ },
/* 920 */
912,
/* 921 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mobile-page-content\" *ngIf=\"totalLossPayroll!==0\"><div class=\"income-summary layout-column layout-padding text-center z-depth-2 animated fadein\" *ngIf=\"lossPayrolls &amp;&amp; lossPayrolls.length &gt; 0\"><div class=\"cover\"></div><div class=\"flex\"><section class=\"subtitle\"><h3 class=\"title\"> <i class=\"flex-nogrow avatar sm zmdi zmdi-account-o hc-4x m-r-10\"></i><span>Payroll Cost</span></h3></section></div><div class=\"flex\"><div class=\"label\">Total</div><div class=\"total c-amber negative\">{{totalLossPayroll| number:'1.0-2'}}</div></div></div><div class=\"h-100\" *ngIf=\"lossPayrolls &amp;&amp; lossPayrolls.length &gt; 0\"><div class=\"loss master\" *ngFor=\"let lossPayroll of lossPayrolls\" [class.item-hidden]=\"lossPayroll.salary == 0\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-account-o\"></i><div class=\"flex content\"><div class=\"title\">{{lossPayroll.name}}</div></div><div class=\"flex-nogrow negative\">{{ lossPayroll.salary| currency:'USD':true}}</div></div></div></div></div>";

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(23);
	var location_routing_1 = __webpack_require__(923);
	var shared_module_1 = __webpack_require__(26);
	var shared_1 = __webpack_require__(925);
	var ng2_material_components_1 = __webpack_require__(33);
	var location_component_1 = __webpack_require__(673);
	var location_index_component_1 = __webpack_require__(924);
	var location_sale_list_1 = __webpack_require__(937);
	var location_sale_details_1 = __webpack_require__(941);
	var shared_2 = __webpack_require__(925);
	var LocationModule = (function () {
	    function LocationModule() {
	    }
	    LocationModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                ng2_material_components_1.MaterialFormsModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                location_routing_1.locationRouting,
	                shared_module_1.SharedModule,
	            ],
	            exports: [
	                location_component_1.LocationComponent,
	                location_index_component_1.LocationIndexComponent,
	                location_sale_list_1.LocationSaleListComponent,
	                location_sale_details_1.LocationSaleDetailsComponent,
	                shared_1.LocationsFilterSheetComponent
	            ],
	            declarations: [
	                location_component_1.LocationComponent,
	                location_index_component_1.LocationIndexComponent,
	                location_sale_list_1.LocationSaleListComponent,
	                location_sale_details_1.LocationSaleDetailsComponent,
	                shared_1.LocationsFilterSheetComponent
	            ],
	            providers: [shared_2.LocationSaleService, shared_2.LocationSaleDetailsService],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocationModule);
	    return LocationModule;
	}());
	exports.LocationModule = LocationModule;


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(77);
	var location_component_1 = __webpack_require__(673);
	var location_index_component_1 = __webpack_require__(924);
	var location_sale_details_component_1 = __webpack_require__(934);
	var locationRoutes = [
	    {
	        path: 'locations',
	        component: location_component_1.LocationComponent,
	        children: [
	            {
	                path: '',
	                component: location_index_component_1.LocationIndexComponent,
	            },
	            {
	                path: 'detail/:id',
	                component: location_sale_details_component_1.LocationSaleDetailsComponent
	            }
	        ]
	    }
	];
	exports.locationRouting = router_1.RouterModule.forChild(locationRoutes);


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ui_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(2);
	var shared_1 = __webpack_require__(925);
	var shared_2 = __webpack_require__(594);
	var forms_1 = __webpack_require__(27);
	var services_1 = __webpack_require__(274);
	var LocationIndexComponent = (function (_super) {
	    __extends(LocationIndexComponent, _super);
	    function LocationIndexComponent(locationSaleService, store, storeHelper, userService) {
	        _super.call(this, store, storeHelper, userService);
	        this.locationSaleService = locationSaleService;
	        this.fg = new forms_1.FormGroup({});
	        this._searchAction = { id: 'calendar', icon: 'calendar' };
	        this._filterReady = false;
	        this.rangeDate = new shared_2.DateRange();
	        this.empty = false;
	        this.loading = true;
	        this.authorized = true;
	        // set title and actions
	        this.headerTitle = 'Locations';
	        this.headerActions = [this._searchAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	    }
	    LocationIndexComponent.prototype.ngOnInit = function () {
	        this.appPage.activatePreloader();
	    };
	    LocationIndexComponent.prototype.onFilterChanged = function (filter) {
	        this._locationFilter = filter;
	        this._loadLocationSaleList();
	    };
	    LocationIndexComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._searchAction.id && this.authorized) {
	            this.filterSheet.toggle();
	        }
	    };
	    LocationIndexComponent.prototype._loadLocationSaleList = function () {
	        var _this = this;
	        var that = this;
	        this._FilterLocationListByName();
	        if (this._locationFilter.locationsSelection.locations.length < 1) {
	            this._resetLocationSales();
	            this.empty = true;
	            if (this.empty) {
	                setTimeout(function () { return _this.filterSheet.toggle(); }, 1500);
	            }
	            if (this._filterReady) {
	                this.filterSheet.toggle();
	            }
	            this._filterReady = true;
	            return;
	        }
	        this.loading = true;
	        this.locationSaleService.getLocationSales(this._locationFilter)
	            .subscribe(function (locations) {
	            _this.empty = locations.length <= 0;
	            _this.locationinvoiceOpen = locations.filter(function (l) { return l.open === true; });
	            _this.locationinvoiceClosed = locations.filter(function (l) { return l.open === false; });
	            if (_this.empty) {
	                setTimeout(function () { return _this.filterSheet.toggle(); }, 1500);
	            }
	            if (_this._filterReady) {
	                _this.filterSheet.toggle();
	            }
	            _this._filterReady = true;
	            that.appPage.deactivatePreloader();
	        }, function (err) {
	            _this.authorized = _this.userService.userHasAccess(err);
	            _this.appPage.deactivatePreloader();
	            _this.loading = false;
	            _this._resetLocationSales();
	        }, function () { return that.loading = false; });
	    };
	    LocationIndexComponent.prototype._FilterLocationListByName = function () {
	        var _this = this;
	        this.filterByName = this._locationFilter.filter.toLowerCase() || '';
	        if (this._locationFilter.locationsSelection.locations.length > 0) {
	            this._locationFilter.locationsSelection.locations = this.filterByName !== ''
	                ? this._locationFilter.locationsSelection.locations.filter(function (l) { return l.name.toLowerCase().indexOf(_this.filterByName) !== -1; })
	                : this._locationFilter.locationsSelection.locations;
	        }
	        else {
	            this._UpdateLocationsByRegion();
	        }
	    };
	    LocationIndexComponent.prototype._UpdateLocationsByRegion = function () {
	        var _this = this;
	        this._locationFilter.locationsSelection.locations = this.filterByName !== ''
	            ? this._locationFilter.locationsSelection.region.locations.filter(function (l) { return l.name.toLowerCase().indexOf(_this.filterByName) !== -1; })
	            : this._locationFilter.locationsSelection.region.locations;
	    };
	    LocationIndexComponent.prototype._resetLocationSales = function () {
	        this.locationinvoiceOpen = [];
	        this.locationinvoiceClosed = [];
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], LocationIndexComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(shared_1.LocationsFilterSheetComponent), 
	        __metadata('design:type', Object)
	    ], LocationIndexComponent.prototype, "filterSheet", void 0);
	    LocationIndexComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(933)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof shared_1.LocationSaleService !== 'undefined' && shared_1.LocationSaleService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _b) || Object, (typeof (_c = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _c) || Object, (typeof (_d = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _d) || Object])
	    ], LocationIndexComponent);
	    return LocationIndexComponent;
	    var _a, _b, _c, _d;
	}(shared_2.TopLevelComponent));
	exports.LocationIndexComponent = LocationIndexComponent;


/***/ },
/* 925 */
[1081, 589, 926, 929],
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(927));
	__export(__webpack_require__(928));


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(589);
	var LocationSaleDetailsService = (function () {
	    function LocationSaleDetailsService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    LocationSaleDetailsService.prototype.getListInvoiceByLocation = function (filter) {
	        var that = this;
	        return this._api.get(this._bi.url, 'reporting/invoices', filter)
	            .map(function (details) { return that._prepareLocationInvoiceDetails(details.data); })
	            .cache();
	    };
	    LocationSaleDetailsService.prototype._prepareLocationInvoiceDetails = function (details) {
	        return details.map(function (detail) { return new models_1.LocationInvoiceDetail(detail); });
	    };
	    LocationSaleDetailsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], LocationSaleDetailsService);
	    return LocationSaleDetailsService;
	    var _a, _b;
	}());
	exports.LocationSaleDetailsService = LocationSaleDetailsService;


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(589);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var LocationSaleService = (function () {
	    function LocationSaleService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    LocationSaleService.prototype.getLocationSales = function (filter) {
	        var that = this;
	        return this._api.get(this._bi.url, 'reporting/mobile/sales/locations', filter)
	            .map(function (sales) { return that._prepareLocations(sales); })
	            .cache();
	    };
	    LocationSaleService.prototype._prepareLocations = function (sales) {
	        return sales.map(function (sale) { return new models_1.LocationSale(sale); });
	    };
	    LocationSaleService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], LocationSaleService);
	    return LocationSaleService;
	    var _a, _b;
	}());
	exports.LocationSaleService = LocationSaleService;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(930));


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(931));


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var ui_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var models_2 = __webpack_require__(589);
	var LocationsFilterSheetComponent = (function () {
	    function LocationsFilterSheetComponent(_userSvc) {
	        this._userSvc = _userSvc;
	        this.filterChanged = new core_1.EventEmitter();
	        this.dateOptions = ['Today', 'Custom Range'];
	        this.activeOption = this.dateOptions[0];
	    }
	    LocationsFilterSheetComponent.prototype.locationPickerReady = function () {
	        this.applyFilter(null);
	    };
	    LocationsFilterSheetComponent.prototype.toggle = function () {
	        this.sheet.toggle();
	    };
	    LocationsFilterSheetComponent.prototype.onDateOptionSelected = function (option) {
	        this.showDateRange = option === 'Custom Range';
	    };
	    LocationsFilterSheetComponent.prototype.applyFilter = function (e) {
	        var _this = this;
	        if (e) {
	            e.preventDefault();
	        }
	        var value = this.fg.value;
	        var dateRange = this.showDateRange ?
	            new models_1.DateRange(value.from, value.to)
	            : new models_1.DateRange();
	        this.IsValidDateRange = dateRange.isValid;
	        if (this.IsValidDateRange) {
	            var locationsPickerSelection = this.locationPicker.getSelection();
	            var filter_1 = new models_2.LocationsFilter(dateRange, locationsPickerSelection, value.filter);
	            setTimeout(function () { return _this.filterChanged.emit(filter_1); }, 10);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
	    ], LocationsFilterSheetComponent.prototype, "fg", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof models_2.LocationsFilter !== 'undefined' && models_2.LocationsFilter) === 'function' && _b) || Object)
	    ], LocationsFilterSheetComponent.prototype, "filter", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], LocationsFilterSheetComponent.prototype, "filterChanged", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.SheetComponent), 
	        __metadata('design:type', Object)
	    ], LocationsFilterSheetComponent.prototype, "sheet", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.LocationPickerComponent), 
	        __metadata('design:type', Object)
	    ], LocationsFilterSheetComponent.prototype, "locationPicker", void 0);
	    LocationsFilterSheetComponent = __decorate([
	        core_1.Component({
	            selector: 'locations-filter-sheet',
	            template: __webpack_require__(932)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _c) || Object])
	    ], LocationsFilterSheetComponent);
	    return LocationsFilterSheetComponent;
	    var _a, _b, _c;
	}());
	exports.LocationsFilterSheetComponent = LocationsFilterSheetComponent;


/***/ },
/* 932 */
/***/ function(module, exports) {

	module.exports = "<sheet><div class=\"text-center m-b-15\"><bw-button-group [options]=\"dateOptions\" [activeOption]=\"activeOption\" type=\"danger\" (optionSelected)=\"onDateOptionSelected($event)\"></bw-button-group></div><div class=\"layout-row layout-padding\">       <text-box [fg]=\"fg\" [alt]=\"true\" field=\"filter\" leftIcon=\"search\" label=\"Filter locations\"></text-box></div><date-range [fg]=\"fg\" [hidden]=\"!showDateRange\"></date-range><div class=\"text-center c-white animated shake\" *ngIf=\"showDateRange &amp;&amp; !IsValidDateRange\"><i class=\"zmdi zmdi-info-outline m-r-10\"> </i>Invalid Range</div><location-picker [fg]=\"fg\" (filterReady)=\"locationPickerReady($event)\"></location-picker><div class=\"text-right m-b-10\"><bw-button title=\"Apply\" icon=\"check\" [simple]=\"true\" (click)=\"applyFilter($event)\"></bw-button></div></sheet>";

/***/ },
/* 933 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"flex\" *ngIf=\"authorized\"><locations-filter-sheet [fg]=\"fg\" (filterChanged)=\"onFilterChanged($event)\"></locations-filter-sheet><my-location-sale-list [locationinvoiceOpen]=\"locationinvoiceOpen\" [locationinvoiceClosed]=\"locationinvoiceClosed\" [locationFilter]=\"_locationFilter\" [empty]=\"empty\"> </my-location-sale-list></div><user-feedback [hidden]=\"authorized || loading\" type=\"info\" message=\"User - Not Authorized\"></user-feedback></app-page>";

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ui_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(2);
	var shared_1 = __webpack_require__(594);
	var services_1 = __webpack_require__(274);
	var shared_2 = __webpack_require__(925);
	var LocationSaleDetailsComponent = (function (_super) {
	    __extends(LocationSaleDetailsComponent, _super);
	    function LocationSaleDetailsComponent(_locationSaleDetailsService, store, storeHelper, userService) {
	        var _this = this;
	        _super.call(this, store, storeHelper, userService);
	        this._locationSaleDetailsService = _locationSaleDetailsService;
	        this.locationInvoicesDetails = [];
	        var that = this;
	        var storeState = this.store.getState();
	        this.locationName = storeState.locationInvoiceDetailFilter.locationSale.name;
	        this.headerTitle = this.locationName;
	        this._invoicesSubs = this._locationSaleDetailsService.getListInvoiceByLocation(storeState.locationInvoiceDetailFilter)
	            .subscribe(function (data) {
	            _this.locationInvoicesDetails = data;
	            that.preloader.hide();
	        });
	    }
	    LocationSaleDetailsComponent.prototype.ngOnInit = function () {
	        this.preloader.show();
	    };
	    LocationSaleDetailsComponent.prototype.ngOnDestroy = function () {
	        this._invoicesSubs.unsubscribe();
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.PagePreloaderComponent), 
	        __metadata('design:type', Object)
	    ], LocationSaleDetailsComponent.prototype, "preloader", void 0);
	    LocationSaleDetailsComponent = __decorate([
	        core_1.Component({
	            selector: 'location-sale-details',
	            styles: [__webpack_require__(935)],
	            template: __webpack_require__(936)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof shared_2.LocationSaleDetailsService !== 'undefined' && shared_2.LocationSaleDetailsService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _b) || Object, (typeof (_c = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _c) || Object, (typeof (_d = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _d) || Object])
	    ], LocationSaleDetailsComponent);
	    return LocationSaleDetailsComponent;
	    var _a, _b, _c, _d;
	}(shared_1.TopLevelComponent));
	exports.LocationSaleDetailsComponent = LocationSaleDetailsComponent;


/***/ },
/* 935 */
809,
/* 936 */
/***/ function(module, exports) {

	module.exports = "<page-preloader></page-preloader><div class=\"h-100\"><div class=\"score\" *ngFor=\"let invoice of locationInvoicesDetails\"><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">{{invoice.timestamp | toLocalDate}}</div></div></div><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">Invoice Number #  {{ invoice.id}}</div><small>{{invoice.location.name}}</small></div><div class=\"flex-nogrow results amount\" [class.sale]=\"invoice.subTotal &gt; 0\" [class.refund]=\"invoice.subTotal &lt;= 0\">{{ invoice.subTotal| currency:'USD':true}}</div></div></div></div>";

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(938));


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var shared_1 = __webpack_require__(594);
	var services_1 = __webpack_require__(274);
	var shared_2 = __webpack_require__(925);
	var LocationSaleListComponent = (function (_super) {
	    __extends(LocationSaleListComponent, _super);
	    function LocationSaleListComponent(store, storeHelper, userService) {
	        _super.call(this, store, storeHelper, userService);
	        this.showLocationSaleDetails = false;
	    }
	    LocationSaleListComponent.prototype.showInvoices = function (locationSale) {
	        var filter = new shared_2.LocationInvoiceDetailFilter(this.locationFilter, locationSale);
	        this.storeHelper.update('locationInvoiceDetailFilter', filter);
	        this.selectedLocation = locationSale;
	        this.showLocationSaleDetails = true;
	    };
	    LocationSaleListComponent.prototype.locationSaleClosed = function () {
	        this.showLocationSaleDetails = false;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], LocationSaleListComponent.prototype, "locationinvoiceOpen", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], LocationSaleListComponent.prototype, "locationinvoiceClosed", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof shared_1.DateRange !== 'undefined' && shared_1.DateRange) === 'function' && _a) || Object)
	    ], LocationSaleListComponent.prototype, "rangeDate", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof shared_2.LocationsFilter !== 'undefined' && shared_2.LocationsFilter) === 'function' && _b) || Object)
	    ], LocationSaleListComponent.prototype, "locationFilter", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], LocationSaleListComponent.prototype, "empty", void 0);
	    LocationSaleListComponent = __decorate([
	        core_1.Component({
	            selector: 'my-location-sale-list',
	            styles: [__webpack_require__(939)],
	            template: __webpack_require__(940)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _c) || Object, (typeof (_d = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _d) || Object, (typeof (_e = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _e) || Object])
	    ], LocationSaleListComponent);
	    return LocationSaleListComponent;
	    var _a, _b, _c, _d, _e;
	}(shared_1.TopLevelComponent));
	exports.LocationSaleListComponent = LocationSaleListComponent;


/***/ },
/* 939 */
/***/ function(module, exports) {

	module.exports = ".score{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.score.master{padding-right:30px}.score.master::before{border-style:solid;border-width:0.1em 0.1em 0 0;content:'';display:inline-block;height:0.55em;width:0.55em;position:absolute;top:calc(50% - 10px);vertical-align:top;right:10px;transform:rotate(45deg)}.score::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.score .avatar{float:left;width:50px;font-size:38px}.score .mini-avatar{float:right;width:20px;font-size:20px}.score .content title{font-size:24px}.score .content small{color:#9e9e9e}.score .results{width:100px;text-align:right}.score .secondary{color:#9e9e9e;font-size:11px}section.subtitle{background-color:transparent;text-align:center}section.subtitle .title{color:#ccc}\n"

/***/ },
/* 940 */
/***/ function(module, exports) {

	module.exports = "<paper-cover *ngIf=\"showLocationSaleDetails\" [title]=\"selectedLocation.name\" (closed)=\"locationSaleClosed()\"><location-sale-details></location-sale-details></paper-cover><div class=\"mobile-page-content\"><section class=\"subtitle\" *ngIf=\"locationinvoiceOpen &amp;&amp; locationinvoiceOpen.length &gt; 0\"><h3 class=\"title\">Open</h3></section><div class=\"h-100\" [ngSwitch]=\"empty\"><user-feedback *ngSwitchCase=\"true\" type=\"info\" message=\"No Results Found\"></user-feedback><div *ngSwitchCase=\"false\"><div class=\"score master\" *ngFor=\"let locationSale of locationinvoiceOpen\" (click)=\"showInvoices(locationSale)\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-pin\"></i><div class=\"flex content\"><div class=\"title\">{{locationSale.name}}</div></div><div class=\"flex-nogrow results c-amber\">{{ locationSale.subTotal| currency:'USD':true}}<br/><span class=\"green\" *ngIf=\"locationSale.percent&gt;0\">+{{locationSale.percent}}%</span><span class=\"green\" *ngIf=\"locationSale.percent&lt;0\">-{{locationSale.percent}}%</span></div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right m-r-20\"><span *ngIf=\"locationSale.averagePerHour&gt;0\">Avg Sale per hour</span></div></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ locationSale.averagePerHour | currency:'USD':true }}</div></div></div></div><div class=\"layout-row\" *ngIf=\"locationSale.lastInvoice\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right m-r-20\"><span>Last Sale Date</span></div></div></div><div class=\"flex-nogrow\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ locationSale.lastInvoice | toLocalDate}}</div></div></div></div><div class=\"separator\"></div></div></div><br/><br/></div><section class=\"subtitle\" *ngIf=\"locationinvoiceClosed &amp;&amp; locationinvoiceClosed.length &gt; 0\"><h3 class=\"title\">Closed</h3></section><div class=\"h-100\" [ngSwitch]=\"empty\"><div *ngSwitchCase=\"false\"><div class=\"score master\" *ngFor=\"let locationSale of locationinvoiceClosed\" (click)=\"showInvoices(locationSale)\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-pin\"></i><div class=\"flex content\"><div class=\"title\">{{locationSale.name}}</div></div><div class=\"flex-nogrow results c-amber\">{{ locationSale.subTotal| currency:'USD':true}}<br/><span class=\"green\" *ngIf=\"locationSale.percent&gt;0\">+{{locationSale.percent}}%</span><span class=\"green\" *ngIf=\"locationSale.percent&lt;0\">-{{locationSale.percent}}%</span></div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right m-r-20\"><span *ngIf=\"locationSale.averagePerHour&gt;0\">Avg Sale per hour</span></div></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ locationSale.averagePerHour | currency:'USD':true }}</div></div></div></div><div class=\"layout-row\" *ngIf=\"locationSale.lastInvoice\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right m-r-20\"><span>Last Sale Date</span></div></div></div><div class=\"flex-nogrow\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ locationSale.lastInvoice | toLocalDate}}</div></div></div></div><div class=\"separator\"></div></div></div></div></div>";

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(934));


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(23);
	var inventory_routing_1 = __webpack_require__(943);
	var shared_module_1 = __webpack_require__(26);
	var services_1 = __webpack_require__(274);
	var forms_1 = __webpack_require__(27);
	var ng2_material_components_1 = __webpack_require__(33);
	var inventory_component_1 = __webpack_require__(674);
	var product_list_1 = __webpack_require__(944);
	var services_2 = __webpack_require__(970);
	var inventory_detail_1 = __webpack_require__(975);
	var location_edit_qty_1 = __webpack_require__(997);
	var report_loss_1 = __webpack_require__(1002);
	var product_transfer_1 = __webpack_require__(980);
	var products_transfer_1 = __webpack_require__(984);
	var transfer_overview_1 = __webpack_require__(1007);
	var products_transfer_selected_1 = __webpack_require__(1012);
	var transfer_locations_1 = __webpack_require__(988);
	var product_qty_1 = __webpack_require__(1016);
	var ui_1 = __webpack_require__(946);
	var transfer_history_1 = __webpack_require__(992);
	var transfer_detail_1 = __webpack_require__(1020);
	var InventoryModule = (function () {
	    function InventoryModule() {
	    }
	    InventoryModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                ng2_material_components_1.MaterialFormsModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                inventory_routing_1.inventoryRouting,
	                shared_module_1.SharedModule,
	                forms_1.FormsModule,
	                forms_1.ReactiveFormsModule
	            ],
	            exports: [
	                inventory_component_1.InventoryComponent,
	                product_list_1.ProductListComponent,
	                ui_1.ProductsFilterSheetComponent,
	                inventory_detail_1.InventoryDetailComponent,
	                ui_1.InputFilterSheetComponent,
	                location_edit_qty_1.LocationEditQtyComponent,
	                report_loss_1.ReportLossComponent,
	                product_transfer_1.ProductTransferComponent,
	                transfer_overview_1.TransferOverviewComponent,
	                products_transfer_selected_1.ProductTransferSelectedComponent,
	                transfer_locations_1.TransferLocationsComponent,
	                products_transfer_1.ProductsTransferComponent,
	                product_qty_1.ProductQtyComponent,
	                transfer_history_1.TransferHistoryComponent,
	                transfer_detail_1.TransferDetailComponent
	            ],
	            declarations: [
	                inventory_component_1.InventoryComponent,
	                product_list_1.ProductListComponent,
	                ui_1.ProductsFilterSheetComponent,
	                inventory_detail_1.InventoryDetailComponent,
	                ui_1.InputFilterSheetComponent,
	                location_edit_qty_1.LocationEditQtyComponent,
	                report_loss_1.ReportLossComponent,
	                product_transfer_1.ProductTransferComponent,
	                transfer_overview_1.TransferOverviewComponent,
	                products_transfer_selected_1.ProductTransferSelectedComponent,
	                transfer_locations_1.TransferLocationsComponent,
	                products_transfer_1.ProductsTransferComponent,
	                product_qty_1.ProductQtyComponent,
	                transfer_history_1.TransferHistoryComponent,
	                transfer_detail_1.TransferDetailComponent
	            ],
	            providers: [
	                services_2.ProductListService,
	                inventory_detail_1.InventoryDetailService,
	                services_1.UserService,
	                location_edit_qty_1.LocationEditQtyService,
	                report_loss_1.ReportLossService,
	                transfer_overview_1.TransferService,
	                transfer_history_1.TransferHistoryService,
	                transfer_detail_1.TransferDetailService
	            ],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], InventoryModule);
	    return InventoryModule;
	}());
	exports.InventoryModule = InventoryModule;


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(77);
	var inventory_component_1 = __webpack_require__(674);
	var product_list_1 = __webpack_require__(944);
	var inventory_detail_1 = __webpack_require__(975);
	var product_transfer_1 = __webpack_require__(980);
	var products_transfer_1 = __webpack_require__(984);
	var transfer_locations_1 = __webpack_require__(988);
	var transfer_history_1 = __webpack_require__(992);
	var inventoryRoutes = [
	    {
	        path: 'inventory',
	        component: inventory_component_1.InventoryComponent,
	        children: [
	            {
	                path: '',
	                component: product_list_1.ProductListComponent
	            },
	            {
	                path: 'inventory-detail/:id',
	                component: inventory_detail_1.InventoryDetailComponent
	            },
	            {
	                path: 'trasfer-product/:productId/:locationTo/:locationFrom',
	                component: product_transfer_1.ProductTransferComponent
	            },
	            {
	                path: 'trasfer-products/:locationTo/:locationFrom',
	                component: products_transfer_1.ProductsTransferComponent
	            },
	            {
	                path: 'transfer',
	                component: transfer_locations_1.TransferLocationsComponent
	            },
	            {
	                path: 'transfer-history',
	                component: transfer_history_1.TransferHistoryComponent
	            }
	        ]
	    }
	];
	exports.inventoryRouting = router_1.RouterModule.forChild(inventoryRoutes);


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(945));


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var router_1 = __webpack_require__(77);
	var ui_1 = __webpack_require__(132);
	var ui_2 = __webpack_require__(946);
	var services_1 = __webpack_require__(970);
	var services_2 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var ProductListComponent = (function (_super) {
	    __extends(ProductListComponent, _super);
	    function ProductListComponent(_appStateService, _productListService, _router, _store, _storeHelper, _userSvc) {
	        _super.call(this, _store, _storeHelper, _userSvc);
	        this._appStateService = _appStateService;
	        this._productListService = _productListService;
	        this._router = _router;
	        this.fg = new forms_1.FormGroup({});
	        this.allLocationsSelected = true;
	        this.loading = true;
	        this.authorized = true;
	        this._filterReady = false;
	        this._searchAction = { id: 'search', icon: 'search' };
	        this.headerTitle = 'Inventory View';
	        this.headerActions = [this._searchAction];
	        //Hide back action in header section
	        this._appStateService.changeBackActionValue(false);
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	    }
	    ProductListComponent.prototype.ngOnDestroy = function () {
	        if (this._preloaderSubs)
	            this._preloaderSubs.unsubscribe();
	    };
	    ProductListComponent.prototype.onFilterChanged = function (filter) {
	        var _this = this;
	        this._productFilter = filter;
	        if (this._productFilter.locationsSelection.locations.length > 0) {
	            this._loadProducts();
	        }
	        else {
	            this._resetProductData();
	            this.empty = true;
	            setTimeout(function () { return _this.productsFilterSheetComponent.toggle(); }, 1500);
	            if (this._filterReady) {
	                this.productsFilterSheetComponent.toggle();
	            }
	            this._filterReady = true;
	        }
	    };
	    ProductListComponent.prototype.editInventory = function (product) {
	        this._router.navigate(['/inventory/inventory-detail', product.id]);
	    };
	    ProductListComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._searchAction.id && this.authorized) {
	            this.productsFilterSheetComponent.toggle();
	        }
	    };
	    ProductListComponent.prototype._getProducts = function () {
	        var _this = this;
	        var that = this;
	        this.empty = false;
	        this.appPage.activatePreloader();
	        this.loading = true;
	        this.products$ = this._productListService.getProducts(this._productFilter);
	        this._preloaderSubs = this.products$.subscribe(function (res) {
	            that.appPage.deactivatePreloader();
	            _this.empty = res.length <= 0;
	            if (_this.empty) {
	                setTimeout(function () { return that.productsFilterSheetComponent.toggle(); }, 1500);
	            }
	        }, function (err) {
	            _this.authorized = _this.userService.userHasAccess(err);
	            _this.appPage.deactivatePreloader();
	            _this.loading = false;
	        }, function () { return that.loading = false; });
	        if (this._filterReady) {
	            this.productsFilterSheetComponent.toggle();
	        }
	        this._filterReady = true;
	    };
	    ProductListComponent.prototype._getStockInformation = function () {
	        var _this = this;
	        this._productListService.getStockInformation(this._productFilter.locationsSelection)
	            .subscribe(function (inOutStock) {
	            _this.productsFilterSheetComponent.setInventoryOptions(inOutStock.inStock, inOutStock.outStock);
	        }, function (error) { return console.log(error); });
	    };
	    ProductListComponent.prototype._loadProducts = function () {
	        this._getProducts();
	        this._getStockInformation();
	    };
	    ProductListComponent.prototype._resetProductData = function () {
	        this.products$.subscribe(function (i) { return i.splice(0); });
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], ProductListComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(ui_2.ProductsFilterSheetComponent), 
	        __metadata('design:type', Object)
	    ], ProductListComponent.prototype, "productsFilterSheetComponent", void 0);
	    ProductListComponent = __decorate([
	        core_1.Component({
	            styles: [__webpack_require__(973)],
	            template: __webpack_require__(974)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_2.AppStateService !== 'undefined' && services_2.AppStateService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ProductListService !== 'undefined' && services_1.ProductListService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof services_2.Store !== 'undefined' && services_2.Store) === 'function' && _d) || Object, (typeof (_e = typeof services_2.StoreHelper !== 'undefined' && services_2.StoreHelper) === 'function' && _e) || Object, (typeof (_f = typeof services_2.UserService !== 'undefined' && services_2.UserService) === 'function' && _f) || Object])
	    ], ProductListComponent);
	    return ProductListComponent;
	    var _a, _b, _c, _d, _e, _f;
	}(models_1.TopLevelComponent));
	exports.ProductListComponent = ProductListComponent;


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(947));
	__export(__webpack_require__(950));


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(948));


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var ui_1 = __webpack_require__(132);
	var InputFilterSheetComponent = (function () {
	    function InputFilterSheetComponent() {
	        this.applyChanges = new core_1.EventEmitter();
	    }
	    InputFilterSheetComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.fg.controls['filter'].valueChanges
	            .debounceTime(50)
	            .subscribe(function (value) { return _this.onApplyClicked(value); });
	    };
	    InputFilterSheetComponent.prototype.toggle = function () {
	        this.sheet.toggle();
	    };
	    InputFilterSheetComponent.prototype.onApplyClicked = function (filter) {
	        this.applyChanges.emit(filter);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
	    ], InputFilterSheetComponent.prototype, "fg", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], InputFilterSheetComponent.prototype, "placeholder", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], InputFilterSheetComponent.prototype, "applyChanges", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.SheetComponent), 
	        __metadata('design:type', Object)
	    ], InputFilterSheetComponent.prototype, "sheet", void 0);
	    InputFilterSheetComponent = __decorate([
	        core_1.Component({
	            selector: 'input-filter-sheet',
	            template: __webpack_require__(949)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], InputFilterSheetComponent);
	    return InputFilterSheetComponent;
	    var _a;
	}());
	exports.InputFilterSheetComponent = InputFilterSheetComponent;


/***/ },
/* 949 */
/***/ function(module, exports) {

	module.exports = "<sheet><div class=\"layout-row layout-padding\">       <text-box [fg]=\"fg\" [alt]=\"true\" field=\"filter\" leftIcon=\"search\" label=\"{{placeholder}}\"></text-box></div></sheet>";

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(951));


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var ui_1 = __webpack_require__(132);
	var shared_1 = __webpack_require__(952);
	var ProductsFilterSheetComponent = (function () {
	    function ProductsFilterSheetComponent() {
	        this.filterChanged = new core_1.EventEmitter();
	        this.inventoryOptions = [];
	        this.setInventoryOptions(0, 0);
	    }
	    ProductsFilterSheetComponent.prototype.locationPickerReady = function () {
	        this.onApplyClicked(null);
	    };
	    ProductsFilterSheetComponent.prototype.toggle = function () {
	        this.sheet.toggle();
	    };
	    ProductsFilterSheetComponent.prototype.onStockOptionSelected = function (option) {
	        this._inStock = option.indexOf('In') === 0;
	        this._outStock = option.indexOf('Out') === 0;
	    };
	    ProductsFilterSheetComponent.prototype.onApplyClicked = function (e) {
	        if (e) {
	            e.preventDefault();
	        }
	        var form = this.fg;
	        if (form.valid) {
	            var locationsPickerSelection = this.locationPickerComponent.getSelection();
	            var filter = new shared_1.ProductFilter(form.value.filter, locationsPickerSelection, this._inStock, this._outStock);
	            this.filterChanged.emit(filter);
	        }
	    };
	    ProductsFilterSheetComponent.prototype.setInventoryOptions = function (inStock, outStock) {
	        this.inventoryOptions = [
	            ("In Stock(" + (inStock || 0) + ")"),
	            ("Out Stock(" + (outStock || 0) + ")")
	        ];
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
	    ], ProductsFilterSheetComponent.prototype, "fg", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], ProductsFilterSheetComponent.prototype, "filterChanged", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.SheetComponent), 
	        __metadata('design:type', Object)
	    ], ProductsFilterSheetComponent.prototype, "sheet", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.LocationPickerComponent), 
	        __metadata('design:type', Object)
	    ], ProductsFilterSheetComponent.prototype, "locationPickerComponent", void 0);
	    ProductsFilterSheetComponent = __decorate([
	        core_1.Component({
	            selector: 'products-filter-sheet',
	            template: __webpack_require__(972)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ProductsFilterSheetComponent);
	    return ProductsFilterSheetComponent;
	    var _a;
	}());
	exports.ProductsFilterSheetComponent = ProductsFilterSheetComponent;


/***/ },
/* 952 */
[1080, 946, 953, 970],
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(954));
	__export(__webpack_require__(955));
	__export(__webpack_require__(956));
	__export(__webpack_require__(957));
	__export(__webpack_require__(958));
	__export(__webpack_require__(959));
	__export(__webpack_require__(960));
	__export(__webpack_require__(961));
	__export(__webpack_require__(962));
	__export(__webpack_require__(963));
	__export(__webpack_require__(964));
	__export(__webpack_require__(965));
	__export(__webpack_require__(966));
	__export(__webpack_require__(967));
	__export(__webpack_require__(968));
	__export(__webpack_require__(969));


/***/ },
/* 954 */
/***/ function(module, exports) {

	"use strict";
	var InOutStock = (function () {
	    function InOutStock(inStock, outStock) {
	        this.inStock = inStock || 0;
	        this.outStock = outStock || 0;
	    }
	    return InOutStock;
	}());
	exports.InOutStock = InOutStock;


/***/ },
/* 955 */
/***/ function(module, exports) {

	"use strict";
	var Inventory = (function () {
	    function Inventory() {
	    }
	    return Inventory;
	}());
	exports.Inventory = Inventory;


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var InventoryLocation = (function (_super) {
	    __extends(InventoryLocation, _super);
	    function InventoryLocation(data) {
	        _super.call(this);
	        Object.assign(this, data);
	    }
	    InventoryLocation.prototype.updateMissQty = function (qty) {
	        this.missQuantity = qty || 0 - this.maximum || 0;
	    };
	    return InventoryLocation;
	}(models_1.Location));
	exports.InventoryLocation = InventoryLocation;


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var shared_1 = __webpack_require__(594);
	var Product = (function (_super) {
	    __extends(Product, _super);
	    function Product(data) {
	        _super.call(this);
	        this.isSelectedForTransfer = false;
	        this.addedToTransfer = false;
	        Object.assign(this, data);
	    }
	    return Product;
	}(shared_1.IdName));
	exports.Product = Product;


/***/ },
/* 958 */
/***/ function(module, exports) {

	"use strict";
	var ProductFamily = (function () {
	    function ProductFamily() {
	    }
	    return ProductFamily;
	}());
	exports.ProductFamily = ProductFamily;


/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var ProductFilter = (function () {
	    function ProductFilter(name, locationsSelection, inStock, outStock) {
	        this.name = name;
	        this.locationsSelection = locationsSelection;
	        this.inStock = inStock;
	        this.outStock = outStock;
	    }
	    ProductFilter.prototype.toQueryString = function () {
	        var payload = {
	            name: this.name,
	            instock: this.inStock,
	            outStock: this.outStock
	        };
	        this.locationsSelection = this.locationsSelection || new models_1.LocationPickerSelection();
	        return "" + models_1.objToQueryString(payload) + this.locationsSelection.toQueryString();
	    };
	    return ProductFilter;
	}());
	exports.ProductFilter = ProductFilter;


/***/ },
/* 960 */
/***/ function(module, exports) {

	"use strict";
	var LocationQtyDetail = (function () {
	    function LocationQtyDetail(locationId, productId, details) {
	        this.locationId = locationId;
	        this.productId = productId;
	        this.details = details;
	    }
	    return LocationQtyDetail;
	}());
	exports.LocationQtyDetail = LocationQtyDetail;


/***/ },
/* 961 */
/***/ function(module, exports) {

	"use strict";
	var QtyDetail = (function () {
	    function QtyDetail(current) {
	        this.current = current;
	    }
	    return QtyDetail;
	}());
	exports.QtyDetail = QtyDetail;


/***/ },
/* 962 */
/***/ function(module, exports) {

	"use strict";
	var Report = (function () {
	    function Report(productId, locationId, details) {
	        this.productId = productId;
	        this.locationId = locationId;
	        this.details = details;
	    }
	    return Report;
	}());
	exports.Report = Report;


/***/ },
/* 963 */
/***/ function(module, exports) {

	"use strict";
	var ReportDetail = (function () {
	    function ReportDetail(quantity, reason, comments) {
	        this.quantity = quantity;
	        this.reason = reason;
	        this.comments = comments;
	    }
	    return ReportDetail;
	}());
	exports.ReportDetail = ReportDetail;


/***/ },
/* 964 */
/***/ function(module, exports) {

	"use strict";
	var Transfer = (function () {
	    function Transfer(origin, destination, products, isRequest) {
	        this.origin = origin;
	        this.destination = destination;
	        this.products = products;
	        this.type = 'Regular';
	        this.workflow = isRequest ? 'Request' : 'Send';
	    }
	    return Transfer;
	}());
	exports.Transfer = Transfer;


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var ProductTransferFilter = (function () {
	    function ProductTransferFilter(name, locations) {
	        this.name = name;
	        this.locations = locations;
	    }
	    ProductTransferFilter.prototype.toQueryString = function () {
	        var payload = {
	            name: this.name,
	            locations: this.locations,
	        };
	        return "" + models_1.objToQueryString(payload);
	    };
	    return ProductTransferFilter;
	}());
	exports.ProductTransferFilter = ProductTransferFilter;


/***/ },
/* 966 */
/***/ function(module, exports) {

	"use strict";
	var TransferDetail = (function () {
	    function TransferDetail() {
	    }
	    return TransferDetail;
	}());
	exports.TransferDetail = TransferDetail;


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var moment = __webpack_require__(139);
	var TransferHistoryFilter = (function () {
	    function TransferHistoryFilter(date) {
	        this.date = date;
	    }
	    TransferHistoryFilter.prototype.toQueryString = function () {
	        var start = this.date ? moment(this.date.start).startOf('day') : null;
	        var end = this.date ? moment(this.date.end).endOf('day') : null;
	        var payload = {
	            'sent[start]': start ? start.format('MM/DD/YYYY HH:mm:ss') : '',
	            'sent[end]': end ? end.format('MM/DD/YYYY HH:mm:ss') : '',
	        };
	        return models_1.objToQueryString(payload);
	    };
	    return TransferHistoryFilter;
	}());
	exports.TransferHistoryFilter = TransferHistoryFilter;


/***/ },
/* 968 */
/***/ function(module, exports) {

	"use strict";
	var TransferDelete = (function () {
	    function TransferDelete() {
	        this.ids = [];
	    }
	    TransferDelete.prototype.addTransferToDelete = function (id) {
	        this.ids.push(id);
	    };
	    return TransferDelete;
	}());
	exports.TransferDelete = TransferDelete;


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var shared_1 = __webpack_require__(594);
	var TransferProduct = (function (_super) {
	    __extends(TransferProduct, _super);
	    function TransferProduct(data) {
	        _super.call(this);
	        Object.assign(this, data);
	    }
	    return TransferProduct;
	}(shared_1.IdName));
	exports.TransferProduct = TransferProduct;


/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(971));


/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	__webpack_require__(277);
	__webpack_require__(339);
	var models_1 = __webpack_require__(953);
	var services_1 = __webpack_require__(274);
	var ProductListService = (function () {
	    function ProductListService(_apiService, _configService) {
	        this._apiService = _apiService;
	        this._configService = _configService;
	        this.products = [];
	        this._inventory = this._configService.getContext('inventory');
	    }
	    ProductListService.prototype.getProducts = function (filter) {
	        return this._apiService.get(this._inventory.url, 'inventory', filter)
	            .map(function (response) { return response.data.map(function (p) { return new models_1.Product(p); }); })
	            .cache();
	    };
	    ProductListService.prototype.getStockInformation = function (location) {
	        return this._apiService.get(this._inventory.url, "inventory/location/quantity", location)
	            .map(function (response) {
	            return new models_1.InOutStock(response.inStock, response.outStock);
	        })
	            .cache();
	    };
	    ProductListService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], ProductListService);
	    return ProductListService;
	    var _a, _b;
	}());
	exports.ProductListService = ProductListService;


/***/ },
/* 972 */
/***/ function(module, exports) {

	module.exports = "<sheet><div class=\"text-center m-b-15\"><bw-button-group [options]=\"inventoryOptions\" type=\"danger\" (optionSelected)=\"onStockOptionSelected($event)\"></bw-button-group></div><div class=\"layout-row layout-padding\">       <text-box [fg]=\"fg\" [alt]=\"true\" field=\"filter\" leftIcon=\"search\" label=\"Filter products\"></text-box></div><location-picker [fg]=\"fg\" (filterReady)=\"locationPickerReady($event)\"></location-picker><div class=\"layout-row layout-align-end layout-padding\"><bw-button title=\"Apply\" icon=\"check\" color=\"white\" [simple]=\"true\" (clicked)=\"onApplyClicked($event)\"></bw-button></div></sheet>";

/***/ },
/* 973 */
/***/ function(module, exports) {

	module.exports = ".product{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 30px;position:relative}.product.master{padding-right:30px}.product.master::before{border-style:solid;border-width:0.1em 0.1em 0 0;content:'';display:inline-block;height:0.55em;width:0.55em;position:absolute;top:calc(50% - 10px);vertical-align:top;right:10px;transform:rotate(45deg)}.product::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.product .avatar{float:left;width:50px;font-size:38px}.product .content title{font-size:24px}.product .content small{color:#9e9e9e}.product .results{width:80px;text-align:right}.product .secondary{color:#9e9e9e;font-size:11px}.product .qty.positive{color:#FFC107}.product .qty.negative{color:#E41736}\n"

/***/ },
/* 974 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"flex\" *ngIf=\"authorized\"><products-filter-sheet (filterChanged)=\"onFilterChanged($event)\" [fg]=\"fg\"></products-filter-sheet><div class=\"mobile-page-content\"><div class=\"h-100\" [ngSwitch]=\"empty\"><user-feedback *ngSwitchCase=\"true\" type=\"info\" message=\"No Results Found\"></user-feedback><div *ngSwitchCase=\"false\"><div class=\"product master\" *ngFor=\"let product of products$ | async\" (click)=\"editInventory(product)\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-shopping-cart-add\"></i><div class=\"flex content\"><div class=\"title\">{{product.name}}</div><small>{{product.category}}</small></div><div class=\"flex-nogrow results qty\" [class.positive]=\"product.current &gt; 0\" [class.negative]=\"product.current &lt;= 0\">{{product.current || 0}}</div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">Total Miss Qty</div><div class=\"flex text-right\">Size </div><div class=\"flex text-right\">Color</div><div class=\"flex text-right\">Locations                           </div></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ product.missQuantity || 0 }}</div><div class=\"flex text-right\">{{ product.size }}</div><div class=\"flex text-right\">{{ product.color }}</div><div class=\"flex text-right\">{{ product.locationsCount }}</div></div></div></div></div></div></div></div></div><user-feedback [hidden]=\"authorized || loading\" type=\"info\" message=\"User - Not Authorized\"></user-feedback></app-page>";

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(976));
	__export(__webpack_require__(977));


/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(77);
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var ui_1 = __webpack_require__(946);
	var ui_2 = __webpack_require__(132);
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var inventory_detail_service_1 = __webpack_require__(977);
	var InventoryDetailComponent = (function (_super) {
	    __extends(InventoryDetailComponent, _super);
	    function InventoryDetailComponent(_appStateService, _inventoryDetailService, _route, _router, _store, _storeHelper, _userSvc) {
	        _super.call(this, _store, _storeHelper, _userSvc);
	        this._appStateService = _appStateService;
	        this._inventoryDetailService = _inventoryDetailService;
	        this._route = _route;
	        this._router = _router;
	        this.fg = new forms_1.FormGroup({});
	        this.showReportDetails = false;
	        this.product = {};
	        this.actionItems = [{ icon: 'edit' }, { icon: 'card-alert' }, { icon: 'swap' }];
	        this.editActionItems = [{ icon: 'check' }, { icon: 'undo' }];
	        this._totalLocations = 0;
	        this._searchAction = { id: 'search', icon: 'search' };
	        this.headerTitle = 'Manage Product';
	        this.headerActions = [this._searchAction];
	        this.subscribeToBackHeaderAction(this._reactToBackHeaderAction);
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	    }
	    InventoryDetailComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        //Show back action in header section
	        this._appStateService.changeBackActionValue(true);
	        this._route.params.forEach(function (params) {
	            var id = +params['id'];
	            _this._getProductById(id);
	        });
	    };
	    InventoryDetailComponent.prototype.onFilterChanged = function (filter) {
	        if (filter) {
	            this.locations = this.product.locations.filter(function (l) { return l.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0; });
	        }
	        else {
	            this.locations = this.product.locations;
	        }
	        this.updateProductInformation();
	    };
	    InventoryDetailComponent.prototype.onActionClicked = function (action, location) {
	        switch (action.icon) {
	            case 'edit':
	                this.locations.forEach(function (l) { return l.editMode = l.id === location.id; });
	                break;
	            case 'card-alert':
	                this._showReport(location);
	                break;
	            case 'swap':
	                if (this._totalLocations > 1) {
	                    this._transferProducts(location);
	                }
	                else {
	                    location.transferNotAllowed = true;
	                }
	                break;
	        }
	    };
	    InventoryDetailComponent.prototype.updateProductInformation = function () {
	        var current = 0;
	        var maximum = 0;
	        this.locations.map(function (l) {
	            current += +l.current;
	            maximum += +l.maximum;
	        });
	        this.product.current = current;
	        this.product.missQuantity = current - maximum;
	    };
	    InventoryDetailComponent.prototype.coverClosed = function () {
	        this.showReportDetails = false;
	        this.headerTitle = 'Manage Product';
	    };
	    InventoryDetailComponent.prototype._showReport = function (location) {
	        this.locationSelectedToReport = location;
	        this.showReportDetails = true;
	    };
	    InventoryDetailComponent.prototype._transferProducts = function (location) {
	        this._router.navigate(['/inventory/trasfer-product', this.product.id, location.id, 0]);
	    };
	    InventoryDetailComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._searchAction.id) {
	            this.inputFilterSheetComponent.toggle();
	        }
	    };
	    InventoryDetailComponent.prototype._reactToBackHeaderAction = function () {
	        this._router.navigate(['/inventory']);
	    };
	    InventoryDetailComponent.prototype._getProductById = function (productId) {
	        var _this = this;
	        this._inventoryDetailService.getProductById(productId)
	            .subscribe(function (res) {
	            _this.appPage.deactivatePreloader();
	            _this.product = res;
	            _this.locations = res.locations;
	            _this._totalLocations = res.locations.length;
	        }, function (error) { return console.log(error); });
	    };
	    __decorate([
	        core_1.ViewChild(ui_2.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], InventoryDetailComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.InputFilterSheetComponent), 
	        __metadata('design:type', Object)
	    ], InventoryDetailComponent.prototype, "inputFilterSheetComponent", void 0);
	    InventoryDetailComponent = __decorate([
	        core_1.Component({
	            selector: 'inventory-detail',
	            styles: [__webpack_require__(978)],
	            template: __webpack_require__(979)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.AppStateService !== 'undefined' && services_1.AppStateService) === 'function' && _a) || Object, (typeof (_b = typeof inventory_detail_service_1.InventoryDetailService !== 'undefined' && inventory_detail_service_1.InventoryDetailService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _e) || Object, (typeof (_f = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _f) || Object, (typeof (_g = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _g) || Object])
	    ], InventoryDetailComponent);
	    return InventoryDetailComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}(models_1.TopLevelComponent));
	exports.InventoryDetailComponent = InventoryDetailComponent;


/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	__webpack_require__(277);
	__webpack_require__(339);
	var services_1 = __webpack_require__(274);
	var shared_1 = __webpack_require__(952);
	var InventoryDetailService = (function () {
	    function InventoryDetailService(_storeHelper, _apiService, _configService) {
	        this._storeHelper = _storeHelper;
	        this._apiService = _apiService;
	        this._configService = _configService;
	        this.products = [];
	        this.product = {};
	        this._inventory = this._configService.getContext('inventory');
	    }
	    InventoryDetailService.prototype.getProductById = function (productId) {
	        var _this = this;
	        return this._apiService.get(this._inventory.url, "products/" + productId)
	            .map(function (response) { return _this._setProduct(response, productId); })
	            .cache();
	    };
	    InventoryDetailService.prototype._setProduct = function (productFromServer, productId) {
	        var _this = this;
	        this.product.name = productFromServer.name;
	        this.product.id = productId;
	        this.product.locations = [];
	        var childProduct = productFromServer.products.find(function (x) { return x.id === productId; });
	        var current = 0;
	        var maximum = 0;
	        childProduct.inventory.locations.map(function (location) {
	            if (location.isAtLocation) {
	                current += location.current;
	                maximum += location.maximum;
	                var inventoryLocation = new shared_1.InventoryLocation(location);
	                inventoryLocation.updateMissQty(location.current);
	                _this.product.locations.push(inventoryLocation);
	            }
	        });
	        this.product.current = current;
	        this.product.missQuantity = current - maximum;
	        this.products.push(this.product);
	        this._storeHelper.update('products', this.products);
	        return this.product;
	    };
	    InventoryDetailService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _b) || Object, (typeof (_c = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _c) || Object])
	    ], InventoryDetailService);
	    return InventoryDetailService;
	    var _a, _b, _c;
	}());
	exports.InventoryDetailService = InventoryDetailService;


/***/ },
/* 978 */
/***/ function(module, exports) {

	module.exports = ".inventory{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 25px}.inventory::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.inventory .subtitle{background-color:transparent !important;text-align:center !important}.inventory .title{color:#ccc !important}.inventory .avatar{float:left;width:50px;font-size:38px}.inventory .mini-avatar{float:right;width:20px;font-size:20px}.inventory .content title{font-size:24px}.inventory .content small{color:#9e9e9e}.inventory .results{width:80px;text-align:right}.inventory .secondary{color:#9e9e9e;font-size:11px}.inventory .red{color:#E41736 !important}.inventory .qty.positive{color:#FFC107}.inventory .qty.negative{color:#E41736}.inventory .inventory-button{padding:3px 5px !important;margin-bottom:5px !important;width:97px !important}section.locations-header{color:#fff !important;font-size:25px;text-align:center}\n"

/***/ },
/* 979 */
/***/ function(module, exports) {

	module.exports = "<app-page><input-filter-sheet (applyChanges)=\"onFilterChanged($event)\" [fg]=\"fg\" placeholder=\"Search Locations\"></input-filter-sheet><paper-cover *ngIf=\"showReportDetails\" title=\"Report Loss\" (closed)=\"coverClosed()\"><div class=\"layout-column layout-padding\"><report-loss [product]=\"product\" [location]=\"locationSelectedToReport\" (applyReportSucess)=\"coverClosed()\"></report-loss></div></paper-cover><div class=\"mobile-page-content\"><div class=\"inventory\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-shopping-cart-add\"></i><div class=\"flex content\"><div class=\"title\">{{product.name}}</div><small>{{product.category}}</small></div><div class=\"flex-nogrow results qty\" [class.positive]=\"product.current &gt; 0\" [class.negative]=\"product.current &lt;= 0\">{{product.current || 0}}</div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">Total Miss Qty</div><div class=\"flex text-right\">Size </div><div class=\"flex text-right\">Color</div></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ product.missQuantity || 0 }}</div><div class=\"flex text-right\">{{ product.size }}</div><div class=\"flex text-right\">{{ product.color }}</div></div></div></div></div><section class=\"locations-header\">Locations</section><br/><div class=\"inventory\" *ngFor=\"let location of locations\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-pin\"></i><div class=\"flex content\"><div class=\"title\">{{location.name}}</div></div><div class=\"bw-header\" block=\"block\"><div class=\"pull-right\"><actions [class]=\"pull-right\" [actionItems]=\"actionItems\" (actionClicked)=\"onActionClicked($event, location)\" *ngIf=\"!location.editMode\"></actions></div></div><location-qty [product]=\"product\" [location]=\"location\" (applyChanges)=\"updateProductInformation()\" *ngIf=\"location.editMode\"> </location-qty></div><div class=\"layout-row\" *ngIf=\"!location.editMode\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">Qty</div><div class=\"flex text-right\">Total Miss Qty </div><div class=\"flex text-right\">Color</div><div class=\"flex text-right\">Size                           </div></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right qty\" [class.positive]=\"location.current &gt; 0\" [class.negative]=\"location.current &lt;= 0\"> {{ location.current || 0 }}</div><div class=\"flex text-right\">{{ location.missQuantity || 0 }}</div><div class=\"flex text-right\">{{ location.color }}</div><div class=\"flex text-right\">{{ location.size }}</div></div></div></div><div class=\"layout-row\" *ngIf=\"location.transferNotAllowed\"><div class=\"flex text-left red\"> This product is only available in this location   </div></div></div></div></app-page>";

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(981));


/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var common_1 = __webpack_require__(23);
	var forms_1 = __webpack_require__(27);
	var ui_1 = __webpack_require__(132);
	var models_1 = __webpack_require__(137);
	var services_1 = __webpack_require__(274);
	var ProductTransferComponent = (function (_super) {
	    __extends(ProductTransferComponent, _super);
	    function ProductTransferComponent(_location, _route, _store, _storeHelper, _userSvc) {
	        _super.call(this, _store, _storeHelper, _userSvc);
	        this._location = _location;
	        this._route = _route;
	        this._store = _store;
	        this.product = {};
	        this.productsToTransfer = [];
	        this.showTransferOverview = false;
	        this.initializeFromServer = false;
	        this.fg = new forms_1.FormGroup({});
	        this._searchAction = { id: 'search', icon: '' };
	        this.headerTitle = 'Qty to Transfer';
	        this.headerActions = [this._searchAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	    }
	    ProductTransferComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var that = this;
	        this._route.params.forEach(function (params) {
	            that.locationDestinationId = +params['locationTo'];
	            that.locationOriginId = +params['locationFrom'];
	            var productId = +params['productId'];
	            var storeState = _this.store.getState();
	            if (storeState.products) {
	                _this.product = storeState.products.find(function (p) { return p.id === productId; });
	            }
	            _this.appPage.deactivatePreloader();
	        });
	    };
	    ProductTransferComponent.prototype.coverClosed = function () {
	        this.showTransferOverview = false;
	        this.headerTitle = 'Qty to Transfer';
	    };
	    ProductTransferComponent.prototype.showTransferCover = function (e) {
	        e.preventDefault();
	        var qty = this.fg.controls[this.product.id].value;
	        this.productsToTransfer = [];
	        this.product.errorInTransfer = false;
	        if (qty > 0) {
	            this.product.quantity = qty;
	            this.productsToTransfer.push(this.product);
	            this.showTransferOverview = true;
	        }
	        else {
	            this.product.errorInTransfer = true;
	        }
	    };
	    ProductTransferComponent.prototype.goBack = function () {
	        this._location.back();
	    };
	    ProductTransferComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._searchAction.id) {
	        }
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], ProductTransferComponent.prototype, "appPage", void 0);
	    ProductTransferComponent = __decorate([
	        core_1.Component({
	            selector: 'product-transfer',
	            styles: [__webpack_require__(982)],
	            template: __webpack_require__(983)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _c) || Object, (typeof (_d = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _d) || Object, (typeof (_e = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _e) || Object])
	    ], ProductTransferComponent);
	    return ProductTransferComponent;
	    var _a, _b, _c, _d, _e;
	}(models_1.TopLevelComponent));
	exports.ProductTransferComponent = ProductTransferComponent;


/***/ },
/* 982 */
/***/ function(module, exports) {

	module.exports = ".product{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.product.master{padding-right:30px}.product.master::before{border-style:solid;border-width:0.1em 0.1em 0 0;content:'';display:inline-block;height:0.55em;width:0.55em;position:absolute;top:calc(50% - 10px);vertical-align:top;right:10px;transform:rotate(45deg)}.product::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.product .avatar{float:left;width:50px;font-size:38px}.product .content title{font-size:24px}.product .content small{color:#9e9e9e}.product .results{width:80px;text-align:right}.product .secondary{color:#9e9e9e;font-size:11px}.product .qty.positive{color:#FFC107}.product .qty.negative{color:#E41736}.product .size{width:80px}.product .qty-margin{margin-right:50px;margin-top:20px}.product .error-in-transfer{color:#E41736}.footer{position:fixed;bottom:0;left:0;right:0;height:50px}\n"

/***/ },
/* 983 */
/***/ function(module, exports) {

	module.exports = "<app-page><paper-cover *ngIf=\"showTransferOverview\" [title]=\"'Transfer Overview'\" (closed)=\"coverClosed()\"><div class=\"layout-column layout-padding\"></div><transfer-overview [products]=\"productsToTransfer\" [locationDestinationId]=\"locationDestinationId\" [locationOriginId]=\"locationOriginId\" [originEditMode]=\"true\" [destinationEditMode]=\"false\" [allowDestinationEditMode]=\"false\" (applytransferSuccess)=\"goBack()\"></transfer-overview></paper-cover><div class=\"mobile-page-content\"><div class=\"product\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-shopping-cart-add\"></i><div class=\"flex content\"><div class=\"title\">{{product.name}}</div><small>{{product.category}}</small></div><div class=\"flex qty-margin\"><div class=\"qty-size\"><number [fg]=\"fg\" [alt]=\"true\" field=\"{{product.id}}\" label=\"Quantity\" required=\"required\"></number></div></div><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">Qty</div><div class=\"flex text-right\">Total Miss Qty</div><div class=\"flex text-right\">Size </div><div class=\"flex text-right\">Color</div></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right qty\" [class.positive]=\"product.current &gt; 0\" [class.negative]=\"product.current &lt;= 0\">{{ product.current || 0 }}</div><div class=\"flex text-right qty\" [class.positive]=\"product.missQuantity &gt; 0\" [class.negative]=\"product.missQuantity &lt;= 0\">{{ product.missQuantity || 0 }}</div><div class=\"flex text-right\">{{ product.size }}</div><div class=\"flex text-right\">{{ product.color }}</div></div></div></div><div class=\"layout-row error-in-transfer\" *ngIf=\"product.errorInTransfer\">Provide quantity to transfer.</div><div class=\"separator\"></div></div></div><div class=\"footer text-center\"><bw-button title=\"Transfer Overview\" color=\"red\" icon=\"swap\" [rounded]=\"true\" (click)=\"showTransferCover($event)\"></bw-button></div></app-page>";

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(985));


/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var forms_1 = __webpack_require__(27);
	var common_1 = __webpack_require__(23);
	var Observable_1 = __webpack_require__(4);
	var Subject_1 = __webpack_require__(3);
	var ui_1 = __webpack_require__(132);
	var models_1 = __webpack_require__(137);
	var services_1 = __webpack_require__(274);
	var ui_2 = __webpack_require__(946);
	var models_2 = __webpack_require__(953);
	var services_2 = __webpack_require__(970);
	var ProductsTransferComponent = (function (_super) {
	    __extends(ProductsTransferComponent, _super);
	    function ProductsTransferComponent(_location, _productListService, _route, _store, _storeHelper, _userSvc) {
	        _super.call(this, _store, _storeHelper, _userSvc);
	        this._location = _location;
	        this._productListService = _productListService;
	        this._route = _route;
	        this._store = _store;
	        this.products$ = new Observable_1.Observable();
	        this.productsToTransfer = [];
	        this.showTransferOverview = false;
	        this.showProductsSelected = false;
	        this.noProductSelectedError = false;
	        this.fg = new forms_1.FormGroup({});
	        this.loading = true;
	        this.authorized = true;
	        this._locations = [];
	        this._searchAction = { id: 'search', icon: 'search' };
	        this._notSelectedProducts = new Subject_1.Subject();
	        this.headerTitle = 'Transfer Item(s)';
	        this.headerActions = [this._searchAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	        this.notSelectedProducts$ = this._notSelectedProducts.asObservable();
	    }
	    ProductsTransferComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._route.params.forEach(function (params) {
	            _this.locationOriginId = +params['locationFrom'];
	            _this.locationDestinationId = +params['locationTo'];
	            _this._locations.push(_this.locationOriginId);
	            _this._productFilter = new models_2.ProductTransferFilter('', _this._locations);
	            _this._getProducts('');
	        });
	    };
	    ProductsTransferComponent.prototype.onFilterChanged = function (name) {
	        this.appPage.activatePreloader();
	        this._getProducts(name);
	    };
	    ProductsTransferComponent.prototype.coverClosed = function () {
	        this.showTransferOverview = false;
	        this.headerTitle = 'Transfer OverView';
	    };
	    ProductsTransferComponent.prototype.showTransferCover = function (e) {
	        e.preventDefault();
	        this.noProductSelectedError = false;
	        if (this.productsToTransfer.length > 0) {
	            this.showTransferOverview = true;
	        }
	        else {
	            this.noProductSelectedError = true;
	        }
	    };
	    ProductsTransferComponent.prototype.coverProductsSelectedClosed = function () {
	        this.showProductsSelected = false;
	        this.headerTitle = 'Transfer OverView';
	    };
	    ProductsTransferComponent.prototype.showProductsSelectedCover = function (e) {
	        e.preventDefault();
	        this.showProductsSelected = true;
	    };
	    ProductsTransferComponent.prototype.addProductToTransfer = function (product) {
	        var that = this;
	        product.errorInTransfer = false;
	        if (product.quantity > 0) {
	            product.isSelectedForTransfer = true;
	            setTimeout(function () { return product.addedToTransfer = true; }, 900);
	            that.productsToTransfer.push(product);
	        }
	        else {
	            product.errorInTransfer = true;
	        }
	    };
	    ProductsTransferComponent.prototype.deleteProductFromSelected = function (product) {
	        var that = this;
	        that.productsToTransfer.forEach(function (p, index) {
	            if (p.id === product.id) {
	                that.productsToTransfer.splice(index, 1);
	            }
	        });
	        this._filterProducts();
	    };
	    ProductsTransferComponent.prototype.goBack = function () {
	        this._location.back();
	    };
	    ProductsTransferComponent.prototype._getProducts = function (name) {
	        this._productFilter.name = name;
	        this.products$ = this._productListService.getProducts(this._productFilter);
	        this._filterProducts();
	    };
	    ProductsTransferComponent.prototype._filterProducts = function () {
	        var _this = this;
	        var that = this;
	        this.loading = true;
	        this.products$.subscribe(function (res) {
	            var productsNotInTransfer = [];
	            res.forEach(function (product) {
	                var isInTransfer = false;
	                that.productsToTransfer.forEach(function (productToTransfer) {
	                    if (product.id === productToTransfer.id) {
	                        product.isSelectedForTransfer = true;
	                        product.addedToTransfer = true;
	                    }
	                });
	                if (!isInTransfer) {
	                    product.isSelectedForTransfer = false;
	                    product.addedToTransfer = false;
	                    productsNotInTransfer.push(product);
	                }
	            });
	            that._notSelectedProducts.next(productsNotInTransfer);
	            _this.appPage.deactivatePreloader();
	        }, function (err) {
	            _this.authorized = _this.userService.userHasAccess(err);
	            _this.appPage.deactivatePreloader();
	            _this.loading = false;
	        }, function () { return that.loading = false; });
	    };
	    ProductsTransferComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._searchAction.id && this.authorized) {
	            this.inputFilterSheetComponent.toggle();
	        }
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], ProductsTransferComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(ui_2.InputFilterSheetComponent), 
	        __metadata('design:type', Object)
	    ], ProductsTransferComponent.prototype, "inputFilterSheetComponent", void 0);
	    ProductsTransferComponent = __decorate([
	        core_1.Component({
	            styles: [__webpack_require__(986)],
	            template: __webpack_require__(987)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _a) || Object, (typeof (_b = typeof services_2.ProductListService !== 'undefined' && services_2.ProductListService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _d) || Object, (typeof (_e = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _e) || Object, (typeof (_f = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _f) || Object])
	    ], ProductsTransferComponent);
	    return ProductsTransferComponent;
	    var _a, _b, _c, _d, _e, _f;
	}(models_1.TopLevelComponent));
	exports.ProductsTransferComponent = ProductsTransferComponent;


/***/ },
/* 986 */
/***/ function(module, exports) {

	module.exports = ".product{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 30px;position:relative}.product.master{padding-right:30px}.product.master::before{border-style:solid;border-width:0.1em 0.1em 0 0;content:'';display:inline-block;height:0.55em;width:0.55em;position:absolute;top:calc(50% - 10px);vertical-align:top;right:10px;transform:rotate(45deg)}.product::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.product .avatar{float:left;width:50px;font-size:38px}.product .content title{font-size:24px}.product .content small{color:#9e9e9e}.product .results{width:80px;text-align:right}.product .secondary{color:#9e9e9e;font-size:11px}.product .qty.positive{color:#FFC107}.product .qty.negative{color:#E41736}.margin-left-80{margin-left:150px !important}.footer{position:fixed;bottom:0;left:0;right:0;height:50px;z-index:14}\n"

/***/ },
/* 987 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"mobile-page-content h-100\"><div class=\"layout-column h-100\"><div class=\"flex\" *ngIf=\"authorized\"><input-filter-sheet (applyChanges)=\"onFilterChanged($event)\" [fg]=\"fg\" placeholder=\"Search Products\"></input-filter-sheet><paper-cover *ngIf=\"showTransferOverview\" [title]=\"'Transfer Overview'\" (closed)=\"coverClosed()\"><div class=\"layout-column layout-padding\"></div><transfer-overview [products]=\"productsToTransfer\" [locationDestinationId]=\"locationDestinationId\" [locationOriginId]=\"locationOriginId\" [originEditMode]=\"false\" [destinationEditMode]=\"false\" [allowDestinationEditMode]=\"true\" (applytransferSuccess)=\"goBack()\" (applyClose)=\"coverClosed()\"></transfer-overview></paper-cover><paper-cover *ngIf=\"showProductsSelected\" [title]=\"'Product(s) Selected'\" (closed)=\"coverProductsSelectedClosed()\"><div class=\"layout-column layout-padding\"><products-transfer-selected [products]=\"productsToTransfer\" (deleteProductFromTransfer)=\"deleteProductFromSelected($event)\"></products-transfer-selected></div></paper-cover><div class=\"layout-column\"><div class=\"layout-row flex m-b-40\" [style.overflow]=\"'auto'\"><div class=\"layout-column flex\"><div class=\"product animated\" *ngFor=\"let product of  notSelectedProducts$ | async\" [class.slideOutRight]=\"product.isSelectedForTransfer\" [class.hidden]=\"product.addedToTransfer\"><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">{{product.name}}</div><small>{{product.category}}</small></div><div class=\"bw-header\" block=\"true\"><div class=\"pull-right\"><ul class=\"actions c-light-gray\"><li class=\"a\" href=\"\" (click)=\"addProductToTransfer(product)\"><i class=\"zmdi zmdi-plus zmdi-hc-lg\"></i></li></ul></div></div></div><div class=\"layout-row\"><product-qty [product]=\"product\"></product-qty><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">Qty</div><div class=\"flex text-right\">Total Miss Qty</div><div class=\"flex text-right\">Size </div><div class=\"flex text-right\">Color</div></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right qty\" [class.positive]=\"product.current &gt; 0\" [class.negative]=\"product.current &lt;= 0\">{{ product.current || 0 }}</div><div class=\"flex text-right qty\" [class.positive]=\"product.missQuantity &gt; 0\" [class.negative]=\"product.missQuantity &lt;= 0\">{{ product.missQuantity || 0 }}</div><div class=\"flex text-right\">{{ product.size }}</div><div class=\"flex text-right\">{{ product.color }}</div></div></div></div></div></div></div><div class=\"layout-column flex-nogrow layout-align-center-center footer\"><div class=\"layout-row layout-padding layout-align-center-center\"><bw-button title=\"Overview\" color=\"red\" icon=\"swap\" [rounded]=\"true\" (click)=\"showTransferCover($event)\"></bw-button><bw-button title=\"Products\" color=\"red\" icon=\"search\" [rounded]=\"true\" (click)=\"showProductsSelectedCover($event)\"></bw-button></div><div class=\"layout-row layout-padding layout-align-center-center\" [class.hidden]=\"!noProductSelectedError\"><div class=\"c-red m-b-5 animated fadeIn\">Add porduct(s) to transfer.</div></div></div></div></div><user-feedback [hidden]=\"authorized || loading\" type=\"info\" message=\"User - Not Authorized\"> </user-feedback></div></div></app-page>";

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(989));


/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(77);
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var ui_1 = __webpack_require__(132);
	var ng2_material_components_1 = __webpack_require__(33);
	var ui_2 = __webpack_require__(132);
	var models_1 = __webpack_require__(137);
	var services_1 = __webpack_require__(274);
	var TransferLocationsComponent = (function (_super) {
	    __extends(TransferLocationsComponent, _super);
	    function TransferLocationsComponent(_router, _store, _storeHelper, _userSvc) {
	        var _this = this;
	        _super.call(this, _store, _storeHelper, _userSvc);
	        this._router = _router;
	        this.locationsOrigin = [];
	        this.locationOriginError = false;
	        this.locationsDestination = [];
	        this.locationDestinationError = false;
	        this.fg = new forms_1.FormGroup({});
	        this.headerTitle = 'Transfer';
	        this.headerActions = [];
	        this._userSubs = _userSvc.user$
	            .do(function (user) { return _this._user = user; })
	            .subscribe(function (user) { return _this._refreshRegions(user); });
	    }
	    TransferLocationsComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.fg.controls['regionOrigin'].valueChanges
	            .subscribe(function (regionId) {
	            _this.fg.controls['locationOrigin'].setValue('');
	            _this.regionOriginId = regionId;
	            _this._updateOriginLocations(regionId);
	        });
	        this.fg.controls['regionDestination'].valueChanges
	            .subscribe(function (regionId) {
	            _this.fg.controls['locationDestination'].setValue('');
	            _this.regionDestinationId = regionId;
	            _this._updateDestinationLocations(regionId);
	        });
	        this.fg.controls['locationOrigin'].valueChanges
	            .subscribe(function (locationId) {
	            if (locationId) {
	                _this.locationOriginId = locationId;
	                _this._updateDestinationLocations(_this.regionOriginId);
	            }
	        });
	        this.fg.controls['locationDestination'].valueChanges
	            .subscribe(function (locationId) {
	            if (locationId) {
	                _this.locationDestinationId = locationId;
	                _this._updateOriginLocations(_this.regionDestinationId);
	            }
	        });
	        this.appPage.deactivatePreloader();
	    };
	    TransferLocationsComponent.prototype.ngOnDestroy = function () {
	        this._userSubs.unsubscribe();
	    };
	    TransferLocationsComponent.prototype.goToSelectProducts = function (e) {
	        e.preventDefault();
	        this.locationDestinationError = false;
	        this.locationOriginError = false;
	        if (!this.locationOriginId) {
	            this.locationOriginError = true;
	            return;
	        }
	        if (!this.locationDestinationId) {
	            this.locationDestinationError = true;
	            return;
	        }
	        this._router.navigate(['/inventory/trasfer-products', this.locationDestinationId, this.locationOriginId]);
	    };
	    TransferLocationsComponent.prototype._refreshRegions = function (user) {
	        if (!user || !user.regions) {
	            return;
	        }
	        var regions = user.regions.map(function (region) {
	            return new ng2_material_components_1.SelectionItem(region.id, region.name);
	        });
	        this.regionsDestination = regions;
	        this.regionsOrigin = regions;
	    };
	    TransferLocationsComponent.prototype._updateOriginLocations = function (regionId) {
	        this.locationsOrigin = this._filteredLocations(regionId, this.locationDestinationId, this.locationOriginId);
	    };
	    TransferLocationsComponent.prototype._updateDestinationLocations = function (regionId) {
	        this.locationsDestination = this._filteredLocations(regionId, this.locationOriginId, this.locationDestinationId);
	    };
	    TransferLocationsComponent.prototype._filteredLocations = function (regionId, locationToFilterId, locationIdSelected) {
	        var filteredLocations = this._user.regions
	            .find(function (region) { return region.id === +regionId; }).locations
	            .filter(function (l) { return l.id !== +locationToFilterId; });
	        return filteredLocations.map(function (location) { return new ng2_material_components_1.SelectionItem(location.id, location.name, location.id === +locationIdSelected); });
	    };
	    __decorate([
	        core_1.ViewChild(ui_2.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], TransferLocationsComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChildren(ui_1.LocationPickerComponent), 
	        __metadata('design:type', Object)
	    ], TransferLocationsComponent.prototype, "inputFilterSheetComponents", void 0);
	    TransferLocationsComponent = __decorate([
	        core_1.Component({
	            styles: [__webpack_require__(990)],
	            template: __webpack_require__(991)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _b) || Object, (typeof (_c = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _c) || Object, (typeof (_d = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _d) || Object])
	    ], TransferLocationsComponent);
	    return TransferLocationsComponent;
	    var _a, _b, _c, _d;
	}(models_1.TopLevelComponent));
	exports.TransferLocationsComponent = TransferLocationsComponent;


/***/ },
/* 990 */
/***/ function(module, exports) {

	module.exports = ".transfer{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 40px;position:relative}.transfer.master{padding-right:30px}.transfer.master::before{border-style:solid;border-width:0.1em 0.1em 0 0;content:'';display:inline-block;height:0.55em;width:0.55em;position:absolute;top:calc(50% - 10px);vertical-align:top;right:10px;transform:rotate(45deg)}.transfer::after{content:'';display:block;width:100%;margin-top:10px}.transfer .title{font-size:15px}.transfer .avatar{float:left;width:50px;font-size:30px}.transfer .avatar-edit{text-align:right;width:50px;font-size:20px;padding-top:5px}.transfer .content title{font-size:24px}.transfer .content small{color:#9e9e9e}.transfer .results{width:80px;text-align:right}.transfer .secondary{color:#9e9e9e;font-size:11px}.transfer .qty.positive{color:#FFC107}.transfer .qty.negative{color:#E41736}.transfer .size{width:50px}.transfer .qty-margin{margin-left:40%}.transfer .amber{font-size:15px !important;color:#FFC107 !important}.scrolling{overflow:auto;height:1500px}\n"

/***/ },
/* 991 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"mobile-page-content p-10 h-100\"><div class=\"layout-column layout-padding h-100\"><div class=\"flex\" [style.overflow]=\"'auto'\"><div class=\"flex\"><h4 class=\"c-red\">From<div class=\"layout-column-xs layout-padding\"><div><select-picker [fg]=\"fg\" field=\"regionOrigin\" label=\"Regions\" [liveSearch]=\"true\" [items]=\"regionsOrigin\" liveSearchPlaceholder=\"... type to seach ...\" noneSelectedText=\"Select Region\" [alt]=\"true\" leftIcon=\"globe\"></select-picker></div><div><select-picker [fg]=\"fg\" field=\"locationOrigin\" label=\"Locations\" [liveSearch]=\"true\" [items]=\"locationsOrigin\" liveSearchPlaceholder=\"... type to seach ...\" noneSelectedText=\"Select Location\" [alt]=\"true\" leftIcon=\"pin\" [multiple]=\"false\"></select-picker></div></div></h4><div class=\"c-red m-l-10 animated fadeIn\" *ngIf=\"locationOriginError\">      Select region and location</div></div><div class=\"flex\"><h4 class=\"c-red\">To<div class=\"layout-column-xs layout-padding\"><div><select-picker [fg]=\"fg\" field=\"regionDestination\" label=\"Regions\" [liveSearch]=\"true\" [items]=\"regionsDestination\" liveSearchPlaceholder=\"... type to seach ...\" noneSelectedText=\"Select Region\" [alt]=\"true\" leftIcon=\"globe\"></select-picker></div><div><select-picker [fg]=\"fg\" field=\"locationDestination\" label=\"Locations\" [liveSearch]=\"true\" [items]=\"locationsDestination\" liveSearchPlaceholder=\"... type to seach ...\" noneSelectedText=\"Select Location\" [alt]=\"true\" leftIcon=\"pin\" [multiple]=\"false\"></select-picker></div></div></h4><div class=\"c-red m-l-10 animated fadeIn\" *ngIf=\"locationDestinationError\">      Select region and location</div></div></div><div class=\"flex-nogrow text-center\"><bw-button title=\"Select Products\" color=\"red\" icon=\"chevron-right\" [rounded]=\"true\" (click)=\"goToSelectProducts($event)\"></bw-button></div></div></div></app-page>";

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(993));
	__export(__webpack_require__(994));


/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(953);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var models_2 = __webpack_require__(137);
	var ui_1 = __webpack_require__(132);
	var transfer_history_service_1 = __webpack_require__(994);
	var TransferHistoryComponent = (function (_super) {
	    __extends(TransferHistoryComponent, _super);
	    function TransferHistoryComponent(_transferHistoryService, store, storeHelper, userService) {
	        _super.call(this, store, storeHelper, userService);
	        this._transferHistoryService = _transferHistoryService;
	        this.transferSelected = {};
	        this.showDetail = false;
	        this.loading = true;
	        this.authorized = true;
	        this._calendarAction = { id: 'calendar', icon: 'calendar' };
	        this._initialFilter = true;
	        this.headerTitle = 'Transfer History';
	        this.headerActions = [this._calendarAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	    }
	    TransferHistoryComponent.prototype.onApplyDateRange = function (range) {
	        this._dateRange = range;
	        this._loadTransfers();
	    };
	    TransferHistoryComponent.prototype.coverClosed = function () {
	        this.showDetail = false;
	        this.headerTitle = 'Transfer History';
	    };
	    TransferHistoryComponent.prototype.showTransferDetail = function (transfer) {
	        this.transferSelected = transfer;
	        this.showDetail = true;
	    };
	    TransferHistoryComponent.prototype.refreshAfterDelteTransfer = function () {
	        this._initialFilter = true;
	        this.showDetail = false;
	        this.headerTitle = 'Transfer History';
	        this._loadTransfers();
	    };
	    TransferHistoryComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._calendarAction.id && this.authorized) {
	            this.dateRangeSheet.toggle();
	        }
	    };
	    TransferHistoryComponent.prototype._toggleSheet = function () {
	        this.dateRangeSheet.toggle();
	    };
	    TransferHistoryComponent.prototype._loadTransfers = function () {
	        var _this = this;
	        var that = this;
	        this.empty = false;
	        this.appPage.activatePreloader();
	        if (this._dateRange && this._dateRange.isValid) {
	            this.transferHistoryFilter = new models_1.TransferHistoryFilter(this._dateRange);
	        }
	        else {
	            this.transferHistoryFilter = new models_1.TransferHistoryFilter();
	        }
	        this.loading = true;
	        this._transferHistoryService.getTransfer(this.transferHistoryFilter)
	            .subscribe(function (transfers) {
	            _this.transfer = transfers;
	            that.appPage.deactivatePreloader();
	            _this.empty = transfers.length <= 0;
	            if (_this.empty) {
	                setTimeout(function () { return _this._toggleSheet(); }, 1500);
	            }
	        }, function (err) {
	            _this.authorized = _this.userService.userHasAccess(err);
	            _this.appPage.deactivatePreloader();
	            _this.loading = false;
	        }, function () { return that.loading = false; });
	        if (!this._initialFilter) {
	            this._toggleSheet();
	        }
	        this._initialFilter = false;
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], TransferHistoryComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.DateRangeSheetComponent), 
	        __metadata('design:type', Object)
	    ], TransferHistoryComponent.prototype, "dateRangeSheet", void 0);
	    TransferHistoryComponent = __decorate([
	        core_1.Component({
	            styles: [
	                __webpack_require__(995)
	            ],
	            template: __webpack_require__(996),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof transfer_history_service_1.TransferHistoryService !== 'undefined' && transfer_history_service_1.TransferHistoryService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _b) || Object, (typeof (_c = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _c) || Object, (typeof (_d = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _d) || Object])
	    ], TransferHistoryComponent);
	    return TransferHistoryComponent;
	    var _a, _b, _c, _d;
	}(models_2.TopLevelComponent));
	exports.TransferHistoryComponent = TransferHistoryComponent;


/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	__webpack_require__(277);
	__webpack_require__(339);
	var services_1 = __webpack_require__(274);
	var TransferHistoryService = (function () {
	    function TransferHistoryService(_apiService, _configService) {
	        this._apiService = _apiService;
	        this._configService = _configService;
	        this.transfers = [];
	        this._inventory = this._configService.getContext('inventory');
	    }
	    TransferHistoryService.prototype.getTransfer = function (filter) {
	        return this._apiService.get(this._inventory.url, 'transfers', filter)
	            .map(function (response) { return response.data.map(function (t) { return t; }); })
	            .cache();
	    };
	    TransferHistoryService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], TransferHistoryService);
	    return TransferHistoryService;
	    var _a, _b;
	}());
	exports.TransferHistoryService = TransferHistoryService;


/***/ },
/* 995 */
/***/ function(module, exports) {

	module.exports = ".transfer{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.transfer.item-disabled{opacity:0.3}.transfer.master{padding-right:30px}.transfer.master::before{border-style:solid;border-width:0.1em 0.1em 0 0;content:'';display:inline-block;height:0.55em;width:0.55em;position:absolute;top:calc(50% - 10px);vertical-align:top;right:10px;transform:rotate(45deg)}.transfer::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.transfer .content title{font-size:24px}.transfer .content small{color:#9e9e9e}.transfer .secondary{font-size:12px}\n"

/***/ },
/* 996 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"flex\" *ngIf=\"authorized\"><date-range-sheet (applyRange)=\"onApplyDateRange($event)\"></date-range-sheet><paper-cover *ngIf=\"showDetail\" title=\"Remove Transfer\" (closed)=\"coverClosed()\"><div class=\"layout-column layout-padding\"><transfer-detail [transfer]=\"transferSelected\" (applyDeleteTransferSucess)=\"refreshAfterDelteTransfer()\"></transfer-detail></div></paper-cover><div class=\"mobile-page-content h-100\"><div class=\"h-100\" [ngSwitch]=\"empty\"><user-feedback *ngSwitchCase=\"true\" type=\"info\" message=\"No Results Found\"></user-feedback><div *ngSwitchCase=\"false\"><div class=\"transfer master\" *ngFor=\"let transfer of transfer\" (click)=\"showTransferDetail(transfer)\"><div class=\"layout-row\"><div class=\"flex content\"><div *ngIf=\"transfer.sent\"><div class=\"title\">{{transfer.sent.by}}</div><small>{{transfer.sent.timestamp | toLocalDate}}</small></div><div *ngIf=\"transfer.requested &amp;&amp; !transfer.sent\"><div class=\"title\">{{transfer.requested.by}}</div><small>{{transfer.requested.timestamp | toLocalDate}}</small></div></div><div class=\"flex\"> <div class=\"pull-right c-red\">{{transfer.status}}</div></div></div><br/><div class=\"layout-row text-center secondary\"><div class=\"flex text-right c-lime\" *ngIf=\"transfer.origin\">{{transfer.origin.name}}</div><div class=\"flex text-right c-lime\" *ngIf=\"!transfer.origin\">Air Transfer</div><div class=\"flex-nogrow m-l-5 m-r-5\"><div class=\"i zmdi zmdi-swap text-center\"></div></div><div class=\"flex text-left c-amber\">{{transfer.destination.name}}  </div></div></div></div></div></div></div><user-feedback [hidden]=\"authorized || loading\" type=\"info\" message=\"User - Not Authorized\"> </user-feedback></app-page>";

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(998));
	__export(__webpack_require__(999));


/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var shared_1 = __webpack_require__(952);
	var location_edit_qty_service_1 = __webpack_require__(999);
	var LocationEditQtyComponent = (function () {
	    function LocationEditQtyComponent(_locationEditQtyService) {
	        this._locationEditQtyService = _locationEditQtyService;
	        this.applyChanges = new core_1.EventEmitter();
	        this.fg = new forms_1.FormGroup({});
	        this.editActionItems = [{ icon: 'check' }, { icon: 'undo' }];
	    }
	    LocationEditQtyComponent.prototype.onEditActionClicked = function (action, location) {
	        switch (action.icon) {
	            case 'check':
	                this._updateQty();
	                break;
	            case 'undo':
	                this._undo();
	                break;
	        }
	    };
	    LocationEditQtyComponent.prototype._updateQty = function () {
	        var _this = this;
	        var qty = this.fg.controls['qty'].value;
	        if (qty) {
	            this.callingServer = true;
	            var locationQtyDetail = new shared_1.LocationQtyDetail(this.location.id, this.product.id, new shared_1.QtyDetail(+qty));
	            this._locationEditQtyService.updateQty(locationQtyDetail)
	                .subscribe(function (res) {
	                _this.callingServer = false;
	                _this.location.current = qty;
	                _this.location.editMode = false;
	                _this.location.updateMissQty(qty);
	                _this.applyChanges.emit(_this.location);
	            }, function (error) { return _this.callingServer = false; });
	        }
	    };
	    LocationEditQtyComponent.prototype._undo = function () {
	        this.location.editMode = false;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof shared_1.Product !== 'undefined' && shared_1.Product) === 'function' && _a) || Object)
	    ], LocationEditQtyComponent.prototype, "product", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof shared_1.InventoryLocation !== 'undefined' && shared_1.InventoryLocation) === 'function' && _b) || Object)
	    ], LocationEditQtyComponent.prototype, "location", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], LocationEditQtyComponent.prototype, "applyChanges", void 0);
	    LocationEditQtyComponent = __decorate([
	        core_1.Component({
	            selector: 'location-qty',
	            styles: [__webpack_require__(1000)],
	            template: __webpack_require__(1001)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof location_edit_qty_service_1.LocationEditQtyService !== 'undefined' && location_edit_qty_service_1.LocationEditQtyService) === 'function' && _c) || Object])
	    ], LocationEditQtyComponent);
	    return LocationEditQtyComponent;
	    var _a, _b, _c;
	}());
	exports.LocationEditQtyComponent = LocationEditQtyComponent;


/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	__webpack_require__(277);
	__webpack_require__(339);
	var services_1 = __webpack_require__(274);
	var LocationEditQtyService = (function () {
	    function LocationEditQtyService(_apiService, _configService) {
	        this._apiService = _apiService;
	        this._configService = _configService;
	        this._inventory = this._configService.getContext('inventory');
	    }
	    LocationEditQtyService.prototype.updateQty = function (locationQtyDetail) {
	        return this._apiService.patch(this._inventory.url, "inventory/" + locationQtyDetail.locationId + "/products/" + locationQtyDetail.productId, locationQtyDetail.details)
	            .map(function (response) { return response; });
	    };
	    LocationEditQtyService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], LocationEditQtyService);
	    return LocationEditQtyService;
	    var _a, _b;
	}());
	exports.LocationEditQtyService = LocationEditQtyService;


/***/ },
/* 1000 */
/***/ function(module, exports) {

	module.exports = ""

/***/ },
/* 1001 */
/***/ function(module, exports) {

	module.exports = "<div class=\"bw-header\" block=\"block\"><div class=\"pull-right animated fadeIn\"><actions [class]=\"pull-right\" [actionItems]=\"editActionItems\" (actionClicked)=\"onEditActionClicked($event)\"></actions></div><div class=\"layout-row\"><div class=\"flex qty-section m-t-40 animated fadeIn\" *ngIf=\"!callingServer\"><number [fg]=\"fg\" [alt]=\"true\" field=\"qty\" [value]=\"location.current || 0\" label=\"Quantity\"></number></div><div class=\"flex text-center\" *ngIf=\"callingServer\"><bw-preloader color=\"red\"></bw-preloader></div></div></div>";

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1003));
	__export(__webpack_require__(1004));


/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var ui_1 = __webpack_require__(132);
	var shared_1 = __webpack_require__(952);
	var report_loss_service_1 = __webpack_require__(1004);
	var ReportLossComponent = (function () {
	    function ReportLossComponent(_reportLossService) {
	        this._reportLossService = _reportLossService;
	        this.applyReportSucess = new core_1.EventEmitter();
	        this.fg = new forms_1.FormGroup({});
	        this.reportErrorMessage = 'Error';
	        this.reportError = false;
	        this.successMessage = 'Success';
	        this.reportSuccess = false;
	        this.reasons = [
	            { id: 1, title: 'Damaged' },
	            { id: 2, title: 'Lost' },
	            { id: 3, title: 'Missing' },
	            { id: 4, title: 'Tester' },
	            { id: 5, title: 'Other' }
	        ];
	    }
	    ReportLossComponent.prototype.ngOnInit = function () {
	        this.preloader.hide();
	    };
	    ReportLossComponent.prototype.reportLoss = function (e) {
	        var _this = this;
	        e.preventDefault();
	        this.reportError = false;
	        this.reportSuccess = false;
	        var controls = this.fg.controls;
	        if (this.fg.valid) {
	            this.preloader.show();
	            var qty = controls['quantity'].value;
	            var reason = this._getReason(+controls['reason'].value);
	            var comments = controls['comments'].value;
	            var report = new shared_1.Report(this.product.id, this.location.id, new shared_1.ReportDetail(qty, reason, comments));
	            this._reportLossService.reportLoss(report)
	                .subscribe(function (res) {
	                _this.preloader.hide();
	                _this.applyReportSucess.emit();
	                _this.reportSuccess = true;
	            }, function (err) {
	                _this.preloader.hide();
	                _this.reportError = true;
	            });
	        }
	        else {
	            this.reportError = true;
	        }
	    };
	    ReportLossComponent.prototype._getReason = function (reasonId) {
	        var reason = this.reasons.find(function (r) { return r.id === reasonId; });
	        return reason.title;
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.PagePreloaderComponent), 
	        __metadata('design:type', Object)
	    ], ReportLossComponent.prototype, "preloader", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof shared_1.Product !== 'undefined' && shared_1.Product) === 'function' && _a) || Object)
	    ], ReportLossComponent.prototype, "product", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof shared_1.InventoryLocation !== 'undefined' && shared_1.InventoryLocation) === 'function' && _b) || Object)
	    ], ReportLossComponent.prototype, "location", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], ReportLossComponent.prototype, "applyReportSucess", void 0);
	    ReportLossComponent = __decorate([
	        core_1.Component({
	            selector: 'report-loss',
	            styles: [__webpack_require__(1005)],
	            template: __webpack_require__(1006)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof report_loss_service_1.ReportLossService !== 'undefined' && report_loss_service_1.ReportLossService) === 'function' && _c) || Object])
	    ], ReportLossComponent);
	    return ReportLossComponent;
	    var _a, _b, _c;
	}());
	exports.ReportLossComponent = ReportLossComponent;


/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	__webpack_require__(277);
	__webpack_require__(339);
	var services_1 = __webpack_require__(274);
	var ReportLossService = (function () {
	    function ReportLossService(_apiService, _configService) {
	        this._apiService = _apiService;
	        this._configService = _configService;
	        this._inventory = this._configService.getContext('inventory');
	    }
	    ReportLossService.prototype.reportLoss = function (report) {
	        return this._apiService.post(this._inventory.url, "inventory/" + report.locationId + "/products/" + report.productId + "/losses", report.details, true)
	            .map(function (res) { return res; });
	    };
	    ReportLossService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], ReportLossService);
	    return ReportLossService;
	    var _a, _b;
	}());
	exports.ReportLossService = ReportLossService;


/***/ },
/* 1005 */
/***/ function(module, exports) {

	module.exports = ".report{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 25px}.report::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.report .subtitle{background-color:transparent !important;text-align:center !important}.report .title{color:#ccc !important;font-size:20px}.report .avatar{float:left;width:50px;font-size:38px}.report .content title{font-size:24px}.report .content small{color:#9e9e9e}.report .results{width:80px;text-align:right}.report .secondary{color:#9e9e9e;font-size:15px}.report .red{color:#E41736 !important}.report .qty{font-size:15px}.report .qty.positive{color:#FFC107}.report .qty.negative{color:#E41736}.report .report-form{display:block;color:#e2e2e2 !important;clear:both;padding:10px 25px !important}.report .inventory-button{padding:3px 5px !important;margin-bottom:5px !important;width:97px !important}\n"

/***/ },
/* 1006 */
/***/ function(module, exports) {

	module.exports = "<page-preloader></page-preloader><div class=\"report\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-pin\"></i><div class=\"flex content\"><div class=\"title\">{{location.name}}</div></div></div><div class=\"separator\"></div></div><div class=\"report\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-shopping-cart-add\"></i><div class=\"flex content\"><div class=\"title\">{{product.name}}</div><small>{{product.category}}</small></div><div class=\"flex-nogrow results qty\" [class.positive]=\"product.current &gt; 0\" [class.negative]=\"product.current &lt;= 0\">{{product.current || 0}}</div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">Total Miss Qty</div><div class=\"flex text-right\">Size </div><div class=\"flex text-right\">Color</div></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ product.missQuantity || 0 }}</div><div class=\"flex text-right\">{{ product.size }}</div><div class=\"flex text-right\">{{ product.color }}</div></div></div></div></div><br/><div class=\"report\"><div class=\"flex input animated\"><div class=\"m-b-25\"><number [fg]=\"fg\" field=\"quantity\" label=\"Report Qty\" [alt]=\"true\" required=\"required\"></number></div><div class=\"m-b-25\"><select-picker [fg]=\"fg\" field=\"reason\" label=\"Reason\" [items]=\"reasons\" noneSelectedText=\"Choose\" [alt]=\"true\" required=\"required\"></select-picker></div><div class=\"m-b-25\"><text-area [fg]=\"fg\" field=\"comments\" label=\"Notes\" [autosize]=\"true\" required=\"required\"></text-area></div><div class=\"layout-row layout-align-center-center\"><bw-button id=\"add-account\" title=\"Report Loss\" color=\"red\" icon=\"plus\" [rounded]=\"true\" (click)=\"reportLoss($event)\"></bw-button></div><div class=\"text-center animated shake m-t-10\" *ngIf=\"reportError\"><div class=\"c-red\">{{reportErrorMessage}}</div></div><div class=\"text-center animated shake m-t-10\" *ngIf=\"reportSuccess\"><div class=\"c-green\">{{successMessage}}</div></div></div></div>";

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var transfer_overview_component_1 = __webpack_require__(1008);
	exports.TransferOverviewComponent = transfer_overview_component_1.TransferOverviewComponent;
	var transfer_service_1 = __webpack_require__(1009);
	exports.TransferService = transfer_service_1.TransferService;


/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var forms_1 = __webpack_require__(27);
	var page_preloader_component_1 = __webpack_require__(616);
	var shared_1 = __webpack_require__(952);
	var ui_1 = __webpack_require__(132);
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var transfer_service_1 = __webpack_require__(1009);
	var TransferOverviewComponent = (function () {
	    function TransferOverviewComponent(_userSvc, _route, _transferService) {
	        this._userSvc = _userSvc;
	        this._route = _route;
	        this._transferService = _transferService;
	        this.applytransferSuccess = new core_1.EventEmitter();
	        this.applyClose = new core_1.EventEmitter();
	        this.fg = new forms_1.FormGroup({});
	        this.locationOrigin = new models_1.Location();
	        this.regionOrigin = new models_1.Region();
	        this.locationDestination = new models_1.Location();
	        this.regionDestination = new models_1.Region();
	        this.title = '';
	        this.total = 0;
	        this.transferErrorMessage = 'Error';
	        this.transferError = false;
	        this.successMessage = 'Success';
	        this.transferSuccess = false;
	        this._isRequestTrasfer = false;
	    }
	    TransferOverviewComponent.prototype.ngOnInit = function () {
	        var that = this;
	        var totalProducts = 0;
	        that.products.forEach(function (p) {
	            that.total += +p.quantity;
	            totalProducts++;
	        });
	        if (totalProducts > 1) {
	            that.title = " Products(Total Qty)";
	        }
	        else {
	            that.title = " " + that.products[0].name;
	        }
	        that._userSubs = that._userSvc.user$
	            .do(function (user) { return that._user = user; })
	            .subscribe(function (user) { return that._initializeRegionAndLocation(user); });
	        that.preloader.hide();
	    };
	    TransferOverviewComponent.prototype.transfer = function (e) {
	        var _this = this;
	        e.preventDefault();
	        this.preloader.show();
	        this.locationOriginError = false;
	        this.locationDestinationError = false;
	        if (this.originEditMode) {
	            var selectionPicker = this.locationPickerComponent.getSelection();
	            var region = selectionPicker ? selectionPicker.region : null;
	            this.locationOrigin = selectionPicker ? selectionPicker.locations[0] : null;
	            if (!region || !this.locationOrigin) {
	                this.locationOriginError = true;
	                this.preloader.hide();
	                return;
	            }
	        }
	        else if (this.destinationEditMode) {
	            var selectionPicker = this.locationPickerComponent.getSelection();
	            this.locationDestination = selectionPicker && selectionPicker.locations ? selectionPicker.locations[0] : null;
	            if (!this.locationDestination) {
	                this.locationDestinationError = true;
	                this.preloader.hide();
	                return;
	            }
	        }
	        var transfer = new shared_1.Transfer(this.locationOrigin, this.locationDestination, this.products, this._isRequestTrasfer);
	        this._transferService.transfer(transfer)
	            .subscribe(function (res) {
	            _this.applytransferSuccess.emit();
	            _this.preloader.hide();
	        }, function (error) {
	            _this.transferError = true;
	            _this.preloader.hide();
	        });
	    };
	    TransferOverviewComponent.prototype.editDestinationLocation = function (e) {
	        var _this = this;
	        e.preventDefault();
	        this.destinationEditMode = !this.destinationEditMode;
	        this.regionsDestination = this._user.regions.map(function (region) {
	            region.locations = region.locations.filter(function (l) { return l.id !== _this.locationOriginId; });
	            return region;
	        });
	    };
	    TransferOverviewComponent.prototype.close = function () {
	        this.applyClose.emit();
	    };
	    TransferOverviewComponent.prototype._initializeRegionAndLocation = function (user) {
	        var that = this;
	        user.locations.map(function (location) {
	            if (location.id === that.locationDestinationId) {
	                that.locationDestination = location;
	            }
	            if (location.id === that.locationOriginId) {
	                that.locationOrigin = location;
	            }
	        });
	        user.regions.map(function (region) {
	            region.locations.map(function (l) {
	                if (l.id === that.locationDestinationId) {
	                    that.regionDestination = region;
	                }
	                if (l.id === that.locationOriginId) {
	                    that.regionOrigin = region;
	                }
	            });
	        });
	        if (this.originEditMode) {
	            this._isRequestTrasfer = true;
	            var productLocations_1 = that.products[0].locations ? that.products[0].locations.map(function (l) { return l.id; }) : [];
	            var regions = user.regions.map(function (region) {
	                region.locations = region.locations
	                    .filter(function (l) {
	                    return productLocations_1.indexOf(l.id) !== -1
	                        && l.id !== that.locationDestinationId;
	                });
	                return region;
	            });
	            this.regionsOrigin = regions.filter(function (r) { return r.locations.length > 0; });
	        }
	    };
	    __decorate([
	        core_1.ViewChild(page_preloader_component_1.PagePreloaderComponent), 
	        __metadata('design:type', Object)
	    ], TransferOverviewComponent.prototype, "preloader", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.LocationPickerComponent), 
	        __metadata('design:type', Object)
	    ], TransferOverviewComponent.prototype, "locationPickerComponent", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], TransferOverviewComponent.prototype, "products", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], TransferOverviewComponent.prototype, "locationOriginId", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], TransferOverviewComponent.prototype, "locationDestinationId", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TransferOverviewComponent.prototype, "destinationEditMode", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TransferOverviewComponent.prototype, "allowDestinationEditMode", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TransferOverviewComponent.prototype, "originEditMode", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], TransferOverviewComponent.prototype, "applytransferSuccess", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], TransferOverviewComponent.prototype, "applyClose", void 0);
	    TransferOverviewComponent = __decorate([
	        core_1.Component({
	            selector: 'transfer-overview',
	            styles: [__webpack_require__(1010)],
	            template: __webpack_require__(1011)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof transfer_service_1.TransferService !== 'undefined' && transfer_service_1.TransferService) === 'function' && _c) || Object])
	    ], TransferOverviewComponent);
	    return TransferOverviewComponent;
	    var _a, _b, _c;
	}());
	exports.TransferOverviewComponent = TransferOverviewComponent;


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	__webpack_require__(277);
	__webpack_require__(339);
	var services_1 = __webpack_require__(274);
	var TransferService = (function () {
	    function TransferService(_apiService, _configService) {
	        this._apiService = _apiService;
	        this._configService = _configService;
	        this._inventory = this._configService.getContext('inventory');
	    }
	    TransferService.prototype.transfer = function (transfer) {
	        return this._apiService.post(this._inventory.url, 'transfers', transfer)
	            .map(function (res) { return res; });
	    };
	    TransferService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], TransferService);
	    return TransferService;
	    var _a, _b;
	}());
	exports.TransferService = TransferService;


/***/ },
/* 1010 */
/***/ function(module, exports) {

	module.exports = ".transfer{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;position:relative}.transfer.master{padding-right:30px}.transfer.master::before{border-style:solid;border-width:0.1em 0.1em 0 0;content:'';display:inline-block;height:0.55em;width:0.55em;position:absolute;top:calc(50% - 10px);vertical-align:top;right:10px;transform:rotate(45deg)}.transfer::after{content:'';display:block;width:100%;margin-top:10px}.transfer .title{font-size:15px}.transfer .avatar{float:left;width:50px;font-size:30px}.transfer .avatar-edit{text-align:right;width:50px;font-size:20px;padding-top:5px}.transfer .content title{font-size:24px}.transfer .content small{color:#9e9e9e}.transfer .results{width:80px;text-align:right}.transfer .secondary{color:#9e9e9e;font-size:11px}.transfer .qty.positive{color:#FFC107}.transfer .qty.negative{color:#E41736}.transfer .size{width:50px}.transfer .qty-margin{margin-left:40%}.transfer .amber{font-size:15px !important;color:#FFC107 !important}.transfer .red{color:#E41736 !important}.footer{position:fixed;bottom:0;left:0;right:0;height:50px;z-index:14}\n"

/***/ },
/* 1011 */
/***/ function(module, exports) {

	module.exports = "<page-preloader></page-preloader><div class=\"layout-row h-100\"><div class=\"layout-column flex-100\"><div class=\"flex scrollable\"><div class=\"transfer\"><div class=\"pull-right\" *ngIf=\"allowDestinationEditMode\"><i class=\"flex-nogrow avatar-edit sm zmdi zmdi-edit text-center\" (click)=\"close()\"></i></div><h4 class=\"red\">Transfer</h4><div class=\"layout-row layout-align-center-center\"><i class=\"flex-nogrow avatar sm zmdi zmdi-shopping-cart-add text-center\"></i></div><div class=\"layout-row layout-align-center-center m-t-10\"><div class=\"title\"> <span class=\"amber\">{{ total }}</span><span> - {{ title }}</span></div></div></div><div class=\"transfer\"><h4 class=\"red\">From</h4><location-picker [fg]=\"fg\" *ngIf=\"originEditMode\" [regionsFiltered]=\"regionsOrigin\"></location-picker><div class=\"layout-row layout-align-center-center\" *ngIf=\"!originEditMode\"><i class=\"flex-nogrow avatar sm zmdi zmdi-pin text-center\"></i></div><div class=\"layout-row layout-align-center-center m-t-10\" *ngIf=\"!originEditMode\"><div class=\"title\"> {{ regionOrigin.name }} - {{ locationOrigin.name }}   </div></div><div class=\"layout-row red m-l-10 animated fadeIn\" *ngIf=\"locationOriginError\">      Select origin and location</div></div><div class=\"transfer\"><div class=\"pull-right\" *ngIf=\"!destinationEditMode &amp;&amp; allowDestinationEditMode\"><i class=\"flex-nogrow avatar-edit sm zmdi zmdi-edit text-center\" (click)=\"editDestinationLocation($event)\"></i></div><h4 class=\"red\">To</h4><div class=\"layout-column\" *ngIf=\"!destinationEditMode\"><div class=\"layout-row layout-align-center-center\"><i class=\"flex-nogrow avatar sm zmdi zmdi-pin text-center\"></i></div><div class=\"layout-row layout-align-center-center m-t-10\"><div class=\"title\"> </div>{{ regionDestination.name }} - {{ locationDestination.name }} </div></div><location-picker [fg]=\"fg\" [regionsFiltered]=\"regionsDestination\" [allowSelectMultipleLocations]=\"false\" *ngIf=\"destinationEditMode\"></location-picker><div class=\"layout-row red m-l-10 animated fadeIn\" *ngIf=\"locationDestinationError\">      Select origin and location</div></div></div><div class=\"flex-nogrow layout-row layout-padding layout-align-center-center m-b-10\" [style.z-index]=\"14\"><bw-button title=\"Transfer Now\" color=\"red\" icon=\"swap\" [rounded]=\"true\" (click)=\"transfer($event)\"></bw-button><div class=\"text-center animated shake m-t-10\" *ngIf=\"transferError\"><div class=\"c-red\">{{ transferErrorMessage }}</div></div></div></div></div>";

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1013));


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var page_preloader_component_1 = __webpack_require__(616);
	var ProductTransferSelectedComponent = (function () {
	    function ProductTransferSelectedComponent() {
	        this.deleteProductFromTransfer = new core_1.EventEmitter();
	    }
	    ProductTransferSelectedComponent.prototype.ngOnInit = function () {
	        this.preloader.hide();
	    };
	    ProductTransferSelectedComponent.prototype.deleteProduct = function (product) {
	        this.products = this.products.filter(function (p) { return p.id !== product.id; });
	        this.deleteProductFromTransfer.emit(product);
	    };
	    __decorate([
	        core_1.ViewChild(page_preloader_component_1.PagePreloaderComponent), 
	        __metadata('design:type', Object)
	    ], ProductTransferSelectedComponent.prototype, "preloader", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ProductTransferSelectedComponent.prototype, "products", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], ProductTransferSelectedComponent.prototype, "deleteProductFromTransfer", void 0);
	    ProductTransferSelectedComponent = __decorate([
	        core_1.Component({
	            selector: 'products-transfer-selected',
	            styles: [__webpack_require__(1014)],
	            template: __webpack_require__(1015)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ProductTransferSelectedComponent);
	    return ProductTransferSelectedComponent;
	}());
	exports.ProductTransferSelectedComponent = ProductTransferSelectedComponent;


/***/ },
/* 1014 */
/***/ function(module, exports) {

	module.exports = ".product{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 40px;position:relative}.product.master{padding-right:30px}.product.master::before{border-style:solid;border-width:0.1em 0.1em 0 0;content:'';display:inline-block;height:0.55em;width:0.55em;position:absolute;top:calc(50% - 10px);vertical-align:top;right:10px;transform:rotate(45deg)}.product::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.product .avatar{float:left;width:50px;font-size:38px}.product .content title{font-size:24px}.product .content small{color:#9e9e9e}.product .results{width:80px;text-align:right}.product .secondary{color:#9e9e9e;font-size:11px}.product .qty{color:#FFC107}.product .remove{color:#E41736}\n"

/***/ },
/* 1015 */
/***/ function(module, exports) {

	module.exports = "<page-preloader></page-preloader><div class=\"product\" *ngFor=\"let product of products\"><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">{{product.name}}</div><small>{{product.category}}</small></div><div class=\"bw-header\" block=\"block\"><div class=\"pull-right\"><ul class=\"actions c-light-gray\"><li class=\"a remove\" href=\"\" (click)=\"deleteProduct(product)\"><i class=\"zmdi zmdi-close zmdi-hc-lg\"></i></li></ul></div></div></div><br/><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">Qty</div></div></div><div class=\"flex-nogrow results secondary qty\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ product.quantity }}</div></div></div></div></div>";

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1017));


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var models_1 = __webpack_require__(953);
	var ProductQtyComponent = (function () {
	    function ProductQtyComponent() {
	        this.fg = new forms_1.FormGroup({});
	    }
	    ProductQtyComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.fg.controls['qty'].valueChanges.subscribe(function (value) { return _this.product.quantity = +value; });
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof models_1.Product !== 'undefined' && models_1.Product) === 'function' && _a) || Object)
	    ], ProductQtyComponent.prototype, "product", void 0);
	    ProductQtyComponent = __decorate([
	        core_1.Component({
	            selector: 'product-qty',
	            styles: [__webpack_require__(1018)],
	            template: __webpack_require__(1019)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ProductQtyComponent);
	    return ProductQtyComponent;
	    var _a;
	}());
	exports.ProductQtyComponent = ProductQtyComponent;


/***/ },
/* 1018 */
/***/ function(module, exports) {

	module.exports = ".size{width:80px}\n"

/***/ },
/* 1019 */
/***/ function(module, exports) {

	module.exports = "<div class=\"flex m-t-20\"><div class=\"size\"><number [fg]=\"fg\" [alt]=\"true\" field=\"qty\" label=\"Quantity\"></number></div><div class=\"layout-column c-red animated fadeIn\" *ngIf=\"product.errorInTransfer\">Provide quantity.</div></div>";

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1021));
	__export(__webpack_require__(1022));


/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var ui_1 = __webpack_require__(132);
	var shared_1 = __webpack_require__(952);
	var transfer_detail_service_1 = __webpack_require__(1022);
	var TransferDetailComponent = (function () {
	    function TransferDetailComponent(_transferDetailService) {
	        this._transferDetailService = _transferDetailService;
	        this.transfer = {};
	        this.applyDeleteTransferSucess = new core_1.EventEmitter();
	        this.transferDelete = new shared_1.TransferDelete();
	        this.deleteAlert = false;
	        this.errorMessage = 'Error';
	        this.error = false;
	    }
	    TransferDetailComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.transfer && this.transfer.id) {
	            this.transferDelete.addTransferToDelete(this.transfer.id);
	            this.products$ = this._transferDetailService.getTransferProducts(this.transfer.id);
	            this._preloaderSubs = this.products$.subscribe(function (res) {
	                _this.preloader.hide();
	            });
	        }
	        else {
	            this.preloader.hide();
	        }
	    };
	    TransferDetailComponent.prototype.beginDelete = function () {
	        this.deleteAlert = true;
	    };
	    TransferDetailComponent.prototype.cancel = function () {
	        this.error = false;
	        this.deleteAlert = false;
	    };
	    TransferDetailComponent.prototype.deleteTransfer = function (e) {
	        var _this = this;
	        e.preventDefault();
	        this.preloader.show();
	        this.error = false;
	        this._transferDetailService.deleteTransfer(this.transferDelete)
	            .subscribe(function (res) {
	            _this.preloader.hide();
	            _this.applyDeleteTransferSucess.emit();
	        }, function (error) {
	            _this.preloader.hide();
	            _this.error = true;
	            _this.errorMessage = error.statusText
	                ? error.statusText
	                : 'Error deleting. Try again.';
	        });
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.PagePreloaderComponent), 
	        __metadata('design:type', Object)
	    ], TransferDetailComponent.prototype, "preloader", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof shared_1.Transfer !== 'undefined' && shared_1.Transfer) === 'function' && _a) || Object)
	    ], TransferDetailComponent.prototype, "transfer", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], TransferDetailComponent.prototype, "applyDeleteTransferSucess", void 0);
	    TransferDetailComponent = __decorate([
	        core_1.Component({
	            selector: 'transfer-detail',
	            styles: [__webpack_require__(1023)],
	            template: __webpack_require__(1024)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof transfer_detail_service_1.TransferDetailService !== 'undefined' && transfer_detail_service_1.TransferDetailService) === 'function' && _b) || Object])
	    ], TransferDetailComponent);
	    return TransferDetailComponent;
	    var _a, _b;
	}());
	exports.TransferDetailComponent = TransferDetailComponent;


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	__webpack_require__(277);
	__webpack_require__(339);
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(953);
	var TransferDetailService = (function () {
	    function TransferDetailService(_apiService, _configService) {
	        this._apiService = _apiService;
	        this._configService = _configService;
	        this._inventory = this._configService.getContext('inventory');
	    }
	    TransferDetailService.prototype.getTransferProducts = function (transferId) {
	        return this._apiService.get(this._inventory.url, "transfers/" + transferId + "/items")
	            .map(function (response) { return response.data.map(function (p) { return new models_1.TransferProduct(p); }); })
	            .cache();
	    };
	    TransferDetailService.prototype.deleteTransfer = function (transferDelete) {
	        return this._apiService.delete(this._inventory.url, 'transfers', transferDelete)
	            .map(function (res) { return res; });
	    };
	    TransferDetailService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], TransferDetailService);
	    return TransferDetailService;
	    var _a, _b;
	}());
	exports.TransferDetailService = TransferDetailService;


/***/ },
/* 1023 */
/***/ function(module, exports) {

	module.exports = ".transfer{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;position:relative}.transfer.item-disabled{opacity:0.3}.transfer::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.transfer .avatar{float:left;width:50px;font-size:38px}.transfer .content title{font-size:24px}.transfer .content small{color:#9e9e9e}.transfer .secondary{font-size:12px}section.products-header{color:#fff !important;font-size:20px;margin-top:30px;text-align:center}.footer{position:fixed;bottom:0;left:0;right:0;height:50px}\n"

/***/ },
/* 1024 */
/***/ function(module, exports) {

	module.exports = "<page-preloader></page-preloader><div class=\"transfer\"><div class=\"layout-row\"><div class=\"flex content\"><div *ngIf=\"transfer.sent\"><div class=\"title\">{{transfer.sent.by}}</div><small>{{transfer.sent.timestamp | toLocalDate}}</small></div><div *ngIf=\"transfer.requested &amp;&amp; !transfer.sent\"><div class=\"title\">{{transfer.requested.by}}</div><small>{{transfer.requested.timestamp | toLocalDate}}</small></div></div><div class=\"flex\"> <div class=\"pull-right c-red\">{{transfer.status}}</div></div></div><br/><div class=\"layout-row text-center secondary\"><div class=\"flex text-right c-lime\" *ngIf=\"transfer.origin\">{{transfer.origin.name}}</div><div class=\"flex text-right c-lime\" *ngIf=\"!transfer.origin\">Air Transfer</div><div class=\"flex-nogrow m-l-5 m-r-5\"><div class=\"i zmdi zmdi-swap text-center\"></div></div><div class=\"flex text-left c-amber\">{{transfer.destination.name}} </div></div></div><section class=\"products-header\" *ngIf=\"!deleteAlert\">Products</section><br/><div *ngIf=\"!deleteAlert\"><div class=\"transfer\" *ngFor=\"let product of products$ | async\"><div class=\"layout-row\"><i class=\"flex-nogrow avatar sm zmdi zmdi-shopping-cart-add\"></i><div class=\"flex content\"><div class=\"title c-lime\">{{product.name}}</div><small>{{product.barcode}}</small></div><div class=\"flex text-center m-r-15\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">Sent</div><div class=\"flex text-right\">Received</div><div class=\"flex text-right\">Cost</div><div class=\"flex text-right\" *ngIf=\"product.lost &amp;&amp; product.lost &gt; 0\">Lost                           </div></div></div><div class=\"flex-nogrow results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ product.sent || 0 }}</div><div class=\"flex text-right\">{{ product.received || 0 }}</div><div class=\"flex text-right\">{{ product.cost || 0 | currency:'USD':true}}</div><div class=\"flex text-right\" *ngIf=\"product.lost &amp;&amp; product.lost &gt; 0\">{{ product.lost }}</div></div></div></div></div></div><user-feedback class=\"c-amber\" type=\"danger\" *ngIf=\"deleteAlert\" message=\"Deleting this transfer will return inventory count as was before the transfer.\"></user-feedback><user-feedback class=\"c-red\" type=\"danger\" *ngIf=\"error\" [message]=\"errorMessage\"></user-feedback><div class=\"footer\"><div class=\"flex\"><div class=\"layout-row layout-align-center-center\"><bw-button class=\"animated fadeIn\" title=\"Delete\" color=\"red\" icon=\"delete\" [rounded]=\"true\" (click)=\"beginDelete($event)\" *ngIf=\"!deleteAlert\"></bw-button><bw-button class=\"animated fadeIn m-r-10\" title=\"Cancel\" color=\"red\" [rounded]=\"true\" (click)=\"cancel($event)\" *ngIf=\"deleteAlert\"></bw-button><bw-button class=\"animated fadeIn\" title=\"Continue\" color=\"red\" [rounded]=\"true\" (click)=\"deleteTransfer($event)\" *ngIf=\"deleteAlert\"></bw-button></div></div></div>";

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(23);
	var shared_module_1 = __webpack_require__(26);
	var forms_1 = __webpack_require__(27);
	var customers_routing_1 = __webpack_require__(1026);
	var ng2_material_components_1 = __webpack_require__(33);
	var customers_component_1 = __webpack_require__(676);
	var shared_1 = __webpack_require__(1032);
	var customers_search_1 = __webpack_require__(1027);
	var customer_invoices_1 = __webpack_require__(1033);
	var CustomersModule = (function () {
	    function CustomersModule() {
	    }
	    CustomersModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                shared_module_1.SharedModule,
	                forms_1.ReactiveFormsModule,
	                ng2_material_components_1.MaterialFormsModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                customers_routing_1.customersRouting
	            ],
	            exports: [
	                customers_component_1.CustomersComponent,
	                customers_search_1.CustomersSearchComponent,
	                customer_invoices_1.CustomerInvoiceComponent
	            ],
	            declarations: [
	                customers_component_1.CustomersComponent,
	                customers_search_1.CustomersSearchComponent,
	                customer_invoices_1.CustomerInvoiceComponent
	            ],
	            providers: [shared_1.CustomersService],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CustomersModule);
	    return CustomersModule;
	}());
	exports.CustomersModule = CustomersModule;


/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(77);
	var customers_component_1 = __webpack_require__(676);
	var customers_search_1 = __webpack_require__(1027);
	var customersRoutes = [
	    {
	        path: 'customers',
	        component: customers_component_1.CustomersComponent,
	        children: [
	            {
	                path: '',
	                component: customers_search_1.CustomersSearchComponent
	            },
	        ]
	    }
	];
	exports.customersRouting = router_1.RouterModule.forChild(customersRoutes);


/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1028));


/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var customer_invoices_filter_1 = __webpack_require__(578);
	var services_1 = __webpack_require__(1029);
	var core_1 = __webpack_require__(2);
	var models_1 = __webpack_require__(137);
	var ui_1 = __webpack_require__(132);
	var services_2 = __webpack_require__(274);
	var forms_1 = __webpack_require__(27);
	var CustomersSearchComponent = (function (_super) {
	    __extends(CustomersSearchComponent, _super);
	    function CustomersSearchComponent(store, storeHelper, userService, _customerService) {
	        _super.call(this, store, storeHelper, userService);
	        this._customerService = _customerService;
	        this.fg = new forms_1.FormGroup({});
	        this.showCustomerDetails = false;
	        this.loading = true;
	        this.authorized = true;
	        this._searchAction = { id: 'search', icon: 'search' };
	        this._filterReady = false;
	    }
	    CustomersSearchComponent.prototype.ngOnInit = function () {
	        // set title and actions
	        this.headerTitle = 'Customers';
	        this.headerActions = [this._searchAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	    };
	    CustomersSearchComponent.prototype.onFilterChanged = function (filter) {
	        var _this = this;
	        this._filter = filter;
	        if (this._filter.locationsSelection.locations.length > 0) {
	            this._loadPurchases();
	        }
	        else {
	            this._resetCustomerData();
	            this.empty = true;
	            setTimeout(function () { return _this.filterSheet.toggle(); }, 1500);
	            if (this._filterReady) {
	                this.filterSheet.toggle();
	            }
	            this._filterReady = true;
	        }
	    };
	    CustomersSearchComponent.prototype.showInvoices = function (purchaseSummary) {
	        if (purchaseSummary.invoiceCount === 0) {
	            return;
	        }
	        var filter = new customer_invoices_filter_1.CustomerInvoicesFilter(this._filter.date, this._filter.locationsSelection, purchaseSummary);
	        this.storeHelper.update('customerInvoicesFilter', filter);
	        this.selectedSummary = purchaseSummary;
	        this.showCustomerDetails = true;
	    };
	    CustomersSearchComponent.prototype.coverClosed = function () {
	        this.showCustomerDetails = false;
	    };
	    CustomersSearchComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._searchAction.id && this.authorized) {
	            this.filterSheet.toggle();
	        }
	    };
	    CustomersSearchComponent.prototype._loadPurchases = function () {
	        var _this = this;
	        var that = this;
	        this.empty = false;
	        this.appPage.activatePreloader();
	        this.loading = true;
	        this._customerService.getPurchasesSummary(this._filter)
	            .subscribe(function (purchases) {
	            _this.purchases = purchases;
	            _this.appPage.deactivatePreloader();
	            _this.empty = purchases.length < 1;
	            if (_this.empty) {
	                setTimeout(function () { return _this.filterSheet.toggle(); }, 2000);
	            }
	        }, function (err) {
	            _this.authorized = _this.userService.userHasAccess(err);
	            _this.appPage.deactivatePreloader();
	            _this.loading = false;
	        }, function () { return that.loading = false; });
	        if (this._filterReady) {
	            this.filterSheet.toggle();
	        }
	        this._filterReady = true;
	    };
	    CustomersSearchComponent.prototype._resetCustomerData = function () {
	        this.purchases = [];
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], CustomersSearchComponent.prototype, "appPage", void 0);
	    __decorate([
	        core_1.ViewChild(ui_1.FilterSheetComponent), 
	        __metadata('design:type', Object)
	    ], CustomersSearchComponent.prototype, "filterSheet", void 0);
	    CustomersSearchComponent = __decorate([
	        core_1.Component({
	            selector: 'customers-search',
	            template: __webpack_require__(1031)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_2.Store !== 'undefined' && services_2.Store) === 'function' && _a) || Object, (typeof (_b = typeof services_2.StoreHelper !== 'undefined' && services_2.StoreHelper) === 'function' && _b) || Object, (typeof (_c = typeof services_2.UserService !== 'undefined' && services_2.UserService) === 'function' && _c) || Object, (typeof (_d = typeof services_1.CustomersService !== 'undefined' && services_1.CustomersService) === 'function' && _d) || Object])
	    ], CustomersSearchComponent);
	    return CustomersSearchComponent;
	    var _a, _b, _c, _d;
	}(models_1.TopLevelComponent));
	exports.CustomersSearchComponent = CustomersSearchComponent;


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1030));


/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(576);
	var core_1 = __webpack_require__(2);
	var services_1 = __webpack_require__(274);
	var models_2 = __webpack_require__(576);
	var CustomersService = (function () {
	    function CustomersService(_api, configService) {
	        this._api = _api;
	        this.configService = configService;
	        this._bi = this.configService.getContext('bi');
	    }
	    CustomersService.prototype.getPurchasesSummary = function (filter) {
	        return this._api.get(this._bi.url, 'customers/purchases/summary', filter)
	            .map(function (summary) { return summary.data.map(function (s) { return new models_2.CustomerPurchasesSummary(s); }); })
	            .cache();
	    };
	    CustomersService.prototype.getInvoices = function (filter) {
	        return this._api.get(this._bi.url, "customers/" + filter.customerPurchasesSummary.customerId + "/purchases", filter)
	            .map(function (purchases) { return purchases.data.map(function (s) { return new models_1.CustomerInvoiceDetails(s); }); })
	            .cache();
	    };
	    CustomersService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.ApiService !== 'undefined' && services_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.ConfigService !== 'undefined' && services_1.ConfigService) === 'function' && _b) || Object])
	    ], CustomersService);
	    return CustomersService;
	    var _a, _b;
	}());
	exports.CustomersService = CustomersService;


/***/ },
/* 1031 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"flex\" *ngIf=\"authorized\"><filter-sheet [fg]=\"fg\" (filterChanged)=\"onFilterChanged($event)\">  </filter-sheet><paper-cover *ngIf=\"showCustomerDetails\" [title]=\"selectedSummary.fullName\" (closed)=\"coverClosed()\"><customer-invoices></customer-invoices></paper-cover><div class=\"h-100\" [ngSwitch]=\"empty\"><user-feedback *ngSwitchCase=\"true\" type=\"info\" message=\"No Results Found\"></user-feedback><div *ngSwitchCase=\"false\"><div class=\"list-item master\" *ngFor=\"let purchase of purchases\" (click)=\"showInvoices(purchase)\" [class.item-disabled]=\"purchase.amountSpent == 0\"><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">{{purchase.fullName}}</div><small>{{purchase.location.name}}</small></div><div class=\"flex-nogrow results c-amber\" [class.negative-number]=\"purchase.amountSpent &lt;= 0\">{{ purchase.amountSpent | currency:'USD':true }}</div></div><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">Total Invoices</div><div class=\"flex text-right\">Last Purchase was on                            </div></div></div><div class=\"flex-40 results secondary\"><div class=\"layout-column secondary\"><div class=\"flex text-right\">{{ purchase.invoiceCount }}</div><div class=\"flex text-right\">{{ purchase.lastInvoiceDate | toLocalDate}}</div></div></div></div></div></div></div></div><user-feedback [hidden]=\"authorized || loading\" type=\"info\" message=\"User - Not Authorized\"></user-feedback></app-page>";

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(576));
	__export(__webpack_require__(1029));


/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1034));


/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var services_1 = __webpack_require__(1029);
	var services_2 = __webpack_require__(274);
	var ui_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(2);
	var CustomerInvoiceComponent = (function () {
	    function CustomerInvoiceComponent(_customersService, _store) {
	        this._customersService = _customersService;
	        this._store = _store;
	    }
	    CustomerInvoiceComponent.prototype.ngOnInit = function () {
	        var that = this;
	        var storeState = this._store.getState();
	        var customerFilter = storeState.customerInvoicesFilter;
	        this._invoicesSubs = this._customersService.getInvoices(customerFilter)
	            .subscribe(function (res) {
	            that.invoices = res;
	            that.preloader.hide();
	        });
	    };
	    CustomerInvoiceComponent.prototype.ngOnDestroy = function () {
	        this._invoicesSubs.unsubscribe();
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.PagePreloaderComponent), 
	        __metadata('design:type', Object)
	    ], CustomerInvoiceComponent.prototype, "preloader", void 0);
	    CustomerInvoiceComponent = __decorate([
	        core_1.Component({
	            selector: 'customer-invoices',
	            template: __webpack_require__(1035)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.CustomersService !== 'undefined' && services_1.CustomersService) === 'function' && _a) || Object, (typeof (_b = typeof services_2.Store !== 'undefined' && services_2.Store) === 'function' && _b) || Object])
	    ], CustomerInvoiceComponent);
	    return CustomerInvoiceComponent;
	    var _a, _b;
	}());
	exports.CustomerInvoiceComponent = CustomerInvoiceComponent;


/***/ },
/* 1035 */
/***/ function(module, exports) {

	module.exports = "<page-preloader></page-preloader><div class=\"list-item\" *ngFor=\"let invoice of invoices\"><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">{{invoice.timestamp | toLocalDate }}</div><small><div>Invoice Number: {{invoice.invoiceId}} </div><div>{{invoice.location.name}}</div></small></div><div class=\"flex-nogrow results amount\" [class.positive-number]=\"invoice.total &gt; 0\" [class.negative-number]=\"invoice.total &lt;= 0\">{{ invoice.total | currency:'USD':true }}</div></div></div>";

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var messages_container_1 = __webpack_require__(1037);
	var chat_message_1 = __webpack_require__(1040);
	var chat_box_1 = __webpack_require__(1044);
	var chat_routing_1 = __webpack_require__(1048);
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var common_1 = __webpack_require__(23);
	var shared_module_1 = __webpack_require__(26);
	var pipes_1 = __webpack_require__(595);
	var ng2_material_components_1 = __webpack_require__(33);
	var chat_component_1 = __webpack_require__(677);
	var chatindex_1 = __webpack_require__(1053);
	var chat_service_1 = __webpack_require__(679);
	var region_thread_1 = __webpack_require__(1054);
	var region_element_1 = __webpack_require__(1058);
	var join_region_1 = __webpack_require__(1062);
	var signalR_service_1 = __webpack_require__(678);
	var ChatModule = (function () {
	    function ChatModule() {
	    }
	    ChatModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                router_1.RouterModule,
	                ng2_material_components_1.MaterialFormsModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                shared_module_1.SharedModule,
	                chat_routing_1.chatRouting
	            ],
	            exports: [
	                chat_component_1.ChatComponent,
	                chatindex_1.ChatIndexComponent,
	                region_thread_1.RegionThreadComponent,
	                join_region_1.JoinRegionComponent,
	                region_element_1.RegionElementComponent,
	                chat_box_1.ChatBoxComponent,
	                chat_message_1.ChatMessageComponent,
	                messages_container_1.MessagesContainerComponent,
	            ],
	            declarations: [
	                chat_component_1.ChatComponent,
	                chatindex_1.ChatIndexComponent,
	                region_thread_1.RegionThreadComponent,
	                join_region_1.JoinRegionComponent,
	                region_element_1.RegionElementComponent,
	                chat_box_1.ChatBoxComponent,
	                chat_message_1.ChatMessageComponent,
	                messages_container_1.MessagesContainerComponent,
	                pipes_1.FromNowPipe,
	                pipes_1.SortByDatePipe,
	            ],
	            providers: [chat_service_1.ChatService, signalR_service_1.SignalRService],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ChatModule);
	    return ChatModule;
	}());
	exports.ChatModule = ChatModule;


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1038));


/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var models_2 = __webpack_require__(680);
	var core_1 = __webpack_require__(2);
	var MessagesContainerComponent = (function () {
	    function MessagesContainerComponent(element) {
	        this.element = element;
	        this.lastScrollHeight = 0;
	        this.el = this.element.nativeElement;
	    }
	    MessagesContainerComponent.prototype.ngDoCheck = function () {
	        if (this.lastScrollHeight === 0) {
	            this.el.scrollTop = 0;
	        }
	        var isScrolledToBottom = this.el.scrollHeight - this.el.clientHeight
	            - this.el.scrollTop <= 80;
	        if (this.lastScrollHeight !== this.el.scrollHeight && isScrolledToBottom) {
	            $('messages-container').animate({ scrollTop: this.el.scrollHeight -
	                    this.el.clientHeight
	            }, 500);
	            this.lastScrollHeight = this.el.scrollHeight;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], MessagesContainerComponent.prototype, "messages", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof models_1.User !== 'undefined' && models_1.User) === 'function' && _a) || Object)
	    ], MessagesContainerComponent.prototype, "user", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof models_2.Thread !== 'undefined' && models_2.Thread) === 'function' && _b) || Object)
	    ], MessagesContainerComponent.prototype, "thread", void 0);
	    MessagesContainerComponent = __decorate([
	        core_1.Component({
	            selector: 'messages-container',
	            template: __webpack_require__(1039),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _c) || Object])
	    ], MessagesContainerComponent);
	    return MessagesContainerComponent;
	    var _a, _b, _c;
	}());
	exports.MessagesContainerComponent = MessagesContainerComponent;


/***/ },
/* 1039 */
/***/ function(module, exports) {

	module.exports = "<chat-message *ngFor=\"let message of messages\" [message]=\"message\" [user]=\"user\"></chat-message>";

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1041));


/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var models_1 = __webpack_require__(137);
	var models_2 = __webpack_require__(680);
	var core_1 = __webpack_require__(2);
	var ChatMessageComponent = (function () {
	    function ChatMessageComponent() {
	    }
	    ChatMessageComponent.prototype.ngOnInit = function () {
	        this.incoming = this.message.name !== this.user.name;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof models_2.ChatMessage !== 'undefined' && models_2.ChatMessage) === 'function' && _a) || Object)
	    ], ChatMessageComponent.prototype, "message", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof models_1.User !== 'undefined' && models_1.User) === 'function' && _b) || Object)
	    ], ChatMessageComponent.prototype, "user", void 0);
	    ChatMessageComponent = __decorate([
	        core_1.Component({
	            selector: 'chat-message',
	            template: __webpack_require__(1042),
	            styles: [__webpack_require__(1043)]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ChatMessageComponent);
	    return ChatMessageComponent;
	    var _a, _b;
	}());
	exports.ChatMessageComponent = ChatMessageComponent;


/***/ },
/* 1042 */
/***/ function(module, exports) {

	module.exports = "<div class=\"layout-column layout-paddingleft\"><div class=\"chatmessage animated fadeIn\" [ngClass]=\"{'text-right': !incoming, 'text-left': incoming}\"><div class=\"content\"><div class=\"layout-row\"><div class=\"flex-nogrow\" *ngIf=\"incoming\"><span class=\"author\">{{ message.name }}: </span></div><div class=\"flex\"><span class=\"timestamp\">{{ message.timestamp | fromNow }}</span></div></div><div class=\"layout-row\"><div class=\"flex\"><span class=\"msg\">{{ message.text }}</span></div></div></div></div></div>";

/***/ },
/* 1043 */
/***/ function(module, exports) {

	module.exports = ".chatmessage{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:2px 3px;position:relative}.chatmessage::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.chatmessage .content{overflow-wrap:break-word}.chatmessage .content .author{font-size:10px;padding-right:5px;color:#9e9e9e}.chatmessage .content .msg{font-size:12px;text-align:left !important}.chatmessage .content .timestamp{font-size:9px;color:#4e4e4e}\n"

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1045));


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ui_1 = __webpack_require__(132);
	var _1 = __webpack_require__(137);
	var services_1 = __webpack_require__(274);
	var chat_service_1 = __webpack_require__(679);
	var core_1 = __webpack_require__(2);
	var forms_1 = __webpack_require__(27);
	var ChatBoxComponent = (function (_super) {
	    __extends(ChatBoxComponent, _super);
	    function ChatBoxComponent(chatService, userService, store, storeHelper) {
	        _super.call(this, store, storeHelper, userService);
	        this.chatService = chatService;
	        this.fg = new forms_1.FormGroup({});
	        this.user = this.chatService.user;
	        this.currentThread = this.chatService.thread;
	        this.messages$ = this.chatService.messages$;
	    }
	    ChatBoxComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.headerTitle = "MESSAGES - " + this.currentThread.region.name;
	        this.headerActions = [{ id: 'none', icon: 'none' }];
	        this.getMessageSub = this.chatService.getMessageHistory()
	            .subscribe(function () { return _this.appPage.deactivatePreloader(); });
	    };
	    ChatBoxComponent.prototype.onEnter = function (event) {
	        this.sendMessage(event);
	    };
	    ChatBoxComponent.prototype.sendMessage = function (event) {
	        event.preventDefault();
	        if (this.fg.pristine) {
	            return;
	        }
	        this.chatService.sendChatMessageToSignalR(this.fg.value.message);
	        this.fg.reset();
	        if (this.currentThread.region.id === -1) {
	            this.getMessageSub.unsubscribe();
	            this.getMessageSub = this.chatService.getMessageHistory().subscribe();
	        }
	    };
	    ChatBoxComponent.prototype.ngOnDestroy = function () {
	        this.getMessageSub.unsubscribe();
	        this.messages$ = null;
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], ChatBoxComponent.prototype, "appPage", void 0);
	    ChatBoxComponent = __decorate([
	        core_1.Component({
	            selector: 'chat-box',
	            template: __webpack_require__(1046),
	            styles: [__webpack_require__(1047)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof chat_service_1.ChatService !== 'undefined' && chat_service_1.ChatService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _b) || Object, (typeof (_c = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _c) || Object, (typeof (_d = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _d) || Object])
	    ], ChatBoxComponent);
	    return ChatBoxComponent;
	    var _a, _b, _c, _d;
	}(_1.TopLevelComponent));
	exports.ChatBoxComponent = ChatBoxComponent;


/***/ },
/* 1046 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"layout-column h-100\"><messages-container class=\"flex\" [messages]=\"(messages$ | async) | sortByDate:'timestamp':'desc'\" [user]=\"user\" [thread]=\"currentThread\"></messages-container><div class=\"animated slideInUp\" id=\"compose-form\"><div class=\"layout-row layout-padding\"><div class=\"flex input\"><div class=\"m-b-25\"><text-box [fg]=\"fg\" field=\"message\" color=\"white\" label=\"Write your message here...\" [alt]=\"true\" [required]=\"false\" (keydown.enter)=\"onEnter($event)\"></text-box></div></div><div class=\"flex-70-nogrow\"><bw-button class=\"animated\" id=\"send-message\" [ngClass]=\"{'rotateInUpRight': fg.pristine}\" color=\"red\" icon=\"mail-send\" size=\"lg\" [simple]=\"true\" (click)=\"sendMessage($event)\"></bw-button></div></div></div></div></app-page>";

/***/ },
/* 1047 */
/***/ function(module, exports) {

	module.exports = "messages-container{overflow:auto;padding:15px;padding-bottom:20px}\n"

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(77);
	var chat_component_1 = __webpack_require__(677);
	var chat_index_component_1 = __webpack_require__(1049);
	var join_region_component_1 = __webpack_require__(1051);
	var chat_box_component_1 = __webpack_require__(1045);
	var chatRoutes = [
	    {
	        path: 'chat',
	        component: chat_component_1.ChatComponent,
	        children: [
	            {
	                path: '',
	                component: chat_index_component_1.ChatIndexComponent
	            },
	            {
	                path: 'joinregion',
	                component: join_region_component_1.JoinRegionComponent
	            },
	            {
	                path: 'messages',
	                component: chat_box_component_1.ChatBoxComponent
	            },
	        ]
	    }
	];
	exports.chatRouting = router_1.RouterModule.forChild(chatRoutes);


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ui_1 = __webpack_require__(132);
	var _1 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var services_1 = __webpack_require__(274);
	var chat_service_1 = __webpack_require__(679);
	var core_1 = __webpack_require__(2);
	var router_1 = __webpack_require__(77);
	var moment = __webpack_require__(139);
	var dateFormat = 'MM/DD/YYYY hh:mm:ss A';
	var ChatIndexComponent = (function (_super) {
	    __extends(ChatIndexComponent, _super);
	    function ChatIndexComponent(_router, storeHelper, store, userService, _chatService) {
	        _super.call(this, store, storeHelper, userService);
	        this._router = _router;
	        this._chatService = _chatService;
	        this.threads = [];
	        this._chatAction = { id: 'join', icon: 'comment' };
	    }
	    ChatIndexComponent.populateThreadsWithTimestamp = function (threads) {
	        threads.forEach(function (t) {
	            if (t.messages.length > 0) {
	                return t.timestamp = moment(t.messages[t.messages.length - 1].timestamp).format(dateFormat);
	                ;
	            }
	        });
	    };
	    ChatIndexComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	        this.threads = this._chatService.threads;
	        this.headerTitle = 'CHAT';
	        this.headerActions = [this._chatAction];
	        this.subscribeToHeaderActions(this._reactToHeaderAction);
	        ChatIndexComponent.populateThreadsWithTimestamp(this.threads);
	        this.threads = this._chatService.threads;
	        if (this._chatService.threads.length > 1) {
	            this.updateThreadSub = this._chatService.pullThreadsLastMessage()
	                .subscribe(function () { return _this.appPage.deactivatePreloader(); });
	        }
	        else {
	            this.appPage.deactivatePreloader();
	        }
	    };
	    ChatIndexComponent.prototype._reactToHeaderAction = function (action) {
	        if (action.id === this._chatAction.id) {
	            this._router.navigate(['chat/joinregion']);
	        }
	    };
	    ChatIndexComponent.prototype.ngOnDestroy = function () {
	        if (this.updateThreadSub) {
	            this.updateThreadSub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild(ui_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], ChatIndexComponent.prototype, "appPage", void 0);
	    ChatIndexComponent = __decorate([
	        core_1.Component({
	            selector: 'nova-chatindex',
	            template: __webpack_require__(1050)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _b) || Object, (typeof (_c = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _c) || Object, (typeof (_d = typeof _1.UserService !== 'undefined' && _1.UserService) === 'function' && _d) || Object, (typeof (_e = typeof chat_service_1.ChatService !== 'undefined' && chat_service_1.ChatService) === 'function' && _e) || Object])
	    ], ChatIndexComponent);
	    return ChatIndexComponent;
	    var _a, _b, _c, _d, _e;
	}(models_1.TopLevelComponent));
	exports.ChatIndexComponent = ChatIndexComponent;


/***/ },
/* 1050 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"layout-column h-100\"><div *ngFor=\"let thread of threads | sortByDate:'timestamp':'asc'\"><div class=\"flex-100-nogrow\"><region-thread [thread]=\"thread\" (openThread)=\"openThread($event)\"></region-thread></div></div><div class=\"flex text-center layout-padding\" *ngIf=\"threads.length&lt;1\"><h3 class=\"title\">There is no chats open, click on the icon at right to start chatting.</h3></div></div></app-page>";

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var _1 = __webpack_require__(132);
	var chat_service_1 = __webpack_require__(679);
	var services_1 = __webpack_require__(274);
	var models_1 = __webpack_require__(137);
	var core_1 = __webpack_require__(2);
	var JoinRegionComponent = (function (_super) {
	    __extends(JoinRegionComponent, _super);
	    function JoinRegionComponent(userService, storeHelper, store, chatService) {
	        _super.call(this, store, storeHelper, userService);
	        this.chatService = chatService;
	        this.allRegions = chat_service_1.VirtualAllRegionsElement;
	    }
	    JoinRegionComponent.prototype.ngOnInit = function () {
	        this.user = this.chatService.user;
	        this.headerTitle = 'CHAT - JOIN REGION';
	        this.headerActions = [{ id: 'none', icon: 'none' }];
	        this.appPage.deactivatePreloader();
	    };
	    __decorate([
	        core_1.ViewChild(_1.AppPageComponent), 
	        __metadata('design:type', Object)
	    ], JoinRegionComponent.prototype, "appPage", void 0);
	    JoinRegionComponent = __decorate([
	        core_1.Component({
	            selector: 'join-region',
	            template: __webpack_require__(1052)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof services_1.UserService !== 'undefined' && services_1.UserService) === 'function' && _a) || Object, (typeof (_b = typeof services_1.StoreHelper !== 'undefined' && services_1.StoreHelper) === 'function' && _b) || Object, (typeof (_c = typeof services_1.Store !== 'undefined' && services_1.Store) === 'function' && _c) || Object, (typeof (_d = typeof chat_service_1.ChatService !== 'undefined' && chat_service_1.ChatService) === 'function' && _d) || Object])
	    ], JoinRegionComponent);
	    return JoinRegionComponent;
	    var _a, _b, _c, _d;
	}(models_1.TopLevelComponent));
	exports.JoinRegionComponent = JoinRegionComponent;


/***/ },
/* 1052 */
/***/ function(module, exports) {

	module.exports = "<app-page><div class=\"joinregion-container mobile-page-content\"><div class=\"layout-column\"><div *ngIf=\"user.regions?.length&gt;1\"><region-element [region]=\"allRegions\"></region-element></div><div *ngFor=\"let region of user.regions\"><region-element [region]=\"region\"></region-element></div><div class=\"flex text-center\" *ngIf=\"user.regions?.length&lt;1\"><h3 class=\"title\">have no regions region, contact an owner.</h3></div></div></div></app-page>";

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1049));


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1055));


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var chat_service_1 = __webpack_require__(679);
	var models_1 = __webpack_require__(680);
	var core_1 = __webpack_require__(2);
	var RegionThreadComponent = (function () {
	    function RegionThreadComponent(_chatService) {
	        this._chatService = _chatService;
	        this.hasMessage = false;
	    }
	    RegionThreadComponent.prototype.ngOnInit = function () {
	        if (this.thread.messages.length > 0) {
	            this.hasMessage = true;
	        }
	        ;
	        if (this.hasMessage) {
	            this.message = this.thread.messages[this.thread.messages.length - 1];
	        }
	    };
	    RegionThreadComponent.prototype.open = function (thread) {
	        this._chatService.pushChatCommand({ id: 'openThread', data: thread });
	        this.message = null;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof models_1.Thread !== 'undefined' && models_1.Thread) === 'function' && _a) || Object)
	    ], RegionThreadComponent.prototype, "thread", void 0);
	    RegionThreadComponent = __decorate([
	        core_1.Component({
	            selector: 'region-thread',
	            styles: [__webpack_require__(1056)],
	            template: __webpack_require__(1057)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof chat_service_1.ChatService !== 'undefined' && chat_service_1.ChatService) === 'function' && _b) || Object])
	    ], RegionThreadComponent);
	    return RegionThreadComponent;
	    var _a, _b;
	}());
	exports.RegionThreadComponent = RegionThreadComponent;


/***/ },
/* 1056 */
/***/ function(module, exports) {

	module.exports = ".thread{height:80px !important;display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.thread.master{padding-right:30px}.thread.master::before{border-style:solid;border-width:0.1em 0.1em 0 0;content:'';display:inline-block;height:0.55em;width:0.55em;position:absolute;top:calc(50% - 10px);vertical-align:top;right:10px;transform:rotate(45deg)}.thread.master::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.thread .icon{float:left;width:32px;font-size:24px}.thread .content title{font-size:24px}.thread .content small{color:#9e9e9e}.thread .timestamp{color:#9e9e9e}\n"

/***/ },
/* 1057 */
/***/ function(module, exports) {

	module.exports = "<div class=\"thread master\" (click)=\"open(thread)\"><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><span class=\"timestamp\" *ngIf=\"hasMessage\">{{ message.timestamp | fromNow }}</span></div></div></div><div class=\"layout-row\"><i class=\"flex-nogrow icon sm zmdi zmdi-globe\"></i><div class=\"flex content\"><div class=\"title\">{{ thread.region.name }}</div><small *ngIf=\"hasMessage\"> {{ message.name }}:  {{ message.text }}</small></div></div></div>";

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1059));


/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var chat_service_1 = __webpack_require__(679);
	var core_1 = __webpack_require__(2);
	var models_1 = __webpack_require__(137);
	var RegionElementComponent = (function () {
	    function RegionElementComponent(_chatService) {
	        this._chatService = _chatService;
	    }
	    RegionElementComponent.prototype.join = function (region) {
	        this._chatService.pushChatCommand({ id: 'joinRegion', data: region });
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof models_1.Region !== 'undefined' && models_1.Region) === 'function' && _a) || Object)
	    ], RegionElementComponent.prototype, "region", void 0);
	    RegionElementComponent = __decorate([
	        core_1.Component({
	            selector: 'region-element',
	            styles: [__webpack_require__(1060)],
	            template: __webpack_require__(1061)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof chat_service_1.ChatService !== 'undefined' && chat_service_1.ChatService) === 'function' && _b) || Object])
	    ], RegionElementComponent);
	    return RegionElementComponent;
	    var _a, _b;
	}());
	exports.RegionElementComponent = RegionElementComponent;


/***/ },
/* 1060 */
/***/ function(module, exports) {

	module.exports = ".region{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative;min-height:60px}.region.master{padding-right:30px}.region.master::before{border-style:solid;border-width:0.1em 0.1em 0 0;content:'';display:inline-block;height:0.55em;width:0.55em;position:absolute;top:calc(50% - 10px);vertical-align:top;right:10px;transform:rotate(45deg)}.region.master::after{content:'';display:block;width:100%;margin-top:20px;border-bottom:1px solid #404040}.region .icon{float:left;width:24px;font-size:18px}.region .content title{font-size:12px}\n"

/***/ },
/* 1061 */
/***/ function(module, exports) {

	module.exports = "<div class=\"region master\" (click)=\"join(region)\"> <div class=\"layout-row layout-align-center\"><i class=\"flex-nogrow icon sm zmdi zmdi-globe\"></i><div class=\"flex content\"><div class=\"title\">{{ region.name }}</div></div></div></div>";

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1051));


/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1064));
	__export(__webpack_require__(686));


/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(23);
	var shared_module_1 = __webpack_require__(26);
	var ng2_material_components_1 = __webpack_require__(33);
	var clock_in_out_component_1 = __webpack_require__(686);
	var ui_1 = __webpack_require__(1065);
	var services_1 = __webpack_require__(693);
	var pipes_1 = __webpack_require__(595);
	var ClockInOutModule = (function () {
	    function ClockInOutModule() {
	    }
	    ClockInOutModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                ng2_material_components_1.MaterialFormsModule,
	                ng2_material_components_1.MaterialUserInterfaceModule,
	                shared_module_1.SharedModule,
	            ],
	            exports: [
	                clock_in_out_component_1.ClockInOutComponent,
	            ],
	            declarations: [
	                clock_in_out_component_1.ClockInOutComponent,
	                ui_1.LocationLogsComponent,
	                ui_1.EmployeeLogComponent,
	                pipes_1.CapitalizePipe,
	                pipes_1.DurationPipe
	            ],
	            providers: [
	                services_1.ClockInOutService
	            ],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ClockInOutModule);
	    return ClockInOutModule;
	}());
	exports.ClockInOutModule = ClockInOutModule;


/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1066));
	__export(__webpack_require__(1070));


/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1067));


/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var models_1 = __webpack_require__(687);
	var LocationLogsComponent = (function () {
	    function LocationLogsComponent() {
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof models_1.LocationEmployeeLog !== 'undefined' && models_1.LocationEmployeeLog) === 'function' && _a) || Object)
	    ], LocationLogsComponent.prototype, "locationLogs", void 0);
	    LocationLogsComponent = __decorate([
	        core_1.Component({
	            selector: 'location-logs',
	            template: __webpack_require__(1068),
	            styles: [__webpack_require__(1069)],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocationLogsComponent);
	    return LocationLogsComponent;
	    var _a;
	}());
	exports.LocationLogsComponent = LocationLogsComponent;


/***/ },
/* 1068 */
/***/ function(module, exports) {

	module.exports = "<div class=\"location-logs\" *ngIf=\"locationLogs &amp;&amp; locationLogs.employees.length &gt; 0\"><div class=\"list-header\"><div class=\"layout-row layout-align-center-center flex\"><div class=\"layout-row layout-align-center-center flex\"><i class=\"zmdi zmdi-pin\"></i><div class=\"title\">{{ locationLogs.name }}</div></div></div></div><div class=\"layout-column\" *ngIf=\"locationLogs &amp;&amp; locationLogs.employees.length &gt; 0\"><div class=\"flex\" *ngFor=\"let employee of locationLogs.employees\"><div class=\"background\"></div><div class=\"list-item simple\"><employee-log [employee]=\"employee\"></employee-log></div></div></div></div>";

/***/ },
/* 1069 */
/***/ function(module, exports) {

	module.exports = ".location-logs{width:100%;display:block;clear:both;cursor:pointer;padding:5px 5px}.location-logs .list-header{font-size:12px}.location-logs .list-header i{font-size:16px}.location-logs .list-item{padding:0px;position:relative}.location-logs .list-item::after{content:'';display:block;width:100%;margin-top:1px;border-bottom:1px solid #404040}\n"

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1071));


/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(2);
	var models_1 = __webpack_require__(687);
	var EmployeeLogComponent = (function () {
	    function EmployeeLogComponent() {
	        this.expanded = false;
	    }
	    EmployeeLogComponent.prototype.toggle = function (event) {
	        this.expanded = !this.expanded;
	    };
	    Object.defineProperty(EmployeeLogComponent.prototype, "buttonColor", {
	        get: function () {
	            return this.canExpand ? 'white' : 'gray';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(EmployeeLogComponent.prototype, "iconButton", {
	        get: function () {
	            return this.expanded ? 'chevron-up' : 'chevron-down';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(EmployeeLogComponent.prototype, "canExpand", {
	        get: function () {
	            return this.employee.clockLogs.length > 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof models_1.EmployeeClockLog !== 'undefined' && models_1.EmployeeClockLog) === 'function' && _a) || Object)
	    ], EmployeeLogComponent.prototype, "employee", void 0);
	    EmployeeLogComponent = __decorate([
	        core_1.Component({
	            selector: 'employee-log',
	            template: __webpack_require__(1072),
	            styles: [__webpack_require__(1073)],
	        }), 
	        __metadata('design:paramtypes', [])
	    ], EmployeeLogComponent);
	    return EmployeeLogComponent;
	    var _a;
	}());
	exports.EmployeeLogComponent = EmployeeLogComponent;


/***/ },
/* 1072 */
/***/ function(module, exports) {

	module.exports = "<div class=\"background\"></div><div class=\"employee-log\"><div class=\"flex\"><div class=\"layout-row layout-align-center-center\"><div class=\"name flex m-l-10\">{{ employee.name }}</div><div class=\"status flex-40\"><div class=\"layout-row layout-align-right\"><div class=\"flex\"></div><div class=\"flex-70\"><div class=\"flex-10 m-t-5\"><i class=\"flex-5-nogrow check-action sm zmdi zmdi-circle {{employee.status.action}}\"> </i></div><div class=\"flex text-right\"><div class=\"description text-right\">{{ employee.status.action | capitalize }}</div></div></div></div><div class=\"timestamp text-right m-b-5\">{{ employee.status.timestamp |  momentify:'MM/DD/YYYY hh:mm a' }}</div></div><div class=\"flex-10\"><div class=\"expand\"><bw-button *ngIf=\"canExpand\" color=\"{{buttonColor}}\" icon=\"{{iconButton}}\" [simple]=\"true\" [disabled]=\"!canExpand\" (clicked)=\"toggle($event)\"></bw-button></div></div></div><div class=\"layout-column flex\" *ngIf=\"expanded\"><div class=\"layout-row layout-align-right details flex\" *ngFor=\"let log of employee.clockLogs\"><div class=\"details-background\"></div><div class=\"flex\"></div><div class=\"flex-40\"><div class=\"layout-row layout-align-right\"><div class=\"flex\"></div><div class=\"flex-70\"><div class=\"flex-10 m-t-5\"><i class=\"flex-5-nogrow check-action sm zmdi zmdi-circle {{log.action}}\"> </i></div><div class=\"flex text-right\"><div class=\"description text-right\">{{ log.action | capitalize }}</div></div></div></div><div *ngIf=\"log.action !== 'break'\"><div class=\"text-right timestamp m-b-5\">{{ log.timestamp |  momentify:'MM/DD/YYYY hh:mm a' }}</div></div><div *ngIf=\"log.action === 'break'\"><div class=\"text-right timestamp m-b-5\">{{ log.duration | duration }}</div></div></div><div class=\"flex-10\"></div></div></div></div></div>";

/***/ },
/* 1073 */
/***/ function(module, exports) {

	module.exports = ".background{position:absolute;left:0;right:0;bottom:0;top:0;background-color:black;opacity:0.2}.employee-log .details{position:relative}.employee-log .details .details-background{position:absolute;left:0;right:0;bottom:0;top:0;background-color:black;opacity:0.2;border-bottom:1px solid #292929}.employee-log .check-action{margin-top:3px;float:left;width:20px;font-size:14px}.employee-log .clockIn{color:limegreen !important;opacity:0.7 !important}.employee-log .clockOut{color:red !important;opacity:0.7 !important}.employee-log .break{color:gray !important;opacity:0.7 !important}.employee-log .timestamp{color:#737373;font-size:11px;float:right}.employee-log .description{color:#737373}\n"

/***/ },
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(__webpack_module_template_argument_0__));
	__export(__webpack_require__(__webpack_module_template_argument_1__));
	__export(__webpack_require__(__webpack_module_template_argument_2__));


/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(__webpack_module_template_argument_0__));
	__export(__webpack_require__(__webpack_module_template_argument_1__));
	__export(__webpack_require__(__webpack_module_template_argument_2__));


/***/ }
]);


// WEBPACK FOOTER //
// js/app.d7c2b2c877372f5019a7.js